import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { hayBackend, ingresar, registrarse, salir, sesionActual, renovarSesion,
  mailRecordado, invitarAlumno, tokenDeInvitacion, fijarPassword,
  subirVideo, verVideo, borrarVideo,
  subirFoto, verFoto, borrarFoto, cambiarPassword,
  subirImagenInsignia, pedirRecuperacion } from "./lib/supabase.js";
import {
  cargarPerfil, cargarAlumnos,
  cargarSemanas, cargarEjercicios, ultimasCargas, cargarRanking, guardarRegistroEjercicio, guardarNotaCoach,
  guardarPrescripcion, esCampoDelCoach, agregarEjercicioSesion, quitarEjercicioSesion,
  cerrarSesion as cerrarSesionEnBase, crearEjercicio as crearEjercicioEnBase, crearSemana,
  crearSesion, duplicarSemana, renombrarSesion, diagnostico, asignarPlantilla,
  registrarCompartido, cargarActividadSemana,
  cargarInsignias, solicitarInsignia, insigniasConDuenos, guardarInsignia,
  insigniasDelGrupo, guardarEmom, guardarNotaSemanal, cambiarVacaciones, novedadesSemana,
  novedadesGrupo, descartarNovedad, mensajesSinLeer,
  listaCoaches, cambiarRol, actividadCoaches,
  conversacionesSesion, conversacionCompleta, enviarMensaje, reaccionar, editarMensaje, borrarMensaje,
  archivarInsignia, asignarInsignia,
  resolverInsignia, insigniasLogradas, cargarPropuestas, proponerInsignia,
  resolverPropuesta, crearInsigniaDesdePropuesta, cargarRecords, proponerRecord, resolverRecord, codigoInvitacion,
  cambiarCodigoInvitacion, regenerarCodigoInvitacion,
  darDeBajaAlumno, reactivarAlumno, cargarInactivos, borrarAlumnoDefinitivo,
  cargarDatosPrivados, guardarDatosPrivados, guardarNombre, actualizarPerfil,
  cargarCategorias, crearCategoriaEjercicios, cambiarColorCategoria,
  borrarEjercicio, usoDelEjercicio,
  borrarSesion as borrarSesionEnBase, borrarSemana as borrarSemanaEnBase, renombrarSemana,
  pedirAsistente, marcarCompartida, miSemanaTorneo, cargarTorneo,
  pedirCambioMeta, resolverCambioMeta, cargarSolicitudesMeta, reordenarEjercicios,
  cargarMusicaDefault, guardarMusicaSesion, fijarPuntosPrevios, renombrarBloque,
  semanaSiguienteMasiva, programarSemana,
  tableroCoach, alumnosEnAlerta, tableroAlumno,
  cargarNotificaciones, marcarLeida, marcarTodasLeidas, borrarNotificacion, miPuesto,
  cargarLibreria, crearPlantilla, actualizarPlantilla, borrarPlantilla as borrarPlantillaEnBase,
  moverPlantilla, crearCategoria, borrarCategoria,
  } from "./lib/api.js";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis,
  CartesianGrid, Tooltip, ResponsiveContainer,
  Legend } from "recharts";
import {
  ChevronLeft, Copy, Check, Clock, Plus, X, Dumbbell,
  Calendar, MessageSquare, Video, Upload, ChevronDown, ListRestart, RefreshCw, Lock, LogOut,
  User, KeyRound, PartyPopper, Camera, Send, Database, Eye, Trash2, Pencil, Users, Trophy,
  Flame, Shield, Zap, Star, Sunrise, Award, Target, Crown, CalendarPlus, Share2, Bell,
  ThumbsUp, ThumbsDown, TrendingUp, Home, ArrowRight, Footprints, Library, Play, Pause,
  RotateCcw, Folder, FolderOpen, FolderPlus, GripVertical, Maximize2, Minimize2, Archive, TrendingDown, Search,
  Volume2, VolumeX, Smartphone, Sparkles, ScrollText, AlertTriangle, ChevronRight, Minus, Circle, Download, Image as ImageIcon, Music, CalendarCheck, ClipboardList, EyeOff, CreditCard, ExternalLink,
  CheckCircle2, MousePointerClick, CalendarClock,
  Layers, Repeat, Gauge, Hourglass, SlidersHorizontal, Wrench, Timer, Sigma,
  History, MessageSquareReply, TrendingUp as Tendencia, Inbox, BookOpen, Palmtree,
  BookmarkPlus, MessagesSquare, ChevronUp, SmilePlus, Info, ArrowUpRight, ArrowDownRight,
  Moon, Sun, BellOff, Activity, LayoutGrid, LayoutList
} from "lucide-react";
import Biomecanica from "./biomecanica/Biomecanica.jsx";
import Planificador from "./planificador/Planificador.jsx";
import ElegirOpcion from "./planificador/ElegirOpcion.jsx";
import { SelectorVisible, visibilidadPorDefecto, estaOculta, textoVisible } from "./planificador/visibilidad.jsx";
import { Chips, EditorChip, COLOR_ESTADO, estadoSerie, chipsDeTecnica, conValor, CabeceraFija, seguirCabecera, ESTILO_DESLIZA } from "./planificador/chips.jsx";

// Logo para fondo claro. El original es blanco y desaparece sobre
// el tema claro, así que hay dos versiones y se elige según el tema.
const LOGO_CLARO = "data:image/png;base64,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";

const LOGO_URI = "data:image/png;base64,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";

// Videos y gifs de cada ejercicio. Se guardan por NOMBRE de ejercicio
// y viven en la biblioteca, no en la sesión: se cargan una vez y se
// reutilizan cada vez que ese ejercicio aparece en un plan.
// Las direcciones apuntan afuera (YouTube, Bunny, Drive): la app
// guarda el link, no el archivo.
const INITIAL_EXERCISE_MEDIA = {};

const esUrlValida = (v) => {
  const t = String(v || "").trim();
  if (!t) return true;             // vacío es válido: el campo es opcional
  return /^https:\/\/[^\s]+$/i.test(t);
};

// ---------- Option sets ----------

const INITIAL_EJERCICIOS_GROUPS = [
  { label: "MMSS", items: [
    "Press banca", "Press inclinado", "Press militar", "Remo en polea", "Remo con mancuerna",
    "Jalón al pecho", "Dominadas", "Press banca con mancuernas", "Press mancuernas en el piso",
    "Press declinado en Smith", "Press pecho en máquina",
  ]},
  { label: "MMII", items: [
    "Sentadilla", "Sentadilla búlgara", "Zancada", "Peso muerto", "Peso muerto rumano", "Prensa", "Hip thrust",
  ]},
  { label: "Activación", items: [
    "Face pull", "Puente de glúteo", "Movilidad de cadera", "Activación de glúteo con banda", "Rotación externa de hombro",
  ]},
  { label: "Tabata", items: [
    "Isométrico sentadillas + estocadas atrás", "Escaladores + Swing", "Peso muerto + puente de glúteo 1 pierna",
    "Oblicuos + sentadillas con peso", "Burpees", "Jumping jacks", "Zancada con salto",
  ]},
  { label: "Aeróbicos", items: [
    "Trote continuo", "Series 400m", "Trote de recuperación", "Umbral 5x1000m",
  ]},
  { label: "Zona media", items: [
    "Plancha", "Oblicuos", "Rueda abdominal", "Elevación de piernas",
  ]},
  { label: "Accesorios MMSS", items: [
    "Curl bíceps", "Extensión tríceps", "Elevaciones laterales", "Aperturas en máquina",
    "Aperturas agarre pronado en máquina", "Aperturas en polea baja", "Aperturas unilateral declinado",
    "Aperturas declinadas en polea", "Cruce de poleas (crossover)", "Aperturas en polea de pie",
    "Flexión declinada", "Flexión con déficit",
  ]},
  { label: "Accesorios MMII", items: [
    "Extensión de cuádriceps", "Curl femoral", "Elevación de talones",
  ]},
];

const CON_QUE_OPTIONS = [
  "Máquina", "Elástico", "Mancuerna", "Barra", "Peso libre", "Kettlebell",
  "Sin material", "Combinado",
];

const SERIES_OPTIONS = Array.from({ length: 8 }, (_, i) => String(i + 1));

const REPS_OPTIONS = [
  ...Array.from({ length: 30 }, (_, i) => String(i + 1)),
  "AMRAP", "Al fallo",
];

const RIR_OPTIONS = ["Al fallo", "0", "1", "2", "3", "+4"];
// La escala que usa Matías con sus alumnos. No es un degradado de
// verde a rojo: cada valor tiene su color y su significado.
//   Al fallo  gris     · sin repeticiones en reserva
//   RIR 0     violeta  · la última que sale
//   RIR 1     rojo     · muy exigente
//   RIR 2     amarillo · exigente
//   RIR 3     verde    · cómodo
//   RIR +4    celeste  · técnica o recuperación
// Cada color tiene dos versiones: mismo tono, distinta luz. Los de
// modo oscuro son ilegibles sobre blanco —el turquesa daba 1.7 de
// contraste sobre 4.5 necesario—, así que en claro van oscurecidos.
const RIR_COLORS = ["#9ca3af", "#a78bfa", "#ef4444", "#fb923c", "#22c55e", "#2dd4bf"];
// Tonos suaves para los estados: el rojo y el verde saturados de
// Tailwind gritan en una pantalla llena de tarjetas. Estos dicen lo
// mismo sin cansar la vista, y siguen pasando el contraste mínimo.
const ESTADO = {
  bien:    "#6fc48d",   // verde apagado
  aviso:   "#d4b555",   // amarillo arena
  atencion:"#e0a068",   // naranja terracota
  alerta:  "#e07a7a",   // rojo ladrillo
  neutro:  "#94a3b8",
};

const RIR_COLORS_CLARO = ["#666f7f", "#774bf7", "#de1313", "#b45304", "#167f3d", "#197c70"];
// RPE (running/tabata/intermitente): ordenado de mayor a menor esfuerzo, mismos colores
const RPE_OPTIONS = ["10", "9-10", "8-9", "7-8", "6-7", "5-6"];

// Colores sutiles para diferenciar cada tipo de campo (ejercicio, con qué, series, etc.)
// Los títulos van todos del mismo gris: son etiquetas, no información.
// El color lo lleva el VALOR, y sale del tipo de trabajo que es ese
// ejercicio. Antes cada campo tenía su color y la tarjeta parecía un
// arcoíris donde nada destacaba porque destacaba todo.
const GRIS_ETIQUETA = "#8b8b93";

// Un color por tipo de trabajo. Mirando la tarjeta ya sabés qué es
// sin leer la etiqueta de la técnica.
const COLOR_TARJETA = {
  normal:    "#34d399",   // verde: el trabajo estándar
  restpause: "#22d3ee",   // celeste
  dropset:   "#f472b6",   // rosa
  emom:      "#a78bfa",   // violeta
  piramidal_asc:  "#fb923c",   // naranja: sube
  piramidal_desc: "#38bdf8",   // celeste: baja
  tabata:    "#f87171",   // rojo
};

// El color de la tarjeta sale del esfuerzo prescrito: es el dato que
// define cómo se entrena ese ejercicio. La técnica y la serie
// combinada conservan su color en sus propias etiquetas.
const colorTarjeta = (ex) =>
  effortColor(ex?.rirConsigna, ex?.metric) || (enClaro() ? "#666f7f" : "#9ca3af");

// Se mantiene el nombre por compatibilidad con el resto del código.
const FIELD_ACCENTS = {
  ejercicio: GRIS_ETIQUETA, conQue: GRIS_ETIQUETA, series: GRIS_ETIQUETA,
  reps: GRIS_ETIQUETA, rirConsigna: GRIS_ETIQUETA, peso: GRIS_ETIQUETA,
  rirTuyo: GRIS_ETIQUETA,
};
// El tema vive acá afuera para que los colores lo consulten sin
// tener que pasarlo por veinte componentes.
let temaActual = "oscuro";
const fijarTema = (t) => { temaActual = t; };
const enClaro = () => temaActual === "claro";

const effortColor = (v, metric = "RIR") => {
  const opts = metric === "RPE" ? RPE_OPTIONS : RIR_OPTIONS;
  const idx = opts.indexOf(v);
  if (idx === -1) return null;
  return (enClaro() ? RIR_COLORS_CLARO : RIR_COLORS)[idx];
};
const metricOptions = (metric) => (metric === "RPE" ? RPE_OPTIONS : RIR_OPTIONS);

// ---------- Análisis de progreso ----------
// Puntaje de la sesión: % de ejercicios efectivamente registrados.
// Un ejercicio cuenta como hecho si el alumno cargó peso o RIR.
const ejercicioRegistrado = (ex) =>
  !!ex.ejercicio && ((ex.pesoUsado && ex.pesoUsado !== "") || (ex.rirTuyo && ex.rirTuyo !== ""));

const sessionScore = (session) => {
  const planificados = (session?.exercises || []).filter((e) => e.ejercicio);
  if (planificados.length === 0) return 0;
  const hechos = planificados.filter(ejercicioRegistrado).length;
  return Math.round((hechos / planificados.length) * 100);
};

// Compara el peso usado con el sugerido. null si alguno no es un
// número: no hay nada que decir.
const estadoPeso = (usado, sugerido) => {
  const n = (v) => { const x = parseFloat(String(v ?? "").trim().replace(",", "."));
                     return /^\s*\d+([.,]\d+)?\s*$/.test(String(v ?? "")) ? x : NaN; };
  const u = n(usado), g = n(sugerido);
  if (isNaN(u) || isNaN(g)) return null;
  return u === g ? "match" : u > g ? "harder" : "easier";
};
const parseNum = (v) => { const n = parseFloat(String(v).replace(",", ".")); return isNaN(n) ? 0 : n; };

// Carga interna de la sesión (Foster): esfuerzo Borg × duración.
const sessionLoad = (session) =>
  session?.borgRPE && session?.duracion
    ? Math.round(session.borgRPE * parseNum(session.duracion))
    : null;


// Distancia de edición, para sugerir "quisiste decir..." con nombres mal tipeados
const levenshtein = (a, b) => {
  const m = a.length, n = b.length;
  const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = 0; i <= m; i++) dp[i][0] = i;
  for (let j = 0; j <= n; j++) dp[0][j] = j;
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      dp[i][j] = a[i - 1] === b[j - 1] ? dp[i - 1][j - 1] : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
    }
  }
  return dp[m][n];
};

const fuzzyMatchStudents = (query, list) => {
  const q = query.trim().toLowerCase();
  if (q.length < 3) return [];
  return list
    .map((s) => {
      const words = s.name.toLowerCase().split(" ");
      const minDist = Math.min(...words.map((w) => levenshtein(q, w)));
      return { student: s, dist: minDist };
    })
    .filter((r) => r.dist > 0 && r.dist <= 3)
    .sort((a, b) => a.dist - b.dist)
    .slice(0, 3)
    .map((r) => r.student);
};

const metricToNumber = (value, metric) => {
  if (!value) return null;
  if (metric === "RPE") {
    const m = String(value).match(/[\d.]+/g);
    if (!m) return null;
    return m.reduce((a, n) => a + parseFloat(n), 0) / m.length;
  }
  const map = { "Al fallo": 0, "0": 0, "1": 1, "2": 2, "3": 3, "+4": 4 };
  return value in map ? map[value] : null;
};

const sessionVolume = (session) => session.exercises.reduce((sum, ex) => {
  const peso = ex.pesoUsado && ex.pesoUsado !== "-" ? parseNum(ex.pesoUsado) : 0;
  const series = parseNum(ex.series);
  const reps = parseNum(ex.reps);
  return sum + peso * series * reps;
}, 0);

// Todas las instancias de una sesión con el mismo nombre, en orden cronológico (según el array de semanas)
const findSessionHistory = (weeks, sessionName) => {
  const out = [];
  weeks.forEach((w) => {
    w.sessions.forEach((s) => {
      if (s.name === sessionName && s.estado === "Completado") out.push({ weekLabel: `${w.name.replace("Semana ", "S")} ${w.period.split(" ")[0].slice(0, 3)}`, week: w, session: s });
    });
  });
  return out;
};

// El peso se guarda SIEMPRE en kilos. Las libras son una forma de
// mostrarlo: si se guardaran las dos, un mismo ejercicio tendría dos
// historias y comparar semanas dejaría de tener sentido.
const aLibras = (kg) => {
  const n = parseNum(kg);
  if (!n) return null;
  // Se redondea a 0,5: nadie carga 88,18 libras.
  return Math.round(n * 2.20462 * 2) / 2;
};

// "40" → "40 kg · 88 lb" cuando el alumno entrena en libras.
const conUnidad = (kg, libras) => {
  if (!kg || kg === "-") return kg;
  if (!libras) return kg;
  const lb = aLibras(kg);
  return lb ? `${kg} - ${lb} lb` : kg;
};

const PESO_OPTIONS = (() => {
  const arr = ["-"];
  for (let v = 2.5; v <= 90; v += 2.5) arr.push(Number.isInteger(v) ? String(v) : v.toFixed(1));
  return arr;
})();

const BORG_OPTIONS = Array.from({ length: 10 }, (_, i) => i + 1);
const borgColor = (v) => `hsl(${120 - ((v - 1) / 9) * 120}, 70%, 48%)`;

// El Borg es una herramienta de trabajo entre coach y alumno.
// Para compartir en el grupo se traduce a una palabra: el número
// suelto no le dice nada a quien lo lee y se presta a comparaciones
// que no tienen sentido entre personas distintas.
const borgEnPalabras = (v) => {
  if (!v) return null;
  if (v <= 2) return "Muy suave";
  if (v <= 4) return "Suave";
  if (v <= 6) return "Moderado";
  if (v <= 8) return "Exigente";
  return "Al límite";
};

const FUERZA_OPTIONS = [
  { label: "Sin fuerza / Muy débil", color: "#ef4444" },
  { label: "Débil", color: "#f97316" },
  { label: "Moderada", color: "#f59e0b" },
  { label: "Buena", color: "#a3e635" },
  { label: "Fuerte", color: "#22c55e" },
  { label: "Muy fuerte", color: "#059669" },
];

const CUSTOM = "__custom__";

// ---------- Alumnos (mock) ----------
// El puntaje hoy es simple (sesiones completadas x 10) — lo terminamos de definir juntos
// cuando decidamos qué otros factores suman (constancia, RIR en objetivo, videos subidos, etc).
const scoreFor = (done) => done * 10;

// Estado del alumno en la semana en curso. Lo que el coach necesita
// ver de un vistazo es quién NO tiene plan armado todavía.
// De viernes a domingo, en hora argentina: el momento de planificar
// la semana que viene. Solo entonces se avisa a quién le falta.
const esFinDeSemanaAR = () => {
  const d = new Date(Date.now() - 3 * 3600e3);
  return [5, 6, 0].includes(d.getUTCDay());
};

const estadoSemana = (s) => {
  const asignadas = s.semanaSesiones || 0;
  const hechas = Math.min(s.semanaHechas || 0, asignadas);
  if (asignadas === 0) {
    return { sinPlan: true, asignadas: 0, hechas: 0, pct: 0,
             texto: "Sin sesiones asignadas", color: "#f97316" };
  }
  const pct = Math.round((hechas / asignadas) * 100);
  const color = pct === 100 ? "#22c55e" : pct >= 50 ? "#facc15" : "#ef4444";
  return { sinPlan: false, asignadas, hechas, pct,
           texto: `${hechas} de ${asignadas} cumplidas`, color };
};



const INITIAL_STUDENTS = [
  { id: "fede", name: "Federico Álvarez", sessionsDone: 14, sessionsTotal: 20, trainedToday: true, todaySession: "DIA 1 - MMII" },
  { id: "s2", name: "Martina Gómez", sessionsDone: 18, sessionsTotal: 20, trainedToday: true, todaySession: "Tren superior" },
  { id: "s3", name: "Lucas Fernández", sessionsDone: 9, sessionsTotal: 16, trainedToday: false },
  { id: "s4", name: "Camila Rodríguez", sessionsDone: 22, sessionsTotal: 24, trainedToday: true, todaySession: "DIA 2 - MMSS" },
  { id: "s5", name: "Tomás Pérez", sessionsDone: 6, sessionsTotal: 16, trainedToday: false },
  { id: "s6", name: "Sofía López", sessionsDone: 16, sessionsTotal: 20, trainedToday: true, todaySession: "Full Body" },
  { id: "s7", name: "Nicolás Díaz", sessionsDone: 11, sessionsTotal: 20, trainedToday: false },
  { id: "s8", name: "Valentina Martínez", sessionsDone: 19, sessionsTotal: 20, trainedToday: true, todaySession: "DIA 1 - MMII" },
  { id: "s9", name: "Agustín Sánchez", sessionsDone: 4, sessionsTotal: 12, trainedToday: false },
  { id: "s10", name: "Julieta Romero", sessionsDone: 20, sessionsTotal: 24, trainedToday: false },
  { id: "s11", name: "Franco Torres", sessionsDone: 13, sessionsTotal: 16, trainedToday: true, todaySession: "Movilidad + Core" },
  { id: "s12", name: "Micaela Ruiz", sessionsDone: 17, sessionsTotal: 20, trainedToday: false },
  { id: "s13", name: "Bautista Flores", sessionsDone: 8, sessionsTotal: 20, trainedToday: false },
  { id: "s14", name: "Catalina Acosta", sessionsDone: 15, sessionsTotal: 16, trainedToday: true, todaySession: "DIA 2 - MMSS" },
  { id: "s15", name: "Joaquín Benítez", sessionsDone: 10, sessionsTotal: 20, trainedToday: false },
  { id: "s16", name: "Delfina Suárez", sessionsDone: 21, sessionsTotal: 24, trainedToday: false },
  { id: "s17", name: "Santiago Molina", sessionsDone: 7, sessionsTotal: 16, trainedToday: false },
  { id: "s18", name: "Pilar Castro", sessionsDone: 12, sessionsTotal: 20, trainedToday: true, todaySession: "DIA 1 - MMII" },
  { id: "s19", name: "Ignacio Rojas", sessionsDone: 5, sessionsTotal: 12, trainedToday: false },
  { id: "s20", name: "Antonella Herrera", sessionsDone: 23, sessionsTotal: 24, trainedToday: false },
].map((s, i) => ({
  ...s,
  score: scoreFor(s.sessionsDone),
  // Plan de ESTA semana: cuántas sesiones tiene asignadas y cuántas cerró.
  // 0 asignadas = todavía no le armaste la semana.
  semanaSesiones: [3, 4, 0, 4, 2, 3, 0, 4, 2, 3, 3, 4, 0, 3, 2, 4, 2, 3, 0, 4][i],
  semanaHechas:   [2, 4, 0, 3, 1, 3, 0, 4, 0, 2, 3, 2, 0, 3, 1, 4, 2, 1, 0, 3][i],
}));

// Quién entrenó cada día de la semana actual, y qué (mock, para el calendario de actividad)
const COMMUNITY_ACTIVITY = {
  "Lunes": [{ id: "fede", session: "DIA 1 - MMII" }, { id: "s2", session: "Tren superior" }, { id: "s4", session: "DIA 2 - MMSS" }],
  "Martes": [{ id: "s6", session: "Full Body" }],
  "Miércoles": [],
  "Jueves": [{ id: "fede", session: "DIA 2 - MMSS" }, { id: "s2", session: "DIA 3 - MMII" }, { id: "s8", session: "DIA 1 - MMII" }, { id: "s11", session: "Movilidad + Core" }],
  "Viernes": [{ id: "s14", session: "DIA 2 - MMSS" }],
  "Sábado": [],
  "Domingo": [{ id: "s18", session: "Full Body" }],
};

const AVATAR_COLORS = ["#38bdf8", "#f472b6", "#34d399", "#fbbf24", "#60a5fa", "#a78bfa", "#fb923c", "#4ade80"];

// Se recorre el texto del id para elegir un color estable. Si no hay
// id —o no es texto— se usa el primero: un avatar sin color preferido
// es mucho mejor que la pantalla en blanco.
const colorForId = (id) => {
  const t = typeof id === "string" ? id : String(id ?? "");
  if (!t) return AVATAR_COLORS[0];
  return AVATAR_COLORS[[...t].reduce((a, c) => a + c.charCodeAt(0), 0) % AVATAR_COLORS.length];
};
const colorForValue = colorForId;

// ---------- Insignias (mock) ----------
const BADGES = [
  { id: "b1", name: "Primer entreno", desc: "Completaste tu primera sesión", icon: Dumbbell, color: "#38bdf8", unlocked: true },
  { id: "b2", name: "Racha de 7 días", desc: "Entrenaste 7 días seguidos", icon: Flame, color: "#f97316", unlocked: true },
  { id: "b3", name: "Constancia de hierro", desc: "4 semanas sin faltar", icon: Shield, color: "#22c55e", unlocked: true },
  { id: "b4", name: "Al límite", desc: "Llegaste a RIR 0 en un ejercicio", icon: Zap, color: "#ef4444", unlocked: true },
  { id: "b5", name: "Video estrella", desc: "Subiste tu primer video de ejecución", icon: Video, color: "#a855f7", unlocked: true },
  { id: "b6", name: "Top 10", desc: "Entraste al Top 10 del ranking", icon: Trophy, color: "#facc15", unlocked: false, progress: "Puesto actual: 14°" },
  { id: "b7", name: "Mes perfecto", desc: "100% de las sesiones de un mes", icon: Star, color: "#22c55e", unlocked: false, progress: "18/20 sesiones" },
  { id: "b8", name: "Madrugador", desc: "Entrenaste antes de las 7am, 5 veces", icon: Sunrise, color: "#f59e0b", unlocked: false, progress: "2/5" },
  { id: "b9", name: "Entrenamiento fino", desc: "Coincidiste el RIR con tu coach 3 veces en una sesión", icon: Target, color: "#06b6d4", unlocked: false, progress: "0/3 coincidencias" },
  { id: "b10", name: "Racha imparable", desc: "Sesiones seguidas sin faltar", icon: TrendingUp, color: "#84cc16", unlocked: false, progress: "12 sesiones seguidas" },
  { id: "b11", name: "Corona del ranking", desc: "Llegaste al 1° puesto del ranking", icon: Crown, color: "#facc15", unlocked: false, progress: "Puesto actual: 3°" },
  { id: "b12", name: "Un día más", desc: "Tu coach te sumó un día extra de entreno", icon: CalendarPlus, color: "#22c55e", unlocked: false, progress: "Esperando que tu coach sume un día" },
  { id: "b13", name: "Embajador Be", desc: "Compartiste tu entrenamiento en el grupo", icon: Share2, color: "#a855f7", unlocked: false, progress: "0/3 veces compartido" },
];

// Nombres en castellano para el panel de diagnóstico.
const NOMBRES_TABLA = {
  perfiles: "Personas registradas",
  ejercicios: "Ejercicios en la biblioteca",
  semanas: "Semanas creadas",
  sesiones: "Sesiones creadas",
  sesion_ejercicios: "Ejercicios dentro de sesiones",
  exp_movimientos: "Movimientos de EXP",
};

const DIAS_SEMANA = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

// ---------- Niveles y EXP ----------
// Cada nivel cuesta más que el anterior: subir de 1 a 2 sale 80 EXP,
// de 9 a 10 sale 400. Así el nivel alto significa constancia sostenida
// y no una racha de dos semanas buenas.
const expParaSubir = (nivel) => 80 + (nivel - 1) * 40;

const levelFromExp = (expTotal) => {
  let nivel = 1, restante = Math.max(0, expTotal || 0);
  while (restante >= expParaSubir(nivel) && nivel < 99) {
    restante -= expParaSubir(nivel);
    nivel += 1;
  }
  return nivel;
};

// Cuánto lleva acumulado dentro del nivel en curso.
const expInLevel = (expTotal) => {
  let nivel = 1, restante = Math.max(0, expTotal || 0);
  while (restante >= expParaSubir(nivel) && nivel < 99) {
    restante -= expParaSubir(nivel);
    nivel += 1;
  }
  return restante;
};

const expDelNivel = (expTotal) => expParaSubir(levelFromExp(expTotal));

// De dónde sale la EXP. Todo lo que suma depende de algo que el
// alumno hizo: nada es al azar y nada se regala.
const EXP = {
  sesionCompleta: 20,   // proporcional al % de la sesión
  sesionPerfecta: 10,   // bonus si la cerró al 100%
  rirCoincide: 5,       // por ejercicio donde acertó la consigna
  recordSuperado: 25,   // por PR nuevo
  videoPropio: 5,       // por video de técnica que sube
  semanaCompleta: 50,   // todas las sesiones de la semana cerradas
  insignia: 40,         // por insignia ganada
};

const seedExercise = (over = {}) => ({
  seccion: "principal", bloque: "",
  ejercicio: "", conQue: "", series: "4", reps: "10", rirConsigna: "2", metric: "RIR",
  pesoUsado: "", rirTuyo: "", comentarios: "", pesoPrevia: "", rirPrevia: "",
  videoTecnica: true, videoAlumno: "", videoUrl: "", gifUrl: "",
  modo: "reps", descanso: null, biserie: null, notaCoach: "",
  tecnica: "normal", tecnicaConfig: null, pesoSugerido: "", finalizador: false, ...over,
});

// ---------- Librería de plantillas (coach) ----------
const tplExercise = (over) => seedExercise(over);

const INITIAL_LIBRARY_CATEGORIES = [
  { id: "sin-categoria", name: "Sin categoría", icon: FolderOpen, templates: [] },
  {
    id: "superior", name: "Miembro superior", icon: Dumbbell,
    templates: [
      { id: "t-sup1", name: "Empuje - Pecho y hombro", exercises: [
        tplExercise({ ejercicio: "Press banca", conQue: "Barra", series: "4", reps: "8", rirConsigna: "2" }),
        tplExercise({ ejercicio: "Press militar", conQue: "Mancuerna", series: "3", reps: "10", rirConsigna: "2" }),
        tplExercise({ ejercicio: "Elevaciones laterales", conQue: "Mancuerna", series: "3", reps: "15", rirConsigna: "1" }),
      ]},
      { id: "t-sup2", name: "Tracción - Espalda y bíceps", exercises: [
        tplExercise({ ejercicio: "Remo en polea", conQue: "Máquina", series: "4", reps: "10", rirConsigna: "2" }),
        tplExercise({ ejercicio: "Dominadas", conQue: "Peso libre", series: "3", reps: "8", rirConsigna: "2" }),
        tplExercise({ ejercicio: "Curl bíceps", conQue: "Mancuerna", series: "3", reps: "12", rirConsigna: "1" }),
      ]},
    ],
  },
  {
    id: "inferior", name: "Miembro inferior", icon: Dumbbell,
    templates: [
      { id: "t-inf1", name: "Cuádriceps dominante", exercises: [
        tplExercise({ ejercicio: "Sentadilla", conQue: "Barra", series: "4", reps: "8", rirConsigna: "2" }),
        tplExercise({ ejercicio: "Prensa", conQue: "Máquina", series: "4", reps: "12", rirConsigna: "2" }),
        tplExercise({ ejercicio: "Extensión de cuádriceps", conQue: "Máquina", series: "3", reps: "15", rirConsigna: "1" }),
      ]},
      { id: "t-inf2", name: "Glúteo y femoral", exercises: [
        tplExercise({ ejercicio: "Hip thrust", conQue: "Barra", series: "4", reps: "10", rirConsigna: "2" }),
        tplExercise({ ejercicio: "Peso muerto rumano", conQue: "Barra", series: "4", reps: "8", rirConsigna: "2" }),
        tplExercise({ ejercicio: "Curl femoral", conQue: "Máquina", series: "3", reps: "12", rirConsigna: "1" }),
      ]},
    ],
  },
  {
    id: "tabata", name: "Tabata", icon: Zap, metric: "RPE",
    templates: [
      { id: "t-tab1", name: "Tabata full body", hasTimer: true, timerConfig: { work: 20, rest: 10, rounds: 8 }, exercises: [
        tplExercise({ ejercicio: "Isométrico sentadillas + estocadas atrás", conQue: "Sin material", series: "8", reps: "20\"/10\"", rirConsigna: "8-9", metric: "RPE" }),
        tplExercise({ ejercicio: "Escaladores + Swing", conQue: "Kettlebell", series: "8", reps: "20\"/10\"", rirConsigna: "8-9", metric: "RPE" }),
        tplExercise({ ejercicio: "Peso muerto + puente de glúteo 1 pierna", conQue: "Peso libre", series: "8", reps: "20\"/10\"", rirConsigna: "8-9", metric: "RPE" }),
        tplExercise({ ejercicio: "Oblicuos + sentadillas con peso", conQue: "Peso libre", series: "8", reps: "20\"/10\"", rirConsigna: "8-9", metric: "RPE" }),
      ]},
    ],
  },
  {
    id: "intermitente", name: "Intermitente", icon: TrendingUp, metric: "RPE",
    templates: [
      { id: "t-int1", name: "HIIT 30/30", hasTimer: true, timerConfig: { work: 30, rest: 30, rounds: 10 }, exercises: [
        tplExercise({ ejercicio: "Burpees", conQue: "Sin material", series: "10", reps: "30\"/30\"", rirConsigna: "8-9", metric: "RPE" }),
        tplExercise({ ejercicio: "Jumping jacks", conQue: "Sin material", series: "10", reps: "30\"/30\"", rirConsigna: "7-8", metric: "RPE" }),
        tplExercise({ ejercicio: "Zancada con salto", conQue: "Sin material", series: "10", reps: "30\"/30\"", rirConsigna: "8-9", metric: "RPE" }),
      ]},
    ],
  },
  {
    id: "running", name: "Running", icon: Footprints, metric: "RPE",
    templates: [
      { id: "t-run1", name: "Fondo regenerativo", exercises: [
        tplExercise({ ejercicio: "Trote continuo", conQue: "Sin material", series: "1", reps: "40 min", rirConsigna: "5-6", metric: "RPE" }),
      ]},
      { id: "t-run2", name: "Series de velocidad", exercises: [
        tplExercise({ ejercicio: "Series 400m", conQue: "Sin material", series: "8", reps: "400m", rirConsigna: "8-9", metric: "RPE" }),
        tplExercise({ ejercicio: "Trote de recuperación", conQue: "Sin material", series: "8", reps: "2 min", rirConsigna: "5-6", metric: "RPE" }),
      ]},
      { id: "t-run3", name: "Umbral anaeróbico", exercises: [
        tplExercise({ ejercicio: "Umbral 5x1000m", conQue: "Sin material", series: "5", reps: "1000m", rirConsigna: "7-8", metric: "RPE" }),
      ]},
    ],
  },
];

const makeSimpleWeek = (id, name, period, sessionNames, weekIndex = 0) => ({
  id, name, period,
  sessions: sessionNames.map((sn, idx) => ({
    id: `${id}-s${idx}`, name: sn, estado: "Completado",
    borgRPE: 5 + (idx % 3), fuerzaPercibida: ["Buena", "Fuerte", "Moderada"][idx % 3],
    duracion: String(45 + (weekIndex % 4) * 5 + idx * 3),
    exercises: [
      seedExercise({ ejercicio: "Sentadilla", conQue: "Barra", series: "4", reps: "8", rirConsigna: "2",
        pesoUsado: String(30 + weekIndex * 2.5), rirTuyo: ["2", "2", "1", "2", "3", "2", "1", "2"][weekIndex % 8] }),
      seedExercise({ ejercicio: "Press banca", conQue: "Barra", series: "4", reps: "8", rirConsigna: "2",
        pesoUsado: String(22.5 + weekIndex * 1.5), rirTuyo: ["1", "2", "2", "1", "2", "3", "2", "2"][weekIndex % 8] }),
    ],
  })),
});

const initialWeeks = [
  makeSimpleWeek("w-may1", "Semana 1", "MAYO 2026", ["DIA 1 - MMII", "DIA 2 - MMSS"], 0),
  makeSimpleWeek("w-may2", "Semana 2", "MAYO 2026", ["DIA 1 - MMII", "DIA 2 - MMSS"], 1),
  makeSimpleWeek("w-may3", "Semana 3", "MAYO 2026", ["DIA 1 - MMII", "DIA 2 - MMSS"], 2),
  makeSimpleWeek("w-jun1", "Semana 1", "JUNIO 2026", ["DIA 1 - MMII", "DIA 2 - MMSS"], 3),
  makeSimpleWeek("w-jun2", "Semana 2", "JUNIO 2026", ["DIA 1 - MMII", "DIA 2 - MMSS"], 4),
  makeSimpleWeek("w-jun3", "Semana 3", "JUNIO 2026", ["DIA 1 - MMII", "DIA 2 - MMSS"], 5),
  makeSimpleWeek("w-jun4", "Semana 4", "JUNIO 2026", ["DIA 1 - MMII", "DIA 2 - MMSS"], 6),
  makeSimpleWeek("w-jun5", "Semana 5", "JUNIO 2026", ["DIA 1 - MMII", "DIA 2 - MMSS"], 7),
  {
    id: "w-jul4", name: "Semana 4", period: "JULIO 2026",
    sessions: [
      {
        id: "s1", name: "DIA 1 - MMII", estado: "Completado", borgRPE: 6, fuerzaPercibida: "Buena", day: "Lunes", duracion: "58",
        exercises: [
          seedExercise({ ejercicio: "Hip thrust", conQue: "Máquina", series: "4", reps: "10", rirConsigna: "1", pesoUsado: "50", rirTuyo: "1" }),
          seedExercise({ ejercicio: "Zancada", conQue: "Máquina", series: "4", reps: "30", rirConsigna: "2", pesoUsado: "14", rirTuyo: "0", comentarios: "hagamos aca la estocada con elastico que hicimos el otro dia en la clase, se sintio bastante mas duro de lo esperado", videoAlumno: "https://drive.google.com/ejemplo-zancada" }),
          seedExercise({ ejercicio: "Sentadilla", conQue: "Elástico", series: "4", reps: "8", rirConsigna: "3", pesoUsado: "-", rirTuyo: "+4" }),
          seedExercise({ ejercicio: "Press banca", conQue: "Mancuerna", series: "4", reps: "10", rirConsigna: "2", pesoUsado: "15", rirTuyo: "2" }),
        ],
      },
      {
        id: "s2", name: "DIA 2 - MMSS", estado: "Completado", borgRPE: 5, fuerzaPercibida: "Fuerte", day: "Jueves", duracion: "50",
        exercises: [
          seedExercise({ ejercicio: "Remo en polea", conQue: "Máquina", series: "4", reps: "12", rirConsigna: "2", pesoUsado: "40", rirTuyo: "2" }),
          seedExercise({ ejercicio: "Press militar", conQue: "Mancuerna", series: "3", reps: "10", rirConsigna: "2", pesoUsado: "12", rirTuyo: "1" }),
          seedExercise({ ejercicio: "Curl bíceps", conQue: "Mancuerna", series: "3", reps: "12", rirConsigna: "1", pesoUsado: "10", rirTuyo: "1" }),
        ],
      },
      {
        id: "s3", name: "DIA 3 - MMII", estado: "Pendiente", borgRPE: null, fuerzaPercibida: null, puntaje: null, carga: null, day: null,
        exercises: [
          seedExercise({ ejercicio: "Peso muerto rumano", conQue: "Barra", series: "4", reps: "8", rirConsigna: "2" }),
          seedExercise({ ejercicio: "Prensa", conQue: "Máquina", series: "4", reps: "12", rirConsigna: "2" }),
        ],
      },
      {
        id: "s4", name: "DIA 4 - Full Body", estado: "Pendiente", borgRPE: null, fuerzaPercibida: null, puntaje: null, carga: null, day: null,
        exercises: [
          seedExercise({ ejercicio: "Dominadas", conQue: "Peso libre", series: "3", reps: "8", rirConsigna: "2" }),
          seedExercise({ ejercicio: "Plancha", conQue: "Sin material", series: "3", reps: "30", rirConsigna: "1" }),
        ],
      },
    ],
  },
];

// ---------- UI helpers ----------

const ESTADO_STYLES = {
  "Pendiente": { text: "text-red-400", bg: "bg-red-400/10", border: "border-red-400/20", icon: Clock },
  "En proceso": { text: "text-yellow-400", bg: "bg-yellow-400/10", border: "border-yellow-400/20", icon: RefreshCw },
  "Completado": { text: "text-emerald-400", bg: "bg-emerald-400/10", border: "border-emerald-400/20", icon: Check },
};

// Campo de contraseña con el ojo para verla.
//
// Escribir a ciegas en un teclado de celular es donde más se
// equivoca la gente, y después no entiende por qué no entra.
const CampoPassword = ({ value, onChange, placeholder, className = "",
                         autoComplete = "current-password", onKeyDown, icono = null }) => {
  const [ver, setVer] = useState(false);
  return (
    <div className="relative">
      {icono}
      <input type={ver ? "text" : "password"} value={value}
        onChange={onChange} onKeyDown={onKeyDown}
        placeholder={placeholder} autoComplete={autoComplete}
        className={`${className} pr-10`} />
      <button type="button" onClick={() => setVer((v) => !v)}
        aria-label={ver ? "Ocultar la contraseña" : "Ver la contraseña"}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-neutral-500 hover:text-neutral-300 transition-colors">
        {ver ? <EyeOff size={15} /> : <Eye size={15} />}
      </button>
    </div>
  );
};

const Avatar = ({ student, size = 18, ring = true }) => {
  const nombre = typeof student?.name === "string" ? student.name : "";
  const initials = nombre.split(" ").filter(Boolean).map((n) => n[0]).slice(0, 2).join("") || "?";
  const color = colorForId(student?.id);
  const style = { width: size, height: size, fontSize: size * 0.4, ...(ring ? { border: "1.5px solid var(--tw-ring-offset-color, #171717)" } : {}) };
  if (student?.photo) {
    return <img src={student.photo} alt={nombre} style={style} className="rounded-full object-cover shrink-0" />;
  }
  return (
    <div style={{ ...style, backgroundColor: `${color}33`, color }} className="rounded-full flex items-center justify-center font-bold shrink-0">
      {initials}
    </div>
  );
};

const EstadoBadge = ({ estado }) => {
  const s = ESTADO_STYLES[estado] || ESTADO_STYLES["Pendiente"];
  const Icon = s.icon || Dumbbell;
  return <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium tracking-wide ${s.bg} ${s.text} border ${s.border}`}><Icon size={11} /> {estado}</span>;
};

// `tono` es el color de la tarjeta. Todos los valores lo usan, así la
// tarjeta se lee como una unidad. El RIR es la excepción: su color
// significa esfuerzo, y eso vale más que la coherencia visual.
// Un icono por concepto. Se elige por la etiqueta del campo, así
// vale para el que lo lee y para el que lo edita sin tocar los dos
// componentes por separado.
// El color de cada concepto. El icono lo lleva aunque la etiqueta
// quede gris: identifica el campo antes de leerlo.
const COLOR_CAMPO = (label = "") => {
  const l = String(label).toLowerCase();
  if (l.includes("usado") || l.includes("tuyo")) return "#38bdf8";
  if (l.includes("serie") && !l.includes("descanso")) return "#a78bfa";
  if (l.includes("rep")) return "#38bdf8";
  if (l.includes("peso")) return "#fbbf24";
  if (l.includes("rir") || l.includes("rpe")) return "#fb923c";
  if (l.includes("descanso")) return "#38bdf8";
  if (l.includes("técnica") || l.includes("tecnica")) return "#94a3b8";
  if (l.includes("con qué") || l.includes("con que")) return "#2dd4bf";
  if (l.includes("tiempo") || l.includes("segundo")) return "#6fc48d";
  return "#8a8a8a";
};

const ICONO_CAMPO = (label = "") => {
  const l = String(label).toLowerCase();
  // Lo que completa el alumno lleva lápiz: distingue de un vistazo lo
  // que se lee de lo que se escribe, que es la diferencia que importa
  // mientras estás entrenando.
  if (l.includes("usado") || l.includes("tuyo")) return Pencil;
  if (l.includes("serie") && !l.includes("descanso")) return Layers;
  if (l.includes("rep")) return Repeat;
  if (l.includes("peso")) return Dumbbell;
  if (l.includes("rir") || l.includes("rpe")) return Gauge;
  if (l.includes("descanso")) return Hourglass;
  if (l.includes("técnica") || l.includes("tecnica")) return SlidersHorizontal;
  if (l.includes("con qué") || l.includes("con que")) return Wrench;
  if (l.includes("tiempo") || l.includes("segundo")) return Timer;
  return null;
};

// La etiqueta con su icono. Los campos que completa el alumno llevan
// lápiz: distingue de un vistazo lo que se lee de lo que se escribe.
// Cada campo en su recuadro, como una ficha: el fondo separa un dato
// del de al lado sin necesidad de líneas, y en un celular angosto eso
// es lo que hace que no se lean todos como un bloque de texto.
const CajaCampo = ({ children, destacada, className = "" }) => (
  <div className={`rounded-[9px] px-2.5 py-2.5 ${className}`}
    style={{
      // Más CLARA que la tarjeta, no más oscura: sobre #262626 un
      // #303030 se despega hacia adelante en vez de hundirse.
      background: "#303030",
      // Un filo de luz casi invisible arriba. Es lo que más aporta y
      // casi no se percibe conscientemente.
      border: destacada ? "1px solid #38bdf855" : "1px solid #ffffff0a",
    }}>
    {children}
  </div>
);

// ─────────────────────────────────────────────────────────────
// La "i" de información: qué es cada campo, sin ir a la guía.
//
// Solo la ve el alumno. Al coach le sobraría: sabe qué es cada cosa,
// y veinte "i" por sesión son ruido para quien arma la planificación.
// Se fija en cada render de la app, antes de dibujar las tarjetas.
// ─────────────────────────────────────────────────────────────
let ayudaVisible = false;

const AYUDAS = {
  conQue:       { t: "Con qué", c: "#2dd4bf",
    x: "El material para hacer el ejercicio: mancuernas, barra, máquina, o sin material." },
  tecnica:      { t: "Técnica", c: "#94a3b8",
    x: "Cómo se hace la serie. Normal es lo habitual; las otras cambian el peso o el descanso dentro de la serie." },
  series:       { t: "Series", c: "#a78bfa",
    x: "Cuántas veces hacés el ejercicio, con un descanso entre cada vez." },
  reps:         { t: "Repeticiones", c: "#38bdf8",
    x: "Cuántas veces repetís el movimiento en cada serie." },
  tiempo:       { t: "Tiempo", c: "#6fc48d",
    x: "Cuánto dura cada serie. Se hace durante ese tiempo en vez de contar repeticiones." },
  pesoSugerido: { t: "Peso sugerido", c: "#fbbf24",
    x: "Con el que Mati calcula que vas a llegar al RIR pedido. Es una referencia: si el día no da, bajalo." },
  pesoUsado:    { t: "Peso usado", c: "#38bdf8",
    x: "El peso que moviste de verdad. Si fue el sugerido, tocá el atajo de abajo y se completa solo." },
  rirConsigna:  { t: "RIR consigna", c: "#fb923c",
    x: "Cuántas repeticiones te tienen que sobrar al terminar la serie. Si dice 2, elegí un peso con el que podrías hacer 2 más." },
  rirTuyo:      { t: "RIR tuyo", c: "#38bdf8",
    x: "Cuántas te sobraron de verdad. Anotá el número real, no el que queda bien: con esto Mati ajusta el peso." },
  descanso:     { t: "Descanso", c: "#38bdf8",
    x: "El tiempo entre serie y serie. Tocá la caja para arrancarlo y suena al terminar." },
  piramidal:    { t: "Piramidal", c: "#fb923c",
    x: "El peso cambia en cada serie. Hacé la que te muestra y tocá \"Hice esta serie\" para pasar a la siguiente." },
  emom:         { t: "EMOM", c: "#a78bfa",
    x: "Cada minuto arranca un bloque nuevo, con una repetición más. Seguí hasta que no llegues y tocá \"Llegué al fallo\"." },
  tabata:       { t: "Tabata", c: "#f87171",
    x: "Intervalos de trabajo y descanso marcados por el reloj. Los dos ejercicios se alternan: uno en cada ronda." },
};

// La ayuda que corresponde a una etiqueta de campo.
const ayudaDe = (label = "") => {
  const l = String(label).toLowerCase();
  if (l.includes("consigna")) return AYUDAS.rirConsigna;
  if (l.includes("tuyo")) return AYUDAS.rirTuyo;
  if (l.includes("sugerido")) return AYUDAS.pesoSugerido;
  if (l.includes("usado")) return AYUDAS.pesoUsado;
  if (l.includes("con qué") || l.includes("con que")) return AYUDAS.conQue;
  if (l.includes("técnica") || l.includes("tecnica")) return AYUDAS.tecnica;
  if (l.includes("serie") && !l.includes("descanso")) return AYUDAS.series;
  if (l.includes("segundo") || l.includes("tiempo")) return AYUDAS.tiempo;
  if (l.includes("rep")) return AYUDAS.reps;
  if (l.includes("descanso")) return AYUDAS.descanso;
  return null;
};

// ─────────────────────────────────────────────────────────────
// Papelitos que salen de un botón.
//
// Para festejar sin frenar: no hay ventana que cerrar, las piezas no
// reciben toques (pointer-events: none) y se borran solas. Se puede
// seguir aprobando la siguiente mientras todavía caen.
// ─────────────────────────────────────────────────────────────
function papelitos(origen, colores = ["#6fc48d", "#38bdf8", "#fbbf24", "#a78bfa", "#fb923c"]) {
  try {
    // Quien pidió menos movimiento en su teléfono no lo recibe.
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    const r = origen?.getBoundingClientRect?.();
    if (!r) return;
    const x0 = r.left + r.width / 2;
    const y0 = r.top + r.height / 2;

    for (let i = 0; i < 26; i++) {
      const pieza = document.createElement("span");
      const ancho = 5 + Math.random() * 4;
      Object.assign(pieza.style, {
        position: "fixed", left: `${x0}px`, top: `${y0}px`,
        width: `${ancho}px`, height: `${ancho * (0.4 + Math.random() * 0.8)}px`,
        background: colores[i % colores.length],
        borderRadius: Math.random() > 0.6 ? "999px" : "1px",
        pointerEvents: "none", zIndex: "60",
      });
      document.body.appendChild(pieza);

      // Salen hacia arriba en abanico y caen con gravedad.
      const angulo = -Math.PI / 2 + (Math.random() - 0.5) * 2.1;
      const fuerza = 70 + Math.random() * 90;
      const dx = Math.cos(angulo) * fuerza;
      const dy = Math.sin(angulo) * fuerza;
      const giro = (Math.random() - 0.5) * 720;
      const dur = 800 + Math.random() * 500;

      pieza.animate([
        { transform: "translate(-50%, -50%) rotate(0deg)", opacity: 1 },
        { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) rotate(${giro / 2}deg)`,
          opacity: 1, offset: 0.45 },
        { transform: `translate(calc(-50% + ${dx * 1.3}px), calc(-50% + ${dy + 110}px)) rotate(${giro}deg)`,
          opacity: 0 },
      ], { duration: dur, easing: "cubic-bezier(0.2, 0.7, 0.4, 1)" })
        .onfinish = () => pieza.remove();
    }
  } catch { /* si el navegador no anima, no pasa nada */ }
}

// El cronómetro de descanso, plegable.
//
// No todos lo usan: quien cuenta el descanso en el reloj del gimnasio
// tenía una caja grande en cada ejercicio ocupando lugar. Plegado
// queda una línea con el tiempo, y se abre tocándola.
//
// La elección se recuerda para TODA la app: quien lo pliega una vez
// no quiere plegarlo en cada ejercicio. Igual puede abrir el de un
// ejercicio suelto sin cambiar el resto.
// La conversación de un ejercicio: todo lo que se dijeron, semana a
// semana, sin copiar nada de una a otra.
//
// Plegada muestra cuántos mensajes hay y el último. Desplegada, el
// hilo separado por semana y el campo para escribir.
// Ocho alcanzan para responder sin escribir. Más que eso convierte
// la elección en una lista para leer, que es justo lo que la reacción
// viene a evitar.
const REACCIONES = ["👍", "💪", "🔥", "👏", "❤️", "😅", "😂", "🤦"];

// Mensajes del otro que siguen sin respuesta: los últimos seguidos que
// escribió él, salvo los que ya tienen tu reacción.
const sinContestar = (mensajes = [], yo) => {
  let n = 0;
  for (let k = (mensajes || []).length - 1; k >= 0; k--) {
    const m = mensajes[k];
    if (m.autor === yo) break;
    if (!(m.reacciones || {})[yo]) n++;
  }
  return n;
};

const HiloEjercicio = ({ hilo, alumnoNombre, esCoach, onEnviar, onFoto,
                         onVerTodo, onReaccionar, abiertoInicial = false,
                         puedeTocar, onEditar, onBorrar }) => {
  // Qué mensaje tiene abierto el selector de reacciones.
  const [eligiendo, setEligiendo] = useState(null);
  // Mensajes propios del coach: el que muestra "Editar · Borrar", el
  // que se está editando y el que pide confirmar el borrado.
  const [acciones, setAcciones] = useState(null);
  const [editando, setEditando] = useState(null);   // { id, texto }
  const [borrando, setBorrando] = useState(null);
  const [abierto, setAbierto] = useState(abiertoInicial);
  const [texto, setTexto] = useState("");
  const [mandando, setMandando] = useState(false);

  const mensajes = hilo?.mensajes || [];
  const total = hilo?.total || mensajes.length;
  const ultimo = mensajes[mensajes.length - 1];
  const hayMas = total > mensajes.length;

  const mandar = async () => {
    const t = texto.trim();
    if (!t || mandando) return;
    setMandando(true);
    const ok = await onEnviar(t);
    setMandando(false);
    if (ok) setTexto("");
  };

  // Los mensajes agrupados por semana, para leerlos como un diario.
  const porSemana = [];
  for (const m of mensajes) {
    const clave = m.semana || "Antes";
    const ult = porSemana[porSemana.length - 1];
    if (ult && ult.semana === clave) ult.items.push(m);
    else porSemana.push({ semana: clave, items: [m] });
  }

  if (!abierto) {
    return (
      <button onClick={() => setAbierto(true)}
        className="w-full text-left rounded-lg px-2.5 py-2.5 transition-colors hover:bg-neutral-700/40"
        style={{ background: "#303030", border: "1px solid #ffffff0a" }}>
        <span className="flex items-center gap-2">
          <MessagesSquare size={14} style={{ color: "#38bdf8" }} className="shrink-0" />
          <span className="text-[11.5px] flex-1">Conversación</span>
          {total > 0 && (
            <span className="text-[10px] text-neutral-500 rounded-full px-2 py-0.5"
              style={{ background: "#ffffff0d" }}>{total}</span>
          )}
          <ChevronDown size={13} className="text-neutral-600 shrink-0" />
        </span>
        {ultimo && (
          <span className="block text-[10px] text-neutral-600 mt-1.5 truncate">
            Último: {ultimo.autor === "coach" ? (esCoach ? "Coach" : "Tu coach") : (alumnoNombre || "el alumno")} ·
            {" "}{ultimo.texto ? `"${ultimo.texto}"` : "una foto"}
          </span>
        )}
      </button>
    );
  }

  return (
    <div className="rounded-lg p-2.5"
      style={{ background: "#303030", border: "1px solid #ffffff0a" }}>
      <button onClick={() => setAbierto(false)}
        className="w-full flex items-center gap-2 mb-2.5">
        <MessagesSquare size={14} style={{ color: "#38bdf8" }} className="shrink-0" />
        <span className="text-[11.5px] flex-1 text-left">Conversación</span>
        <ChevronDown size={13} className="text-neutral-600 shrink-0 rotate-180" />
      </button>

      {hayMas && (
        <button onClick={onVerTodo}
          className="w-full text-[10px] text-neutral-500 hover:text-sky-400 mb-2 transition-colors">
          Ver los {total} mensajes
        </button>
      )}

      {!mensajes.length && (
        <p className="text-[10.5px] text-neutral-600 text-center py-2">
          Todavía no hay nada acá.
        </p>
      )}

      {porSemana.map((g, gi) => (
        <div key={gi}>
          <div className="flex items-center gap-2 mb-2">
            <span className="h-px flex-1" style={{ background: "#ffffff0d" }} />
            {/* La semana y el día: "Semana 3" solo no ubica cuándo
                fue si pasaron dos meses. */}
            <span className="text-[8.5px] uppercase tracking-[0.06em] text-neutral-600">
              {g.semana}
              {g.items[0]?.cuando && ` · ${new Date(g.items[0].cuando)
                .toLocaleDateString("es-AR", { day: "numeric", month: "short" })}`}
            </span>
            <span className="h-px flex-1" style={{ background: "#ffffff0d" }} />
          </div>
          {g.items.map((m) => {
            const mio = esCoach ? m.autor === "coach" : m.autor === "alumno";
            const tocable = !!(puedeTocar && puedeTocar(m) && onEditar && onBorrar);
            return (
              <div key={m.id}
                className={`flex gap-1.5 mb-1.5 ${mio ? "flex-row-reverse" : ""}`}>
                <span className="w-[22px] h-[22px] rounded-full shrink-0 flex items-center justify-center text-[9px]"
                  style={m.autor === "coach"
                    ? { background: "#38bdf826", color: "#38bdf8" }
                    : { background: "#404040", color: "#a3a3a3" }}>
                  {m.autor === "coach" ? "C" : (alumnoNombre || "A").charAt(0).toUpperCase()}
                </span>
                <div className="max-w-[78%] relative">
                  <div onDoubleClick={() => setEligiendo(eligiendo === m.id ? null : m.id)}
                    onClick={tocable && editando?.id !== m.id
                      ? () => { setAcciones(acciones === m.id ? null : m.id); setBorrando(null); } : undefined}
                    className={`rounded-[9px] px-2.5 py-2 ${tocable ? "cursor-pointer" : ""}`}
                    style={m.autor === "coach"
                      ? { background: "#38bdf814", border: "1px solid #38bdf833" }
                      : { background: "#262626" }}>
                    {editando?.id === m.id ? (
                      <div className="space-y-1.5" onClick={(e) => e.stopPropagation()}>
                        <textarea autoFocus rows={2} value={editando.texto}
                          onChange={(e) => setEditando({ id: m.id, texto: e.target.value })}
                          className="w-full bg-neutral-900 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-md px-2 py-1.5 text-base resize-none" />
                        <div className="flex justify-end gap-2">
                          <button onClick={() => setEditando(null)} className="text-[11px] text-neutral-500 px-1.5">Cancelar</button>
                          <button onClick={async () => {
                              const t = editando.texto.trim();
                              if (!t && !m.foto) return;
                              setEditando(null); setAcciones(null);
                              await onEditar(m, t);
                            }}
                            className="text-[11px] font-semibold rounded-md px-2.5 py-1 bg-sky-400 text-black">Guardar</button>
                        </div>
                      </div>
                    ) : m.texto && (
                      <p className="text-[11.5px] leading-relaxed" style={{ color: "#d4d4d4" }}>
                        {m.texto}
                        {m.editado && <span className="text-[9.5px] text-neutral-500"> · editado</span>}
                      </p>
                    )}
                    {m.foto && (
                      <div className={m.texto ? "mt-1.5" : ""}>
                        <FotoAdjunta ruta={m.foto} />
                      </div>
                    )}
                  </div>

                  {/* Editar o borrar: aparece al tocar un mensaje propio. */}
                  {tocable && acciones === m.id && editando?.id !== m.id && (
                    <div className={`flex items-center gap-2.5 mt-1 text-[11px] ${mio ? "justify-end" : ""}`}>
                      {borrando === m.id ? (
                        <>
                          <span className="text-neutral-400">¿Borrar el mensaje?</span>
                          <button onClick={() => setBorrando(null)} className="text-neutral-500">No</button>
                          <button onClick={async () => { setBorrando(null); setAcciones(null); await onBorrar(m); }}
                            className="text-red-400 font-semibold">Sí, borrar</button>
                        </>
                      ) : (
                        <>
                          {m.texto != null && (
                            <button onClick={() => setEditando({ id: m.id, texto: m.texto || "" })}
                              className="inline-flex items-center gap-1 text-sky-400"><Pencil size={11} /> Editar</button>
                          )}
                          <button onClick={() => setBorrando(m.id)}
                            className="inline-flex items-center gap-1 text-red-400"><Trash2 size={11} /> Borrar</button>
                        </>
                      )}
                    </div>
                  )}

                  {/* Las reacciones puestas, debajo del mensaje. */}
                  {Object.keys(m.reacciones || {}).length > 0 && (
                    <div className={`flex gap-1 mt-1 ${mio ? "justify-end" : ""}`}>
                      {Object.entries(m.reacciones).map(([quien, emoji]) => (
                        <span key={quien} title={quien === "coach" ? "Coach" : alumnoNombre}
                          className="text-[11px] rounded-full px-1.5 py-0.5"
                          style={{ background: "#ffffff0d" }}>{emoji}</span>
                      ))}
                    </div>
                  )}

                  {/* Reaccionar: se abre con un toque en la carita. */}
                  <button onClick={() => setEligiendo(eligiendo === m.id ? null : m.id)}
                    title="Reaccionar"
                    className={`absolute -bottom-1 ${mio ? "-left-5" : "-right-5"} w-5 h-5 rounded-full flex items-center justify-center text-neutral-600 hover:text-sky-400 transition-colors`}>
                    <SmilePlus size={13} />
                  </button>

                  {eligiendo === m.id && (
                    <div className={`absolute z-20 -bottom-9 ${mio ? "right-0" : "left-0"} flex gap-0.5 rounded-full px-1.5 py-1 shadow-lg modal-caja max-w-[86vw] overflow-x-auto`}
                      style={{ background: "#1c1c1c", border: "1px solid #404040" }}>
                      {REACCIONES.map((emoji) => (
                        <button key={emoji}
                          onClick={() => { setEligiendo(null); onReaccionar?.(m, emoji); }}
                          className="text-[15px] px-1 hover:scale-125 transition-transform">
                          {emoji}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ))}

      <div className="flex items-center gap-2 mt-2.5 pt-2.5"
        style={{ borderTop: "1px solid #ffffff0d" }}>
        <input value={texto} onChange={(e) => setTexto(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && mandar()}
          placeholder={esCoach ? `Escribile a ${alumnoNombre || "tu alumno"}…` : "Contale a tu coach…"}
          className="flex-1 min-w-0 bg-neutral-900 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-lg px-2.5 py-2 text-sm" />
        {onFoto && (
          <label className="p-1.5 text-neutral-500 hover:text-sky-400 transition-colors shrink-0 cursor-pointer"
            title="Adjuntar una foto">
            <input type="file" accept="image/*" className="hidden"
              onChange={(e) => {
                const f = e.target.files?.[0];
                e.target.value = "";
                if (!f) return;
                const lector = new FileReader();
                lector.onload = () => onFoto(lector.result);
                lector.readAsDataURL(f);
              }} />
            <Camera size={15} />
          </label>
        )}
        <button onClick={mandar} disabled={!texto.trim() || mandando}
          className="p-1.5 transition-colors shrink-0"
          style={{ color: texto.trim() ? "#38bdf8" : "#525252" }}>
          <Send size={15} />
        </button>
      </div>
    </div>
  );
};

// La ventana de una novedad: se lee sin salir de donde estaba, y
// desde ahí se entra al ejercicio si hace falta.
//
// Al coach lo llevamos directo: está revisando y quiere resolver. Al
// alumno casi siempre le alcanza con leer lo que le contestaron, y
// mandarlo a la sesión le abre el entrenamiento para nada.
const VentanaNovedad = ({ novedad, onCerrar, onIr }) => {
  if (!novedad) return null;
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
      onClick={onCerrar}>
      <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 space-y-3"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-2">
          <div className="flex-1 min-w-0">
            <p className="font-display font-semibold text-sm truncate">
              {novedad.ejercicio || "Novedad"}
            </p>
            {novedad.contexto && (
              <p className="text-[10px] text-neutral-500 mt-0.5 truncate">{novedad.contexto}</p>
            )}
          </div>
          <button onClick={onCerrar} className="p-1 text-neutral-500 hover:text-white shrink-0">
            <X size={16} />
          </button>
        </div>

        {novedad.mensaje && (
          <div className="flex gap-2">
            <span className="w-[22px] h-[22px] rounded-full shrink-0 flex items-center justify-center text-[9px]"
              style={{ background: "#38bdf826", color: "#38bdf8" }}>
              {(novedad.deQuien || "C").charAt(0).toUpperCase()}
            </span>
            <div className="rounded-[9px] px-2.5 py-2"
              style={{ background: "#38bdf814", border: "1px solid #38bdf833" }}>
              <p className="text-[11.5px] leading-relaxed" style={{ color: "#d4d4d4" }}>
                {novedad.mensaje}
              </p>
            </div>
          </div>
        )}

        {novedad.dato && (
          <div className="rounded-lg px-2.5 py-2 flex items-center gap-2"
            style={{ background: "#303030" }}>
            <span className="text-[10.5px] text-neutral-400 flex-1">{novedad.dato.etiqueta}</span>
            <span className="text-[13px] font-semibold">{novedad.dato.valor}</span>
          </div>
        )}

        <div className="flex gap-2 pt-1">
          <button onClick={onCerrar}
            className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
            Cerrar
          </button>
          {onIr && (
            <button onClick={onIr}
              className="flex-[1.4] py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors flex items-center justify-center gap-1.5">
              Ir al ejercicio <ArrowRight size={13} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const CronoPlegable = ({ segundos, children }) => {
  const [global, setGlobal] = useState(() => {
    try { return localStorage.getItem("be_crono_plegado") === "1"; }
    catch { return false; }
  });
  const [propio, setPropio] = useState(null);   // null = sigue al global
  const plegado = propio === null ? global : propio;

  const alternar = () => {
    const nuevo = !plegado;
    setPropio(nuevo);
    // Plegar marca la preferencia; abrir uno suelto no la cambia.
    if (nuevo) {
      setGlobal(true);
      try { localStorage.setItem("be_crono_plegado", "1"); } catch { /* ignorar */ }
    }
  };

  const mm = Math.floor(segundos / 60);
  const ss = String(segundos % 60).padStart(2, "0");

  if (!plegado) {
    return (
      <div className="relative">
        {children}
        <button onClick={alternar} title="Plegar el cronómetro"
          className="absolute -top-1.5 -right-1.5 w-6 h-6 rounded-full flex items-center justify-center text-neutral-500 hover:text-white transition-colors"
          style={{ background: "#262626", border: "1px solid #404040" }}>
          <Minus size={12} />
        </button>
      </div>
    );
  }

  return (
    <button onClick={alternar}
      className="w-full flex items-center gap-2 rounded-lg px-2.5 py-1.5 transition-colors hover:bg-neutral-700/40"
      style={{ background: "#26262680", border: "1px solid #ffffff0a" }}>
      <Hourglass size={12} className="text-neutral-600 shrink-0" />
      <span className="text-[10px] uppercase tracking-wider text-neutral-500 flex-1 text-left">
        Descanso
      </span>
      <span className="text-[11px] text-neutral-400">
        {mm > 0 ? `${mm}:${ss}` : `${segundos}s`}
      </span>
      <ChevronDown size={12} className="text-neutral-600 shrink-0" />
    </button>
  );
};

const InfoBoton = ({ tema, label }) => {
  const [pos, setPos] = useState(null);   // null = cerrado
  const ref = React.useRef(null);
  const info = tema ? AYUDAS[tema] : ayudaDe(label);

  // Se cierra al tocar afuera o al desplazar: está fija en la
  // pantalla y no seguiría al campo.
  useEffect(() => {
    if (!pos) return;
    const cerrar = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setPos(null);
    };
    const alMover = () => setPos(null);
    document.addEventListener("pointerdown", cerrar);
    window.addEventListener("scroll", alMover, true);
    return () => {
      document.removeEventListener("pointerdown", cerrar);
      window.removeEventListener("scroll", alMover, true);
    };
  }, [pos]);

  if (!info || !ayudaVisible) return null;
  const abierta = !!pos;

  return (
    <span ref={ref} className="inline-flex shrink-0">
      <button type="button"
        onClick={(e) => {
          e.stopPropagation(); e.preventDefault();
          if (abierta) { setPos(null); return; }
          // Fija en la pantalla y no dentro de la tarjeta: si no, la
          // recortaría cualquier contenedor con los bordes cerrados.
          const r = e.currentTarget.getBoundingClientRect();
          const ancho = Math.min(240, window.innerWidth - 16);
          const left = Math.max(8, Math.min(r.left - 12, window.innerWidth - ancho - 8));
          setPos({ top: r.bottom + 8, left, ancho, flecha: r.left + r.width / 2 - left });
        }}
        aria-label={`Qué es ${info.t}`}
        className="w-[15px] h-[15px] rounded-full flex items-center justify-center transition-colors"
        style={abierta ? { background: info.c } : { border: "1px solid #525252" }}>
        <span className="text-[9px] font-bold leading-none"
          style={{ color: abierta ? "#000" : "#8a8a8a",
                   fontFamily: "Georgia, serif", fontStyle: "italic" }}>i</span>
      </button>

      {abierta && (
        <span onClick={(e) => e.stopPropagation()}
          className="fixed z-50 rounded-[10px] p-3 text-left normal-case tracking-normal modal-caja"
          style={{ top: pos.top, left: pos.left, width: pos.ancho,
                   background: "#1c1c1c", border: `1px solid ${info.c}55`,
                   boxShadow: "0 10px 30px #000a" }}>
          <span className="absolute w-2.5 h-2.5 rotate-45"
            style={{ top: -6, left: Math.max(10, pos.flecha - 5),
                     background: "#1c1c1c",
                     borderLeft: `1px solid ${info.c}55`, borderTop: `1px solid ${info.c}55` }} />
          <span className="flex items-center gap-1.5 mb-1.5">
            <span className="text-[12px] font-semibold flex-1" style={{ color: "#f5f5f5" }}>
              {info.t}
            </span>
            <button type="button" onClick={(e) => { e.stopPropagation(); setPos(null); }}
              className="text-neutral-500 hover:text-white">
              <X size={13} />
            </button>
          </span>
          <span className="block text-[11.5px] leading-relaxed" style={{ color: "#d4d4d4" }}>
            {info.x}
          </span>
          <span className="block text-[10px] mt-2 pt-2" style={{ color: "#737373",
                 borderTop: "1px solid #ffffff0d" }}>
            Más en la guía, en tu perfil
          </span>
        </span>
      )}
    </span>
  );
};

const EtiquetaCampo = ({ label, color, editable }) => {
  const Ico = ICONO_CAMPO(label);
  // El icono lleva el color del concepto; el texto va gris parejo. Si
  // los dos fueran de color, la tarjeta entera parecería un semáforo.
  return (
    <span className="flex items-center gap-1.5">
      {Ico && <Ico size={12} className="shrink-0"
        style={{ color: COLOR_CAMPO(label) }} />}
      <span className="text-[9px] uppercase tracking-[0.06em] font-semibold truncate flex-1 min-w-0"
        style={{ color: color || "#8a8a8a" }}>{label}</span>
      <InfoBoton label={label} />
    </span>
  );
};

const LockedField = ({ label, value, dotColor, tono, esfuerzo, etiqueta, previa, previaDelAlumno }) => {
  const color = esfuerzo || tono || "#a3a3a3";
  return (
    <CajaCampo>
      <EtiquetaCampo label={label} color={GRIS_ETIQUETA} />
      {/* El valor va suelto debajo de la etiqueta, no dentro de una
          píldora de color: la caja ya lo separa del de al lado, y dos
          fondos superpuestos hacen que el número se lea peor. */}
      <div className="flex items-center gap-1.5 mt-1">
        {dotColor && value && (
          <span className="w-1.5 h-1.5 rounded-full shrink-0"
            style={{ backgroundColor: dotColor }} />
        )}
        <span className="text-base font-semibold truncate"
          style={{ color: value ? (esfuerzo || "#f5f5f5") : "#737373" }}>
          {value ? (etiqueta ? etiqueta(value) : value) : "—"}
        </span>
      </div>
      {/* La referencia de la semana pasada, dentro de la misma caja:
          es del mismo dato, y afuera se leía como un campo aparte. */}
      {/* Separada por una línea, no flotando suelta debajo del número:
          es el mismo dato en otro momento, no otro campo. */}
      {/* Lo que VOS prescribiste va en gris; lo que el alumno CARGÓ,
          en verde. Sin esa diferencia, "previa · 42,5" en el sugerido
          y en el usado se leen igual y son cosas distintas. */}
      {previa && (
        <p className="text-[9px] mt-1.5 pt-1.5 truncate"
          style={{ color: previaDelAlumno ? ESTADO.bien : "#5f5f5f",
                   borderTop: "1px solid #ffffff0d" }}>
          previa · {previa}
        </p>
      )}
    </CajaCampo>
  );
};

// Buscador de ejercicios. Reemplaza al desplegable cuando la lista
// es larga: con noventa ejercicios, encontrar uno bajando por una
// lista nativa es imposible, sobre todo desde el celular.
//
// Busca sin acentos y sin distinguir mayúsculas, y por partes: "press
// banc" encuentra "PECHO PRESS BANCO PLANO 1". Así no hace falta
// acordarse de cómo empieza el nombre.
const sinAcentos = (t = "") =>
  t.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

const coincide = (texto, busqueda) => {
  const t = sinAcentos(texto);
  return sinAcentos(busqueda).split(/\s+/).filter(Boolean).every((p) => t.includes(p));
};

const BuscadorEjercicio = ({ value, grupos = [], onChange, onEscribir, label = "Ejercicio" }) => {
  const [abierto, setAbierto] = useState(false);
  const [busqueda, setBusqueda] = useState("");

  const resultados = React.useMemo(() => {
    if (!busqueda.trim()) return grupos;
    return grupos
      .map((g) => ({ ...g, items: g.items.filter((i) => coincide(i, busqueda)) }))
      .filter((g) => g.items.length);
  }, [grupos, busqueda]);

  const cuantos = resultados.reduce((n, g) => n + g.items.length, 0);
  const total = grupos.reduce((n, g) => n + g.items.length, 0);

  if (!abierto) {
    return (
      <div className="flex flex-col gap-1">
        <span className="text-[10px] uppercase tracking-wider" style={{ color: GRIS_ETIQUETA }}>
          {label}
        </span>
        <button onClick={() => { setAbierto(true); setBusqueda(""); }}
          className="w-full flex items-center gap-2 bg-neutral-700 border border-neutral-600 hover:border-sky-400/40 rounded-md px-2 py-2 text-left transition-colors">
          <Search size={13} className="text-neutral-500 shrink-0" />
          {/* El nombre de lo que está elegido, y "cambiar" al lado.
              Lo había sacado para no repetirlo con la cabecera, pero
              acá no se ve la cabecera al mismo tiempo: quedaba un
              campo que no decía qué ejercicio era. */}
          <span className="flex-1 min-w-0">
            <span className={`block text-base font-medium leading-snug ${
              value ? "text-white" : "text-neutral-600"}`}>
              {value || "Buscar entre " + total + " ejercicios..."}
            </span>
            {value && (
              <span className="block text-[10px] text-neutral-500">tocá para cambiarlo</span>
            )}
          </span>
          <ChevronDown size={13} className="text-neutral-500 shrink-0" />
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <span className="text-[10px] uppercase tracking-wider" style={{ color: GRIS_ETIQUETA }}>
        {label}
      </span>
      <div className="bg-neutral-800 border border-sky-400/40 rounded-lg overflow-hidden">
        <div className="flex items-center gap-2 px-2 py-2 border-b border-neutral-700">
          <Search size={14} className="text-sky-400 shrink-0" />
          <input autoFocus value={busqueda} onChange={(e) => setBusqueda(e.target.value)}
            placeholder="Escribí parte del nombre..."
            className="flex-1 min-w-0 bg-transparent focus:outline-none text-base text-white placeholder-neutral-600" />
          <button onClick={() => setAbierto(false)}
            className="p-1 text-neutral-500 hover:text-white transition-colors shrink-0">
            <X size={14} />
          </button>
        </div>

        <div className="max-h-64 overflow-y-auto">
          {cuantos === 0 ? (
            <div className="p-4 text-center space-y-2">
              <p className="text-xs text-neutral-500">Ningún ejercicio con ese nombre.</p>
              {onEscribir && busqueda.trim().length > 2 && (
                <button onClick={() => { onChange(busqueda.trim()); setAbierto(false); }}
                  className="text-[11px] text-sky-400 hover:underline">
                  Usar "{busqueda.trim()}" igual
                </button>
              )}
            </div>
          ) : resultados.map((g) => (
            <div key={g.label}>
              <p className="text-[9px] uppercase tracking-wider px-3 py-1.5 bg-neutral-900/60 sticky top-0"
                style={{ color: colorGrupo(g.label) }}>
                {g.label}
              </p>
              {g.items.map((item) => (
                <button key={item} onClick={() => { onChange(item); setAbierto(false); }}
                  className={`w-full text-left px-3 py-2.5 text-sm transition-colors hover:bg-neutral-700 ${
                    item === value ? "bg-sky-400/15 text-sky-400" : "text-neutral-200"}`}>
                  {item}
                </button>
              ))}
            </div>
          ))}
        </div>

        {busqueda.trim() && cuantos > 0 && (
          <p className="text-[10px] text-neutral-600 px-3 py-1.5 border-t border-neutral-700">
            {cuantos} de {total}
          </p>
        )}
      </div>
    </div>
  );
};

const FieldSelect = ({ label, value, options, groups, onChange, accent = "neutral", customActive, onToggleCustom, matchStatus, dotColor, labelColor, colorful, tono, etiqueta, previa, previaDelAlumno, atajo }) => {
  let borderClass = accent === "cyan" ? "border-sky-400/30 focus:border-sky-400" : "border-neutral-600 focus:border-neutral-600";
  let ringClass = "";
  if (matchStatus === "match") { borderClass = "border-emerald-400"; ringClass = "ring-1 ring-emerald-400/40"; }
  else if (matchStatus === "harder") { borderClass = "border-red-400"; ringClass = "ring-1 ring-red-400/40"; }
  else if (matchStatus === "easier") { borderClass = "border-yellow-400"; ringClass = "ring-1 ring-yellow-400/40"; }
  const labelClass = accent === "cyan" ? "text-sky-400/70" : "text-neutral-500";
  // El tono viene del ejercicio: antes se derivaba del texto del
  // valor, así que "Mancuerna" y "Barra" tenían colores al azar sin
  // que eso significara nada.
  const tint = value ? (tono || (colorful ? colorForValue(value) : null)) : null;
  const flatOptions = groups ? groups.flatMap((g) => g.items) : options;

  return (
    <CajaCampo destacada={accent === "cyan"} className="flex flex-col gap-1">
      {/* Con icono, salvo que el campo no tenga etiqueta —hay algunos
          que la ponen aparte, como las reps de la activación. */}
      {/* La misma etiqueta que en los campos de lectura: icono con el
          color del concepto, texto gris. Antes acá el icono tomaba el
          color de la etiqueta, así que al coach le salían todos grises
          o todos celestes. */}
      {label ? (
        <EtiquetaCampo label={label} color={labelColor} />
      ) : null}
      {customActive ? (
        <div className="flex items-center gap-1">
          <input autoFocus value={value} onChange={(e) => onChange(e.target.value)} placeholder="Escribir..."
            className={`w-full bg-neutral-700 border ${borderClass} focus:outline-none rounded-md px-2 py-2 text-base text-white placeholder-neutral-600 transition-colors`} />
          <button onClick={onToggleCustom} title="Volver a la lista" className="p-1.5 rounded-md bg-neutral-700 border border-neutral-600 text-neutral-500 hover:text-sky-400 shrink-0"><ListRestart size={13} /></button>
        </div>
      ) : (
        <div className="flex items-center gap-1.5">
          {dotColor && <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: dotColor }} />}
          <div className="relative flex-1">
            <select value={value}
              onChange={(e) => (e.target.value === CUSTOM
                ? onToggleCustom && onToggleCustom()
                : onChange(e.target.value))}
              className={`w-full appearance-none border ${tint ? "" : "bg-neutral-700"} ${borderClass} ${ringClass} focus:outline-none rounded-md pl-2 pr-6 py-2 text-base font-medium transition-colors`}
              style={tint ? { backgroundColor: `${tint}20`, color: tint } : { color: "white" }}>
              {value && !flatOptions.includes(value) && <option value={value}>{value}</option>}
              {!value && <option value="">—</option>}
              {/* Arriba de todo: si el valor que hace falta no está en
                  la lista, hay que bajar hasta el final para poder
                  escribirlo. Con ocho o más opciones eso es scroll. */}
              {onToggleCustom && <option value={CUSTOM}>✎ Escribir otro…</option>}
              {groups
                ? groups.map((g) => (
                    <optgroup key={g.label} label={g.label} className="bg-neutral-800 text-neutral-400">
                      {g.items.map((o) => <option key={o} value={o}>{o}</option>)}
                    </optgroup>
                  ))
                : options.map((o) => (
                    // La etiqueta puede diferir del valor: en libras se
                    // muestra "40 - 88 lb" pero se guarda "40".
                    <option key={o} value={o}>{etiqueta ? etiqueta(o) : o}</option>
                  ))}
            </select>
            <ChevronDown size={13} className="absolute right-2 top-3 text-neutral-500 pointer-events-none" />
          </div>
        </div>
      )}
      {previa && (
        <p className="text-[9px] mt-1.5 pt-1.5 truncate"
          style={{ color: previaDelAlumno ? ESTADO.bien : "#5f5f5f",
                   borderTop: "1px solid #ffffff0d" }}>
          previa · {previa}
        </p>
      )}
      {/* Un toque para copiar lo que ya está en pantalla. Escribir a
          mano un número que el alumno está mirando es trabajo que la
          app puede ahorrarle. No se guarda solo: puede ajustarlo. */}
      {atajo && (
        <button onClick={atajo.onTocar}
          className="w-full mt-1.5 text-[10px] font-medium rounded-md px-2 py-1 transition-transform active:scale-95 truncate"
          style={{ color: "#38bdf8", background: "#38bdf814",
                   border: "1px solid #38bdf833" }}>
          {atajo.texto}
        </button>
      )}
    </CajaCampo>
  );
};

const RefNote = ({ label, value }) => {
  if (!value) return null;
  return <p className="text-[11px] text-neutral-500 mt-1"><span className="text-neutral-600">{label}: </span><span className="text-neutral-400 font-medium">{value}</span></p>;
};


// Foto adjunta a un comentario. Vive en un depósito privado, así que
// hay que pedir una dirección temporal para poder verla.
const FotoAdjunta = ({ ruta, onQuitar, onMarcar }) => {
  const [url, setUrl] = useState(null);
  const [grande, setGrande] = useState(false);

  useEffect(() => {
    if (!ruta) { setUrl(null); return; }
    let vivo = true;
    verFoto(ruta).then((u) => vivo && setUrl(u)).catch(() => vivo && setUrl("error"));
    return () => { vivo = false; };
  }, [ruta]);

  if (!ruta) return null;
  if (!url) return <p className="text-[10px] text-neutral-600">Abriendo la imagen...</p>;
  if (url === "error") return <p className="text-[10px] text-neutral-600">No se pudo abrir la imagen</p>;

  return (
    <>
      <div className="relative inline-block">
        <img src={url} alt="Adjunto" onClick={() => setGrande(true)}
          className="rounded-lg border border-neutral-600 cursor-zoom-in"
          style={{ maxHeight: 140, maxWidth: "100%" }} />
        <div className="absolute top-1 right-1 flex gap-1">
          {onMarcar && (
            <button onClick={(e) => { e.stopPropagation(); onMarcar(url); }}
              title="Marcar sobre esta imagen"
              className="w-6 h-6 rounded-full bg-black/70 text-white flex items-center justify-center">
              <Pencil size={11} />
            </button>
          )}
          {onQuitar && (
            <button onClick={(e) => { e.stopPropagation(); onQuitar(); }}
              title="Quitar"
              className="w-6 h-6 rounded-full bg-black/70 text-white flex items-center justify-center">
              <X size={11} />
            </button>
          )}
        </div>
      </div>

      {grande && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setGrande(false)}>
          <img src={url} alt="Adjunto" className="max-w-full max-h-full object-contain rounded-lg" />
        </div>
      )}
    </>
  );
};

// Elegir una foto del carrete. Pasa por el editor antes de guardarse,
// porque el caso normal es marcarla.
const AdjuntarFoto = ({ onElegir, etiqueta = "Adjuntar una foto" }) => {
  const leer = (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    const lector = new FileReader();
    lector.onload = () => onElegir(lector.result);
    lector.readAsDataURL(f);
  };

  // Dos entradas: una abre la cámara y la otra la galería. Un solo
  // campo con `capture` no deja elegir de la galería, y sin `capture`
  // en algunos teléfonos no ofrece la cámara.
  return (
    <div className="flex items-center gap-3">
      <label className="flex items-center gap-1.5 text-[11px] font-medium text-neutral-500 hover:text-sky-400 cursor-pointer transition-colors">
        <input type="file" accept="image/*" className="hidden" onChange={leer} />
        <ImageIcon size={12} /> {etiqueta}
      </label>
      <label className="flex items-center gap-1.5 text-[11px] font-medium text-neutral-500 hover:text-sky-400 cursor-pointer transition-colors">
        <input type="file" accept="image/*" capture="environment" className="hidden" onChange={leer} />
        <Camera size={12} /> Sacar una
      </label>
    </div>
  );
};

// Conversación sobre un ejercicio: la consulta del alumno y la
// respuesta del coach quedan una debajo de la otra. La pregunta no
// se borra al responder, así el alumno ve a qué se le contestó.
const Conversacion = ({ comentarioAlumno, comentarioFoto, notaCoach, notaCoachFoto,
  onNota, onFotoCoach, onMarcar, esCoach, nombreCoach = "Tu coach" }) => {
  const [editando, setEditando] = useState(false);
  const [borrador, setBorrador] = useState(notaCoach || "");
  const hayAlgo = !!(comentarioAlumno || notaCoach || comentarioFoto || notaCoachFoto);

  useEffect(() => { if (!editando) setBorrador(notaCoach || ""); }, [notaCoach, editando]);

  if (!esCoach && !notaCoach && !notaCoachFoto) return null;
  if (esCoach && !hayAlgo && !editando) {
    return (
      <button onClick={() => setEditando(true)}
        className="w-full flex items-center justify-center gap-1.5 text-[11px] font-medium text-neutral-500 border border-dashed border-neutral-600 hover:border-sky-400/40 hover:text-sky-400 rounded-lg py-2 transition-colors">
        <MessageSquare size={12} /> Dejar una observación para el alumno
      </button>
    );
  }

  return (
    <div className="space-y-1.5">
      {(comentarioAlumno || comentarioFoto) && (
        <div className="bg-neutral-700/40 border border-neutral-600 rounded-lg p-2.5">
          <p className="text-[9px] uppercase tracking-wider text-neutral-500 mb-1">
            {esCoach ? "Consulta del alumno" : "Lo que escribiste"}
          </p>
          {comentarioAlumno && (
            <p className="text-xs text-neutral-200 whitespace-pre-wrap">{comentarioAlumno}</p>
          )}
          {comentarioFoto && (
            <div className="mt-2">
              <FotoAdjunta ruta={comentarioFoto}
                onMarcar={esCoach && onMarcar ? onMarcar : null} />
            </div>
          )}
        </div>
      )}

      {editando ? (
        <div className="bg-sky-400/5 border border-sky-400/25 rounded-lg p-2.5 space-y-2">
          <p className="text-[9px] uppercase tracking-wider text-sky-400">Tu respuesta</p>
          <textarea value={borrador} onChange={(e) => setBorrador(e.target.value)}
            rows={3} autoFocus
            placeholder="Bajá el peso y enfocate en la bajada controlada…"
            className="w-full bg-neutral-800 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-2.5 py-2 text-sm resize-y" />

          {notaCoachFoto
            ? <FotoAdjunta ruta={notaCoachFoto} onMarcar={onMarcar}
                onQuitar={onFotoCoach ? () => onFotoCoach("") : null} />
            : onFotoCoach && <AdjuntarFoto onElegir={onFotoCoach}
                etiqueta="Adjuntar una imagen" />}

          <div className="flex gap-2">
            <button onClick={() => { setBorrador(notaCoach || ""); setEditando(false); }}
              className="flex-1 py-1.5 rounded-lg text-[11px] font-medium text-neutral-400 border border-neutral-600">
              Cancelar
            </button>
            <button onClick={() => { onNota(borrador.trim()); setEditando(false); }}
              className="flex-1 py-1.5 rounded-lg text-[11px] font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
              Guardar
            </button>
          </div>
        </div>
      ) : (notaCoach || notaCoachFoto) ? (
        <div className="bg-sky-400/10 border border-sky-400/30 rounded-lg p-2.5">
          <div className="flex items-center gap-1.5 mb-1">
            <span className="text-[9px] uppercase tracking-wider text-sky-400 flex-1">
              {esCoach ? "Tu observación" : `${nombreCoach} te dice`}
            </span>
            {esCoach && (
              <>
                <button onClick={() => { setBorrador(notaCoach); setEditando(true); }}
                  title="Editar" className="p-0.5 text-neutral-500 hover:text-sky-400 transition-colors">
                  <Pencil size={12} />
                </button>
                <button onClick={() => onNota("")}
                  title="Eliminar" className="p-0.5 text-neutral-500 hover:text-red-400 transition-colors">
                  <Trash2 size={12} />
                </button>
              </>
            )}
          </div>
          {notaCoach && <p className="text-xs text-neutral-100 whitespace-pre-wrap">{notaCoach}</p>}
          {notaCoachFoto && (
            <div className="mt-2"><FotoAdjunta ruta={notaCoachFoto} /></div>
          )}
        </div>
      ) : esCoach && comentarioAlumno ? (
        <button onClick={() => setEditando(true)}
          className="w-full flex items-center justify-center gap-1.5 text-[11px] font-medium text-sky-400 bg-sky-400/10 border border-sky-400/25 hover:bg-sky-400/20 rounded-lg py-2 transition-colors">
          <MessageSquare size={12} /> Responderle
        </button>
      ) : null}
    </div>
  );
};

const CommentBox = ({ value, onChange, readOnly = false, onGuardar,
  foto, onFoto, onQuitarFoto, onMarcarFoto }) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = value.length > 48;

  if (!expanded && (isLong || value === "")) {
    return (
      <button onClick={() => setExpanded(true)} className="w-full text-left flex items-start gap-1.5 group">
        <MessageSquare size={13} className="text-neutral-600 mt-0.5 shrink-0" />
        <span className="text-xs text-neutral-400 truncate group-hover:text-sky-400">
          {value || <span className="text-neutral-600">{readOnly ? "Sin comentario del alumno." : "Comentario para Mati..."}</span>}
          {isLong && <span className="text-sky-400 font-medium"> ... ver más</span>}
        </span>
      </button>
    );
  }
  if (readOnly) {
    return (
      <button onClick={() => setExpanded(false)} className="w-full text-left flex items-start gap-1.5">
        <MessageSquare size={13} className="text-neutral-600 mt-0.5 shrink-0" />
        <p className="text-xs text-sky-400">{value || "Sin comentario del alumno."}</p>
      </button>
    );
  }
  // Con botón explícito: antes se cerraba al tocar afuera y no había
  // ninguna señal de que se hubiera guardado. Escribirle algo al coach
  // y quedarse con la duda de si llegó es peor que un toque más.
  return (
    <div className="flex items-start gap-1.5">
      <MessageSquare size={13} className="text-neutral-600 mt-2 shrink-0" />
      <div className="flex-1 min-w-0 space-y-1.5">
        <textarea autoFocus value={value} onChange={(e) => onChange(e.target.value)}
          placeholder="Comentario para Mati..." rows={3}
          className="w-full bg-transparent border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-md px-2 py-1.5 text-xs text-sky-400 placeholder-neutral-600 resize-none transition-colors" />
        <div className="flex gap-2">
          <button onClick={() => setExpanded(false)}
            className="flex-1 py-1.5 rounded-md text-[11px] font-medium text-neutral-400 border border-neutral-600 hover:border-neutral-500 transition-colors">
            Cerrar
          </button>
          <button onClick={() => { setExpanded(false); onGuardar && onGuardar(); }}
            className="flex-1 py-1.5 rounded-md text-[11px] font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
            Guardar comentario
          </button>
        </div>
      </div>
    </div>
  );
};

const CONFETTI_COLORS = ["#38bdf8", "#f472b6", "#34d399", "#fbbf24", "#60a5fa", "#a78bfa", "#fb923c", "#4ade80"];
const ConfettiBurst = () => {
  const pieces = React.useMemo(() => Array.from({ length: 26 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
    delay: Math.random() * 0.25,
    duration: 1.1 + Math.random() * 0.7,
    size: 5 + Math.random() * 4,
    drift: (Math.random() - 0.5) * 60,
  })), []);
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden rounded-2xl">
      <style>{`
        @keyframes confettiFall {
          0% { transform: translate(0, -12px) rotate(0deg); opacity: 1; }
          100% { transform: translate(var(--drift), 260px) rotate(540deg); opacity: 0; }
        }
      `}</style>
      {pieces.map((p) => (
        <span key={p.id} style={{
          position: "absolute", top: 0, left: `${p.left}%`,
          width: p.size, height: p.size * 2.4, backgroundColor: p.color, borderRadius: 1,
          "--drift": `${p.drift}px`,
          animation: `confettiFall ${p.duration}s ease-in ${p.delay}s forwards`,
        }} />
      ))}
    </div>
  );
};

const ChipSelect = ({ options, value, onChange, getLabel = (o) => o, getColor, getKey = (o) => o, readOnly = false }) => (
  <div className="flex flex-wrap gap-1.5">
    {options.map((o) => {
      const key = getKey(o);
      const active = value === key;
      const color = getColor(o);
      if (readOnly && !active) return null;
      return (
        <button key={key} onClick={() => !readOnly && onChange(key)} disabled={readOnly}
          className={`text-[11px] font-medium rounded-full px-2.5 py-1 border transition-all ${active ? "text-black" : "text-sky-400"} ${readOnly ? "cursor-default" : ""}`}
          style={{ backgroundColor: active ? color : "transparent", borderColor: color }}>
          {getLabel(o)}
        </button>
      );
    })}
  </div>
);

const DEFAULT_TIMER_CONFIG = { work: 20, rest: 10, rounds: 8 };
const DEFAULT_REST_CONFIG = { work: 0, rest: 90, rounds: 1 };

// ─────────────────────────────────────────────────────────────
// Avisos del cronómetro.
//
// El pitido se genera con el sintetizador del navegador: no hace
// falta ningún archivo de audio, y así funciona sin conexión.
// Se crea una sola vez y se reutiliza, porque los navegadores
// limitan cuántos contextos de audio se pueden abrir.
// ─────────────────────────────────────────────────────────────
let ctxAudio = null;

// El pitido del cronómetro.
//
// Una onda senoidal suave a volumen bajo se pierde en un gimnasio: es
// justo el tipo de sonido que el oído descarta como ruido de fondo.
// Ahora usa onda cuadrada, más volumen, y suma un armónico una octava
// arriba: eso le da el filo que hace que se escuche entre las pesas y
// la música. Sigue siendo corto para no molestar.
// ─────────────────────────────────────────────────────────────
// Destrabar el audio en el celular.
//
// Dos cosas silenciaban el temporizador aunque el código anduviera:
//
// 1. En iPhone, el interruptor de silencio apaga el audio generado
//    por la página. Reproducir un audio "de verdad" —acá, uno mudo—
//    cambia el modo de audio a reproducción, y ahí el interruptor
//    deja de afectarlo. Es la misma razón por la que un video suena
//    con el teléfono en silencio y un pitido de una web no.
//
// 2. El navegador solo deja activar el audio desde un toque. Si el
//    audio se creaba recién cuando el reloj llegaba a cero, ya no
//    había toque y quedaba mudo. Ahora se destraba en el PRIMER toque
//    en cualquier lado de la app.
// ─────────────────────────────────────────────────────────────
const AUDIO_MUDO = "data:audio/wav;base64,UklGRkQDAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YSADAACAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgA==";
let audioMudo = null;

function desbloquearAudio() {
  try {
    if (!ctxAudio) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (AC) ctxAudio = new AC();
    }
    if (ctxAudio?.state === "suspended") ctxAudio.resume();

    // El audio mudo en bucle: mantiene el modo de reproducción activo
    // mientras la app está abierta.
    if (!audioMudo) {
      audioMudo = new Audio(AUDIO_MUDO);
      audioMudo.loop = true;
      audioMudo.volume = 0;
      audioMudo.setAttribute("playsinline", "");
    }
    if (audioMudo.paused) audioMudo.play().catch(() => {});
  } catch { /* sin audio, se sigue igual */ }
}

// En el primer toque en cualquier parte de la app.
if (typeof window !== "undefined") {
  const alPrimerToque = () => {
    desbloquearAudio();
    window.removeEventListener("pointerdown", alPrimerToque);
    window.removeEventListener("touchend", alPrimerToque);
  };
  window.addEventListener("pointerdown", alPrimerToque);
  window.addEventListener("touchend", alPrimerToque);

  // Si la app vuelve de segundo plano, el audio quedó suspendido:
  // se reactiva en el próximo toque.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      window.addEventListener("pointerdown", desbloquearAudio, { once: true });
    }
  });
}

function pitido(frecuencia = 880, ms = 180, volumen = 0.7) {
  try {
    if (!ctxAudio) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;
      ctxAudio = new AC();
    }
    if (ctxAudio.state === "suspended") ctxAudio.resume();

    const ahora = ctxAudio.currentTime;
    const dur = ms / 1000;
    const salida = ctxAudio.createGain();
    salida.gain.setValueAtTime(volumen, ahora);
    // Un ataque instantáneo y una caída rápida: un pitido con
    // principio marcado se percibe antes que uno que sube de a poco.
    salida.gain.setValueAtTime(volumen, ahora + dur * 0.7);
    salida.gain.exponentialRampToValueAtTime(0.001, ahora + dur);
    salida.connect(ctxAudio.destination);

    // Dos voces: la nota y su octava, más floja.
    [[frecuencia, "square", 1], [frecuencia * 2, "square", 0.35]].forEach(([hz, tipo, peso]) => {
      const osc = ctxAudio.createOscillator();
      const g = ctxAudio.createGain();
      osc.type = tipo;
      osc.frequency.value = hz;
      g.gain.value = peso;
      osc.connect(g); g.connect(salida);
      osc.start(ahora);
      osc.stop(ahora + dur);
    });
  } catch { /* si el navegador no deja, se sigue sin sonido */ }
}

// Varios pitidos seguidos, para el final: uno solo se puede perder
// entre el ruido, tres seguidos no.
function tanda(hz, ms, veces = 1, separacion = 130) {
  for (let i = 0; i < veces; i++) setTimeout(() => pitido(hz, ms), i * separacion);
}

const avisar = ({ sonido, vibracion }, tipo) => {
  // Frecuencias distintas para poder distinguir sin mirar la pantalla.
  const perfiles = {
    cuenta:   { hz: 880,  ms: 110, veces: 1, vib: 80 },
    trabajo:  { hz: 1180, ms: 200, veces: 2, vib: [0, 200] },
    descanso: { hz: 640,  ms: 200, veces: 2, vib: [0, 150] },
    // El final va con tres pitidos: es el que no se puede perder.
    fin:      { hz: 990,  ms: 260, veces: 3, vib: [0, 250, 120, 250, 120, 450] },
  };
  const p = perfiles[tipo] || perfiles.cuenta;
  if (sonido) tanda(p.hz, p.ms, p.veces);
  if (vibracion && navigator.vibrate) {
    try { navigator.vibrate(p.vib); } catch { /* ignorar */ }
  }
};

// ─────────────────────────────────────────────────────────────
// El reloj de la vista de lista.
//
// En la lista no hay cronómetro dentro de cada ejercicio: cada fila
// tiene un botón con su tiempo y este reloj aparece abajo, flotando,
// así se ve aunque se deslice la planilla. Uno solo a la vez.
// Cuenta contra el reloj real, como el cronómetro de intervalos: si
// la pantalla se apaga, no se atrasa.
// ─────────────────────────────────────────────────────────────
function RelojLista({ reloj, onCerrar }) {
  const [inicio, setInicio] = useState(() => Date.now());
  const [pausado, setPausado] = useState(null);   // ms corridos al pausar
  const [extra, setExtra] = useState(0);
  const [ahora, setAhora] = useState(Date.now());
  const ultimo = React.useRef(null);
  const avisos = React.useMemo(() => {
    try { return JSON.parse(localStorage.getItem("be_avisos") || "") || { sonido: true, vibracion: true }; }
    catch { return { sonido: true, vibracion: true }; }
  }, []);

  useEffect(() => {
    const t = setInterval(() => setAhora(Date.now()), 200);
    return () => clearInterval(t);
  }, []);

  const trans = (pausado != null ? pausado : ahora - inicio) / 1000;
  const total = reloj.segundos + extra;
  // El EMOM se repite: cada bloque vuelve a empezar hasta que se corta.
  const bloque = reloj.repetir ? Math.floor(trans / reloj.segundos) + 1 : 1;
  const restante = reloj.repetir ? reloj.segundos - (trans % reloj.segundos) : Math.max(0, total - trans);
  const seg = Math.ceil(restante);
  const termino = !reloj.repetir && restante <= 0;
  const avance = reloj.repetir ? (trans % reloj.segundos) / reloj.segundos : Math.min(1, trans / total);

  // Avisos: cuenta regresiva en 3, 2, 1; bloque nuevo en el EMOM; y
  // el final con la tanda larga, igual que el cronómetro de tarjetas.
  useEffect(() => {
    if (pausado != null) return;
    const k = `${bloque}-${seg}-${termino}`;
    if (ultimo.current === k) return;
    const antes = ultimo.current;
    ultimo.current = k;
    if (antes === null) return;
    if (termino) avisar(avisos, "fin");
    else if (reloj.repetir && seg === reloj.segundos) avisar(avisos, "trabajo");
    else if (seg <= 3 && seg > 0) avisar(avisos, "cuenta");
  }, [seg, bloque, termino, pausado]); // eslint-disable-line react-hooks/exhaustive-deps

  // Terminado, se va solo a los pocos segundos.
  useEffect(() => {
    if (!termino) return;
    const t = setTimeout(onCerrar, 4000);
    return () => clearTimeout(t);
  }, [termino]); // eslint-disable-line react-hooks/exhaustive-deps

  const pausar = () => {
    if (pausado != null) { setInicio(Date.now() - pausado); setPausado(null); }
    else setPausado(Date.now() - inicio);
  };
  const reloj2 = `${String(Math.floor(seg / 60)).padStart(2, "0")}:${String(seg % 60).padStart(2, "0")}`;

  return ReactDOM.createPortal(
    <div className="fixed z-40 left-3 right-3 md:left-auto md:right-6 md:w-96 bottom-[calc(env(safe-area-inset-bottom)+76px)] md:bottom-6 rounded-2xl border bg-neutral-800 px-3 py-2.5 flex items-center gap-3 shadow-lg"
      style={{ borderColor: "#fb923c66" }}>
      <button onClick={termino ? onCerrar : pausar}
        className="w-11 h-11 rounded-full flex items-center justify-center shrink-0"
        style={{ background: "#fb923c", color: "#000" }}>
        {termino ? <Check size={18} strokeWidth={3} /> : pausado != null ? <Play size={18} /> : <Pause size={18} />}
      </button>
      <div className="flex-1 min-w-0">
        <p className="text-[9.5px] uppercase tracking-wider truncate" style={{ color: "#fb923c" }}>
          {termino ? "¡Listo!" : `${reloj.tipo}${reloj.repetir ? ` · bloque ${bloque}` : ""} · ${reloj.nombre || ""}`}
        </p>
        <p className="font-display font-bold text-2xl leading-none mt-0.5">{reloj2}</p>
        <div className="h-[3px] rounded-full bg-neutral-700 mt-1.5 overflow-hidden">
          <div className="h-full" style={{ width: `${avance * 100}%`, background: "#fb923c" }} />
        </div>
      </div>
      {!reloj.repetir && !termino && (
        <button onClick={() => setExtra((x) => x + 15)}
          className="text-[11px] border border-neutral-600 rounded-md px-2 py-1 text-neutral-400">+15 s</button>
      )}
      <button onClick={onCerrar} title="Cortar"
        className="border border-neutral-600 rounded-md p-1.5 text-neutral-400"><X size={13} /></button>
    </div>, document.body);
}

// ─────────────────────────────────────────────────────────────
// Cronómetro de intervalos.
//
// Dos decisiones que hacen que sirva en un gimnasio:
//
// 1. El tiempo se calcula contra el reloj real, no contando de a un
//    segundo. Los navegadores frenan los temporizadores cuando la
//    pantalla se apaga o cambiás de app: contando, el cronómetro se
//    atrasaba en silencio y el alumno creía haber hecho 20 segundos
//    cuando había hecho 12.
//
// 2. Se le pide al sistema que no apague la pantalla mientras corre.
//    Si el navegador no lo soporta, igual sigue andando bien por (1).
// ─────────────────────────────────────────────────────────────
const IntervalTimer = ({ config, onConfigChange, editable, compacto, silencioso,
  alterna, emom }) => {
  const cfg = config || DEFAULT_TIMER_CONFIG;
  const soloDescanso = !cfg.work || cfg.work === 0;

  const [corriendo, setCorriendo] = useState(false);
  const [ahora, setAhora] = useState(Date.now());
  const inicio = React.useRef(null);       // instante en que arrancó
  const acumulado = React.useRef(0);       // segundos ya corridos al pausar
  const ultimoAviso = React.useRef(null);
  const wakeLock = React.useRef(null);

  const [avisos, setAvisos] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("be_avisos") || "") || { sonido: true, vibracion: true };
    } catch { return { sonido: true, vibracion: true }; }
  });

  // Con la música marcando los tiempos, dos sonidos desincronizados
  // molestan más de lo que ayudan: el cronómetro se calla y queda
  // como referencia visual.
  const avisosReales = silencioso ? { sonido: false, vibracion: false } : avisos;
  const guardarAvisos = (a) => {
    setAvisos(a);
    try { localStorage.setItem("be_avisos", JSON.stringify(a)); } catch { /* ignorar */ }
  };

  // Duración de un ciclo completo y del entrenamiento entero.
  const ciclo = (cfg.work || 0) + (cfg.rest || 0);
  // El EMOM va al fallo: no hay un total, sigue hasta que el alumno
  // diga que no llegó. Poner un número de rondas sería inventar
  // dónde termina algo que termina cuando el cuerpo dice.
  const total = emom ? Infinity : ciclo * (cfg.rounds || 1);

  // Segundos transcurridos, calculados contra el reloj real.
  const transcurrido = corriendo && inicio.current
    ? acumulado.current + (ahora - inicio.current) / 1000
    : acumulado.current;

  const restanteTotal = Math.max(0, total - transcurrido);
  const termino = restanteTotal <= 0 && total > 0;

  // En qué ronda y en qué fase estamos.
  const enCiclo = ciclo > 0 ? Math.min(transcurrido, total) % ciclo : 0;
  const rondaIdx = ciclo > 0 ? Math.floor(Math.min(transcurrido, total) / ciclo) : 0;
  const round = emom ? rondaIdx + 1 : Math.min((cfg.rounds || 1), rondaIdx + 1);

  // Las repeticiones de este bloque y del siguiente. La escalera sale
  // de lo que planificó el coach: arranca en repsInicio y sube el
  // incremento cada bloque.
  const repsDe = (n) => (emom?.repsInicio || 1) + (emom?.incremento || 0) * (n - 1);
  const repsAhora = emom ? repsDe(round) : null;
  const repsSigue = emom ? repsDe(round + 1) : null;
  // Cuántas hizo hasta ahora: la suma de todos los bloques cerrados.
  const bloquesHechos = emom ? rondaIdx : 0;
  const repsTotales = emom
    ? Array.from({ length: bloquesHechos }, (_, k) => repsDe(k + 1))
        .reduce((a, b) => a + b, 0)
    : 0;

  // Con dos ejercicios alternando, cada ronda cambia de ejercicio:
  // ronda 1 es A, la 2 es B, la 3 es A otra vez. Es el dato que la
  // música no puede darte, así que va en grande.
  const cualToca = alterna?.length
    ? alterna[rondaIdx % alterna.length] : null;
  const cualSigue = alterna?.length
    ? alterna[(rondaIdx + 1) % alterna.length] : null;
  const fase = soloDescanso ? "rest" : (enCiclo < (cfg.work || 0) ? "work" : "rest");
  const restanteFase = termino ? 0
    : fase === "work" ? Math.ceil((cfg.work || 0) - enCiclo)
    : Math.ceil(ciclo - enCiclo);

  // Latido de 100 ms: suficiente para que el número se vea al día
  // sin que el cálculo dependa de que se ejecute puntualmente.
  useEffect(() => {
    if (!corriendo) return;
    const id = setInterval(() => setAhora(Date.now()), 100);
    return () => clearInterval(id);
  }, [corriendo]);

  // Al volver de segundo plano, recalcular de inmediato.
  useEffect(() => {
    const alVolver = () => { if (!document.hidden) setAhora(Date.now()); };
    document.addEventListener("visibilitychange", alVolver);
    return () => document.removeEventListener("visibilitychange", alVolver);
  }, []);

  // Mantener la pantalla encendida mientras corre.
  useEffect(() => {
    let cancelado = false;
    const pedir = async () => {
      try {
        if (corriendo && "wakeLock" in navigator) {
          wakeLock.current = await navigator.wakeLock.request("screen");
        }
      } catch { /* el navegador puede negarlo; no es crítico */ }
    };
    const soltar = () => {
      try { wakeLock.current?.release(); } catch { /* ignorar */ }
      wakeLock.current = null;
    };
    if (corriendo) pedir(); else soltar();
    // Si el sistema lo suelta al minimizar, se vuelve a pedir.
    const alVolver = () => { if (!document.hidden && corriendo && !cancelado) pedir(); };
    document.addEventListener("visibilitychange", alVolver);
    return () => { cancelado = true; document.removeEventListener("visibilitychange", alVolver); soltar(); };
  }, [corriendo]);

  // Avisos. Se disparan por cambio de estado, no por el conteo, así
  // que suenan aunque el navegador haya frenado el temporizador.
  useEffect(() => {
    if (!corriendo) return;
    const clave = termino ? "fin" : `${round}-${fase}-${restanteFase}`;
    if (ultimoAviso.current === clave) return;
    const anterior = ultimoAviso.current;
    ultimoAviso.current = clave;
    if (anterior === null) return;   // no avisar en el primer render

    if (termino) { avisar(avisosReales, "fin"); setCorriendo(false); return; }
    const [rondaAnterior, faseAnterior] = String(anterior).split("-");
    // En EMOM no hay cambio de fase —es todo trabajo—, así que el
    // aviso de bloque nuevo tiene que salir del cambio de ronda.
    if (emom && rondaAnterior && Number(rondaAnterior) !== round) {
      avisar(avisosReales, "trabajo");
    } else if (faseAnterior && faseAnterior !== fase) {
      avisar(avisosReales, fase === "work" ? "trabajo" : "descanso");
    } else if (restanteFase > 0 && restanteFase <= 3) {
      avisar(avisosReales, "cuenta");
    }
  }, [corriendo, round, fase, restanteFase, termino, avisos, emom]);

  const arrancar = () => {
    // Arrancar el reloj es un toque: se aprovecha para destrabar el
    // audio, que después va a sonar cuando ya no haya toque.
    desbloquearAudio();
    if (termino) { acumulado.current = 0; }
    inicio.current = Date.now();
    ultimoAviso.current = null;
    setAhora(Date.now());
    setCorriendo(true);
  };
  const pausar = () => {
    acumulado.current = transcurrido;
    setCorriendo(false);
  };
  const reiniciar = () => {
    acumulado.current = 0;
    inicio.current = null;
    ultimoAviso.current = null;
    setCorriendo(false);
    setAhora(Date.now());
  };

  const totalFase = fase === "work" ? (cfg.work || 0) : (cfg.rest || 0);
  const progreso = totalFase ? restanteFase / totalFase : 0;
  const color = termino ? "#22c55e" : fase === "work" ? "#fb923c" : "#60a5fa";
  const mm = String(Math.floor(restanteFase / 60)).padStart(2, "0");
  const ss = String(Math.floor(restanteFase % 60)).padStart(2, "0");

  const updateCfg = (field, v) =>
    onConfigChange && onConfigChange({ ...cfg, [field]: Math.max(0, parseInt(v) || 0) });

  // Toda la caja arranca y pausa. Con el dedo transpirado entre
  // series, apuntarle a un botón de cuarenta píxeles es trabajo;
  // tocar cualquier parte del recuadro no lo es.
  //
  // Salvo cuando es editable: ahí adentro hay campos que tocar y el
  // toque tiene que ir a ellos.
  const cajaTocable = !editable;

  return (
    <div
      onClick={cajaTocable ? (e) => {
        // Los botones de adentro cortan la propagación, así que un
        // clic acá es siempre en el fondo de la caja.
        if (e.target.closest("button")) return;
        corriendo ? pausar() : arrancar();
      } : undefined}
      className={`border rounded-xl p-3 flex flex-wrap items-center gap-3 overflow-hidden transition-colors ${
        cajaTocable ? "cursor-pointer select-none" : ""}`}
      style={{
        background: cajaTocable && !corriendo ? `${color}12` : "#262626",
        borderColor: cajaTocable && !corriendo ? `${color}55` : "#404040",
      }}>
      {/* EMOM: a la derecha del reloj, cuántas repeticiones tocan y
          los bloques que ya cumplió. Es lo que no se puede llevar en
          la cabeza mientras la escalera sube. */}
      {emom && (
        <div className="flex flex-col gap-2 shrink-0" style={{ minWidth: 96 }}>
          <div className="rounded-lg px-2.5 py-2 text-center"
            style={{ background: "#a78bfa1A", border: "1px solid #a78bfa44" }}>
            <p className="text-[8px] uppercase tracking-wider" style={{ color: "#a78bfa" }}>
              Este bloque
            </p>
            <p className="font-display font-bold text-2xl leading-none">{repsAhora}</p>
            <p className="text-[9px] text-neutral-500 mt-0.5">
              {repsAhora === 1 ? "repetición" : "repeticiones"}
            </p>
          </div>

          <div className="rounded-lg px-2.5 py-2 bg-neutral-700/40">
            <p className="text-[8px] uppercase tracking-wider text-neutral-500 mb-1.5">
              Cumplidos
            </p>
            <div className="flex flex-wrap gap-1">
              {/* Hasta ocho: más íconos no se leen de un vistazo y el
                  número de abajo ya lleva la cuenta exacta. */}
              {Array.from({ length: Math.min(bloquesHechos, 8) }, (_, k) => (
                <Dumbbell key={k} size={13} style={{ color: "#a78bfa" }} />
              ))}
              {bloquesHechos === 0 && (
                <span className="text-[9px] text-neutral-600">ninguno todavía</span>
              )}
              {bloquesHechos > 8 && (
                <span className="text-[10px] font-semibold self-center"
                  style={{ color: "#a78bfa" }}>+{bloquesHechos - 8}</span>
              )}
            </div>
            {bloquesHechos > 0 && (
              <p className="text-[9px] text-neutral-500 mt-1.5">
                {bloquesHechos} {bloquesHechos === 1 ? "bloque" : "bloques"} · {repsTotales} reps
              </p>
            )}
          </div>

          <p className="text-[9px] text-neutral-600 text-center">
            Después: {repsSigue}
          </p>
        </div>
      )}

      {/* Con dos ejercicios alternando, lo que hace falta saber es CUÁL
          toca. El reloj te lo dice la música; el ejercicio, no. Por eso
          va arriba y en grande. */}
      {cualToca && (
        <div className="w-full order-first basis-full text-center pb-1">
          <p className="text-[10px] uppercase tracking-wider"
            style={{ color: fase === "work" ? "#fb923c" : "#60a5fa" }}>
            {fase === "work" ? "Ahora" : "Pausa · después"}
          </p>
          <p className="font-display font-bold text-lg leading-tight truncate">
            {fase === "work" ? cualToca : cualSigue}
          </p>
          {fase === "work" && cualSigue && (
            <p className="text-[10px] text-neutral-600 truncate">
              después: {cualSigue}
            </p>
          )}
        </div>
      )}

      {editable && (
        <div className={`grid ${soloDescanso ? "grid-cols-1" : "grid-cols-3"} gap-2 w-full order-first basis-full`}>
          {(soloDescanso ? [["rest", "Descanso (s)"]]
                         : [["work", "Trabajo (s)"], ["rest", "Descanso (s)"], ["rounds", "Rondas"]]
          ).map(([f, l]) => (
            <div key={f} className="flex flex-col gap-1">
              <span className="text-[9px] uppercase tracking-wider text-neutral-500">{l}</span>
              <input type="number" inputMode="numeric" value={cfg[f]} onChange={(e) => updateCfg(f, e.target.value)}
                className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-2 py-2 text-base text-white text-center transition-colors" />
            </div>
          ))}
        </div>
      )}

      {/* El número grande y una barra fina abajo, en vez del anillo.
          En un aro el progreso hay que interpretarlo; una barra que
          se vacía se entiende de reojo, que es como se mira el reloj
          en el medio de una serie.

          Y el número queda mucho más grande: en el aro competía con
          el espacio del propio anillo. */}
      <div className="flex-1 min-w-[150px]">
        <div className="flex items-center gap-3">
          {/* El círculo es indicador, no botón: toda la caja ya lo es.
              Igual se ve como algo que se toca, que es lo que hace que
              se entienda sin explicación. */}
          <span className="w-12 h-12 rounded-full flex items-center justify-center shrink-0 transition-colors"
            style={{ background: corriendo ? "transparent" : color,
                     border: corriendo ? `2px solid ${color}` : "none" }}>
            {corriendo
              ? <Pause size={19} style={{ color }} />
              : <Play size={19} className="text-black" fill="currentColor" />}
          </span>

          <div className="flex-1 min-w-0">
            <span className="flex items-center gap-1.5 text-[9px] uppercase tracking-wider"
              style={{ color }}>
              <span className="truncate">
              {termino ? "Terminaste"
                : corriendo ? (emom ? `Bloque ${round}`
                    : soloDescanso ? "Descanso"
                    : fase === "work" ? "Trabajo" : "Descanso")
                : soloDescanso ? "Tocá para arrancar el descanso"
                : "Tocá para arrancar"}
              </span>
              {soloDescanso && <InfoBoton tema="descanso" />}
            </span>
            <span className={`block font-display font-bold leading-none tracking-tight ${
              compacto ? "text-3xl" : "text-4xl"}`}>
              {mm}:{ss}
            </span>
          </div>

          {!soloDescanso && !emom && cfg.rounds > 1 && (
            <span className="text-[10px] text-neutral-500 shrink-0">
              {round}/{cfg.rounds}
            </span>
          )}
        </div>

        <div className="w-full h-[3px] bg-neutral-900 rounded-full mt-3 overflow-hidden">
          <div className="h-full rounded-full"
            style={{ width: `${Math.round(progreso * 100)}%`, background: color,
                     transition: "width 0.1s linear" }} />
        </div>
      </div>

      {/* Todo en una fila: reloj, botones y avisos. Apilado, el
          cronómetro ocupaba media pantalla en una tarjeta que ya es
          larga de por sí. */}
      <div className="flex-1 min-w-0 flex flex-wrap items-center gap-2">
        {/* Arrancar es toda la caja; acá queda solo reiniciar, chico
            y al costado: se usa poco y no debe competir con lo otro. */}
        <button onClick={(e) => { e.stopPropagation(); reiniciar(); }}
          title="Volver a empezar"
          className="w-9 h-9 rounded-full text-neutral-500 hover:text-white flex items-center justify-center transition-colors shrink-0">
          <RotateCcw size={15} />
        </button>

        {/* Botones de ícono en vez de casillas con texto: ocupaban
            un tercio de la fila y desbordaban la tarjeta en celulares
            angostos. El estado se ve por el color y el ícono. */}
        <div className="flex gap-1.5 shrink-0">
          {[["sonido", Volume2, VolumeX, "Sonido"],
            ["vibracion", Smartphone, Smartphone, "Vibración"]].map(([k, Si, No, l]) => {
            const activo = !!avisos[k];
            const Ico = activo ? Si : No;
            return (
              <button key={k} onClick={() => guardarAvisos({ ...avisos, [k]: !activo })}
                title={`${l}: ${activo ? "activado" : "apagado"}`}
                aria-label={`${l} ${activo ? "activado" : "apagado"}`}
                aria-pressed={activo}
                className={`w-9 h-9 rounded-full flex items-center justify-center border transition-colors ${
                  activo ? "bg-sky-400/15 border-sky-400/40 text-sky-400"
                         : "border-neutral-600 text-neutral-600"}`}>
                <Ico size={14} />
              </button>
            );
          })}
        </div>
      </div>

      {/* Cortar el EMOM. Va al fallo, así que necesita una forma de
          decir "hasta acá llegué": sin esto el reloj seguiría solo
          para siempre y el conteo quedaría mintiendo. */}
      {emom && corriendo && (
        <button onClick={() => { setCorriendo(false); emom.onFallo?.(round - 1, repsTotales); }}
          className="w-full basis-full rounded-lg py-2.5 text-xs font-semibold transition-colors"
          style={{ background: ESTADO.atencion, color: "#000" }}>
          Llegué al fallo · terminar
        </button>
      )}
    </div>
  );
};

// Convierte el link de un video en algo reproducible dentro de la app.
// El alumno está entrenando: mandarlo a YouTube lo saca de la sesión,
// pierde el lugar y vuelve con la app recargada.
const videoEmbebido = (url) => {
  const u = String(url || "").trim();
  if (!u) return null;

  // YouTube en cualquiera de sus formas.
  const yt = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) {
    const inicio = u.match(/[?&]t=(\d+)/);
    return { tipo: "iframe",
             src: `https://www.youtube-nocookie.com/embed/${yt[1]}?rel=0&playsinline=1${inicio ? `&start=${inicio[1]}` : ""}` };
  }

  // Vimeo.
  const vm = u.match(/vimeo\.com\/(\d+)/);
  if (vm) return { tipo: "iframe", src: `https://player.vimeo.com/video/${vm[1]}` };

  // Drive: el link normal abre una página, hace falta el de vista previa.
  const dr = u.match(/drive\.google\.com\/file\/d\/([\w-]+)/);
  if (dr) return { tipo: "iframe", src: `https://drive.google.com/file/d/${dr[1]}/preview` };

  // Archivo de video directo.
  if (/\.(mp4|webm|mov|m4v)(\?|$)/i.test(u)) return { tipo: "video", src: u };

  // Cualquier otra cosa: no se puede embeber, se abre afuera.
  return { tipo: "externo", src: u };
};

// Reproductor dentro de la app. Arranca cerrado para no cargar el
// video de todos los ejercicios de una: en datos móviles eso son
// varios megas por sesión que casi nadie mira.
const ReproductorVideo = ({ url, etiqueta = "Ver video de técnica", acento = "indigo",
  onCapturar, onDescargar }) => {
  const videoRef = React.useRef(null);
  const [abierto, setAbierto] = useState(false);
  const [pantallaCompleta, setPantallaCompleta] = useState(false);
  const [firmada, setFirmada] = useState(null);
  // El teléfono no puede DECODIFICAR el archivo. Distinto de que la
  // dirección falle: acá el video llegó bien y no se puede mostrar.
  const [noReproduce, setNoReproduce] = useState(false);
  useEffect(() => { setNoReproduce(false); }, [url]);

  // Los videos que suben los alumnos viven en un depósito privado:
  // no tienen dirección pública, hay que pedir una que caduca. Se
  // pide al abrirlo, no antes: si no, cada sesión pediría diez.
  const esPropio = url && !/^https?:\/\//.test(url);

  useEffect(() => {
    if (!abierto || !esPropio || firmada) return;
    verVideo(url).then(setFirmada).catch(() => setFirmada("error"));
  }, [abierto, esPropio, url, firmada]);

  const v = esPropio
    ? (firmada && firmada !== "error" ? { tipo: "video", src: firmada } : null)
    : videoEmbebido(url);

  if (!url) return null;
  if (!esPropio && !v) return null;

  // Si la dirección firmada no se pudo pedir, antes quedaba un marco
  // negro sin explicación y parecía que el video no existía. Ahora lo
  // dice y deja volver a intentar.
  if (esPropio && firmada === "error") {
    return (
      <button onClick={() => setFirmada(null)}
        className="w-full flex items-center justify-center gap-1.5 text-[11px] font-medium border rounded-lg py-2 transition-colors text-amber-400 bg-amber-400/10 border-amber-400/25 hover:bg-amber-400/20">
        <Bell size={12} /> No se pudo abrir el video · tocá para reintentar
      </button>
    );
  }

  const colores = acento === "emerald"
    ? "text-emerald-400 bg-emerald-400/10 border-emerald-400/20 hover:bg-emerald-400/20"
    : "text-sky-400 bg-sky-400/10 border-sky-400/20 hover:bg-sky-400/20";

  // Los links que no se pueden embeber siguen abriéndose afuera.
  // El `v &&` importa: con un video propio sin abrir todavía, `v` es
  // nulo y leer su tipo tumbaba la pantalla entera.
  if (v && v.tipo === "externo") {
    return (
      <a href={v.src} target="_blank" rel="noopener noreferrer"
        className={`w-full flex items-center justify-center gap-1.5 text-[11px] font-medium border rounded-lg py-2 transition-colors ${colores}`}>
        <Play size={12} /> {etiqueta}
      </a>
    );
  }

  if (!abierto) {
    return (
      <button onClick={() => setAbierto(true)}
        className={`w-full flex items-center justify-center gap-1.5 text-[11px] font-medium border rounded-lg py-2 transition-colors ${colores}`}>
        <Play size={12} /> {etiqueta}
      </button>
    );
  }

  const marco = (
    <div className={pantallaCompleta
      ? "fixed inset-0 z-50 bg-black flex flex-col"
      : "rounded-lg overflow-hidden border border-neutral-600 bg-black"}>
      <div className="flex items-center gap-2 px-2 py-1.5 bg-neutral-900">
        <span className="text-[10px] text-neutral-400 flex-1 truncate">{etiqueta}</span>
        {/* Capturar el cuadro donde está pausado y marcarlo. Es lo
            que un coach hace de verdad: pausar en la repetición mala,
            señalar la espalda, mandarlo. */}
        {onCapturar && esPropio && (
          <button onClick={() => {
              const v = videoRef.current;
              if (!v) return;
              const c = document.createElement("canvas");
              c.width = v.videoWidth; c.height = v.videoHeight;
              c.getContext("2d").drawImage(v, 0, 0);
              onCapturar(c.toDataURL("image/jpeg", 0.9));
            }}
            title="Capturar este momento y marcarlo"
            className="p-1 text-neutral-400 hover:text-sky-400 transition-colors">
            <Pencil size={13} />
          </button>
        )}
        {onDescargar && esPropio && v?.src && (
          <button onClick={() => onDescargar(v.src)}
            title="Descargar el video"
            className="p-1 text-neutral-400 hover:text-sky-400 transition-colors">
            <Download size={13} />
          </button>
        )}
        <button onClick={() => setPantallaCompleta((f) => !f)}
          title={pantallaCompleta ? "Achicar" : "Pantalla completa"}
          className="p-1 text-neutral-400 hover:text-white transition-colors">
          {pantallaCompleta ? <Minimize2 size={13} /> : <Maximize2 size={13} />}
        </button>
        <button onClick={() => { setAbierto(false); setPantallaCompleta(false); }}
          title="Cerrar" className="p-1 text-neutral-400 hover:text-white transition-colors">
          <X size={13} />
        </button>
      </div>
      {/* En pantalla completa el video conserva su proporción y se
          centra: antes el contenedor le daba todo el alto disponible
          y el video se estiraba hasta deformarse. */}
      <div className={pantallaCompleta
        ? "flex-1 min-h-0 flex items-center justify-center p-2"
        : "aspect-video"}>
        {!v ? (
          <div className="w-full h-full flex items-center justify-center">
            <p className="text-[11px] text-neutral-500">
              {firmada === "error" ? "No se pudo abrir el video" : "Abriendo…"}
            </p>
          </div>
        ) : v.tipo === "iframe" ? (
          <iframe src={v.src} title={etiqueta}
            className={pantallaCompleta ? "w-full aspect-video max-h-full" : "w-full h-full"}
            allowFullScreen
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" />
        ) : (
          noReproduce ? (
            /* Antes quedaba un recuadro negro y parecía que el video
               no existía. El archivo está: lo que falla es que este
               teléfono no sabe abrir ese formato. */
            <div className="w-full h-full flex flex-col items-center justify-center gap-2 px-4 text-center">
              <Bell size={16} className="text-amber-400" />
              <p className="text-[11px] text-neutral-300 leading-relaxed">
                Este teléfono no puede reproducir el formato de este video.
              </p>
              {onDescargar && (
                <button onClick={() => onDescargar(v.src)}
                  className="flex items-center gap-1.5 text-[11px] font-medium text-amber-400 bg-amber-400/10 border border-amber-400/25 rounded-lg px-3 py-1.5 hover:bg-amber-400/20 transition-colors">
                  <Download size={12} /> Descargarlo para verlo
                </button>
              )}
            </div>
          ) : (
          <video ref={videoRef} src={v.src} controls playsInline crossOrigin="anonymous"
            onError={() => setNoReproduce(true)}
            className={pantallaCompleta
              ? "max-w-full max-h-full w-auto h-auto object-contain"
              : "w-full h-full object-contain"} />
          )
        )}
      </div>
    </div>
  );

  return marco;
};

// Biseries: dos o más ejercicios que se hacen seguidos, sin pausa
// entre medio. El descanso corresponde al final del bloque, no de
// cada ejercicio.
// Lo que hace falta marcar en una tarjeta, y con qué clave se guarda.
//
// Tiene que coincidir EXACTO con lo que dibuja la sesión: si la barra
// cuenta distinto de lo que el alumno puede marcar, nunca llega al
// 100%. Por eso vive acá y la usan los dos.
const unidadesDeTarjeta = (sesionId, items) => {
  const ultimo = items[items.length - 1].ex;
  const esBi = items.length > 1 && !!ultimo.biserie;
  const ex = esBi ? ultimo : items[0].ex;
  const idx = items[0].i;

  const n = seccionDe(ex) === "movilidad" ? 1
    : ex.tecnica === "tabata" ? 1
    : esPiramidal(ex.tecnica) ? (ex.tecnicaConfig?.escalones?.length || 1)
    : (parseNum(ex.series) || 1);

  return {
    // La biserie se marca una vez para todo el grupo, con las series
    // del último ejercicio: es el contador que ve el alumno.
    clave: esBi ? `${sesionId}-bi${ultimo.biserie}` : `${sesionId}-${idx}`,
    total: n,
    nombre: ex.ejercicio,
  };
};

const agruparBiseries = (exercises = []) => {
  const bloques = [];
  let i = 0;
  while (i < exercises.length) {
    const g = exercises[i]?.biserie;
    if (!g) {
      bloques.push({ tipo: "solo", items: [{ ex: exercises[i], i: exercises[i].__i ?? i }] });
      i++; continue;
    }
    // Se juntan los consecutivos del mismo grupo.
    const items = [];
    while (i < exercises.length && exercises[i]?.biserie === g) {
      items.push({ ex: exercises[i], i: exercises[i].__i ?? i });
      i++;
    }
    bloques.push(items.length > 1
      ? { tipo: "biserie", grupo: g, items }
      : { tipo: "solo", items });
  }
  return bloques;
};

// Icono de una carpeta de la librería según su nombre. Las categorías
// que vienen de la base no guardan el icono: es presentación, no dato.
const iconoCategoria = (nombre = "") => {
  const n = nombre.toLowerCase();
  if (n.includes("sin categor")) return FolderOpen;
  if (n.includes("superior") || n.includes("mmss")) return Dumbbell;
  if (n.includes("inferior") || n.includes("mmii")) return Footprints;
  if (n.includes("tabata")) return Zap;
  if (n.includes("intermitente")) return TrendingUp;
  if (n.includes("running") || n.includes("aer")) return Footprints;
  return Folder;
};

// Color por grupo muscular. Sirve para que el coach reconozca de un
// vistazo qué está mirando cuando arma o revisa una sesión larga.
const COLOR_GRUPO = {
  "MMSS": "#60a5fa", "Miembro superior": "#60a5fa", "Accesorios MMSS": "#93c5fd",
  "MMII": "#34d399", "Miembro inferior": "#34d399", "Accesorios MMII": "#6ee7b7",
  "Zona media": "#f59e0b", "Core": "#f59e0b",
  "Activación": "#a78bfa", "Movilidad": "#a78bfa",
  "Tabata": "#f87171", "Intermitente": "#fb923c",
  "Aeróbicos": "#22d3ee", "Running": "#22d3ee",
};
// Colores para elegir al crear una categoría. Se eligieron para que
// se distingan entre sí incluso en un punto de 8 píxeles.
const PALETA_CATEGORIAS = [
  "#60a5fa", "#34d399", "#f59e0b", "#a78bfa", "#f87171",
  "#fb923c", "#22d3ee", "#f472b6", "#84cc16", "#c084fc",
];

// Los colores llegan de la base al cargar los ejercicios. Se guardan
// acá para que colorGrupo los use sin tener que pasarlos por toda la
// app: es un dato de presentación que se lee en veinte lugares.
let coloresPropios = {};
const fijarColoresCategorias = (mapa) => { coloresPropios = { ...mapa }; };
const recordarColorLocal = (label, color) => { coloresPropios[label] = color; };

const colorGrupo = (label) =>
  coloresPropios[label] || COLOR_GRUPO[label] || "#9ca3af";

// La edad se calcula, no se guarda: guardada quedaría vieja sola.
const edadDesde = (fecha) => {
  if (!fecha) return null;
  const n = new Date(fecha);
  if (isNaN(n)) return null;
  const hoy = new Date();
  let edad = hoy.getFullYear() - n.getFullYear();
  const m = hoy.getMonth() - n.getMonth();
  if (m < 0 || (m === 0 && hoy.getDate() < n.getDate())) edad--;
  return edad >= 0 && edad < 120 ? edad : null;
};

// Color por grupo de biserie. Cada grupo tiene el suyo para que se
// distingan de un vistazo cuando hay varios en la misma sesión.
const COLORES_SERIE = ["#fbbf24", "#22d3ee", "#a78bfa", "#f472b6", "#84cc16", "#fb923c"];
const colorSerie = (grupo) => COLORES_SERIE[((grupo || 1) - 1) % COLORES_SERIE.length];

// El nombre depende de cuántos ejercicios tenga el grupo.
const nombreSerie = (n) => n === 2 ? "Biserie" : n === 3 ? "Triserie" : `Serie de ${n}`;

// Selector de serie combinada (biserie, triserie...). Solo el coach.
// El número identifica el grupo; la cantidad de ejercicios que le
// pongas define si es bi o tri.
const SelectorBiserie = ({ valor, onChange, gruposUsados, cuantosEnGrupo }) => {
  const activo = !!valor;
  const opciones = [...new Set([...gruposUsados, Math.max(0, ...gruposUsados) + 1])]
    .sort((a, b) => a - b);
  const n = cuantosEnGrupo || 0;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <label className="flex items-center gap-1.5 cursor-pointer select-none">
        <input type="checkbox" checked={activo}
          onChange={(e) => onChange(e.target.checked ? (opciones[opciones.length - 1] || 1) : null)}
          className="w-3.5 h-3.5 rounded accent-sky-400" />
        <span className="text-[11px] text-neutral-400">Serie combinada</span>
      </label>

      {activo && (
        <div className="flex gap-1">
          {opciones.map((g) => (
            <button key={g} onClick={() => onChange(g)}
              className="text-[10px] font-bold rounded-md w-7 h-7 border transition-colors"
              style={valor === g
                ? { background: colorSerie(g), color: "#000", borderColor: colorSerie(g) }
                : { color: colorSerie(g), borderColor: `${colorSerie(g)}55` }}>
              {g}
            </button>
          ))}
        </div>
      )}

      {activo && (
        <span className="text-[10px]" style={{ color: colorSerie(valor) }}>
          {n >= 2 ? `${nombreSerie(n)} — ${n} ejercicios seguidos`
                  : "Poné el mismo número en el ejercicio de al lado"}
        </span>
      )}
    </div>
  );
};

// Etiqueta del grupo muscular al que pertenece un ejercicio.
const EtiquetaGrupo = ({ nombre, grupos }) => {
  if (!nombre) return null;
  const g = grupos?.find((x) => x.items.includes(nombre));
  if (!g) return null;
  return (
    <span className="text-[9px] font-medium rounded px-1.5 py-0.5 shrink-0"
      style={{ color: colorGrupo(g.label), background: `${colorGrupo(g.label)}1F` }}>
      {g.label}
    </span>
  );
};

// Ficha de un ejercicio de la biblioteca: se ve como le llega al
// alumno, con el gif y el video reproducible ahí mismo.
const FichaEjercicio = ({ nombre, media, categoria, onEditar, onCerrar }) => {
  if (!nombre) return null;
  const vacio = !media?.gifUrl && !media?.videoUrl;

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-end sm:items-center justify-center p-3 modal-fondo"
      onClick={onCerrar}>
      <div className="modal-caja bg-neutral-900 border border-neutral-700 rounded-2xl w-full max-w-sm max-h-[88vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 px-4 py-3 border-b border-neutral-700 shrink-0">
          <Dumbbell size={15} className="text-emerald-400 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="font-display font-semibold text-sm leading-snug">{nombre}</p>
            {categoria && (
              <p className="text-[10px] font-medium" style={{ color: colorGrupo(categoria) }}>{categoria}</p>
            )}
          </div>
          <button onClick={onCerrar} className="p-1 text-neutral-400 hover:text-white shrink-0">
            <X size={16} />
          </button>
        </div>

        <div className="overflow-y-auto p-4 space-y-3">
          {media?.gifUrl && (
            <img src={media.gifUrl} alt={nombre}
              className="w-full max-h-64 rounded-lg object-contain bg-neutral-950 border border-neutral-700"
              onError={(e) => { e.currentTarget.style.display = "none"; }} />
          )}

          {media?.videoUrl && <ReproductorVideo url={media.videoUrl} />}

          {vacio && (
            <div className="border border-dashed border-neutral-700 rounded-lg py-8 text-center">
              <Video size={22} className="text-neutral-700 mx-auto mb-2" />
              <p className="text-xs text-neutral-500">Todavía no tiene gif ni video.</p>
            </div>
          )}

          <button onClick={onEditar}
            className="w-full flex items-center justify-center gap-1.5 text-xs font-medium text-sky-400 bg-sky-400/10 border border-sky-400/25 hover:bg-sky-400/20 rounded-lg py-2.5 transition-colors">
            <Pencil size={12} /> {vacio ? "Cargar video y gif" : "Editar este ejercicio"}
          </button>
        </div>
      </div>
    </div>
  );
};

// Vista previa de una plantilla tal como la va a ver el alumno.
//
// Usa los MISMOS componentes que la sesión real (BloqueMedios,
// LockedField, IntervalTimer), no una versión resumida. Una previa
// que no se parece a lo que llega no sirve para lo único que
// importa: darse cuenta de que falta un gif o que un campo quedó
// vacío antes de mandarla.
const VistaPreviaPlantilla = ({ plantilla, medios, onCerrar }) => {
  if (!plantilla) return null;
  // El finalizador va aparte, igual que lo va a ver el alumno.
  const todos = plantilla.exercises || [];
  const bloques = agruparBiseries(todos.filter((e) => !e.finalizador));
  const delFinal = todos.filter((e) => e.finalizador);

  const Ejercicio = ({ ex }) => {
    const media = { videoUrl: ex.videoUrl || medios[ex.ejercicio]?.videoUrl || "",
                    gifUrl: ex.gifUrl || medios[ex.ejercicio]?.gifUrl || "" };
    const exMetric = ex.metric === "RPE" ? "RPE" : "RIR";
    const porTiempo = ["tiempo", "tabata"].includes(ex.modo);

    return (
      <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-4 space-y-3">
        <BloqueMedios media={media} nombre={ex.ejercicio} modo="previa"
          campoEjercicio={
            <LockedField label="Ejercicio" value={ex.ejercicio} tono={colorTarjeta(ex)} />
          } />

        {porTiempo && parseNum(ex.reps) > 0 && (
          <div className="space-y-1.5">
            <p className="text-[10px] uppercase tracking-wider text-neutral-500 text-center">
              {ex.modo === "tabata" ? "Tabata" : "Trabajo"} · {parseNum(ex.series) || 1} {parseNum(ex.series) === 1 ? "ronda" : "rondas"} de {parseNum(ex.reps)}s
              {parseNum(ex.descanso) > 0 && ` / ${parseNum(ex.descanso)}s`}
            </p>
            <IntervalTimer compacto
              config={{ work: parseNum(ex.reps), rest: parseNum(ex.descanso) || 0,
                        rounds: parseNum(ex.series) || 1 }} />
          </div>
        )}

        {!ex.biserie && !porTiempo && parseNum(ex.descanso) > 0 && (
          <div className="space-y-1.5">
            <p className="text-[10px] uppercase tracking-wider text-neutral-500 text-center">
              Descanso entre series
            </p>
            <IntervalTimer compacto config={{ work: 0, rest: parseNum(ex.descanso), rounds: 1 }} />
          </div>
        )}

        <div className="grid grid-cols-2 gap-2">
          <LockedField label="Con qué" value={ex.conQue} tono={colorTarjeta(ex)} />
          <LockedField label={`${exMetric} consigna`} value={ex.rirConsigna}
            esfuerzo={effortColor(ex.rirConsigna, exMetric)} tono={colorTarjeta(ex)} />
          <LockedField label={ex.modo === "tabata" ? "Rondas" : "Series"} value={ex.series}
            tono={colorTarjeta(ex)} />
          <LockedField
            label={porTiempo ? "Trabajo (seg)" : ex.repsPorLado ? "Reps por lado" : "Reps"}
            value={ex.repsPorLado && ex.reps ? `${ex.reps} × lado` : ex.reps}
            tono={colorTarjeta(ex)} />
        </div>

        {/* Los campos que completa el alumno, vacíos como los recibe. */}
        <div className="grid grid-cols-2 gap-2 pt-1 border-t border-neutral-700">
          <LockedField label="Peso usado (kg)" value="" tono={colorTarjeta(ex)} />
          <LockedField label={`${exMetric} tuyo`} value="" tono={colorTarjeta(ex)} />
        </div>
        {ex.notaCoach && (
          <Conversacion notaCoach={ex.notaCoach} esCoach={false} onNota={() => {}} />
        )}
        <p className="text-[10px] text-neutral-600">
          El alumno completa peso, {exMetric} y su comentario mientras entrena.
        </p>
      </div>
    );
  };

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-end sm:items-center justify-center p-3 modal-fondo"
      onClick={onCerrar}>
      <div className="modal-caja bg-neutral-900 border border-neutral-700 rounded-2xl w-full max-w-md max-h-[88vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 px-4 py-3 border-b border-neutral-700 shrink-0">
          <Eye size={15} className="text-amber-400 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="font-display font-semibold text-sm truncate">{plantilla.name}</p>
            <p className="text-[10px] text-neutral-500">Así la va a ver tu Be Trainer</p>
          </div>
          <button onClick={onCerrar} className="p-1 text-neutral-400 hover:text-white shrink-0">
            <X size={16} />
          </button>
        </div>

        <div className="overflow-y-auto p-3 space-y-3">
          {bloques.length === 0 && (
            <p className="text-xs text-neutral-600 text-center py-8">Esta sesión no tiene ejercicios.</p>
          )}
          {bloques.map((b, i) => b.tipo === "biserie" ? (
            <div key={i} className="rounded-xl border-2 p-2.5 space-y-2.5"
              style={{ borderColor: `${colorSerie(b.grupo)}66`, background: `${colorSerie(b.grupo)}0D` }}>
              <div className="flex items-center gap-2 px-1">
                <span className="text-[10px] font-bold uppercase tracking-wider rounded-full px-2.5 py-1"
                  style={{ color: colorSerie(b.grupo), background: `${colorSerie(b.grupo)}26` }}>
                  {nombreSerie(b.items.length)} {b.grupo}
                </span>
                <span className="text-[10px] text-neutral-400 flex-1">
                  {b.items.length} ejercicios seguidos, sin pausa entre medio
                </span>
              </div>
              {b.items.map(({ ex }, j) => <Ejercicio key={j} ex={ex} />)}
              {parseNum(b.items[b.items.length - 1].ex.descanso) > 0 && (
                <div className="space-y-1.5 pt-1">
                  <p className="text-[10px] uppercase tracking-wider text-center"
                    style={{ color: colorSerie(b.grupo) }}>
                    Descanso al terminar la {nombreSerie(b.items.length).toLowerCase()}
                  </p>
                  <IntervalTimer compacto
                    config={{ work: 0, rest: parseNum(b.items[b.items.length - 1].ex.descanso), rounds: 1 }} />
                </div>
              )}
            </div>
          ) : (
            b.items.map(({ ex }, j) => <Ejercicio key={`${i}-${j}`} ex={ex} />)
          ))}

          {delFinal.length > 0 && (
            <div className="rounded-xl border-2 p-3 space-y-2"
              style={{ borderColor: "#fb923c66", background: "#fb923c0D" }}>
              <div className="flex items-center gap-2 px-1">
                <Flame size={14} style={{ color: "#fb923c" }} className="shrink-0" />
                <span className="text-[11px] font-bold uppercase tracking-wider"
                  style={{ color: "#fb923c" }}>Finalizador</span>
              </div>
              {delFinal.map((ex, k) => <Ejercicio key={`fin-${k}`} ex={ex} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Rueda de segundos: se desliza con el dedo y engancha en cada valor.
// Elegir 20 en un campo numérico del celular obliga a abrir el teclado;
// esto se hace con el pulgar sin mirar.
const RuedaSegundos = ({ valor, onChange, etiqueta, color = "#38bdf8", max = 60 }) => {
  const pista = React.useRef(null);
  const valores = Array.from({ length: max + 1 }, (_, i) => i);

  // Centrar el valor elegido al abrir.
  useEffect(() => {
    const el = pista.current?.querySelector(`[data-v="${valor}"]`);
    if (el) el.scrollIntoView({ block: "nearest", inline: "center" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-baseline gap-1.5">
        <span className="text-[9px] uppercase tracking-wider text-neutral-500 flex-1">{etiqueta}</span>
        <span className="font-display text-lg font-bold leading-none" style={{ color }}>{valor}</span>
        <span className="text-[10px] text-neutral-500">seg</span>
      </div>
      <div ref={pista}
        className="flex gap-1 overflow-x-auto pb-1 snap-x snap-mandatory"
        style={{ scrollbarWidth: "none" }}>
        {valores.map((v) => (
          <button key={v} data-v={v} onClick={() => onChange(v)}
            className={`snap-center shrink-0 rounded-md text-xs font-medium transition-colors ${
              v === valor ? "text-black font-bold" : "text-neutral-400 bg-neutral-800 hover:bg-neutral-700"}`}
            style={{ width: 38, height: 38, ...(v === valor ? { background: color } : {}) }}>
            {v}
          </button>
        ))}
      </div>
    </div>
  );
};

// Referencia de lo que el alumno movió la última vez. Se muestra
// debajo del campo, en chico: informa sin competir con lo que hay
// que completar.
const CargaPrevia = ({ dato, campo }) => {
  if (!dato) return null;
  const valor = campo === "peso" ? dato.peso : dato.rir;
  if (!valor || valor === "-") return null;
  const cuando = dato.fecha
    ? new Date(dato.fecha + "T00:00:00").toLocaleDateString("es-AR",
        { day: "numeric", month: "short" })
    : null;
  return (
    <p className="text-[10px] text-neutral-500 mt-1">
      {campo === "peso" ? "Última vez: " : "Último RIR: "}
      <b className="text-neutral-300">{valor}{campo === "peso" ? " kg" : ""}</b>
      {cuando && <span className="text-neutral-600"> · {cuando}</span>}
    </p>
  );
};

// Cada tipo de novedad con su ícono y color, para reconocerla sin
// leer: el ojo distingue antes el color que el texto.
const ICONO_NOTIF = {
  sesion: Dumbbell, completada: Check, comentario: MessageSquare,
  respuesta: MessageSquare, insignia: Award, solicitud: Award,
  propuesta: Award, ranking: Trophy,
};
const COLOR_NOTIF = {
  sesion: "#38bdf8", completada: "#22c55e", comentario: "#fbbf24",
  respuesta: "#38bdf8", insignia: "#a78bfa", solicitud: "#fbbf24",
  propuesta: "#a78bfa", ranking: "#22d3ee",
};

// "hace 5 min" se lee más rápido que una fecha completa.
const haceCuanto = (iso) => {
  if (!iso) return "";
  const seg = Math.floor((Date.now() - new Date(iso)) / 1000);
  if (seg < 60) return "recién";
  if (seg < 3600) return `hace ${Math.floor(seg / 60)} min`;
  if (seg < 86400) return `hace ${Math.floor(seg / 3600)} h`;
  const dias = Math.floor(seg / 86400);
  if (dias === 1) return "ayer";
  if (dias < 7) return `hace ${dias} días`;
  return new Date(iso).toLocaleDateString("es-AR", { day: "numeric", month: "short" });
};

// ─────────────────────────────────────────────────────────────
// Compresión de video en el navegador.
//
// Un video de 30 segundos del celular pesa entre 40 y 80 MB. Con 20
// alumnos subiendo dos por semana eso son 6 GB por mes: el espacio se
// termina en un año y cada subida tarda una eternidad con datos.
//
// Se reproduce el video en silencio, se dibuja cada cuadro en un
// lienzo a 720 de ancho y se graba esa salida. Queda en unos 5 MB.
// Es lo mismo que hace WhatsApp cuando mandás un video.
// ─────────────────────────────────────────────────────────────
const SEGUNDOS_MAX = 30;
const PESO_SIN_COMPRIMIR = 12 * 1024 * 1024;   // 12 MB

// Comprime reproduciendo el video en silencio y grabando lo que se
// dibuja en un lienzo a 720 de ancho.
//
// Dos cosas que aprendí a la mala:
//
// 1. Es en tiempo real. Un video de 30 segundos tarda 30 segundos.
//    Por eso los chicos no se comprimen: no vale la pena la espera.
//
// 2. Puede colgarse sin avisar. Si el navegador no deja reproducir,
//    el tiempo del video no avanza y el bucle gira para siempre con
//    la barra en cero. Por eso hay un plazo máximo: si no termina,
//    se sube el original. Un video pesado es mejor que uno colgado.
const comprimirVideo = (archivo, alProgreso) => new Promise((resolver) => {
  let listo = false;
  const terminar = (resultado) => { if (!listo) { listo = true; resolver(resultado); } };

  // Los chicos van tal cual: comprimir tardaría más que subirlos.
  if (archivo.size <= PESO_SIN_COMPRIMIR) { terminar(archivo); return; }

  if (typeof MediaRecorder === "undefined" || !HTMLCanvasElement.prototype.captureStream) {
    terminar(archivo); return;
  }

  // Plazo máximo: la duración del video más un margen. Si se pasa,
  // se sube el original.
  let plazo = setTimeout(() => terminar(archivo), 15000);
  const reprogramar = (ms) => { clearTimeout(plazo); plazo = setTimeout(() => terminar(archivo), ms); };

  const video = document.createElement("video");
  video.muted = true;
  video.playsInline = true;
  video.preload = "auto";
  const objeto = URL.createObjectURL(archivo);
  video.src = objeto;

  const limpiar = () => { try { URL.revokeObjectURL(objeto); } catch { /* ignorar */ } };

  video.onerror = () => { limpiar(); clearTimeout(plazo); terminar(archivo); };

  video.onloadedmetadata = () => {
    const dur = Math.min(video.duration || 0, SEGUNDOS_MAX);
    if (!dur || !video.videoWidth) { limpiar(); clearTimeout(plazo); terminar(archivo); return; }

    // La compresión corre en tiempo real, así que el plazo tiene que
    // dar para el video entero.
    reprogramar(dur * 1000 + 8000);

    const escala = Math.min(1, 720 / Math.max(video.videoWidth, video.videoHeight));
    const lienzo = document.createElement("canvas");
    lienzo.width = Math.round(video.videoWidth * escala);
    lienzo.height = Math.round(video.videoHeight * escala);
    const ctx = lienzo.getContext("2d");

    // mp4 PRIMERO, aunque esté disponible en menos navegadores.
    //
    // El iPhone no reproduce webm, así que un video comprimido en
    // Chrome Android le llegaba al coach como un recuadro negro: él
    // creía que la alumna no lo había subido. Chrome ya sabe grabar
    // mp4, y donde no se pueda se cae a webm como antes.
    const tipo = ["video/mp4;codecs=avc1", "video/mp4",
                  "video/webm;codecs=vp9", "video/webm;codecs=vp8", "video/webm"]
      .find((t) => MediaRecorder.isTypeSupported(t));
    if (!tipo) { limpiar(); clearTimeout(plazo); terminar(archivo); return; }

    let grabador;
    try {
      grabador = new MediaRecorder(lienzo.captureStream(24), {
        mimeType: tipo, videoBitsPerSecond: 1400000,
      });
    } catch { limpiar(); clearTimeout(plazo); terminar(archivo); return; }

    const trozos = [];
    grabador.ondataavailable = (e) => e.data.size && trozos.push(e.data);
    grabador.onstop = () => {
      limpiar(); clearTimeout(plazo);
      const salida = new Blob(trozos, { type: tipo.split(";")[0] });
      terminar(salida.size > 0 && salida.size < archivo.size ? salida : archivo);
    };

    const parar = () => { try { grabador.stop(); video.pause(); } catch { /* ignorar */ } };
    video.onended = parar;

    grabador.start(500);

    video.play().then(() => {
      let ultimoTiempo = -1;
      let quieto = 0;

      const dibujar = () => {
        if (listo) return;
        if (video.currentTime >= dur || video.ended) { parar(); return; }

        // Si el tiempo no avanza durante dos segundos, el navegador no
        // está reproduciendo: se corta en vez de girar para siempre.
        if (video.currentTime === ultimoTiempo) {
          quieto += 1;
          if (quieto > 120) { parar(); limpiar(); clearTimeout(plazo); terminar(archivo); return; }
        } else { quieto = 0; ultimoTiempo = video.currentTime; }

        ctx.drawImage(video, 0, 0, lienzo.width, lienzo.height);
        if (alProgreso) alProgreso(Math.min(1, video.currentTime / dur));
        requestAnimationFrame(dibujar);
      };
      requestAnimationFrame(dibujar);
    }).catch(() => { limpiar(); clearTimeout(plazo); terminar(archivo); });
  };
});

// Nombre y mes de una semana. Antes era un campo de texto único con
// el formato "Semana 3 - AGOSTO 2026": había que respetar el guión y
// escribir el mes igual que en las otras, porque el mes es lo que las
// agrupa. Una letra distinta y la semana aparecía sola en su grupo.
const MESES = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
               "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];

const mesSiguiente = (periodo) => {
  const m = /^([A-ZÁÉÍÓÚÑ]+)\s+(\d{4})$/.exec((periodo || "").trim().toUpperCase());
  if (!m) return null;
  const i = MESES.indexOf(m[1]);
  if (i < 0) return null;
  return i === 11 ? `${MESES[0]} ${Number(m[2]) + 1}` : `${MESES[i + 1]} ${m[2]}`;
};

const CamposSemana = ({ nombre, periodo, onNombre, onPeriodo, mesesUsados = [] }) => {
  // Se ofrecen los meses ya usados, más el siguiente al último: son
  // los dos casos reales, seguir cargando el mes en curso o arrancar
  // el que viene.
  const opciones = [...new Set([...mesesUsados,
    mesSiguiente(mesesUsados[mesesUsados.length - 1]) || "",
  ].filter(Boolean))];

  return (
    <div className="space-y-3">
      <div>
        <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">
          Nombre de la semana
        </label>
        <input value={nombre} onChange={(e) => onNombre(e.target.value)}
          placeholder="Semana 3"
          className="w-full bg-neutral-700 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-base" />
      </div>

      <div>
        <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">
          Mes
        </label>
        <input value={periodo} onChange={(e) => onPeriodo(e.target.value.toUpperCase())}
          placeholder="AGOSTO 2026"
          className="w-full bg-neutral-700 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-base" />

        {opciones.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-2">
            {opciones.map((m) => (
              <button key={m} onClick={() => onPeriodo(m)}
                className={`text-[10px] rounded-full px-2.5 py-1 border transition-colors ${
                  periodo === m ? "bg-sky-400 text-black border-sky-400"
                    : "text-neutral-400 border-neutral-600 hover:border-sky-400/40"}`}>
                {m}
              </button>
            ))}
          </div>
        )}
        <p className="text-[10px] text-neutral-600 mt-1.5">
          El mes agrupa las semanas en la lista. Tocá uno de arriba para que quede igual.
        </p>
      </div>
    </div>
  );
};

// Fecha de nacimiento con tres campos separados.
//
// El calendario del navegador abre en el mes actual y obliga a
// retroceder trescientos meses para llegar a 1992. Con día, mes y año
// sueltos se completa en tres toques, y el año es el que más importa:
// va como lista, de los más probables a los menos.
const SelectorNacimiento = ({ valor, onChange }) => {
  // Los tres desplegables tienen su propio estado.
  //
  // Antes cada uno escribía directo en la fecha completa, y como una
  // fecha no existe hasta tener día, mes y año, elegir el día borraba
  // todo y el campo volvía a cero. Era imposible de completar.
  const desdeValor = React.useCallback(() => {
    const p = (valor || "").split("-");
    // Se guarda con ceros adelante (1992-04-05) y las opciones son
    // números sueltos: hay que sacarlos o el navegador no encuentra
    // la opción y muestra el campo vacío.
    return p.length === 3
      ? { d: String(Number(p[2])), m: String(Number(p[1])), a: p[0] }
      : { d: "", m: "", a: "" };
  }, [valor]);

  const [partes, setPartes] = useState(desdeValor);

  useEffect(() => { setPartes(desdeValor()); }, [desdeValor]);

  const cambiar = (campo, v) => {
    const next = { ...partes, [campo]: v };
    setPartes(next);
    const { d, m, a } = next;
    if (!d || !m || !a) { onChange(""); return; }
    // Un día que no existe en ese mes se recorta al último válido.
    const ultimo = new Date(Number(a), Number(m), 0).getDate();
    const dia = Math.min(Number(d), ultimo);
    onChange(`${a}-${String(m).padStart(2, "0")}-${String(dia).padStart(2, "0")}`);
  };

  const hoy = new Date().getFullYear();
  const años = Array.from({ length: 65 }, (_, i) => hoy - 16 - i);
  const dias = Array.from({ length: 31 }, (_, i) => i + 1);
  const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                 "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

  const claseSel = "w-full min-w-0 box-border appearance-none bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-2 py-2 text-base text-white";

  return (
    <div className="grid grid-cols-3 gap-2">
      <select value={partes.d} onChange={(e) => cambiar("d", e.target.value)} className={claseSel}>
        <option value="">Día</option>
        {dias.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <select value={partes.m} onChange={(e) => cambiar("m", e.target.value)} className={claseSel}>
        <option value="">Mes</option>
        {meses.map((x, i) => <option key={x} value={i + 1}>{x}</option>)}
      </select>
      <select value={partes.a} onChange={(e) => cambiar("a", e.target.value)} className={claseSel}>
        <option value="">Año</option>
        {años.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
    </div>
  );
};

// Las fechas reales de la semana en curso.
//
// La grilla mostraba LUN MAR MIÉ sin número: no había forma de saber
// si "miércoles" era hoy, el de la semana pasada o el que viene. Con
// la fecha al lado, la semana deja de ser abstracta.
const semanaDeHoy = () => {
  const hoy = new Date();
  const lunes = new Date(hoy);
  // getDay() devuelve 0 para domingo: se corre para que la semana
  // empiece el lunes, como la lee cualquiera acá.
  lunes.setDate(hoy.getDate() - ((hoy.getDay() + 6) % 7));
  lunes.setHours(0, 0, 0, 0);

  return DIAS_SEMANA.map((nombre, i) => {
    const d = new Date(lunes);
    d.setDate(lunes.getDate() + i);
    return {
      nombre,
      dia: d.getDate(),
      mes: d.getMonth(),
      esHoy: d.toDateString() === hoy.toDateString(),
      // El cambio de mes a mitad de semana hay que marcarlo.
      abreMes: i > 0 && d.getDate() === 1,
    };
  });
};

// Qué semana del mes es. Se cuenta por el LUNES de la semana, no por
// el día: una semana que arranca el 31 de agosto y termina el 6 de
// septiembre es la primera de septiembre para quien la vive, no la
// sexta de agosto.
const semanaDelMes = (fecha = new Date()) => {
  const lunes = new Date(fecha);
  lunes.setDate(fecha.getDate() - ((fecha.getDay() + 6) % 7));
  const primero = new Date(lunes.getFullYear(), lunes.getMonth(), 1);
  const primerLunes = new Date(primero);
  primerLunes.setDate(1 + ((8 - primero.getDay()) % 7));
  if (lunes < primerLunes) return 1;
  return Math.floor((lunes.getDate() - primerLunes.getDate()) / 7) + 1;
};

const MESES_LARGOS = ["enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

// Editor de marcas sobre una imagen.
//
// Se usa para dos cosas: un cuadro sacado del video del alumno, y una
// foto que sube cualquiera de los dos. Es el mismo editor porque el
// gesto es el mismo: señalar algo en una imagen.
//
// Herramientas al mínimo a propósito. Un coach marcando una espalda
// necesita una línea, un círculo y un trazo libre; todo lo demás es
// ruido en una pantalla de celular con el dedo encima.
const COLORES_MARCA = ["#ef4444", "#facc15", "#22c55e", "#22d3ee", "#ffffff"];

const EditorMarcas = ({ imagen, onGuardar, onCancelar, titulo = "Marcá lo que quieras señalar" }) => {
  const lienzoRef = React.useRef(null);
  const baseRef = React.useRef(null);
  const [herramienta, setHerramienta] = useState("lapiz");
  const [color, setColor] = useState(COLORES_MARCA[0]);
  const [trazos, setTrazos] = useState([]);
  const [enCurso, setEnCurso] = useState(null);
  const [listo, setListo] = useState(false);

  // La imagen se carga una vez y se guarda: redibujar en cada trazo
  // desde el archivo haría parpadear todo.
  useEffect(() => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => { baseRef.current = img; setListo(true); };
    img.onerror = () => setListo(false);
    img.src = imagen;
  }, [imagen]);

  const dibujar = React.useCallback(() => {
    const lienzo = lienzoRef.current;
    const img = baseRef.current;
    if (!lienzo || !img) return;

    // 1000 px de ancho máximo: alcanza para ver una técnica y no
    // genera un archivo de varios megas.
    const escala = Math.min(1, 1000 / img.width);
    lienzo.width = Math.round(img.width * escala);
    lienzo.height = Math.round(img.height * escala);

    const ctx = lienzo.getContext("2d");
    ctx.drawImage(img, 0, 0, lienzo.width, lienzo.height);
    ctx.lineCap = "round";
    ctx.lineJoin = "round";

    [...trazos, enCurso].filter(Boolean).forEach((t) => {
      ctx.strokeStyle = t.color;
      // El grosor acompaña al tamaño: 4px sobre una foto de 1000 de
      // ancho casi no se ve en un celular.
      ctx.lineWidth = Math.max(3, lienzo.width / 180);
      ctx.beginPath();

      if (t.tipo === "lapiz") {
        t.puntos.forEach((p, i) => (i === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y)));
      } else if (t.tipo === "linea") {
        ctx.moveTo(t.desde.x, t.desde.y);
        ctx.lineTo(t.hasta.x, t.hasta.y);
      } else if (t.tipo === "circulo") {
        const rx = Math.abs(t.hasta.x - t.desde.x) / 2;
        const ry = Math.abs(t.hasta.y - t.desde.y) / 2;
        ctx.ellipse((t.desde.x + t.hasta.x) / 2, (t.desde.y + t.hasta.y) / 2,
                    rx, ry, 0, 0, Math.PI * 2);
      }
      ctx.stroke();
    });
  }, [trazos, enCurso]);

  useEffect(() => { if (listo) dibujar(); }, [listo, dibujar]);

  // El dedo toca en coordenadas de pantalla; el lienzo tiene las
  // suyas. Sin esta conversión el trazo aparece desplazado.
  const punto = (e) => {
    const lienzo = lienzoRef.current;
    const caja = lienzo.getBoundingClientRect();
    return {
      x: (e.clientX - caja.left) * (lienzo.width / caja.width),
      y: (e.clientY - caja.top) * (lienzo.height / caja.height),
    };
  };

  const empezar = (e) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    const p = punto(e);
    setEnCurso(herramienta === "lapiz"
      ? { tipo: "lapiz", color, puntos: [p] }
      : { tipo: herramienta, color, desde: p, hasta: p });
  };

  const mover = (e) => {
    if (!enCurso) return;
    const p = punto(e);
    setEnCurso((t) => t.tipo === "lapiz"
      ? { ...t, puntos: [...t.puntos, p] }
      : { ...t, hasta: p });
  };

  const soltar = () => {
    if (!enCurso) return;
    setTrazos((prev) => [...prev, enCurso]);
    setEnCurso(null);
  };

  const guardar = () => {
    const lienzo = lienzoRef.current;
    if (!lienzo) return;
    lienzo.toBlob((b) => b && onGuardar(b), "image/jpeg", 0.85);
  };

  const HERRAMIENTAS = [
    ["lapiz", Pencil, "Dibujar"],
    ["linea", Minus, "Línea"],
    ["circulo", Circle, "Círculo"],
  ];

  return (
    <div className="fixed inset-0 bg-black z-50 flex flex-col">
      <div className="flex items-center gap-2 px-3 py-2.5 border-b border-neutral-800 shrink-0">
        <p className="text-xs text-neutral-400 flex-1 truncate">{titulo}</p>
        <button onClick={onCancelar}
          className="p-1.5 text-neutral-500 hover:text-white transition-colors">
          <X size={16} />
        </button>
      </div>

      <div className="flex-1 min-h-0 flex items-center justify-center p-2">
        {listo ? (
          <canvas ref={lienzoRef}
            onPointerDown={empezar} onPointerMove={mover}
            onPointerUp={soltar} onPointerCancel={soltar}
            style={{ touchAction: "none", maxWidth: "100%", maxHeight: "100%" }}
            className="rounded-lg" />
        ) : (
          <p className="text-xs text-neutral-500">Abriendo la imagen...</p>
        )}
      </div>

      <div className="border-t border-neutral-800 px-3 py-3 shrink-0 space-y-2.5">
        <div className="flex items-center gap-2">
          {HERRAMIENTAS.map(([id, Ico, nombre]) => (
            <button key={id} onClick={() => setHerramienta(id)}
              title={nombre} aria-label={nombre} aria-pressed={herramienta === id}
              className={`w-10 h-10 rounded-lg flex items-center justify-center border transition-colors ${
                herramienta === id ? "bg-sky-400 text-black border-sky-400"
                  : "border-neutral-700 text-neutral-400"}`}>
              <Ico size={16} />
            </button>
          ))}

          <div className="flex gap-1.5 flex-1 justify-center">
            {COLORES_MARCA.map((c) => (
              <button key={c} onClick={() => setColor(c)}
                aria-label={`Color ${c}`}
                className="w-7 h-7 rounded-full transition-transform"
                style={{ background: c,
                         outline: color === c ? "2px solid #fafafa" : "none",
                         outlineOffset: 2 }} />
            ))}
          </div>

          <button onClick={() => setTrazos((p) => p.slice(0, -1))}
            disabled={!trazos.length}
            title="Deshacer" aria-label="Deshacer"
            className="w-10 h-10 rounded-lg flex items-center justify-center border border-neutral-700 text-neutral-400 disabled:opacity-30 transition-colors">
            <RotateCcw size={15} />
          </button>
        </div>

        <div className="flex gap-2">
          <button onClick={onCancelar}
            className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-300 border border-neutral-600">
            Cancelar
          </button>
          <button onClick={guardar} disabled={!listo}
            className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 disabled:opacity-40 transition-colors">
            {trazos.length ? "Guardar con las marcas" : "Guardar sin marcas"}
          </button>
        </div>
      </div>
    </div>
  );
};

// Elegir qué parte de la foto queda en el avatar.
//
// Antes se recortaba el centro sin preguntar: si la cara estaba en un
// costado, quedaba afuera. Se arrastra la foto y se acerca o aleja
// hasta que el círculo muestre lo que uno quiere.
const RecorteFoto = ({ archivo, onListo, onCancelar }) => {
  const LADO = 260;                    // el círculo, en pantalla
  const [img, setImg] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const arrastre = React.useRef(null);
  const lienzoRef = React.useRef(null);

  useEffect(() => {
    const lector = new FileReader();
    lector.onload = () => {
      const i = new Image();
      i.onload = () => {
        setImg(i);
        // Arranca mostrando la foto entera dentro del círculo.
        setZoom(1);
        setPos({ x: 0, y: 0 });
      };
      i.src = lector.result;
    };
    lector.readAsDataURL(archivo);
  }, [archivo]);

  // El lado más corto llena el círculo: así nunca queda un borde vacío.
  const escalaBase = img ? LADO / Math.min(img.width, img.height) : 1;

  const dibujar = React.useCallback(() => {
    const c = lienzoRef.current;
    if (!c || !img) return;
    const ctx = c.getContext("2d");
    const e = escalaBase * zoom;
    const w = img.width * e;
    const h = img.height * e;

    ctx.clearRect(0, 0, LADO, LADO);
    ctx.save();
    ctx.beginPath();
    ctx.arc(LADO / 2, LADO / 2, LADO / 2, 0, Math.PI * 2);
    ctx.clip();
    ctx.drawImage(img, (LADO - w) / 2 + pos.x, (LADO - h) / 2 + pos.y, w, h);
    ctx.restore();
  }, [img, zoom, pos, escalaBase]);

  useEffect(() => { dibujar(); }, [dibujar]);

  // No se deja arrastrar más allá del borde: si no, se puede dejar el
  // círculo medio vacío sin darse cuenta.
  const limitar = (p) => {
    if (!img) return p;
    const e = escalaBase * zoom;
    const maxX = Math.max(0, (img.width * e - LADO) / 2);
    const maxY = Math.max(0, (img.height * e - LADO) / 2);
    return {
      x: Math.max(-maxX, Math.min(maxX, p.x)),
      y: Math.max(-maxY, Math.min(maxY, p.y)),
    };
  };

  const empezar = (e) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    arrastre.current = { x: e.clientX - pos.x, y: e.clientY - pos.y };
  };
  const mover = (e) => {
    if (!arrastre.current) return;
    setPos(limitar({ x: e.clientX - arrastre.current.x, y: e.clientY - arrastre.current.y }));
  };
  const soltar = () => { arrastre.current = null; };

  const guardar = () => {
    if (!img) return;
    // Se genera a 256 px, que es el tamaño real del avatar.
    const salida = document.createElement("canvas");
    salida.width = salida.height = 256;
    const ctx = salida.getContext("2d");
    const f = 256 / LADO;
    const e = escalaBase * zoom * f;
    const w = img.width * e;
    const h = img.height * e;
    ctx.drawImage(img, (256 - w) / 2 + pos.x * f, (256 - h) / 2 + pos.y * f, w, h);
    salida.toBlob((b) => b && onListo(b), "image/jpeg", 0.85);
  };

  return (
    <div className="fixed inset-0 bg-black/85 backdrop-blur-sm z-50 flex items-center justify-center p-4 modal-fondo"
      onClick={onCancelar}>
      <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-4 space-y-3"
        onClick={(e) => e.stopPropagation()}>
        <p className="font-display font-semibold text-sm">Elegí qué parte se ve</p>

        <div className="flex justify-center">
          <div className="relative" style={{ width: LADO, height: LADO }}>
            <canvas ref={lienzoRef} width={LADO} height={LADO}
              onPointerDown={empezar} onPointerMove={mover}
              onPointerUp={soltar} onPointerCancel={soltar}
              style={{ touchAction: "none", cursor: "grab" }}
              className="rounded-full bg-neutral-900" />
            {/* El aro marca el borde del recorte. */}
            <div className="absolute inset-0 rounded-full pointer-events-none"
              style={{ border: "2px solid #38bdf8" }} />
          </div>
        </div>

        <div className="flex items-center gap-2.5">
          <ImageIcon size={12} className="text-neutral-600 shrink-0" />
          <input type="range" min={1} max={3} step={0.05} value={zoom}
            onChange={(e) => { setZoom(Number(e.target.value)); setPos((p) => limitar(p)); }}
            className="flex-1" aria-label="Acercar o alejar" />
          <ImageIcon size={18} className="text-neutral-400 shrink-0" />
        </div>

        <p className="text-[10px] text-neutral-600 text-center">
          Arrastrá la foto para moverla y usá la barra para acercarla.
        </p>

        <div className="flex gap-2">
          <button onClick={onCancelar}
            className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-300 border border-neutral-600">
            Cancelar
          </button>
          <button onClick={guardar} disabled={!img}
            className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 disabled:opacity-40 transition-colors">
            Usar esta foto
          </button>
        </div>
      </div>
    </div>
  );
};

// Tarjeta de número del tablero. Etiqueta chica arriba, el número
// grande, y una línea de contexto abajo: sin esa línea un "78%" no
// dice si está bien o mal.
const Metrica = ({ etiqueta, valor, sufijo, pie, color = "#fafafa", onClick, icono: Ico }) => {
  const Caja = onClick ? "button" : "div";
  return (
    <Caja onClick={onClick}
      className={`relative overflow-hidden bg-neutral-800 border border-neutral-700 rounded-xl p-3 text-left transition-colors ${
        onClick ? "hover:border-sky-400/40" : ""}`}>
      {/* El icono va de fondo, muy tenue y en el color de la métrica:
          se percibe sin leerse y no le pelea el espacio al número,
          que es lo que escasea en un celular. */}
      {Ico && (
        <Ico size={38} strokeWidth={1.5} aria-hidden="true"
          style={{ color, opacity: 0.09, position: "absolute",
                   right: -6, bottom: -8, pointerEvents: "none" }} />
      )}
      <p className="relative text-[10px] text-neutral-500 mb-1 truncate">{etiqueta}</p>
      <p className="relative font-display font-bold leading-none" style={{ color, fontSize: 24 }}>
        {valor}
        {sufijo && <span className="text-sm text-neutral-600 font-normal">{sufijo}</span>}
      </p>
      {pie && <p className="text-[10px] mt-1 truncate" style={{ color: pie.color || "#737373" }}>
        {pie.texto}
      </p>}
    </Caja>
  );
};

// Las fechas reales de la semana en curso.
//
// La grilla mostraba LUN MAR MIÉ sin número: no había forma de saber
// si "miércoles" era hoy, el de la semana pasada o el que viene. Con
// la fecha al lado, la semana deja de ser abstracta.

// Qué semana del mes es. Se cuenta por el LUNES de la semana, no por
// el día: una semana que arranca el 31 de agosto y termina el 6 de
// septiembre es la primera de septiembre para quien la vive, no la
// sexta de agosto.


// ─────────────────────────────────────────────────────────────
// El contexto que recibe el asistente.
//
// Lo que se manda define si el borrador sirve o no. Se incluye lo
// que hace falta para decidir sobre el entrenamiento y nada más:
// el género y el seguimiento de ciclo NO se mandan, porque son datos
// privados del alumno y decidir si van es de Matías, no mío.
// ─────────────────────────────────────────────────────────────

const resumirEjercicio = (e) => {
  const partes = [e.ejercicio];
  if (e.conQue) partes.push(e.conQue);
  if (e.tecnica && e.tecnica !== "normal") {
    partes.push(e.tecnica === "dropset" ? "drop set"
      : e.tecnica === "tabata"
        ? `tabata con ${e.tecnicaConfig?.ejercicioB || "otro ejercicio"}: ${
            e.tecnicaConfig?.rondas || 8} bloques de ${
            e.tecnicaConfig?.trabajo || 20}s / ${e.tecnicaConfig?.pausa || 10}s`
      : esPiramidal(e.tecnica)
        ? `piramidal ${e.tecnica === "piramidal_asc" ? "ascendente" : "descendente"}: ${
            (Array.isArray(e.tecnicaConfig?.escalones) ? e.tecnicaConfig.escalones : []).map((x) => `${x.peso}x${x.reps}`).join(", ")}`
      : e.tecnica === "emom"
        ? `EMOM ${e.tecnicaConfig?.segundos || 60}s, desde ${e.tecnicaConfig?.repsInicio || 1} subiendo de a ${e.tecnicaConfig?.incremento || 1}`
        : "rest-pause");
  }
  if (e.biserie) partes.push(`serie combinada ${e.biserie}`);
  partes.push(`${e.series || "?"}x${e.reps || "?"}`);
  if (e.rirConsigna) partes.push(`RIR pedido ${e.rirConsigna}`);
  if (e.pesoSugerido) partes.push(`sugerido ${e.pesoSugerido}kg`);
  if (e.pesoUsado) partes.push(`MOVIÓ ${e.pesoUsado}kg`);
  if (e.rirTuyo) partes.push(`RIR reportado ${e.rirTuyo}`);
  if (e.comentarios) partes.push(`dijo: "${e.comentarios}"`);
  return "  - " + partes.join(" · ");
};

const contextoSesion = (alumno, semana, sesion, datos, previas) => {
  const l = [];
  l.push(`ALUMNO: ${alumno?.name || "sin nombre"}`);
  if (datos?.sesiones_semana) l.push(`Puede entrenar ${datos.sesiones_semana} veces por semana`);
  l.push(`SEMANA: ${semana?.name} - ${semana?.period}`);
  l.push(`SESIÓN: ${sesion.name} (${sesion.estado})`);
  if (sesion.borgRPE) l.push(`Esfuerzo que reportó: ${sesion.borgRPE}/10`);
  if (sesion.fuerzaPercibida) l.push(`Cómo se sintió: ${sesion.fuerzaPercibida}`);
  if (sesion.duracion) l.push(`Duró ${sesion.duracion} minutos`);
  l.push("");
  l.push("EJERCICIOS:");
  sesion.exercises.filter((e) => e.ejercicio).forEach((e) => {
    l.push(resumirEjercicio(e));
    const prev = previas?.[e.ejercicio];
    if (prev?.peso) l.push(`      (la vez anterior: ${prev.peso}kg${prev.rir ? `, RIR ${prev.rir}` : ""})`);
  });
  return l.join("\n");
};

const contextoPlanificacion = (alumno, semanas, datos, repertorio, previas) => {
  const l = [];
  l.push(`ALUMNO: ${alumno?.name || "sin nombre"}`);
  if (datos?.sesiones_semana) l.push(`Puede entrenar ${datos.sesiones_semana} veces por semana`);
  l.push("");

  // Las últimas tres semanas alcanzan para ver la tendencia sin
  // mandar el historial entero.
  l.push("ÚLTIMAS SEMANAS:");
  semanas.slice(-3).forEach((w) => {
    const hechas = w.sessions.filter((x) => x.estado === "Completado").length;
    l.push(`\n${w.name} - ${w.period} (${hechas}/${w.sessions.length} completadas)`);
    w.sessions.forEach((se) => {
      l.push(`  ${se.name} [${se.estado}]${se.borgRPE ? ` esfuerzo ${se.borgRPE}/10` : ""}`);
      se.exercises.filter((e) => e.ejercicio).forEach((e) => l.push("  " + resumirEjercicio(e)));
    });
  });

  l.push("\nÚLTIMAS CARGAS POR EJERCICIO:");
  const cargas = Object.entries(previas || {}).slice(0, 40);
  if (cargas.length) {
    cargas.forEach(([nombre, d]) => l.push(`  ${nombre}: ${d.peso || "-"}kg${d.rir ? `, RIR ${d.rir}` : ""}`));
  } else {
    l.push("  (todavía no hay registro)");
  }

  l.push("\nREPERTORIO DISPONIBLE (usá estos nombres exactos):");
  repertorio.forEach((g) => {
    if (g.items.length) l.push(`  ${g.label}: ${g.items.join(", ")}`);
  });
  return l.join("\n");
};

const contextoRepaso = (alumnos, hoy) => {
  const l = [];
  l.push(`Hoy es ${hoy}. Son ${alumnos.length} alumnos.`);
  l.push("");
  alumnos.forEach((a) => {
    const partes = [`${a.name}:`];
    partes.push(`${a.done ?? 0}/${a.total ?? 0} sesiones esta semana`);
    if (a.lastActivity) partes.push(`última actividad ${a.lastActivity}`);
    if (a.sinPlan) partes.push("SIN SESIONES ASIGNADAS");
    l.push("- " + partes.join(" · "));
  });
  return l.join("\n");
};

// La música de la sesión.
//
// En un tabata la lista marca los tiempos, así que hay dos formas de
// entrenarlo y las dos son válidas: con el cronómetro de la app, o
// con la música sonando afuera. Elige el alumno, no la app.
//
// El reproductor incrustado tiene una limitación de Spotify que
// conviene decir en vez de esconder: sin sesión iniciada en el mismo
// navegador, suenan 30 segundos de vista previa. Por eso el botón de
// abrirla en Spotify está siempre.
const MUSICA_MODOS = {
  cronometro: "Cronómetro de la app",
  musica: "Con la música",
};

const idSpotify = (url) => {
  const m = /open\.spotify\.com\/(playlist|album|track)\/([A-Za-z0-9]+)/.exec(url || "");
  return m ? { tipo: m[1], id: m[2] } : null;
};

const BloqueMusica = ({ url, editable, onCambiar }) => {
  const [abierto, setAbierto] = useState(false);
  const [editando, setEditando] = useState(false);
  const [borrador, setBorrador] = useState(url || "");
  const sp = idSpotify(url);

  useEffect(() => { setBorrador(url || ""); }, [url]);

  if (!url && !editable) return null;

  if (editando) {
    return (
      <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-3 space-y-2">
        <p className="text-xs font-medium">Lista de Spotify</p>
        <input value={borrador} onChange={(e) => setBorrador(e.target.value)}
          placeholder="https://open.spotify.com/playlist/..."
          className="w-full bg-neutral-700 border border-neutral-600 focus:border-emerald-400 focus:outline-none rounded-lg px-3 py-2 text-sm" />
        {borrador && !idSpotify(borrador) && (
          <p className="text-[10px] text-yellow-400">
            Eso no parece un link de Spotify. Copialo desde Compartir → Copiar enlace.
          </p>
        )}
        <div className="flex gap-2">
          <button onClick={() => { setBorrador(url || ""); setEditando(false); }}
            className="flex-1 py-2 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
            Cancelar
          </button>
          <button onClick={() => { onCambiar(borrador.trim()); setEditando(false); }}
            className="flex-1 py-2 rounded-lg text-xs font-medium bg-emerald-500 text-black hover:bg-emerald-400 transition-colors">
            Guardar
          </button>
        </div>
      </div>
    );
  }

  if (!url) {
    return (
      <button onClick={() => setEditando(true)}
        className="w-full flex items-center justify-center gap-1.5 text-[11px] font-medium text-neutral-500 border border-dashed border-neutral-600 hover:border-emerald-400/40 hover:text-emerald-400 rounded-xl py-2.5 transition-colors">
        <Music size={12} /> Sumarle una lista de música
      </button>
    );
  }

  return (
    <div className="rounded-xl border overflow-hidden"
      style={{ borderColor: "#1DB95466", background: "#1DB9540D" }}>
      <div className="flex items-center gap-2 px-3 py-2.5">
        <Music size={14} style={{ color: "#1DB954" }} className="shrink-0" />
        <span className="text-xs flex-1 min-w-0 truncate text-neutral-200">
          Lista para entrenar
        </span>
        {editable && (
          <button onClick={() => setEditando(true)} title="Cambiar la lista"
            className="p-1 text-neutral-500 hover:text-white transition-colors shrink-0">
            <Pencil size={12} />
          </button>
        )}
        <a href={url} target="_blank" rel="noopener noreferrer"
          title="Abrir en Spotify"
          className="text-[11px] font-medium rounded-lg px-2.5 py-1 transition-colors shrink-0"
          style={{ background: "#1DB954", color: "#000" }}>
          Abrir
        </a>
        <button onClick={() => setAbierto((v) => !v)}
          title={abierto ? "Ocultar el reproductor" : "Escuchar acá"}
          className="p-1 text-neutral-500 hover:text-white transition-colors shrink-0">
          <ChevronDown size={14} className={`transition-transform ${abierto ? "" : "-rotate-90"}`} />
        </button>
      </div>

      {abierto && sp && (
        <div className="px-3 pb-3 space-y-1.5">
          <iframe
            src={`https://open.spotify.com/embed/${sp.tipo}/${sp.id}`}
            width="100%" height="152" frameBorder="0" allowFullScreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy" title="Lista de Spotify"
            className="rounded-lg" />
          <p className="text-[10px] text-neutral-600 leading-relaxed">
            Si no tenés la sesión de Spotify abierta en este navegador, suenan
            30 segundos de cada tema. Tocá "Abrir" para escucharla completa.
          </p>
        </div>
      )}
    </div>
  );
};

// Una insignia que se inclina siguiendo el dedo.
//
// No es 3D de verdad: es la imagen plana girada en perspectiva, con
// un brillo que se mueve por encima. Un modelo 3D real necesitaría
// archivos .glb —que hay que modelar uno por uno— y sumar 600 KB de
// librería a una app que la gente abre con datos móviles.
//
// Se siente como un objeto físico, que es lo que importa.
const InsigniaGirable = ({ src, color, inicial, tam = 96, onClick = null }) => {
  // Si la imagen no carga —una ruta vieja, un archivo borrado— se
  // muestra el color con la inicial en vez de un cuadrado roto.
  const [falla, setFalla] = useState(false);
  useEffect(() => { setFalla(false); }, [src]);
  const usable = src && !falla && /^https?:|^data:/.test(src);
  const [giro, setGiro] = useState({ x: 0, y: 0 });
  const caja = React.useRef(null);
  const [tocando, setTocando] = useState(false);

  const mover = (e) => {
    const el = caja.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    // 22 grados de tope: más que eso deforma la imagen y se ve el
    // truco en vez de sentirse como volumen.
    setGiro({ x: -py * 44, y: px * 44 });
  };

  const soltar = () => { setTocando(false); setGiro({ x: 0, y: 0 }); };

  return (
    <div ref={caja}
      onPointerDown={(e) => { setTocando(true); mover(e); }}
      onPointerMove={(e) => tocando && mover(e)}
      onPointerUp={soltar}
      onPointerLeave={soltar}
      onMouseMove={(e) => !tocando && mover(e)}
      onMouseLeave={soltar}
      onClick={onClick}
      style={{ width: tam, height: tam, perspective: 500, touchAction: "none",
               cursor: onClick ? "pointer" : "grab" }}
      className="shrink-0 select-none">
      <div className="relative w-full h-full"
        style={{
          transform: `rotateX(${giro.x}deg) rotateY(${giro.y}deg)`,
          transformStyle: "preserve-3d",
          // Al soltar vuelve sola, con un rebote corto.
          transition: tocando ? "none" : "transform 420ms cubic-bezier(.2,1.4,.4,1)",
        }}>
        {usable
          ? <img src={src} alt="" draggable={false}
              onError={() => setFalla(true)}
              className="w-full h-full object-contain"
              style={{ filter: `drop-shadow(0 ${4 + Math.abs(giro.x) / 4}px ${8 + Math.abs(giro.y) / 3}px rgba(0,0,0,.5))` }} />
          : <div className="w-full h-full rounded-full flex items-center justify-center font-display font-bold"
              style={{ background: `${color}26`, border: `2px solid ${color}66`,
                       color, fontSize: tam / 2.6 }}>
              {(inicial || "?").slice(0, 1).toUpperCase()}
            </div>}

        {/* El brillo que se mueve: es lo que hace que parezca metal
            y no una calcomanía. */}
        <div className="absolute inset-0 pointer-events-none rounded-full"
          style={{
            background: `radial-gradient(circle at ${50 + giro.y * 1.4}% ${50 - giro.x * 1.4}%, rgba(255,255,255,.38), transparent 55%)`,
            opacity: tocando ? 1 : 0.45,
            transition: "opacity 300ms",
            mixBlendMode: "overlay",
          }} />
      </div>
    </div>
  );
};

// Contador de series: un círculo por serie programada, que se van
// tocando a medida que se completan.
//
// Existe porque contar series de memoria es lo primero que se pierde
// entrenando: entre el descanso, el celular y la charla, nadie se
// acuerda si iba por la tercera o la cuarta.
//
// El estado vive en el navegador, no en la base: es un apunte del
// momento, como contar con los dedos. Lo que se registra es el peso.
// La progresión de un EMOM al fallo.
//
// Con este tipo de ejercicio lo que importa es la tendencia: que
// alguien haya bajado de 6 a 5 y vuelto a 7 dice algo que el último
// número solo no dice.
const ProgresionEmom = ({ historial, actual, color = "#a78bfa" }) => {
  const previas = Array.isArray(historial) ? historial : [];
  const todas = [...previas.map((h) => h.bloques || 0),
                 ...(actual != null ? [actual] : [])];
  if (!todas.length) return null;

  const tope = Math.max(...todas, 1);
  const anterior = todas.length > 1 ? todas[todas.length - 2] : null;
  const ultimo = todas[todas.length - 1];
  const dif = anterior != null ? ultimo - anterior : null;

  return (
    <div className="rounded-lg p-2.5"
      style={{ background: "#303030", border: `1px solid ${color}44` }}>
      <span className="flex items-center gap-1.5 mb-2">
        <Tendencia size={12} style={{ color }} />
        <span className="text-[9px] uppercase tracking-[0.06em] font-semibold flex-1"
          style={{ color }}>
          {previas.length ? "Tu progresión" : "Esta vez"}
        </span>
        {dif != null && dif !== 0 && (
          <span className="text-[9px]"
            style={{ color: dif > 0 ? ESTADO.bien : ESTADO.atencion }}>
            {dif > 0 ? "+" : ""}{dif} bloque{Math.abs(dif) === 1 ? "" : "s"}
          </span>
        )}
      </span>

      {todas.length > 1 && (
        <div className="flex items-end gap-1.5 h-[52px] mb-2">
          {todas.map((n, k) => {
            const esUltima = k === todas.length - 1;
            return (
              <div key={k} className="flex-1 flex flex-col items-center gap-1">
                <div className="w-full rounded-t"
                  style={{ height: `${Math.max(6, (n / tope) * 40)}px`,
                           background: esUltima ? color : `${color}66` }} />
                <span className="text-[8px]"
                  style={{ color: esUltima ? color : "#5f5f5f" }}>
                  {esUltima ? "hoy" : `S${k + 1}`}
                </span>
              </div>
            );
          })}
        </div>
      )}

      <div className="flex items-baseline gap-1.5 pt-2"
        style={{ borderTop: todas.length > 1 ? "1px solid #ffffff0d" : "none" }}>
        <span className="font-display font-bold text-xl" style={{ color: "#f5f5f5" }}>
          {ultimo}
        </span>
        <span className="text-[11px] text-neutral-500 flex-1">
          bloque{ultimo === 1 ? "" : "s"}
          {previas.length > 0 && actual == null && " · la vez pasada"}
        </span>
        {previas.length > 1 && (
          <span className="text-[9px] text-neutral-600">
            antes: {previas.slice(0, -1).map((h) => h.bloques).join(", ")}
          </span>
        )}
      </div>
    </div>
  );
};

const ContadorSeries = ({ total, hechas, onCambio, tono = "#fbbf24" }) => {
  const n = Math.max(0, Math.min(12, parseNum(total) || 0));
  if (!n) return null;
  const completo = hechas >= n;

  return (
    <div className="flex items-center justify-end gap-2 pt-1">
      <span className="text-[9px] uppercase tracking-wider text-neutral-600">
        {/* Con una sola no dice "0/1 series": ahí no hay una cuenta que
            llevar, hay algo que se hizo o no. */}
        {n === 1
          ? (completo ? "Hecho" : "Marcá al terminarlo")
          : completo ? "Series" : `${hechas}/${n} series`}
      </span>

      <div className="relative flex items-center" style={{ height: 22 }}>
        {Array.from({ length: n }, (_, i) => {
          const marcado = i < hechas;
          return (
            <button key={i}
              onClick={() => onCambio(marcado && i === hechas - 1 ? i : i + 1)}
              title={`Serie ${i + 1}`}
              style={{
                width: 17, height: 17,
                marginLeft: i === 0 ? 0 : 7,
                borderRadius: "50%",
                // Mientras se llenan van del color del ejercicio; al
                // completarse, el que queda es verde de "terminado".
                border: `2px solid ${marcado ? (completo ? "#22c55e" : tono) : "#525252"}`,
                background: marcado ? (completo ? "#22c55e" : tono) : "transparent",
                // Al completar, todos se juntan en el primero.
                transform: completo ? `translateX(${-(i * 24)}px) scale(${i === 0 ? 1 : 0.5})` : "none",
                opacity: completo && i > 0 ? 0 : 1,
                transition: "all 320ms cubic-bezier(0.34, 1.3, 0.64, 1)",
              }} />
          );
        })}
      </div>

      <Check size={14}
        style={{
          color: "#22c55e",
          opacity: completo ? 1 : 0,
          transform: completo ? "scale(1)" : "scale(0.4)",
          marginLeft: completo ? -(n - 1) * 24 : 0,
          transition: "all 320ms cubic-bezier(0.34, 1.3, 0.64, 1) 180ms",
        }} />
    </div>
  );
};

// Técnicas de ejecución de una serie.
//
// Drop set: se llega al fallo, se baja el peso y se sigue sin
//   descanso. Las caídas se calculan solas desde el peso que cargó
//   el alumno, así no tiene que hacer la cuenta con el pulso alto.
// Rest-pause: se llega al fallo, se descansan unos segundos y se
//   sacan repeticiones extra con el mismo peso.
const TECNICAS = {
  normal:    { nombre: "Normal",     color: "#9ca3af" },
  dropset:   { nombre: "Drop set",   color: "#f472b6" },
  restpause: { nombre: "Rest-pause", color: "#22d3ee" },
  emom:      { nombre: "EMOM",       color: "#a78bfa" },
  piramidal_asc:  { nombre: "Piramidal ↑", color: "#fb923c" },
  piramidal_desc: { nombre: "Piramidal ↓", color: "#38bdf8" },
  tabata:    { nombre: "Tabata",     color: "#f87171" },
};

// La técnica se dice con FORMA, no con color.
//
// El color de la tarjeta es del RIR y significa cuánto exige el
// ejercicio. Si además la técnica tuviera color propio, dos cosas
// distintas se pintarían igual —el violeta era RIR 0 y EMOM a la
// vez— y el color dejaría de informar.
//
// El tabata es la excepción: no es una variante de cómo hacés las
// series, son dos ejercicios contra reloj sin peso ni RIR. Como no
// compite con la escala, se queda con su rojo.
const ICONO_TECNICA = {
  dropset: TrendingDown,
  restpause: Pause,
  emom: Clock,
  piramidal_asc: TrendingUp,
  piramidal_desc: TrendingDown,
  tabata: Flame,
};

const EtiquetaTecnica = ({ tecnica }) => {
  if (!tecnica || tecnica === "normal") return null;
  const t = TECNICAS[tecnica];
  if (!t) return null;
  const Ico = ICONO_TECNICA[tecnica] || Flame;
  const esTabata = tecnica === "tabata";
  const color = esTabata ? t.color : (enClaro() ? "#475569" : "#94a3b8");
  return (
    <span className="text-[10px] rounded-full px-2.5 py-1 inline-flex items-center gap-1 shrink-0"
      style={{ color, background: `${color}1F`, border: `1px solid ${color}44` }}>
      <Ico size={11} /> {t.nombre}
    </span>
  );
};

// Las tres secciones de una sesión. El orden es el del entrenamiento:
// primero se activa, después se trabaja, al final lo opcional.
// La sección verde tiene dos partes, porque son dos cosas con
// prescripciones distintas: la movilidad se mide en tiempo —un minuto
// de cadera, no 3×10— y la activación en series y repeticiones.
const SUB_VERDE = [
  { id: "movilidad",  nombre: "Movilidad",  ayuda: "Solo tiempo",
    bloques: false },
  { id: "activacion", nombre: "Activación", ayuda: "Series y repeticiones",
    bloques: true },
];

const SECCIONES = [
  { id: "verde",       nombre: "Activación y movilidad", color: "#6fc48d",
    subs: SUB_VERDE,   ayuda: "Lo que se hace antes de lo pesado" },
  { id: "principal",   nombre: "Parte principal",        color: "#38bdf8",
    ayuda: "El trabajo de la sesión" },
  { id: "finalizador", nombre: "Finalizador",            color: "#e0a068",
    ayuda: "Opcional, al cierre" },
];

// Las secciones reales que se guardan en la base.
const SECCIONES_REALES = ["movilidad", "activacion", "principal", "finalizador"];
const PESO_SECCION = { movilidad: 1, activacion: 2, principal: 3, finalizador: 4 };

// Agrupa una lista en bloques con nombre. Los seguidos con el mismo
// nombre van juntos; los que no tienen nombre quedan sueltos.
//
// El bloque es un texto en el ejercicio y no una tabla aparte: con
// una tabla habría que crear el bloque antes de poder agregarle
// nada, y borrarlo cuando queda vacío.
const agruparBloques = (lista = []) => {
  const grupos = [];
  for (const item of lista) {
    const nombre = (item.e || item).bloque || "";
    const ultimo = grupos[grupos.length - 1];
    if (ultimo && ultimo.nombre === nombre) ultimo.items.push(item);
    else grupos.push({ nombre, items: [item] });
  }
  return grupos;
};

// Qué campos ve el alumno. Se guarda lo OCULTO, no lo visible: un
// ejercicio nuevo muestra todo, que es lo esperable.
const estaOculto = (ex, campo) =>
  Array.isArray(ex?.ocultos) && ex.ocultos.includes(campo);

// Envuelve un campo con el ojo de visibilidad. Solo el coach lo ve;
// el alumno directamente no recibe el campo oculto.
const ConOjo = ({ ex, campo, esCoach, onCambiar, children }) => {
  const oculto = estaOculto(ex, campo);
  if (!esCoach) return oculto ? null : children;
  return (
    <div className="relative">
      <div className={oculto ? "opacity-35" : ""}>{children}</div>
      <button
        onClick={() => {
          const lista = Array.isArray(ex.ocultos) ? ex.ocultos : [];
          onCambiar(oculto ? lista.filter((x) => x !== campo) : [...lista, campo]);
        }}
        title={oculto ? "El alumno NO lo ve · tocá para mostrarlo"
                      : "El alumno lo ve · tocá para ocultarlo"}
        className="absolute -top-1 right-0 p-1 rounded transition-colors"
        style={{ color: oculto ? "#e0a068" : "#475569" }}>
        {oculto ? <EyeOff size={12} /> : <Eye size={12} />}
      </button>
    </div>
  );
};

// Lo que viene de la base tiene que ser una lista antes de guardarse.
// Si una consulta falla devuelve un objeto de error, y guardarlo hace
// que la app reviente DESPUÉS, al dibujar, lejos de donde falló.
const aLista = (x) => (Array.isArray(x) ? x : []);

// ¿Sirve como componente para dibujar?
//
// Los íconos de lucide se crean con forwardRef: son OBJETOS, no
// funciones. Comprobar solo "typeof === function" los descartaba a
// todos y la barra quedaba con el mismo ícono seis veces.
const esIcono = (x) => !!x && (typeof x === "function" || typeof x === "object");

// La sección, normalizada. Un espacio de más o una mayúscula en la
// base rompían la comparación en silencio: la sección se dibujaba
// igual pero los botones que dependen de ella no aparecían.
// El mes en curso, como se escribe en las semanas: "SEPTIEMBRE 2026".
// El mes, siempre igual: en mayúsculas y sin espacios de más.
//
// Las semanas se agrupan por el texto del período. "Septiembre 2026"
// y "SEPTIEMBRE 2026" son el mismo mes pero distinto texto, así que
// quedaban en dos carpetas separadas.
const normalizarMes = (t) => String(t || "").trim().toUpperCase().replace(/\s+/g, " ");

const mesActual = () => {
  const meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
                 "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];
  const h = new Date();
  return `${meses[h.getMonth()]} ${h.getFullYear()}`;
};

// La carga previa de un ejercicio. Busca por nombre exacto y, si no,
// sin distinguir mayúsculas ni acentos: "PRESS BANCA" y "Press banca"
// son el mismo ejercicio, y por esa diferencia la referencia no
// aparecía.
const cargaPreviaDe = (cargas, nombre) => {
  if (!cargas || !nombre) return null;
  if (cargas[nombre]) return cargas[nombre];
  const limpio = (t) => String(t || "").trim().toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const buscado = limpio(nombre);
  for (const k of Object.keys(cargas)) {
    if (limpio(k) === buscado) return cargas[k];
  }
  return null;
};

const seccionDe = (ex) => {
  const s = String(ex?.seccion || "").trim().toLowerCase();
  if (s) return s;
  return ex?.finalizador ? "finalizador" : "principal";
};

const esPiramidal = (t) => t === "piramidal_asc" || t === "piramidal_desc";

// Las columnas de la vista de lista del alumno y su ancho. Los títulos
// van en una tabla aparte (fija arriba): los anchos tienen que ser los
// mismos en las dos para que cada título quede sobre su dato.
const COLS_LISTA = [["Ejercicio", 160], ["Con qué", 104], ["Técnica", 160], ["Series", 60], ["Reps", 76],
  ["Peso sug.", 150], ["Peso usado", 230], ["RIR cons.", 76], ["RIR tuyo", 96], ["Reloj", 112], ["Hechas", 210],
  ["Video", 60], ["Charla", 64]];
const ANCHO_LISTA = COLS_LISTA.reduce((t, [, w]) => t + w, 0);


// Los escalones que se proponen al elegir piramidal. Se calculan
// desde el peso sugerido para no arrancar con cuatro filas vacías:
// el coach corrige lo que no le sirva, que es más rápido que cargar
// todo de cero.
const escalonesSugeridos = (pesoBase, cuantos = 4, asc = true) => {
  const base = parseNum(pesoBase) || 40;
  const reps = [12, 10, 8, 6, 5, 4];
  return Array.from({ length: cuantos }, (_, i) => {
    // 10% de salto por escalón, redondeado a 2,5 kg.
    const salto = base * 0.1 * (asc ? i : (cuantos - 1 - i));
    const peso = Math.max(2.5, Math.round((base + salto) / 2.5) * 2.5);
    const idx = asc ? i : (cuantos - 1 - i);
    return { peso: String(peso), reps: String(reps[Math.min(idx, reps.length - 1)]) };
  });
};

// EMOM ascendente: cada bloque arranca en punto y las repeticiones
// suben. Se corta cuando ya no entran en el tiempo del bloque, así
// que no hay una cantidad de bloques fijada de antemano.
const bloquesEmom = (cfg = {}, cuantos = 8) => {
  const inicio = Number(cfg.repsInicio) || 1;
  const paso = Number(cfg.incremento) || 1;
  return Array.from({ length: cuantos }, (_, i) => ({
    bloque: i + 1,
    reps: inicio + paso * i,
  }));
};

// Cada caída baja un 20% sobre la anterior: es el salto habitual
// para poder seguir moviendo con la técnica sana.
const caidasDropset = (peso, cuantas = 3) => {
  const inicial = parseNum(peso);
  if (!inicial) return [];
  // En pesos chicos se redondea más fino: con salto de 2.5 kg, dos
  // caídas de 10 kg daban 7.5 y 7.5, o sea la segunda no bajaba.
  const salto = inicial >= 30 ? 2.5 : inicial >= 12 ? 1 : 0.5;
  const salida = [];
  let actual = inicial;
  for (let i = 0; i < Math.max(1, cuantas) - 1; i++) {
    actual = actual * 0.8;
    const kg = Math.max(salto, Math.round(actual / salto) * salto);
    // Cada caída tiene que bajar de la anterior; si el redondeo las
    // empata, se resta un salto.
    const previo = salida.length ? salida[salida.length - 1] : inicial;
    salida.push(kg >= previo ? Math.max(salto, previo - salto) : kg);
  }
  return salida;
};

const SelectorTecnica = ({ tecnica, config, onChange, onReps, pesoBase,
  gruposEjercicios, soloCaja, soloPanel, compacto, nombreA }) => {
  const actual = tecnica || "normal";
  const cfg = config || {};

  const cambiar = (t) => {
    if (t === "dropset") onChange("dropset", { caidas: cfg.caidas || 3 });
    else if (t === "restpause") onChange("restpause", { pausa: cfg.pausa || 15, tandas: cfg.tandas || 3 });
    else if (esPiramidal(t)) onChange(t, {
      escalones: cfg.escalones?.length
        ? cfg.escalones
        : escalonesSugeridos(pesoBase, 4, t === "piramidal_asc"),
    });
    else if (t === "tabata") onChange("tabata", {
      titulo: cfg.titulo || "",
      ejercicioB: cfg.ejercicioB || "",
      // Cada ejercicio del tabata puede usar material distinto: uno
      // con mancuernas y el otro sin nada es lo normal.
      conQueA: cfg.conQueA || "",
      conQueB: cfg.conQueB || "",
      trabajo: cfg.trabajo || 20,
      pausa: cfg.pausa || 10,
      rondas: cfg.rondas || 8,
      musica: cfg.musica || "",
    });
    else if (t === "emom") onChange("emom", {
      segundos: cfg.segundos || 60,
      repsInicio: cfg.repsInicio || 1,
      incremento: cfg.incremento || 1,
    });
    else onChange("normal", null);
    // En rest-pause y EMOM se va al fallo, así que un número fijo de
    // repeticiones no significa nada.
    // En piramidal cada serie tiene sus repeticiones: un número
    // único arriba no significa nada.
    if (onReps) onReps(t === "restpause" || t === "emom" ? "Al fallo"
                     : esPiramidal(t) || t === "tabata" ? "—" : "");
  };

  // Los parámetros de las técnicas son números (pausa, tandas,
  // segundos), pero los escalones de la piramidal son una lista.
  // Convertirla a número la dejaba en 1 y la escalera reventaba al
  // recorrerla: pantalla en negro al escribir una repetición.
  const setCfg = (campo, v) =>
    onChange(actual, {
      ...cfg,
      // Los textos (el ejercicio B, el link de la lista) se guardan
      // tal cual; los parámetros numéricos, como números.
      [campo]: Array.isArray(v) ? v
        : ["ejercicioB", "musica", "titulo", "conQueA", "conQueB"].includes(campo) ? v
        : Math.max(1, parseInt(v) || 0),
    });


  // La caja va DENTRO de la grilla; el panel de configuración, DEBAJO.
  //
  // Devolver los dos juntos en un fragmento los metía a ambos en la
  // grilla —un fragmento no es una celda—, así que el panel se
  // colaba entre "Técnica" y "Series" y corría todo lo que seguía.
  // Un desplegable igual que "Con qué": la lista del sistema, no una
  // caja de botones propia.
  // En la planilla del planificador: el desplegable solo, del tamaño
  // de una celda. Es el mismo cambio de técnica, con los mismos valores
  // iniciales que en la tarjeta.
  if (compacto) {
    return (
      <select value={actual} onChange={(e) => cambiar(e.target.value)}
        className="bg-neutral-700/70 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-2 py-1.5 text-sm w-full">
        {Object.entries(TECNICAS).map(([k, t]) => (
          <option key={k} value={k}>{t.nombre}</option>
        ))}
      </select>
    );
  }
  if (!soloPanel) {
    return (
      <CajaCampo>
        <EtiquetaCampo label="Técnica" color={GRIS_ETIQUETA} />
        <div className="relative mt-1">
          <select value={actual}
            onChange={(e) => cambiar(e.target.value)}
            className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md pl-2 pr-7 py-2 text-base text-white appearance-none transition-colors">
            {Object.entries(TECNICAS).map(([k, t]) => (
              <option key={k} value={k}>{t.nombre}</option>
            ))}
          </select>
          <ChevronDown size={13}
            className="absolute right-2 top-3 text-neutral-500 pointer-events-none" />
        </div>
      </CajaCampo>
    );
  }

  // El panel de configuración, debajo de la grilla y a lo ancho.
  return (
    <>

      {actual === "dropset" && (
        <div className="bg-neutral-700/40 border border-neutral-600 rounded-lg p-3 space-y-2">
          <div className="flex items-center gap-2">
            <span className="text-[11px] text-neutral-400 flex-1">Caídas de peso</span>
            <input type="number" inputMode="numeric" min={2} max={5} value={cfg.caidas ?? 3}
              onChange={(e) => setCfg("caidas", e.target.value)}
              className="w-16 bg-neutral-800 border border-neutral-600 focus:border-pink-400 focus:outline-none rounded-md px-2 py-1.5 text-base text-center" />
          </div>
          <p className="text-[10px] text-neutral-600 leading-relaxed">
            Al fallo, baja el peso y sigue sin descanso. Los kilos de cada
            caída se calculan solos con el peso que cargue el alumno.
          </p>
        </div>
      )}

      {actual === "restpause" && (
        <div className="bg-neutral-700/40 border border-neutral-600 rounded-lg p-3 space-y-2">
          <div className="grid grid-cols-2 gap-2">
            <div>
              <span className="text-[9px] uppercase tracking-wider text-neutral-500">Pausa (seg)</span>
              <input type="number" inputMode="numeric" value={cfg.pausa ?? 15}
                onChange={(e) => setCfg("pausa", e.target.value)}
                className="w-full mt-1 bg-neutral-800 border border-neutral-600 focus:border-cyan-400 focus:outline-none rounded-md px-2 py-1.5 text-base text-center" />
            </div>
            <div>
              <span className="text-[9px] uppercase tracking-wider text-neutral-500">Tandas</span>
              <input type="number" inputMode="numeric" min={2} max={5} value={cfg.tandas ?? 3}
                onChange={(e) => setCfg("tandas", e.target.value)}
                className="w-full mt-1 bg-neutral-800 border border-neutral-600 focus:border-cyan-400 focus:outline-none rounded-md px-2 py-1.5 text-base text-center" />
            </div>
          </div>
          <p className="text-[10px] text-neutral-600 leading-relaxed">
            Al fallo, {cfg.pausa ?? 15} segundos de pausa y seguís con el mismo
            peso. {cfg.tandas ?? 3} tandas en total.
          </p>
        </div>
      )}

      {esPiramidal(actual) && (() => {
        const escalones = Array.isArray(cfg.escalones) ? cfg.escalones : [];
        const asc = actual === "piramidal_asc";
        const color = asc ? "#fb923c" : "#38bdf8";
        const cambiar = (idx, campo, v) => setCfg("escalones",
          escalones.map((e, k) => (k === idx ? { ...e, [campo]: v } : e)));

        return (
          <div className="bg-neutral-700/40 border border-neutral-600 rounded-lg p-3 space-y-2">
            <div className="flex items-center gap-2">
              <span className="text-[9px] uppercase tracking-wider text-neutral-500 flex-1">
                {escalones.length} series · cada una con su peso
              </span>
              <button onClick={() => setCfg("escalones",
                escalonesSugeridos(pesoBase, Math.min(8, escalones.length + 1), asc))}
                className="text-[10px] px-2 py-0.5 rounded border border-neutral-600 text-neutral-400 hover:text-white transition-colors"
                disabled={escalones.length >= 8}>
                + serie
              </button>
              <button onClick={() => setCfg("escalones", escalones.slice(0, -1))}
                className="text-[10px] px-2 py-0.5 rounded border border-neutral-600 text-neutral-400 hover:text-white transition-colors"
                disabled={escalones.length <= 2}>
                − serie
              </button>
            </div>

            {escalones.length === 0 && (
              <button onClick={() => setCfg("escalones", escalonesSugeridos(pesoBase, 4, asc))}
                className="w-full text-[11px] text-neutral-400 border border-dashed border-neutral-600 rounded-lg py-2 hover:border-sky-400/40 hover:text-sky-400 transition-colors">
                Armar las series
              </button>
            )}

            {escalones.map((e, idx) => (
              // Las dos columnas iguales y las dos con min-w-0: el
              // campo de reps tenía ancho fijo y en pantallas angostas
              // empujaba la fila fuera del recuadro.
              <div key={idx} className="flex items-center gap-1.5">
                <span className="w-4 text-[10px] text-neutral-600 shrink-0">{idx + 1}</span>
                <input type="number" inputMode="decimal" step="2.5" value={e.peso}
                  onChange={(ev) => cambiar(idx, "peso", ev.target.value)}
                  placeholder="kg"
                  className="flex-1 min-w-0 bg-neutral-800 border border-neutral-600 focus:outline-none rounded-md px-1.5 py-1.5 text-base text-center"
                  style={{ borderColor: `${color}44` }} />
                <span className="text-[10px] text-neutral-600 shrink-0">×</span>
                <input type="number" inputMode="numeric" value={e.reps}
                  onChange={(ev) => cambiar(idx, "reps", ev.target.value)}
                  placeholder="rep"
                  className="flex-1 min-w-0 bg-neutral-800 border border-neutral-600 focus:outline-none rounded-md px-1.5 py-1.5 text-base text-center"
                  style={{ borderColor: `${color}44` }} />
              </div>
            ))}

            <button onClick={() => setCfg("escalones",
              escalonesSugeridos(pesoBase, escalones.length || 4, asc))}
              className="w-full text-[10px] text-neutral-500 hover:text-white transition-colors pt-1">
              Recalcular desde el peso sugerido
            </button>
          </div>
        );
      })()}

      {actual === "tabata" && (() => {
        // El tabata es UN bloque con dos ejercicios que alternan, no
        // un ejercicio con una técnica rara. Antes el primero estaba
        // arriba como cualquier otro y el segundo escondido acá
        // adentro: había que ir a dos lugares para armar una sola cosa,
        // y nunca se veían juntos.
        const seg = Number(cfg.segundos) || 20;
        const desc = Number(cfg.descanso) || 10;
        const rondas = Number(cfg.rondas) || 8;
        const total = (seg + desc) * rondas;
        const mm = Math.floor(total / 60);
        const ss = String(total % 60).padStart(2, "0");

        return (
        <div className="bg-neutral-700/40 border border-neutral-600 rounded-lg p-3 space-y-3">
          {/* El nombre del bloque, arriba: es el título de la tarjeta
              y lo que ve el alumno. */}
          <div className="flex items-center gap-2">
            <Zap size={14} style={{ color: "#f87171" }} className="shrink-0" />
            <input value={cfg.titulo || ""}
              onChange={(e) => setCfg("titulo", e.target.value)}
              placeholder="Tabata de core"
              className="flex-1 min-w-0 bg-neutral-800 border border-neutral-600 focus:border-red-400 focus:outline-none rounded-md px-2.5 py-1.5 text-base" />
          </div>

          {/* Los tiempos, con el total calculado: sin eso hay que
              hacer la cuenta a mano para saber cuánto dura. */}
          <div className="grid grid-cols-2 gap-2">
            {[["Trabajo", "segundos", seg, "#f87171", Clock],
              ["Descanso", "descanso", desc, "#38bdf8", Hourglass],
              ["Rondas", "rondas", rondas, "#a78bfa", Repeat]].map(([et, campo, val, col, Ico]) => (
              <div key={campo} className="rounded-lg px-2.5 py-2"
                style={{ background: "#303030", border: "1px solid #ffffff0a" }}>
                <span className="flex items-center gap-1.5">
                  <Ico size={11} style={{ color: col }} className="shrink-0" />
                  <span className="text-[8px] uppercase tracking-[0.05em] font-semibold"
                    style={{ color: "#8a8a8a" }}>{et}</span>
                </span>
                <input type="number" inputMode="numeric" value={val}
                  onChange={(e) => setCfg(campo, e.target.value)}
                  className="w-full mt-1 bg-transparent border-0 focus:outline-none text-base font-semibold p-0" />
              </div>
            ))}
            <div className="rounded-lg px-2.5 py-2"
              style={{ background: "#303030", border: "1px solid #ffffff0a" }}>
              <span className="flex items-center gap-1.5">
                <Sigma size={11} style={{ color: ESTADO.bien }} className="shrink-0" />
                <span className="text-[8px] uppercase tracking-[0.05em] font-semibold"
                  style={{ color: "#8a8a8a" }}>Total</span>
              </span>
              <p className="mt-1 text-base font-semibold" style={{ color: ESTADO.bien }}>
                {mm}:{ss}
              </p>
            </div>
          </div>

          {/* Los dos ejercicios JUNTOS, marcados A y B. El primero es
              el del ejercicio de arriba; el segundo se elige acá. */}
          <div className="rounded-lg p-2.5"
            style={{ background: "#303030", border: "1px solid #ffffff0a" }}>
            <p className="text-[8px] uppercase tracking-[0.05em] font-semibold mb-2"
              style={{ color: "#8a8a8a" }}>
              Los ejercicios que alternan
            </p>

            {[["A", "#f87171", null, "conQueA"],
              ["B", "#38bdf8", "ejercicioB", "conQueB"]].map(([letra, col, campoEj, campoQue]) => (
              <div key={letra} className="flex gap-2 items-start mb-2 last:mb-0">
                <span className="w-5 h-5 rounded-full flex items-center justify-center shrink-0 mt-1.5 text-[10px] font-bold"
                  style={{ background: `${col}26`, color: col }}>{letra}</span>
                <div className="flex-1 min-w-0">
                  {campoEj ? (
                    <BuscadorEjercicio value={cfg[campoEj] || ""} grupos={gruposEjercicios}
                      onChange={(v) => setCfg(campoEj, v)} label="" onEscribir />
                  ) : (
                    // El A es el ejercicio de esta misma tarjeta o fila: se
                    // muestra su nombre. "El ejercicio de arriba" no se
                    // entendía, sobre todo en la planilla.
                    <div className="bg-neutral-800 border border-neutral-600 rounded-md px-2.5 py-2 text-sm text-white truncate">
                      {nombreA || "Este ejercicio"}
                    </div>
                  )}
                </div>
                {/* Con qué se hace cada uno. Sin etiqueta se veía un
                    guion suelto al costado y no se entendía qué era. */}
                <div className="w-[110px] shrink-0">
                  <FieldSelect label="Con qué" value={cfg[campoQue] || ""} options={CON_QUE_OPTIONS}
                    onChange={(v) => setCfg(campoQue, v)} labelColor={GRIS_ETIQUETA} />
                </div>
              </div>
            ))}

            <p className="text-[9px] text-neutral-600 mt-2 pt-2"
              style={{ borderTop: "1px solid #ffffff0d" }}>
              Ronda 1 hace A, ronda 2 hace B, y así hasta la {rondas}.
            </p>
          </div>
        </div>
        );
      })()}

      {actual === "emom" && (
        <div className="bg-neutral-700/40 border border-neutral-600 rounded-lg p-3 space-y-2">
          <div>
            <span className="text-[9px] uppercase tracking-wider text-neutral-500">
              Cada bloque dura (seg)
            </span>
            {/* Ocho opciones no entran en una fila en un celular. */}
            <div className="grid grid-cols-4 gap-1.5 mt-1">
              {[10, 15, 20, 30, 45, 60, 90, 120].map((sg) => (
                <button key={sg} onClick={() => setCfg("segundos", sg)}
                  className={`rounded-md py-1.5 text-xs font-medium border transition-colors ${
                    (cfg.segundos ?? 60) === sg
                      ? "bg-violet-400 text-black border-violet-400"
                      : "text-neutral-400 border-neutral-600"}`}>
                  {sg}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div>
              <span className="text-[9px] uppercase tracking-wider text-neutral-500">
                Arranca con
              </span>
              <input type="number" inputMode="numeric" min={1} value={cfg.repsInicio ?? 1}
                onChange={(e) => setCfg("repsInicio", e.target.value)}
                className="w-full mt-1 bg-neutral-800 border border-neutral-600 focus:border-violet-400 focus:outline-none rounded-md px-2 py-1.5 text-base text-center" />
            </div>
            <div>
              <span className="text-[9px] uppercase tracking-wider text-neutral-500">
                Sube de a
              </span>
              <input type="number" inputMode="numeric" min={1} value={cfg.incremento ?? 1}
                onChange={(e) => setCfg("incremento", e.target.value)}
                className="w-full mt-1 bg-neutral-800 border border-neutral-600 focus:border-violet-400 focus:outline-none rounded-md px-2 py-1.5 text-base text-center" />
            </div>
          </div>

          {/* La escalera, para ver de una si el salto es razonable. */}
          <div className="flex flex-wrap gap-1">
            {bloquesEmom(cfg, 6).map((b) => (
              <span key={b.bloque}
                className="text-[10px] rounded px-1.5 py-0.5"
                style={{ background: "#a78bfa1F", color: "#a78bfa" }}>
                {b.reps}
              </span>
            ))}
            <span className="text-[10px] text-neutral-600 px-1">→ hasta el fallo</span>
          </div>

          <p className="text-[10px] text-neutral-500 leading-relaxed">
            Cada {cfg.segundos ?? 60} segundos arranca un bloque nuevo con una
            repetición más. Se sigue hasta que ya no entran en el tiempo.
          </p>
        </div>
      )}
    </>
  );
};

// Prescripción del trabajo: repeticiones o tiempo.
//
// Si el coach elige tiempo, el ejercicio lleva cronómetro de trabajo
// automáticamente: no tiene sentido prescribir 40 segundos y que el
// alumno los cuente de memoria.
const PrescripcionTrabajo = ({ ex, onChange, opcionesSeries, opcionesReps,
                               customSeries, onToggleSeries, customReps, onToggleReps }) => {
  const modo = ex.modo || "reps";

  // En piramidal cada serie trae su peso y sus repeticiones: series,
  // reps y peso sugerido acá arriba serían el mismo dato dos veces,
  // y dos lugares para lo mismo es un lugar donde equivocarse.
  if (esPiramidal(ex.tecnica) || ex.tecnica === "tabata") return null;

  const cambiarModo = (m) => {
    if (m === "tiempo") {
      onChange({ modo: "tiempo", reps: ex.reps && /^\d+$/.test(ex.reps) ? ex.reps : "40" });
    } else if (m === "tabata") {
      // Los valores clásicos del protocolo: 20 de trabajo, 10 de pausa.
      onChange({ modo: "tabata", reps: "20", descanso: 10,
                 series: ex.series && /^\d+$/.test(ex.series) ? ex.series : "8" });
    } else {
      onChange({ modo: "reps", reps: "" });
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-1.5">
        <span className="text-[10px] uppercase tracking-wider text-neutral-500 flex-1">
          Cómo se mide el trabajo
        </span>
        <div className="flex gap-1">
          {[["reps", "Reps"], ["tiempo", "Tiempo"], ["tabata", "Tabata"]].map(([m, l]) => (
            <button key={m} onClick={() => cambiarModo(m)}
              className={`text-[10px] font-medium rounded-md px-2.5 py-1 border transition-colors ${
                modo === m ? "bg-sky-400 text-black border-sky-400"
                  : "text-neutral-400 border-neutral-600 hover:border-sky-400/40"}`}>
              {l}
            </button>
          ))}
        </div>
      </div>

      {modo === "tabata" ? (
        <div className="bg-neutral-700/40 border border-neutral-600 rounded-lg p-3 space-y-3">
          <RuedaSegundos etiqueta="Trabajo" color="#fb923c" max={60}
            valor={parseNum(ex.reps) || 0}
            onChange={(v) => onChange({ reps: String(v) })} />
          <RuedaSegundos etiqueta="Pausa" color="#60a5fa" max={60}
            valor={parseNum(ex.descanso) || 0}
            onChange={(v) => onChange({ descanso: v })} />
          <div className="flex items-center gap-2 pt-1 border-t border-neutral-600">
            <span className="text-[10px] uppercase tracking-wider text-neutral-500 flex-1">Rondas</span>
            <input type="number" inputMode="numeric" value={ex.series || ""}
              onChange={(e) => onChange({ series: e.target.value })}
              className="w-20 bg-neutral-800 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-2 py-1.5 text-base text-white text-center" />
          </div>
          <p className="text-[10px] text-neutral-600 text-center">
            {parseNum(ex.series) || 0} rondas de {parseNum(ex.reps) || 0}s / {parseNum(ex.descanso) || 0}s
            {" · "}
            {Math.round(((parseNum(ex.reps) + parseNum(ex.descanso)) * (parseNum(ex.series) || 0)) / 60 * 10) / 10} min en total
          </p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-2 gap-2">
            <FieldSelect label="Series" value={ex.series} options={opcionesSeries}
              onChange={(v) => onChange({ series: v })} customActive={customSeries}
              onToggleCustom={onToggleSeries} labelColor={FIELD_ACCENTS.series} colorful />
            {modo === "tiempo" ? (
              <div className="flex flex-col gap-1">
                <span className="text-[10px] uppercase tracking-wider" style={{ color: FIELD_ACCENTS.reps }}>
                  Trabajo (seg)
                </span>
                <input type="number" inputMode="numeric" value={ex.reps || ""}
                  onChange={(e) => onChange({ reps: e.target.value })} placeholder="40"
                  className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-2 py-2 text-base text-white text-center transition-colors" />
              </div>
            ) : (
              <FieldSelect label="Reps" value={ex.reps} options={opcionesReps}
                onChange={(v) => onChange({ reps: v })} customActive={customReps}
                onToggleCustom={onToggleReps} labelColor={FIELD_ACCENTS.reps} colorful />
            )}
          </div>

          {/* Descanso entre series: opcional, para cualquier sesión.
              En tabata no aparece porque la pausa ya es parte del ciclo. */}
          <DescansoPlanner valor={ex.descanso} onChange={(v) => onChange({ descanso: v })} />
        </>
      )}
    </div>
  );
};

// Descanso entre series. Se muestra siempre como opción, debajo de
// series y reps, que es donde el coach lo piensa.
const DescansoPlanner = ({ valor, onChange }) => {
  if (!valor) {
    return (
      <button onClick={() => onChange(90)}
        className="w-full flex items-center justify-center gap-1.5 text-[11px] font-medium text-neutral-500 border border-dashed border-neutral-600 hover:border-sky-400/40 hover:text-sky-400 rounded-lg py-2 transition-colors">
        <Clock size={12} /> Definir descanso entre series
      </button>
    );
  }
  return (
    <div className="flex items-center gap-2 bg-neutral-700/40 border border-neutral-600 rounded-lg px-3 py-2">
      <Clock size={13} className="text-sky-400 shrink-0" />
      <span className="text-[11px] text-neutral-400 flex-1">Descanso entre series</span>
      <input type="number" inputMode="numeric" value={valor}
        onChange={(e) => onChange(Math.max(0, parseInt(e.target.value) || 0))}
        className="w-20 bg-neutral-800 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-2 py-1.5 text-base text-white text-center" />
      <span className="text-[11px] text-neutral-500">seg</span>
      <button onClick={() => onChange(null)}
        className="text-neutral-600 hover:text-red-400 transition-colors shrink-0">
        <X size={13} />
      </button>
    </div>
  );
};

const InfoTooltip = ({ title, body }) => {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-block">
      <button onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }}
        className="w-4 h-4 rounded-full border border-neutral-500 text-neutral-500 hover:text-sky-400 hover:border-sky-400 flex items-center justify-center text-[9px] font-bold transition-colors">
        i
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute z-50 top-6 left-0 w-64 bg-neutral-900 border border-neutral-600 rounded-lg p-3 shadow-xl">
            <p className="text-xs font-semibold text-white mb-1.5">{title}</p>
            <p className="text-[11px] text-neutral-400 leading-relaxed whitespace-pre-line">{body}</p>
          </div>
        </>
      )}
    </span>
  );
};

const RANGE_OPTIONS = [
  { key: "1", label: "Última" },
  { key: "3", label: "3 anteriores" },
  { key: "5", label: "5 anteriores" },
  { key: "all", label: "Todo" },
];

const ChartTooltipStyle = { backgroundColor: "#262626", border: "1px solid #525252", borderRadius: 8, fontSize: 12 };
const axisTick = { fontSize: 10, fill: "#a3a3a3" };

const SessionProgressCard = ({ weeks, sessionName }) => {
  const [range, setRange] = useState("5");
  // Arranca plegado: durante el entrenamiento lo que importa es el
  // ejercicio, no el gráfico. Se abre cuando se lo quiere mirar.
  const [abierto, setAbierto] = useState(() => {
    try { return sessionStorage.getItem("be_grafico_abierto") === "1"; }
    catch { return false; }
  });
  const alternar = () => setAbierto((v) => {
    try { sessionStorage.setItem("be_grafico_abierto", v ? "0" : "1"); }
    catch { /* ignorar */ }
    return !v;
  });
  const fullHistory = findSessionHistory(weeks, sessionName);
  if (fullHistory.length < 2) {
    return (
      <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-4">
        <p className="font-display font-semibold text-sm mb-1 flex items-center gap-1.5"><TrendingUp size={14} className="text-sky-400" /> Progreso de esta sesión</p>
        <p className="text-xs text-neutral-500">Todavía no hay suficiente historial de "{sessionName}" para comparar — necesitás al menos 2 sesiones completadas con este nombre.</p>
      </div>
    );
  }
  const n = range === "all" ? fullHistory.length : Math.min(parseInt(range) + 1, fullHistory.length);
  const history = fullHistory.slice(-n);
  const volumeData = history.map((h) => ({ label: h.weekLabel, carga: Math.round(sessionVolume(h.session)) }));
  const rirData = history.map((h) => {
    const vals = h.session.exercises
      .map((ex) => ({ consigna: metricToNumber(ex.rirConsigna, ex.metric), real: metricToNumber(ex.rirTuyo, ex.metric) }))
      .filter((v) => v.consigna !== null && v.real !== null);
    const avg = (key) => (vals.length ? Math.round((vals.reduce((a, v) => a + v[key], 0) / vals.length) * 10) / 10 : null);
    return { label: h.weekLabel, esperado: avg("consigna"), real: avg("real") };
  });
  const internalLoadData = history
    .filter((h) => h.session.borgRPE && h.session.duracion)
    .map((h) => ({ label: h.weekLabel, srpe: Math.round(h.session.borgRPE * parseNum(h.session.duracion)) }));

  return (
    <div className={`bg-neutral-800 border border-neutral-700 rounded-xl ${
      abierto ? "p-4 space-y-4" : "px-3 py-2"}`}>
      <button onClick={alternar} className="w-full flex items-center gap-1.5 text-left">
        <TrendingUp size={14} className="text-sky-400 shrink-0" />
        <span className="font-display font-semibold text-sm flex-1">Progreso de esta sesión</span>
        <span className="text-[10px] text-neutral-600">{history.length} sesiones</span>
        <ChevronDown size={15}
          className={`text-neutral-500 shrink-0 transition-transform ${abierto ? "" : "-rotate-90"}`} />
      </button>

      {!abierto ? null : (<>
      <div className="flex gap-1.5 flex-wrap">
        {RANGE_OPTIONS.map((o) => (
          <button key={o.key} onClick={() => setRange(o.key)}
            className={`text-[11px] font-medium rounded-full px-2.5 py-1 border transition-colors ${range === o.key ? "bg-sky-400 text-black border-sky-400" : "text-neutral-400 border-neutral-600"}`}>
            {o.label}
          </button>
        ))}
      </div>

      <div>
        <p className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 flex items-center gap-1.5">
          Carga total (peso × series × reps)
          <InfoTooltip title="Carga total (Volumen de carga)"
            body={"Eje Y: kilos totales movidos, sumando peso × series × reps de todos los ejercicios de la sesión.\nEje X: instancias anteriores de esta misma sesión, en orden cronológico.\n\nEs el 'Volumen de carga' (Volume Load), la métrica estándar en ciencias del entrenamiento de fuerza para medir el trabajo mecánico total. Es carga externa — no incluye el Borg ni la duración."} />
        </p>
        <div style={{ width: "100%", height: 150 }}>
          <ResponsiveContainer>
            <LineChart data={volumeData} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#404040" />
              <XAxis dataKey="label" tick={axisTick} />
              <YAxis tick={axisTick} />
              <Tooltip contentStyle={ChartTooltipStyle} />
              <Line type="monotone" dataKey="carga" name="Carga" stroke="#38bdf8" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div>
        <p className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 flex items-center gap-1.5">
          Carga interna (sRPE)
          <InfoTooltip title="Carga interna (método sRPE)"
            body={"Eje Y: Borg de la sesión (1-10) × duración en minutos — unidad 'UA' (unidades arbitrarias), como en la literatura original.\nEje X: mismas instancias anteriores de esta sesión.\n\nEs el método session-RPE (Foster, 2001), muy usado en ciencias del deporte para medir cuánto le costó al cuerpo, más allá del peso en la barra. Complementa la carga externa: si el peso se mantiene pero el sRPE sube semana a semana, puede ser señal de fatiga acumulada. Necesita que cargues Borg y duración al completar la sesión."} />
        </p>
        {internalLoadData.length < 2 ? (
          <p className="text-xs text-neutral-600 py-6 text-center">Cargá Borg y duración en al menos 2 sesiones para ver esta comparación.</p>
        ) : (
          <div style={{ width: "100%", height: 150 }}>
            <ResponsiveContainer>
              <LineChart data={internalLoadData} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#404040" />
                <XAxis dataKey="label" tick={axisTick} />
                <YAxis tick={axisTick} />
                <Tooltip contentStyle={ChartTooltipStyle} />
                <Line type="monotone" dataKey="srpe" name="sRPE" stroke="#fbbf24" strokeWidth={2} dot={{ r: 3 }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>

      <div>
        <p className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 flex items-center gap-1.5">
          RIR/RPE esperado vs real (promedio)
          <InfoTooltip title="RIR/RPE esperado vs real"
            body={"Eje Y: escala de esfuerzo (RIR de 0 a +4, o RPE si la sesión usa esa métrica), promediada entre los ejercicios de la sesión.\nEje X: mismas instancias anteriores de esta sesión.\n\nCompara lo que vos pautaste (consigna) contra lo que el alumno realmente sintió (real). Es el principio de autorregulación del entrenamiento de fuerza: sirve para ver si viene entrenando sistemáticamente más duro o más liviano de lo planificado."} />
        </p>
        <div style={{ width: "100%", height: 150 }}>
          <ResponsiveContainer>
            <LineChart data={rirData} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#404040" />
              <XAxis dataKey="label" tick={axisTick} />
              <YAxis tick={axisTick} />
              <Tooltip contentStyle={ChartTooltipStyle} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Line type="monotone" dataKey="esperado" name="Esperado" stroke="#f472b6" strokeWidth={2} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="real" name="Real" stroke="#34d399" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>

          </ResponsiveContainer>
        </div>
      </div>
      </>)}
    </div>
  );
};

const MonthProgressCard = ({ weeks, period }) => {
  const [abierto, setAbierto] = useState(() => {
    try { return sessionStorage.getItem("be_grafico_mes") === "1"; }
    catch { return false; }
  });
  const alternar = () => setAbierto((v) => {
    try { sessionStorage.setItem("be_grafico_mes", v ? "0" : "1"); }
    catch { /* ignorar */ }
    return !v;
  });

  const weeksInPeriod = weeks.filter((w) => w.period === period);
  if (weeksInPeriod.length < 2) return null;
  const data = weeksInPeriod.map((w) => ({ label: w.name.replace("Semana ", "S"), carga: Math.round(w.sessions.reduce((sum, s) => sum + sessionVolume(s), 0)) }));
  return (
    <div className={`bg-neutral-800 border border-neutral-700 rounded-xl ${
      abierto ? "p-4" : "px-3 py-2"}`}>
      <button onClick={alternar} className="w-full flex items-center gap-1.5 text-left">
        <TrendingUp size={14} className="text-sky-400 shrink-0" />
        <span className="font-display font-semibold text-sm flex-1">Carga del mes</span>
        <ChevronDown size={15}
          className={`text-neutral-500 shrink-0 transition-transform ${abierto ? "" : "-rotate-90"}`} />
      </button>

      {!abierto ? null : (<>
      <p className="text-[10px] uppercase tracking-wider text-neutral-500 mb-0.5 flex items-center gap-1.5">
        Volumen por semana
        <InfoTooltip title="Carga del mes"
          body={"Eje Y: suma del Volumen de carga (peso × series × reps) de todas las sesiones de esa semana.\nEje X: cada semana del mes.\n\nAgrega la carga semanal para ver la progresión del mes de un vistazo — si sube, baja o se estanca. Es carga externa; no pondera por Borg ni por cómo se sintió cada sesión."} />
      </p>
      <p className="text-[11px] text-neutral-500 mb-3">{period} · todas las sesiones por semana</p>
      <div style={{ width: "100%", height: 160 }}>
        <ResponsiveContainer>
          <BarChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#404040" />
            <XAxis dataKey="label" tick={axisTick} />
            <YAxis tick={axisTick} />
            <Tooltip contentStyle={ChartTooltipStyle} />
            <Bar dataKey="carga" name="Carga" fill="#38bdf8" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      </>)}
    </div>
  );
};

const WeeksFolderList = ({ weeks, isCoach, onPublicarSemana, collapsedMonths, setCollapsedMonths,
  semanasPlegadas, setSemanasPlegadas, onOpenWeek,
  lastWeekId, onAddWeek, onBorrarSemana, onEditarSemana, onProponerSemana,
  onAbrirSesion, onBorrarSesion, onDuplicarSesion, onVerComo,
  onALibreria, onRenombrar, emptyLabel }) => {
  const groups = [];
  weeks.forEach((w) => {
    // Se compara normalizado para que las variantes de un mismo mes
    // caigan en la misma carpeta.
    const clave = normalizarMes(w.period);
    let g = groups.find((g) => normalizarMes(g.period) === clave);
    if (!g) { g = { period: normalizarMes(w.period), weeks: [] }; groups.push(g); }
    g.weeks.push(w);
  });
  if (groups.length === 0) {
    // Antes solo mostraba un texto gris y el botón de crear quedaba
    // fuera, así que el coach llegaba a una pantalla sin salida.
    return (
      <div className="text-center py-8">
        <Calendar size={24} className="text-neutral-600 mx-auto mb-3" />
        <p className="text-neutral-500 text-xs mb-4">{emptyLabel || "Todavía no hay semanas acá."}</p>
        {isCoach && onAddWeek && (
          <button onClick={() => onAddWeek(null)}
            className="inline-flex items-center gap-1.5 text-xs font-medium text-sky-400 bg-sky-400/10 border border-sky-400/25 hover:bg-sky-400/20 rounded-full px-4 py-2.5 transition-colors">
            <Plus size={13} /> Crear la primera semana
          </button>
        )}
      </div>
    );
  }
  return (
    <div className="space-y-3">
      {groups.map((g, gi) => {
        const isLast = gi === groups.length - 1;
        const collapsed = g.period in collapsedMonths ? collapsedMonths[g.period] : !isLast;
        const doneWeeks = g.weeks.filter((w) => w.sessions.every((s) => s.estado === "Completado")).length;
        return (
          <div key={g.period} className="space-y-2">
            <button onClick={() => setCollapsedMonths((prev) => ({ ...prev, [g.period]: !collapsed }))}
              className="w-full flex items-center gap-2 bg-neutral-800 border border-neutral-700 rounded-xl px-4 py-3 hover:border-sky-400/30 transition-colors">
              <ChevronDown size={15} className={`text-neutral-500 transition-transform ${collapsed ? "-rotate-90" : ""}`} />
              <Calendar size={14} className="text-sky-400" />
              <p className="font-display font-semibold text-sm flex-1 text-left">{g.period}</p>
              <span className="text-[11px] text-neutral-500">{doneWeeks}/{g.weeks.length} semanas</span>
            </button>

            {!collapsed && (
              <div className="space-y-2.5 pl-2 border-l border-neutral-700 ml-3">
                {g.weeks.map((w) => {
                  // Cada semana se pliega sola. Con un mes entero
                  // abierto hay que bajar mucho para llegar a la que
                  // interesa, y con veinte alumnos eso es todos los días.
                  // Arrancan contraídas menos la última: es la que se
                  // está usando. Con tres meses de historial, todo
                  // abierto son decenas de sesiones para pasar.
                  //
                  // Una vez que el coach la abre o la cierra a mano,
                  // manda su elección.
                  const plegada = semanasPlegadas[w.id] !== undefined
                    ? !!semanasPlegadas[w.id]
                    : w.id !== lastWeekId;
                  return (
                  <React.Fragment key={w.id}>
                    <div className={`bg-neutral-800 border border-neutral-700 rounded-xl hover:border-sky-400/30 transition-colors ${
                      plegada ? "px-4 py-2.5" : "p-4"}`}>
                      <div className={`flex items-start gap-2 ${plegada ? "" : "mb-2"}`}>
                        <button
                          onClick={() => setSemanasPlegadas((prev) => ({ ...prev, [w.id]: !plegada }))}
                          title={plegada ? "Abrir" : "Plegar"}
                          className="p-1 -ml-1 text-neutral-600 hover:text-sky-400 transition-colors shrink-0">
                          <ChevronDown size={14}
                            className={`transition-transform ${plegada ? "-rotate-90" : ""}`} />
                        </button>
                        <button onClick={() => onOpenWeek(w)} className="flex-1 min-w-0 text-left">
                          <p className="font-display text-base font-semibold truncate">
                            {w.name} <span className="text-neutral-500 font-normal">- {w.period}</span>
                          </p>
                          {/* Programada: el alumno todavía no la ve. */}
                          {isCoach && estaOculta(w.visibleDesde) && (
                            <span className="inline-flex items-center gap-1 text-[10px] font-medium text-amber-400 mt-0.5">
                              <Lock size={10} /> La ve desde {textoVisible(w.visibleDesde)}
                            </span>
                          )}
                        </button>
                        {isCoach && onPublicarSemana && estaOculta(w.visibleDesde) && (
                          <button onClick={() => onPublicarSemana(w)}
                            className="text-[10px] font-medium text-sky-400 border border-sky-400/30 rounded-md px-2 py-1 shrink-0">
                            Publicar ya
                          </button>
                        )}
                        <span className="text-[11px] text-neutral-500 shrink-0 mt-1">
                          {w.sessions.filter((s) => s.estado === "Completado").length}/{w.sessions.length}
                        </span>
                        {/* Se podían crear semanas pero no corregirlas
                            ni sacarlas: una cargada mal quedaba así. */}
                        {isCoach && onEditarSemana && (
                          <button onClick={() => onEditarSemana(w)}
                            title={`Cambiar el nombre de ${w.name}`}
                            className="p-1 text-neutral-600 hover:text-sky-400 transition-colors shrink-0">
                            <Pencil size={13} />
                          </button>
                        )}
                        {isCoach && onBorrarSemana && (
                          <button onClick={() => onBorrarSemana(w)}
                            title={`Eliminar ${w.name}`}
                            className="p-1 -mr-1 text-neutral-600 hover:text-red-400 transition-colors shrink-0">
                            <Trash2 size={13} />
                          </button>
                        )}
                      </div>
                      {/* Las sesiones a la vista y entrando directo.
                          Antes eran etiquetas que llevaban a la semana,
                          y desde ahí había que tocar la sesión otra
                          vez: dos toques para lo mismo, y la pantalla
                          del medio repetía lo que ya estaba acá. */}
                      {!plegada && (
                      <div className="space-y-1.5">
                        {w.sessions.length === 0 && (
                          <p className="text-[11px] text-neutral-600">Sin sesiones todavía</p>
                        )}
                        {w.sessions.map((s) => {
                          const st = ESTADO_STYLES[s.estado] || ESTADO_STYLES["Pendiente"];
                          const Icon = st.icon || Dumbbell;
                          return (
                            <div key={s.id}
                              className="flex items-center bg-neutral-900/50 border border-neutral-700 hover:border-sky-400/30 rounded-lg transition-colors">
                              <button onClick={() => onAbrirSesion && onAbrirSesion(w, s)}
                                className="flex-1 min-w-0 flex items-center gap-2 px-3 py-2.5 text-left">
                                <Dumbbell size={12} className="text-sky-400 shrink-0" />
                                <span className="flex-1 min-w-0">
                                  <span className="text-xs text-neutral-200 block truncate">{s.name}</span>
                                  <span className="text-[10px] text-neutral-600">
                                    {s.exercises.filter((e) => e.ejercicio).length} ejercicios
                                    {s.day && ` · ${s.day}`}
                                  </span>
                                </span>
                                <Icon size={12} className={`${st.text} shrink-0`} />
                              </button>
                              {/* Guardarla en tu librería. Si le hiciste
                                  cambios a la sesión de alguien y sirven
                                  para otros, tenerla que rehacer desde
                                  cero es trabajo perdido. */}
                              {isCoach && onALibreria && (
                                <button onClick={() => onALibreria(w, s)}
                                  title={`Guardar ${s.name} en mi librería`}
                                  className="px-2 py-2.5 text-neutral-600 hover:text-sky-400 transition-colors shrink-0">
                                  <BookmarkPlus size={12} />
                                </button>
                              )}
                              {isCoach && onRenombrar && (
                                <button onClick={() => onRenombrar(w, s)}
                                  title={`Cambiar el nombre de ${s.name}`}
                                  className="px-2 py-2.5 text-neutral-600 hover:text-sky-400 transition-colors shrink-0">
                                  <Pencil size={12} />
                                </button>
                              )}

                              {/* Ver esta sesión como la ve el alumno.
                                  Es el mismo modo que el ojo del perfil,
                                  pero entra directo a la sesión en vez
                                  de obligar a buscarla desde su inicio. */}
                              {isCoach && onVerComo && (
                                <button onClick={() => onVerComo(w, s)}
                                  title={`Ver ${s.name} como el alumno`}
                                  className="px-2 py-2.5 text-neutral-600 hover:text-sky-400 transition-colors shrink-0">
                                  <Eye size={12} />
                                </button>
                              )}
                              {isCoach && onDuplicarSesion && (
                                <button onClick={() => onDuplicarSesion(w, s)}
                                  title={`Duplicar ${s.name}`}
                                  className="px-2 py-2.5 text-neutral-600 hover:text-sky-400 transition-colors shrink-0">
                                  <Copy size={12} />
                                </button>
                              )}
                              {isCoach && onBorrarSesion && (
                                <button onClick={() => onBorrarSesion(w, s)}
                                  title={`Eliminar ${s.name}`}
                                  className="px-3 py-2.5 text-neutral-600 hover:text-red-400 transition-colors shrink-0">
                                  <Trash2 size={12} />
                                </button>
                              )}
                            </div>
                          );
                        })}

                        {isCoach && onOpenWeek && (
                          <button onClick={() => onOpenWeek(w)}
                            className="w-full flex items-center justify-center gap-1.5 text-[11px] font-medium text-neutral-500 border border-dashed border-neutral-700 hover:border-sky-400/40 hover:text-sky-400 rounded-lg py-2 transition-colors">
                            <Plus size={12} /> Agregar sesión
                          </button>
                        )}
                      </div>
                      )}
                    </div>
                    {isCoach && onAddWeek && w.id === lastWeekId && (
                      <div className="space-y-1.5">
                        <button onClick={() => onAddWeek(w)} className="w-full flex items-center justify-center gap-1.5 text-xs font-medium text-sky-400 bg-sky-400/10 hover:bg-sky-400/20 border border-sky-400/20 rounded-lg py-2.5 transition-colors">
                          <Plus size={13} /> Duplicar o crear nueva semana
                        </button>
                        {/* El asistente mira las últimas semanas y
                            propone la que viene. Es un borrador: se
                            revisa y se carga a mano. */}
                        {onProponerSemana && (
                          <button onClick={onProponerSemana}
                            className="w-full flex items-center justify-center gap-1.5 text-[11px] font-medium text-neutral-400 border border-dashed border-neutral-600 hover:border-sky-400/40 hover:text-sky-400 rounded-lg py-2 transition-colors">
                            <Sparkles size={12} /> Proponerme la semana que viene
                          </button>
                        )}
                      </div>
                    )}
                  </React.Fragment>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

// ---------- Login screen ----------

// Sección plegable del perfil. Antes cada ajuste ocupaba su tarjeta
// y había que bajar mucho para llegar al último; así el perfil se ve
// entero de un vistazo y se abre solo lo que se va a tocar.
const Submenu = ({ icono: Ico, titulo, resumen, abierto, onToggle, children, color = "#38bdf8" }) => (
  <div className="bg-neutral-800 border border-neutral-700 rounded-xl overflow-hidden">
    <button onClick={onToggle} className="w-full flex items-center gap-2.5 p-4 text-left">
      <span className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
        style={{ background: `${color}1F` }}>
        <Ico size={15} style={{ color }} />
      </span>
      <span className="flex-1 min-w-0">
        <span className="font-display font-semibold text-sm block">{titulo}</span>
        {resumen && <span className="text-[11px] text-neutral-500 block truncate">{resumen}</span>}
      </span>
      <ChevronDown size={16}
        className={`text-neutral-500 transition-transform shrink-0 ${abierto ? "" : "-rotate-90"}`} />
    </button>
    <div className="overflow-hidden transition-all duration-250"
      style={{ maxHeight: abierto ? 900 : 0, opacity: abierto ? 1 : 0 }}>
      <div className="px-4 pb-4 space-y-4 border-t border-neutral-700 pt-4">{children}</div>
    </div>
  </div>
);

// Pantalla para el alumno que llega desde el mail de invitación.
// Viene con una sesión temporal en la dirección: solo le falta
// elegir una contraseña para poder entrar de ahí en más.
const PonerPassword = ({ onListo, esRecuperacion = false }) => {
  const [pass, setPass] = useState("");
  const [pass2, setPass2] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);

  const guardar = async () => {
    if (pass.length < 6) { setError("La contraseña necesita al menos 6 caracteres"); return; }
    if (pass !== pass2) { setError("Las dos contraseñas no coinciden"); return; }
    setError(""); setCargando(true);
    try {
      await fijarPassword(pass);
      onListo();
    } catch (e) {
      setError(e.message || "No se pudo guardar la contraseña");
    } finally { setCargando(false); }
  };

  return (
    <div className="min-h-screen bg-neutral-900 text-white flex items-center justify-center px-5"
      style={{ fontFamily: "'Inter', sans-serif" }}>
      <div className="w-full max-w-sm">
        <img src={LOGO_URI} alt="BE Training" className="h-12 mx-auto mb-4 object-contain" />
        <p className="text-center text-sm text-neutral-300 mb-1">{esRecuperacion ? "Elegí una contraseña nueva" : "¡Bienvenido a BE Training!"}</p>
        <p className="text-center text-xs text-neutral-500 mb-6">
          {esRecuperacion
              ? "Con esta vas a entrar de ahora en más."
              : "Elegí una contraseña para entrar a tu cuenta."}
        </p>

        <div className="space-y-3">
          <CampoPassword value={pass} onChange={(e) => setPass(e.target.value)}
            placeholder="Contraseña" autoComplete="new-password"
            className="w-full bg-neutral-800 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-sm" />
          <CampoPassword value={pass2} onChange={(e) => setPass2(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && guardar()}
            placeholder="Repetila" autoComplete="new-password"
            className="w-full bg-neutral-800 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-sm" />

          {error && <p className="text-red-400 text-xs">{error}</p>}

          <button onClick={guardar} disabled={cargando}
            className="w-full bg-sky-400 hover:bg-sky-200 disabled:opacity-50 text-black font-medium text-sm rounded-lg py-2.5 transition-colors">
            {cargando ? "Guardando..." : "Entrar"}
          </button>
        </div>
      </div>
    </div>
  );
};

// Pantalla de carga: lo que se ve entre que entrás y la app tiene
// todo listo. Son unos segundos, pero sin nada en pantalla parece
// que se colgó.
//
// La barra no mide el progreso real —no hay forma de saber cuánto
// falta— pero avanza a un ritmo que se corresponde con lo que suele
// tardar, y frena cerca del final en vez de quedarse en 100% esperando.
const PantallaCargando = () => {
  const [pct, setPct] = useState(8);

  useEffect(() => {
    const reloj = setInterval(() => {
      // Cuanto más cerca del final, más lento: si llegara a 100 y la
      // app no estuviera lista, la barra mentiría.
      setPct((p) => (p >= 92 ? p : p + Math.max(1, (92 - p) * 0.08)));
    }, 90);
    return () => clearInterval(reloj);
  }, []);

  return (
    <div className="min-h-screen bg-neutral-900 text-white flex items-center justify-center px-5"
      style={{ fontFamily: "'Inter', sans-serif" }}>
      <div className="w-full max-w-[220px] flex flex-col items-center">
        <div className="w-20 h-14 flex items-center justify-center mb-5 latido">
          <img src={LOGO_URI} alt="Be Training" className="h-full w-full object-contain" />
        </div>

        <div className="w-full h-1 bg-neutral-800 rounded-full overflow-hidden">
          <div className="h-full rounded-full"
            style={{ width: `${pct}%`, background: "#38bdf8",
                     transition: "width 260ms cubic-bezier(0.4, 0, 0.2, 1)" }} />
        </div>

        <p className="text-neutral-500 text-[11px] mt-3">Preparando todo…</p>
      </div>

      <style>{`
        @keyframes latidoLogo {
          0%, 100% { opacity: 0.75; transform: scale(1); }
          50%      { opacity: 1;    transform: scale(1.04); }
        }
        .latido { animation: latidoLogo 1.6s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) {
          .latido { animation: none; opacity: 1; }
        }
      `}</style>
    </div>
  );
};

const LoginScreen = ({ onLogin }) => {
  const [tab, setTab] = useState("coach");
  const [user, setUser] = useState(hayBackend ? mailRecordado() : "");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);
  // Viene tildado por defecto: es lo que quiere la mayoría. Quien use
  // un celular prestado lo destilda y la sesión muere con la pestaña.
  const [recordar, setRecordar] = useState(true);
  // El alumno crea su propia cuenta: el coach nunca maneja
  // contraseñas ajenas, que es como tiene que ser.
  const [modo, setModo] = useState("entrar");
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [codigo, setCodigo] = useState("");
  // Las veces por semana que entrena. Obligatorio: sin esto el ranking
  // lo mide contra todas sus sesiones pendientes acumuladas.
  const [meta, setMeta] = useState(null);
  const [aviso, setAviso] = useState("");

  const submit = async (e) => {
    if (e) e.preventDefault();
    if (!user || !pass) { setError("Completá los dos campos"); return; }
    setError(""); setAviso("");

    // Sin base configurada, la app sigue en modo demo.
    if (!hayBackend) { onLogin(tab, user); return; }

    if (modo === "crear") {
      if (!nombre.trim() || !apellido.trim()) { setError("Poné tu nombre y apellido"); return; }
      if (!codigo.trim()) { setError("Falta el código de invitación que te pasó Mati"); return; }
      if (!meta) { setError("Elegí cuántas veces por semana vas a entrenar"); return; }
      if (pass.length < 6) { setError("La contraseña necesita al menos 6 caracteres"); return; }
      setCargando(true);
      try {
        const r = await registrarse(user, pass, {
          nombre: nombre.trim(), apellido: apellido.trim(), codigo: codigo.trim(),
          meta: String(meta) });
        // Si el proyecto pide confirmar por mail, todavía no hay sesión.
        if (!r?.access_token) {
          setAviso("Cuenta creada. Revisá tu mail para confirmarla y después entrá.");
          setModo("entrar");
          return;
        }
        const perfil = await cargarPerfil();
        onLogin(perfil?.rol || "alumno",
                perfil ? `${perfil.nombre} ${perfil.apellido}`.trim() : user, perfil);
      } catch (err) {
        setError(
          err.message?.includes("CODIGO_INVALIDO") ? "El código de invitación no es correcto"
          : err.message?.includes("already registered") ? "Ese mail ya tiene una cuenta"
          : err.message?.includes("Password") ? "La contraseña es muy corta"
          : err.message?.includes("Database error") ? "El código de invitación no es correcto"
          : err.message || "No se pudo crear la cuenta"
        );
      } finally { setCargando(false); }
      return;
    }

    setCargando(true);
    try {
      await ingresar(user, pass, recordar);
      const perfil = await cargarPerfil();
      if (!perfil) throw new Error("Tu usuario no tiene perfil cargado. Avisale a Mati.");
      onLogin(perfil.rol, `${perfil.nombre} ${perfil.apellido}`.trim(), perfil);
    } catch (err) {
      setError(
        err.status === 400 ? "Mail o contraseña incorrectos"
        : err.message?.includes("Failed to fetch") ? "No hay conexión con el servidor"
        : err.message || "No se pudo entrar"
      );
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-900 text-white flex items-center justify-center px-5" style={{ fontFamily: "'Inter', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600&display=swap');
        .font-display { font-family: 'Space Grotesk', sans-serif; }

        /* Los campos de fecha y hora traen un ancho intrínseco del
           navegador que ignora el 100%, y en iPhone se salen de su
           tarjeta. Hay que forzarlos. */
        input[type="date"], input[type="time"], input[type="month"] {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          box-sizing: border-box;
          -webkit-appearance: none;
          appearance: none;
        }
        input[type="date"]::-webkit-date-and-time-value { text-align: left; }
        input[type="date"]::-webkit-calendar-picker-indicator { margin-left: auto; }

        /* Nada puede empujar la página a lo ancho. Un texto largo sin
           espacios, una tabla o una imagen grande dejaban la app
           corrida con una franja del fondo asomando al costado. */
        html, body { overflow-x: hidden; max-width: 100%; }
      `}</style>
      <div className="w-full max-w-xs">
        <div className="flex flex-col items-center mb-8">
          <div className="w-20 h-14 flex items-center justify-center mb-3">
            <img src={LOGO_URI} alt="Be Training" className="h-full w-full object-contain" />
          </div>
          <p className="text-neutral-500 text-xs mt-0.5">Entrená hoy, viví mejor mañana</p>
        </div>

        {!hayBackend && (
        <div className="flex bg-neutral-800 border border-neutral-700 rounded-xl p-1 mb-5">
          {[{ id: "coach", label: "Coach" }, { id: "alumno", label: "Be Trainer" }].map((t) => (
            <button key={t.id} onClick={() => setTab(t.id)}
              className={`flex-1 py-2 rounded-lg text-xs font-medium transition-colors ${tab === t.id ? "bg-sky-400 text-black" : "text-neutral-400"}`}>
              {t.label}
            </button>
          ))}
        </div>
        )}

        <div className="space-y-3">
          {hayBackend && modo === "crear" && (
            <div className="grid grid-cols-2 gap-2">
              <input value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Nombre"
                autoComplete="given-name"
                className="w-full bg-neutral-800 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-sm" />
              <input value={apellido} onChange={(e) => setApellido(e.target.value)} placeholder="Apellido"
                autoComplete="family-name"
                className="w-full bg-neutral-800 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-sm" />
            </div>
          )}
          {hayBackend && modo === "crear" && (
            <div>
              <input value={codigo} onChange={(e) => setCodigo(e.target.value.toUpperCase())}
                placeholder="Código de invitación" autoCapitalize="characters" autoComplete="off"
                className="w-full bg-neutral-800 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-sm tracking-widest" />
              <p className="text-[11px] text-neutral-600 mt-1.5">Te lo pasa Mati junto con el link.</p>
            </div>
          )}
          {/* Las veces por semana, obligatorio. Es contra lo que se
              mide el ranking: sin esto se medía contra todas las
              sesiones pendientes, y competía en desventaja. */}
          {hayBackend && modo === "crear" && (
            <div>
              <p className="text-[11px] text-neutral-400 mb-1.5">
                ¿Cuántas veces por semana vas a entrenar?
              </p>
              <div className="grid grid-cols-7 gap-1">
                {[1, 2, 3, 4, 5, 6, 7].map((n) => (
                  <button key={n} type="button" onClick={() => setMeta(n)}
                    className="rounded-lg py-2 text-sm font-semibold border transition-colors"
                    style={meta === n
                      ? { background: "#38bdf8", color: "#000", borderColor: "#38bdf8" }
                      : { color: "#a3a3a3", borderColor: "#404040", background: "#262626" }}>
                    {n}
                  </button>
                ))}
              </div>
              <p className="text-[11px] text-neutral-600 mt-1.5">
                Poné las que de verdad podés sostener: contra eso se mide tu puntaje.
              </p>
            </div>
          )}
          <div className="relative">
            <User size={14} className="absolute left-3 top-3 text-neutral-500" />
            <input value={user} onChange={(e) => setUser(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()}
              placeholder={hayBackend ? "Tu mail" : "Usuario"} type={hayBackend ? "email" : "text"}
              inputMode={hayBackend ? "email" : "text"} autoComplete="username"
              className="w-full bg-neutral-800 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg pl-9 pr-3 py-2.5 text-sm" />
          </div>
          <div className="relative">
            <CampoPassword value={pass} onChange={(e) => setPass(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && submit()}
              placeholder="Contraseña" autoComplete="current-password"
              icono={<KeyRound size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500 z-10" />}
              className="w-full bg-neutral-800 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg pl-9 py-2.5 text-sm" />
          </div>
          {hayBackend && modo === "entrar" && (
            <label className="flex items-center gap-2.5 cursor-pointer select-none py-1">
              <input type="checkbox" checked={recordar} onChange={(e) => setRecordar(e.target.checked)}
                className="w-4 h-4 rounded accent-sky-400 shrink-0" />
              <span className="text-xs text-neutral-400">Mantener la sesión iniciada</span>
            </label>
          )}
          {error && <p className="text-red-400 text-xs">{error}</p>}
          {aviso && <p className="text-emerald-400 text-xs">{aviso}</p>}
          <button onClick={submit} disabled={cargando}
            className="w-full bg-sky-400 hover:bg-sky-200 disabled:opacity-50 text-black font-medium text-sm rounded-lg py-2.5 transition-colors mt-2">
            {cargando ? (modo === "crear" ? "Creando..." : "Entrando...")
              : hayBackend ? (modo === "crear" ? "Crear mi cuenta" : "Ingresar")
              : `Ingresar como ${tab === "coach" ? "Coach" : "Be Trainer"}`}
          </button>
        </div>
        {/* Olvidé mi contraseña. Solo al entrar: en el registro no
            tiene sentido y sería una opción más para leer. */}
        {hayBackend && modo === "entrar" && (
          <p className="text-center mt-4">
            <button onClick={async () => {
                // El campo se llama "user", no "email".
                const mail = String(user || "").trim();
                if (!mail.includes("@")) {
                  setError("Escribí tu mail arriba y volvé a tocar acá");
                  return;
                }
                setError(""); setAviso("");
                try {
                  await pedirRecuperacion(mail);
                  setAviso("Te mandamos un mail con el link para cambiarla. Revisá el correo no deseado.");
                } catch (e) {
                  setError(e.message || "No se pudo enviar el mail");
                }
              }}
              className="text-neutral-500 hover:text-sky-400 text-[11px] underline transition-colors">
              Olvidé mi contraseña
            </button>
          </p>
        )}

        {hayBackend ? (
          <p className="text-center text-neutral-500 text-xs mt-5">
            {modo === "entrar" ? "¿Primera vez? " : "¿Ya tenés cuenta? "}
            <button onClick={() => { setModo(modo === "entrar" ? "crear" : "entrar"); setError(""); setAviso(""); }}
              className="text-sky-400 hover:text-sky-300 font-medium underline">
              {modo === "entrar" ? "Creá tu cuenta" : "Entrá acá"}
            </button>
          </p>
        ) : (
          <p className="text-center text-neutral-600 text-[11px] mt-5">Demo — cualquier usuario y contraseña funcionan</p>
        )}
      </div>
    </div>
  );
};

// ---------- Main App ----------


// Bloque de medios del ejercicio. Cumple tres roles según quién mire:
//  - coach armando: ve qué hay cargado y puede cargarlo ahí mismo
//  - alumno entrenando: ve el gif y el video de técnica del coach
//  - alumno + su propio video: lo carga para que el coach revise técnica
function BloqueMedios({ media, nombre, modo, onCargar, videoAlumno,
  onSubirVideo, onQuitarVideo, onDescargarVideo, onCapturarCuadro,
  subiendo = null, campoEjercicio, sinAviso = false }) {
  const [gifFallo, setGifFallo] = useState(false);
  const [gifGrande, setGifGrande] = useState(false);
  const tiene = !!(media.videoUrl || media.gifUrl);
  const esCoach = modo === "coach";

  return (
    <div className="space-y-2">
      {/* El gif va al costado y siempre visible: es la referencia rápida
          del movimiento mientras el alumno entrena, no algo que haya que
          abrir. object-contain para no recortar el ejercicio. */}
      {/* El nombre del ejercicio y el gif comparten la fila: el
          selector no necesita todo el ancho y así el gif queda
          pegado al ejercicio que ilustra. El video va debajo,
          a lo ancho, que es como se mira. */}
      <div className="flex gap-2.5 items-start">
        <div className="flex-1 min-w-0">{campoEjercicio}</div>

        {media.gifUrl && gifFallo && modo === "previa" && (
          <div className="w-[84px] h-[84px] rounded-lg border border-red-400/40 bg-red-400/5 shrink-0 flex flex-col items-center justify-center gap-1 p-1.5 text-center">
            <X size={14} className="text-red-400" />
            <span className="text-[8px] text-red-300 leading-tight">El gif no carga</span>
          </div>
        )}
        {media.gifUrl && !gifFallo && (
          <button onClick={() => setGifGrande(true)} title="Ampliar"
            className="w-[84px] h-[84px] rounded-lg overflow-hidden border border-neutral-600 bg-neutral-900 shrink-0 relative group">
            <img src={media.gifUrl} alt={nombre || "Ejercicio"}
              className="w-full h-full object-contain"
              onError={() => setGifFallo(true)} />
            <span className="absolute bottom-0.5 right-0.5 bg-black/60 rounded p-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
              <Maximize2 size={10} className="text-white" />
            </span>
          </button>
        )}
      </div>

      {media.videoUrl && <ReproductorVideo url={media.videoUrl} />}

      {modo === "previa" && !media.gifUrl && !media.videoUrl && (
        <p className="text-[10px] text-neutral-600 border border-dashed border-neutral-700 rounded-lg py-2 px-2.5">
          Este ejercicio no tiene gif ni video cargado.
        </p>
      )}

      {/* Ampliado, para mirar el detalle de la técnica. */}
      {gifGrande && media.gifUrl && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 modal-fondo"
          onClick={() => setGifGrande(false)}>
          <div className="max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center gap-2 mb-2">
              <span className="text-xs text-neutral-300 flex-1 leading-snug">{nombre}</span>
              <button onClick={() => setGifGrande(false)} className="p-1 text-neutral-400 hover:text-white">
                <X size={16} />
              </button>
            </div>
            <img src={media.gifUrl} alt={nombre || "Ejercicio"}
              className="w-full rounded-lg border border-neutral-700" />
          </div>
        </div>
      )}

      {esCoach && (
        <button onClick={onCargar} disabled={!nombre}
          className={`w-full flex items-center justify-center gap-1.5 text-[11px] font-medium rounded-lg py-2 border transition-colors ${
            !nombre ? "text-neutral-600 bg-neutral-800 border-neutral-700 cursor-not-allowed"
            : tiene ? "text-emerald-400 bg-emerald-400/10 border-emerald-400/20 hover:bg-emerald-400/20"
            : "text-sky-400 bg-neutral-700 border-sky-400/30 hover:bg-sky-400/10"}`}>
          {tiene ? <Check size={13} /> : <Video size={13} />}
          {!nombre ? "Elegí el ejercicio para cargar su video"
            : tiene ? "Video y gif cargados · editar"
            : "Cargar video y gif de este ejercicio"}
        </button>
      )}

      {!esCoach && !tiene && !sinAviso && (
        <p className="text-[11px] text-neutral-600 text-center py-1">
          Este ejercicio todavía no tiene video ni gif.
        </p>
      )}

      {modo === "alumno" && (
        subiendo !== null ? (
          <div className="bg-neutral-700/50 border border-neutral-600 rounded-lg p-3 space-y-2">
            <p className="text-[11px] text-neutral-300">
              {subiendo < 0.5 ? "Achicando el video…" : "Subiendo…"}
            </p>
            <div className="h-1.5 rounded-full bg-neutral-600 overflow-hidden">
              <div className="h-full bg-sky-400 transition-all duration-200"
                style={{ width: `${Math.round(subiendo * 100)}%` }} />
            </div>
            <p className="text-[10px] text-neutral-500">
              {subiendo < 0.5
                ? "Achicarlo tarda lo que dura el video. No cierres la app."
                : "Se achicó para que no te coma los datos."}
            </p>
          </div>
        ) : (
          <>
            {/* Directo desde la galería. Pedir un link a Drive o
                YouTube significaba, en la práctica, que nadie subía
                nada: es un trámite que no se hace entre serie y serie. */}
            {/* Dos botones y no uno: `capture` OBLIGA a grabar en el
                momento y no deja abrir la galería. El botón decía
                "Grabar o elegir" pero lo segundo nunca pasaba. */}
            {videoAlumno ? (
              <label className="w-full flex items-center justify-center gap-1.5 text-[11px] font-medium rounded-lg py-2 border cursor-pointer text-emerald-400 bg-emerald-400/10 border-emerald-400/20 transition-colors">
                <input type="file" accept="video/*" className="hidden"
                  onChange={(e) => {
                    const f = e.target.files?.[0];
                    e.target.value = "";
                    if (f && onSubirVideo) onSubirVideo(f);
                  }} />
                <Check size={13} /> Tu video cargado · cambiar
              </label>
            ) : (
              <div className="flex gap-1.5">
                <label className="flex-1 flex items-center justify-center gap-1.5 text-[11px] font-medium rounded-lg py-2 border cursor-pointer text-sky-400 bg-neutral-700 border-neutral-600 hover:border-sky-400/40 transition-colors">
                  <input type="file" accept="video/*" capture="environment" className="hidden"
                    onChange={(e) => {
                      const f = e.target.files?.[0];
                      e.target.value = "";
                      if (f && onSubirVideo) onSubirVideo(f);
                    }} />
                  <Video size={12} /> Grabar
                </label>
                <label className="flex-1 flex items-center justify-center gap-1.5 text-[11px] font-medium rounded-lg py-2 border cursor-pointer text-sky-400 bg-neutral-700 border-neutral-600 hover:border-sky-400/40 transition-colors">
                  <input type="file" accept="video/*" className="hidden"
                    onChange={(e) => {
                      const f = e.target.files?.[0];
                      e.target.value = "";
                      if (f && onSubirVideo) onSubirVideo(f);
                    }} />
                  <Upload size={12} /> De la galería
                </label>
              </div>
            )}
            {videoAlumno && onQuitarVideo && (
              <button onClick={onQuitarVideo}
                className="w-full text-[10px] text-neutral-500 hover:text-red-400 transition-colors">
                Quitar el video
              </button>
            )}
          </>
        )
      )}

      {videoAlumno && (
        <ReproductorVideo url={videoAlumno}
          etiqueta={esCoach ? "Video del alumno" : "Tu video"} acento="emerald"
          onDescargar={onDescargarVideo} onCapturar={onCapturarCuadro} />
      )}
    </div>
  );
}

export default function App() {
  useEffect(() => {
    let tag = document.querySelector('meta[name="viewport"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.name = "viewport";
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1");
  }, []);

  const [screen, setScreen] = useState("login");
  const [role, setRole] = useState(null);

  // ── Preferencias de la app ───────────────────────────────
  // Se guardan en el navegador: son de este dispositivo, no de la
  // cuenta. Alguien puede querer texto grande en el celular y
  // normal en la computadora.
  const CLAVE_PREFS = "be_preferencias";
  const [prefs, setPrefs] = useState(() => {
    try {
      const g = JSON.parse(localStorage.getItem(CLAVE_PREFS) || "{}");
      return { tema: "oscuro", sonido: true, vibracion: true, ...g,
               // Las versiones anteriores guardaban un nombre.
               // Se lleva al más cercano de los tres: quien venía con
               // 105% de la barra anterior no puede quedar sin ninguno
               // marcado, viendo tres botones apagados.
               escala: (() => {
                 const v = typeof g.escala === "number" ? g.escala
                   : ({ chico: 90, normal: 100, grande: 112, enorme: 125 })[g.texto] || 100;
                 return [90, 100, 118].reduce((a, b) =>
                   Math.abs(b - v) < Math.abs(a - v) ? b : a);
               })() };
    } catch {
      return { escala: 100, tema: "oscuro", sonido: true, vibracion: true };
    }
  });

  const cambiarPref = (campo, valor) => {
    setPrefs((prev) => {
      const next = { ...prev, [campo]: valor };
      try { localStorage.setItem(CLAVE_PREFS, JSON.stringify(next)); } catch { /* ignorar */ }
      // El cronómetro lee sus avisos de su propia clave.
      if (["sonido", "vibracion"].includes(campo)) {
        try {
          localStorage.setItem("be_avisos",
            JSON.stringify({ sonido: next.sonido, vibracion: next.vibracion }));
        } catch { /* ignorar */ }
      }
      return next;
    });
  };
  // Un alumno invitado llega con un token en la dirección.
  const [invitacion, setInvitacion] = useState(() => hayBackend ? tokenDeInvitacion() : null);

  // Dónde estaba el usuario antes de recargar. En el celular, tirar
  // para refrescar te devolvía al inicio y perdías el lugar: si
  // estabas en el medio de un entrenamiento, eso duele.
  const CLAVE_VISTA = "be_ultima_vista";
  const leerVistaGuardada = () => {
    try { return JSON.parse(sessionStorage.getItem(CLAVE_VISTA) || "null"); }
    catch { return null; }
  };

  // El perfil se guarda en el navegador para poder entrar de inmediato
  // al recargar, sin esperar a que responda el servidor. Después se
  // verifica contra la base y se corrige si cambió algo.
  const CLAVE_PERFIL = "be_perfil";
  const leerPerfilGuardado = () => {
    try { return JSON.parse(localStorage.getItem(CLAVE_PERFIL) || "null"); }
    catch { return null; }
  };
  const guardarPerfil = (p) => {
    try {
      if (p) localStorage.setItem(CLAVE_PERFIL, JSON.stringify(p));
      else localStorage.removeItem(CLAVE_PERFIL);
    } catch { /* ignorar */ }
  };
  // El coach puede mirar la app con los ojos de un alumno. No cambia
  // su rol real ni sus permisos en la base: es solo la vista.
  const [viendoComo, setViendoComo] = useState(null);
  const [userName, setUserName] = useState("");

  // Con la base conectada se arranca vacío: mezclar datos de ejemplo
  // con datos reales hace creer que hay algo cargado cuando no lo hay.
  const [semanasTodas, setWeeks] = useState(hayBackend ? [] : initialWeeks);
  // Mirando como el alumno, se ve lo mismo que ve él: las semanas
  // programadas a futuro todavía no existen para él. Antes el coach,
  // con el ojo, veía la semana nueva aunque el alumno todavía no.
  const weeks = viendoComo
    ? semanasTodas.filter((w) => !estaOculta(w.visibleDesde)) : semanasTodas;
  const [studentsList, setStudentsList] = useState(hayBackend ? [] : INITIAL_STUDENTS);
  const [view, setView] = useState("weeks");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [activeWeekId, setActiveWeekId] = useState(null);
  const [activeSessionId, setActiveSessionId] = useState(null);
  const [duplicateModal, setDuplicateModal] = useState(null);
  const [draftSession, setDraftSession] = useState(null);
  const [celebrationOpen, setCelebrationOpen] = useState(false);
  const [shareStep, setShareStep] = useState(false);
  // La foto del cierre. Antes esto era solo un estado que se ponía en
  // verdadero al tocar el botón: no abría la cámara ni guardaba nada.
  // Y encima bloqueaba el envío al grupo hasta tocarlo.
  const [selfieTaken, setSelfieTaken] = useState(false);
  const [fotoCierre, setFotoCierre] = useState(null);
  const [shareMessage, setShareMessage] = useState("");
  const [profile, setProfile] = useState({ name: "", photo: null, exp: 0 });
  const [passwordForm, setPasswordForm] = useState({ current: "", next: "", confirm: "" });
  const [badgeStatus, setBadgeStatus] = useState(() => Object.fromEntries(BADGES.map((b) => [b.id, b.unlocked ? "earned" : "locked"])));
  const [badgeRequests, setBadgeRequests] = useState([]);
  const [shareCount, setShareCount] = useState(0);
  const [sessionRewards, setSessionRewards] = useState({ points: 0, exp: 0, detalle: [], leveledUp: false, newLevel: null, newPRs: [] });
  const [personalRecords, setPersonalRecords] = useState({});
  const [prModalOpen, setPrModalOpen] = useState(false);
  const [prDraft, setPrDraft] = useState({ ejercicio: "", valor: "", tipo: "peso" });
  const [weekOrigin, setWeekOrigin] = useState("weeks");
  const [exerciseGroups, setExerciseGroups] = useState(INITIAL_EJERCICIOS_GROUPS);

  // ─────────── Conexión con la base ───────────
  // Estado visible de la sincronización: el usuario tiene que saber
  // si lo que ve está guardado o no. Un guardado silencioso que falla
  // es peor que no guardar.
  // Modo edición de la lista de Be Trainers: muestra el tacho de baja.
  const [editandoTrainers, setEditandoTrainers] = useState(false);
  const [inactivos, setInactivos] = useState([]);
  const [verInactivos, setVerInactivos] = useState(false);
  // Qué submenú del perfil está abierto. Uno por vez: abrir todos
  // devuelve el mismo problema de scroll que esto viene a resolver.
  const [menuPerfil, setMenuPerfil] = useState(null);

  // Datos personales. Género y sesiones semanales son los que el
  // coach necesita para planificar; el ciclo es opcional y privado.
  const [datosPersonales, setDatosPersonales] = useState({
    nombre: "", apellido: "", genero: "", fechaNacimiento: "", sesionesSemana: "",
    sigueCiclo: false, cicloUltimoPeriodo: "", cicloDuracion: "28",
  });
  const [guardandoDatos, setGuardandoDatos] = useState(false);
  // Datos del alumno que el coach tiene abierto: sesiones pactadas,
  // género, seguimiento de ciclo. Son los que necesita para planificar.
  const [datosDelAlumno, setDatosDelAlumno] = useState(null);


  // Lo que el alumno movió la última vez en cada ejercicio. Es la
  // referencia más honesta para prescribir: su historial real.
  const [cargasPrevias, setCargasPrevias] = useState({});

  // Subida de video: qué ejercicio y cuánto lleva.
  const [subiendoVideo, setSubiendoVideo] = useState({});

  // Editor de marcas: qué imagen se está marcando y qué hacer al
  // guardarla. El destino lo decide quien lo abre.
  const [marcando, setMarcando] = useState(null);
  // Foto de perfil a la espera de que se elija el recorte.
  const [recortando, setRecortando] = useState(null);

  // Bienvenida: se muestra una vez, la primera que entra.
  const [bienvenida, setBienvenida] = useState(false);

  useEffect(() => {
    if (screen !== "app" || role !== "alumno" || viendoComo) return;
    try {
      if (localStorage.getItem("be_bienvenida")) return;
      localStorage.setItem("be_bienvenida", "1");
      setBienvenida(true);
    } catch { /* ignorar */ }
  }, [screen, role, viendoComo]);

  // Descargar el video al teléfono. En iPhone la descarga directa no
  // existe: se abre el video y desde ahí se guarda con el botón de
  // compartir. En Android y computadora baja el archivo.
  const descargarVideo = async (src, nombre = "entrenamiento.mp4") => {
    try {
      const r = await fetch(src);
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = nombre;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 4000);
      showToast("✓ Video descargado");
    } catch {
      // Si el navegador no deja bajarlo, al menos se abre.
      window.open(src, "_blank");
      showToast("Se abrió el video — usá el botón de compartir para guardarlo");
    }
  };

  // Guarda la imagen marcada donde corresponda: el comentario del
  // alumno o la observación del coach.
  const guardarMarcada = async (blob) => {
    const { destino, indice, hilo, alGuardar } = marcando;
    setMarcando(null);
    const carpeta = marcando.carpeta || viendoComo?.id || selectedStudent?.id || profile?.id;
    if (!hayBackend || !carpeta) { showToast("✓ Imagen lista"); return; }

    try {
      const archivo = new File([blob], `marca-${Date.now()}.jpg`, { type: "image/jpeg" });
      const ruta = await subirFoto(carpeta, archivo);

      // Desde el planificador: quien la pidió sabe qué hacer con ella.
      if (alGuardar) {
        const ok = await alGuardar(ruta);
        if (ok !== false) showToast("✓ Foto enviada");
        return;
      }

      // Desde la conversación, la foto es un mensaje más del hilo.
      if (hilo) {
        await mandarMensaje(hilo, "", ruta);
        showToast("✓ Foto enviada");
        return;
      }

      const campo = destino === "coach" ? "notaCoachFoto" : "comentarioFoto";
      updateExercise(activeWeek.id, activeSession.id, indice, campo, ruta);
      showToast(destino === "coach"
        ? "✓ Imagen guardada en tu observación"
        : "✓ Imagen guardada en tu comentario");
    } catch (e) {
      setSincro({ cargando: false, guardando: false,
        error: e.message || "No se pudo guardar la imagen." });
    }
  };

  const subirVideoEjercicio = async (indice, archivo) => {
    const clave = `${activeSession?.id}-${indice}`;
    if (!archivo.type.startsWith("video/")) { showToast("Elegí un video"); return; }

    setSubiendoVideo((p) => ({ ...p, [clave]: 0 }));
    try {
      // Primero achicar, después subir. La barra va de 0 a 0.5
      // mientras comprime y de 0.5 a 1 mientras sube.
      const chico = await comprimirVideo(archivo,
        (x) => setSubiendoVideo((p) => ({ ...p, [clave]: x * 0.5 })));

      if (!hayBackend) {
        updateExercise(activeWeek.id, activeSession.id, indice, "videoAlumno",
                       URL.createObjectURL(chico));
        showToast("✓ Video cargado");
        return;
      }

      const ruta = await subirVideo(profile.id, chico,
        (x) => setSubiendoVideo((p) => ({ ...p, [clave]: 0.5 + x * 0.5 })));

      updateExercise(activeWeek.id, activeSession.id, indice, "videoAlumno", ruta);
      showToast("✓ Video subido — Mati lo va a poder ver");
    } catch (e) {
      setSincro({ cargando: false, guardando: false,
        error: e.message || "No se pudo subir el video. Probá de nuevo." });
    } finally {
      setSubiendoVideo((p) => { const n = { ...p }; delete n[clave]; return n; });
    }
  };

  // Notificaciones. Se generan solas en la base con disparadores, así
  // que existen aunque la persona no estuviera con la app abierta.
  const [notificaciones, setNotificaciones] = useState([]);
  const [panelNotif, setPanelNotif] = useState(false);
  const sinLeer = notificaciones.filter((n) => !n.leida).length;

  const refrescarNotificaciones = React.useCallback(async () => {
    if (!hayBackend) return;
    try { setNotificaciones(aLista(await cargarNotificaciones())); } catch { /* ignorar */ }
  }, []);

  useEffect(() => {
    if (screen !== "app") return;
    refrescarNotificaciones();
    // Se vuelve a mirar cada dos minutos: no hace falta más para algo
    // que se lee cuando uno abre la app.
    const id = setInterval(refrescarNotificaciones, 120000);
    return () => clearInterval(id);
  }, [screen, refrescarNotificaciones]);

  // El puesto en el ranking cambia cuando entrena OTRO, así que no
  // hay disparador: se compara al entrar contra el último visto.
  useEffect(() => {
    if (!hayBackend || screen !== "app" || role !== "alumno") return;
    miPuesto().then((puesto) => {
      if (!puesto) return;
      const previo = Number(localStorage.getItem("be_puesto") || 0);
      localStorage.setItem("be_puesto", String(puesto));
      if (previo && previo !== puesto) {
        setNotificaciones((prev) => [{
          id: `puesto-${Date.now()}`,
          tipo: "ranking",
          titulo: puesto < previo ? `¡Subiste al puesto ${puesto}!` : `Bajaste al puesto ${puesto}`,
          detalle: `Antes estabas ${previo}°`,
          vista: "ranking", leida: false, creado_en: new Date().toISOString(),
          local: true,
        }, ...prev]);
      }
    }).catch(() => {});
  }, [screen, role]);

  const abrirNotificacion = async (n) => {
    setPanelNotif(false);

    // Si apunta a un ejercicio, se abre la ventana con el mensaje y
    // desde ahí se entra. Antes solo cambiaba de pantalla y había que
    // buscar el ejercicio a mano.
    if (n.sesion_id) {
      setNovedadAbierta({
        clave: null,
        ejercicio: n.ejercicio_nombre || n.titulo,
        contexto: n.titulo,
        mensaje: n.detalle,
        deQuien: n.titulo?.endsWith("te respondió") ? "Coach" : "",
        destino: { semanaId: n.semana_id, sesionId: n.sesion_id,
                   ejercicioId: n.ejercicio_id, tipo: "comentario" },
      });
    } else if (n.vista) {
      setView(n.vista);
    }

    if (n.local || n.leida) return;
    setNotificaciones((prev) => prev.map((x) => x.id === n.id ? { ...x, leida: true } : x));
    if (hayBackend) marcarLeida(n.id).catch(() => {});
  };

  const leerTodas = async () => {
    setNotificaciones((prev) => prev.map((n) => ({ ...n, leida: true })));
    if (hayBackend) marcarTodasLeidas().catch(() => {});
  };

  // Series marcadas por ejercicio. Dura lo que dura la pestaña.
  // Las series marcadas y el plegado sobreviven al cierre de la app.
  //
  // Antes vivían en la pestaña: al volver al gimnasio después de
  // cerrar el navegador, los círculos y el reborde verde de lo ya
  // hecho desaparecían, y no había forma de saber por dónde ibas.
  const [seriesHechas, setSeriesHechas] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("be_series")
        || sessionStorage.getItem("be_series") || "{}");
    } catch { return {}; }
  });
  // Qué ejercicios están plegados. Vive en la pestaña, igual que los
  // círculos: es un apunte del momento, no un dato del entrenamiento.
  // Cómo prefiere entrenar el alumno: con el cronómetro de la app o
  // con la música marcando los tiempos. Es una preferencia suya, no
  // una decisión del coach.
  const [modoRitmo, setModoRitmo] = useState(() => {
    try { return localStorage.getItem("be_modo_ritmo") || "cronometro"; }
    catch { return "cronometro"; }
  });
  const cambiarModoRitmo = (m) => {
    setModoRitmo(m);
    try { localStorage.setItem("be_modo_ritmo", m); } catch { /* ignorar */ }
  };

  // El tema se avisa a los colores: sin esto, effortColor sigue
  // devolviendo los tonos de modo oscuro sobre fondo blanco.
  useEffect(() => { fijarTema(prefs.tema); }, [prefs.tema]);

  const [musicaDefault, setMusicaDefault] = useState("");
  useEffect(() => {
    if (!hayBackend || screen !== "app") return;
    cargarMusicaDefault().then(setMusicaDefault).catch(() => {});
  }, [screen]);

  const [plegados, setPlegados] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("be_plegados")
        || sessionStorage.getItem("be_plegados") || "{}");
    } catch { return {}; }
  });

  // Al cerrar una sesión se borran sus marcas: quedan pegadas a la
  // sesión, y si esa sesión ya está completa no hay nada que retomar.
  // Sin esto, el almacenamiento crece sin techo.
  const limpiarMarcas = React.useCallback((sesionId) => {
    const limpiar = (clave) => {
      try {
        const datos = JSON.parse(localStorage.getItem(clave) || "{}");
        let cambio = false;
        for (const k of Object.keys(datos)) {
          if (k.startsWith(`${sesionId}-`)) { delete datos[k]; cambio = true; }
        }
        if (cambio) localStorage.setItem(clave, JSON.stringify(datos));
        return datos;
      } catch { return null; }
    };
    const s1 = limpiar("be_series");
    const s2 = limpiar("be_plegados");
    if (s1) setSeriesHechas(s1);
    if (s2) setPlegados(s2);
  }, []);

  // Cómo ve el alumno la sesión: en tarjetas (todo a la vista) o en
  // lista (una línea por ejercicio; se abre el que va a hacer). Es una
  // preferencia de cada uno, en su teléfono.
  const [vistaSesion, setVistaSesion] = useState(() => {
    try { return localStorage.getItem("be_vista_sesion") === "lista" ? "lista" : "tarjetas"; }
    catch { return "tarjetas"; }
  });
  const cambiarVistaSesion = (v) => {
    setVistaSesion(v);
    setFilaLista(null);
    try { localStorage.setItem("be_vista_sesion", v); } catch { /* ignorar */ }
  };
  // En la lista, debajo de un ejercicio se abre su video o su
  // conversación: { i, que: "video" | "charla" }. Y el video de la
  // técnica, en una ventana.
  const [filaLista, setFilaLista] = useState(null);
  // En la lista, el ejercicio en el que se está escribiendo un peso
  // que no está en las opciones.
  const [pesoEscrito, setPesoEscrito] = useState(null);
  // El reloj flotante de la lista: { segundos, tipo, nombre, repetir }.
  const [relojLista, setRelojLista] = useState(null);
  const [tecnicaLista, setTecnicaLista] = useState(null);

  const plegar = (clave, valor) => {
    setPlegados((prev) => {
      const next = { ...prev, [clave]: valor };
      try { localStorage.setItem("be_plegados", JSON.stringify(next)); } catch { /* ignorar */ }
      return next;
    });
  };

  const marcarSeries = (clave, cuantas, total) => {
    setSeriesHechas((prev) => {
      const next = { ...prev, [clave]: cuantas };
      try { localStorage.setItem("be_series", JSON.stringify(next)); } catch { /* ignorar */ }
      return next;
    });
    // Al completar todas, la tarjeta se pliega sola: el ejercicio ya
    // está hecho y lo único que hace es tapar el que viene. Se espera
    // a que termine la animación de los círculos.
    if (total && cuantas >= total) setTimeout(() => plegar(clave, true), 700);
    else if (plegados[clave]) plegar(clave, false);
  };
  const abrirMenu = (id) => setMenuPerfil((prev) => (prev === id ? null : id));

  // Se piden al abrir el submenú, no al entrar: casi nunca se tocan.
  useEffect(() => {
    // Al previsualizar se cargan los datos del alumno que se mira,
    // no los del coach: si no, el coach vería los suyos en la pantalla
    // de otro y podría pisárselos sin darse cuenta.
    const idDatos = viendoComo?.id || profile?.id;
    const nombreDatos = viendoComo?.name || profile?.name;
    if (!hayBackend || menuPerfil !== "datos" || !idDatos) return;

    // Se limpia primero. Sin esto, al pasar de un alumno a otro
    // quedaban a la vista los datos del anterior —incluido el ciclo
    // tildado— hasta que llegara la respuesta.
    setDatosPersonales({
      nombre: "", apellido: "", genero: "", fechaNacimiento: "",
      sesionesSemana: "", sigueCiclo: false,
      cicloUltimoPeriodo: "", cicloDuracion: "28",
    });

    cargarDatosPrivados(idDatos).then((d) => {
      const [n, ...ape] = (nombreDatos || "").split(" ");
      setDatosPersonales({
        nombre: n || "", apellido: ape.join(" "),
        genero: d?.genero || "",
        fechaNacimiento: d?.fecha_nacimiento || "",
        sesionesSemana: d?.sesiones_semana ? String(d.sesiones_semana) : "",
        sigueCiclo: !!d?.sigue_ciclo,
        cicloUltimoPeriodo: d?.ciclo_ultimo_periodo || "",
        cicloDuracion: d?.ciclo_duracion ? String(d.ciclo_duracion) : "28",
      });
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuPerfil, profile?.id, viendoComo?.id]);

  // El cambio de sesiones semanales va por su propio camino: es el
  // denominador del torneo, así que lo aprueba el coach.
  const cambiarSesionesSemana = async (n) => {
    const antes = datosPersonales.sesionesSemana;
    setDatosPersonales((p) => ({ ...p, sesionesSemana: String(n) }));
    if (!hayBackend || viendoComo) return;

    try {
      const r = await pedirCambioMeta(n);
      if (r?.aprobacion) {
        // Se revierte en pantalla: todavía no rige.
        setDatosPersonales((p) => ({ ...p, sesionesSemana: antes }));
        showToast("Le pedí a Mati que apruebe el cambio. Te aviso cuando responda.");
      } else if (!r?.sin_cambio) {
        showToast("✓ Listo, quedaron " + n + " sesiones por semana");
      }
    } catch (e) {
      setDatosPersonales((p) => ({ ...p, sesionesSemana: antes }));
      setSincro({ cargando: false, guardando: false,
        error: e.message || "No se pudo cambiar. Probá de nuevo." });
    }
  };

  const guardarDatosPersonales = async () => {
    const d = datosPersonales;
    const destino = viendoComo?.id || profile?.id;
    if (!d.nombre.trim() || !d.apellido.trim()) { showToast("Poné nombre y apellido"); return; }
    if (!hayBackend) { showToast("✓ Datos guardados"); return; }
    setGuardandoDatos(true);
    try {
      // El nombre solo se cambia el propio: la base no deja que un
      // usuario reescriba el nombre de otro, y está bien que así sea.
      const perfil = viendoComo ? true : await guardarNombre(d.nombre.trim(), d.apellido.trim());
      const filas = await guardarDatosPrivados(destino, d);

      // Si la base no devuelve nada, no guardó: hay que decirlo en vez
      // de mostrar un tilde verde sobre algo que no pasó.
      if (!perfil || !filas?.length) {
        throw new Error("La base no confirmó el guardado");
      }

      if (!viendoComo) setProfile((p) => ({ ...p, name: `${d.nombre.trim()} ${d.apellido.trim()}` }));
      else { setDatosDelAlumno(null); refrescarAlumnos(); }
      showToast("✓ Datos guardados");
    } catch (e) {
      setSincro({ cargando: false, guardando: false,
        error: e.message?.includes("confirmó")
          ? "No se guardaron tus datos. Probá de nuevo."
          : (e.message || "No se pudieron guardar tus datos.") });
    } finally { setGuardandoDatos(false); }
  };

  const [sincro, setSincro] = useState({ cargando: false, guardando: false, error: null });

  // Actividad real de la semana, para la grilla de días del inicio.
  const [actividad, setActividad] = useState(null);

  // Catálogo de insignias de la base. La app las identifica por
  // código ("b1"), la base por id: acá se traduce entre los dos.
  const [insigniasDB, setInsigniasDB] = useState({ catalogo: [], otorgadas: [] });

  // Las insignias que se dibujan: las de la base si hay, y si no la
  // lista del código. Sin esto, una insignia creada desde la app no
  // aparecía en ningún lado: la pantalla del alumno leía solo la
  // lista fija.
  const BADGES_VIVAS = React.useMemo(() => {
    const cat = Array.isArray(insigniasDB?.catalogo) ? insigniasDB.catalogo : [];
    const dela = cat.filter((i) => i && i.activa !== false && i.codigo);
    if (!dela.length) return BADGES;
    return dela.map((i) => {
      // La lista FIJA, no la que se está armando: usar BADGES_VIVAS
      // acá la haría referirse a sí misma antes de existir.
      const fija = BADGES.find((b) => b.id === i.codigo);
      return {
        id: i.codigo,
        insigniaId: i.id,
        name: i.nombre,
        desc: i.descripcion || "",
        color: i.color || "#38bdf8",
        imagen: i.imagen_url || "",
        // El ícono de la lista fija se conserva como respaldo para
        // las que no tienen imagen propia. Nunca nulo: React.createElement
        // con nulo tumba la pantalla entera.
        icon: esIcono(fija?.icon) ? fija.icon : Award,
        unlocked: true,
      };
    });
  }, [insigniasDB.catalogo]);
  // Qué condiciones cumplió el alumno, según la base.
  const [logradas, setLogradas] = useState({});
  const [propuestas, setPropuestas] = useState([]);
  const [propuestaDraft, setPropuestaDraft] = useState({ nombre: "", descripcion: "" });
  const [proponerAbierto, setProponerAbierto] = useState(false);
  // Aviso de insignias recién desbloqueadas, para que el alumno se
  // entere sin tener que revisar la pantalla de insignias.
  const [avisoInsignias, setAvisoInsignias] = useState([]);

  // Código de invitación: sin él nadie puede registrarse.
  const [codigoInv, setCodigoInv] = useState(null);
  const [editandoCodigo, setEditandoCodigo] = useState(false);
  const [codigoDraft, setCodigoDraft] = useState("");

  // Catálogo de ejercicios: se pide una vez al entrar.
  useEffect(() => {
    if (!hayBackend || screen !== "app") return;
    let vivo = true;
    (async () => {
      try {
        const { grupos, medios } = await cargarEjercicios();
        if (!vivo) return;
        if (grupos.length) setExerciseGroups(grupos);
        setExerciseMedia(medios);
      } catch (e) {
        if (vivo) setSincro((x) => ({ ...x, error: "No se pudo cargar la biblioteca" }));
      }
    })();
    return () => { vivo = false; };
  }, [screen]);

  // Alumnos y ranking: solo el coach los necesita completos.
  useEffect(() => {
    if (!hayBackend || screen !== "app") return;
    let vivo = true;
    (async () => {
      try {
        const lista = role === "coach" ? await cargarAlumnos() : await cargarRanking();
        // Solo si es una lista de verdad: guardar un error acá lo
        // hace reventar después al dibujar el ranking, lejos de
        // donde estuvo el problema.
        if (vivo) {
          setStudentsList(Array.isArray(lista) ? lista : []);
          setAlumnosCargados(true);
        }
        // También la necesita el alumno: en su calendario ve qué
        // compañeros entrenaron cada día.
        if (vivo) cargarActividadSemana().then((a) => vivo && setActividad(a)).catch(() => {});
      } catch (e) {
        if (vivo) setSincro((x) => ({ ...x, error: "No se pudo cargar la lista" }));
      }
    })();
    return () => { vivo = false; };
  }, [screen, role]);

  // Semanas del alumno que se esté mirando (el coach elige, el
  // alumno siempre es él mismo).
  // La semana en curso, explícita: antes se tomaba la última de la
  // lista y eso dependía de cómo viniera ordenada.
  const semanaActual = React.useMemo(
    () => (weeks.length ? weeks[weeks.length - 1] : null), [weeks]);

  // Una sesión empezada y sin cerrar: tiene algo cargado pero no está
  // completada. Es el caso de quien entrena, se va del gimnasio, y
  // vuelve a la app sin acordarse de en cuál estaba.
  const sesionEnCurso = React.useMemo(() => {
    for (let i = weeks.length - 1; i >= 0; i--) {
      const w = weeks[i];
      for (const se of w.sessions) {
        if (se.estado === "Completado") continue;
        const conDatos = se.exercises.filter(ejercicioRegistrado).length;
        if (conDatos > 0) {
          return { semana: w, sesion: se, hechos: conDatos,
                   total: se.exercises.filter((e) => e.ejercicio).length };
        }
      }
    }
    return null;
  }, [weeks]);

  const alumnoMirado = viendoComo ? viendoComo.id
    : role === "coach" ? selectedStudent?.id : profile?.id;
  useEffect(() => {
    if (!hayBackend || screen !== "app" || !alumnoMirado) {
      setWeeks([]);
      // El coach entra sin ningún alumno elegido: no hay semanas que
      // esperar, y si no se marca acá la barra de carga no termina.
      setSemanasCargadas(true);
      return;
    }
    let vivo = true;
    setSincro((x) => ({ ...x, cargando: true, error: null }));
    (async () => {
      try {
        const w = await cargarSemanas(alumnoMirado);
        if (vivo) { setWeeks(aLista(w)); setSemanasCargadas(true); }
      } catch (e) {
        if (vivo) {
          setSincro((x) => ({ ...x, error: "No se pudieron cargar las semanas de este alumno" }));
          setSemanasCargadas(true);
        }
      } finally {
        if (vivo) setSincro((x) => ({ ...x, cargando: false }));
      }
    })();
    return () => { vivo = false; };
  }, [screen, alumnoMirado]);

  const [exerciseMedia, setExerciseMedia] = useState(INITIAL_EXERCISE_MEDIA);
  const [newExerciseModalOpen, setNewExerciseModalOpen] = useState(false);
  const [newExerciseDraft, setNewExerciseDraft] = useState({ name: "", category: "", videoUrl: "", gifUrl: "", editando: null });
  const [pendingPRs, setPendingPRs] = useState({});
  const [prRequests, setPrRequests] = useState([]);
  const [achievementPopup, setAchievementPopup] = useState(null);
  const [addSessionChoiceOpen, setAddSessionChoiceOpen] = useState(false);
  const [libraryPickerOpen, setLibraryPickerOpen] = useState(false);
  const [weekActionChoiceOpen, setWeekActionChoiceOpen] = useState(null);
  const [emptyWeekModalOpen, setEmptyWeekModalOpen] = useState(false);
  const [newTrainerModalOpen, setNewTrainerModalOpen] = useState(false);
  const [trainerSearch, setTrainerSearch] = useState("");
  const [ordenTrainers, setOrdenTrainers] = useState("alfabetico");
  const [newTrainerDraft, setNewTrainerDraft] = useState({ nombre: "", apellido: "", genero: "", ciclo: false, sesiones: "3" });
  const [cycleData, setCycleData] = useState({ lastPeriod: "", cycleLength: "28" });
  const [toast, setToast] = useState("");
  const [customFields, setCustomFields] = useState({});
  const [collapsedMonths, setCollapsedMonths] = useState({});
  const [bannerDismissed, setBannerDismissed] = useState(false);
  const [dragSessionId, setDragSessionId] = useState(null);
  const [dragPos, setDragPos] = useState({ x: 0, y: 0 });
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [hoverDay, setHoverDay] = useState(null);
  const [expandedDay, setExpandedDay] = useState(null);
  const [expandedLibCategories, setExpandedLibCategories] = useState({});
  const [assignModal, setAssignModal] = useState(null);
  // Con base conectada se arranca vacío y se llena desde la base:
  // mezclar las plantillas de ejemplo con las reales haría creer que
  // hay sesiones armadas que no existen.
  const [libraryCategories, setLibraryCategories] = useState(
    hayBackend ? [] : INITIAL_LIBRARY_CATEGORIES);

  const refrescarLibreria = React.useCallback(async () => {
    if (!hayBackend) return;
    try { setLibraryCategories(aLista(await cargarLibreria())); } catch { /* ignorar */ }
  }, []);

  useEffect(() => {
    if (screen === "app" && role === "coach") refrescarLibreria();
  }, [screen, role, refrescarLibreria]);

  useEffect(() => {
    if (!hayBackend || screen !== "app" || !alumnoMirado) { setCargasPrevias({}); return; }
    ultimasCargas(alumnoMirado).then(setCargasPrevias).catch(() => {});
  }, [screen, alumnoMirado]);
  const [draftTemplate, setDraftTemplate] = useState(null);
  const [folderModalOpen, setFolderModalOpen] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [newFolderMetric, setNewFolderMetric] = useState("RIR");
  const [dragTemplate, setDragTemplate] = useState(null);
  const [dragTemplatePos, setDragTemplatePos] = useState({ x: 0, y: 0 });
  const [dragTemplateStart, setDragTemplateStart] = useState({ x: 0, y: 0 });
  const [hoverCategory, setHoverCategory] = useState(null);

  const rolVista = viendoComo ? "alumno" : role;
  // Al previsualizar se muestran los datos del alumno, no los del coach.
  // Al previsualizar se muestran los datos del alumno, no los del
  // coach: si no, la pantalla dice "Nivel 1" con la foto de Mati.
  const perfilVista = viendoComo
    ? { name: viendoComo.name, photo: viendoComo.photo, exp: viendoComo.exp || 0, id: viendoComo.id }
    : profile;
  const isCoach = rolVista === "coach";

  // Las pestañas de navegación. Una sola definición para las dos
  // barras: la de abajo en el celular y la lateral en la computadora.
  const pestañas = React.useMemo(() => (rolVista === "coach"
    ? [{ id: "inicio", label: "Inicio", icon: Home, active: ["inicio"] },
       { id: "alumnos", label: "Be Trainers", icon: Users, active: ["alumnos", "weeks", "week", "session", "newSession"] },
       { id: "libreria", label: "Librería", icon: Library, active: ["libreria", "newTemplate"] },
       // Insignias y récords: hasta ahora solo se llegaba desde el
       // recuadro "Te esperan" del inicio, y solo si había algo
       // pendiente. Sin pendientes no había forma de entrar a mirar
       // qué insignias existen ni quién tiene cuáles.
       { id: "solicitudes", label: "Insignias", icon: Award, active: ["solicitudes", "insignias"] },
       { id: "ranking", label: "Ranking", icon: Trophy, active: ["ranking"] },
       { id: "biomecanica", label: "Biomecánica", corto: "Biomec.", icon: Activity, active: ["biomecanica"] },
       { id: "perfil", label: "Perfil", icon: User, active: ["perfil"] }]
    : [{ id: "inicio", label: "Inicio", icon: Home, active: ["inicio"] },
       { id: "weeks", label: "Entrenos", icon: Dumbbell, active: ["weeks", "week", "session"] },
       { id: "ranking", label: "Ranking", icon: Trophy, active: ["ranking"] },
       { id: "insignias", label: "Insignias", icon: Award, active: ["insignias"] },
       { id: "biomecanica", label: "Biomecánica", corto: "Biomec.", icon: Activity, active: ["biomecanica"] },
       { id: "perfil", label: "Perfil", icon: User, active: ["perfil", "historial"] }]
  ), [rolVista]);


  const isAlumno = rolVista === "alumno";
  // El zoom va en el documento, NO en este div.
  //
  // Un elemento con zoom se vuelve el marco de referencia de todo lo
  // que tiene fijo adentro: la barra de abajo se pegaba al final de
  // ESE div —más alto que la pantalla por el propio zoom— y al
  // desplazar quedaba flotando a media altura.
  //
  // Aplicado al documento, lo fijo sigue midiéndose contra la
  // pantalla y la barra se queda donde tiene que estar.
  useEffect(() => {
    const raiz = document.documentElement;
    raiz.style.zoom = prefs.escala !== 100 ? `${prefs.escala}%` : "";
    return () => { raiz.style.zoom = ""; };
  }, [prefs.escala]);

  // La "i" de información solo para el alumno —o para el coach cuando
  // mira como él—. Se fija acá, antes de que se dibujen las tarjetas.
  ayudaVisible = isAlumno;

  const activeWeek = weeks.find((w) => w.id === activeWeekId);
  const activeSession = activeWeek?.sessions.find((s) => s.id === activeSessionId);

  // Armar una sesión de la librería usa la MISMA pantalla que editar la
  // sesión de un alumno. Antes eran dos editores distintos, con otro
  // aspecto y otras opciones. La plantilla se dibuja como una sesión
  // más, con id "plantilla"; lo que se cambia va a la plantilla en
  // borrador y se guarda recién con el botón de abajo.
  const enPlantilla = view === "newTemplate" && !!draftTemplate;
  const sesionEnPantalla = enPlantilla
    ? { id: "plantilla", name: draftTemplate.name, estado: "Pendiente",
        exercises: draftTemplate.exercises, hasTimer: !!draftTemplate.hasTimer,
        timerConfig: draftTemplate.timerConfig || DEFAULT_TIMER_CONFIG }
    : activeSession;
  const semanaEnPantalla = enPlantilla
    ? { id: "plantilla", sessions: [sesionEnPantalla] }
    : activeWeek;
  // Cada plantilla arranca con sus tarjetas y secciones abiertas: lo
  // plegado de la anterior no tiene que ver con esta.
  useEffect(() => { if (view === "newTemplate") limpiarMarcas("plantilla"); }, [view, limpiarMarcas]);

  // Un aviso nuevo cancelaba el reloj del anterior, así que dos
  // seguidos hacían que el segundo durara lo que le quedaba al
  // primero. Al mover un entrenamiento de día salían dos casi juntos
  // y el último se veía un instante.
  const relojToast = React.useRef(null);
  // Dos segundos. Al centro de la pantalla tapa contenido, así que
  // tiene que irse rápido; el que quiera leerlo de nuevo repite la
  // acción, y el que quiera sacarlo antes tiene la cruz.
  const showToast = (msg, ms = 2000) => {
    setToast(msg);
    clearTimeout(relojToast.current);
    relojToast.current = setTimeout(() => setToast(""), ms);
  };
  const toggleCustom = (key) => setCustomFields((prev) => ({ ...prev, [key]: !prev[key] }));

  const handleLogin = (r, u, perfilReal = null) => {
    setRole(r); setUserName(u); setScreen("app");
    setProfile(perfilReal
      ? { name: `${perfilReal.nombre} ${perfilReal.apellido}`.trim(),
          photo: perfilReal.foto_url, exp: perfilReal.exp || 0, id: perfilReal.id,
            // Sin esto el panel de coaches no aparecía nunca: el
            // perfil se arma campo por campo y este quedaba afuera.
            admin: !!perfilReal.admin }
      : { name: u || (r === "coach" ? "Coach" : "Be Trainer"), photo: null, exp: r === "alumno" ? 340 : 0 });
    if (perfilReal) guardarPerfil(perfilReal);
    setSelectedStudent(r === "coach" ? null : studentsList[0]);
    setBannerDismissed(false);
    setView("inicio");
  };

  const handleLogout = () => {
    try { sessionStorage.removeItem(CLAVE_VISTA); } catch { /* ignorar */ }
    guardarPerfil(null);
    restaurado.current = false;
    salir(); setViendoComo(null); setScreen("login"); setRole(null); setView("weeks"); setSelectedStudent(null); setActiveWeekId(null); setActiveSessionId(null); };

  const guardarNombreSemana = async () => {
    const { id, name, period } = editandoSemana;
    if (!name.trim()) { showToast("Poné un nombre para la semana"); return; }
    const nombre = name.trim(), periodo = (period || "").trim();

    setWeeks((prev) => prev.map((w) => w.id !== id ? w : { ...w, name: nombre, period: periodo }));
    setEditandoSemana(null);
    if (!hayBackend) { showToast("✓ Semana actualizada"); return; }

    const fila = await persistir(() => renombrarSemana(id, nombre, periodo),
                                 "No se pudo cambiar el nombre.");
    if (fila) showToast("✓ Semana actualizada");
    else if (alumnoMirado) cargarSemanas(alumnoMirado).then(setWeeks).catch(() => {});
  };

  // Agregar un ejercicio a una sesión ya asignada. Corregir un olvido
  // sin tener que rehacer la sesión entera y volver a mandarla.
  const sumarEjercicioASesion = async (seccion = "principal", bloque = null) => {
    if (enPlantilla) {
      const nuevo = seedExercise({
        seccion, finalizador: seccion === "finalizador", bloque: bloque || "",
        ...(seccion === "movilidad" ? { series: "", reps: "30", modo: "tiempo", rirConsigna: "" } : {}),
      });
      setDraftTemplate((prev) => {
        // Entra al final de su sección (y de su bloque, si tiene).
        const lista = [...prev.exercises];
        const mio = PESO_SECCION[seccion] || 3;
        let corte = lista.length;
        for (let k = 0; k < lista.length; k++) {
          if ((PESO_SECCION[seccionDe(lista[k])] || 3) > mio) { corte = k; break; }
        }
        if (bloque) {
          for (let k = lista.length - 1; k >= 0; k--) {
            if (seccionDe(lista[k]) === seccion && (lista[k].bloque || "") === bloque) { corte = k + 1; break; }
          }
        }
        lista.splice(corte, 0, nuevo);
        return { ...prev, exercises: lista };
      });
      return;
    }
    if (!activeSession) return;
    // La columna vieja se mantiene al día por si algo la sigue leyendo.
    const finalizador = seccion === "finalizador";
      // La movilidad no lleva series: se hace el tiempo y listo. Sin
    // esto nacía con 4, que el coach nunca puso y no se ven en la
    // tarjeta, pero quedaban guardadas igual.
    const nuevo = seedExercise({
      seccion, finalizador, bloque: bloque || "",
      ...(seccion === "movilidad"
        ? { series: "", reps: "30", modo: "tiempo", rirConsigna: "" }
        : {}),
    });

    if (!hayBackend) {
      setWeeks((prev) => prev.map((w) => w.id !== activeWeek.id ? w : {
        ...w, sessions: w.sessions.map((s) => s.id !== activeSession.id ? s
          : { ...s, exercises: [...s.exercises, nuevo] }) }));
      return;
    }
    // El motivo va en el cartel, no solo en la consola: en el celular
    // no hay forma de abrirla, y sin el motivo no se sabe si falta una
    // migración, si es permisos o si es la red.
    const id = await persistir(
      () => agregarEjercicioSesion(activeSession.id, {
              seccion, finalizador, bloque,
              modo: seccion === "movilidad" ? "tiempo" : "reps",
              metric: "RIR",
              ...(seccion === "movilidad" ? { reps: "30" } : {}),
            }),
      "No se pudo agregar el ejercicio.", true);
    if (!id) return;
    setWeeks((prev) => prev.map((w) => w.id !== activeWeek.id ? w : {
      ...w, sessions: w.sessions.map((s) => s.id !== activeSession.id ? s
        : { ...s, exercises: [...s.exercises, { ...nuevo, id }] }) }));
    showToast(`✓ Sumado a ${(SECCIONES.find((x) => x.id === seccion)?.nombre || "la sesión").toLowerCase()}`);
  };

  const sacarEjercicioDeSesion = async (indice) => {
    if (enPlantilla) { setConfirmar(null); removeDraftTemplateExercise(indice); return; }
    const ej = activeSession?.exercises?.[indice];
    if (!ej) return;
    setConfirmar(null);
    setWeeks((prev) => prev.map((w) => w.id !== activeWeek.id ? w : {
      ...w, sessions: w.sessions.map((s) => s.id !== activeSession.id ? s
        : { ...s, exercises: s.exercises.filter((_, k) => k !== indice) }) }));
    if (!hayBackend || !ej.id) return;
    const ok = await persistir(() => quitarEjercicioSesion(ej.id),
                               "No se pudo quitar el ejercicio.");
    if (ok) showToast("Ejercicio quitado");
    else if (alumnoMirado) cargarSemanas(alumnoMirado).then(setWeeks).catch(() => {});
  };

  // Duplicar una sesión ya asignada, dentro de la misma semana.
  //
  // Dos formas, porque hay dos usos distintos:
  //
  //   "igual"     → la misma sesión otra vez. Alguien que hace el
  //                 mismo entrenamiento dos veces por semana necesita
  //                 los pesos y las repeticiones ya puestos.
  //   "vacia"     → solo la estructura: los ejercicios y su orden,
  //                 con la prescripción en blanco para completarla.
  //
  // En ninguna de las dos se copia lo que cargó el alumno: su
  // registro es suyo, y una copia que aparezca completada falsearía
  // lo que hizo.
  const [duplicandoSesion, setDuplicandoSesion] = useState(null);

  const duplicarSesion = async (semana, sesion, modo = "igual", nombre = "") => {
    setDuplicandoSesion(null);
    const igual = modo === "igual";

    const copia = {
      id: `session-${Date.now()}`,
      name: nombre.trim() || `${sesion.name} (copia)`,
      estado: "Pendiente",
      borgRPE: null, fuerzaPercibida: null, puntaje: null, carga: null,
      day: null,
      hasTimer: !!sesion.hasTimer,
      timerConfig: sesion.timerConfig || DEFAULT_TIMER_CONFIG,
      musicaUrl: sesion.musicaUrl || "",
      exercises: sesion.exercises.map((ex) => ({
        ...ex,
        id: undefined,
        // Lo que prescribiste: se conserva o se vacía según el modo.
        series: igual ? ex.series : "",
        reps: igual ? ex.reps : "",
        rirConsigna: igual ? ex.rirConsigna : "",
        pesoSugerido: igual ? ex.pesoSugerido : "",
        descanso: igual ? ex.descanso : "",
        tecnica: igual ? ex.tecnica : "normal",
        tecnicaConfig: igual && ex.tecnicaConfig ? { ...ex.tecnicaConfig } : null,

        // El registro del alumno nunca se copia.
        pesoUsado: "", rirTuyo: "", comentarios: "", comentarioFoto: "",
        videoAlumno: "", resultadoSeries: null,
        // Lo que movió pasa a ser su referencia previa.
        pesoPrevia: ex.pesoUsado || ex.pesoPrevia || "",
        rirPrevia: ex.rirTuyo || ex.rirPrevia || "",
      })),
    };

    setWeeks((prev) => prev.map((w) => w.id !== semana.id ? w
      : { ...w, sessions: [...w.sessions, copia] }));

    if (!hayBackend) { showToast(`✓ "${copia.name}" creada`); return; }

    const ok = await persistir(async () => {
      await crearSesion(semana.id, copia);
      if (alumnoMirado) setWeeks(aLista(await cargarSemanas(alumnoMirado)));
      return true;
    }, "No se pudo duplicar la sesión.");
    if (ok) {
      showToast(igual ? `✓ "${copia.name}" lista para entrenar`
                      : `✓ "${copia.name}" creada — completale la prescripción`);
    }
  };

  // Borrar una semana entera, con todas sus sesiones. Hacía falta:
  // se podían crear pero no sacar, y una semana agregada por error
  // quedaba ahí para siempre, aunque se le vaciaran las sesiones.
  const eliminarSemana = async (semana) => {
    setConfirmar(null);
    setWeeks((prev) => prev.filter((w) => w.id !== semana.id));
    if (activeWeekId === semana.id) { setActiveWeekId(null); setView("weeks"); }
    if (!hayBackend) { showToast(`"${semana.name}" eliminada`); return; }
    const ok = await persistir(() => borrarSemanaEnBase(semana.id),
                               "No se pudo eliminar la semana.");
    if (ok) { refrescarAlumnos(); showToast(`"${semana.name}" eliminada`); }
    else if (alumnoMirado) cargarSemanas(alumnoMirado).then(setWeeks).catch(() => {});
  };

  // Borrar una sesión. Se lleva sus ejercicios y el registro que el
  // alumno haya hecho, así que siempre pide confirmación.
  const eliminarSesion = async (sesion) => {
    setConfirmar(null);
    setWeeks((prev) => prev.map((w) => w.id !== activeWeek?.id ? w
      : { ...w, sessions: w.sessions.filter((x) => x.id !== sesion.id) }));
    if (!hayBackend) { showToast(`"${sesion.name}" eliminada`); return; }
    const ok = await persistir(() => borrarSesionEnBase(sesion.id),
                               "No se pudo eliminar la sesión.");
    if (ok) { refrescarAlumnos(); showToast(`"${sesion.name}" eliminada`); }
    else if (alumnoMirado) cargarSemanas(alumnoMirado).then(setWeeks).catch(() => {});
  };

  const openStudent = (student) => {
    setSelectedStudent(student);
    setDatosDelAlumno(null);
    if (hayBackend) cargarDatosPrivados(student.id).then(setDatosDelAlumno).catch(() => {});
    setView("weeks");
  };


  const createTrainer = async () => {
    const { nombre, apellido, email } = newTrainerDraft;
    if (!nombre.trim() || !apellido.trim()) { showToast("Completá nombre y apellido"); return; }

    if (!hayBackend) {
      const fullName = `${nombre.trim()} ${apellido.trim()}`;
      setStudentsList((prev) => [...prev, {
        id: `st-${Date.now()}`, name: fullName, semanaSesiones: 0, semanaHechas: 0, exp: 0 }]);
      setNewTrainerModalOpen(false);
      setNewTrainerDraft({ nombre: "", apellido: "", email: "" });
      showToast(`✓ "${fullName}" agregado`);
      return;
    }

    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email.trim())) {
      showToast("Poné un mail válido"); return;
    }

    setSincro((x) => ({ ...x, guardando: true, error: null }));
    try {
      await invitarAlumno({ nombre: nombre.trim(), apellido: apellido.trim(), email: email.trim() });
      setSincro((x) => ({ ...x, guardando: false }));
      setNewTrainerModalOpen(false);
      setNewTrainerDraft({ nombre: "", apellido: "", email: "" });
      showToast(`✓ Invitación enviada a ${email.trim()}`);
    } catch (e) {
      setSincro({ cargando: false, guardando: false, error: e.message || "No se pudo invitar" });
    }
  };

  // Si quedó una sesión abierta, se entra de inmediato con el perfil
  // guardado y se verifica contra el servidor en paralelo. Antes se
  // esperaba a que respondieran dos llamadas antes de dibujar nada, y
  // en el celular eso eran uno o dos segundos de pantalla de login.
  useEffect(() => {
    if (!hayBackend || screen !== "login") return;
    if (!sesionActual()) return;
    let vivo = true;

    const guardado = leerPerfilGuardado();
    const vista = leerVistaGuardada();

    if (guardado?.rol) {
      handleLogin(guardado.rol, `${guardado.nombre} ${guardado.apellido}`.trim(), guardado);
      if (vista?.view) {
        setActiveWeekId(vista.activeWeekId || null);
        setActiveSessionId(vista.activeSessionId || null);
        setView(vista.view);
      }
    }

    (async () => {
      const s = await renovarSesion();
      if (!vivo) return;
      if (!s) { guardarPerfil(null); if (guardado) handleLogout(); return; }
      const perfil = await cargarPerfil();
      if (!perfil || !vivo) return;
      guardarPerfil(perfil);
      // Si no se había entrado con caché, se entra ahora.
      if (!guardado) {
        handleLogin(perfil.rol, `${perfil.nombre} ${perfil.apellido}`.trim(), perfil);
        if (vista?.view) {
          setActiveWeekId(vista.activeWeekId || null);
          setActiveSessionId(vista.activeSessionId || null);
          setView(vista.view);
        }
      } else {
        // Ya estaba adentro: solo se corrigen los datos si cambiaron.
        setProfile((pr) => ({ ...pr, name: `${perfil.nombre} ${perfil.apellido}`.trim(),
                              photo: perfil.foto_url, exp: perfil.exp || 0, id: perfil.id,
                              admin: !!perfil.admin }));
        if (perfil.rol !== guardado.rol) setRole(perfil.rol);
      }
    })().catch(() => {});
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screen]);


  // Toda escritura del coach pasa por acá. Si falla, se avisa y se
  // recarga desde la base: es preferible perder el cambio a que la
  // pantalla muestre una semana que en realidad no existe.
  // Vuelve a pedir la lista de alumnos: el contador de "X de Y esta
  // semana" tiene que reflejar lo que se acaba de asignar.
  // Trae insignias y récords desde la base y los vuelca al estado que
  // ya usa la interfaz, para no tocar todas las pantallas.
  const refrescarLogros = React.useCallback(async () => {
    if (!hayBackend) return;
    try {
      const r = await cargarInsignias();
      // Si la consulta falla o devuelve algo raro, se usan listas
      // vacías: recorrer un nulo tumba la pantalla entera, y perder
      // las insignias un rato es mucho menos grave que eso.
      const catalogo = Array.isArray(r?.catalogo) ? r.catalogo : [];
      const otorgadas = Array.isArray(r?.otorgadas) ? r.otorgadas : [];
      setInsigniasDB({ catalogo, otorgadas });

      const porId = Object.fromEntries(catalogo.map((i) => [i.id, i.codigo]));
      // De quién son las insignias que se muestran. Mirando como un
      // alumno hay que leer LAS SUYAS: antes se leían las del coach y
      // por eso las que le aprobabas no le aparecían.
      const mio = viendoComo?.id || profile?.id;
      const alumnoCond = mio;
      const cond = alumnoCond
        ? await insigniasLogradas(alumnoCond).catch(() => ({}))
        : {};
      setLogradas(cond || {});

      // Estado de MIS insignias, por código.
      //
      // La interfaz maneja cuatro estados y la base tres:
      //   sin fila en la base → "locked" o "earned" (lograda, sin reclamar)
      //   pending             → "pending"  (esperando al coach)
      //   earned en la base   → "approved" (insignia activa)
      //
      // Las que no están en la base conservan su estado local, para no
      // perder el botón de Reclamar de las que el alumno ya logró.
      setBadgeStatus((prev) => {
        const estados = { ...prev };
        const enBase = new Set();
        for (const o of (Array.isArray(otorgadas) ? otorgadas : [])) {
          if (o.alumno_id !== mio) continue;
          const codigo = porId[o.insignia_id];
          if (!codigo) continue;
          enBase.add(codigo);
          estados[codigo] = o.estado === "earned" ? "approved" : "pending";
        }
        // Lo que no está en la base depende de si cumplió la condición.
        //
        // Las insignias que el coach crea desde la app no tienen una
        // condición automática que las desbloquee: se otorgan a mano.
        // Marcarlas como bloqueadas las dejaba invisibles aunque se
        // las hubiera dado. Solo se evalúan las que tienen condición.
        for (const b of (Array.isArray(BADGES) ? BADGES : [])) {
          if (enBase.has(b.id)) continue;
          estados[b.id] = cond?.[b.id]?.ok ? "earned" : "locked";
        }
        // "ins" y no "i": esta función corre dentro de un ámbito donde
        // i es el índice del ejercicio, y usarlo acá lo pisaba.
        for (const ins of (Array.isArray(catalogo) ? catalogo : [])) {
          if (enBase.has(ins.codigo) || BADGES.some((b) => b.id === ins.codigo)) continue;
          // Sin condición y sin otorgar: existe pero todavía no es suya.
          estados[ins.codigo] = "locked";
        }
        return estados;
      });

      // Solicitudes pendientes: el coach ve las de todos.
      if (role === "coach") {
        const nombres = Object.fromEntries(studentsList.map((a) => [a.id, a.name]));
        setBadgeRequests(otorgadas
          .filter((o) => o.estado === "pending")
          .map((o) => ({
            id: `${o.alumno_id}:${o.insignia_id}`,
            badgeId: porId[o.insignia_id],
            alumnoId: o.alumno_id,
            insigniaId: o.insignia_id,
            studentName: nombres[o.alumno_id] || "Be Trainer",
            requestedAt: Date.parse(o.otorgada_en || "") || Date.now(),
          }))
          .filter((r) => r.badgeId));
      }

      // Aviso de lo recién desbloqueado: cumplido, no reclamado, y
      // que no se haya avisado antes en este dispositivo.
      if (alumnoCond) {
        const yaAvisadas = (() => {
          try { return JSON.parse(localStorage.getItem("be_avisadas") || "[]"); }
          catch { return []; }
        })();
        const nuevas = BADGES_VIVAS.filter((b) =>
          cond?.[b.id]?.ok && !yaAvisadas.includes(b.id)
          && !otorgadas.some((o) => o.alumno_id === alumnoCond
                && porId[o.insignia_id] === b.id));
        if (nuevas.length) setAvisoInsignias(nuevas);
      }

      setPropuestas(aLista(await cargarPropuestas().catch(() => [])));

      // Récords.
      // Si la consulta falla —o devuelve un error en vez de filas—
      // se usa una lista vacía: recorrer eso tumba la pantalla.
      const records = await cargarRecords(role === "coach" ? null : mio)
        .catch(() => []);
      const aprobados = {};
      for (const r of (Array.isArray(records) ? records : [])
                        .filter((x) => x?.estado === "aprobado")) {
        if (r.alumno_id === mio || role === "coach") {
          aprobados[r.ejercicio_nombre] = {
            tipo: r.tipo, valor: Number(r.valor), fecha: "Aprobado por el coach" };
        }
      }
      setPersonalRecords((prev) => ({ ...prev, ...aprobados }));

      setPrRequests(records
        .filter((r) => r.estado === "pendiente")
        .map((r) => ({
          id: r.id, ejercicio: r.ejercicio_nombre, tipo: r.tipo,
          valor: Number(r.valor), prevValor: null,
          studentName: (studentsList.find((a) => a.id === r.alumno_id)?.name) || "Be Trainer",
        })));
    } catch {
      // Si falla, la app sigue con lo que tiene en pantalla.
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  // viendoComo va en las dependencias: sin esto la función se queda
  // con el valor de cuando se creó, y al mirar como un alumno seguía
  // leyendo las insignias del coach.
  }, [role, profile?.id, studentsList, viendoComo?.id]);

  useEffect(() => {
    if (screen === "app") refrescarLogros();
  }, [screen, refrescarLogros]);

  // El alumno que se estaba mirando se restaura recién cuando llega la
  // lista: al recargar, la lista viene de la base y tarda un instante.
  const restaurado = React.useRef(false);
  useEffect(() => {
    if (screen !== "app" || restaurado.current || !studentsList.length) return;
    const g = leerVistaGuardada();
    if (!g) { restaurado.current = true; return; }
    if (g.viendoComoId) {
      const a = studentsList.find((x) => x.id === g.viendoComoId);
      if (a) setViendoComo(a);
    } else if (g.selectedStudentId) {
      const a = studentsList.find((x) => x.id === g.selectedStudentId);
      if (a) setSelectedStudent(a);
    }
    restaurado.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screen, studentsList]);

  // Se guarda en sessionStorage, no en localStorage: dura lo que dura
  // la pestaña. Cerrar la app y volver mañana arranca en el inicio,
  // que es lo esperable; recargar te deja donde estabas.
  useEffect(() => {
    if (screen !== "app") return;
    try {
      const g = leerVistaGuardada();
      // Mientras no se haya restaurado el alumno, se conserva el id
      // guardado: si no, el primer render lo borraría con un null.
      sessionStorage.setItem(CLAVE_VISTA, JSON.stringify({
        view, activeWeekId, activeSessionId,
        selectedStudentId: selectedStudent?.id || (restaurado.current ? null : g?.selectedStudentId) || null,
        viendoComoId: viendoComo?.id || (restaurado.current ? null : g?.viendoComoId) || null,
      }));
    } catch { /* si el navegador lo bloquea, no pasa nada */ }
  }, [screen, view, activeWeekId, activeSessionId, selectedStudent, viendoComo]);

  // El código solo lo devuelve la base si sos el coach.
  useEffect(() => {
    if (!hayBackend || screen !== "app" || role !== "coach") return;
    codigoInvitacion().then(setCodigoInv).catch(() => {});
  }, [screen, role]);

  const regenerarCodigo = async () => {
    try {
      const nuevo = await regenerarCodigoInvitacion();
      setCodigoInv(nuevo);
      setEditandoCodigo(false);
      showToast("✓ Código nuevo — el anterior dejó de servir");
    } catch {
      showToast("No se pudo generar un código nuevo");
    }
  };

  const guardarCodigo = async () => {
    const nuevo = codigoDraft.trim().toUpperCase();
    if (nuevo.length < 8) { showToast("El código necesita al menos 8 caracteres"); return; }
    try {
      const r = await cambiarCodigoInvitacion(nuevo);
      setCodigoInv(r || nuevo);
      setEditandoCodigo(false);
      showToast("✓ Código actualizado — pasáles el nuevo a tus Be Trainers");
    } catch {
      showToast("No se pudo cambiar el código");
    }
  };

  const refrescarAlumnos = React.useCallback(() => {
    if (!hayBackend || role !== "coach") return;
    cargarAlumnos().then(setStudentsList).catch(() => {});
    cargarActividadSemana().then(setActividad).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  // Ver la app con los ojos de un alumno. Solo el coach: se comprueba
  // acá y además en la base, donde un alumno no puede leer datos de
  // otro por más que manipule la app desde el navegador.
  const verComoAlumno = (alumno) => {
    if (role !== "coach") return;
    setViendoComo(alumno);
    setSelectedStudent(alumno);
    setActiveWeekId(null);
    setActiveSessionId(null);
    setView("inicio");
    showToast(`Estás viendo la app como ${alumno.name.split(" ")[0]}`);
  };

  const volverACoach = () => {
    setViendoComo(null);
    setActiveWeekId(null);
    setActiveSessionId(null);
    setView("alumnos");
    refrescarAlumnos();
  };


  // Que quede una marca de "guardado" al terminar. Sin esto la barra
  // desaparecía y no había forma de saber si cerró bien: solo se
  // enteraba si FALLABA.
  const [reciénGuardado, setReciénGuardado] = useState(false);
  const relojGuardado = React.useRef(null);
  const marcarGuardado = () => {
    setReciénGuardado(true);
    clearTimeout(relojGuardado.current);
    // Tres segundos y medio. Con dos no llegabas a mirarlo: el
    // guardado de un peso tarda medio segundo y el aviso se iba antes
    // de que levantaras la vista del teclado.
    relojGuardado.current = setTimeout(() => setReciénGuardado(false), 3500);
  };

  const persistir = async (accion, mensajeError, conDetalle = false) => {
    if (!hayBackend) return null;
    setSincro((x) => ({ ...x, guardando: true, error: null }));
    try {
      const r = await accion();
      setSincro((x) => ({ ...x, guardando: false }));
      marcarGuardado();
      return r;
    } catch (e) {
      // Con detalle, el cartel dice QUÉ falló: sin eso, "no se pudo"
      // obliga a abrir la consola, que en el celular no se puede.
      const motivo = conDetalle ? (e?.message || "").slice(0, 140) : "";
      setSincro({ cargando: false, guardando: false,
        error: motivo ? `${mensajeError} ${motivo}` : mensajeError });
      if (alumnoMirado) cargarSemanas(alumnoMirado).then(setWeeks).catch(() => {});
      return null;
    }
  };

  // Archivar: pierde el acceso pero su historial queda guardado.
  // Es lo que corresponde cuando alguien deja y puede volver.
  const archivarAlumno = async (alumno) => {
    setStudentsList((prev) => prev.filter((a) => a.id !== alumno.id));
    setConfirmar(null);
    if (!hayBackend) { showToast(`${alumno.name} archivado`); return; }
    const ok = await persistir(() => darDeBajaAlumno(alumno.id),
                               "No se pudo archivar. Probá de nuevo.");
    if (ok) { refrescarAlumnos(); cargarInactivos().then(setInactivos).catch(() => {}); }
    showToast(`${alumno.name} pasó a archivados`);
  };

  // Eliminar: se va todo, incluida la cuenta. No se puede deshacer.
  const eliminarAlumno = async (alumno) => {
    const nombre = alumno.name || `${alumno.nombre} ${alumno.apellido}`.trim();
    setStudentsList((prev) => prev.filter((a) => a.id !== alumno.id));
    setInactivos((prev) => prev.filter((a) => a.id !== alumno.id));
    setConfirmar(null);
    if (!hayBackend) { showToast(`${nombre} eliminado`); return; }
    // Borrar una cuenta y todo su historial tarda unos segundos.
    setTarea({ texto: `Eliminando a ${nombre.split(" ")[0]}`,
               hechos: 0, total: 0, detalle: "y todo su historial" });
    setSincro((x) => ({ ...x, guardando: true, error: null }));
    try {
      await borrarAlumnoDefinitivo(alumno.id);
      setTarea(null);
      setSincro((x) => ({ ...x, guardando: false }));
      refrescarAlumnos();
      cargarInactivos().then(setInactivos).catch(() => {});
      showToast(`${nombre} y todo su historial fueron eliminados`);
    } catch (e) {
      setTarea(null);
      setSincro({ cargando: false, guardando: false,
        error: e.message || "No se pudo eliminar. Probá de nuevo." });
      refrescarAlumnos();
      cargarInactivos().then(setInactivos).catch(() => {});
    }
  };

  const altaAlumno = async (alumno) => {
    setInactivos((prev) => prev.filter((a) => a.id !== alumno.id));
    if (!hayBackend) return;
    const ok = await persistir(() => reactivarAlumno(alumno.id), "No se pudo reactivar.");
    if (ok) { refrescarAlumnos(); showToast(`${alumno.nombre} volvió a tener acceso`); }
  };

  // Los inactivos se piden solo al entrar en modo edición: es una
  // consulta que casi nunca hace falta.
  // Se cargan siempre: la sección de archivados vive al pie de la
  // lista, no solo dentro del modo edición.
  useEffect(() => {
    if (hayBackend && screen === "app" && role === "coach") {
      cargarInactivos().then(setInactivos).catch(() => {});
    }
  }, [screen, role]);

  // Panel de diagnóstico: muestra qué hay realmente guardado en la
  // base. Evita tener que ir a buscarlo al panel de Supabase.
  const [diagOpen, setDiagOpen] = useState(false);
  const [diag, setDiag] = useState(null);

  const correrDiagnostico = async () => {
    setDiagOpen(true);
    setDiag(null);
    try {
      setDiag(await diagnostico());
    } catch (e) {
      setDiag({ error: e.message || "No se pudo consultar la base" });
    }
  };

  // Al duplicar se propone la semana siguiente dentro del mismo mes:
  // duplicar una semana es, casi siempre, armar la que viene.
  const openDuplicateModal = (week) => {
    const periodo = week?.period || mesesUsados[mesesUsados.length - 1] || "";
    const enEseMes = weeks.filter((w) => w.period === periodo).length;
    setNuevaSemana({ nombre: `Semana ${enEseMes + 1}`, periodo, visibleDesde: visibilidadPorDefecto() });
    setDuplicateModal(week);
  };

  const openWeekActionChoice = (week) => {
    // El mes se toma del último cargado, no del calendario: si estás
    // armando septiembre en agosto, proponerte agosto te obliga a
    // corregirlo cada vez.
    const hoy = new Date();
    const ultimo = mesesUsados[mesesUsados.length - 1];
    const periodo = ultimo || `${MESES[hoy.getMonth()]} ${hoy.getFullYear()}`;

    // Y el número cuenta DENTRO del mes: con tres semanas de agosto,
    // la primera de septiembre es la 1, no la 4.
    const enEseMes = weeks.filter((w) => w.period === periodo).length;
    setNuevaSemana({ nombre: `Semana ${enEseMes + 1}`, periodo, visibleDesde: visibilidadPorDefecto() });
    // Sin semana de origen no hay nada que duplicar: va directo a crear.
    if (!week) { setEmptyWeekModalOpen(true); return; }
    setWeekActionChoiceOpen(week);
  };

  const createEmptyWeek = async () => {
    const nombre = nuevaSemana.nombre.trim() || "Semana nueva";
    const period = nuevaSemana.periodo.trim();
    setEmptyWeekModalOpen(false);

    if (!hayBackend) {
      const newWeek = { id: `w-${Date.now()}`, name: nombre, period, sessions: [] };
      setWeeks((prev) => [...prev, newWeek]);
      setActiveWeekId(newWeek.id);
      setWeekOrigin("weeks");
      setView("week");
      showToast(`✓ "${nombre} - ${period}" creada — agregale sesiones cuando quieras`);
      return;
    }

    if (!alumnoMirado) { showToast("Elegí primero a qué Be Trainer"); return; }
    const visibleDesde = nuevaSemana.visibleDesde || null;
    const fila = await persistir(() => crearSemana(alumnoMirado, nombre, period, visibleDesde),
                                 "No se pudo crear la semana");
    if (!fila) return;   // persistir ya mostró el error
    setWeeks((prev) => [...prev, { id: fila.id, name: nombre, period, sessions: [], visibleDesde }]);
    setActiveWeekId(fila.id);
    setWeekOrigin("weeks");
    setView("week");
    refrescarAlumnos();
    showToast(`✓ "${nombre} - ${period}" creada — agregale sesiones cuando quieras`);
  };

  const confirmDuplicate = async () => {
    const source = duplicateModal;
    const nombre = nuevaSemana.nombre.trim() || "Semana nueva";
    const period = nuevaSemana.periodo.trim();
    const clonedSessions = source.sessions.map((s) => ({
      id: `${s.id}-${Date.now()}`, name: s.name, estado: "Pendiente", borgRPE: null, fuerzaPercibida: null, puntaje: null, carga: null,
      exercises: s.exercises.map((ex) => ({
        ...ex, pesoPrevia: ex.pesoUsado || "", rirPrevia: ex.rirTuyo || "",
        pesoUsado: "", rirTuyo: "", comentarios: "", videoAlumno: "",
      })),
    }));
    setDuplicateModal(null);

    if (!hayBackend) {
      setWeeks((prev) => [...prev, { id: `w-${Date.now()}`, name: nombre, period, sessions: clonedSessions }]);
      showToast(`✓ "${nombre} - ${period}" creada — pendiente, con referencia de la semana previa`);
      return;
    }

    if (!alumnoMirado) { showToast("Elegí primero a qué Be Trainer"); return; }
    const ok = await persistir(async () => {
      await duplicarSemana(alumnoMirado, source, nombre, period, nuevaSemana.visibleDesde || null);
      // Se recarga entero: duplicar crea muchas filas con ids nuevos
      // y reconstruir ese árbol a mano es donde se cuelan diferencias.
      setWeeks(aLista(await cargarSemanas(alumnoMirado)));
      return true;
    }, "No se pudo duplicar la semana");
    if (ok) { refrescarAlumnos(); showToast(`✓ "${nombre} - ${period}" creada — pendiente, con referencia de la semana previa`); }
  };

  // El alumno escribe mientras entrena: guardar en cada tecla sería
  // una llamada por letra. Se espera a que pare de escribir.
  const pendientes = React.useRef({});
  const temporizador = React.useRef(null);

  const guardarPendientes = React.useCallback(async () => {
    const cola = pendientes.current;
    pendientes.current = {};
    const ids = Object.keys(cola);
    if (!ids.length) return;
    setSincro((x) => ({ ...x, guardando: true, error: null }));
    try {
      await Promise.all(ids.map((id) => guardarRegistroEjercicio(id, cola[id])));
      setSincro((x) => ({ ...x, guardando: false }));
      marcarGuardado();
    } catch (e) {
      // Si falla, vuelve a la cola: no se pierde lo que cargó.
      pendientes.current = { ...cola, ...pendientes.current };
      setSincro({ cargando: false, guardando: false, error: "No se pudo guardar. Revisá la conexión." });
    }
  }, []);

  // Si la app se va a segundo plano —cambia de pestaña, se bloquea el
  // teléfono, la cierra— se vuelca lo pendiente. En el gimnasio eso
  // pasa todo el tiempo: cargás una serie y apagás la pantalla.
  useEffect(() => {
    const alOcultarse = () => {
      if (document.visibilityState === "hidden") {
        clearTimeout(temporizador.current);
        guardarPendientes();
      }
    };
    document.addEventListener("visibilitychange", alOcultarse);
    window.addEventListener("pagehide", alOcultarse);
    return () => {
      document.removeEventListener("visibilitychange", alOcultarse);
      window.removeEventListener("pagehide", alOcultarse);
    };
  }, [guardarPendientes]);

  // Cuántos cambios hay sin volcar, y cuándo fue el último guardado.
  // Van en estado y no solo en una referencia porque tienen que
  // redibujar el aviso: "se guarda solo" es cierto pero no tranquiliza.
  const [cambiosPendientes, setCambiosPendientes] = useState(0);
  const [guardadoReciente, setGuardadoReciente] = useState(0);

  // Cola aparte para lo que prescribe el coach. El permiso de la tabla
  // no deja escribir esas columnas por el camino del alumno, así que
  // antes los cambios se descartaban en silencio: agregabas un drop
  // set a una sesión ya creada y se perdía al recargar.
  const pendientesCoach = React.useRef({});
  const relojCoach = React.useRef(null);

  const volcarPrescripcion = React.useCallback(async () => {
    const cola = pendientesCoach.current;
    pendientesCoach.current = {};

    // "orden" ya no viaja por acá: tiene su propia función. Si quedó
    // alguno encolado de una versión anterior, se descarta en vez de
    // fallar para siempre y arrastrar al resto de los cambios.
    for (const k of Object.keys(cola)) {
      if (cola[k] && "orden" in cola[k]) {
        delete cola[k].orden;
        if (!Object.keys(cola[k]).length) delete cola[k];
      }
    }

    const ids = Object.keys(cola);
    if (!ids.length) { setCambiosPendientes(0); return; }
    try {
      setSincro((x) => ({ ...x, guardando: true, error: null }));
      // Un reintento antes de darse por vencido: en el gimnasio la
      // señal se corta un segundo y volvía un error por algo que
      // funcionaba perfecto medio segundo después.
      try {
        await Promise.all(ids.map((id) => guardarPrescripcion(id, cola[id])));
      } catch (primera) {
        await new Promise((r) => setTimeout(r, 800));
        await Promise.all(ids.map((id) => guardarPrescripcion(id, cola[id])));
      }
      setSincro({ cargando: false, guardando: false, error: null });
      setCambiosPendientes(0);
      setGuardadoReciente(Date.now());
    } catch (e) {
      // Los cambios vuelven a la cola: si se perdieran acá, el coach
      // creería que guardó algo que nunca llegó.
      pendientesCoach.current = { ...cola, ...pendientesCoach.current };
      // El motivo real, no un mensaje genérico: sin esto no hay forma
      // de saber si falta una migración, si es permisos o si es la red.
      // eslint-disable-next-line no-console
      console.error("[BE Training] no se guardó la prescripción:", e?.message || e, cola);
      setCambiosPendientes(Object.keys(pendientesCoach.current).length);
      // Se dice cuántos quedaron pendientes: "un cambio" cuando son
      // seis hace pensar que el resto sí llegó.
      const cuantos = Object.keys(pendientesCoach.current).length;
      // El motivo va en el cartel, no solo en la consola: en el celular
      // no hay forma de abrir la consola, y sin el motivo no se puede
      // saber si falta una migración, si es permisos o si es la red.
      const motivo = (e?.message || "").slice(0, 160);
      setSincro({ cargando: false, guardando: false,
        error: (cuantos === 1
          ? "Un cambio no se guardó."
          : `${cuantos} cambios no se guardaron.`) + (motivo ? ` ${motivo}` : "") });
    }
  }, []);


  const encolarPrescripcion = (id, campo, valor) => {
    // "orden" ya no viaja por acá: tiene su propia función. Si quedó
    // alguno encolado de una versión anterior, se descarta en vez de
    // fallar para siempre y arrastrar al resto de los cambios.
    if (campo === "orden") return;
    pendientesCoach.current[id] = { ...(pendientesCoach.current[id] || {}), [campo]: valor };
    setCambiosPendientes(Object.keys(pendientesCoach.current).length);
    clearTimeout(relojCoach.current);
    relojCoach.current = setTimeout(volcarPrescripcion, 700);
  };

  useEffect(() => {
    if (!guardadoReciente) return;
    const t = setTimeout(() => setGuardadoReciente(0), 2500);
    return () => clearTimeout(t);
  }, [guardadoReciente]);

  // Descartar lo que está en la cola y volver a lo que hay guardado.
  // Un "cancelar" que solo vaciara la cola dejaría los cambios a la
  // vista en pantalla: el coach creería que se deshicieron.
  const descartarCambios = async () => {
    clearTimeout(relojCoach.current);
    pendientesCoach.current = {};
    setCambiosPendientes(0);
    if (hayBackend && alumnoMirado) {
      try {
        setSincro((x) => ({ ...x, cargando: true, error: null }));
        setWeeks(aLista(await cargarSemanas(alumnoMirado)));
        setSincro({ cargando: false, guardando: false, error: null });
        showToast("Cambios descartados");
      } catch {
        setSincro({ cargando: false, guardando: false,
          error: "No se pudo recargar. Actualizá la página." });
      }
    }
  };

  const guardarCambiosYa = async () => {
    clearTimeout(relojCoach.current);
    await volcarPrescripcion();
  };

  const encolarGuardado = (ejercicio) => {
    if (!hayBackend || !ejercicio?.id) return;
    pendientes.current[ejercicio.id] = {
      pesoUsado: ejercicio.pesoUsado, rirTuyo: ejercicio.rirTuyo,
      comentarios: ejercicio.comentarios, videoAlumno: ejercicio.videoAlumno,
      comentarioFoto: ejercicio.comentarioFoto,
      resultadoSeries: ejercicio.resultadoSeries,
      timer: ejercicio.timer,
    };
    clearTimeout(temporizador.current);
    temporizador.current = setTimeout(guardarPendientes, 900);
  };

  // Si cierra la pestaña con algo sin guardar, se intenta igual.
  useEffect(() => {
    const alSalir = () => {
      if (Object.keys(pendientes.current).length) guardarPendientes();
      if (Object.keys(pendientesCoach.current).length) volcarPrescripcion();
    };
    window.addEventListener("pagehide", alSalir);
    return () => { window.removeEventListener("pagehide", alSalir); alSalir(); };
  }, [guardarPendientes, volcarPrescripcion]);

  const updateExercise = (weekId, sessionId, index, field, value) => {
    if (sessionId === "plantilla") {
      setDraftTemplate((prev) => {
        if (!prev) return prev;
        const exercises = [...prev.exercises];
        exercises[index] = { ...exercises[index], [field]: value,
          ...(field === "seccion" ? { finalizador: value === "finalizador" } : {}) };
        if (field === "bloque") {
          const [movido] = exercises.splice(index, 1);
          const suSeccion = seccionDe(movido);
          let corte = exercises.length;
          for (let k = exercises.length - 1; k >= 0; k--) {
            if (seccionDe(exercises[k]) === suSeccion
                && (exercises[k].bloque || "") === (value || "")) { corte = k + 1; break; }
            if (seccionDe(exercises[k]) === suSeccion) corte = k + 1;
          }
          exercises.splice(corte, 0, movido);
        }
        return { ...prev, exercises };
      });
      return;
    }
    setWeeks((prev) => prev.map((w) => {
      if (w.id !== weekId) return w;
      return {
        ...w, sessions: w.sessions.map((s) => {
          if (s.id !== sessionId) return s;
          let exercises = [...s.exercises];
          exercises[index] = { ...exercises[index], [field]: value };
          const ejActual = exercises[index];

          // Al cambiar de bloque hay que moverlo físicamente: los
          // bloques agrupan ejercicios SEGUIDOS con el mismo nombre,
          // así que uno que quedó lejos de los suyos formaría un
          // bloque aparte con el mismo título.
          if (field === "bloque") {
            const [movido] = exercises.splice(index, 1);
            const suSeccion = seccionDe(movido);
            let corte = exercises.length;
            for (let k = exercises.length - 1; k >= 0; k--) {
              if (seccionDe(exercises[k]) === suSeccion
                  && (exercises[k].bloque || "") === (value || "")) {
                corte = k + 1; break;
              }
              if (seccionDe(exercises[k]) === suSeccion) corte = k + 1;
            }
            exercises.splice(corte, 0, movido);
          }
          if (esCampoDelCoach(field)) {
            // Lo que prescribe el coach va por su propio camino.
            if (hayBackend && ejActual.id) {
              encolarPrescripcion(ejActual.id, field, value);
            } else if (hayBackend) {
              // Sin id el cambio no se puede guardar. Antes se
              // descartaba en silencio: quedaba en pantalla y se
              // perdía al recargar, que es lo peor que puede pasar.
              setSincro({ cargando: false, guardando: false,
                error: "Este ejercicio todavía no está en la base. Recargá la página." });
            }
          } else if (field === "notaCoach" || field === "notaCoachFoto") {
            // La observación del coach y su foto van juntas por su
            // propio camino: el alumno no tiene permiso sobre esas
            // columnas. Se mandan las DOS aunque cambie una sola, o
            // guardar el texto borraría la imagen y al revés.
            if (hayBackend && ejActual.id) {
              persistir(() => guardarNotaCoach(ejActual.id, ejActual.notaCoach, ejActual.notaCoachFoto),
                        "La observación no se guardó. Probá de nuevo.");
            }
          } else {
            encolarGuardado(exercises[index]);
          }
          let estado = s.estado;
          if (field === "rirTuyo" && estado === "Pendiente") estado = "En proceso";
          return { ...s, exercises, estado };
        }),
      };
    }));
  };

  const setSessionEstado = (weekId, sessionId, estado) => {
    setWeeks((prev) => prev.map((w) => w.id !== weekId ? w : { ...w, sessions: w.sessions.map((s) => s.id !== sessionId ? s : { ...s, estado }) }));
    // El estado también vive en la base: sin esto, marcar "En proceso"
    // se veía en pantalla pero se perdía al recargar.
    if (hayBackend) {
      // Marcarla completada desde acá también guarda cuándo. Sin esto
      // quedaba "Completado" sin fecha ni hora, y el ranking no sabía
      // a qué semana asignarla.
      const cambios = { estado };
      if (estado === "Completado") {
        const sesion = weeks.find((w) => w.id === weekId)
          ?.sessions.find((x) => x.id === sessionId);
        const d = new Date();
        cambios.completadaEn = d.toISOString();
        // Si ya tenía un día asignado, se respeta esa fecha.
        if (!sesion?.fecha) {
          cambios.fecha = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
        }
      }
      persistir(() => renombrarSesion(sessionId, cambios),
                "El estado no se guardó.")
        .then((ok) => { if (ok) refrescarAlumnos(); });
    }
  };
  const setSessionRating = (weekId, sessionId, field, value) => {
    if (sessionId === "plantilla") { setDraftTemplate((p) => p && ({ ...p, [field]: value })); return; }
    setWeeks((prev) => prev.map((w) => w.id !== weekId ? w : { ...w, sessions: w.sessions.map((s) => s.id !== sessionId ? s : { ...s, [field]: value }) }));
    // Solo estos tres campos viven en la tabla de sesiones; el resto
    // (esfuerzo, sensación) se escribe al cerrar la sesión.
    if (hayBackend && ["name", "day", "estado"].includes(field)) {
      persistir(() => renombrarSesion(sessionId, { [field]: value }),
                "No se pudo guardar el cambio");
    }
  };


  
  const openNewSessionForm = () => { setDraftSession({ name: "", exercises: [seedExercise()], withFinalizador: false }); setView("newSession"); };
  const cancelNewSessionForm = () => { setDraftSession(null); setView("week"); };
  const updateDraftExercise = (index, field, value) => {
    setDraftSession((prev) => {
      const exercises = [...prev.exercises];
      exercises[index] = { ...exercises[index], [field]: value };
      return { ...prev, exercises };
    });
  };
  // El último agregado late un momento para que el ojo lo encuentre
  // sin tener que buscarlo entre ocho tarjetas iguales.
  const [recienAgregado, setRecienAgregado] = useState(null);
  const marcarNuevo = (i) => {
    setRecienAgregado(i);
    setTimeout(() => setRecienAgregado(null), 500);
  };

  const addDraftExercise = () => setDraftSession((prev) => {
    marcarNuevo(prev.exercises.length);
    return { ...prev, exercises: [...prev.exercises,
      seedExercise({ seccion, finalizador: seccion === "finalizador" })] };
  });
  const removeDraftExercise = (index) => setDraftSession((prev) => ({ ...prev, exercises: prev.exercises.filter((_, i) => i !== index) }));
  // El finalizador es un bloque al final de la sesión: el trabajo que
  // se hace después de lo principal. Antes esto agregaba un ejercicio
  // vacío llamado "Finalizador" y le pegaba un tabata a toda la
  // sesión, que no es lo que el nombre promete.
  const toggleFinalizador = () => setDraftSession((prev) => {
    const tiene = prev.exercises.some((e) => e.finalizador);
    if (tiene) {
      // Al apagarlo, sus ejercicios se sacan.
      return { ...prev, withFinalizador: false,
               exercises: prev.exercises.filter((e) => !e.finalizador) };
    }
    return { ...prev, withFinalizador: true,
             exercises: [...prev.exercises, seedExercise({ finalizador: true })] };
  });

  // Las mismas dos acciones para el armador de la Librería: una
  // plantilla con finalizador conserva ese bloque al asignarse.
  const toggleFinalizadorPlantilla = () => setDraftTemplate((prev) => {
    const tiene = prev.exercises.some((e) => e.finalizador);
    if (tiene) {
      return { ...prev, exercises: prev.exercises.filter((e) => !e.finalizador) };
    }
    return { ...prev, exercises: [...prev.exercises, seedExercise({ finalizador: true })] };
  });



  // Marca las insignias como avisadas para no repetir el cartel.
  const cerrarAvisoInsignias = (irA) => {
    try {
      const previas = JSON.parse(localStorage.getItem("be_avisadas") || "[]");
      localStorage.setItem("be_avisadas",
        JSON.stringify([...new Set([...previas, ...avisoInsignias.map((b) => b.id)])]));
    } catch { /* ignorar */ }
    setAvisoInsignias([]);
    if (irA) setView("insignias");
  };

  const enviarPropuesta = async () => {
    const { nombre, descripcion } = propuestaDraft;
    if (nombre.trim().length < 3) { showToast("Poné un nombre para la insignia"); return; }
    if (descripcion.trim().length < 5) { showToast("Contá cómo se consigue"); return; }
    if (!hayBackend || !profile?.id) {
      setProponerAbierto(false);
      setPropuestaDraft({ nombre: "", descripcion: "" });
      showToast("✓ Propuesta enviada a Mati");
      return;
    }
    const ok = await persistir(async () => {
      await proponerInsignia(profile.id, nombre, descripcion);
      setPropuestas(aLista(await cargarPropuestas()));
      return true;
    }, "No se pudo enviar la propuesta.");
    if (!ok) return;
    setProponerAbierto(false);
    setPropuestaDraft({ nombre: "", descripcion: "" });
    showToast("✓ Propuesta enviada — Mati la va a revisar");
  };

  // Aprobar crea la insignia real: pasa a estar disponible para todos.
  const resolverPropuestaInsignia = async (propuesta, aprobar) => {
    setPropuestas((prev) => prev.map((x) => x.id !== propuesta.id ? x
      : { ...x, estado: aprobar ? "aprobada" : "rechazada" }));
    if (!hayBackend) return;
    const ok = await persistir(async () => {
      if (aprobar) await crearInsigniaDesdePropuesta(propuesta);
      await resolverPropuesta(propuesta.id, aprobar);
      setPropuestas(aLista(await cargarPropuestas()));
      return true;
    }, "No se pudo resolver la propuesta.");
    if (ok) {
      refrescarLogros();
      showToast(aprobar
        ? `✓ "${propuesta.nombre}" ya está disponible para todos`
        : "Propuesta rechazada");
    }
  };

  const idInsignia = (codigo) =>
    insigniasDB.catalogo.find((i) => i.codigo === codigo)?.id;

  const claimBadge = async (badgeId) => {
    setBadgeStatus((prev) => ({ ...prev, [badgeId]: "pending" }));
    if (!hayBackend) {
      setBadgeRequests((prev) => [...prev, { id: `req-${Date.now()}`, badgeId, studentName: profile.name || "Alumno", requestedAt: Date.now() }]);
      showToast("✓ Solicitud enviada a tu coach para aprobar la insignia");
      return;
    }
    const insigniaId = idInsignia(badgeId);
    if (!insigniaId || !profile?.id) { showToast("No se pudo enviar la solicitud"); return; }
    const ok = await persistir(() => solicitarInsignia(profile.id, insigniaId),
                               "La solicitud no se envió. Probá de nuevo.");
    if (!ok) { setBadgeStatus((prev) => ({ ...prev, [badgeId]: "locked" })); return; }
    showToast("✓ Solicitud enviada a tu coach para aprobar la insignia");
  };

  // Compartir una insignia conseguida, con el mismo camino que el
  // festejo de fin de sesión.
  const compartirInsignia = (b) => {
    const nivel = levelFromExp(perfilVista?.exp || 0);
    const texto = [
      `🏅 ¡Conseguí la insignia "${b.name}"!`,
      b.desc,
      `Nivel ${nivel} en BE Training`,
      "#BeTraining",
    ].filter(Boolean).join("\n");
    window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, "_blank");
  };

  // Reclamar todas las insignias listas de una. Con cuatro cumplidas,
  // pedirlas una por una son ocho toques para lo mismo.
  const reclamarTodas = async () => {
    const listas = BADGES_VIVAS.filter((b) => badgeStatus[b.id] === "earned");
    if (!listas.length) return;
    for (const b of listas) await claimBadge(b.id);
    showToast(listas.length === 1
      ? "✓ Insignia solicitada"
      : `✓ ${listas.length} insignias solicitadas — Mati las va a revisar`);
  };

  // Aprobar deja la insignia en 'earned' y la base suma la EXP sola.
  const approveBadgeRequest = async (reqId, boton) => {
    const req = badgeRequests.find((r) => r.id === reqId);
    if (!req) return;
    const badge = BADGES_VIVAS.find((b) => b.id === req.badgeId);
    // Los papelitos ANTES de sacar la tarjeta: salen de donde está el
    // botón. Si se sacara primero, el botón ya no existiría.
    papelitos(boton, [badge?.color || "#6fc48d", "#6fc48d", "#38bdf8", "#fbbf24"]);
    setBadgeRequests((prev) => prev.filter((r) => r.id !== reqId));

    if (hayBackend && req.alumnoId && req.insigniaId) {
      const ok = await persistir(() => resolverInsignia(req.alumnoId, req.insigniaId, true),
                                 "No se pudo aprobar la insignia.");
      if (!ok) { refrescarLogros(); return; }
      refrescarLogros();
    } else {
      setBadgeStatus((prev) => ({ ...prev, [req.badgeId]: "approved" }));
    }
    // Sin ventana que cerrar: el festejo grande es del alumno cuando la
    // recibe, no del coach cuando aprueba veinte seguidas. Se actualiza
    // el número de pendientes para que no quede viejo.
    if (role === "coach" && !viendoComo) {
      tableroCoach().then(setTablero).catch(() => {});
    }
    refrescarNotificaciones();
  };

  // Rechazar vuelve la insignia a bloqueada. Antes hacía lo contrario:
  // rechazar la otorgaba, que era justo al revés de lo que dice el botón.
  const rejectBadgeRequest = async (reqId) => {
    const req = badgeRequests.find((r) => r.id === reqId);
    if (!req) return;
    setBadgeRequests((prev) => prev.filter((r) => r.id !== reqId));

    if (hayBackend && req.alumnoId && req.insigniaId) {
      await persistir(() => resolverInsignia(req.alumnoId, req.insigniaId, false),
                      "No se pudo rechazar la solicitud.");
      refrescarLogros();
    } else {
      setBadgeStatus((prev) => ({ ...prev, [req.badgeId]: "locked" }));
    }
    showToast("Solicitud rechazada");
  };

  // Día de la semana de hoy, con el nombre que usa la app.
  const diaDeHoy = () => DIAS_SEMANA[(new Date().getDay() + 6) % 7];

  // Antes de cerrar: qué ejercicios quedaron sin RIR.
  //
  // No lo bloquea. Hay días en que alguien entrena y no anota, y
  // dejarlo trabado sin poder cerrar la sesión es peor que registrar
  // una sesión incompleta. Pero se avisa qué falta y cuánto cuesta.
  const ejerciciosSinRir = () => (activeSession?.exercises || [])
    .filter((ex) => {
      if (!ex.ejercicio) return false;
      // El RIR es SOLO de la parte principal y el finalizador. La
      // movilidad y la activación son preparación: no se van al fallo,
      // así que pedir cuántas repeticiones sobraron no significa nada.
      const sec = seccionDe(ex);
      if (sec !== "principal" && sec !== "finalizador") return false;
      if (ex.tecnica === "tabata") return false;
      return !String(ex.rirTuyo ?? "").trim();
    })
    // Con la sección: "faltan tres" sin decir dónde obliga a recorrer
    // toda la sesión abriendo tarjetas para encontrarlos.
    .map((ex) => {
      const sec = seccionDe(ex);
      const nombre = { activacion: "Activación", finalizador: "Finalizador" }[sec];
      return nombre ? `${ex.ejercicio} (${nombre})` : ex.ejercicio;
    });

  const intentarCerrar = () => {
    const sinRir = ejerciciosSinRir();
    if (sinRir.length) { setAvisoRir(sinRir); return; }
    openCelebration();
  };

  const openCelebration = (incompleta = false) => {
    // Si el alumno entrenó sin haber arrastrado la sesión a un día,
    // se le pone el de hoy. Si no, la sesión queda completada pero
    // sigue figurando como pendiente de ubicar en el calendario.
    const diaFinal = activeSession.day || diaDeHoy();

    // Se guardan EN la sesión para que queden en el historial,
    // no solo en la pantalla de festejo.
    const puntaje = sessionScore(activeSession);
    const carga = sessionLoad(activeSession);
    setWeeks((prev) => prev.map((w) => w.id !== activeWeek.id ? w : {
      ...w,
      sessions: w.sessions.map((se) => se.id !== activeSession.id ? se : {
        ...se, puntaje, carga, day: diaFinal, completadaEn: new Date().toISOString(),
      }),
    }));

    const matches = activeSession.exercises.filter((ex) => {
      const cIdx = RIR_OPTIONS.indexOf(ex.rirConsigna), tIdx = RIR_OPTIONS.indexOf(ex.rirTuyo);
      return ex.rirTuyo && cIdx !== -1 && tIdx !== -1 && cIdx === tIdx;
    }).length;

    const newPRs = [];
    const primerasMarcas = [];
    activeSession.exercises.forEach((ex) => {
      if (!ex.ejercicio) return;
      const prev = personalRecords[ex.ejercicio];
      const tipo = prev?.tipo || (ex.pesoUsado && ex.pesoUsado !== "-" ? "peso" : "reps");
      const rawVal = tipo === "peso" ? ex.pesoUsado : ex.reps;
      if (!rawVal || rawVal === "-") return;
      const val = parseNum(rawVal);
      if (val <= 0) return;
      // Un récord exige una marca previa que superar: la primera vez
      // que se hace un ejercicio es el punto de partida, no un récord.
      // Este es el mismo criterio que usa la base para pagar la EXP.
      if (prev && val > prev.valor) newPRs.push({ ejercicio: ex.ejercicio, tipo, valor: val, prevValor: prev.valor });
      // Sin marca previa, se registra como referencia para la próxima.
      else if (!prev) primerasMarcas.push({ ejercicio: ex.ejercicio, tipo, valor: val });
    });
    // Las primeras marcas se guardan SIEMPRE, aunque no haya récords:
    // son el punto de partida contra el que se compara la próxima vez.
    // Si esto viviera dentro del if de arriba, en la primera sesión no
    // quedaría nada y nunca habría con qué comparar.
    if (primerasMarcas.length > 0) {
      setPersonalRecords((prev) => {
        const next = { ...prev };
        primerasMarcas.forEach((m) => {
          if (!next[m.ejercicio]) next[m.ejercicio] = { tipo: m.tipo, valor: m.valor, fecha: `${activeWeek.name} - ${activeWeek.period}` };
        });
        return next;
      });
    }

    if (newPRs.length > 0) {
      setPendingPRs((prev) => {
        const next = { ...prev };
        newPRs.forEach((pr) => { next[pr.ejercicio] = { tipo: pr.tipo, valor: pr.valor, prevValor: pr.prevValor, fecha: `${activeWeek.name} - ${activeWeek.period}` }; });
        return next;
      });
    }

    const points = Math.round(puntaje / 10);  // 100% de la sesión = 10 puntos

    // La EXP se desglosa para poder mostrarle al alumno de dónde salió.
    const videos = activeSession.exercises.filter((ex) => ex.videoAlumno).length;
    const semanaCerrada = activeWeek.sessions.every(
      (se) => se.id === activeSession.id || se.estado === "Completado");
    const detalle = [
      { txt: `Sesión completada (${puntaje}%)`, exp: Math.round(EXP.sesionCompleta * puntaje / 100) },
      puntaje === 100 && { txt: "Sesión al 100%", exp: EXP.sesionPerfecta },
      matches > 0 && { txt: `${matches} ${matches === 1 ? "RIR acertado" : "RIR acertados"}`, exp: matches * EXP.rirCoincide },
      newPRs.length > 0 && { txt: `${newPRs.length} ${newPRs.length === 1 ? "récord superado" : "récords superados"}`, exp: newPRs.length * EXP.recordSuperado },
      videos > 0 && { txt: `${videos} ${videos === 1 ? "video propio" : "videos propios"}`, exp: videos * EXP.videoPropio },
      semanaCerrada && { txt: "¡Semana completa!", exp: EXP.semanaCompleta },
      // Que se vea POR QUÉ sumó menos. La experiencia ya baja sola
      // —sin RIR no hay aciertos ni sesión al 100%—, pero sin decirlo
      // parece un descuento arbitrario.
      incompleta && { txt: "Cerraste sin todos los RIR", exp: 0, aviso: true },
    ].filter(Boolean);
    const exp = detalle.reduce((t, d) => t + d.exp, 0);
    const oldLevel = levelFromExp(profile.exp);
    const newExpTotal = profile.exp + exp;
    const newLevel = levelFromExp(newExpTotal);
    setProfile((p) => ({ ...p, exp: newExpTotal }));
    setSessionRewards({ points, exp, detalle, leveledUp: newLevel > oldLevel, newLevel, newPRs });

    // La EXP la calcula la base, no el navegador: es lo que alimenta
    // el ranking y no puede depender de lo que diga el cliente.
    // Lo de arriba es una estimación optimista para no hacer esperar;
    // cuando la base responde, se reemplaza por los puntos reales.
    if (hayBackend && activeSession?.id) {
      setSincro((x) => ({ ...x, guardando: true }));
      (async () => {
        try {
          await guardarPendientes();
          const r = await cerrarSesionEnBase(activeSession.id, {
            fecha: activeSession.fecha, dia: diaFinal,
            duracion: activeSession.duracion, borgRPE: activeSession.borgRPE,
            fuerzaPercibida: activeSession.fuerzaPercibida,
          });
          if (r) {
            setSessionRewards((prev) => ({
              ...prev,
              points: Math.round((r.puntaje || 0) / 10),
              exp: r.exp ?? prev.exp,
              detalle: r.detalle?.length ? r.detalle : prev.detalle,
            }));
            if (typeof r.exp_total === "number") {
              setProfile((pr) => ({ ...pr, exp: r.exp_total }));
            }
            setWeeks((prev) => prev.map((w) => w.id !== activeWeek.id ? w : {
              ...w, sessions: w.sessions.map((se) => se.id !== activeSession.id ? se
                : { ...se, puntaje: r.puntaje }) }));
          }
          setSincro({ cargando: false, guardando: false, error: null });
        } catch (e) {
          setSincro({ cargando: false, guardando: false,
            error: "La sesión no se pudo guardar. Volvé a abrirla y cerrala de nuevo." });
        }
      })();
    }

    setCelebrationOpen(true); setShareStep(false);
    // La foto se limpia: si no, la del entrenamiento anterior
    // aparecería en el siguiente.
    setSelfieTaken(false); setFotoCierre(null);
  };
  // Cerrar el festejo termina el entrenamiento: vuelve a la semana.
  // Antes solo tapaba el cartel y dejaba al alumno parado en la misma
  // sesión ya completada, sin señal de que había terminado.
  const closeCelebration = () => {
    // La sesión quedó completada: sus marcas ya no sirven.
    if (activeSession?.id) limpiarMarcas(activeSession.id);
    setCelebrationOpen(false);
    setShareStep(false);
    setSelfieTaken(false); setFotoCierre(null);
    setActiveSessionId(null);
    setView(weekOrigin || "weeks");
  };
  const goToShareStep = () => {
    const esfuerzo = borgEnPalabras(activeSession?.borgRPE);
    const sensacion = activeSession?.fuerzaPercibida;
    const nivel = levelFromExp(profile.exp);

    const lineas = [
      `¡Entreno cumplido! 💪 ${activeSession?.name}`,
      `${activeWeek?.name} · ${activeWeek?.period}`,
      [esfuerzo && `Esfuerzo: ${esfuerzo}`, sensacion && `Me sentí: ${sensacion}`]
        .filter(Boolean).join(" · "),
      `⚡ +${sessionRewards.exp} EXP · Nivel ${nivel}`,
      sessionRewards.leveledUp && `🎉 ¡Subí al nivel ${sessionRewards.newLevel}!`,
      sessionRewards.newPRs?.length > 0 &&
        `🏆 ${sessionRewards.newPRs.length === 1 ? "Nuevo récord personal" : `${sessionRewards.newPRs.length} récords nuevos`}`,
      "#BeTraining",
    ].filter(Boolean);

    setShareMessage(lineas.join("\n"));
    setShareStep(true);
  };

  const sendToWhatsappGroup = async () => {
    // Se marca como compartida ANTES de abrir WhatsApp. Antes se marcaba
    // después, a la vuelta: en el celular, al saltar a WhatsApp el
    // teléfono congela o cierra la app, ese paso nunca llegaba y la
    // sesión no sumaba al ranking aunque la foto estuviera en el grupo.
    const sesionId = activeSession?.id;
    const marcada = hayBackend && sesionId
      ? marcarCompartida(sesionId).catch(() => {}) : null;
    const registro = hayBackend && sesionId
      ? registrarCompartido(sesionId).catch(() => null) : null;

    // Con foto: se usa el menú de compartir del teléfono, que sí puede
    // mandar imagen y texto juntos. El link de WhatsApp solo lleva
    // texto, así que la foto se quedaría en la app.
    let compartioNativo = false;
    if (fotoCierre && navigator.share) {
      try {
        const r = await fetch(fotoCierre);
        const blob = await r.blob();
        const archivo = new File([blob], "entrenamiento.jpg", { type: "image/jpeg" });
        if (!navigator.canShare || navigator.canShare({ files: [archivo] })) {
          await navigator.share({ text: shareMessage, files: [archivo] });
          compartioNativo = true;
        }
      } catch {
        // Si el usuario cancela o el teléfono no deja, sigue por el
        // camino de siempre.
      }
    }
    if (!compartioNativo) {
      window.open(`https://wa.me/?text=${encodeURIComponent(shareMessage)}`, "_blank");
    }
    const newCount = shareCount + 1;
    setShareCount(newCount);
    if (newCount >= 3) otorgarInsignia("b13");

    closeCelebration();

    if (hayBackend && sesionId) {
      try {
        await marcada;
        const r = await registro;
        if (typeof r?.exp_total === "number") setProfile((pr) => ({ ...pr, exp: r.exp_total }));
        showToast(r?.exp > 0
          ? `✓ Compartido · +${r.exp} EXP al ranking`
          : "✓ WhatsApp abierto — elegí el grupo para compartir");
      } catch {
        showToast("✓ WhatsApp abierto — elegí el grupo para compartir");
      }
      return;
    }
    showToast("✓ WhatsApp abierto — elegí el grupo para compartir tu logro");
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) { showToast("Elegí una imagen"); return; }
    // El recorte lo elige la persona: antes se cortaba el centro y
    // una cara en un costado quedaba afuera.
    setRecortando(file);
  };

  const guardarFotoRecortada = async (blob) => {
    setRecortando(null);
    const lector = new FileReader();
    lector.onload = async () => {
      const foto = lector.result;
      setProfile((prev) => ({ ...prev, photo: foto }));
      if (!hayBackend) { showToast("✓ Foto actualizada"); return; }
      try {
        const fila = await actualizarPerfil({ foto_url: foto });
        if (!fila) throw new Error("La base no confirmó el guardado");
        guardarPerfil({ ...leerPerfilGuardado(), foto_url: foto });
        refrescarAlumnos();
        showToast("✓ Foto actualizada");
      } catch {
        setSincro({ cargando: false, guardando: false,
          error: "No se pudo guardar la foto. Probá con otra imagen." });
      }
    };
    lector.readAsDataURL(blob);
  };

  const [cambiandoPass, setCambiandoPass] = useState(false);

  const handleChangePassword = async () => {
    if (!passwordForm.current || !passwordForm.next) { showToast("Completá los campos de contraseña"); return; }
    if (passwordForm.next.length < 6) { showToast("La contraseña nueva debe tener al menos 6 caracteres"); return; }
    if (passwordForm.next !== passwordForm.confirm) { showToast("Las contraseñas nuevas no coinciden"); return; }
    if (passwordForm.next === passwordForm.current) { showToast("La nueva tiene que ser distinta de la actual"); return; }

    if (!hayBackend) {
      setPasswordForm({ current: "", next: "", confirm: "" });
      showToast("✓ Contraseña actualizada");
      return;
    }

    setCambiandoPass(true);
    try {
      // Antes esto no cambiaba nada: validaba los campos, los limpiaba
      // y mostraba el tilde verde sin tocar la base. La gente creía
      // haber cambiado su contraseña y seguía con la vieja.
      await cambiarPassword(passwordForm.current, passwordForm.next);
      setPasswordForm({ current: "", next: "", confirm: "" });
      setMenuPerfil(null);
      showToast("✓ Contraseña cambiada. Usá la nueva la próxima vez.");
    } catch (e) {
      setSincro({ cargando: false, guardando: false,
        error: e.message || "No se pudo cambiar la contraseña" });
    } finally {
      setCambiandoPass(false);
    }
  };

  const savePR = () => {
    if (!prDraft.ejercicio.trim() || !prDraft.valor || parseNum(prDraft.valor) <= 0) { showToast("Completá ejercicio y valor"); return; }
    const ejercicio = prDraft.ejercicio.trim();
    const valor = parseNum(prDraft.valor);
    const prevValor = personalRecords[ejercicio]?.valor || null;
    setPendingPRs((prev) => ({ ...prev, [ejercicio]: { tipo: prDraft.tipo, valor, prevValor, fecha: "Cargado a mano" } }));
    setPrModalOpen(false);
    showToast(`"${ejercicio}" queda pendiente de aprobación del coach`);
  };
  const deletePR = () => {
    setPersonalRecords((prev) => { const next = { ...prev }; delete next[prDraft.ejercicio]; return next; });
    setPendingPRs((prev) => { const next = { ...prev }; delete next[prDraft.ejercicio]; return next; });
    setPrModalOpen(false);
    showToast("PR eliminado");
  };
  const claimPR = async (ejercicio) => {
    const pr = pendingPRs[ejercicio];
    if (!pr) return;

    if (!hayBackend) {
      setPrRequests((prev) => [...prev, { id: `prreq-${Date.now()}`, ejercicio, tipo: pr.tipo, valor: pr.valor, prevValor: pr.prevValor, studentName: profile.name || "Alumno" }]);
      showToast("✓ PR reclamado — esperando aprobación de tu coach");
      return;
    }
    if (!profile?.id) return;
    const ok = await persistir(() => proponerRecord(profile.id, ejercicio, pr.tipo, pr.valor),
                               "El récord no se envió. Probá de nuevo.");
    if (!ok) return;
    refrescarLogros();
    showToast("✓ PR reclamado — esperando aprobación de tu coach");
  };

  const approvePRRequest = async (reqId, boton) => {
    const req = prRequests.find((r) => r.id === reqId);
    if (!req) return;
    // Igual que las insignias: papelitos desde el botón, sin ventana.
    papelitos(boton, ["#fbbf24", "#fb923c", "#6fc48d", "#38bdf8"]);
    setPrRequests((prev) => prev.filter((r) => r.id !== reqId));
    setPendingPRs((prev) => { const next = { ...prev }; delete next[req.ejercicio]; return next; });
    setPersonalRecords((prev) => ({ ...prev, [req.ejercicio]: { tipo: req.tipo, valor: req.valor, fecha: "Aprobado por el coach" } }));

    if (hayBackend) {
      const ok = await persistir(() => resolverRecord(req.id, true), "No se pudo aprobar el récord.");
      if (ok) refrescarLogros();
    }
    if (role === "coach" && !viendoComo) {
      tableroCoach().then(setTablero).catch(() => {});
    }
  };

  const rejectPRRequest = async (reqId) => {
    const req = prRequests.find((r) => r.id === reqId);
    setPrRequests((prev) => prev.filter((r) => r.id !== reqId));
    if (hayBackend && req) {
      await persistir(() => resolverRecord(req.id, false), "No se pudo rechazar el récord.");
      refrescarLogros();
    }
    showToast("Solicitud de PR rechazada");
  };

  // Sirve para crear y para editar: si viene `editando`, actualiza
  // el ejercicio existente en vez de agregar uno nuevo.
  // Los efectos (sumar EXP, avisar) van FUERA del actualizador de estado:
  // React puede ejecutar el actualizador más de una vez, y ahí se
  // duplicaría la EXP o directamente reventaría el render.
  // Insignias automáticas. Con base conectada, el alumno no puede
  // otorgárselas: queda pendiente y el coach aprueba. El coach sí
  // puede otorgarlas directo, y la base suma la EXP con su disparador.
  const otorgarInsignia = async (badgeId, paraAlumno = null) => {
    const destino = paraAlumno || (role === "alumno" ? profile?.id : null);

    if (!hayBackend) {
      if (["pending", "approved"].includes(badgeStatus[badgeId])) return;
      setBadgeStatus((prev) => ({ ...prev, [badgeId]: "approved" }));
      setProfile((pr) => ({ ...pr, exp: pr.exp + EXP.insignia }));
      showToast(`🏅 Insignia desbloqueada · +${EXP.insignia} EXP`);
      return;
    }

    const insigniaId = idInsignia(badgeId);
    if (!insigniaId || !destino) return;

    // ¿Ya la tiene o ya la solicitó?
    const ya = insigniasDB.otorgadas.some(
      (o) => o.alumno_id === destino && o.insignia_id === insigniaId);
    if (ya) return;

    try {
      if (role === "coach") {
        await solicitarInsignia(destino, insigniaId);
        await resolverInsignia(destino, insigniaId, true);
        showToast("🏅 Insignia otorgada");
      } else {
        await solicitarInsignia(destino, insigniaId);
        setBadgeStatus((prev) => ({ ...prev, [badgeId]: "pending" }));
        showToast("🏅 Insignia lograda · esperando que Mati la apruebe");
      }
      refrescarLogros();
    } catch {
      // Si ya existía, la base la rechaza y no hay nada que avisar.
    }
  };

  const createExercise = async () => {
    const { name, category, videoUrl, gifUrl, editando } = newExerciseDraft;
    if (!name.trim()) { showToast("Poné el nombre del ejercicio"); return; }
    if (!category.trim() || category.trim().length < 2) {
      showToast("Elegí una categoría o escribí una nueva"); return;
    }
    if (!esUrlValida(videoUrl) || !esUrlValida(gifUrl)) {
      showToast("Las direcciones tienen que empezar con https://"); return;
    }
    const limpio = name.trim();
    const categoriaLimpia = category.trim();

    // Si es una categoría nueva, se agrega a la lista para que el
    // ejercicio tenga dónde caer.
    if (!exerciseGroups.some((g) => g.label === categoriaLimpia)) {
      setExerciseGroups((prev) => [...prev, { label: categoriaLimpia, items: [] }]);
      const colorElegido = newExerciseDraft.color || PALETA_CATEGORIAS[0];
      recordarColorLocal(categoriaLimpia, colorElegido);
      if (hayBackend) {
        // A la base: así el color se ve igual desde cualquier
        // dispositivo, y la categoría no desaparece si todavía no
        // tiene ejercicios.
        crearCategoriaEjercicios(categoriaLimpia, colorElegido).catch(() => {});
      }
    }

    if (!editando) {
      const yaExiste = exerciseGroups.some((g) => g.items.includes(limpio));
      if (yaExiste) { showToast(`"${limpio}" ya está en la biblioteca`); return; }
      setExerciseGroups((prev) => {
        const conCategoria = prev.some((g) => g.label === categoriaLimpia)
          ? prev : [...prev, { label: categoriaLimpia, items: [] }];
        return conCategoria.map((g) => (g.label === categoriaLimpia
          ? { ...g, items: [...g.items, limpio] } : g));
      });
    } else if (editando !== limpio) {
      // Cambió el nombre: lo movemos y arrastramos sus medios.
      setExerciseGroups((prev) => prev.map((g) => ({
        ...g,
        items: g.label === categoriaLimpia
          ? [...g.items.filter((x) => x !== editando), limpio]
          : g.items.filter((x) => x !== editando),
      })));
    }
    setExerciseMedia((prev) => {
      const next = { ...prev };
      if (editando && editando !== limpio) delete next[editando];
      next[limpio] = { videoUrl: videoUrl.trim(), gifUrl: gifUrl.trim() };
      return next;
    });
    setNewExerciseModalOpen(false);
    setNewExerciseDraft({ name: "", category: "", videoUrl: "", gifUrl: "", editando: null, categoriaNueva: false, color: PALETA_CATEGORIAS[0] });

    if (!hayBackend) {
      showToast(editando ? `✓ "${limpio}" actualizado` : `✓ Ejercicio "${limpio}" creado en ${categoriaLimpia}`);
      return;
    }

    // Se espera la respuesta antes de avisar: antes decía "guardado"
    // sin saber si había llegado, y el error se veía después.
    try {
      await crearEjercicioEnBase({ nombre: limpio, categoria: categoriaLimpia,
        nombreAnterior: editando || null,
        videoUrl: videoUrl.trim(), gifUrl: gifUrl.trim() });
      // Se relee la biblioteca para que el gif aparezca en todos los
      // ejercicios donde ya estaba puesto, no solo en el que se editó.
      cargarEjercicios().then(({ grupos, medios, colores }) => {
        if (colores) fijarColoresCategorias(colores);
        if (grupos.length) setExerciseGroups(grupos);
        setExerciseMedia(medios);
      }).catch(() => {});
      showToast(editando ? `✓ "${limpio}" actualizado` : `✓ Ejercicio "${limpio}" creado en ${categoriaLimpia}`);
    } catch (e) {
      setSincro({ cargando: false, guardando: false,
        error: `No se pudo guardar "${limpio}" en la base. Probá de nuevo.` });
    }
  };

  // Medios de un ejercicio dentro de un plan: primero lo que se cargó
  // para esa sesión puntual, si no lo que tiene el ejercicio en la
  // biblioteca. Así se puede pisar el video para un caso particular.
  const mediaDe = (ex) => {
    const lib = exerciseMedia[ex?.ejercicio] || {};
    return { videoUrl: ex?.videoUrl || lib.videoUrl || "", gifUrl: ex?.gifUrl || lib.gifUrl || "" };
  };

  // Borrar un ejercicio del catálogo. Antes de pedir confirmación se
  // consulta dónde está usado: avisar "está en 3 sesiones de Mariano"
  // es más útil que un "no se puede" sin explicación.
  const idEjercicio = (nombre) => exerciseMedia[nombre]?.id || null;

  const refrescarEjercicios = () => {
    if (!hayBackend) return;
    cargarEjercicios().then(({ grupos, medios, colores }) => {
      if (colores) fijarColoresCategorias(colores);
      if (grupos.length) setExerciseGroups(grupos);
      setExerciseMedia(medios);
    }).catch(() => {});
  };

  const pedirBorrarEjercicio = async (nombre) => {
    const id = idEjercicio(nombre);
    if (!hayBackend || !id) {
      setConfirmar({ tipo: "ejercicio", nombre, uso: null });
      return;
    }
    try {
      const uso = await usoDelEjercicio(nombre);
      setConfirmar({ tipo: "ejercicio", nombre, id, uso });
    } catch {
      setConfirmar({ tipo: "ejercicio", nombre, id, uso: null });
    }
  };

  const eliminarEjercicio = async ({ nombre, id }) => {
    setConfirmar(null);
    setExerciseGroups((prev) => prev.map((g) => ({
      ...g, items: g.items.filter((n) => n !== nombre) })));
    if (!hayBackend || !id) { showToast(`"${nombre}" eliminado`); return; }

    const r = await persistir(() => borrarEjercicio(id),
                              "No se pudo eliminar el ejercicio.");
    if (r && r.ok === false) {
      // Quedó en uso: se devuelve a la lista.
      refrescarEjercicios();
      setSincro({ cargando: false, guardando: false,
        error: `"${nombre}" se usa en ${r.en_sesiones + r.en_plantillas} lugares. Sacalo de ahí primero.` });
      return;
    }
    refrescarEjercicios();
    showToast(`"${nombre}" eliminado del catálogo`);
  };

  const abrirEdicionEjercicio = (nombre) => {
    const grupo = exerciseGroups.find((g) => g.items.includes(nombre));
    const m = exerciseMedia[nombre] || {};
    setNewExerciseDraft({ name: nombre, category: grupo?.label || "",
      videoUrl: m.videoUrl || "", gifUrl: m.gifUrl || "", editando: nombre });
    setNewExerciseModalOpen(true);
  };

  const myName = isCoach ? (userName || "Mati") : (profile.name || "Fede");
  const resolveStudent = (id) => {
    const base = studentsList.find((st) => st.id === id) || { id, name: "Be Trainer" };
    // El propio alumno se muestra con su nombre y foto reales.
    const soyYo = hayBackend ? id === profile?.id : (isAlumno && id === "fede");
    if (soyYo) return { ...base, name: profile.name || base.name, photo: profile.photo };
    return base;
  };


  const assignSessionDay = (weekId, sessionId, day) => {
    // El nombre se busca ANTES de actualizar. Leerlo dentro del
    // setWeeks lo dejaba vacío: React ejecuta esa función después, y
    // el aviso salía con las comillas sin nada adentro.
    const sessionName = weeks.find((w) => w.id === weekId)
      ?.sessions.find((s) => s.id === sessionId)?.name || "El entrenamiento";

    setWeeks((prev) => prev.map((w) => {
      if (w.id !== weekId) return w;
      return {
        ...w, sessions: w.sessions.map((s) =>
          s.id !== sessionId ? s : { ...s, day }),
      };
    }));

    // Guardar el día en la base. Sin esto, arrastrar solo movía la
    // sesión en la pantalla del alumno: el coach seguía viendo el día
    // vacío porque en la base nunca cambiaba nada.
    // La fecha real de ese día en la semana en curso: el ranking
    // cuenta por fecha, y el nombre del día solo no alcanza.
    //
    // Pero NO para una sesión ya completada: su fecha es cuándo se
    // hizo. Moverla la pasaría a otra semana, y una sesión de la
    // semana pasada arrastrada hoy sumaría puntos otra vez.
    const yaHecha = weeks.find((w) => w.id === weekId)
      ?.sessions.find((x) => x.id === sessionId)?.estado === "Completado";
    let fecha = null;
    if (day && !yaHecha) {
      const idx = DIAS_SEMANA.indexOf(day);
      if (idx >= 0) {
        const hoy = new Date();
        const lunes = new Date(hoy);
        lunes.setDate(hoy.getDate() - ((hoy.getDay() + 6) % 7));
        const d = new Date(lunes);
        d.setDate(lunes.getDate() + idx);
        // En hora local, no UTC: si no, a la noche corre un día.
        fecha = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
      }
    }

    if (hayBackend) {
      persistir(() => renombrarSesion(sessionId,
                    yaHecha ? { day: day || null } : { day: day || null, fecha }),
                "El día no se guardó. Probá moverlo de nuevo.")
        .then((ok) => { if (ok) refrescarAlumnos(); });
    }
    showToast(day ? `✓ "${sessionName}" registrado el ${day}` : `"${sessionName}" quitado del día`);
  };

  // Dónde se tocó DENTRO de la etiqueta, para que el fantasma no
  // aparezca desplazado respecto del dedo.
  const agarre = React.useRef({ x: 60, y: 20 });
  const agarreTpl = React.useRef({ x: 60, y: 20 });

  const handleDragStart = (e, sessionId) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    const caja = e.currentTarget.getBoundingClientRect();
    agarre.current = { x: e.clientX - caja.left, y: e.clientY - caja.top };
    setDragSessionId(sessionId);
    setDragStart({ x: e.clientX, y: e.clientY });
    setDragPos({ x: e.clientX, y: e.clientY });
  };
  const handleDragMove = (e) => {
    if (!dragSessionId) return;
    setDragPos({ x: e.clientX, y: e.clientY });
    const el = document.elementFromPoint(e.clientX, e.clientY);
    const dayEl = el && el.closest("[data-day]");
    setHoverDay(dayEl ? dayEl.getAttribute("data-day") : null);
  };
  const handleDragEnd = (weekId, e, tapDay) => {
    const moved = Math.hypot(e.clientX - dragStart.x, e.clientY - dragStart.y);
    if (moved < 6) {
      if (tapDay) setExpandedDay((prev) => (prev === tapDay ? null : tapDay));
    } else if (dragSessionId) {
      // Soltar FUERA de un día no desasigna: se queda donde estaba.
      //
      // Antes, soltar un poco más abajo o al costado de la grilla le
      // quitaba el día, y la sesión desaparecía del inicio. No se
      // perdía —quedaba en la semana sin ubicar— pero ahí no se veía.
      //
      // Para sacarla de un día está la zona "Sin día asignado".
      if (hoverDay) assignSessionDay(weekId, dragSessionId, hoverDay);
    }
    setDragSessionId(null);
    setHoverDay(null);
  };

  // Arma una sesión con los ejercicios tildados en la biblioteca.
  // Los ejercicios NO se mueven: la biblioteca es un catálogo, la
  // sesión guarda una copia con su propia prescripción.
  const crearSesionDesdeSeleccion = () => {
    if (!seleccionados.length) return;
    setDraftTemplate({
      name: "",
      exercises: seleccionados.map((nombre) => {
        const grupo = exerciseGroups.find((g) => g.items.includes(nombre));
        const esRPE = ["Tabata", "Intermitente", "Running"].includes(grupo?.label);
        return seedExercise({ ejercicio: nombre, metric: esRPE ? "RPE" : "RIR" });
      }),
    });
    setSeleccionados([]);
    setView("newTemplate");
  };

  // ── Reordenar ejercicios arrastrando ─────────────────────
  // El orden importa: define la secuencia real del entrenamiento y
  // qué ejercicios quedan juntos en una serie combinada.
  const [arrastrando, setArrastrando] = useState(null);   // índice en movimiento
  const [sobreIndice, setSobreIndice] = useState(null);   // dónde caería

  const moverEjercicio = (setLista, desde, hasta) => {
    if (desde === hasta || hasta == null) return;
    setLista((prev) => {
      const ej = [...prev.exercises];

      // Solo dentro de la misma sección. Arrastrar un ejercicio de la
      // activación al medio de la parte principal lo dejaría visualmente
      // ahí pero seguiría siendo de activación: dos cosas distintas
      // diciendo lo contrario. Para cambiar de sección están los
      // botones de la tarjeta.
      if (seccionDe(ej[desde]) !== seccionDe(ej[hasta])) return prev;
      // Y dentro del mismo bloque: mover un ejercicio de "zona media"
      // al medio de otro bloque lo dejaría visualmente ahí pero
      // seguiría perteneciendo al primero.
      if ((ej[desde].bloque || "") !== (ej[hasta].bloque || "")) return prev;

      const [movido] = ej.splice(desde, 1);
      ej.splice(hasta, 0, movido);
      return { ...prev, exercises: ej };
    });
  };

  const inicioArrastre = (e, i) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    setArrastrando(i);
    setSobreIndice(i);
  };
  const moviendoArrastre = (e) => {
    if (arrastrando === null) return;
    const el = document.elementFromPoint(e.clientX, e.clientY);
    const destino = el && el.closest("[data-ejercicio-idx]");
    if (destino) setSobreIndice(Number(destino.getAttribute("data-ejercicio-idx")));
  };
  const finArrastre = (setLista) => {
    if (arrastrando !== null && sobreIndice !== null) {
      moverEjercicio(setLista, arrastrando, sobreIndice);
    }
    setArrastrando(null);
    setSobreIndice(null);
  };

  // Reordenar los ejercicios de una sesión ya asignada.
  //
  // El arrastre ya existía para la librería y funciona sobre cualquier
  // lista: lo que faltaba era el adaptador, porque una sesión vive
  // dentro de una semana y no en un estado suelto.
  const reordenarSesion = (fn) => {
    if (enPlantilla) { setDraftTemplate((prev) => prev && { ...prev, exercises: fn({ exercises: prev.exercises }).exercises }); return; }
    setWeeks((prev) => prev.map((w) => w.id !== activeWeek?.id ? w : {
      ...w,
      sessions: w.sessions.map((se) => {
        if (se.id !== activeSession?.id) return se;
        // fn espera { exercises } y devuelve lo mismo.
        const r = fn({ exercises: se.exercises });

        // El orden nuevo se encola acá, con la lista ya reordenada a
        // la vista. Hacerlo después, leyendo el estado, tomaba el
        // orden viejo: el estado todavía no se había actualizado.
        // El orden va por su propia función, en UNA operación.
        //
        // Guardarlo ejercicio por ejercicio no funciona: la columna
        // tiene unicidad por sesión, así que al mover uno colisiona
        // con el que todavía ocupa esa posición y la base rechaza
        // todos los cambios.
        if (hayBackend && se.id) {
          const ids = r.exercises.map((ex) => ex.id).filter(Boolean);
          if (ids.length === r.exercises.length) {
            reordenarEjercicios(se.id, ids).catch(() => {
              setSincro({ cargando: false, guardando: false,
                error: "No se pudo guardar el orden nuevo." });
            });
          }
        }
        return { ...se, exercises: r.exercises };
      }),
    }));
  };

  const openTemplateBuilder = () => { setDraftTemplate({ name: "", exercises: [seedExercise()] }); setView("newTemplate"); };

  // Abrir una plantilla existente para editarla. Se guarda de dónde
  // vino para poder reemplazarla en su carpeta al guardar.
  const editTemplate = (template, categoryId) => {
    setDraftTemplate({
      ...template,
      editando: { id: template.id, categoryId },
      exercises: template.exercises.map((ex) => ({ ...ex })),
    });
    setView("newTemplate");
  };
  // Duplicar es abrir el armador con una copia y SIN la marca de
  // "editando": al guardar se crea una plantilla nueva en vez de
  // pisar la original. Sirve para variantes —la misma sesión con
  // más volumen, o cambiando un ejercicio— sin rehacerla entera.
  const duplicarPlantilla = (template, categoryId) => {
    setDraftTemplate({
      ...template,
      id: undefined,
      editando: null,
      categoryId,
      name: `${template.name} (copia)`,
      // Los ejercicios se copian de verdad: sin esto los dos quedarían
      // apuntando a los mismos objetos y editar uno cambiaría el otro.
      exercises: template.exercises.map((ex) => ({
        ...ex,
        tecnicaConfig: ex.tecnicaConfig ? { ...ex.tecnicaConfig } : null,
      })),
    });
    setView("newTemplate");
    showToast("Copia lista — cambiale lo que quieras y guardala");
  };

  const cancelTemplateBuilder = () => { setDraftTemplate(null); setView("libreria"); };
  const updateDraftTemplateExercise = (index, field, value) => {
    setDraftTemplate((prev) => {
      const exercises = [...prev.exercises];
      exercises[index] = { ...exercises[index], [field]: value };
      return { ...prev, exercises };
    });
  };
  const addDraftTemplateExercise = (seccion = "principal") => setDraftTemplate((prev) => {
    marcarNuevo(prev.exercises.length);
    // El ejercicio entra al final de SU sección, no de la lista.
    // Antes se agregaba al fondo y había que marcarle la sección a
    // mano, que es justo lo que el botón tenía que evitar.
    const nuevo = seedExercise({ seccion, finalizador: seccion === "finalizador" });
    const mio = PESO_SECCION[seccion] || 3;
    const lista = [...prev.exercises];
    let corte = lista.length;
    for (let i = 0; i < lista.length; i++) {
      if ((PESO_SECCION[seccionDe(lista[i])] || 3) > mio) { corte = i; break; }
    }
    lista.splice(corte, 0, nuevo);
    return { ...prev, exercises: lista };
  });
  const removeDraftTemplateExercise = (index) => setDraftTemplate((prev) => ({ ...prev, exercises: prev.exercises.filter((_, i) => i !== index) }));
  const saveTemplate = async () => {
    if (!draftTemplate.name.trim()) { showToast("Poné un nombre para la sesión"); return; }
    const sinNombreT = draftTemplate.exercises.filter((e) => !e.ejercicio).length;
    if (sinNombreT > 0) {
      showToast(sinNombreT === 1
        ? "Hay 1 ejercicio sin elegir. Elegilo o sacalo con la X."
        : `Hay ${sinNombreT} ejercicios sin elegir. Elegilos o sacalos con la X.`);
      return;
    }
    const edit = draftTemplate.editando;
    // Una copia se guarda en la MISMA carpeta que la original: mandarla
    // a "sin categoría" obliga a arrastrarla de vuelta cada vez.
    const destino = draftTemplate.categoryId
      ? libraryCategories.find((c) => c.id === draftTemplate.categoryId)
      : null;
    const sinCategoria = destino || libraryCategories[0];

    if (!hayBackend) {
      if (edit) {
        setLibraryCategories((prev) => prev.map((c) => c.id !== edit.categoryId ? c : {
          ...c, templates: c.templates.map((t) => t.id !== edit.id ? t
            : { ...t, name: draftTemplate.name, exercises: draftTemplate.exercises,
                hasTimer: draftTemplate.hasTimer, timerConfig: draftTemplate.timerConfig }),
        }));
      } else {
        const nueva = { id: `tpl-${Date.now()}`, name: draftTemplate.name, exercises: draftTemplate.exercises };
        const idDestino = sinCategoria?.id || "sin-categoria";
        setLibraryCategories((prev) => prev.map((c) => (c.id === idDestino
          ? { ...c, templates: [...c.templates, nueva] } : c)));
      }
      setDraftTemplate(null);
      setView("libreria");
      showToast(edit ? `✓ "${draftTemplate.name}" actualizada` : `✓ "${draftTemplate.name}" creada`);
      return;
    }

    const ok = await persistir(async () => {
      if (edit) await actualizarPlantilla(edit.id, draftTemplate);
      else await crearPlantilla(edit ? edit.categoryId : sinCategoria?.id, draftTemplate);
      await refrescarLibreria();
      return true;
    }, "La sesión no se guardó. Probá de nuevo.");
    if (!ok) return;

    setDraftTemplate(null);
    setView("libreria");
    if (sinCategoria) setExpandedLibCategories((prev) => ({ ...prev, [sinCategoria.id]: true }));
    showToast(edit ? `✓ "${draftTemplate.name}" actualizada`
             : destino ? `✓ "${draftTemplate.name}" guardada en ${destino.name}`
             : `✓ "${draftTemplate.name}" creada — arrastrala a una carpeta para organizarla`);
  };

  // ── Borrado, siempre con confirmación ──────────────────────
  // Un borrado sin preguntar es irreversible y no hay papelera.
  const [confirmar, setConfirmar] = useState(null);
  const [previa, setPrevia] = useState(null);
  const [bibliotecaAbierta, setBibliotecaAbierta] = useState(false);
  // Buscadores de la librería: uno para las plantillas y otro para
  // los ejercicios creados.
  const [buscarPlantilla, setBuscarPlantilla] = useState("");
  const [buscarEjercicio, setBuscarEjercicio] = useState("");
  // Qué categoría tiene abierto el selector de color.
  const [colorCategoria, setColorCategoria] = useState(null);

  // Asistente: qué borrador se está pidiendo y qué devolvió.
  const [asistente, setAsistente] = useState(null);

  // Estado del torneo: la semana en curso y las fechas.
  const [miSemana, setMiSemana] = useState(null);
  const [torneo, setTorneo] = useState(null);
  const [reglamentoAbierto, setReglamentoAbierto] = useState(false);
  const [solicitudesMeta, setSolicitudesMeta] = useState([]);

  // Los números del tablero. Se piden al entrar y al volver a Inicio:
  // son un resumen del momento, no algo que haya que refrescar solo.
  const [tablero, setTablero] = useState(null);
  const [alertas, setAlertas] = useState([]);
  // Arranca abierto: si hay alguien que necesita atención, la idea es
  // que lo veas. Se pliega cuando ya los revisaste.
  const [alertasAbiertas, setAlertasAbiertas] = useState(true);
  // Los puntos que traen de la plataforma anterior. Se editan desde
  // el ranking: es una carga única y ahí están los veinte a la vista.
  const [editandoPuntos, setEditandoPuntos] = useState(null);
  const [puntosDraft, setPuntosDraft] = useState("0");
  // Arranca en la semana: es lo que la gente mira todos los días.
  const [vistaRanking, setVistaRanking] = useState("semana");
  // Gestión de insignias.
  const [vistaInsignias, setVistaInsignias] = useState("pendientes");
  const [catalogoInsignias, setCatalogoInsignias] = useState([]);
  const [insigniaAbierta, setInsigniaAbierta] = useState(null);
  const [editandoInsignia, setEditandoInsignia] = useState(null);
  // La insignia que se está mirando en grande.
  const [insigniaGrande, setInsigniaGrande] = useState(null);
  const [insigniasGrupo, setInsigniasGrupo] = useState([]);
  // Si la lista de alumnos ya llegó. Sin esto no se puede distinguir
  // "todavía no cargó" de "no hay ninguno".
  const [alumnosCargados, setAlumnosCargados] = useState(false);
  // Las semanas del alumno: lo otro que hace falta antes de mostrar.
  const [semanasCargadas, setSemanasCargadas] = useState(false);

  // Listo cuando llegó lo esencial, o a los 4 segundos pase lo que
  // pase: dejar a alguien mirando una barra por un error de red es
  // peor que mostrarle la app a medio llenar.
  // El tema también en el <html>: el fondo de la página y la zona de
  // rebote del celular no los pinta ningún elemento de la app, y en
  // modo claro asomaba una franja negra abajo de la barra.
  useEffect(() => {
    const raiz = document.documentElement;
    raiz.classList.toggle("claro", prefs.tema === "claro");
    // La barra del sistema del celular acompaña: sin esto queda de un
    // color y la app de otro.
    const meta = document.querySelector('meta[name="theme-color"]')
      || Object.assign(document.createElement("meta"), { name: "theme-color" });
    meta.content = prefs.tema === "claro" ? "#f5f7fa" : "#171717";
    if (!meta.parentNode) document.head.appendChild(meta);
  }, [prefs.tema]);

  const [porTiempo, setPorTiempo] = useState(false);
  useEffect(() => {
    if (screen !== "app") return;
    const t = setTimeout(() => setPorTiempo(true), 4000);
    return () => clearTimeout(t);
  }, [screen]);
  const listoParaMostrar = porTiempo || (alumnosCargados && semanasCargadas);
  // Los ejercicios sin RIR, cuando se intenta cerrar la sesión.
  const [avisoRir, setAvisoRir] = useState(null);
  // La semana que viene, para varios alumnos a la vez.
  const [semanaMasiva, setSemanaMasiva] = useState(null);
  // Desde el planificador, "Copiar igual a varios" ofrece solo a los
  // que todavía no tienen la semana nueva.
  const listaMasiva = semanaMasiva?.candidatos
    ? studentsList.filter((a) => semanaMasiva.candidatos.includes(a.id)) : studentsList;
  const [refrescarPlan, setRefrescarPlan] = useState(0);

  // Lo que tarda de verdad: duplicar veinte semanas, borrar un alumno.
  // Un "guardando…" sin más hace pensar que se colgó.
  //   { texto, hechos, total, detalle }  · null cuando no hay nada
  const [tarea, setTarea] = useState(null);

  // La guía abierta dentro de la app.
  const [verGuia, setVerGuia] = useState(false);
  // Cambiar el nombre de una sesión ya creada.
  const [renombrando, setRenombrando] = useState(null);
  // Qué semanas están plegadas, por id.
  const [semanasPlegadas, setSemanasPlegadas] = useState({});
  // Guardar una sesión de un alumno en la librería propia.
  const [aGuardar, setAGuardar] = useState(null);
  // La ventana del ciclo: en qué fase está y qué implica entrenar ahí.
  const [verCiclo, setVerCiclo] = useState(null);

  // Quién le planificó a quién, para no pisarse entre coaches.
  const [quienPlanifico, setQuienPlanifico] = useState([]);
  // null = todavía no eligió nada: se pliega solo si no hay nada que
  // mostrar, y se abre cuando aparece la primera. Si lo toca, manda
  // su elección.
  const [actividadAbierta, setActividadAbierta] = useState(null);
  // Qué alumno está desplegado dentro del panel. Uno por vez: con
  // varios abiertos hay que desplazar para encontrar el que importa.
  const [detalleAbierto, setDetalleAbierto] = useState(null);
  useEffect(() => {
    if (!hayBackend || role !== "coach" || viendoComo) { setQuienPlanifico([]); return; }
    let vivo = true;
    actividadCoaches(7).then((a) => vivo && setQuienPlanifico(aLista(a))).catch(() => {});
    return () => { vivo = false; };
  }, [role, viendoComo, screen]);

  // Los coaches, para el administrador.
  const [coaches, setCoaches] = useState([]);
  const [eligiendoCoach, setEligiendoCoach] = useState(false);
  const refrescarCoaches = React.useCallback(() => {
    if (!hayBackend || role !== "coach") return;
    listaCoaches().then((c) => setCoaches(aLista(c))).catch(() => {});
  }, [role]);
  useEffect(() => { refrescarCoaches(); }, [refrescarCoaches]);

  const sumarCoach = async (alumno) => {
    setEligiendoCoach(false);
    const ok = await persistir(() => cambiarRol(alumno.id, "coach"),
                               "No se pudo sumarlo como coach.", true);
    if (!ok) return;
    showToast(`${alumno.name?.split(" ")[0] || "Listo"} ahora es coach`);
    refrescarCoaches();
    refrescarAlumnos();
  };

  const quitarCoach = async (c) => {
    setConfirmar(null);
    const ok = await persistir(() => cambiarRol(c.id, "alumno"),
                               "No se pudo sacarlo.", true);
    if (!ok) return;
    showToast(`${c.nombre} vuelve a ser alumno`);
    refrescarCoaches();
    refrescarAlumnos();
  };

  // Qué cambió en la semana en curso respecto de la anterior.
  const [novedades, setNovedades] = useState([]);
  const [novedadesAbiertas, setNovedadesAbiertas] = useState(true);

  // Los mensajes sin leer del alumno: van a su inicio.
  const [misMensajes, setMisMensajes] = useState([]);
  const [novedadAbierta, setNovedadAbierta] = useState(null);
  useEffect(() => {
    if (!hayBackend || role === "coach") { setMisMensajes([]); return; }
    let vivo = true;
    mensajesSinLeer(14).then((m) => vivo && setMisMensajes(aLista(m))).catch(() => {});
    return () => { vivo = false; };
  }, [role, screen]);

  // Abrir la ventana de un mensaje, y desde ahí ir al ejercicio.
  const abrirMensaje = (m) => setNovedadAbierta({
    clave: m.clave,
    ejercicio: m.ejercicio_nombre || m.titulo,
    contexto: m.titulo,
    mensaje: m.detalle,
    deQuien: "Coach",
    destino: m.semana_id && m.sesion_id
      ? { semanaId: m.semana_id, sesionId: m.sesion_id,
          ejercicioId: m.ejercicio_id, tipo: "comentario" }
      : null,
  });

  const descartarMensaje = (m) => {
    setMisMensajes((prev) => prev.filter((x) => x.clave !== m.clave));
    if (hayBackend && m.clave) {
      descartarNovedad(m.clave).catch(() => setMisMensajes((prev) => [m, ...prev]));
    }
  };

  // Lo que pasó en el grupo, para el coach.
  const [novedadesDelGrupo, setNovedadesDelGrupo] = useState([]);
  const [grupoAbierto, setGrupoAbierto] = useState(true);

  // Marcar una novedad como vista. Se saca de la lista en el momento
  // y se guarda en la base, así no vuelve al recargar.
  const descartarNovedadGrupo = (n) => {
    setNovedadesDelGrupo((prev) => prev.filter((x) => x.clave !== n.clave));
    if (hayBackend && n.clave) {
      descartarNovedad(n.clave).catch(() => {
        // Si falló, vuelve a la lista: mejor verla de nuevo que
        // perderla sin haberla resuelto.
        setNovedadesDelGrupo((prev) => [n, ...prev]);
      });
    }
  };

  // Ir al lugar exacto de una novedad. Las semanas del alumno se cargan
  // al elegirlo, así que el salto queda pendiente hasta que llegan.
  const [irA, setIrA] = useState(null);
  // El ejercicio remarcado al llegar. Se va al tocar la tarjeta.
  const [destacar, setDestacar] = useState(null);

  // Los hilos de la sesión abierta, uno por nombre de ejercicio. Se
  // piden todos juntos: uno por tarjeta serían doce consultas.
  const [hilos, setHilos] = useState({});
  useEffect(() => {
    if (!hayBackend || !activeSessionId) { setHilos({}); return; }
    let vivo = true;
    conversacionesSesion(activeSessionId)
      .then((h) => vivo && setHilos(h && typeof h === "object" ? h : {}))
      .catch(() => {});
    return () => { vivo = false; };
  }, [activeSessionId]);

  // Volver a traer los hilos de la sesión abierta.
  //
  // persistir() recarga las SEMANAS cuando algo falla, pero los hilos
  // viven aparte: si fallaba una reacción, la pantalla seguía
  // mostrándola como si se hubiera guardado.
  const refrescarHilos = React.useCallback(() => {
    if (!hayBackend || !activeSessionId) return;
    conversacionesSesion(activeSessionId)
      .then((h) => setHilos(h && typeof h === "object" ? h : {}))
      .catch(() => {});
  }, [activeSessionId]);

  // Mandar un mensaje al hilo de un ejercicio.
  const mandarMensaje = async (ex, texto, foto) => {
    const alumnoId = alumnoMirado;
    if (!alumnoId || !ex?.ejercicio) return false;
    if (!hayBackend) return true;
    const r = await persistir(() => enviarMensaje({
      alumnoId, ejercicio: ex.ejercicio, texto, foto,
      sesionId: activeSession?.id, ejercicioId: ex.id,
      semana: activeWeek?.name,
    }), "No se pudo enviar el mensaje.");
    if (!r) { refrescarHilos(); return false; }
    // Aparece en el acto, sin esperar a recargar el hilo.
    setHilos((prev) => {
      const actual = prev[ex.ejercicio] || { total: 0, mensajes: [] };
      const nuevo = {
        id: r.id || `tmp-${Date.now()}`, autor: r.autor || (isCoach ? "coach" : "alumno"),
        autor_id: profile?.id || null,
        texto: texto || null, foto: foto || null,
        semana: activeWeek?.name, cuando: new Date().toISOString(),
      };
      return { ...prev, [ex.ejercicio]: {
        total: (actual.total || 0) + 1,
        mensajes: [...(actual.mensajes || []), nuevo] } };
    });
    return true;
  };

  // Reaccionar a un mensaje. Se ve en el acto y se guarda después.
  const reaccionarMensaje = async (ex, mensaje, emoji) => {
    const quien = isCoach ? "coach" : "alumno";
    const yaEstaba = (mensaje.reacciones || {})[quien] === emoji;
    setHilos((prev) => {
      const h = prev[ex.ejercicio];
      if (!h) return prev;
      return { ...prev, [ex.ejercicio]: { ...h,
        mensajes: h.mensajes.map((m) => {
          if (m.id !== mensaje.id) return m;
          const r = { ...(m.reacciones || {}) };
          // La misma otra vez la saca, igual que en la base.
          if (yaEstaba) delete r[quien]; else r[quien] = emoji;
          return { ...m, reacciones: r };
        }) } };
    });
    if (!hayBackend) return;
    if (String(mensaje.id).startsWith("tmp-")) {
      // Todavía no tiene id real: se relee el hilo y se reacciona
      // sobre el mensaje ya guardado.
      refrescarHilos();
      return;
    }
    const ok = await persistir(() => reaccionar(mensaje.id, emoji),
                               "No se pudo guardar la reacción.", true);
    // Si no entró, la pantalla vuelve a lo que hay guardado: mostrar
    // una reacción que no existe es peor que no mostrarla.
    if (!ok) refrescarHilos();
  };

  // Editar o borrar un mensaje propio del coach. Se ve en el acto; si
  // la base no lo acepta, la pantalla vuelve a lo guardado.
  const puedeTocarMensaje = (m) => isCoach && m.autor === "coach"
    && (!m.autor_id || m.autor_id === profile?.id || !!profile?.admin);
  const cambiarEnHilo = (ex, f) => setHilos((prev) => {
    const h = prev[ex.ejercicio];
    return h ? { ...prev, [ex.ejercicio]: f(h) } : prev;
  });
  const editarMensajeHilo = async (ex, mensaje, texto) => {
    cambiarEnHilo(ex, (h) => ({ ...h, mensajes: h.mensajes.map((m) => (m.id === mensaje.id
      ? { ...m, texto: texto || null, editado: new Date().toISOString() } : m)) }));
    if (!hayBackend) return;
    if (String(mensaje.id).startsWith("tmp-")) { refrescarHilos(); return; }
    const ok = await persistir(() => editarMensaje(mensaje.id, texto), "No se pudo editar el mensaje.", true);
    if (!ok) refrescarHilos();
  };
  const borrarMensajeHilo = async (ex, mensaje) => {
    cambiarEnHilo(ex, (h) => ({ ...h, total: Math.max(0, (h.total || 1) - 1),
      mensajes: h.mensajes.filter((m) => m.id !== mensaje.id) }));
    if (!hayBackend) return;
    if (String(mensaje.id).startsWith("tmp-")) { refrescarHilos(); return; }
    const ok = await persistir(() => borrarMensaje(mensaje.id), "No se pudo borrar el mensaje.", true);
    if (!ok) refrescarHilos();
    else showToast("Mensaje borrado");
  };

  // El hilo entero de un ejercicio, cuando piden ver todo.
  const verHiloCompleto = async (ex) => {
    if (!hayBackend || !alumnoMirado) return;
    const todo = await persistir(
      () => conversacionCompleta(alumnoMirado, ex.ejercicio),
      "No se pudo traer la conversación.");
    if (!todo) return;
    setHilos((prev) => ({ ...prev, [ex.ejercicio]: {
      total: todo.length, mensajes: aLista(todo) } }));
  };

  const irANovedad = (n) => {
    const a = studentsList.find((x) => x.id === n.alumno_id);
    if (!a) return;
    setDestacar(null);
    setIrA({ semanaId: n.semana_id, sesionId: n.sesion_id,
             ejercicioId: n.ejercicio_id, tipo: n.tipo, detalle: n.detalle });
    setSelectedStudent(a);
  };

  useEffect(() => {
    if (!irA) return;
    const semana = weeks.find((w) => w.id === irA.semanaId);
    if (!semana) return;          // todavía no llegaron sus semanas
    const sesion = semana.sessions.find((x) => x.id === irA.sesionId);
    if (!sesion) { setIrA(null); showToast("Esa sesión ya no existe"); return; }

    // Abrir todo lo que haya entre la sesión y el ejercicio: para el
    // coach las secciones arrancan plegadas, y la tarjeta puede estar
    // plegada también.
    const idx = sesion.exercises.findIndex((e) => e.id === irA.ejercicioId);
    const ej = sesion.exercises[idx];
    if (ej) {
      const sub = seccionDe(ej);
      const top = (sub === "movilidad" || sub === "activacion") ? "verde" : sub;
      plegar(`${sesion.id}-sec-${top}`, false);
      if (top === "verde") plegar(`${sesion.id}-sub-${sub}`, false);
      plegar(ej.biserie ? `${sesion.id}-bi${ej.biserie}` : `${sesion.id}-${idx}`, false);
    }

    setActiveWeekId(semana.id);
    setActiveSessionId(sesion.id);
    setWeekOrigin("inicio");
    setView("session");
    setDestacar({ ejercicioId: irA.ejercicioId, tipo: irA.tipo, detalle: irA.detalle });
    setIrA(null);

    // Llevarlo a la vista cuando la tarjeta ya está dibujada.
    setTimeout(() => {
      document.getElementById(`ej-${irA.ejercicioId}`)
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 350);
  }, [irA, weeks]);

  // El remarcado es de ESA visita: al salir de la sesión se borra.
  useEffect(() => {
    if (view !== "session") setDestacar(null);
  }, [view]);
  useEffect(() => {
    if (!hayBackend || role !== "coach" || viendoComo) { setNovedadesDelGrupo([]); return; }
    let vivo = true;
    novedadesGrupo(7).then((n) => vivo && setNovedadesDelGrupo(aLista(n))).catch(() => {});
    return () => { vivo = false; };
  }, [role, viendoComo, screen]);
  useEffect(() => {
    if (!hayBackend || !activeWeek?.id) { setNovedades([]); return; }
    let vivo = true;
    novedadesSemana(activeWeek.id)
      .then((n) => vivo && setNovedades(aLista(n)))
      .catch(() => {});
    return () => { vivo = false; };
  }, [activeWeek?.id]);

  // El botón "atrás" del teléfono cierra la guía en vez de salir de
  // la app: es lo que espera cualquiera que abrió algo encima.
  useEffect(() => {
    if (!verGuia) return;
    window.history.pushState({ guia: true }, "");
    const alVolver = () => setVerGuia(false);
    window.addEventListener("popstate", alVolver);
    return () => {
      window.removeEventListener("popstate", alVolver);
      if (window.history.state?.guia) window.history.back();
    };
  }, [verGuia]);

  useEffect(() => {
    if (!hayBackend || screen !== "app") return;
    // Si falta la migración 052, la función no existe: la lista queda
    // vacía y el panel muestra solo lo del propio alumno.
    insigniasDelGrupo().then((r) => setInsigniasGrupo(Array.isArray(r) ? r : []))
                       .catch(() => setInsigniasGrupo([]));
  }, [screen, viendoComo?.id]);

  const refrescarCatalogo = React.useCallback(async () => {
    if (!hayBackend || !isCoach) return;
    try { setCatalogoInsignias(aLista(await insigniasConDuenos())); }
    catch { /* si falla, la lista queda como estaba */ }
  }, [isCoach]);

  useEffect(() => {
    if (view === "solicitudes") refrescarCatalogo();
  }, [view, refrescarCatalogo]);

  // Al pasar a mirar como otro alumno, sus insignias se recargan: si
  // no, quedaban las del anterior.
  useEffect(() => {
    if (hayBackend && screen === "app") refrescarLogros();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viendoComo?.id]);

  // Dar o quitar una insignia a mano, sin esperar a que la reclamen.
  const alternarInsignia = async (alumnoId, insigniaId, dar) => {
    // En pantalla primero: con veinte alumnos en la lista, esperar la
    // respuesta hace que parezca que el toque no registró.
    setCatalogoInsignias((prev) => prev.map((i) => i.id !== insigniaId ? i : {
      ...i,
      dueños: dar
        ? [...(i.dueños || []), { alumno_id: alumnoId, estado: "earned" }]
        : (i.dueños || []).filter((d) => d.alumno_id !== alumnoId),
    }));
    const ok = await persistir(() => asignarInsignia(alumnoId, insigniaId, dar),
                               "No se pudo cambiar la insignia.");
    if (!ok) { refrescarCatalogo(); return; }

    // Un aviso flotante, no un cartel que haya que confirmar: asignar
    // varias seguidas con una ventana en el medio es un toque de más
    // por cada una.
    const quien = studentsList.find((a) => a.id === alumnoId)?.name?.split(" ")[0] || "";
    const cual = catalogoInsignias.find((i) => i.id === insigniaId)?.nombre || "la insignia";
    showToast(dar ? `🏅 ${cual} para ${quien}` : `Le sacaste ${cual} a ${quien}`);

    // El tablero del inicio cuenta las insignias pendientes, y las
    // notificaciones solo se releen cada dos minutos. Sin pedirlas
    // ahora, el número seguía igual después de asignar.
    if (role === "coach" && !viendoComo) {
      tableroCoach().then(setTablero).catch(() => {});
    }
    refrescarNotificaciones();

    // Si estás mirando a ese alumno, su pantalla se actualiza sola.
    if (viendoComo?.id === alumnoId) refrescarLogros();
  };
  // Qué secciones están abiertas en el armador de plantillas.
  const [secAbiertas, setSecAbiertas] = useState({});
  // Los bloques con nombre dentro de una sección: "zona media",
  // "movilidad de cadera".
  const [nuevoBloque, setNuevoBloque] = useState(null);
  const [renombrandoBloque, setRenombrandoBloque] = useState(null);

  useEffect(() => {
    if (!hayBackend || screen !== "app" || view !== "inicio") return;
    setTablero(null);
    if (role === "coach" && !viendoComo) {
      tableroCoach().then(setTablero).catch(() => {});
      alumnosEnAlerta().then((a) => setAlertas(Array.isArray(a) ? a : [])).catch(() => {});
    } else if (alumnoMirado) {
      tableroAlumno(alumnoMirado).then(setTablero).catch(() => {});
    }
  }, [screen, view, role, viendoComo, alumnoMirado]);

  const refrescarSolicitudesMeta = React.useCallback(async () => {
    if (!hayBackend) return;
    try { setSolicitudesMeta(aLista(await cargarSolicitudesMeta())); } catch { /* ignorar */ }
  }, []);

  useEffect(() => {
    if (screen === "app") refrescarSolicitudesMeta();
  }, [screen, refrescarSolicitudesMeta]);

  const resolverMeta = async (sol, aprobar) => {
    setSolicitudesMeta((prev) => prev.map((x) => x.id !== sol.id ? x
      : { ...x, estado: aprobar ? "aprobada" : "rechazada" }));
    if (!hayBackend) return;
    const ok = await persistir(() => resolverCambioMeta(sol.id, aprobar),
                               "No se pudo resolver la solicitud.");
    if (ok) {
      refrescarSolicitudesMeta();
      refrescarAlumnos();
      showToast(aprobar
        ? `✓ Ahora entrena ${sol.pedida} veces por semana`
        : "Solicitud rechazada");
    }
  };

  useEffect(() => {
    if (!hayBackend || screen !== "app") return;
    cargarTorneo().then(setTorneo).catch(() => {});
    // Se limpia antes de pedir: si no, se ven los puntos del alumno
    // anterior hasta que llega la respuesta.
    setMiSemana(null);
    if (alumnoMirado) miSemanaTorneo(alumnoMirado).then(setMiSemana).catch(() => {});
  }, [screen, alumnoMirado, view]);

  const pedirBorrador = async (tarea, contexto, titulo) => {
    setAsistente({ tarea, titulo, cargando: true, texto: "", error: null });
    try {
      const r = await pedirAsistente(tarea, contexto);
      setAsistente({ tarea, titulo, cargando: false, texto: r.texto, error: null, uso: r.uso });
    } catch (e) {
      setAsistente({ tarea, titulo, cargando: false, texto: "",
                     error: e.message || "No se pudo consultar al asistente" });
    }
  };

  // Los tres pedidos, cada uno con el contexto que necesita.
  const borradorDevolucion = () => {
    if (!activeSession) return;
    pedirBorrador("devolucion",
      contextoSesion(selectedStudent, activeWeek, activeSession, datosDelAlumno, cargasPrevias),
      `Devolución · ${activeSession.name}`);
  };

  const borradorPlanificacion = () => {
    if (!selectedStudent) return;
    pedirBorrador("planificacion",
      contextoPlanificacion(selectedStudent, weeks, datosDelAlumno, exerciseGroups, cargasPrevias),
      `Semana nueva · ${selectedStudent.name}`);
  };

  const borradorRepaso = () => {
    const hoy = new Date().toLocaleDateString("es-AR",
      { weekday: "long", day: "numeric", month: "long" });
    pedirBorrador("repaso", contextoRepaso(studentsList, hoy), "Repaso del grupo");
  };
  // Semana que se está renombrando.
  const [editandoSemana, setEditandoSemana] = useState(null);
  // Nombre y mes de la semana que se está por crear, separados.
  const [nuevaSemana, setNuevaSemana] = useState({ nombre: "", periodo: "" });

  // Los meses que este alumno ya tiene, en orden.
  const mesesUsados = React.useMemo(
    () => [...new Set(weeks.map((w) => w.period).filter(Boolean))], [weeks]);
  const [categoriasDB, setCategoriasDB] = useState([]);

  useEffect(() => {
    if (!hayBackend || screen !== "app" || role !== "coach") return;
    cargarCategorias().then(setCategoriasDB).catch(() => {});
  }, [screen, role]);

  const ponerColorCategoria = async (nombre, color) => {
    recordarColorLocal(nombre, color);
    setExerciseGroups((prev) => [...prev]);   // fuerza el redibujo
    setColorCategoria(null);
    if (!hayBackend) return;
    const fila = categoriasDB.find((c) => c.nombre === nombre);
    try {
      if (fila) await cambiarColorCategoria(fila.id, color);
      else await crearCategoriaEjercicios(nombre, color);
      setCategoriasDB(aLista(await cargarCategorias()));
    } catch { showToast("No se pudo guardar el color"); }
  };
  const [fichaEjercicio, setFichaEjercicio] = useState(null);
  // Selección múltiple para armar una sesión de una.
  const [seleccionados, setSeleccionados] = useState([]);

  const borrarPlantilla = async (templateId, categoryId) => {
    setLibraryCategories((prev) => prev.map((c) => c.id !== categoryId ? c
      : { ...c, templates: c.templates.filter((t) => t.id !== templateId) }));
    setConfirmar(null);
    if (hayBackend) {
      await persistir(() => borrarPlantillaEnBase(templateId), "No se pudo eliminar la sesión.");
      refrescarLibreria();
    }
    showToast("Sesión eliminada de la librería");
  };

  // Al borrar una carpeta, sus sesiones no se pierden: vuelven a
  // "Sin categoría". Perder trabajo por borrar una carpeta sería
  // una sorpresa cara.
  const borrarCarpeta = async (categoryId) => {
    const sinCategoria = libraryCategories[0];
    setLibraryCategories((prev) => {
      const cat = prev.find((c) => c.id === categoryId);
      const rescatadas = cat?.templates || [];
      return prev
        .filter((c) => c.id !== categoryId)
        .map((c, i) => i === 0 ? { ...c, templates: [...c.templates, ...rescatadas] } : c);
    });
    setConfirmar(null);
    if (hayBackend) {
      await persistir(() => borrarCategoria(categoryId, sinCategoria?.id),
                      "No se pudo eliminar la carpeta.");
      refrescarLibreria();
    }
    showToast("Carpeta eliminada — sus sesiones quedaron en Sin categoría");
  };

  const createFolder = async () => {
    if (!newFolderName.trim()) { showToast("Poné un nombre para la carpeta"); return; }
    const nombre = newFolderName.trim();
    const metrica = newFolderMetric;
    setFolderModalOpen(false);
    setNewFolderName("");
    setNewFolderMetric("RIR");

    if (!hayBackend) {
      setLibraryCategories((prev) => [...prev, {
        id: `cat-${Date.now()}`, name: nombre, icon: Folder, templates: [],
        ...(metrica === "RPE" ? { metric: "RPE" } : {}) }]);
      showToast(`✓ Carpeta "${nombre}" creada`);
      return;
    }
    const ok = await persistir(async () => {
      await crearCategoria(nombre, metrica);
      await refrescarLibreria();
      return true;
    }, "No se pudo crear la carpeta.");
    if (ok) showToast(`✓ Carpeta "${nombre}" creada`);
  };

  const handleTemplateDragStart = (e, templateId, fromCategoryId) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    const caja = e.currentTarget.getBoundingClientRect();
    agarreTpl.current = { x: e.clientX - caja.left, y: e.clientY - caja.top };
    setDragTemplate({ id: templateId, from: fromCategoryId });
    setDragTemplateStart({ x: e.clientX, y: e.clientY });
    setDragTemplatePos({ x: e.clientX, y: e.clientY });
  };
  const handleTemplateDragMove = (e) => {
    if (!dragTemplate) return;
    setDragTemplatePos({ x: e.clientX, y: e.clientY });
    const el = document.elementFromPoint(e.clientX, e.clientY);
    const catEl = el && el.closest("[data-category]");
    setHoverCategory(catEl ? catEl.getAttribute("data-category") : null);
  };
  const handleTemplateDragEnd = (e) => {
    const moved = Math.hypot(e.clientX - dragTemplateStart.x, e.clientY - dragTemplateStart.y);
    if (moved >= 6 && dragTemplate && hoverCategory && hoverCategory !== dragTemplate.from) {
      setLibraryCategories((prev) => {
        const source = prev.find((c) => c.id === dragTemplate.from);
        const tpl = source?.templates.find((t) => t.id === dragTemplate.id);
        if (!tpl) return prev;
        return prev.map((c) => {
          if (c.id === dragTemplate.from) return { ...c, templates: c.templates.filter((t) => t.id !== dragTemplate.id) };
          if (c.id === hoverCategory) return { ...c, templates: [...c.templates, tpl] };
          return c;
        });
      });
      setExpandedLibCategories((prev) => ({ ...prev, [hoverCategory]: true }));
      if (hayBackend) {
        persistir(() => moverPlantilla(dragTemplate.id, hoverCategory),
                  "No se pudo mover la sesión de carpeta.")
          .then((ok) => { if (!ok) refrescarLibreria(); });
      }
      showToast("✓ Entrenamiento movido de carpeta");
    }
    setDragTemplate(null);
    setHoverCategory(null);
  };

  const addTemplateToCurrentWeek = async (template) => {
    const newSession = {
      id: `session-${Date.now()}`, name: template.name, estado: "Pendiente", borgRPE: null, fuerzaPercibida: null, puntaje: null, carga: null, day: null,
      hasTimer: !!template.hasTimer, timerConfig: template.timerConfig || DEFAULT_TIMER_CONFIG,
      exercises: template.exercises.map((ex) => ({ ...ex, pesoUsado: "", rirTuyo: "", comentarios: "", pesoPrevia: "", rirPrevia: "", videoAlumno: "" })),
    };
    const semanaId = activeWeek.id;
    setWeeks((prev) => prev.map((w) => (w.id !== semanaId ? w : { ...w, sessions: [...w.sessions, newSession] })));

    if (!hayBackend) {
      showToast(`✓ "${template.name}" agregada a ${activeWeek.name} - ${activeWeek.period}`);
      return;
    }
    const fila = await persistir(() => crearSesion(semanaId, newSession),
                                 "La sesión no se guardó. Probá de nuevo.");
    if (!fila) return;
    // Los ids REALES, los de la sesión y los de cada ejercicio.
    //
    // Antes solo se reemplazaba el de la sesión: los ejercicios
    // quedaban con el id temporal que inventó el teléfono, y todo lo
    // que el coach editaba después viajaba a una fila que no existe.
    // Él lo veía cambiado en pantalla y el alumno seguía viendo la
    // plantilla original.
    const reales = Array.isArray(fila.ejercicios) ? fila.ejercicios : [];
    setWeeks((prev) => prev.map((w) => w.id !== semanaId ? w : {
      ...w, sessions: w.sessions.map((se) => se.id !== newSession.id ? se : {
        ...se, id: fila.id,
        exercises: (se.exercises || []).map((ex, k) =>
          reales[k]?.id ? { ...ex, id: reales[k].id } : ex),
      }) }));
    refrescarAlumnos();
    showToast(`✓ "${template.name}" agregada a ${activeWeek.name} - ${activeWeek.period}`);
  };

  // Asignar a varios de una. Antes había que abrir el modal, elegir
  // uno, esperar, y volver a abrirlo: con quince alumnos recibiendo
  // la misma sesión eso son quince vueltas.
  const [aQuienes, setAQuienes] = useState([]);
  const [buscarAlumno, setBuscarAlumno] = useState("");
  const [asignando, setAsignando] = useState(false);

  const asignarAVarios = async (template) => {
    if (!aQuienes.length) { showToast("Elegí al menos uno"); return; }
    const elegidos = studentsList.filter((s) => aQuienes.includes(s.id));
    setAsignando(true);
    let bien = 0;
    const fallaron = [];

    for (const st of elegidos) {
      const sesion = {
        id: `session-${Date.now()}-${st.id}`, name: template.name, estado: "Pendiente",
        borgRPE: null, fuerzaPercibida: null, puntaje: null, carga: null, day: null,
        hasTimer: !!template.hasTimer, timerConfig: template.timerConfig || DEFAULT_TIMER_CONFIG,
        exercises: template.exercises.map((ex) => ({
          ...ex, pesoUsado: "", rirTuyo: "", comentarios: "", pesoPrevia: "",
          rirPrevia: "", videoAlumno: "",
          tecnicaConfig: ex.tecnicaConfig ? { ...ex.tecnicaConfig } : null,
        })),
      };
      if (!hayBackend) { bien += 1; continue; }
      try { await asignarPlantilla(st.id, sesion); bien += 1; }
      // Se anota quién falló en vez de cortar: que uno no reciba la
      // sesión no es motivo para que los otros catorce tampoco.
      catch { fallaron.push(st.name.split(" ")[0]); }
    }

    setAsignando(false);
    setAssignModal(null);
    setAQuienes([]);
    setBuscarAlumno("");
    if (alumnoMirado) cargarSemanas(alumnoMirado).then(setWeeks).catch(() => {});

    if (fallaron.length) {
      setSincro({ cargando: false, guardando: false,
        error: `No se pudo asignar a: ${fallaron.join(", ")}. Probá de nuevo con ellos.` });
    } else {
      showToast(bien === 1
        ? `✓ "${template.name}" asignada a ${elegidos[0].name.split(" ")[0]}`
        : `✓ "${template.name}" asignada a ${bien} Be Trainers`);
    }
  };



  // Antes que nada: si llegó por invitación, primero la contraseña.
  if (invitacion) {
    return <PonerPassword esRecuperacion={invitacion?.tipo === "recovery"} onListo={async () => {
      setInvitacion(null);
      const perfil = await cargarPerfil().catch(() => null);
      if (perfil) handleLogin(perfil.rol, `${perfil.nombre} ${perfil.apellido}`.trim(), perfil);
    }} />;
  }

  if (screen === "login") return <LoginScreen onLogin={handleLogin} />;

  // Mientras llega lo esencial. Sin esto la app aparece vacía unos
  // segundos y parece colgada: los recuadros en cero, la lista sin
  // nadie, y todo poblándose de a pedazos.
  if (hayBackend && !listoParaMostrar) return <PantallaCargando />;

  return (
    <div className={`min-h-screen bg-neutral-900 text-white font-sans tema-${prefs.tema} ${viendoComo ? "pt-9" : ""}`}
      style={{ fontFamily: "'Inter', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600&display=swap');
        .font-display { font-family: 'Space Grotesk', sans-serif; }
        select { color-scheme: dark; }

        /* ── Movimiento ──────────────────────────────────────
           Todo corto y con desaceleración: la animación tiene que
           explicar de dónde vino algo, no hacerse notar. Nada pasa
           de 260ms, que es el umbral donde una transición deja de
           sentirse instantánea y empieza a sentirse lenta. */

        @keyframes entrarAbajo {
          from { opacity: 0; transform: translateY(10px); }
          to   { opacity: 1; transform: none; }
        }
        @keyframes entrarSuave {
          from { opacity: 0; transform: scale(0.97); }
          to   { opacity: 1; transform: none; }
        }
        @keyframes subirModal {
          from { opacity: 0; transform: translateY(24px) scale(0.98); }
          to   { opacity: 1; transform: none; }
        }
        @keyframes aparecerFondo {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes latir {
          0%, 100% { transform: scale(1); }
          50%      { transform: scale(1.06); }
        }

        /* La barra de lo que se guarda solo: no sabe cuánto falta,
           así que recorre la pantalla en vez de fingir un porcentaje. */
        @keyframes recorrer {
          0%   { transform: translateX(-100%); }
          100% { transform: translateX(400%); }
        }
        .barra-indefinida {
          width: 25%;
          animation: recorrer 1.1s ease-in-out infinite;
        }

        @keyframes girar { to { transform: rotate(360deg); } }

        /* El ejercicio al que se llegó desde una novedad: un pulso
           suave para que el ojo lo encuentre, sin tapar nada. */
        @keyframes resaltarNovedad {
          0%, 100% { box-shadow: 0 0 0 2px #fbbf24; }
          50%      { box-shadow: 0 0 0 6px #fbbf2440; }
        }
        .resaltar-novedad { animation: resaltarNovedad 1.4s ease-in-out infinite; }
        .giro { animation: girar 0.7s linear infinite; }

        /* El contenido de una tarjeta o sección al abrirse. Sin esto
           aparece de golpe con todo su alto y el salto se nota. */
        @keyframes desplegar {
          from { opacity: 0; transform: translateY(-6px); }
          to   { opacity: 1; transform: none; }
        }
        .desplegar { animation: desplegar 260ms cubic-bezier(0.16, 1, 0.3, 1) both; }

        /* Al abrirse una tarjeta, lo de adentro entra suave. Se aplica
           desde el contenedor y no envolviendo el contenido: envolverlo
           obligaba a tocar el cierre de cada bloque, y ahí es fácil
           romper algo por un paréntesis. */
        .tarjeta-abierta > *:not(:first-child) {
          animation: desplegar 240ms cubic-bezier(0.16, 1, 0.3, 1) both;
        }

        /* Cambio de pestaña: el contenido entra desde abajo. */
        .vista-entra { animation: entrarAbajo 300ms cubic-bezier(0.16, 1, 0.3, 1) both; }

        /* Tarjetas de una lista: entran escalonadas, así el ojo
           sigue el orden en vez de recibir todo de golpe. */
        .lista-entra > * { animation: entrarSuave 320ms cubic-bezier(0.16, 1, 0.3, 1) both; }
        .lista-entra > *:nth-child(1) { animation-delay: 0ms; }
        .lista-entra > *:nth-child(2) { animation-delay: 35ms; }
        .lista-entra > *:nth-child(3) { animation-delay: 70ms; }
        .lista-entra > *:nth-child(4) { animation-delay: 105ms; }
        .lista-entra > *:nth-child(5) { animation-delay: 140ms; }
        .lista-entra > *:nth-child(n+6) { animation-delay: 170ms; }

        /* Ventanas emergentes. */
        .modal-fondo { animation: aparecerFondo 160ms ease-out both; }
        .modal-caja  { animation: subirModal 280ms cubic-bezier(0.16, 1, 0.3, 1) both; }

        /* Algo que se acaba de crear: un latido y listo. */
        .recien-creado { animation: latir 400ms ease-out; }

        /* Todo lo que se puede tocar responde al toque. */
        button:not(:disabled):active,
        [role="button"]:active { transform: scale(0.975); }
        button { transition: transform 90ms ease, background-color 160ms ease,
                             border-color 160ms ease, color 160ms ease; }

        /* ── Tamaño de texto ─────────────────────────────────
           La app usa tamaños fijos en píxeles, así que cambiar el
           font-size de la raíz no hacía nada. Se escala el contenido
           entero, que además agranda los espacios y las áreas
           táctiles en la misma proporción: el resultado se ve
           parejo en vez de textos grandes en cajas chicas. */
        /* La barra deslizable. El punto tiene que ser grande: se
           maneja con el pulgar, no con el mouse. */
        input[type="range"] {
          -webkit-appearance: none;
          appearance: none;
          background: transparent;
          cursor: pointer;
        }
        input[type="range"]::-webkit-slider-runnable-track {
          height: 6px;
          border-radius: 999px;
          background: #404040;
        }
        input[type="range"]::-moz-range-track {
          height: 6px;
          border-radius: 999px;
          background: #404040;
        }
        input[type="range"]::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 22px;
          height: 22px;
          margin-top: -8px;
          border-radius: 50%;
          background: #38bdf8;
          border: 3px solid #171717;
          box-shadow: 0 1px 4px rgba(0,0,0,0.5);
          transition: transform 100ms ease;
        }
        input[type="range"]::-moz-range-thumb {
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background: #38bdf8;
          border: 3px solid #171717;
          box-shadow: 0 1px 4px rgba(0,0,0,0.5);
        }
        input[type="range"]:active::-webkit-slider-thumb { transform: scale(1.15); }

        /* ── Tema claro ──────────────────────────────────────
           Cada selector va en su propia regla. Agrupados con coma,
           un solo selector inválido hace que el navegador descarte
           el grupo entero, y ahí se perdían los fondos de las
           tarjetas junto con los que llevan barra en el nombre. */
        /* Modo claro con el mismo aire azulado que el oscuro, y el celeste
           de la marca oscurecido: el #38bdf8 sobre blanco da 2.0 de
           contraste, muy por debajo del 4.5 legible. */
        /* Las reglas del tema cuelgan del <html>, no de un div: la
           barra de navegación de abajo está fuera de ese div y en modo
           claro se quedaba oscura, con una franja negra debajo. */
        html.claro, html.claro body { background: #f5f7fa !important; color: #1e293b !important; }
        html.claro .text-sky-400 { color: #0674a6 !important; }
        html.claro .bg-sky-400 { background-color: #0674a6 !important; }
        html.claro .bg-sky-400 { color: #ffffff !important; }
        html.claro .border-sky-400 { border-color: #0674a6 !important; }
        html.claro .accent-sky-400 { accent-color: #0674a6 !important; }
        html.claro .text-emerald-400 { color: #167f3d !important; }
        html.claro .text-red-400 { color: #de1313 !important; }
        html.claro .text-yellow-400 { color: #b45304 !important; }
        html.claro .bg-neutral-950 { background-color: #f7f7f9 !important; }
        html.claro .bg-neutral-900 { background-color: #f7f7f9 !important; }
        html.claro .bg-neutral-800 { background-color: #ffffff !important; }
        html.claro .bg-neutral-700 { background-color: #eef2f7 !important; }
        html.claro .bg-neutral-600 { background-color: #e2e8f0 !important; }
        html.claro .border-neutral-800 { border-color: #eeeef2 !important; }
        html.claro .border-neutral-700 { border-color: #e6e6ec !important; }
        html.claro .border-neutral-600 { border-color: #dcdce4 !important; }
        html.claro .border-neutral-500 { border-color: #c4c4ce !important; }
        html.claro .text-white { color: #1f1f23 !important; }
        html.claro .text-neutral-100 { color: #1f1f23 !important; }
        html.claro .text-neutral-200 { color: #26262b !important; }
        html.claro .text-neutral-300 { color: #33333a !important; }
        html.claro .text-neutral-400 { color: #55555f !important; }
        html.claro .text-neutral-500 { color: #6e6e79 !important; }
        html.claro .text-neutral-600 { color: #85858f !important; }
        html.claro .text-neutral-700 { color: #9c9ca6 !important; }
        html.claro .text-sky-400 { color: #4f46e5 !important; }
        html.claro .bg-sky-400 { background-color: #4f46e5 !important; }
        html.claro .border-sky-400 { border-color: #4f46e5 !important; }
        html.claro .text-emerald-400 { color: #059669 !important; }
        html.claro .text-amber-400 { color: #b45309 !important; }
        html.claro .text-amber-300 { color: #b45309 !important; }
        html.claro .text-red-400 { color: #dc2626 !important; }
        html.claro .text-red-300 { color: #dc2626 !important; }
        html.claro .text-pink-400 { color: #db2777 !important; }
        html.claro .text-orange-400 { color: #ea580c !important; }
        html.claro .bg-neutral-900\\/60 { background-color: #f7f7f9 !important; }
        html.claro .bg-neutral-900\\/90 { background-color: #f7f7f9 !important; }
        html.claro .bg-neutral-900\\/95 { background-color: #f7f7f9 !important; }
        html.claro .bg-neutral-800\\/60 { background-color: #ffffff !important; }
        html.claro .bg-neutral-800\\/90 { background-color: #ffffff !important; }
        html.claro .bg-neutral-800\\/95 { background-color: #ffffff !important; }
        html.claro .bg-neutral-700\\/40 { background-color: #f6f6f9 !important; }
        html.claro .bg-neutral-700\\/50 { background-color: #f6f6f9 !important; }
        html.claro .bg-sky-400\\/10 { background-color: #eeeefc !important; }
        html.claro .bg-amber-400\\/10 { background-color: #fdf6e3 !important; }
        html.claro .bg-amber-400\\/5 { background-color: #fdf9ef !important; }
        html.claro .bg-emerald-400\\/10 { background-color: #e7f9f1 !important; }
        html.claro .bg-red-400\\/10 { background-color: #fdeeed !important; }
        html.claro .bg-red-400\\/5 { background-color: #fdf4f3 !important; }
        html.claro .bg-red-500\\/15 { background-color: #fdeeed !important; }
        html.claro .bg-pink-400\\/10 { background-color: #fdeef5 !important; }

        /* Lo que va dentro de un botón violeta sigue en blanco. */
        html.claro .bg-sky-400 { color: #ffffff !important; }
        html.claro .text-black { color: #ffffff !important; }

        /* Campos de formulario. */
        html.claro select { color-scheme: light; }
        html.claro input { background-color: #ffffff !important; color: #1f1f23 !important; border-color: #dcdce4 !important; }
        html.claro textarea { background-color: #ffffff !important; color: #1f1f23 !important; border-color: #dcdce4 !important; }
        html.claro select { background-color: #ffffff !important; color: #1f1f23 !important; border-color: #dcdce4 !important; }

        /* Con grises tan cercanos, lo que separa una tarjeta del
           fondo es la sombra, no el color. */
        html.claro .rounded-xl { box-shadow: 0 1px 2px rgba(31,31,35,0.05), 0 1px 8px rgba(31,31,35,0.04); }
        html.claro .rounded-2xl { box-shadow: 0 6px 20px rgba(31,31,35,0.10); }
        html.claro .shadow-lg { box-shadow: 0 6px 20px rgba(31,31,35,0.12) !important; }

        /* Colores puestos a mano en cada elemento (no con clases).
           Las reglas de arriba no los alcanzan: eran del modo oscuro
           y en claro quedaban letras claras sobre blanco y cajas
           oscuras con letras oscuras. Se reconocen por el color
           escrito en el elemento y se cambian por uno legible. */
        html.claro [style^="color: rgb(250, 204, 21)"] { color: #a16207 !important; }
        html.claro [style*="; color: rgb(250, 204, 21)"] { color: #a16207 !important; }
        html.claro [style^="color: rgb(250, 250, 250)"] { color: #1f1f23 !important; }
        html.claro [style*="; color: rgb(250, 250, 250)"] { color: #1f1f23 !important; }
        html.claro [style^="color: rgb(245, 245, 245)"] { color: #1f1f23 !important; }
        html.claro [style*="; color: rgb(245, 245, 245)"] { color: #1f1f23 !important; }
        html.claro [style^="color: rgb(226, 232, 240)"] { color: #334155 !important; }
        html.claro [style*="; color: rgb(226, 232, 240)"] { color: #334155 !important; }
        html.claro [style^="color: rgb(209, 213, 219)"] { color: #6b7280 !important; }
        html.claro [style*="; color: rgb(209, 213, 219)"] { color: #6b7280 !important; }
        html.claro [style^="color: rgb(163, 163, 163)"] { color: #55555f !important; }
        html.claro [style*="; color: rgb(163, 163, 163)"] { color: #55555f !important; }
        html.claro [style^="color: rgb(148, 163, 184)"] { color: #64748b !important; }
        html.claro [style*="; color: rgb(148, 163, 184)"] { color: #64748b !important; }
        html.claro [style^="color: rgb(56, 189, 248)"] { color: #0369a1 !important; }
        html.claro [style*="; color: rgb(56, 189, 248)"] { color: #0369a1 !important; }
        html.claro [style^="color: rgb(52, 211, 153)"] { color: #047857 !important; }
        html.claro [style*="; color: rgb(52, 211, 153)"] { color: #047857 !important; }
        html.claro [style^="color: rgb(34, 197, 94)"] { color: #15803d !important; }
        html.claro [style*="; color: rgb(34, 197, 94)"] { color: #15803d !important; }
        html.claro [style^="color: rgb(74, 222, 128)"] { color: #15803d !important; }
        html.claro [style*="; color: rgb(74, 222, 128)"] { color: #15803d !important; }
        html.claro [style^="color: rgb(111, 196, 141)"] { color: #2f7d4a !important; }
        html.claro [style*="; color: rgb(111, 196, 141)"] { color: #2f7d4a !important; }
        html.claro [style^="color: rgb(224, 160, 104)"] { color: #a55a17 !important; }
        html.claro [style*="; color: rgb(224, 160, 104)"] { color: #a55a17 !important; }
        html.claro [style^="color: rgb(224, 122, 122)"] { color: #b91c1c !important; }
        html.claro [style*="; color: rgb(224, 122, 122)"] { color: #b91c1c !important; }
        html.claro [style^="color: rgb(248, 113, 113)"] { color: #dc2626 !important; }
        html.claro [style*="; color: rgb(248, 113, 113)"] { color: #dc2626 !important; }
        html.claro [style^="color: rgb(212, 181, 85)"] { color: #8a6d12 !important; }
        html.claro [style*="; color: rgb(212, 181, 85)"] { color: #8a6d12 !important; }
        html.claro [style^="color: rgb(167, 139, 250)"] { color: #6d28d9 !important; }
        html.claro [style*="; color: rgb(167, 139, 250)"] { color: #6d28d9 !important; }
        html.claro [style^="color: rgb(251, 146, 60)"] { color: #c2410c !important; }
        html.claro [style*="; color: rgb(251, 146, 60)"] { color: #c2410c !important; }
        html.claro [style^="color: rgb(244, 114, 182)"] { color: #be185d !important; }
        html.claro [style*="; color: rgb(244, 114, 182)"] { color: #be185d !important; }
        html.claro [style^="color: rgb(249, 115, 22)"] { color: #c2410c !important; }
        html.claro [style*="; color: rgb(249, 115, 22)"] { color: #c2410c !important; }
        html.claro [style^="color: rgb(96, 165, 250)"] { color: #1d4ed8 !important; }
        html.claro [style*="; color: rgb(96, 165, 250)"] { color: #1d4ed8 !important; }
        html.claro [style^="color: rgb(129, 140, 248)"] { color: #4338ca !important; }
        html.claro [style*="; color: rgb(129, 140, 248)"] { color: #4338ca !important; }
        html.claro [style^="color: rgb(45, 212, 191)"] { color: #0f766e !important; }
        html.claro [style*="; color: rgb(45, 212, 191)"] { color: #0f766e !important; }
        html.claro [style*="background: rgb(38, 38, 38)"] { background: #ffffff !important; }
        html.claro [style*="background-color: rgb(38, 38, 38)"] { background-color: #ffffff !important; }
        html.claro [style*="background: rgb(48, 48, 48)"] { background: #f1f3f7 !important; }
        html.claro [style*="background-color: rgb(48, 48, 48)"] { background-color: #f1f3f7 !important; }
        html.claro [style*="background: rgb(64, 64, 64)"] { background: #e2e8f0 !important; }
        html.claro [style*="background-color: rgb(64, 64, 64)"] { background-color: #e2e8f0 !important; }
        html.claro [style*="background: rgba(38, 38, 38, 0.5)"] { background: #f6f6f9 !important; }
        html.claro [style*="background-color: rgba(38, 38, 38, 0.5)"] { background-color: #f6f6f9 !important; }
        html.claro [style*="background: rgb(22, 32, 46)"] { background: #eef6fc !important; }
        html.claro [style*="background-color: rgb(22, 32, 46)"] { background-color: #eef6fc !important; }
        html.claro [style*="background: rgb(23, 23, 23)"] { background: #f7f7f9 !important; }
        html.claro [style*="background-color: rgb(23, 23, 23)"] { background-color: #f7f7f9 !important; }
        html.claro [style*="background: rgb(115, 115, 115)"] { background: #cbd5e1 !important; }
        html.claro [style*="background-color: rgb(115, 115, 115)"] { background-color: #cbd5e1 !important; }
        html.claro [style*="solid rgb(64, 64, 64)"] { border-color: #dcdce4 !important; }
        html.claro [style*="border-color: rgb(64, 64, 64)"] { border-color: #dcdce4 !important; }
        html.claro .bg-neutral-700\\/30 { background-color: #f6f6f9 !important; }
        html.claro .bg-neutral-700\\/70 { background-color: #eef2f7 !important; }
        html.claro .bg-neutral-800\\/40 { background-color: #ffffff !important; }
        html.claro .bg-neutral-800\\/80 { background-color: #ffffff !important; }
        html.claro .bg-neutral-900\\/50 { background-color: #f7f7f9 !important; }
        html.claro .bg-emerald-500 { background-color: #047857 !important; }
        html.claro .bg-neutral-900\\/40 { background-color: #f1f3f7 !important; }
        html.claro select[style*="border-color: rgb(52, 211, 153)"] { border-color: #047857 !important; }
        html.claro select[style*="border-color: rgb(248, 113, 113)"] { border-color: #dc2626 !important; }
        html.claro select[style*="border-color: rgb(250, 204, 21)"] { border-color: #a16207 !important; }
        html.claro .bg-violet-400 { background-color: #6d28d9 !important; }


        /* Nada de esto para quien pidió menos movimiento. */
        @media (prefers-reduced-motion: reduce) {
          *, *::before, *::after {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
          }
        }
      `}</style>


      <div data-cabecera className="sticky top-0 z-20 bg-neutral-900/90 backdrop-blur border-b border-neutral-700 px-4 md:px-8 md:pl-64 py-3 flex items-center gap-3 overflow-hidden">
        {!(view === "alumnos" || view === "ranking" || view === "perfil" || view === "insignias" || view === "inicio" || view === "libreria" || view === "solicitudes" || view === "biomecanica" || (view === "weeks" && isAlumno)) && (
          <button
            onClick={() => {
              // Si quedaron cambios, se vuelcan antes de salir: la cola
              // espera 700ms y salir antes los perdería.
              if (Object.keys(pendientesCoach.current).length) guardarCambiosYa();
              if (view === "newSession") cancelNewSessionForm();
              else if (view === "newTemplate") cancelTemplateBuilder();
              // Desde una sesión se vuelve a donde se entró. Con las
              // sesiones a la vista en la lista, pasar por la pantalla
              // de la semana es un paso que ya no aporta nada.
              else if (view === "session") {
                // Volcar lo que quedó en la cola ANTES de salir.
                //
                // Lo que carga el alumno espera a que pare de escribir
                // antes de guardarse. Si tocaba "volver" en esa espera,
                // la cola se descartaba y al recargar la sesión venía
                // de la base sin esos datos: parecía que se le borraba
                // todo lo completado.
                clearTimeout(temporizador.current);
                guardarPendientes();

                // Un aviso que se va solo, no una ventana que hay que
                // cerrar: el mensaje es "quedate tranquilo, está
                // guardado", y hacerle tocar un botón para salir dice
                // justo lo contrario. Solo si dejó algo cargado.
                if (isAlumno && activeSession?.estado !== "Completado"
                    && activeSession?.exercises?.some(ejercicioRegistrado)) {
                  showToast("✓ Guardado · podés retomarlo desde el inicio");
                }
                setView(weekOrigin || "weeks");
              }
              else if (view === "week") setView(weekOrigin);
              else if (view === "solicitudes") setView("alumnos");
              else if (view === "planificador") setView("alumnos");
              else if (view === "weeks" && isCoach) setView("alumnos");
              else if (view === "historial") setView("perfil");
            }}
            className="p-1.5 rounded-full hover:bg-neutral-700 text-neutral-400 hover:text-sky-400 transition-colors"><ChevronLeft size={18} /></button>
        )}
        <div className="flex items-center gap-2 flex-1 min-w-0">
          {/* En escritorio el logo ya está en la columna lateral. */}
          <div className="w-9 h-9 flex items-center justify-center shrink-0 md:hidden">
            <img src={prefs.tema === "claro" ? LOGO_CLARO : LOGO_URI} alt="Be Training"
              className="h-full w-full object-contain" />
          </div>
          {/* min-w-0 y truncate: sin esto, un nombre de sesión largo
              sin espacios ensancha toda la página y la app queda
              corrida, con una franja negra al costado. */}
          <div className="flex-1 min-w-0">
            <p className="font-display text-sm font-semibold leading-none truncate">
              {view === "inicio" && "Inicio"}
              {view === "alumnos" && "Be Trainers"}
              {view === "ranking" && "Ranking"}
              {view === "perfil" && "Mi perfil"}
              {view === "insignias" && "Insignias"}
              {view === "biomecanica" && "Biomecánica"}
              {view === "planificador" && "Planificador"}
              {view === "libreria" && "Librería"}
              {view === "historial" && "Historial de entrenamientos"}
              {view === "newTemplate" && (draftTemplate?.editando ? "Editar sesión" : "Nueva sesión de librería")}
              {view === "solicitudes" && "Solicitudes de insignias"}
              {/* Al alumno se le mostraba su propio nombre, que ya
                  sabe. El título tiene que decirle dónde está.
                  Para el coach sí aporta: le dice de quién es el plan
                  que está mirando. */}
              {view === "weeks" && (isCoach ? selectedStudent?.name || "Be Trainer" : "Mis entrenos")}
              {view === "week" && `${activeWeek?.name} - ${activeWeek?.period}`}
              {view === "session" && activeSession?.name}
              {view === "newSession" && "Nueva sesión"}
            </p>
            <p className="text-[11px] text-neutral-500 mt-0.5 truncate">
              {view === "weeks" && isCoach ? "Plan de entrenamiento" : "Be Training"}
            </p>
          </div>
        </div>
        <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${isCoach ? "text-sky-400 border-sky-400/30 bg-sky-400/10" : "text-sky-400 border-neutral-700 bg-neutral-700"}`}>
          {isCoach ? "Coach" : "Be Trainer"}
        </span>

        {/* Campanita: a la derecha de la etiqueta de rol. */}
        {hayBackend && (
          <button onClick={() => setPanelNotif((v) => !v)}
            title="Novedades"
            className="relative p-1.5 rounded-full hover:bg-neutral-700 text-neutral-500 hover:text-sky-400 transition-colors">
            <Bell size={16} />
            {sinLeer > 0 && (
              <span className="absolute -top-0.5 -right-0.5 min-w-[15px] h-[15px] px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center">
                {sinLeer > 9 ? "9+" : sinLeer}
              </span>
            )}
          </button>
        )}
        {hayBackend && isCoach && (
          <button onClick={correrDiagnostico} title="Ver qué hay guardado en la base"
            className="p-1.5 rounded-full hover:bg-neutral-700 text-neutral-500 hover:text-sky-400 transition-colors"><Database size={15} /></button>
        )}
        <button onClick={handleLogout} className="p-1.5 rounded-full hover:bg-neutral-700 text-neutral-500 hover:text-red-400 transition-colors"><LogOut size={15} /></button>
      </div>

      {/* La key hace que React rehaga este bloque al cambiar de
          pestaña, y eso dispara la animación de entrada. */}
      {/* El contenido se corre a la derecha de la columna lateral y se
          ensancha: en una pantalla de computadora, una columna angosta
          en el medio deja el 70% de la pantalla vacío. */}
      <div key={view} className="md:pl-56">
      {/* Las planillas (planificador y vista de lista) usan todo el
          ancho en la computadora: con una columna de 768 píxeles había
          que deslizarlas de costado aunque sobrara pantalla. Las
          tarjetas y el resto siguen angostos, que se leen mejor. */}
      <div className={`max-w-md ${(view === "planificador"
          || ((view === "session" || view === "newTemplate") && vistaSesion === "lista"))
          ? "md:max-w-[1680px]" : "md:max-w-3xl"} mx-auto px-4 md:px-8 pt-4 md:pt-8 vista-entra`}
        style={{ paddingBottom: "calc(96px + env(safe-area-inset-bottom))" }}>
        {view === "alumnos" && (() => {
          const query = trainerSearch.trim().toLowerCase();
          const filtrados = query ? studentsList.filter((s) => s.name.toLowerCase().includes(query)) : studentsList;

          // El orden por defecto sigue siendo el de siempre. Los otros
          // dos responden preguntas distintas: "dónde está fulano" y
          // "a quién me falta armarle la semana".
          const exactMatches = [...filtrados].sort((a, b) => {
            if (ordenTrainers === "alfabetico") {
              return a.name.localeCompare(b.name, "es");
            }
            if (ordenTrainers === "sin-plan") {
              // Primero los que no tienen nada asignado: son los que
              // requieren que hagas algo.
              const sa = estadoSemana(a).sinPlan ? 0 : 1;
              const sb = estadoSemana(b).sinPlan ? 0 : 1;
              if (sa !== sb) return sa - sb;
              return a.name.localeCompare(b.name, "es");
            }
            if (ordenTrainers === "con-plan") {
              const sa = estadoSemana(a).sinPlan ? 1 : 0;
              const sb = estadoSemana(b).sinPlan ? 1 : 0;
              if (sa !== sb) return sa - sb;
              return a.name.localeCompare(b.name, "es");
            }
            return 0;
          });
          const suggestions = query && exactMatches.length === 0 ? fuzzyMatchStudents(trainerSearch, studentsList) : [];
          return (
            <div className="space-y-2.5">
              {/* Todas las semanas nuevas en una planilla, sin entrar y
                  salir de cada alumno. */}
              {studentsList.length > 0 && hayBackend && (
                <button onClick={() => setView("planificador")}
                  className="w-full flex items-center justify-center gap-2 text-xs font-semibold text-black bg-sky-400 hover:bg-sky-200 rounded-xl py-2.5 transition-colors">
                  <ClipboardList size={14} /> Planificar semanas nuevas
                </button>
              )}

              <div className="flex items-center justify-between mb-1">
                <p className="text-neutral-500 text-xs">{studentsList.length} Be Trainers · tocá uno para ver su plan</p>
                <button onClick={() => setEditandoTrainers((v) => !v)}
                  className={`flex items-center gap-1 text-[11px] font-medium rounded-full px-2.5 py-1.5 border transition-colors shrink-0 ${
                    editandoTrainers ? "bg-sky-400 text-black border-sky-400"
                      : "text-sky-400 bg-sky-400/10 hover:bg-sky-400/20 border-sky-400/20"}`}>
                  {editandoTrainers ? <><Check size={12} /> Listo</> : <><Pencil size={12} /> Editar</>}
                </button>
              </div>

              {(() => {
                const sinPlan = studentsList.filter((s) => estadoSemana(s).sinPlan).length;
                if (sinPlan === 0) return null;
                return (
                  <div className="flex items-center gap-2 bg-orange-400/10 border border-orange-400/25 rounded-lg px-3 py-2">
                    <Bell size={13} className="text-orange-400 shrink-0" />
                    <p className="text-[11px] text-orange-400">
                      {sinPlan === 1 ? "1 Be Trainer sigue" : `${sinPlan} Be Trainers siguen`} sin sesiones asignadas esta semana
                    </p>
                  </div>
                );
              })()}

              {/* El orden se elige, no se adivina: cada uno responde
                  una pregunta distinta. */}
              <div className="flex gap-1.5">
                {[["alfabetico", "A–Z"],
                  ["sin-plan", "Sin plan primero"],
                  ["con-plan", "Con plan primero"]].map(([id, txt]) => (
                  <button key={id} onClick={() => setOrdenTrainers(id)}
                    className={`flex-1 rounded-lg py-1.5 text-[11px] font-medium border transition-colors ${
                      ordenTrainers === id
                        ? "bg-sky-400 text-black border-sky-400"
                        : "text-neutral-400 border-neutral-600 hover:border-sky-400/40"}`}>
                    {txt}
                  </button>
                ))}
              </div>

              <div className="relative">
                <input value={trainerSearch} onChange={(e) => setTrainerSearch(e.target.value)} placeholder="Buscar Be Trainer..."
                  className="w-full bg-neutral-800 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-lg pl-9 pr-3 py-2 text-sm text-white placeholder-neutral-600 transition-colors" />
                <User size={14} className="absolute left-3 top-2.5 text-neutral-500" />
              </div>

              {suggestions.length > 0 && (
                <div className="bg-sky-400/5 border border-sky-400/20 rounded-lg p-3 space-y-1.5">
                  <p className="text-[11px] text-neutral-400">¿Quisiste decir...?</p>
                  {suggestions.map((s) => (
                    <button key={s.id} onClick={() => { setTrainerSearch(""); openStudent(s); }}
                      className="w-full flex items-center gap-2 text-left hover:bg-sky-400/10 rounded-md px-2 py-1.5 transition-colors">
                      <Avatar student={s} size={22} />
                      <span className="text-sm text-sky-400 font-medium">{s.name}</span>
                    </button>
                  ))}
                </div>
              )}

              {query && exactMatches.length === 0 && suggestions.length === 0 && (
                <p className="text-neutral-600 text-xs text-center py-6">No encontramos ningún Be Trainer con ese nombre.</p>
              )}

              {editandoTrainers && (
                <>
                  <button onClick={() => { setNewTrainerDraft({ nombre: "", apellido: "", email: "" }); setNewTrainerModalOpen(true); }}
                    className="w-full flex items-center justify-center gap-1.5 text-xs font-medium text-sky-400 border border-dashed border-sky-400/40 hover:bg-sky-400/10 rounded-xl py-3 transition-colors">
                    <Plus size={14} /> Sumar Be Trainer
                  </button>

                </>
              )}

              {/* Archivados: al pie de la lista, siempre accesibles. */}
              {inactivos.length > 0 && (
                <div className="space-y-2 pt-2 border-t border-neutral-800">
                  <button onClick={() => setVerInactivos((v) => !v)}
                    className="w-full flex items-center gap-2 text-[11px] text-neutral-500 hover:text-neutral-300 transition-colors py-1">
                    <ChevronDown size={13} className={`transition-transform ${verInactivos ? "" : "-rotate-90"}`} />
                    <Archive size={12} />
                    Archivados ({inactivos.length})
                  </button>
                  {verInactivos && (
                    <div className="space-y-1.5 lista-entra">
                      {inactivos.map((a) => (
                        <div key={a.id} className="flex items-center gap-2.5 bg-neutral-800/60 border border-neutral-700 rounded-lg p-2.5">
                          <div className="w-8 h-8 rounded-full bg-neutral-700 flex items-center justify-center shrink-0">
                            <span className="text-[10px] text-neutral-500 font-bold">
                              {`${a.nombre} ${a.apellido}`.split(" ").map((n) => n[0]).slice(0, 2).join("")}
                            </span>
                          </div>
                          <p className="text-xs text-neutral-500 flex-1 min-w-0 truncate">
                            {a.nombre} {a.apellido}
                          </p>
                          <button onClick={() => altaAlumno(a)}
                            className="text-[10px] font-medium text-emerald-400 border border-emerald-400/30 hover:bg-emerald-400/10 rounded-full px-2.5 py-1 transition-colors shrink-0">
                            Reactivar
                          </button>
                          {editandoTrainers && (
                            <button onClick={() => setConfirmar({ tipo: "eliminar",
                                alumno: { ...a, name: `${a.nombre} ${a.apellido}`.trim() } })}
                              title="Eliminar definitivamente"
                              className="p-1.5 rounded-full text-neutral-600 hover:text-red-400 transition-colors shrink-0">
                              <Trash2 size={13} />
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  <p className="text-[10px] text-neutral-600 leading-relaxed">
                    Sin acceso a la app, pero su historial está guardado. Podés reactivarlos cuando vuelvan.
                  </p>
                </div>
              )}

              {/* Sin alumnos todavía: en vez de una pantalla en blanco,
                  se explica cómo se suman. */}
              {!query && studentsList.length === 0 && (
                <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-6 text-center">
                  <Users size={26} className="text-neutral-600 mx-auto mb-3" />
                  <p className="font-display font-semibold text-sm mb-1.5">Todavía no hay Be Trainers</p>
                  <p className="text-xs text-neutral-500 leading-relaxed mb-4">
                    Cada uno crea su propia cuenta desde el link de la app, tocando
                    “Creá tu cuenta”. Apenas se registran, te aparecen acá.
                  </p>
                  <div className="bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2.5 text-left space-y-3">
                    <div>
                      <p className="text-[10px] uppercase tracking-wider text-neutral-600 mb-1">Link para compartirles</p>
                      <p className="text-xs text-sky-400 break-all">{window.location.origin}</p>
                    </div>
                    {hayBackend && codigoInv && (
                      <div className="pt-3 border-t border-neutral-700">
                        <p className="text-[10px] uppercase tracking-wider text-neutral-600 mb-1">Código de invitación</p>
                        <p className="font-display text-sm font-bold tracking-wider text-emerald-400 break-all">{codigoInv}</p>
                        <p className="text-[10px] text-neutral-600 mt-1">Sin este código nadie puede registrarse.</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="space-y-2 lista-entra">
              {exactMatches.map((s) => {
                const semana = estadoSemana(s);
                return (
                  <button key={s.id} onClick={() => openStudent(s)}
                    className={`w-full bg-neutral-800 border rounded-xl p-4 flex items-center gap-3 transition-colors text-left ${semana.sinPlan ? "border-orange-400/40 hover:border-orange-400/70" : "border-neutral-700 hover:border-sky-400/30"}`}>
                    <div className="w-10 h-10 rounded-full bg-sky-400/10 border border-sky-400/30 flex items-center justify-center shrink-0">
                      <span className="font-display text-sky-400 text-xs font-bold">{s.name.split(" ").map((n) => n[0]).slice(0, 2).join("")}</span>
                    </div>
                    <div className="flex-1 min-w-0">
                      {/* El estado al lado del nombre: quién está
                          entrenando y quién de vacaciones. Sin esto,
                          alguien que avisó que se iba figura igual que
                          alguien que dejó de entrenar sin avisar. */}
                      <p className="font-display font-semibold text-sm truncate flex items-center gap-1.5">
                        <span className="truncate">{s.name}</span>
                        <span className="text-[9px] font-medium px-1.5 py-0.5 rounded shrink-0"
                          style={s.vacaciones
                            ? { color: ESTADO.bien, background: `${ESTADO.bien}1F` }
                            : { color: "#8a8a8a", background: "#ffffff0d" }}>
                          {s.vacaciones ? "Vacaciones" : "Activo"}
                        </span>
                      </p>
                      <p className="text-[11px] mt-0.5 flex items-center gap-1" style={{ color: semana.color }}>
                        {semana.sinPlan && <Bell size={11} />}
                        {semana.texto}
                      </p>
                      {/* La semana que viene, si ya está cargada: de un
                          vistazo, a quién falta planificarle. */}
                      {isCoach && (s.proximaLista ? (
                        <p className="text-[10.5px] mt-1 flex flex-wrap items-center gap-x-1 text-sky-400">
                          <span className="inline-flex items-center gap-1 whitespace-nowrap"><CalendarCheck size={11} /> Próxima semana cargada</span>
                          {s.proximaDesde && <span className="text-neutral-500 whitespace-nowrap">· la ve {textoVisible(s.proximaDesde)}</span>}
                        </p>
                      ) : esFinDeSemanaAR() && !s.vacaciones && (
                        <p className="text-[10.5px] mt-1 flex items-center gap-1 text-neutral-500">
                          <CalendarClock size={11} /> Falta la próxima semana
                        </p>
                      ))}
                      {!semana.sinPlan && (
                        <div className="h-1 bg-neutral-700 rounded-full mt-1.5 overflow-hidden">
                          <div className="h-full rounded-full transition-all" style={{ width: `${semana.pct}%`, background: semana.color }} />
                        </div>
                      )}
                    </div>
                    {editandoTrainers && (
                      <>
                        <span onClick={(e) => { e.stopPropagation(); setConfirmar({ tipo: "archivar", alumno: s }); }}
                          role="button" tabIndex={0}
                          title={`Archivar a ${s.name}`}
                          className="p-2 rounded-full hover:bg-amber-400/10 text-neutral-600 hover:text-amber-400 transition-colors shrink-0">
                          <Archive size={14} />
                        </span>
                        <span onClick={(e) => { e.stopPropagation(); setConfirmar({ tipo: "eliminar", alumno: s }); }}
                          role="button" tabIndex={0}
                          title={`Eliminar a ${s.name} definitivamente`}
                          className="p-2 rounded-full hover:bg-red-400/10 text-neutral-600 hover:text-red-400 transition-colors shrink-0">
                          <Trash2 size={14} />
                        </span>
                      </>
                    )}
                    {/* Solo el coach real. Un alumno nunca ve esta lista,
                        pero la comprobación explícita evita que aparezca
                        mientras el coach está previsualizando a otro. */}
                    {role === "coach" && !viendoComo && (
                    <span onClick={(e) => { e.stopPropagation(); verComoAlumno(s); }}
                      role="button" tabIndex={0}
                      onKeyDown={(e) => { if (e.key === "Enter") { e.stopPropagation(); verComoAlumno(s); } }}
                      title={`Ver la app como ${s.name}`}
                      className="p-2 rounded-full hover:bg-neutral-700 text-neutral-600 hover:text-amber-400 transition-colors shrink-0">
                      <Eye size={14} />
                    </span>
                    )}
                    {semana.sinPlan ? (
                      <span className="text-[10px] font-medium text-orange-400 bg-orange-400/10 border border-orange-400/20 rounded-full px-2 py-1 shrink-0">
                        Armar semana
                      </span>
                    ) : (
                      <div className="text-right shrink-0">
                        <p className="font-display font-semibold text-sm" style={{ color: semana.color }}>
                          {semana.hechas}<span className="text-neutral-600">/{semana.asignadas}</span>
                        </p>
                        <p className="text-[10px] text-neutral-600">esta semana</p>
                      </div>
                    )}
                  </button>
                );
              })}
              </div>
            </div>
          );
        })()}

        {view === "ranking" && (
          <div className="space-y-3">
            {/* Cómo viene la semana. El acumulado no le dice a nadie
                qué le falta hoy: esto sí. */}
            {isAlumno && miSemana && miSemana.meta > 0 && (
              <div className="rounded-xl border-2 p-4"
                style={{ borderColor: `${miSemana.puntos === 3 ? "#22c55e" : "#38bdf8"}66`,
                         background: `${miSemana.puntos === 3 ? "#22c55e" : "#38bdf8"}0D` }}>
                <div className="flex items-center gap-2 mb-2">
                  <Trophy size={14} style={{ color: miSemana.puntos === 3 ? "#22c55e" : "#38bdf8" }} className="shrink-0" />
                  <span className="text-[10px] font-bold uppercase tracking-wider flex-1"
                    style={{ color: miSemana.puntos === 3 ? "#22c55e" : "#38bdf8" }}>
                    Tu semana
                  </span>
                  <span className="font-display text-lg font-bold"
                    style={{ color: miSemana.puntos === 3 ? "#22c55e" : "#38bdf8" }}>
                    {miSemana.puntos} {miSemana.puntos === 1 ? "punto" : "puntos"}
                  </span>
                </div>

                <div className="flex gap-1.5 mb-2">
                  {Array.from({ length: miSemana.meta }, (_, i) => (
                    <div key={i} className="flex-1 h-2 rounded-full transition-colors"
                      style={{ background: i < miSemana.validas
                        ? (miSemana.puntos === 3 ? "#22c55e" : "#38bdf8") : "#404040" }} />
                  ))}
                </div>

                <p className="text-[11px] text-neutral-400">
                  {miSemana.validas} de {miSemana.meta} sesiones validadas
                  {miSemana.validas < miSemana.meta && (
                    <> · te faltan {miSemana.meta - miSemana.validas} para los 3 puntos</>
                  )}
                </p>

                {/* Lo más importante del reglamento: completar no
                    alcanza, hay que mandar la foto al grupo. */}
                {miSemana.sin_compartir > 0 && (
                  <p className="text-[11px] text-yellow-400 mt-2 leading-relaxed">
                    ⚠️ Tenés {miSemana.sin_compartir} {miSemana.sin_compartir === 1 ? "sesión completada" : "sesiones completadas"} sin
                    compartir al grupo. Sin la foto no suman al ranking.
                  </p>
                )}

                {!miSemana.en_temporada && (
                  <p className="text-[10px] text-neutral-500 mt-2">
                    El torneo está fuera de temporada: los puntos de esta semana no cuentan.
                  </p>
                )}
              </div>
            )}

            <p className="text-neutral-500 text-xs">
              {vistaRanking === "semana"
                ? "Los puntos de esta semana · se reinicia el lunes"
                : "Todo el torneo acumulado"}
              {torneo && (
                <span className="block text-[10px] text-neutral-600 mt-0.5">
                  {torneo.nombre} · {new Date(torneo.desde + "T00:00:00").toLocaleDateString("es-AR", { day: "numeric", month: "long" })} al {new Date(torneo.hasta + "T00:00:00").toLocaleDateString("es-AR", { day: "numeric", month: "long" })}
                </span>
              )}
            </p>

            {/* Dos preguntas distintas: cómo viene el torneo y cómo
                viene esta semana. La segunda es la que mueve — el que
                arrancó tarde no alcanza al primero del acumulado, pero
                sí puede ganar la semana. */}
            <div className="flex gap-1.5 mb-3">
              {[["semana", "Esta semana"], ["general", "General"]].map(([k, txt]) => (
                <button key={k} onClick={() => setVistaRanking(k)}
                  className={`flex-1 rounded-lg py-2 text-xs font-medium border transition-colors ${
                    vistaRanking === k
                      ? "bg-sky-400 text-black border-sky-400"
                      : "text-neutral-400 border-neutral-600 hover:border-sky-400/40"}`}>
                  {txt}
                </button>
              ))}
            </div>

            <div className="space-y-2">
            {[...(Array.isArray(studentsList) ? studentsList : [])].sort((a, b) => {
              if (vistaRanking === "semana") {
                const d = (b.puntosSemana || 0) - (a.puntosSemana || 0);
                if (d !== 0) return d;
                // A igual puntaje, primero el que más entrenó.
                const h = (b.hechasSemana || 0) - (a.hechasSemana || 0);
                if (h !== 0) return h;
                return (a.name || "").localeCompare(b.name || "", "es");
              }
              return b.score - a.score;
            }).map((s, i) => {
              const medal = i === 0 ? "#facc15" : i === 1 ? "#d1d5db" : i === 2 ? "#c2793a" : null;
              const soyYo = isAlumno && s.id === "fede";
              return (
                <div key={s.id} className={`w-full rounded-xl p-3.5 flex items-center gap-3 border ${soyYo ? "bg-sky-400/10 border-sky-400/40" : "bg-neutral-800 border-neutral-700"}`}>
                  <div className="w-7 text-center shrink-0">
                    <span className={`font-display font-bold text-sm ${medal ? "" : "text-neutral-600"}`} style={medal ? { color: medal } : {}}>{i + 1}</span>
                  </div>
                  <div className="w-9 h-9 rounded-full bg-sky-400/10 border border-sky-400/30 flex items-center justify-center shrink-0">
                    <span className="font-display text-sky-400 text-[11px] font-bold">{s.name.split(" ").map((n) => n[0]).slice(0, 2).join("")}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-display font-semibold text-sm truncate">
                      {s.name}{soyYo && <span className="text-sky-400 font-normal text-[11px]"> · vos</span>}
                    </p>
                    <p className="text-[11px] text-neutral-500 mt-0.5">{s.sessionsDone}/{s.sessionsTotal} sesiones</p>
                  </div>
                  {/* El total y nada más: es el mismo torneo, que
                      venga de otra app es un detalle nuestro.
                      El coach puede tocar el arrastre desde acá, con
                      los veinte a la vista: entrar a cada perfil para
                      una carga única no tiene sentido. */}
                  {isCoach && editandoPuntos === s.id ? (
                    <span className="flex items-center gap-1 shrink-0"
                      onClick={(e) => e.stopPropagation()}>
                      <input type="number" inputMode="numeric" min={0} max={9999}
                        value={puntosDraft} autoFocus
                        onChange={(e) => setPuntosDraft(e.target.value)}
                        className="w-16 bg-neutral-700 border border-sky-400 focus:outline-none rounded-md px-2 py-1 text-sm text-center" />
                      <button onClick={async () => {
                          const v = Math.max(0, parseInt(puntosDraft) || 0);
                          const ok = await persistir(() => fijarPuntosPrevios(s.id, v),
                                                     "No se pudieron guardar los puntos.");
                          setEditandoPuntos(null);
                          if (ok) {
                            const r = await cargarRanking();
                            setStudentsList(r);
                            showToast(`✓ ${s.name.split(" ")[0]}: ${v} de arrastre`);
                          }
                        }}
                        className="w-7 h-7 rounded-md bg-sky-400 text-black flex items-center justify-center">
                        <Check size={13} strokeWidth={3} />
                      </button>
                      <button onClick={() => setEditandoPuntos(null)}
                        className="w-7 h-7 rounded-md border border-neutral-600 text-neutral-500 flex items-center justify-center">
                        <X size={12} />
                      </button>
                    </span>
                  ) : (
                    <span className="text-right shrink-0">
                      <p className="text-sky-400 font-display font-semibold text-sm">
                        {vistaRanking === "semana" ? (s.puntosSemana || 0) : s.score} pts
                      </p>
                      {/* En la semana, de qué sirve el puntaje: 2 de 3
                          dice más que "2 pts" solo. */}
                      {vistaRanking === "semana" && s.metaSemana > 0 && (
                        <p className="text-[9px] text-neutral-600 leading-tight">
                          {s.hechasSemana} de {s.metaSemana}
                        </p>
                      )}
                      {isCoach && vistaRanking === "general" && (
                        <button onClick={(e) => {
                            e.stopPropagation();
                            setPuntosDraft(String(s.puntosPrevios || 0));
                            setEditandoPuntos(s.id);
                          }}
                          className="text-[9px] text-neutral-600 hover:text-sky-400 transition-colors">
                          {s.puntosPrevios > 0 ? `+${s.puntosPrevios} arrastre` : "sumar arrastre"}
                        </button>
                      )}
                    </span>
                  )}
                </div>
              );
            })}
            </div>

            {/* El reglamento, adentro de la app. Estaba en un PDF que
                nadie vuelve a abrir, y las dudas sobre por qué una
                sesión no sumó son justo las que se responden acá. */}
            <button onClick={() => setReglamentoAbierto((v) => !v)}
              className="w-full flex items-center gap-2 bg-neutral-800 border border-neutral-700 rounded-xl p-3 hover:border-sky-400/30 transition-colors">
              <ScrollText size={14} className="text-neutral-500 shrink-0" />
              <span className="text-xs font-medium flex-1 text-left">Cómo se puntúa</span>
              <ChevronDown size={14}
                className={`text-neutral-500 transition-transform ${reglamentoAbierto ? "" : "-rotate-90"}`} />
            </button>

            {reglamentoAbierto && (
              <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-4 space-y-4 text-xs leading-relaxed">
                <div>
                  <p className="font-display font-semibold text-sm mb-1">Se puntúa el cumplimiento, no la cantidad</p>
                  <p className="text-neutral-400">
                    Cada uno tiene su cantidad de sesiones semanales, la que puso en su perfil.
                    El torneo mide qué porcentaje de <b>esa</b> planificación cumplió. Así el que
                    entrena 2 veces por semana compite en igualdad con el que entrena 5.
                  </p>
                </div>

                <div>
                  <p className="font-display font-semibold text-sm mb-2">Puntos por semana</p>
                  <div className="space-y-1.5">
                    {[["100% de las sesiones", 3, "#22c55e"],
                      ["50% o más, sin llegar al 100%", 2, "#facc15"],
                      ["Menos del 50% (aunque sea una)", 1, "#fb923c"],
                      ["Ninguna sesión", 0, "#737373"]].map(([txt, pts, c]) => (
                      <div key={pts} className="flex items-center gap-2.5 bg-neutral-700/40 rounded-lg px-3 py-2">
                        <span className="text-neutral-300 flex-1">{txt}</span>
                        <span className="font-display font-bold text-sm shrink-0" style={{ color: c }}>
                          {pts} {pts === 1 ? "punto" : "puntos"}
                        </span>
                      </div>
                    ))}
                  </div>
                  <p className="text-[11px] text-neutral-500 mt-2">
                    Los puntos se acumulan durante toda la temporada.
                  </p>
                </div>

                <div className="rounded-lg p-3"
                  style={{ background: "#facc1512", border: "1px solid #facc1533" }}>
                  <p className="font-display font-semibold text-sm mb-1" style={{ color: "#facc15" }}>
                    Completar no alcanza
                  </p>
                  <p className="text-neutral-300">
                    Para que una sesión sume, hay que <b>compartirla al grupo con una foto tuya
                    o una captura del entrenamiento</b>. Sin comprobante no cuenta.
                  </p>
                  <p className="text-neutral-500 mt-1.5 text-[11px]">
                    Es lo que hace que el ranking sea transparente y que nadie pueda cargar
                    sesiones que no hizo. En semanas particulares Mati puede pedir otra
                    consigna —un video del ejercicio, por ejemplo— y lo avisa al grupo.
                  </p>
                </div>

                <div>
                  <p className="font-display font-semibold text-sm mb-1">Temporada y premios</p>
                  <p className="text-neutral-400">
                    {torneo
                      ? <>El torneo va del {new Date(torneo.desde + "T00:00:00").toLocaleDateString("es-AR", { day: "numeric", month: "long" })} al {new Date(torneo.hasta + "T00:00:00").toLocaleDateString("es-AR", { day: "numeric", month: "long" })}. </>
                      : "El torneo va de julio a noviembre. "}
                    Diciembre queda afuera por las fiestas. Al cierre, los <b>tres primeros
                    puestos</b> del acumulado son los ganadores.
                  </p>
                  <p className="text-neutral-500 mt-1.5 text-[11px]">
                    El ranking actualizado se comparte al grupo al inicio de cada semana.
                    Cualquier situación no contemplada la resuelve Mati.
                  </p>
                </div>
              </div>
            )}
          </div>
        )}

        {view === "inicio" && isAlumno && (() => {
          const currentWeek = semanaActual;
          // Alumno recién registrado: todavía no tiene plan asignado.
          if (!currentWeek) {
            return (
              <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-6 text-center">
                <Calendar size={26} className="text-neutral-600 mx-auto mb-3" />
                <p className="font-display font-semibold text-sm mb-1.5">
                  Hola {perfilVista?.name?.split(" ")[0] || "Be Trainer"} 👋
                </p>
                <p className="text-xs text-neutral-500 leading-relaxed">
                  Todavía no tenés entrenamientos asignados. Apenas tu coach te arme
                  la semana, te van a aparecer acá.
                </p>
              </div>
            );
          }
          const doneThisWeek = currentWeek.sessions.filter((s) => s.estado === "Completado").length;
          // Sin día Y sin completar: una sesión ya hecha no tiene sentido
          // arrastrarla, y si aparece ahí parece que quedó pendiente.
          const availableSessions = currentWeek.sessions.filter((s) => !s.day && s.estado !== "Completado");
          return (
            <div className="space-y-4">
              <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-4">
                <p className="font-display font-semibold text-sm mb-1">Hola {perfilVista?.name?.split(" ")[0] || "Be Trainer"} 👋</p>
                <p className="text-xs text-neutral-500">Esta semana completaste {doneThisWeek}/{currentWeek.sessions.length} sesiones · {currentWeek.name} - {currentWeek.period}</p>
              </div>

              {/* Sesión empezada y sin cerrar. Va primero y sin nada
                  arriba: quien vuelve a la app a mitad de un entreno
                  busca eso y nada más. Si no hay ninguna, no ocupa
                  espacio. */}
              {sesionEnCurso && (
                <button
                  onClick={() => {
                    setActiveWeekId(sesionEnCurso.semana.id);
                    setActiveSessionId(sesionEnCurso.sesion.id);
                    setWeekOrigin("inicio");
                    setView("session");
                  }}
                  className="w-full text-left rounded-xl border-2 p-4 transition-transform active:scale-[0.99]"
                  style={{ borderColor: "#38bdf866", background: "#38bdf80F" }}>
                  <div className="flex items-center gap-2 mb-2">
                    <span className="w-2 h-2 rounded-full bg-sky-400 animate-pulse shrink-0" />
                    <span className="text-[10px] font-bold uppercase tracking-wider text-sky-400 flex-1">
                      Entrenamiento en curso
                    </span>
                    <ArrowRight size={14} className="text-sky-400 shrink-0" />
                  </div>

                  <p className="font-display font-semibold text-base truncate">
                    {sesionEnCurso.sesion.name}
                  </p>
                  <p className="text-[11px] text-neutral-500 mt-0.5">
                    {sesionEnCurso.hechos} de {sesionEnCurso.total} ejercicios cargados
                    {sesionEnCurso.sesion.day && ` · ${sesionEnCurso.sesion.day}`}
                  </p>

                  <div className="h-1.5 rounded-full bg-neutral-700 overflow-hidden mt-2.5">
                    <div className="h-full bg-sky-400 transition-all duration-300"
                      style={{ width: `${Math.round((sesionEnCurso.hechos / Math.max(1, sesionEnCurso.total)) * 100)}%` }} />
                  </div>

                  <p className="text-[11px] font-medium text-sky-400 mt-2.5">
                    Retomá tu entrenamiento →
                  </p>
                </button>
              )}

              {/* Mientras no cargue sus sesiones semanales, el torneo
                  no le puede calcular el puntaje. El cartel de
                  bienvenida se ve una vez; esto queda hasta que lo
                  complete. */}
              {hayBackend && miSemana && miSemana.meta === 0 && (
                <button onClick={() => setView("perfil")}
                  className="w-full flex items-start gap-2.5 rounded-xl p-3 text-left transition-colors"
                  style={{ background: "#38bdf812", border: "1px solid #38bdf833" }}>
                  <User size={14} className="shrink-0 mt-0.5 text-sky-400" />
                  <span className="flex-1 min-w-0">
                    <span className="text-xs text-neutral-200 block">
                      Falta un dato para entrar al torneo
                    </span>
                    <span className="text-[11px] text-neutral-500 block leading-relaxed">
                      Cargá cuántas veces por semana podés entrenar. Sin eso no se
                      te puede calcular el puntaje.
                    </span>
                  </span>
                  <ChevronRight size={14} className="text-neutral-600 shrink-0 mt-0.5" />
                </button>
              )}

              {/* Lo de hoy, primero y grande. El alumno abre la app
                  para entrenar: los números vienen después. */}
              {(() => {
                const hoy = DIAS_SEMANA[(new Date().getDay() + 6) % 7];
                const deHoy = currentWeek.sessions.find(
                  (x) => x.day === hoy && x.estado !== "Completado");
                if (!deHoy || sesionEnCurso) return null;
                return (
                  <button
                    onClick={() => {
                      setActiveWeekId(currentWeek.id);
                      setActiveSessionId(deHoy.id);
                      setWeekOrigin("inicio");
                      setView("session");
                    }}
                    className="w-full text-left rounded-xl border-2 p-4 transition-transform active:scale-[0.99]"
                    style={{ borderColor: "#38bdf866", background: "#38bdf80F" }}>
                    <div className="flex items-center gap-2 mb-1.5">
                      <Dumbbell size={14} className="text-sky-400 shrink-0" />
                      <span className="text-[10px] font-bold uppercase tracking-wider text-sky-400">
                        Hoy te toca
                      </span>
                    </div>
                    <p className="font-display font-semibold text-base truncate">{deHoy.name}</p>
                    <p className="text-[11px] text-neutral-500 mt-0.5">
                      {deHoy.exercises.filter((e) => e.ejercicio).length} ejercicios
                    </p>
                    <div className="w-full bg-sky-400 text-black font-medium text-sm rounded-lg py-2.5 mt-3 text-center">
                      Empezar
                    </div>
                  </button>
                );
              })()}

              {/* Sus números. Lo pendiente es uno más y no una barra
                  flotante: la barra tapaba contenido y había que
                  cerrarla, y una vez cerrada no volvía. */}
              {(miSemana || tablero) && (
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
                  {(() => {
                    const pendientes = (semanaActual?.sessions || [])
                      .filter((s) => s.estado !== "Completado").length;
                    if (!pendientes) return null;
                    return (
                      <Metrica icono={ClipboardList} etiqueta="Te faltan"
                        valor={pendientes}
                        sufijo={pendientes === 1 ? " entreno" : " entrenos"}
                        color={ESTADO.atencion}
                        pie={{ texto: sesionEnCurso ? "uno a medio hacer" : "tocá para ir",
                               color: ESTADO.atencion }}
                        onClick={() => {
                          // Si hay uno a medio hacer, se abre ese.
                          if (sesionEnCurso) {
                            setActiveWeekId(sesionEnCurso.semana.id);
                            setActiveSessionId(sesionEnCurso.sesion.id);
                            setWeekOrigin("weeks");
                            setView("session");
                          } else {
                            setView("weeks");
                          }
                        }} />
                    );
                  })()}

                  {/* Las insignias como un recuadro más: antes eran un
                      bloque entero que empujaba todo hacia abajo. Acá
                      se ven las últimas tres y el puesto, que es lo
                      que se mira de reojo; el detalle está a un toque. */}
                  {(() => {
                    const mias = BADGES_VIVAS.filter((b) => badgeStatus[b.id] === "approved");
                    const listas = BADGES_VIVAS.filter((b) => badgeStatus[b.id] === "earned");
                    const yo = viendoComo?.id || profile?.id;
                    const grupo = [...insigniasGrupo]
                      .sort((a, b) => (b.cuantas || 0) - (a.cuantas || 0));
                    const puesto = grupo.findIndex((g) => g.alumno_id === yo) + 1;

                    return (
                      <button onClick={() => setView("insignias")}
                        className="relative overflow-hidden bg-neutral-800 border border-neutral-700 hover:border-sky-400/40 rounded-xl p-3 text-left transition-colors">
                        <Award size={38} strokeWidth={1.5} aria-hidden="true"
                          style={{ color: "#d4b555", opacity: 0.09, position: "absolute",
                                   right: -6, bottom: -8, pointerEvents: "none" }} />
                        <p className="relative text-[10px] text-neutral-500 mb-1 truncate">
                          Insignias{puesto > 0 && ` · ${puesto}°`}
                        </p>
                        {mias.length > 0 ? (
                          <span className="relative flex items-center gap-1">
                            {mias.slice(0, 3).map((b) => (
                              <span key={b.id}
                                className="w-7 h-7 rounded-md flex items-center justify-center shrink-0"
                                style={{ background: `${b.color}1F` }}>
                                {b.imagen
                                  ? <img src={b.imagen} alt="" className="w-full h-full object-contain" />
                                  : React.createElement(esIcono(b.icon) ? b.icon : Award,
                                      { size: 15, style: { color: b.color } })}
                              </span>
                            ))}
                            {mias.length > 3 && (
                              <span className="text-[11px] text-neutral-500">
                                +{mias.length - 3}
                              </span>
                            )}
                          </span>
                        ) : (
                          <p className="relative font-display font-bold leading-none"
                            style={{ color: "#737373", fontSize: 24 }}>0</p>
                        )}
                        {listas.length > 0 && (
                          <p className="relative text-[10px] mt-1 truncate"
                            style={{ color: ESTADO.aviso }}>
                            {listas.length} para reclamar
                          </p>
                        )}
                      </button>
                    );
                  })()}

                  {miSemana && miSemana.meta > 0 && (
                    <Metrica icono={CalendarCheck} etiqueta="Tu semana"
                      valor={miSemana.validas} sufijo={`/${miSemana.meta}`}
                      color={miSemana.puntos === 3 ? "#22c55e" : "#fafafa"}
                      pie={miSemana.validas >= miSemana.meta
                        ? { texto: "3 puntos ✓", color: "#22c55e" }
                        : { texto: `${miSemana.meta - miSemana.validas} más y son 3 puntos`,
                            color: "#facc15" }} />
                  )}

                  {tablero && (
                    <Metrica icono={Flame} etiqueta="Racha"
                      valor={tablero.racha}
                      color={tablero.racha > 0 ? "#22c55e" : "#737373"}
                      pie={{ texto: tablero.racha === 0 ? "arrancá esta semana"
                        : tablero.racha === 1 ? "semana al 100%" : "semanas al 100%" }} />
                  )}

                  {tablero?.puesto && (
                    <Metrica icono={Trophy} etiqueta="En el torneo"
                      valor={`${tablero.puesto}°`}
                      color={tablero.puesto <= 3 ? "#facc15" : "#fafafa"}
                      onClick={() => setView("ranking")}
                      pie={{ texto: `de ${tablero.total_alumnos}` }} />
                  )}

                  <Metrica icono={Star} etiqueta={`Nivel ${levelFromExp(perfilVista?.exp || 0)}`}
                    valor={expInLevel(perfilVista?.exp || 0)}
                    sufijo={`/${expDelNivel(perfilVista?.exp || 0)}`}
                    color="#38bdf8"
                    pie={{ texto: `faltan ${expDelNivel(perfilVista?.exp || 0) - expInLevel(perfilVista?.exp || 0)} EXP` }} />
                </div>
              )}



              {/* Lo que hoy nadie descubre hasta que ve que no sumó. */}
              {miSemana && miSemana.sin_compartir > 0 && (
                <button onClick={() => setView("ranking")}
                  className="w-full flex items-start gap-2 rounded-xl p-3 text-left transition-colors"
                  style={{ background: "#facc1512", border: "1px solid #facc1533" }}>
                  <Camera size={14} className="shrink-0 mt-0.5" style={{ color: "#facc15" }} />
                  <span className="text-[11px] leading-relaxed" style={{ color: "#facc15" }}>
                    Tenés {miSemana.sin_compartir} {miSemana.sin_compartir === 1 ? "entrenamiento" : "entrenamientos"} sin
                    compartir al grupo. Sin la foto no {miSemana.sin_compartir === 1 ? "suma" : "suman"} al torneo.
                  </span>
                </button>
              )}

              <div className="flex items-baseline gap-2">
                <p className="text-[11px] uppercase tracking-wider text-neutral-500 flex-1">
                  {MESES_LARGOS[new Date().getMonth()]} {new Date().getFullYear()}
                </p>
                <p className="text-[10px] text-neutral-600">semana {semanaDelMes()}</p>
              </div>

              <div className="grid grid-cols-7 gap-1">
                {semanaDeHoy().map(({ nombre: dia, dia: numero, mes, esHoy, abreMes }) => {
                  // Todas las del día, no la primera: hay gente que
                  // hace dos entrenamientos el mismo día y la segunda
                  // desaparecía de la grilla.
                  const delDia = currentWeek.sessions.filter((x) => x.day === dia);
                  const s = delDia[0];
                  const st = s ? (ESTADO_STYLES[s.estado] || ESTADO_STYLES["Pendiente"]) : null;
                  const isHover = dragSessionId && hoverDay === dia;
                  const isBeingDragged = s && dragSessionId === s.id;
                  return (
                    <div key={dia} data-day={dia}
                      onPointerDown={s ? (e) => handleDragStart(e, s.id) : undefined}
                      onPointerMove={s ? handleDragMove : undefined}
                      onPointerUp={s ? (e) => handleDragEnd(currentWeek.id, e, dia) : undefined}
                      // Los días sin entrenamiento propio también se
                      // pueden tocar: ahí se ve quién del grupo corrió.
                      onClick={!s ? () => setExpandedDay(expandedDay === dia ? null : dia) : undefined}
                      style={s ? { touchAction: "none" } : undefined}
                      className={`flex flex-col items-center gap-1.5 rounded-lg py-2.5 border transition-colors select-none cursor-pointer ${s ? "cursor-grab active:cursor-grabbing" : ""} ${
                        expandedDay === dia ? "border-sky-400 bg-sky-400/10"
                        : isHover ? "border-sky-400 bg-sky-400/10"
                        : isBeingDragged ? "border-sky-400/40 bg-neutral-800 opacity-40"
                        : esHoy ? "border-sky-400 bg-sky-400/10"
                        : s ? "border-neutral-700 bg-neutral-800"
                        : "border-neutral-800 bg-transparent border-dashed"
                      }`}>
                      <span className={`text-[9px] uppercase ${
                        esHoy ? "text-sky-400 font-bold" : "text-neutral-500"}`}>
                        {dia.slice(0, 3)}
                      </span>
                      <span className={`font-display text-sm leading-none ${
                        esHoy ? "text-sky-400 font-bold" : "text-neutral-400"}`}>
                        {numero}
                        {abreMes && (
                          <span className="text-[8px] text-neutral-600 ml-0.5">
                            {MESES_LARGOS[mes].slice(0, 3)}
                          </span>
                        )}
                      </span>
                      {s ? (
                        <span className="flex items-center gap-0.5">
                          <st.icon size={13} className={st.text} />
                          {/* Si hay más de uno ese día se avisa: sin
                              esto el segundo no existía en la grilla. */}
                          {delDia.length > 1 && (
                            <span className="text-[9px] font-bold text-sky-400">
                              ×{delDia.length}
                            </span>
                          )}
                        </span>
                      ) : <span className="text-neutral-700 text-xs">–</span>}
                      {(() => {
                        // Compañeros que entrenaron ese día. Con base
                        // conectada son personas reales; el filtro saca
                        // al propio alumno para no contarse a sí mismo.
                        const fuenteAl = hayBackend ? (actividad?.porDia || {}) : COMMUNITY_ACTIVITY;
                        const yo = hayBackend ? profile?.id : "fede";
                        const others = (fuenteAl[dia] || [])
                          .filter((a) => a.id !== yo && a.completado !== false)
                          .map((a) => ({ id: a.id, name: a.nombre || "Be Trainer", photo: a.foto || null }));
                        if (others.length === 0) return <div style={{ height: 14 }} />;
                        const shown = others.slice(0, 2);
                        return (
                          <div className="flex items-center -space-x-1.5 mt-0.5">
                            {shown.map((st2) => <Avatar key={st2.id} student={st2} size={14} />)}
                            {others.length > shown.length && (
                              <span className="text-[8px] text-neutral-500 pl-1">+{others.length - shown.length}</span>
                            )}
                          </div>
                        );
                      })()}
                    </div>
                  );
                })}
              </div>

              {/* Las que quedaron sin ubicar. Antes no se veían en
                  ningún lado del inicio: la sesión existía pero parecía
                  perdida. Se pueden arrastrar a un día desde acá. */}
              {(() => {
                const sinDia = currentWeek.sessions.filter((x) => !x.day);
                if (!sinDia.length) return null;
                return (
                  <div className="mt-2 rounded-lg p-2.5"
                    style={{ border: "1px dashed #38bdf866", background: "#38bdf80A" }}>
                    <div className="flex items-center gap-2 mb-2">
                      <Inbox size={13} style={{ color: "#38bdf8" }} className="shrink-0" />
                      <span className="text-[11px] flex-1" style={{ color: "#38bdf8" }}>
                        Sin día asignado
                      </span>
                      <span className="text-[10px] text-neutral-500">{sinDia.length}</span>
                    </div>
                    <div className="space-y-1">
                      {sinDia.map((se) => {
                        const st = ESTADO_STYLES[se.estado] || ESTADO_STYLES["Pendiente"];
                        return (
                          <div key={se.id}
                            onPointerDown={(e) => handleDragStart(e, se.id)}
                            onPointerMove={handleDragMove}
                            onPointerUp={(e) => handleDragEnd(currentWeek.id, e, null)}
                            className="flex items-center gap-2 bg-neutral-800 border border-neutral-700 rounded-md px-2.5 py-2 cursor-grab active:cursor-grabbing touch-none"
                            style={{ opacity: dragSessionId === se.id ? 0.4 : 1 }}>
                            <GripVertical size={12} className="text-neutral-600 shrink-0" />
                            <span className="text-xs flex-1 min-w-0 leading-snug">{se.name}</span>
                            <span className={`text-[9px] ${st.text} shrink-0`}>{se.estado}</span>
                          </div>
                        );
                      })}
                    </div>
                    <p className="text-[9px] text-neutral-600 mt-2">
                      Arrastralas a un día de arriba
                    </p>
                  </div>
                );
              })()}

              {/* Con veinte alumnos no entran todos en 300px, y overflow-hidden
                  recortaba sin dejar deslizar: los de abajo no existían.
                  Ahora la lista tiene su propio scroll. */}
              <div className="transition-all duration-300"
                style={{ maxHeight: expandedDay ? 380 : 0,
                         opacity: expandedDay ? 1 : 0,
                         overflowY: expandedDay ? "auto" : "hidden",
                         overflowX: "hidden" }}>
                {expandedDay && (() => {
                  // Todas las del día, no la primera.
                  const misDelDia = currentWeek.sessions.filter((x) => x.day === expandedDay);
                  const s = misDelDia[0];
                  const fuenteAl = hayBackend ? (actividad?.porDia || {}) : COMMUNITY_ACTIVITY;
                  const yo = hayBackend ? profile?.id : "fede";
                  const others = (fuenteAl[expandedDay] || [])
                    .filter((a) => a.id !== yo && a.completado !== false)
                    .map((a) => ({ id: a.id, name: a.nombre || "Be Trainer", photo: a.foto || null, session: a.session }));
                  return (
                    <div className="bg-neutral-800 border border-sky-400/30 rounded-xl p-4 space-y-3">
                      <div className="flex items-center justify-between">
                        <p className="font-display font-semibold text-sm">
                          {expandedDay === DIAS_SEMANA[(new Date().getDay() + 6) % 7]
                            ? <>Hoy <span className="text-neutral-500 font-normal">· {expandedDay}</span></>
                            : expandedDay}
                        </p>
                        {misDelDia.length > 1
                          ? <span className="text-[11px] text-sky-400">{misDelDia.length} entrenamientos</span>
                          : s ? <EstadoBadge estado={s.estado} />
                          : <span className="text-xs text-neutral-500">Sin entrenamiento tuyo</span>}
                      </div>

                      {/* Una fila por entrenamiento: si hizo dos ese
                          día, los dos tienen que poder abrirse. */}
                      {misDelDia.map((se) => (
                        <button key={se.id}
                          onClick={() => { setActiveWeekId(currentWeek.id); setActiveSessionId(se.id); setView("session"); }}
                          className="w-full flex items-center gap-2 bg-neutral-700/40 hover:bg-neutral-700 rounded-lg px-3 py-2 transition-colors text-left">
                          <p className="text-xs text-neutral-300 flex-1 min-w-0 truncate">{se.name}</p>
                          {misDelDia.length > 1 && <EstadoBadge estado={se.estado} />}
                          <span className="text-[11px] text-sky-400 font-medium shrink-0">Abrir</span>
                        </button>
                      ))}
                      {others.length > 0 && (
                        <div className={`space-y-1.5 ${s ? "pt-2 border-t border-neutral-700" : ""}`}>
                          <p className="text-[10px] uppercase tracking-wider text-neutral-500">También entrenaron ese día</p>
                          {others.map((o) => (
                            <div key={o.id} className="flex items-center gap-2">
                              <Avatar student={o} size={18} />
                              <p className="text-xs text-neutral-300">{o.name} <span className="text-neutral-500">· {o.session}</span></p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>

              <div className="space-y-2">
                <p className="text-[11px] uppercase tracking-wider text-neutral-500">
                  {availableSessions.length > 0 ? "Arrastrá un entrenamiento a su día" : "Arrastrá para reordenar o soltá afuera para sacarlo del día"}
                </p>
                <div className="flex flex-wrap gap-2">
                  {availableSessions.map((s) => (
                    <div key={s.id}
                      onPointerDown={(e) => handleDragStart(e, s.id)}
                      onPointerMove={handleDragMove}
                      onPointerUp={(e) => handleDragEnd(currentWeek.id, e, null)}
                      style={{ touchAction: "none" }}
                      className={`flex items-center gap-1.5 text-xs font-medium bg-neutral-800 border rounded-full pl-3 pr-3.5 py-2 cursor-grab active:cursor-grabbing select-none transition-colors ${
                        dragSessionId === s.id ? "border-sky-400 opacity-40" : "border-neutral-700"
                      }`}>
                      <Dumbbell size={12} className="text-sky-400" /> {s.name}
                    </div>
                  ))}
                  {availableSessions.length === 0 && (
                    <p className="text-xs text-neutral-600">Todos tus entrenamientos ya tienen un día asignado.</p>
                  )}
                </div>
              </div>

            </div>
          );
        })()}

        {/* Solo cuando la carga TERMINÓ y de verdad no hay nadie.
            Antes salía siempre al entrar, en el instante entre que se
            dibuja la pantalla y llega la lista: un cartel de "todavía
            no tenés alumnos" cuando tenés veinte. */}
        {/* Los mensajes nuevos, en el inicio del alumno.
            Antes solo aparecían dentro de la sesión y desplegando ese
            ejercicio: si le contestabas en un día que todavía no le
            tocaba, no se enteraba. */}
        {view === "inicio" && isAlumno && misMensajes.length > 0 && (
          <div className="rounded-xl p-3 mb-2.5"
            style={{ background: "#262626", border: "1px solid #38bdf844" }}>
            <div className="flex items-center gap-2 mb-2.5">
              <MessagesSquare size={14} style={{ color: "#38bdf8" }} className="shrink-0" />
              <span className="text-[10px] uppercase tracking-[0.06em] font-bold flex-1"
                style={{ color: "#38bdf8" }}>
                Mensajes nuevos
              </span>
              <span className="text-[10px] text-neutral-500">{misMensajes.length}</span>
            </div>
            <div className="space-y-1.5">
              {misMensajes.slice(0, 8).map((m) => (
                <div key={m.clave} className="rounded-lg flex items-stretch"
                  style={{ background: "#303030" }}>
                  <button onClick={() => abrirMensaje(m)}
                    className="flex-1 min-w-0 px-2.5 py-2 text-left hover:bg-neutral-700/40 rounded-l-lg transition-colors">
                    <span className="block text-[11.5px] text-neutral-100 leading-snug truncate">
                      {m.titulo}
                    </span>
                    {m.ejercicio_nombre && (
                      <span className="block text-[10px] text-neutral-500 mt-0.5 truncate">
                        {m.ejercicio_nombre}
                      </span>
                    )}
                  </button>
                  {/* Ya lo vio: se va y no vuelve. */}
                  <button onClick={() => descartarMensaje(m)} title="Marcar como visto"
                    className="px-2.5 flex items-center shrink-0 group">
                    <span className="w-[18px] h-[18px] rounded-[5px] flex items-center justify-center transition-colors group-hover:bg-emerald-400/20"
                      style={{ border: "1.5px solid #525252" }}>
                      <Check size={11} strokeWidth={3}
                        className="text-transparent group-hover:text-emerald-400 transition-colors" />
                    </span>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Quién le planificó a quién. Con dos coaches, saber en qué
            anduvo el otro evita planificarle dos veces a la misma
            persona. Solo lo ven los coaches. */}
        {view === "inicio" && isCoach && (() => {
          // Sin elección hecha: abierto si hay algo, plegado si no.
          const abierta = actividadAbierta === null
            ? quienPlanifico.length > 0 : actividadAbierta;
          return (
          <div className="rounded-xl p-3 mb-2.5"
            style={{ background: "#262626", border: "1px solid #404040" }}>
            <button onClick={() => setActividadAbierta(!abierta)}
              className="w-full flex items-center gap-2 text-left">
              <Users size={14} style={{ color: "#a78bfa" }} className="shrink-0" />
              <span className="text-[10px] uppercase tracking-[0.06em] font-bold flex-1"
                style={{ color: "#a78bfa" }}>
                Quién planificó qué
              </span>
              <span className="text-[10px] text-neutral-500">{quienPlanifico.length}</span>
              <ChevronDown size={13}
                className={`text-neutral-600 shrink-0 transition-transform ${
                  abierta ? "" : "-rotate-90"}`} />
            </button>

            {abierta && quienPlanifico.length === 0 && (
              <p className="text-[10.5px] text-neutral-600 text-center py-3 mt-1">
                Todavía nadie planificó nada esta semana.
              </p>
            )}

            {abierta && quienPlanifico.length > 0 && (
              <div className="mt-2.5 space-y-1.5 max-h-80 overflow-y-auto">
                {quienPlanifico.map((a) => {
                  const clave = `${a.coach_id}-${a.alumno_id}-${a.dia}`;
                  const desplegado = detalleAbierto === clave;
                  const quien = a.mio ? "Vos" : a.coach;
                  return (
                    <div key={clave} className="rounded-lg overflow-hidden"
                      style={{ background: "#303030" }}>
                      {/* La cabecera: el alumno y quién lo tocó. */}
                      <button onClick={() => setDetalleAbierto(desplegado ? null : clave)}
                        className="w-full px-2.5 py-2 flex items-center gap-2.5 text-left hover:bg-neutral-700/40 transition-colors">
                        <Avatar student={{ id: a.alumno_id, name: a.alumno,
                                           photo: a.foto_url }} size={24} />
                        <span className="flex-1 min-w-0">
                          <span className="block text-xs truncate">
                            {String(a.alumno || "").split(" ")[0]}
                          </span>
                          <span className="block text-[10px] mt-0.5 truncate"
                            style={{ color: a.mio ? "#38bdf8" : "#a78bfa" }}>
                            {quien} · {a.semana || "sin semana"}
                            {a.semana_nueva ? " · semana nueva" : ""}
                            {a.detalle_total > 0
                              ? ` · ${a.detalle_total} cambio${a.detalle_total === 1 ? "" : "s"}`
                              : ""}
                          </span>
                        </span>
                        <ChevronDown size={13}
                          className={`text-neutral-600 shrink-0 transition-transform ${
                            desplegado ? "" : "-rotate-90"}`} />
                      </button>

                      {/* Lo que cambió, encabezado por quién lo hizo. */}
                      {desplegado && (
                        <div className="px-2.5 pb-2.5" style={{ borderTop: "1px solid #ffffff0d" }}>
                          <p className="text-[9px] uppercase tracking-[0.05em] mt-2 mb-1.5"
                            style={{ color: a.mio ? "#38bdf8" : "#a78bfa" }}>
                            {quien} · {new Date(a.ultima).toLocaleDateString("es-AR",
                              { day: "numeric", month: "short" })}
                          </p>

                          {(!a.detalle || a.detalle.length === 0) && (
                            <p className="text-[10.5px] text-neutral-600 py-1">
                              {a.semana_nueva
                                ? "Creó la semana, sin cambios en los ejercicios todavía."
                                : "Sin detalle de cambios."}
                            </p>
                          )}

                          {aLista(a.detalle).map((d, k) => {
                            const comoSeLlama = {
                              nuevo: "ejercicio nuevo", peso: "peso", reps: "reps",
                              rir: "RIR", series: "series", con_que: "con qué",
                              tecnica: "técnica", descanso: "descanso",
                              por_lado: "reps", ejercicio: "ejercicio",
                            }[d.campo] || d.campo;
                            const [Ico, col] = {
                              nuevo: [Plus, "#a78bfa"], peso: [Dumbbell, "#fbbf24"],
                              reps: [Repeat, "#38bdf8"], rir: [Gauge, "#fb923c"],
                            }[d.campo] || [Pencil, "#8a8a8a"];
                            return (
                              <div key={k} className="flex gap-2 items-start mb-1.5">
                                <Ico size={12} style={{ color: col }}
                                  className="shrink-0 mt-0.5" />
                                <span className="text-[11px] text-neutral-300 leading-snug">
                                  <b className="text-neutral-100">{d.ejercicio}</b>
                                  {d.campo === "nuevo" ? " · agregado" : (
                                    <> · {comoSeLlama} {d.antes || "—"} → <b className="text-neutral-100">
                                      {d.ahora || "—"}</b></>
                                  )}
                                </span>
                              </div>
                            );
                          })}

                          {a.detalle_total > (a.detalle?.length || 0) && (
                            <p className="text-[10px] text-neutral-600 mt-1">
                              y {a.detalle_total - a.detalle.length} cambios más
                            </p>
                          )}

                          <button
                            onClick={() => {
                              const al = studentsList.find((x) => x.id === a.alumno_id);
                              if (al) { setSelectedStudent(al); setView("weeks"); }
                            }}
                            className="w-full mt-2 text-[10.5px] text-sky-400 hover:text-sky-300 py-1.5 transition-colors">
                            Ver su plan
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          );
        })()}

        {/* Lo que pasó en el grupo, en el inicio: es lo primero que
            mirás al abrir la app. En la pestaña de Be Trainers había
            que entrar a buscarlo. */}
        {view === "inicio" && isCoach && novedadesDelGrupo.length > 0 && (
                <div className="rounded-xl p-3 mb-2.5"
                  style={{ background: "#262626", border: "1px solid #404040" }}>
                  <button onClick={() => setGrupoAbierto((v) => !v)}
                    className="w-full flex items-center gap-2 text-left">
                    <Bell size={14} style={{ color: "#fbbf24" }} className="shrink-0" />
                    <span className="text-[10px] uppercase tracking-[0.06em] font-bold flex-1"
                      style={{ color: "#fbbf24" }}>
                      Novedades del grupo
                    </span>
                    <span className="text-[10px] text-neutral-500">
                      {novedadesDelGrupo.length}
                    </span>
                    <ChevronDown size={13}
                      className={`text-neutral-600 shrink-0 transition-transform ${
                        grupoAbierto ? "" : "-rotate-90"}`} />
                  </button>

                  {grupoAbierto && (
                    <div className="mt-2.5 space-y-1.5 max-h-64 overflow-y-auto">
                      {novedadesDelGrupo.slice(0, 12).map((n) => {
                        const col = { peso: ESTADO.bien, comentario: "#a3a3a3",
                                      emom: "#a78bfa" }[n.tipo] || "#a3a3a3";
                        const titulo = { peso: `movió ${n.detalle}`,
                          comentario: "te dejó un comentario",
                          emom: `llegó a ${n.detalle}` }[n.tipo];
                        return (
                          <div key={n.clave || `${n.tipo}-${n.ejercicio_id}`}
                            className="rounded-lg flex items-stretch"
                            style={{ background: "#303030" }}>
                            {/* Tocar la novedad lleva al ejercicio exacto,
                                con el dato remarcado. Antes llevaba al
                                plan del alumno y había que buscarlo. */}
                            <button
                              onClick={() => irANovedad(n)}
                              className="flex-1 min-w-0 px-2.5 py-2 flex gap-2.5 items-start text-left hover:bg-neutral-700/40 rounded-l-lg transition-colors">
                              <Avatar student={{ id: n.alumno_id, name: n.alumno }} size={24} />
                              <span className="flex-1 min-w-0">
                                <span className="block text-[11.5px] text-neutral-100 leading-snug">
                                  <b>{String(n.alumno || "").split(" ")[0]}</b> {titulo}
                                </span>
                                <span className="block text-[10px] mt-0.5 leading-snug truncate"
                                  style={{ color: col }}>
                                  {n.tipo === "comentario"
                                    ? `"${n.detalle}"`
                                    : `${n.ejercicio}${n.extra ? ` · ${n.extra}` : ""}`}
                                </span>
                              </span>
                            </button>
                            {/* Ya la viste: se va y no vuelve. */}
                            <button
                              onClick={() => descartarNovedadGrupo(n)}
                              title="Marcar como vista"
                              className="px-2.5 flex items-center shrink-0 group">
                              <span className="w-[18px] h-[18px] rounded-[5px] flex items-center justify-center transition-colors group-hover:bg-emerald-400/20"
                                style={{ border: "1.5px solid #525252" }}>
                                <Check size={11} strokeWidth={3}
                                  className="text-transparent group-hover:text-emerald-400 transition-colors" />
                              </span>
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}

        {view === "inicio" && isCoach && hayBackend
          && alumnosCargados && studentsList.length === 0 && (
          <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-6 text-center">
            <Users size={26} className="text-neutral-600 mx-auto mb-3" />
            <p className="font-display font-semibold text-sm mb-1.5">Todo listo para arrancar</p>
            <p className="text-xs text-neutral-500 leading-relaxed mb-4">
              Cuando tus Be Trainers creen su cuenta desde el link, vas a ver acá
              quiénes entrenaron y cómo viene la semana del grupo.
            </p>
            <button onClick={() => setView("alumnos")}
              className="text-xs font-medium text-sky-400 bg-sky-400/10 border border-sky-400/20 rounded-full px-4 py-2 hover:bg-sky-400/20 transition-colors">
              Ver el link para compartir
            </button>
          </div>
        )}

        {view === "inicio" && isCoach && !(hayBackend && studentsList.length === 0) && (
          <div className="space-y-4">
            <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-4">
              <p className="font-display font-semibold text-sm mb-1">Hola {(profile?.name || userName || "coach").split(" ")[0]} 👋</p>
              <p className="text-xs text-neutral-500">
                {hayBackend ? (actividad?.entrenaronHoy?.length ?? 0)
                            : studentsList.filter((s) => s.trainedToday).length}
                /{studentsList.length} Be Trainers entrenaron hoy
              </p>
            </div>

            <div className="space-y-2">
              {/* Los cuatro números de la semana. Responden lo que uno
                  se pregunta al abrir la app, antes de tener que
                  buscar nada. */}
              {tablero && (
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
                  <Metrica icono={TrendingUp} etiqueta="Adherencia"
                    valor={tablero.adherencia === null ? "—" : `${tablero.adherencia}%`}
                    color={tablero.adherencia === null ? ESTADO.neutro
                      : tablero.adherencia >= 75 ? ESTADO.bien
                      : tablero.adherencia >= 50 ? ESTADO.aviso : ESTADO.atencion}
                    pie={(() => {
                      if (tablero.adherencia === null) return { texto: "sin datos todavía" };
                      if (tablero.adherencia_previa === null) return { texto: "primera semana" };
                      const d = tablero.adherencia - tablero.adherencia_previa;
                      if (d === 0) return { texto: "igual que la semana pasada" };
                      return { texto: `${d > 0 ? "+" : ""}${d} vs semana pasada`,
                               color: d > 0 ? ESTADO.bien : ESTADO.atencion };
                    })()} />

                  <Metrica icono={Dumbbell} etiqueta="Entrenaron hoy"
                    valor={tablero.entrenaron_hoy} sufijo={`/${tablero.activos}`}
                    pie={{ texto: new Date().toLocaleDateString("es-AR", { weekday: "long" }) }} />

                  <Metrica icono={Camera} etiqueta="Sin compartir"
                    valor={tablero.sin_compartir}
                    color={tablero.sin_compartir > 0 ? ESTADO.aviso : ESTADO.bien}
                    pie={{ texto: tablero.sin_compartir > 0
                      ? "no suman al torneo" : "todo validado" }} />

                  <Metrica icono={Bell} etiqueta="Te esperan"
                    valor={tablero.pendientes}
                    color={tablero.pendientes > 0 ? "#38bdf8" : "#737373"}
                    onClick={tablero.pendientes > 0 ? () => setView("solicitudes") : null}
                    pie={{ texto: tablero.pendientes > 0
                      ? "tocá para verlas" : "nada pendiente" }} />
                </div>
              )}

              {/* Quién necesita atención. Sale de los datos, no del
                  asistente: es gratis y está siempre actualizado. */}
              {alertas.length > 0 && (
                <div className={`bg-neutral-800 border border-neutral-700 rounded-xl ${
                  alertasAbiertas ? "p-4 space-y-2" : "px-4 py-3"}`}>
                  {/* Plegable: con ocho alumnos marcados el bloque
                      empujaba todo lo demás fuera de la pantalla. */}
                  <button onClick={() => setAlertasAbiertas((v) => !v)}
                    className="w-full flex items-center gap-2 text-left">
                    <AlertTriangle size={14} className="shrink-0" style={{ color: ESTADO.aviso }} />
                    <p className="text-xs font-medium flex-1">Necesitan atención</p>
                    <span className="text-[10px] rounded-full px-2 py-0.5"
                      style={{ color: ESTADO.aviso, background: `${ESTADO.aviso}1F` }}>
                      {alertas.length}
                    </span>
                    <ChevronDown size={14}
                      className={`text-neutral-500 shrink-0 transition-transform ${
                        alertasAbiertas ? "" : "-rotate-90"}`} />
                  </button>

                  {alertasAbiertas && (<>
                  {alertas.map((a) => {
                    const color = a.motivo === "sin_plan" || a.motivo === "nunca" ? ESTADO.alerta
                      : a.motivo === "semana_vacia" || a.motivo === "inactivo" ? ESTADO.atencion
                      : ESTADO.aviso;
                    return (
                      <button key={a.alumno_id}
                        onClick={() => {
                          const al = studentsList.find((x) => x.id === a.alumno_id);
                          if (al) openStudent(al);
                        }}
                        className="w-full flex items-center gap-2.5 py-1.5 text-left hover:bg-neutral-700/30 rounded-lg px-1 transition-colors">
                        <div className="w-8 h-8 rounded-full overflow-hidden shrink-0 flex items-center justify-center"
                          style={{ background: `${color}1F` }}>
                          {a.foto
                            ? <img src={a.foto} alt="" className="w-full h-full object-cover" />
                            : <span className="text-[10px] font-bold" style={{ color }}>
                                {(a.nombre || "?").split(" ").map((n) => n[0]).slice(0, 2).join("")}
                              </span>}
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-xs text-neutral-200 truncate">{a.nombre}</p>
                          <p className="text-[11px] truncate" style={{ color }}>{a.detalle}</p>
                        </div>
                        <ChevronRight size={13} className="text-neutral-600 shrink-0" />
                      </button>
                    );
                  })}
                  </>)}
                </div>
              )}

              {hayBackend && studentsList.length > 0 && (
                <button onClick={borradorRepaso}
                  className="w-full flex items-center justify-center gap-1.5 text-xs font-medium text-sky-400 bg-sky-400/10 border border-sky-400/25 hover:bg-sky-400/20 rounded-xl py-2.5 transition-colors">
                  <Sparkles size={13} /> ¿A quién le presto atención esta semana?
                </button>
              )}

              {/* El mes y la semana en curso: sin esto la grilla es un
                  "lunes a domingo" abstracto que podría ser cualquier
                  semana del año. */}
              <div className="flex items-baseline gap-2">
                <p className="text-[11px] uppercase tracking-wider text-neutral-500 flex-1">
                  {MESES_LARGOS[new Date().getMonth()]} {new Date().getFullYear()}
                </p>
                <p className="text-[10px] text-neutral-600">
                  semana {semanaDelMes()}
                </p>
              </div>

              <div className="grid grid-cols-7 gap-1">
                {semanaDeHoy().map(({ nombre: dia, dia: numero, mes, esHoy, abreMes }) => {
                  const fuente = hayBackend ? (actividad?.porDia || {}) : COMMUNITY_ACTIVITY;
                  const entradas = fuente[dia] || [];
                  // El nombre y la foto vienen en la respuesta: el alumno no
                  // tiene la lista de sus compañeros para buscarlos.
                  const activos = entradas.map((a) => ({
                    id: a.id,
                    name: a.nombre || "Be Trainer",
                    photo: a.foto || null,
                    session: a.session,
                    completado: a.completado !== false,
                  }));
                  const hechos = activos.filter((a) => a.completado).length;
                  const shown = activos.slice(0, 2);
                  return (
                    <button key={dia} onClick={() => setExpandedDay((prev) => (prev === dia ? null : dia))}
                      className={`flex flex-col items-center gap-1.5 rounded-lg py-2.5 border transition-colors ${
                        expandedDay === dia ? "border-sky-400 bg-sky-400/10"
                        : activos.length > 0 && hechos < activos.length ? "border-[#e07a7a66] bg-[#e07a7a0d]"
                        : activos.length > 0 ? "border-[#6fc48d55] bg-[#6fc48d0d]"
                        : esHoy ? "border-sky-400 bg-sky-400/10"
                        : "border-neutral-700 bg-neutral-800"}`}>
                      <span className={`text-[9px] uppercase ${esHoy ? "text-sky-400 font-bold" : "text-neutral-500"}`}>
                        {dia.slice(0, 3)}
                      </span>
                      <span className={`font-display text-sm leading-none ${
                        esHoy ? "text-sky-400 font-bold" : "text-neutral-400"}`}>
                        {numero}
                        {abreMes && (
                          <span className="text-[8px] text-neutral-600 ml-0.5">
                            {MESES_LARGOS[mes].slice(0, 3)}
                          </span>
                        )}
                      </span>
                      {activos.length === 0 ? (
                        <span className="text-neutral-700 text-xs" style={{ height: 14 }}>–</span>
                      ) : (
                        <div className="flex items-center -space-x-1.5">
                          {/* Anillo rojo = asignado y todavía sin hacer. */}
                          {shown.map((st2) => (
                            <span key={st2.id}
                              className={`rounded-full ${st2.completado
                                ? "ring-1 ring-emerald-400/60"
                                : "ring-1 ring-red-400 opacity-70"}`}>
                              <Avatar student={st2} size={14} />
                            </span>
                          ))}
                          {activos.length > shown.length && <span className="text-[8px] text-neutral-500 pl-1">+{activos.length - shown.length}</span>}
                        </div>
                      )}
                      {activos.length > 0 && (
                        <span className={`text-[8px] font-semibold ${
                          hechos === activos.length ? "text-emerald-400" : "text-red-400"}`}>
                          {hechos}/{activos.length}
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>

              {/* Con veinte alumnos no entran todos en 300px, y overflow-hidden
                  recortaba sin dejar deslizar: los de abajo no existían.
                  Ahora la lista tiene su propio scroll. */}
              <div className="transition-all duration-300"
                style={{ maxHeight: expandedDay ? 380 : 0,
                         opacity: expandedDay ? 1 : 0,
                         overflowY: expandedDay ? "auto" : "hidden",
                         overflowX: "hidden" }}>
                {expandedDay && (() => {
                  const fuente = hayBackend ? (actividad?.porDia || {}) : COMMUNITY_ACTIVITY;
                  const activos = (fuente[expandedDay] || []).map((a) => ({
                    id: a.id,
                    name: a.nombre || "Be Trainer",
                    photo: a.foto || null,
                    session: a.session,
                    completado: a.completado !== false,
                  }));
                  return (
                    <div className="bg-neutral-800 border border-sky-400/30 rounded-xl p-4 space-y-2.5">
                      <p className="font-display font-semibold text-sm">
                          {expandedDay === DIAS_SEMANA[(new Date().getDay() + 6) % 7]
                            ? <>Hoy <span className="text-neutral-500 font-normal">· {expandedDay}</span></>
                            : expandedDay}
                        </p>
                      {activos.length > 0 && (
                        <p className="text-[10px] text-neutral-600">
                          {activos.length} {activos.length === 1 ? "persona" : "personas"}
                          {activos.length > 5 && " · deslizá para ver todas"}
                        </p>
                      )}
                      {activos.length === 0 ? (
                        <p className="text-xs text-neutral-500">Nadie entrenó ese día todavía.</p>
                      ) : (
                        // Solo el coach entra al perfil del otro: un
                        // alumno ve quién entrenó, no el detalle de su
                        // entrenamiento.
                        activos.map((o) => (
                          <button key={o.id}
                            onClick={() => { if (isCoach) openStudent(studentsList.find((st3) => st3.id === o.id) || studentsList[0]); }}
                            className={`w-full flex items-center gap-2.5 rounded-lg p-1.5 -m-1.5 transition-colors text-left ${
                              isCoach ? "hover:bg-neutral-700/50 cursor-pointer" : "cursor-default"}`}>
                            <span className={`rounded-full shrink-0 ${o.completado
                              ? "ring-1 ring-emerald-400/60" : "ring-1 ring-red-400"}`}>
                              <Avatar student={o} size={26} />
                            </span>
                            <p className="text-xs text-neutral-300 flex-1 min-w-0 truncate">
                              {o.name} <span className="text-neutral-500">· {o.session}</span>
                            </p>
                            {o.completado
                              ? <Check size={13} className="text-emerald-400 shrink-0" />
                              : <span className="text-[9px] font-medium text-red-400 bg-red-400/10 border border-red-400/25 rounded-full px-2 py-0.5 shrink-0">pendiente</span>}
                          </button>
                        ))
                      )}
                    </div>
                  );
                })()}
              </div>
            </div>


          </div>
        )}

        {view === "libreria" && isCoach && (
          <div className="space-y-3">
            <p className="text-neutral-500 text-xs mb-1">Sesiones pre armadas · asignalas a cualquier alumno</p>

            <div className="flex gap-2">
              <button onClick={openTemplateBuilder} className="flex-1 flex items-center justify-center gap-1.5 text-xs font-medium text-sky-400 bg-sky-400/10 hover:bg-sky-400/20 border border-sky-400/20 rounded-xl py-2.5 transition-colors">
                <Plus size={13} /> Crear sesión de entrenamiento
              </button>
              <button onClick={() => setFolderModalOpen(true)} className="flex items-center justify-center gap-1.5 text-xs font-medium text-neutral-400 border border-dashed border-neutral-600 hover:border-sky-400/40 hover:text-sky-400 rounded-xl px-3 transition-colors">
                <FolderPlus size={15} />
              </button>
            </div>
            <button onClick={() => { setNewExerciseDraft({ name: "", category: "", videoUrl: "", gifUrl: "", editando: null, categoriaNueva: false, color: PALETA_CATEGORIAS[0] }); setNewExerciseModalOpen(true); }}
              className="w-full flex items-center justify-center gap-1.5 text-xs font-medium text-neutral-400 border border-dashed border-neutral-600 hover:border-sky-400/40 hover:text-sky-400 rounded-xl py-2.5 transition-colors">
              <Dumbbell size={13} /> Crear ejercicio nuevo
            </button>

            {/* Buscador de sesiones armadas. Con muchas carpetas, abrir
                una por una para encontrar la de tren superior del
                martes es más trabajo que armarla de nuevo. */}
            <div className="relative">
              <Search size={14} className="absolute left-3 top-2.5 text-neutral-500 pointer-events-none" />
              <input value={buscarPlantilla} onChange={(e) => setBuscarPlantilla(e.target.value)}
                placeholder="Buscar una sesión armada..."
                className="w-full bg-neutral-800 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-lg pl-9 pr-8 py-2 text-sm text-white placeholder-neutral-600 transition-colors" />
              {buscarPlantilla && (
                <button onClick={() => setBuscarPlantilla("")}
                  className="absolute right-2.5 top-2.5 text-neutral-500 hover:text-white transition-colors">
                  <X size={14} />
                </button>
              )}
            </div>

            {/* Con búsqueda activa se muestran los resultados sueltos,
                sin carpetas: buscar sirve justamente para no tener que
                acordarse de en qué carpeta estaba. */}
            {buscarPlantilla.trim() && (() => {
              const hallados = libraryCategories.flatMap((c) =>
                c.templates
                  .filter((t) => coincide(t.name, buscarPlantilla)
                    || t.exercises?.some((e) => e.ejercicio && coincide(e.ejercicio, buscarPlantilla)))
                  .map((t) => ({ ...t, categoria: c.name, categoriaId: c.id })));
              return (
                <div className="space-y-2">
                  <p className="text-[11px] text-neutral-500">
                    {hallados.length === 0 ? "Ninguna sesión coincide."
                      : `${hallados.length} ${hallados.length === 1 ? "sesión" : "sesiones"}`}
                  </p>
                  {hallados.map((t) => (
                    <div key={t.id} className="bg-neutral-800 border border-neutral-700 rounded-xl p-3 space-y-2">
                      <div>
                        <p className="font-display font-semibold text-sm truncate">{t.name}</p>
                        <p className="text-[10px] text-neutral-500 flex items-center gap-1.5">
                          {t.exercises.length} ejercicios
                          <span style={{ color: colorGrupo(t.categoria) }}>· {t.categoria}</span>
                        </p>
                      </div>
                      <div className="flex gap-1.5">
                        <button onClick={() => setAssignModal(t)}
                          className="flex-1 flex items-center justify-center gap-1.5 text-xs font-medium text-sky-400 bg-sky-400/10 hover:bg-sky-400/20 border border-sky-400/20 rounded-lg py-1.5 transition-colors min-w-0">
                          <Send size={12} /> <span className="truncate">Asignar</span>
                        </button>
                        <button onClick={() => setPrevia(t)} title="Ver como Be Trainer"
                          className="flex items-center justify-center text-neutral-400 border border-neutral-600 hover:border-amber-400/50 hover:text-amber-400 rounded-lg px-2.5 transition-colors shrink-0">
                          <Eye size={12} />
                        </button>
                        <button onClick={() => editTemplate(t, t.categoriaId)} title="Editar"
                          className="flex items-center justify-center text-neutral-400 border border-neutral-600 hover:border-sky-400/40 hover:text-sky-400 rounded-lg px-2.5 transition-colors shrink-0">
                          <Pencil size={12} />
                        </button>
                        <button onClick={() => duplicarPlantilla(t, t.categoriaId)}
                          title="Duplicar para hacerle cambios"
                          className="flex items-center justify-center text-neutral-400 border border-neutral-600 hover:border-sky-400/40 hover:text-sky-400 rounded-lg px-2.5 transition-colors shrink-0">
                          <Copy size={12} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* Biblioteca de ejercicios: todos los creados, con su video
                y gif. Antes solo se podían editar desde el armador de una
                sesión, así que preparar el material obligaba a armar una
                sesión de mentira. */}
            <div className="space-y-2 relative">
              <button onClick={() => setBibliotecaAbierta((v) => !v)}
                className="w-full flex items-center gap-2 rounded-xl px-4 py-3 border bg-neutral-800 border-neutral-700 hover:border-neutral-500 transition-colors">
                <ChevronDown size={15} className={`text-neutral-500 transition-transform ${bibliotecaAbierta ? "" : "-rotate-90"}`} />
                <Dumbbell size={15} className="text-emerald-400" />
                <p className="font-display font-semibold text-sm flex-1 text-left">Ejercicios creados</p>
                <span className="text-[11px] text-neutral-500">
                  {exerciseGroups.reduce((t, g) => t + g.items.length, 0)}
                </span>
              </button>

              {bibliotecaAbierta && (
                <div className="space-y-3 pl-2 border-l border-neutral-700 ml-3">
                  {(() => {
                    const total = exerciseGroups.reduce((t, g) => t + g.items.length, 0);
                    const conMedios = exerciseGroups.reduce((t, g) =>
                      t + g.items.filter((n) => exerciseMedia[n]?.gifUrl || exerciseMedia[n]?.videoUrl).length, 0);
                    return (
                      <p className="text-[11px] text-neutral-500">
                        {conMedios} de {total} tienen video o gif cargado.
                        {conMedios < total && " Tocá los que faltan para completarlos."}
                      </p>
                    );
                  })()}

                  {/* Con noventa ejercicios, bajar por la lista para
                      encontrar uno no es viable. */}
                  <div className="relative">
                    <Search size={13} className="absolute left-2.5 top-2.5 text-neutral-500 pointer-events-none" />
                    <input value={buscarEjercicio} onChange={(e) => setBuscarEjercicio(e.target.value)}
                      placeholder="Buscar un ejercicio..."
                      className="w-full bg-neutral-800 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-lg pl-8 pr-8 py-1.5 text-xs text-white placeholder-neutral-600 transition-colors" />
                    {buscarEjercicio && (
                      <button onClick={() => setBuscarEjercicio("")}
                        className="absolute right-2 top-2 text-neutral-500 hover:text-white transition-colors">
                        <X size={13} />
                      </button>
                    )}
                  </div>

                  {exerciseGroups
                    .map((g) => ({ ...g, items: buscarEjercicio.trim()
                      ? g.items.filter((i) => coincide(i, buscarEjercicio)) : g.items }))
                    .filter((g) => g.items.length > 0).map((g) => (
                    <div key={g.label} className="space-y-1.5">
                      <div className="flex items-center gap-1.5">
                        <button onClick={() => setColorCategoria(colorCategoria === g.label ? null : g.label)}
                          title="Cambiar el color"
                          className="w-3.5 h-3.5 rounded-full shrink-0 hover:scale-125 transition-transform"
                          style={{ background: colorGrupo(g.label) }} />
                        <p className="text-[10px] uppercase tracking-wider font-semibold"
                          style={{ color: colorGrupo(g.label) }}>
                          {g.label}
                        </p>
                      </div>

                      {colorCategoria === g.label && (
                        <div className="flex flex-wrap gap-1.5 bg-neutral-800 border border-neutral-700 rounded-lg p-2">
                          {PALETA_CATEGORIAS.map((c) => (
                            <button key={c} onClick={() => ponerColorCategoria(g.label, c)}
                              className="w-6 h-6 rounded-full transition-transform hover:scale-110"
                              style={{
                                background: c,
                                outline: colorGrupo(g.label) === c ? "2px solid #fafafa" : "none",
                                outlineOffset: 2,
                              }} />
                          ))}
                        </div>
                      )}
                      <div className="space-y-1.5">
                        {g.items.map((nombre) => {
                          const m = exerciseMedia[nombre] || {};
                          const completo = !!(m.gifUrl && m.videoUrl);
                          const algo = !!(m.gifUrl || m.videoUrl);
                          const elegido = seleccionados.includes(nombre);
                          return (
                            <div key={nombre}
                              className="w-full flex items-center gap-2 bg-neutral-800 border rounded-lg p-2 transition-colors"
                              style={elegido
                                ? { borderColor: "#38bdf8", background: "#38bdf81A" }
                                : { borderColor: `${colorGrupo(g.label)}40` }}>
                              {/* Tildar varios y armar una sesión de una sola vez. */}
                              <input type="checkbox" checked={elegido}
                                onChange={(e) => setSeleccionados((prev) => e.target.checked
                                  ? [...prev, nombre] : prev.filter((n) => n !== nombre))}
                                className="w-4 h-4 rounded accent-sky-400 shrink-0" />
                              <button onClick={() => setFichaEjercicio({ nombre, categoria: g.label })}
                                className="flex items-center gap-2.5 flex-1 min-w-0 text-left">
                              <div className="w-11 h-11 rounded-md overflow-hidden bg-neutral-900 border border-neutral-700 shrink-0 flex items-center justify-center">
                                {m.gifUrl
                                  ? <img src={m.gifUrl} alt={nombre} className="w-full h-full object-contain"
                                      onError={(e) => { e.currentTarget.style.display = "none"; }} />
                                  : <Dumbbell size={14} className="text-neutral-700" />}
                              </div>
                              <span className="text-xs text-neutral-200 flex-1 min-w-0 leading-snug">{nombre}</span>
                              <div className="flex items-center gap-1 shrink-0">
                                <span title={m.gifUrl ? "Con gif" : "Sin gif"}
                                  className={`text-[9px] font-bold rounded px-1.5 py-0.5 ${
                                    m.gifUrl ? "bg-emerald-400/15 text-emerald-400" : "bg-neutral-700 text-neutral-600"}`}>
                                  GIF
                                </span>
                                <span title={m.videoUrl ? "Con video" : "Sin video"}
                                  className={`text-[9px] font-bold rounded px-1.5 py-0.5 ${
                                    m.videoUrl ? "bg-sky-400/15 text-sky-400" : "bg-neutral-700 text-neutral-600"}`}>
                                  VIDEO
                                </span>
                              </div>
                              </button>
                              <button onClick={() => abrirEdicionEjercicio(nombre)} title="Editar"
                                className="p-1.5 text-neutral-600 hover:text-sky-400 shrink-0">
                                <Pencil size={12} />
                              </button>
                              <button onClick={() => pedirBorrarEjercicio(nombre)} title="Eliminar del catálogo"
                                className="p-1.5 text-neutral-600 hover:text-red-400 shrink-0 transition-colors">
                                <Trash2 size={12} />
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {libraryCategories.map((cat) => {
              // Las categorías de la base no traen icono; se elige por
              // el nombre. Sin esto, <Icon /> con undefined rompe el render.
              const Icon = cat.icon || iconoCategoria(cat.name);
              const open = !!expandedLibCategories[cat.id];
              const isHoverTarget = dragTemplate && hoverCategory === cat.id && dragTemplate.from !== cat.id;
              return (
                <div key={cat.id} className="space-y-2 relative">
                  <button data-category={cat.id} onClick={() => setExpandedLibCategories((prev) => ({ ...prev, [cat.id]: !open }))}
                    className={`w-full flex items-center gap-2 rounded-xl px-4 py-3 border transition-colors ${isHoverTarget ? "border-sky-400 bg-sky-400/10" : "bg-neutral-800 border-neutral-700 hover:border-neutral-500"}`}>
                    <ChevronDown size={15} className={`text-neutral-500 transition-transform ${open ? "" : "-rotate-90"}`} />
                    <Icon size={15} className="text-sky-400" />
                    <p className="font-display font-semibold text-sm flex-1 text-left">{cat.name}</p>
                    <span className={`text-[11px] text-neutral-500 ${cat.id !== "sin-categoria" ? "mr-7" : ""}`}>{cat.templates.length}</span>
                  </button>
                  {/* "Sin categoría" no se borra: es donde caen las sesiones
                      sueltas y las que quedan al eliminar una carpeta. */}
                  {cat.id !== "sin-categoria" && (
                    <button onClick={(e) => { e.stopPropagation(); setConfirmar({ tipo: "carpeta", id: cat.id, nombre: cat.name, cuenta: cat.templates.length }); }}
                      title="Eliminar esta carpeta"
                      className="absolute right-3 top-3 p-1.5 rounded-full text-neutral-600 hover:text-red-400 hover:bg-neutral-700 transition-colors">
                      <Trash2 size={13} />
                    </button>
                  )}

                  {open && (
                    <div className="space-y-2 pl-2 border-l border-neutral-700 ml-3">
                      {cat.templates.length === 0 && (
                        <p className="text-xs text-neutral-600 py-2">Arrastrá una sesión acá para organizarla en esta carpeta.</p>
                      )}
                      {cat.templates.map((tpl) => (
                        <div key={tpl.id} className={`bg-neutral-800 border rounded-xl p-4 transition-opacity ${dragTemplate?.id === tpl.id ? "opacity-40 border-sky-400/40" : "border-neutral-700"}`}>
                          <div className="flex items-start gap-2 mb-2">
                            <div onPointerDown={(e) => handleTemplateDragStart(e, tpl.id, cat.id)} onPointerMove={handleTemplateDragMove} onPointerUp={handleTemplateDragEnd}
                              style={{ touchAction: "none" }} className="cursor-grab active:cursor-grabbing text-neutral-600 hover:text-sky-400 pt-0.5 shrink-0">
                              <GripVertical size={15} />
                            </div>
                            <p className="font-display font-semibold text-sm flex-1 min-w-0 truncate">{tpl.name}</p>
                          </div>
                          <div className="space-y-1 mb-3 pl-[22px]">
                            {tpl.exercises.map((ex, i) => (
                              <p key={i} className="text-xs text-neutral-400 leading-snug">{ex.ejercicio} · {ex.series}x{ex.reps}{ex.repsPorLado ? " × lado" : ""}</p>
                            ))}
                          </div>
                          <div className="flex gap-2">
                            <button onClick={() => setAssignModal(tpl)}
                              className="flex-1 flex items-center justify-center gap-1.5 text-xs font-medium text-sky-400 bg-sky-400/10 hover:bg-sky-400/20 border border-sky-400/20 rounded-lg py-2 transition-colors min-w-0">
                              <Send size={12} /> <span className="truncate">Asignar</span>
                            </button>
                            <button onClick={() => setPrevia(tpl)} title="Ver como Be Trainer"
                              className="flex items-center justify-center text-neutral-400 border border-neutral-600 hover:border-amber-400/50 hover:text-amber-400 rounded-lg px-2.5 py-2 transition-colors shrink-0">
                              <Eye size={12} />
                            </button>
                            <button onClick={() => editTemplate(tpl, cat.id)} title="Editar esta sesión"
                              className="flex items-center justify-center gap-1.5 text-xs font-medium text-neutral-400 border border-neutral-600 hover:border-sky-400/40 hover:text-sky-400 rounded-lg px-2.5 py-2 transition-colors shrink-0">
                              <Pencil size={12} />
                            </button>
                            <button onClick={() => duplicarPlantilla(tpl, cat.id)}
                              title="Duplicar para hacerle cambios"
                              className="flex items-center justify-center text-neutral-400 border border-neutral-600 hover:border-sky-400/40 hover:text-sky-400 rounded-lg px-2.5 py-2 transition-colors shrink-0">
                              <Copy size={12} />
                            </button>
                            <button onClick={() => setConfirmar({ tipo: "plantilla", id: tpl.id, categoryId: cat.id, nombre: tpl.name })}
                              title="Eliminar esta sesión"
                              className="flex items-center justify-center text-neutral-400 border border-neutral-600 hover:border-red-400/50 hover:text-red-400 rounded-lg px-2.5 py-2 transition-colors shrink-0">
                              <Trash2 size={12} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}


          </div>
        )}

        {view === "weeks" && (() => {
          const currentPeriod = semanaActual?.period;
          const visibleWeeks = isAlumno ? weeks.filter((w) => w.period === currentPeriod) : weeks;
          return (
            <div className="space-y-3">
              <p className="text-neutral-500 text-xs mb-1">{isCoach ? `Conectado como ${userName || "coach"}` : "Entrená hoy, viví mejor mañana."}</p>

              {/* Ficha rápida del alumno, para tenerla a la vista al
                  armar la semana en vez de tener que recordarla. */}
              {isCoach && selectedStudent && datosDelAlumno && (
                <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-3 flex flex-wrap items-center gap-2">
                  {datosDelAlumno.sesiones_semana && (
                    <span className="text-[11px] bg-sky-400/10 text-sky-400 border border-sky-400/20 rounded-full px-2.5 py-1">
                      {datosDelAlumno.sesiones_semana} sesiones/semana
                    </span>
                  )}
                  {datosDelAlumno.genero && (
                    <span className="text-[11px] bg-neutral-700 text-neutral-300 rounded-full px-2.5 py-1">
                      {datosDelAlumno.genero}
                    </span>
                  )}
                  {edadDesde(datosDelAlumno.fecha_nacimiento) !== null && (
                    <span className="text-[11px] bg-neutral-700 text-neutral-300 rounded-full px-2.5 py-1">
                      {edadDesde(datosDelAlumno.fecha_nacimiento)} años
                    </span>
                  )}
                  {datosDelAlumno.sigue_ciclo && datosDelAlumno.ciclo_ultimo_periodo && (() => {
                    const inicio = new Date(datosDelAlumno.ciclo_ultimo_periodo);
                    const dias = Math.floor((Date.now() - inicio) / 86400000);
                    const largo = datosDelAlumno.ciclo_duracion || 28;
                    const dia = ((dias % largo) + largo) % largo + 1;
                    const fase = dia <= 5 ? "Menstrual" : dia <= 13 ? "Folicular"
                      : dia <= 16 ? "Ovulación" : "Lútea";
                    return (
                      <button onClick={() => setVerCiclo({ dia, fase, largo })}
                        className="text-[11px] bg-pink-400/10 text-pink-400 border border-pink-400/20 rounded-full px-2.5 py-1 hover:bg-pink-400/20 transition-colors flex items-center gap-1.5">
                        Día {dia} · {fase}
                        <Info size={11} />
                      </button>
                    );
                  })()}
                  {!datosDelAlumno.sesiones_semana && !datosDelAlumno.genero
                    && !datosDelAlumno.fecha_nacimiento && (
                    <span className="text-[11px] text-neutral-600">
                      Todavía no completó sus datos personales.
                    </span>
                  )}
                </div>
              )}
              <WeeksFolderList
                weeks={visibleWeeks}
                isCoach={isCoach}
                collapsedMonths={collapsedMonths}
                semanasPlegadas={semanasPlegadas} setSemanasPlegadas={setSemanasPlegadas}
                setCollapsedMonths={setCollapsedMonths}
                onOpenWeek={(w) => { setActiveWeekId(w.id); setWeekOrigin("weeks"); setView("week"); }}
                onBorrarSemana={(w) => setConfirmar({ tipo: "semana", semana: w })}
                onEditarSemana={(w) => setEditandoSemana({ id: w.id, name: w.name, period: w.period })}
                onAbrirSesion={(w, se) => {
                  setActiveWeekId(w.id);
                  setActiveSessionId(se.id);
                  setWeekOrigin("weeks");
                  setView("session");
                }}
                onRenombrar={(w, se) => setRenombrando({ semana: w, sesion: se,
                  nombre: se.name })}
                onALibreria={(w, se) => setAGuardar({ sesion: se, categoria: "" })}
                onVerComo={(w, se) => {
                  // El mismo modo que el ojo del perfil, pero entra
                  // directo a ESTA sesión. El otro sigue existiendo:
                  // este es el atajo, no su reemplazo.
                  const alumno = viendoComo || selectedStudent;
                  if (!alumno) return;
                  setViendoComo(alumno);
                  setActiveWeekId(w.id);
                  setActiveSessionId(se.id);
                  setWeekOrigin("weeks");
                  setView("session");
                  showToast(`Viendo como ${alumno.name.split(" ")[0]}`);
                }}
                onBorrarSesion={(w, se) => {
                  setActiveWeekId(w.id);
                  setConfirmar({ tipo: "sesion", sesion: se });
                }}
                onDuplicarSesion={(w, se) => setDuplicandoSesion({
                  semana: w, sesion: se, nombre: `${se.name} (copia)` })}
                onProponerSemana={hayBackend && isCoach ? borradorPlanificacion : null}
                onPublicarSemana={hayBackend && isCoach ? async (w) => {
                  const ok = await persistir(async () => { await programarSemana(w.id, null); return true; },
                    "No se pudo publicar la semana");
                  if (!ok) return;
                  setWeeks((prev) => prev.map((x) => x.id === w.id ? { ...x, visibleDesde: null } : x));
                  showToast(`✓ ${w.name} publicada: ya la ve`);
                } : null}
                lastWeekId={semanaActual?.id}
                onAddWeek={openWeekActionChoice}
              />
            </div>
          );
        })()}

        {view === "week" && activeWeek && (
          <div className="space-y-3">
            <MonthProgressCard weeks={weeks} period={activeWeek.period} />
            <div className="flex items-center gap-2 text-neutral-500 text-xs mb-1"><Calendar size={13} /> {activeWeek.sessions.length} sesiones esta semana</div>
            {activeWeek.sessions.map((s) => (
              <div key={s.id} className="w-full bg-neutral-800 border border-neutral-700 hover:border-sky-400/30 rounded-xl flex items-center transition-colors">
                <button onClick={() => { setActiveSessionId(s.id); setView("session"); }}
                  className="flex-1 min-w-0 p-4 flex items-center justify-between gap-2 text-left">
                  <div className="min-w-0">
                    <p className="font-display font-semibold text-sm truncate">{s.name}</p>
                    <p className="text-[11px] text-neutral-500 mt-0.5">{s.exercises.length} ejercicios</p>
                  </div>
                  <EstadoBadge estado={s.estado} />
                </button>
                {isCoach && (
                  <button onClick={() => setDuplicandoSesion({
                    semana: activeWeek, sesion: s, nombre: `${s.name} (copia)` })}
                    title={`Duplicar ${s.name}`}
                    className="py-4 px-2 text-neutral-600 hover:text-sky-400 transition-colors shrink-0">
                    <Copy size={15} />
                  </button>
                )}
                {isCoach && (
                  <button onClick={() => setConfirmar({ tipo: "sesion", sesion: s })}
                    title={`Eliminar ${s.name}`}
                    className="py-4 pr-4 pl-2 text-neutral-600 hover:text-red-400 transition-colors shrink-0">
                    <Trash2 size={15} />
                  </button>
                )}
              </div>
            ))}
            {isCoach && (
              <button onClick={() => setAddSessionChoiceOpen(true)} className="w-full flex items-center justify-center gap-1.5 text-xs font-medium text-neutral-400 border border-dashed border-neutral-600 hover:border-sky-400/40 hover:text-sky-400 rounded-xl py-3 transition-colors">
                <Plus size={13} /> Agregar sesión
              </button>
            )}
          </div>
        )}

        {view === "newSession" && draftSession && (
          <div className="space-y-3">
            <div>
              <span className="text-[10px] uppercase tracking-wider text-sky-400/70">Nombre de la sesión</span>
              <input value={draftSession.name} onChange={(e) => setDraftSession((prev) => ({ ...prev, name: e.target.value }))}
                placeholder="Ej: DIA 3 - Full body" autoFocus
                className="w-full mt-1 bg-neutral-700 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-md px-3 py-2 text-sm text-white placeholder-neutral-600 transition-colors" />
            </div>

            <p className="text-[11px] text-neutral-500 pt-1">{draftSession.exercises.length} ejercicio{draftSession.exercises.length !== 1 ? "s" : ""}</p>

            {draftSession.exercises.map((ex, i) => {
              if (ex.finalizador) return null;
              const kEj = `draft-${i}-ejercicio`, kConQue = `draft-${i}-conQue`, kSeries = `draft-${i}-series`, kReps = `draft-${i}-reps`, kRirC = `draft-${i}-rirConsigna`;
              const set = (field) => (v) => updateDraftExercise(i, field, v);
              return (
                <div key={i} data-ejercicio-idx={i}
                  className={`bg-neutral-800 border rounded-xl p-4 space-y-3 transition-all ${
                    recienAgregado === i ? "recien-creado border-sky-400" : ""} ${
                    arrastrando === i ? "opacity-40 border-sky-400"
                    : sobreIndice === i && arrastrando !== null ? "border-sky-400 border-2"
                    : "border-neutral-700"}`}>
                  <div className="flex items-center justify-between">
                    <span className="text-[11px] text-neutral-500 flex items-center gap-1.5">
                      {/* Agarradera: arrastrar para cambiar el orden. */}
                      <span onPointerDown={(e) => inicioArrastre(e, i)}
                        onPointerMove={moviendoArrastre}
                        onPointerUp={() => finArrastre(setDraftSession)}
                        style={{ touchAction: "none" }}
                        className="cursor-grab active:cursor-grabbing text-neutral-600 hover:text-sky-400 -ml-1 p-1">
                        <GripVertical size={14} />
                      </span>
                      Ejercicio {i + 1}
                      {!ex.ejercicio && (
                        <span className="text-[9px] font-bold uppercase tracking-wider text-yellow-400 bg-yellow-400/15 rounded-full px-2 py-0.5">
                          Falta elegirlo
                        </span>
                      )}
                      {ex.biserie && (
                        <span className="text-[9px] font-bold uppercase tracking-wider rounded-full px-2 py-0.5"
                          style={{ color: colorSerie(ex.biserie),
                                   background: `${colorSerie(ex.biserie)}26` }}>
                          Serie {ex.biserie}
                        </span>
                      )}
                      {ex.tecnica && ex.tecnica !== "normal" && (
                        <span className="text-[9px] font-bold uppercase tracking-wider rounded-full px-2 py-0.5"
                          style={{ color: TECNICAS[ex.tecnica]?.color,
                                   background: `${TECNICAS[ex.tecnica]?.color}26` }}>
                          {TECNICAS[ex.tecnica]?.nombre}
                        </span>
                      )}
                    </span>
                    {draftSession.exercises.length > 1 && (
                      <button onClick={() => removeDraftExercise(i)} className="text-neutral-600 hover:text-red-400 transition-colors"><X size={14} /></button>
                    )}
                  </div>

                  <BloqueMedios media={mediaDe(ex)} nombre={ex.ejercicio} modo="coach"
                    onCargar={() => abrirEdicionEjercicio(ex.ejercicio)}
                    campoEjercicio={
                      <div className="space-y-1.5">
                        <BuscadorEjercicio value={ex.ejercicio} grupos={exerciseGroups} onChange={set("ejercicio")} onEscribir />
                        <EtiquetaGrupo nombre={ex.ejercicio} grupos={exerciseGroups} />
                      </div>
                    } />

                  <div className="grid grid-cols-2 gap-2">
                    {ex.tecnica !== "tabata" && (
                      <FieldSelect label="Con qué" value={ex.conQue} options={CON_QUE_OPTIONS} onChange={set("conQue")} customActive={customFields[kConQue]} onToggleCustom={() => toggleCustom(kConQue)} labelColor={FIELD_ACCENTS.conQue} colorful />
                    )}
                    <div>
                      <FieldSelect label="RIR consigna" value={ex.rirConsigna} options={RIR_OPTIONS} onChange={set("rirConsigna")} customActive={customFields[kRirC]} onToggleCustom={() => toggleCustom(kRirC)} dotColor={effortColor(ex.rirConsigna)} labelColor={FIELD_ACCENTS.rirConsigna} />
                      <CargaPrevia dato={cargaPreviaDe(cargasPrevias, ex.ejercicio)} campo="rir" />
                    </div>
                  </div>

                  <PrescripcionTrabajo ex={ex}
                    onChange={(cambios) => Object.entries(cambios).forEach(([k, v]) => set(k)(v))}
                    opcionesSeries={SERIES_OPTIONS} opcionesReps={REPS_OPTIONS}
                    customSeries={customFields[kSeries]} onToggleSeries={() => toggleCustom(kSeries)}
                    customReps={customFields[kReps]} onToggleReps={() => toggleCustom(kReps)} />

                  <SelectorBiserie valor={ex.biserie} onChange={set("biserie")}
                    gruposUsados={draftSession.exercises.map((e) => e.biserie).filter(Boolean)}
                    cuantosEnGrupo={ex.biserie ? draftSession.exercises.filter((e) => e.biserie === ex.biserie).length : 0} />

                  {/* En piramidal el peso vive en cada escalón: uno
                      general acá arriba no significa nada. */}
                  <div className={esPiramidal(ex.tecnica) || ex.tecnica === "tabata" || seccionDe(ex) === "activacion" ? "hidden" : ""}>
                    <FieldSelect label="Peso sugerido (kg)" value={ex.pesoSugerido}
                      options={PESO_OPTIONS} etiqueta={(kg) => conUnidad(kg, ex.mostrarLibras)} onChange={set("pesoSugerido")}
                      customActive={customFields[`${kEj}-pesoSug`]}
                      onToggleCustom={() => toggleCustom(`${kEj}-pesoSug`)}
                      labelColor={FIELD_ACCENTS.peso} colorful />

                    {/* Para los que entrenan afuera. El peso se sigue
                        guardando en kilos: las libras son una forma de
                        mostrarlo, no un dato aparte. Si se guardaran las
                        dos, un mismo ejercicio tendría dos historias. */}
                    <label className="flex items-center gap-2 cursor-pointer select-none mt-1.5">
                      <input type="checkbox" checked={!!ex.mostrarLibras}
                        onChange={(e) => set("mostrarLibras")(e.target.checked)}
                        className="w-3.5 h-3.5 rounded accent-sky-400 shrink-0" />
                      <span className="text-[10px] text-neutral-500">
                        Mostrar también en libras
                        {ex.pesoSugerido && ex.mostrarLibras && aLibras(ex.pesoSugerido) && (
                          <span className="text-neutral-400"> · {aLibras(ex.pesoSugerido)} lb</span>
                        )}
                      </span>
                    </label>
                    <CargaPrevia dato={cargaPreviaDe(cargasPrevias, ex.ejercicio)} campo="peso" />
                  </div>

                  <SelectorTecnica tecnica={ex.tecnica} config={ex.tecnicaConfig}
                    onChange={(t, cfg) => { set("tecnica")(t); set("tecnicaConfig")(cfg); }}
                    onReps={(v) => { if (v) set("reps")(v); }}
                      pesoBase={ex.pesoSugerido}
                      gruposEjercicios={exerciseGroups} />

                  <Conversacion notaCoach={ex.notaCoach} onNota={set("notaCoach")} esCoach />

                </div>
              );
            })}

            {draftSession.exercises.length > 1 && (
              <p className="text-[10px] text-neutral-600 text-center flex items-center justify-center gap-1">
                <GripVertical size={11} /> Arrastrá desde el ícono para cambiar el orden
              </p>
            )}

            <button onClick={addDraftExercise} className="w-full flex items-center justify-center gap-1.5 text-xs font-medium text-neutral-400 border border-dashed border-neutral-600 hover:border-sky-400/40 hover:text-sky-400 rounded-xl py-3 transition-colors">
              <Plus size={13} /> Agregar ejercicio
            </button>

            {/* Finalizador: el trabajo que va después de lo principal.
                Sus ejercicios se arman igual que los demás, pero quedan
                agrupados y el alumno los ve como un bloque aparte. */}
            {(() => {
              const delFinal = draftSession.exercises.filter((e) => e.finalizador);
              if (!delFinal.length) {
                return (
                  <button onClick={toggleFinalizador}
                    className="w-full flex items-center justify-between rounded-xl p-4 border border-neutral-700 bg-neutral-800 hover:border-orange-400/40 transition-colors">
                    <div className="text-left">
                      <p className="text-sm font-medium text-neutral-200">Agregar finalizador</p>
                      <p className="text-[11px] text-neutral-500 mt-0.5">
                        Un bloque al final de la sesión, con sus propios ejercicios
                      </p>
                    </div>
                    <Flame size={18} className="text-neutral-600 shrink-0" />
                  </button>
                );
              }
              return (
                <div className="rounded-xl border-2 p-3 space-y-3"
                  style={{ borderColor: "#fb923c66", background: "#fb923c0D" }}>
                  <div className="flex items-center gap-2 px-1">
                    <Flame size={14} style={{ color: "#fb923c" }} className="shrink-0" />
                    <span className="text-[11px] font-bold uppercase tracking-wider flex-1"
                      style={{ color: "#fb923c" }}>
                      Finalizador
                    </span>
                    <button onClick={toggleFinalizador}
                      className="text-[10px] text-neutral-500 hover:text-red-400 transition-colors">
                      Quitar
                    </button>
                  </div>

                  {draftSession.exercises.map((ex, i) => {
                    if (!ex.finalizador) return null;
                    const kEj = `draft-${i}-ejercicio`, kConQue = `draft-${i}-conQue`;
                    const kSeries = `draft-${i}-series`, kReps = `draft-${i}-reps`, kRirC = `draft-${i}-rirConsigna`;
                    const set = (field) => (v) => updateDraftExercise(i, field, v);
                    return (
                      <div key={i} className="bg-neutral-800 border rounded-xl p-4 space-y-3"
                        style={{ borderColor: !ex.ejercicio ? "#facc1580" : "#fb923c33" }}>
                        <div className="flex items-center justify-between">
                          <span className="text-[11px] text-neutral-500 flex items-center gap-1.5">
                            Ejercicio {draftSession.exercises.filter((e, j) => e.finalizador && j <= i).length}
                            {!ex.ejercicio && (
                              <span className="text-[9px] font-bold uppercase tracking-wider text-yellow-400 bg-yellow-400/15 rounded-full px-2 py-0.5">
                                Falta elegirlo
                              </span>
                            )}
                          </span>
                          <button onClick={() => removeDraftExercise(i)}
                            className="text-neutral-600 hover:text-red-400 transition-colors">
                            <X size={14} />
                          </button>
                        </div>

                        <BloqueMedios media={mediaDe(ex)} nombre={ex.ejercicio} modo="coach"
                          onCargar={() => abrirEdicionEjercicio(ex.ejercicio)}
                          campoEjercicio={
                            <BuscadorEjercicio value={ex.ejercicio} grupos={exerciseGroups}
                              onChange={set("ejercicio")} onEscribir />
                          } />

                        <div className="grid grid-cols-2 gap-2">
                          <FieldSelect label="Con qué" value={ex.conQue} options={CON_QUE_OPTIONS}
                            onChange={set("conQue")} customActive={customFields[kConQue]}
                            onToggleCustom={() => toggleCustom(kConQue)} labelColor={GRIS_ETIQUETA} colorful />
                          <FieldSelect label={`${ex.metric === "RPE" ? "RPE" : "RIR"} consigna`}
                            value={ex.rirConsigna} options={metricOptions(ex.metric)}
                            onChange={set("rirConsigna")} customActive={customFields[kRirC]}
                            onToggleCustom={() => toggleCustom(kRirC)}
                            dotColor={effortColor(ex.rirConsigna, ex.metric)} labelColor={GRIS_ETIQUETA} />
                        </div>

                        <PrescripcionTrabajo ex={ex}
                          onChange={(cambios) => Object.entries(cambios).forEach(([k, v]) => set(k)(v))}
                          opcionesSeries={SERIES_OPTIONS} opcionesReps={REPS_OPTIONS}
                          customSeries={customFields[kSeries]} onToggleSeries={() => toggleCustom(kSeries)}
                          customReps={customFields[kReps]} onToggleReps={() => toggleCustom(kReps)} />

                        <SelectorTecnica tecnica={ex.tecnica} config={ex.tecnicaConfig}
                          onChange={(t, cfg) => { set("tecnica")(t); set("tecnicaConfig")(cfg); }}
                    onReps={(v) => { if (v) set("reps")(v); }}
                      pesoBase={ex.pesoSugerido}
                      gruposEjercicios={exerciseGroups} />
                      </div>
                    );
                  })}

                  <button onClick={agregarAlFinalizador}
                    className="w-full flex items-center justify-center gap-1.5 text-xs font-medium border border-dashed rounded-xl py-2.5 transition-colors"
                    style={{ color: "#fb923c", borderColor: "#fb923c66" }}>
                    <Plus size={13} /> Sumar al finalizador
                  </button>
                </div>
              );
            })()}

            <div className="flex gap-2 pt-2">
              <button onClick={cancelNewSessionForm} className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">Cancelar</button>
              <button onClick={saveNewSession} className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">Confirmar</button>
            </div>
          </div>
        )}

        {view === "perfil" && (
          <div className="space-y-4">
            <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-5 flex flex-col items-center">
              <label className="relative cursor-pointer group">
                <div className="w-20 h-20 rounded-full bg-sky-400/10 border border-sky-400/30 flex items-center justify-center overflow-hidden">
                  {perfilVista?.photo ? (
                    <img src={perfilVista.photo} alt="Foto de perfil" className="w-full h-full object-cover" />
                  ) : (
                    <span className="font-display text-sky-400 text-xl font-bold">{(perfilVista?.name || "?").split(" ").map((n) => n[0]).slice(0, 2).join("")}</span>
                  )}
                </div>
                <div className="absolute bottom-0 right-0 w-6 h-6 rounded-full bg-sky-400 border-2 border-black flex items-center justify-center">
                  <Camera size={11} className="text-black" />
                </div>
                <input type="file" accept="image/*" onChange={handlePhotoChange} className="hidden" />
              </label>

              {/* Y sacarse una en el momento: la galería sola obliga a
                  salir de la app, sacarla, y volver. */}
              <label className="text-[11px] text-sky-400 hover:underline cursor-pointer mt-2 inline-flex items-center gap-1">
                <input type="file" accept="image/*" capture="user"
                  onChange={handlePhotoChange} className="hidden" />
                <Camera size={11} /> Sacarte una ahora
              </label>
              <p className="text-[11px] text-neutral-500 mt-1">
                O tocá la foto para elegir una de tu galería
              </p>
            </div>

            {isAlumno && (
              <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-4 space-y-2">
                <div className="flex items-center justify-between">
                  <p className="font-display font-semibold text-sm flex items-center gap-1.5"><Star size={14} className="text-sky-400" /> Nivel {levelFromExp(perfilVista?.exp || 0)}</p>
                  <p className="text-[11px] text-neutral-500">{expInLevel(perfilVista?.exp || 0)}/{expDelNivel(perfilVista?.exp || 0)} EXP</p>
                </div>
                <p className="text-[10px] text-neutral-600">
                  Te faltan {expDelNivel(perfilVista?.exp || 0) - expInLevel(perfilVista?.exp || 0)} EXP para el nivel {levelFromExp(perfilVista?.exp || 0) + 1}
                </p>
                <div className="w-full h-2 bg-neutral-700 rounded-full overflow-hidden">
                  <div className="h-full bg-gradient-to-r from-sky-500 to-sky-200 rounded-full transition-all duration-500" style={{ width: `${Math.round((expInLevel(perfilVista?.exp || 0) / expDelNivel(perfilVista?.exp || 0)) * 100)}%` }} />
                </div>
              </div>
            )}

            <Submenu icono={User} titulo="Datos personales" color="#f472b6"
              resumen={[
                viendoComo?.name || profile?.name,
                edadDesde(datosPersonales.fechaNacimiento) !== null &&
                  `${edadDesde(datosPersonales.fechaNacimiento)} años`,
                datosPersonales.sesionesSemana && `${datosPersonales.sesionesSemana} sesiones/semana`,
              ].filter(Boolean).join(" · ")}
              abierto={menuPerfil === "datos"} onToggle={() => abrirMenu("datos")}>

              {viendoComo && (
                <p className="text-[10px] text-amber-400 bg-amber-400/10 border border-amber-400/25 rounded-lg px-2.5 py-2 leading-relaxed">
                  Estás editando los datos de {viendoComo.name.split(" ")[0]}.
                  El nombre solo lo puede cambiar él.
                </p>
              )}

              <div className="grid grid-cols-2 gap-2">
                <div>
                  <span className="text-[10px] uppercase tracking-wider text-neutral-500">Nombre</span>
                  <input value={datosPersonales.nombre} autoComplete="given-name"
                    disabled={!!viendoComo}
                    onChange={(e) => setDatosPersonales((p) => ({ ...p, nombre: e.target.value }))}
                    className="w-full mt-1 bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-3 py-2 text-sm" />
                </div>
                <div>
                  <span className="text-[10px] uppercase tracking-wider text-neutral-500">Apellido</span>
                  <input value={datosPersonales.apellido} autoComplete="family-name"
                    disabled={!!viendoComo}
                    onChange={(e) => setDatosPersonales((p) => ({ ...p, apellido: e.target.value }))}
                    className="w-full mt-1 bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-3 py-2 text-sm" />
                </div>
              </div>

              {/* El género y las sesiones semanales son datos que el
                  coach necesita de sus alumnos, no de sí mismo: nadie
                  le planifica a él. Por eso solo se muestran cuando el
                  perfil es de un Be Trainer. */}
              {(isAlumno || viendoComo) && (
                <>
                  <div>
                    <span className="text-[10px] uppercase tracking-wider text-neutral-500 block mb-1.5">Género</span>
                    <div className="grid grid-cols-2 gap-1.5">
                      {["Femenino", "Masculino", "No binario", "Sin especificar"].map((g) => (
                        <button key={g} onClick={() => setDatosPersonales((p) => ({ ...p, genero: g }))}
                          className={`rounded-lg py-2 text-[11px] font-medium border transition-colors ${
                            datosPersonales.genero === g ? "bg-sky-400 text-black border-sky-400"
                              : "text-neutral-400 border-neutral-600 hover:border-sky-400/40"}`}>
                          {g}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div>
                    <span className="text-[10px] uppercase tracking-wider text-neutral-500 block mb-1.5">
                      Fecha de nacimiento
                      {edadDesde(datosPersonales.fechaNacimiento) !== null && (
                        <span className="text-sky-400 normal-case tracking-normal ml-1.5">
                          · {edadDesde(datosPersonales.fechaNacimiento)} años
                        </span>
                      )}
                    </span>
                    <SelectorNacimiento valor={datosPersonales.fechaNacimiento}
                      onChange={(v) => setDatosPersonales((p) => ({ ...p, fechaNacimiento: v }))} />
                  </div>

                  <div>
                    <span className="text-[10px] uppercase tracking-wider text-neutral-500 block mb-1.5">
                      Sesiones por semana
                    </span>
                    <div className="flex gap-1.5">
                      {[1, 2, 3, 4, 5, 6].map((n) => (
                        <button key={n} onClick={() => cambiarSesionesSemana(n)}
                          className={`flex-1 rounded-lg py-2 text-sm font-bold border transition-colors ${
                            datosPersonales.sesionesSemana === String(n)
                              ? "bg-sky-400 text-black border-sky-400"
                              : "text-neutral-400 border-neutral-600 hover:border-sky-400/40"}`}>
                          {n}
                        </button>
                      ))}
                    </div>
                    <p className="text-[10px] text-neutral-600 mt-1.5 leading-relaxed">
                      Cuántas veces por semana podés entrenar. Es tu 100% en el torneo:
                      con {datosPersonales.sesionesSemana || "N"} sesiones cumplidas y
                      compartidas, sumás 3 puntos esa semana.
                    </p>

                    {/* Cambiarlo después necesita aprobación, y el
                        alumno tiene que saberlo antes de tocar. */}
                    {datosPersonales.sesionesSemana && (
                      <p className="text-[10px] text-neutral-600 mt-1">
                        Para cambiarlo más adelante, Mati lo tiene que aprobar. Las semanas
                        que ya jugaste conservan el número que tenías.
                      </p>
                    )}

                    {solicitudesMeta.some((x) => x.estado === "pendiente" && x.alumno_id === profile?.id) && (
                      <p className="text-[10px] text-yellow-400 mt-1.5">
                        Tenés un cambio esperando que Mati lo apruebe.
                      </p>
                    )}
                  </div>

                  {/* El seguimiento de ciclo se ofrece a quien puede
                      tenerlo. En "Masculino" no aparece; en "No binario"
                      y "Sin especificar" sí, porque el género declarado
                      no determina si la persona menstrúa. */}
                  {["Femenino", "No binario", "Sin especificar"].includes(datosPersonales.genero) && (
                    <div className="border-t border-neutral-700 pt-3 space-y-2.5">
                      <label className="flex items-start gap-2.5 cursor-pointer select-none">
                        <input type="checkbox" checked={datosPersonales.sigueCiclo}
                          onChange={(e) => setDatosPersonales((p) => ({ ...p, sigueCiclo: e.target.checked }))}
                          className="w-4 h-4 rounded accent-pink-400 mt-0.5 shrink-0" />
                        <span className="flex-1">
                          <span className="text-xs text-neutral-200 block">Registrar ciclo menstrual</span>
                          <span className="text-[10px] text-neutral-500">
                            Permite ajustar la carga según la fase. Solo lo ven vos y tu coach.
                          </span>
                        </span>
                      </label>

                      {datosPersonales.sigueCiclo && (
                        <div className="grid grid-cols-2 gap-2">
                          <div>
                            <span className="text-[10px] uppercase tracking-wider text-neutral-500">Último inicio</span>
                            <input type="date" value={datosPersonales.cicloUltimoPeriodo}
                              max={new Date().toISOString().slice(0, 10)}
                              onChange={(e) => setDatosPersonales((p) => ({ ...p, cicloUltimoPeriodo: e.target.value }))}
                              className="w-full mt-1 bg-neutral-700 border border-neutral-600 focus:border-pink-400 focus:outline-none rounded-md px-2 py-2 text-xs" />
                          </div>
                          <div>
                            <span className="text-[10px] uppercase tracking-wider text-neutral-500">Duración (días)</span>
                            <input type="number" inputMode="numeric" value={datosPersonales.cicloDuracion}
                              onChange={(e) => setDatosPersonales((p) => ({ ...p, cicloDuracion: e.target.value }))}
                              className="w-full mt-1 bg-neutral-700 border border-neutral-600 focus:border-pink-400 focus:outline-none rounded-md px-2 py-2 text-xs text-center" />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}

              <button onClick={guardarDatosPersonales} disabled={guardandoDatos}
                className="w-full bg-sky-400 hover:bg-sky-200 disabled:opacity-50 text-black font-medium text-sm rounded-lg py-2.5 transition-colors">
                {guardandoDatos ? "Guardando..." : "Guardar datos"}
              </button>
            </Submenu>

            {viendoComo && (
              <div className="bg-amber-400/10 border border-amber-400/30 rounded-xl p-3 flex items-start gap-2">
                <Eye size={14} className="text-amber-400 shrink-0 mt-0.5" />
                <p className="text-[11px] text-amber-300 leading-relaxed">
                  Estás viendo el perfil de {viendoComo.name.split(" ")[0]} como lo ve él.
                  Su contraseña no se muestra acá.
                </p>
              </div>
            )}

            {/* Los coaches. Solo lo ve el administrador: un coach
                entrena alumnos, nombrar a otro coach es otra cosa. */}
            {isCoach && profile?.admin && (
              <div className="w-full bg-neutral-800 border border-neutral-700 rounded-xl p-4">
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
                    style={{ background: "#a78bfa26" }}>
                    <Shield size={16} style={{ color: "#a78bfa" }} />
                  </span>
                  <span className="flex-1 min-w-0 text-left">
                    <span className="block text-sm font-medium text-neutral-200">Coaches</span>
                    <span className="block text-[11px] text-neutral-500">
                      Quién puede planificar
                    </span>
                  </span>
                </div>

                <div className="space-y-1.5">
                  {coaches.map((c) => (
                    <div key={c.id} className="flex items-center gap-2.5 rounded-lg px-2.5 py-2"
                      style={{ background: "#303030" }}>
                      <Avatar student={{ id: c.id, name: `${c.nombre} ${c.apellido}` }} size={26} />
                      <span className="flex-1 min-w-0">
                        <span className="block text-xs truncate">
                          {c.nombre} {c.apellido}
                        </span>
                        {c.admin && (
                          <span className="block text-[9px]" style={{ color: "#a78bfa" }}>
                            Administrador
                          </span>
                        )}
                      </span>
                      {/* A sí mismo no: si se sacara, nadie podría
                          volver a nombrar coaches. */}
                      {c.id !== profile?.id && (
                        <button
                          onClick={() => setConfirmar({
                            titulo: `¿Sacar a ${c.nombre} como coach?`,
                            detalle: "Vuelve a ser alumno. No se borra nada de lo que hizo.",
                            accion: () => quitarCoach(c),
                          })}
                          className="text-[10px] text-neutral-500 hover:text-red-400 transition-colors shrink-0">
                          Sacar
                        </button>
                      )}
                    </div>
                  ))}
                </div>

                <button onClick={() => setEligiendoCoach(true)}
                  className="w-full mt-2 flex items-center justify-center gap-1.5 text-[11px] font-medium text-sky-400 bg-sky-400/10 border border-sky-400/25 rounded-lg py-2 transition-colors hover:bg-sky-400/20">
                  <Plus size={12} /> Sumar un coach
                </button>

                <p className="text-[10px] text-neutral-600 mt-2.5 pt-2.5 leading-relaxed"
                  style={{ borderTop: "1px solid #ffffff0d" }}>
                  Para sumar a alguien, primero tiene que registrarse como
                  alumno con el código de invitación. Desde acá lo pasás a coach.
                </p>
              </div>
            )}

            {/* Modo vacaciones. Sin esto, el que avisa que se va dos
                semanas termina en el ranking igual que el que abandonó:
                el sistema no distingue entre no poder y no querer. */}
            {isAlumno && (
              <div className="w-full bg-neutral-800 border border-neutral-700 rounded-xl p-4">
                <div className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
                    style={{ background: `${ESTADO.bien}26` }}>
                    <Palmtree size={16} style={{ color: ESTADO.bien }} />
                  </span>
                  <span className="flex-1 min-w-0 text-left">
                    <span className="block text-sm font-medium text-neutral-200">
                      Modo vacaciones
                    </span>
                    <span className="block text-[11px] text-neutral-500">
                      Pausá el ranking mientras no entrenás
                    </span>
                  </span>
                  <button
                    onClick={async () => {
                      const nuevo = !profile?.vacaciones;
                      setProfile((p) => ({ ...p, vacaciones: nuevo }));
                      const ok = await persistir(() => cambiarVacaciones(nuevo),
                        "No se pudo cambiar el modo vacaciones.");
                      if (!ok) { setProfile((p) => ({ ...p, vacaciones: !nuevo })); return; }
                      showToast(nuevo
                        ? "Modo vacaciones activado"
                        : "✓ De vuelta · el ranking vuelve a contar");
                    }}
                    className="w-11 h-6 rounded-full relative shrink-0 transition-colors"
                    style={{ background: profile?.vacaciones ? ESTADO.bien : "#404040" }}>
                    <span className="absolute top-1 w-4 h-4 rounded-full transition-all"
                      style={{ left: profile?.vacaciones ? 24 : 4,
                               background: profile?.vacaciones ? "#000" : "#737373" }} />
                  </button>
                </div>
                <p className="text-[10px] text-neutral-600 mt-2.5 pt-2.5 leading-relaxed"
                  style={{ borderTop: "1px solid #ffffff0d" }}>
                  Las semanas en vacaciones no cuentan como incumplidas.
                  Tu puesto queda como está hasta que vuelvas.
                </p>
              </div>
            )}

            {/* La guía, con el logo de la marca y no un icono genérico.
                Se abre DENTRO de la app, como los videos: al cerrarla
                volvés donde estabas, sin cambiar de pestaña. */}
            <button onClick={() => setVerGuia(true)}
              className="w-full bg-neutral-800 border border-neutral-700 hover:border-sky-400/40 rounded-xl p-4 flex items-center gap-3 transition-colors">
              <span className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 p-1.5"
                style={{ background: "#38bdf826" }}>
                <img src={LOGO_URI} alt="" className="w-full h-full object-contain" />
              </span>
              <span className="flex-1 min-w-0 text-left">
                <span className="block text-sm font-medium text-neutral-200">Cómo usar la app</span>
                <span className="block text-[11px] text-neutral-500">
                  Guía completa: entrenar, RIR, insignias y ranking
                </span>
              </span>
              <ChevronRight size={14} className="text-neutral-600 shrink-0" />
            </button>

            {/* El abono vive en otra aplicación: acá va el acceso, no
                una copia de esa información. Duplicarla obligaría a
                mantener dos verdades sobre lo mismo. */}
            <a href="https://www.abonosbe.com.ar" target="_blank" rel="noopener noreferrer"
              className="w-full bg-neutral-800 border border-neutral-700 hover:border-emerald-400/40 rounded-xl p-4 flex items-center gap-3 transition-colors">
              <span className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
                style={{ background: "#34d39926" }}>
                <CreditCard size={16} style={{ color: "#34d399" }} />
              </span>
              <span className="flex-1 min-w-0 text-left">
                <span className="block text-sm font-medium text-neutral-200">Abono</span>
                <span className="block text-[11px] text-neutral-500">
                  Ingresá acá para realizar el pago de tu abono
                </span>
              </span>
              <ExternalLink size={14} className="text-neutral-600 shrink-0" />
            </a>

            <Submenu icono={Sun} titulo="Apariencia" color="#38bdf8"
              resumen={`Texto ${({ 90: "pequeño", 100: "estándar", 118: "grande" })[prefs.escala] || `${prefs.escala}%`} · tema ${prefs.tema}`}
              abierto={menuPerfil === "apariencia"} onToggle={() => abrirMenu("apariencia")}>
              <div>
                <p className="text-[10px] text-neutral-600 mb-2">Tamaño del texto</p>

                {/* Tres opciones y no una barra continua: nadie
                    necesita elegir entre 103% y 108%, y una barra
                    obliga a decidir un número en vez de una idea. */}
                <div className="flex gap-1.5">
                  {[["Pequeño", 90, 12], ["Estándar", 100, 15], ["Grande", 118, 18]].map(([l, v, px]) => (
                    <button key={v} onClick={() => cambiarPref("escala", v)}
                      className={`flex-1 rounded-lg py-2.5 border transition-colors flex flex-col items-center gap-0.5 ${
                        prefs.escala === v ? "bg-sky-400 text-black border-sky-400"
                          : "text-neutral-400 border-neutral-600 hover:border-sky-400/40"}`}>
                      <span style={{ fontSize: px, fontWeight: 700, lineHeight: 1 }}>A</span>
                      <span className="text-[9px]">{l}</span>
                    </button>
                  ))}
                </div>

                {/* La muestra se queda: ver el resultado antes de
                    aplicarlo es lo que hace que la elección sea fácil. */}
                <div className="mt-2.5 bg-neutral-900 border border-neutral-700 rounded-lg p-3 overflow-hidden">
                  <p className="text-[9px] uppercase tracking-wider text-neutral-600 mb-1.5">Así se va a ver</p>
                  <div style={{ zoom: `${prefs.escala}%` }}>
                    <p className="font-display font-semibold text-sm">Sentadilla búlgara</p>
                    <p className="text-[11px] text-neutral-400 mt-0.5">4 series × 8 · RIR 2 · 20 kg</p>
                  </div>
                </div>
              </div>

              <div>
                <p className="text-[10px] text-neutral-600 mb-2">Tema</p>
                <div className="flex gap-1.5">
                  {[["oscuro", "Oscuro", Moon], ["claro", "Claro", Sun]].map(([v, l, Ico]) => (
                    <button key={v} onClick={() => cambiarPref("tema", v)}
                      className={`flex-1 flex items-center justify-center gap-1.5 rounded-lg py-2.5 text-xs font-medium border transition-colors ${
                        prefs.tema === v ? "bg-sky-400 text-black border-sky-400"
                          : "text-neutral-400 border-neutral-600 hover:border-sky-400/40"}`}>
                      <Ico size={13} /> {l}
                    </button>
                  ))}
                </div>
              </div>

              <p className="text-[10px] text-neutral-600 leading-relaxed">
                Valen para este dispositivo. Si entrás desde otro, los configurás allá.
              </p>
            </Submenu>

            <Submenu icono={Clock} titulo="Temporizador" color="#fb923c"
              resumen={!prefs.sonido && !prefs.vibracion ? "En silencio"
                : [prefs.sonido && "sonido", prefs.vibracion && "vibración"].filter(Boolean).join(" y ")}
              abierto={menuPerfil === "temporizador"} onToggle={() => abrirMenu("temporizador")}>
              <div className="space-y-1.5">
                {[["sonido", "Sonido", "Pitido en cada cambio y en la cuenta final"],
                  ["vibracion", "Vibración", "El celular vibra al cambiar de fase"]].map(([k, l, ayuda]) => (
                  <label key={k} className="flex items-start gap-2.5 cursor-pointer select-none bg-neutral-700/40 rounded-lg p-2.5">
                    <input type="checkbox" checked={!!prefs[k]}
                      onChange={(e) => cambiarPref(k, e.target.checked)}
                      className="w-4 h-4 rounded accent-sky-400 mt-0.5 shrink-0" />
                    <span className="flex-1 min-w-0">
                      <span className="text-xs text-neutral-200 block">{l}</span>
                      <span className="text-[10px] text-neutral-500">{ayuda}</span>
                    </span>
                  </label>
                ))}
                <button onClick={() => { cambiarPref("sonido", false); cambiarPref("vibracion", false); }}
                  className={`w-full flex items-center justify-center gap-1.5 rounded-lg py-2 text-[11px] font-medium border transition-colors ${
                    !prefs.sonido && !prefs.vibracion
                      ? "bg-neutral-700 text-neutral-300 border-neutral-600"
                      : "text-neutral-500 border-neutral-700 hover:border-neutral-500"}`}>
                  <BellOff size={12} /> Silencio total
                </button>
              </div>
              <p className="text-[10px] text-neutral-600 leading-relaxed">
                En un tabata no mirás la pantalla: el aviso es lo que te deja seguir el ritmo.
              </p>
            </Submenu>

            {/* Acceso a la app: link y código, para pasarle a los alumnos. */}
            {hayBackend && isCoach && codigoInv && (
              <Submenu icono={Share2} titulo="Acceso a la app" color="#22d3ee"
                resumen="Link y código para tus Be Trainers"
                abierto={menuPerfil === "acceso"} onToggle={() => abrirMenu("acceso")}>

                <div>
                  <p className="text-[10px] text-neutral-600 mb-1">Link</p>
                  <div className="flex items-center gap-2">
                    <p className="text-xs text-sky-400 break-all flex-1">{window.location.origin}</p>
                    <button onClick={() => { navigator.clipboard?.writeText(window.location.origin); showToast("✓ Link copiado"); }}
                      className="text-[10px] font-medium text-neutral-400 border border-neutral-600 rounded-full px-2.5 py-1 shrink-0 hover:border-sky-400/40 hover:text-sky-400 transition-colors">
                      Copiar
                    </button>
                  </div>
                </div>

                <div className="pt-3 border-t border-neutral-700">
                  <p className="text-[10px] text-neutral-600 mb-1.5">Código de invitación</p>
                  {editandoCodigo ? (
                    <div className="space-y-2">
                      <input value={codigoDraft} onChange={(e) => setCodigoDraft(e.target.value.toUpperCase())}
                        placeholder="Mínimo 8 caracteres" autoCapitalize="characters"
                        className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-base tracking-widest" />
                      <div className="flex gap-2">
                        <button onClick={() => setEditandoCodigo(false)}
                          className="flex-1 py-2 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
                          Cancelar
                        </button>
                        <button onClick={guardarCodigo}
                          className="flex-1 py-2 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                          Guardar
                        </button>
                      </div>
                      <p className="text-[10px] text-neutral-600">
                        Si lo cambiás, el anterior deja de servir. Los que ya se registraron no se ven afectados.
                      </p>
                    </div>
                  ) : (
                    <div className="flex items-center gap-2">
                      <p className="font-display text-base font-bold tracking-wider text-emerald-400 flex-1 break-all">{codigoInv}</p>
                      <button onClick={() => { navigator.clipboard?.writeText(codigoInv); showToast("✓ Código copiado"); }}
                        className="text-[10px] font-medium text-neutral-400 border border-neutral-600 rounded-full px-2.5 py-1 hover:border-sky-400/40 hover:text-sky-400 transition-colors">
                        Copiar
                      </button>
                      <button onClick={regenerarCodigo} title="Generar uno nuevo al azar"
                        className="text-[10px] font-medium text-neutral-400 border border-neutral-600 rounded-full px-2.5 py-1 hover:border-sky-400/40 hover:text-sky-400 transition-colors">
                        Generar otro
                      </button>
                    </div>
                  )}
                  <p className="text-[10px] text-neutral-600 mt-2 leading-relaxed">
                    Sin este código nadie puede crear una cuenta, aunque tenga el link.
                  </p>
                </div>
              </Submenu>
            )}


            {isAlumno && (
              <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-4 space-y-3">
                <div className="flex items-center justify-between">
                  <p className="font-display font-semibold text-sm flex items-center gap-1.5"><Trophy size={13} className="text-amber-400" /> Récords personales (PR)</p>
                  <button onClick={() => { setPrDraft({ ejercicio: "", valor: "", tipo: "peso" }); setPrModalOpen(true); }} className="text-sky-400 hover:text-sky-200"><Plus size={16} /></button>
                </div>
                {Object.keys(personalRecords).length === 0 && Object.keys(pendingPRs).length === 0 ? (
                  <p className="text-xs text-neutral-500">Todavía no tenés PRs registrados. Se detectan solos cuando superás un peso o repeticiones en una sesión, o los agregás a mano acá — el coach los tiene que aprobar.</p>
                ) : (
                  <div className="space-y-1.5">
                    {Object.entries(pendingPRs).map(([ejercicio, pr]) => {
                      const alreadyClaimed = prRequests.some((r) => r.ejercicio === ejercicio);
                      const unit = pr.tipo === "peso" ? "kg" : "reps";
                      return (
                        <div key={`pending-${ejercicio}`} className="flex items-center justify-between bg-amber-400/5 border border-amber-400/20 rounded-lg px-3 py-2">
                          <div className="min-w-0">
                            <p className="text-xs text-neutral-300 truncate">{ejercicio}</p>
                            <p className="text-[10px] text-amber-400">{pr.valor} {unit} · {alreadyClaimed ? "Esperando aprobación" : "Sin reclamar"}</p>
                          </div>
                          {!alreadyClaimed && (
                            <button onClick={() => claimPR(ejercicio)} className="text-[11px] font-medium text-black bg-amber-400 hover:bg-amber-300 rounded-full px-2.5 py-1 shrink-0 transition-colors">
                              Reclamar
                            </button>
                          )}
                        </div>
                      );
                    })}
                    {Object.entries(personalRecords).sort((a, b) => a[0].localeCompare(b[0])).map(([ejercicio, pr]) => (
                      <button key={ejercicio} onClick={() => { setPrDraft({ ejercicio, valor: String(pr.valor), tipo: pr.tipo || "peso" }); setPrModalOpen(true); }}
                        className="w-full flex items-center justify-between bg-neutral-700/40 hover:bg-neutral-700 rounded-lg px-3 py-2 transition-colors">
                        <p className="text-xs text-neutral-300">{ejercicio}</p>
                        <p className="text-xs font-semibold text-amber-400">{pr.valor} {pr.tipo === "peso" ? "kg" : "reps"}</p>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}

            {isAlumno && (
              <button onClick={() => setView("historial")} className="w-full flex items-center justify-between bg-neutral-800 border border-neutral-700 hover:border-sky-400/30 rounded-xl p-4 transition-colors">
                <p className="font-display font-semibold text-sm flex items-center gap-1.5"><Calendar size={13} className="text-sky-400" /> Historial de entrenamientos</p>
                <ChevronDown size={15} className="text-neutral-500 -rotate-90" />
              </button>
            )}


            {!viendoComo && (
            <Submenu icono={KeyRound} titulo="Cambiar contraseña" color="#34d399"
              abierto={menuPerfil === "password"} onToggle={() => abrirMenu("password")}>
              <div>
                <span className="text-[10px] uppercase tracking-wider text-neutral-500">Contraseña actual</span>
                <CampoPassword value={passwordForm.current} autoComplete="current-password"
                  onChange={(e) => setPasswordForm((p) => ({ ...p, current: e.target.value }))}
                  className="w-full mt-1 bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-3 py-2 text-sm text-white transition-colors" />
              </div>
              <div>
                <span className="text-[10px] uppercase tracking-wider text-neutral-500">Contraseña nueva</span>
                <CampoPassword value={passwordForm.next} autoComplete="new-password"
                  onChange={(e) => setPasswordForm((p) => ({ ...p, next: e.target.value }))}
                  className="w-full mt-1 bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-3 py-2 text-sm text-white transition-colors" />
              </div>
              <div>
                <span className="text-[10px] uppercase tracking-wider text-neutral-500">Repetir contraseña nueva</span>
                <CampoPassword value={passwordForm.confirm} autoComplete="new-password"
                  onChange={(e) => setPasswordForm((p) => ({ ...p, confirm: e.target.value }))}
                  className="w-full mt-1 bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-3 py-2 text-sm text-white transition-colors" />
              </div>
              <button onClick={handleChangePassword} disabled={cambiandoPass}
                className="w-full border border-sky-400/30 text-sky-400 hover:bg-sky-400/10 disabled:opacity-50 font-medium text-sm rounded-lg py-2 transition-colors">
                {cambiandoPass ? "Cambiando..." : "Actualizar contraseña"}
              </button>
            </Submenu>
            )}
          </div>
        )}

        {view === "historial" && isAlumno && (
          <div className="space-y-3">
            <p className="text-neutral-500 text-xs mb-1">Copia de seguridad de todas tus sesiones, organizadas por mes.</p>
            <WeeksFolderList
              weeks={weeks}
              isCoach={false}
              collapsedMonths={collapsedMonths}
                semanasPlegadas={semanasPlegadas} setSemanasPlegadas={setSemanasPlegadas}
              setCollapsedMonths={setCollapsedMonths}
              onOpenWeek={(w) => { setActiveWeekId(w.id); setWeekOrigin("historial"); setView("week"); }}
              onBorrarSemana={(w) => setConfirmar({ tipo: "semana", semana: w })}
              emptyLabel="Todavía no hay entrenamientos registrados."
            />
          </div>
        )}

        {view === "biomecanica" && <Biomecanica tema={prefs.tema} />}

        {view === "planificador" && isCoach && (
          <Planificador alumnos={studentsList}
            opcionesRir={RIR_OPTIONS} opcionesRpe={RPE_OPTIONS} estadoPeso={estadoPeso}
            EditorTecnica={SelectorTecnica}
            gruposEjercicios={exerciseGroups} mediosEjercicios={exerciseMedia}
            opcionesConQue={CON_QUE_OPTIONS}
            onCopiarVarios={(ids) => setSemanaMasiva({
              paso: "quienes", elegidos: [], candidatos: ids, nombre: "", periodo: "", clonar: true,
              visibleDesde: visibilidadPorDefecto() })}
            refrescar={refrescarPlan}
            Hilo={HiloEjercicio} puedeTocarMensaje={puedeTocarMensaje}
            libreria={libraryCategories} alGuardarLibreria={refrescarLibreria}
            marcarFoto={(imagen, alumnoId, alGuardar) => setMarcando({
              imagen, carpeta: alumnoId, alGuardar, titulo: "Marcá lo que quieras señalar" })}
            aviso={showToast}
            alCrear={() => cargarAlumnos().then((l) => setStudentsList(aLista(l))).catch(() => {})} />
        )}

        {view === "insignias" && (
          <div className="space-y-4">
            <p className="text-neutral-500 text-xs">{Object.values(badgeStatus).filter((s) => s !== "locked").length}/{BADGES.length} insignias conseguidas</p>

            {/* Lo que se puede reclamar va arriba y aparte: mezclado
                con el catálogo, el alumno tiene que barrer trece
                tarjetas para descubrir que hay dos esperándolo. */}
            {isAlumno && (() => {
              const listas = BADGES_VIVAS.filter((b) => badgeStatus[b.id] === "earned");
              if (!listas.length) return null;
              return (
                <div className="rounded-xl border-2 p-3 space-y-3"
                  style={{ borderColor: "#22c55e66", background: "#22c55e0D" }}>
                  <div className="flex items-center gap-2">
                    <Award size={14} style={{ color: "#22c55e" }} className="shrink-0" />
                    <p className="text-[11px] font-bold uppercase tracking-wider flex-1"
                      style={{ color: "#22c55e" }}>
                      {listas.length === 1 ? "Podés reclamar 1" : `Podés reclamar ${listas.length}`}
                    </p>
                    {listas.length > 1 && (
                      <button onClick={reclamarTodas}
                        className="text-[11px] font-medium bg-emerald-500 text-black hover:bg-emerald-400 rounded-lg px-3 py-1.5 transition-colors">
                        Reclamar todas
                      </button>
                    )}
                  </div>
                  <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
                    {listas.map((b) => {
                      const Icon = esIcono(b.icon) ? b.icon : Award;
                      return (
                        <div key={b.id} className="bg-neutral-800 border border-neutral-700 rounded-xl p-4 flex flex-col items-center text-center">
                          {/* Se inclina siguiendo el dedo: una medalla
                              que responde al toque se siente distinta
                              a una calcomanía. */}
                          {b.imagen
                            ? <InsigniaGirable src={b.imagen} color={b.color}
                                inicial={b.name} tam={64}
                                onClick={() => setInsigniaGrande(b)} />
                            : <div className="w-12 h-12 rounded-full flex items-center justify-center mb-2"
                                style={{ backgroundColor: `${b.color}1A`, border: `1px solid ${b.color}40` }}>
                                <Icon size={20} style={{ color: b.color }} />
                              </div>}
                          <div className="mb-2" />
                          <p className="font-display font-semibold text-xs">{b.name}</p>
                          <p className="text-[10px] text-neutral-500 mt-1 leading-snug">{b.desc}</p>
                          <button onClick={() => claimBadge(b.id)}
                            className="mt-2.5 w-full text-[11px] font-medium bg-sky-400 text-black hover:bg-sky-200 rounded-lg py-1.5 transition-colors">
                            Reclamar
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}

            <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
              {BADGES_VIVAS.filter((b) => !(isAlumno && badgeStatus[b.id] === "earned")).map((b) => {
                const Icon = esIcono(b.icon) ? b.icon : Award;
                const status = badgeStatus[b.id];
                const locked = status === "locked";
                return (
                  <div key={b.id}
                    className={`bg-neutral-800 border rounded-xl p-3.5 flex flex-col items-center text-center gap-1 ${
                      locked ? "border-neutral-700 opacity-45" : "border-neutral-700"}`}>

                    {/* La imagen si la tiene y ya es suya —ahí se puede
                        girar—; si no, el ícono. Bloqueada va en gris:
                        mostrarla a todo color sería prometer algo que
                        todavía no pasó. */}
                    <div className="relative mb-1">
                      {b.imagen && !locked
                        ? <InsigniaGirable src={b.imagen} color={b.color}
                            inicial={b.name} tam={56}
                            onClick={() => setInsigniaGrande(b)} />
                        : <div className="w-14 h-14 rounded-full flex items-center justify-center"
                            style={{ backgroundColor: locked ? "#26262620" : `${b.color}1A`,
                                     border: `1px solid ${locked ? "#52525240" : b.color + "40"}` }}>
                            {b.imagen
                              ? <img src={b.imagen} alt="" className="w-9 h-9 object-contain"
                                  style={{ filter: "grayscale(1)", opacity: 0.6 }} />
                              : <Icon size={22} style={{ color: locked ? "#525252" : b.color }} />}
                          </div>}
                      {locked && (
                        <span className="absolute -bottom-0.5 -right-0.5 w-5 h-5 rounded-full bg-neutral-700 border-2 border-neutral-800 flex items-center justify-center">
                          <Lock size={9} className="text-neutral-500" />
                        </span>
                      )}
                      {status === "approved" && (
                        <span className="absolute -bottom-0.5 -right-0.5 w-5 h-5 rounded-full flex items-center justify-center border-2 border-neutral-800"
                          style={{ background: ESTADO.bien }}>
                          <Check size={10} className="text-black" strokeWidth={3} />
                        </span>
                      )}
                    </div>

                    <p className="font-display font-semibold text-xs">{b.name}</p>
                    <p className="text-[10px] text-neutral-500 mt-1 leading-snug">{b.desc}</p>
                    {status === "approved" && isAlumno && (
                      <button onClick={() => compartirInsignia(b)}
                        className="mt-2.5 w-full flex items-center justify-center gap-1.5 text-[11px] font-medium text-emerald-400 border border-emerald-400/30 hover:bg-emerald-400/10 rounded-lg py-1.5 transition-colors">
                        <Share2 size={11} /> Compartir
                      </button>
                    )}

                    {/* El progreso viene de la base: "3/7 días seguidos".
                        Antes era un texto fijo en el código, igual para
                        todos y siempre desactualizado. */}
                    {locked && (logradas[b.id]?.txt || b.progress) && (
                      <p className="text-[10px] text-sky-400 mt-1.5 font-medium">
                        {logradas[b.id]?.txt || b.progress}
                      </p>
                    )}
                    {status === "earned" && (
                      <button onClick={() => claimBadge(b.id)} className="mt-2 w-full text-[11px] font-medium text-black bg-sky-400 hover:bg-sky-200 rounded-full py-1.5 transition-colors">
                        Reclamar
                      </button>
                    )}
                    {status === "pending" && (
                      <p className="mt-2 text-[10px] text-yellow-400 flex items-center gap-1"><Clock size={10} /> Esperando a tu coach</p>
                    )}
                    {status === "approved" && (
                      <p className="mt-2 text-[10px] text-emerald-400 font-medium">Insignia activa</p>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Las del grupo. Una insignia que solo ve el que la
                      ganó pierde la mitad de su sentido: el resto no
                      sabe que existe ni que se puede conseguir. */}
                  {isAlumno && insigniasGrupo.length > 0 && (
                    <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-4 space-y-2">
                      <p className="text-xs font-medium mb-2">Las del grupo</p>
                      {[...insigniasGrupo]
                        .sort((a, b) => (b.cuantas || 0) - (a.cuantas || 0))
                        .map((g, k) => {
                        const suyas = BADGES_VIVAS.filter((b) =>
                          (g.codigos || []).includes(b.id));
                        const esYo = g.alumno_id === (viendoComo?.id || profile?.id);
                        return (
                          <div key={g.alumno_id}
                            className="flex items-center gap-2.5 py-2 px-2 -mx-2 rounded-lg"
                            style={esYo ? { background: "#38bdf814" } : undefined}>
                            <span className="text-[11px] font-bold w-4 shrink-0"
                              style={{ color: esYo ? "#38bdf8"
                                : k === 0 ? ESTADO.aviso : "#64748b" }}>
                              {k + 1}
                            </span>
                            <Avatar student={{ id: g.alumno_id, name: g.nombre, photo: g.foto }} size={26} />
                            <span className="min-w-0 flex-1">
                              <span className="block text-xs truncate"
                                style={{ color: esYo ? "#38bdf8" : "#e2e8f0",
                                         fontWeight: esYo ? 500 : 400 }}>
                                {esYo ? "Vos" : g.nombre}
                              </span>
                              <span className="flex gap-1 mt-1">
                                {suyas.length === 0
                                  ? <span className="text-[10px] text-neutral-600">sin insignias todavía</span>
                                  : suyas.slice(0, 7).map((b) => (
                                      <span key={b.id} title={b.name}
                                        className="w-5 h-5 rounded flex items-center justify-center shrink-0"
                                        style={{ background: `${b.color}1F` }}>
                                        {b.imagen
                                          ? <img src={b.imagen} alt="" className="w-full h-full object-contain" />
                                          : React.createElement(esIcono(b.icon) ? b.icon : Award,
                                              { size: 11, style: { color: b.color } })}
                                      </span>
                                    ))}
                                {suyas.length > 7 && (
                                  <span className="text-[10px] text-neutral-600 self-center">
                                    +{suyas.length - 7}
                                  </span>
                                )}
                              </span>
                            </span>
                            <span className="text-sm font-display font-semibold shrink-0"
                              style={{ color: esYo ? "#38bdf8" : "#94a3b8" }}>
                              {g.cuantas || 0}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )}

            {/* Insignias que salieron de propuestas aprobadas. */}
            {insigniasDB.catalogo.filter((i) => i.codigo?.startsWith("p")).length > 0 && (
              <div className="space-y-2">
                <p className="text-[11px] uppercase tracking-wider text-neutral-500">
                  Propuestas por Be Trainers
                </p>
                <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
                  {insigniasDB.catalogo.filter((i) => i.codigo?.startsWith("p")).map((i) => (
                    <div key={i.id} className="bg-neutral-800 border border-neutral-700 rounded-xl p-4 flex flex-col items-center text-center">
                      <div className="w-12 h-12 rounded-full flex items-center justify-center mb-2"
                        style={{ backgroundColor: `${i.color || "#a78bfa"}1A`, border: `1px solid ${i.color || "#a78bfa"}40` }}>
                        <Award size={20} style={{ color: i.color || "#a78bfa" }} />
                      </div>
                      <p className="font-display font-semibold text-xs">{i.nombre}</p>
                      <p className="text-[10px] text-neutral-500 mt-1 leading-snug">{i.descripcion}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {isAlumno && (
              <div className="space-y-2.5">
                {proponerAbierto ? (
                  <div className="bg-neutral-800 border border-sky-400/30 rounded-xl p-4 space-y-3">
                    <p className="font-display font-semibold text-sm">Proponé una insignia</p>
                    <p className="text-[11px] text-neutral-500 leading-relaxed">
                      Contale a tu coach qué insignia se te ocurre y cómo se consigue.
                      No hace falta que vos la cumplas: puede ser una buena idea igual.
                    </p>
                    <div>
                      <span className="text-[10px] uppercase tracking-wider text-neutral-500">Nombre</span>
                      <input value={propuestaDraft.nombre} maxLength={60}
                        onChange={(e) => setPropuestaDraft((p) => ({ ...p, nombre: e.target.value }))}
                        placeholder="Ej: Lluvia o frío"
                        className="w-full mt-1 bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-3 py-2 text-sm" />
                    </div>
                    <div>
                      <span className="text-[10px] uppercase tracking-wider text-neutral-500">Cómo se consigue</span>
                      <textarea value={propuestaDraft.descripcion} rows={2} maxLength={200}
                        onChange={(e) => setPropuestaDraft((p) => ({ ...p, descripcion: e.target.value }))}
                        placeholder="Entrenar 5 veces con menos de 10 grados"
                        className="w-full mt-1 bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-3 py-2 text-sm resize-y" />
                    </div>
                    <div className="flex gap-2">
                      <button onClick={() => setProponerAbierto(false)}
                        className="flex-1 py-2 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
                        Cancelar
                      </button>
                      <button onClick={enviarPropuesta}
                        className="flex-1 py-2 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                        Enviar
                      </button>
                    </div>
                  </div>
                ) : (
                  <button onClick={() => setProponerAbierto(true)}
                    className="w-full flex items-center justify-center gap-1.5 text-xs font-medium text-sky-400 border border-dashed border-sky-400/40 hover:bg-sky-400/10 rounded-xl py-3 transition-colors">
                    <Plus size={13} /> Proponé tu insignia
                  </button>
                )}

                {/* Las propias, con su estado. */}
                {propuestas.filter((x) => x.autor_id === profile?.id).map((x) => (
                  <div key={x.id} className="bg-neutral-800/60 border border-neutral-700 rounded-lg p-2.5 flex items-center gap-2">
                    <Award size={13} className="text-neutral-600 shrink-0" />
                    <span className="text-[11px] text-neutral-400 flex-1 min-w-0 truncate">{x.nombre}</span>
                    <span className={`text-[10px] font-medium rounded-full px-2 py-0.5 shrink-0 ${
                      x.estado === "aprobada" ? "text-emerald-400 bg-emerald-400/10"
                      : x.estado === "rechazada" ? "text-neutral-500 bg-neutral-700"
                      : "text-yellow-400 bg-yellow-400/10"}`}>
                      {x.estado === "aprobada" ? "Aprobada"
                        : x.estado === "rechazada" ? "No esta vez" : "Esperando"}
                    </span>
                  </div>
                ))}
              </div>
            )}

            <p className="text-[11px] text-neutral-600 text-center py-2">
              Próximamente más insignias.
            </p>
          </div>
        )}

        {/* Insignias. Tres cosas en una pantalla: lo que hay que
            resolver, el catálogo, y quién tiene qué. Separarlas
            obligaría a saltar entre pantallas para algo que se hace
            de una sentada. */}
        {view === "solicitudes" && (
          <div className="space-y-3">
            <div className="flex gap-1.5">
              {[["pendientes", "Pendientes"], ["catalogo", "Todas"]].map(([k, txt]) => (
                <button key={k} onClick={() => setVistaInsignias(k)}
                  className={`flex-1 rounded-lg py-2 text-xs font-medium border transition-colors ${
                    vistaInsignias === k
                      ? "bg-sky-400 text-black border-sky-400"
                      : "text-neutral-400 border-neutral-600 hover:border-sky-400/40"}`}>
                  {txt}
                  {k === "pendientes" && tablero?.pendientes > 0 && ` (${tablero.pendientes})`}
                </button>
              ))}
            </div>

            {vistaInsignias === "catalogo" ? (
              <>
                <button onClick={() => setEditandoInsignia({
                    nombre: "", descripcion: "", color: "#38bdf8", imagenUrl: "" })}
                  className="w-full flex items-center justify-center gap-1.5 text-xs font-medium text-sky-400 border border-dashed border-sky-400/40 hover:bg-sky-400/10 rounded-xl py-3 transition-colors">
                  <Plus size={14} /> Crear una insignia
                </button>

                {catalogoInsignias.length === 0 && (
                  <p className="text-xs text-neutral-600 text-center py-6">
                    Todavía no hay insignias cargadas.
                  </p>
                )}

                {catalogoInsignias.map((ins) => {
                  const abierta = insigniaAbierta === ins.id;
                  const ganadores = (ins.dueños || []).filter((d) => d.estado === "earned");
                  return (
                    <div key={ins.id}
                      className={`bg-neutral-800 border rounded-xl p-3 space-y-2.5 ${
                        ins.activa ? "border-neutral-700" : "border-neutral-800 opacity-60"}`}>
                      <div className="flex items-center gap-3">
                        {ins.imagen_url
                          ? <img src={ins.imagen_url} alt=""
                              className="w-10 h-10 rounded-lg object-contain shrink-0"
                              style={{ background: `${ins.color}1F` }} />
                          : <span className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0 font-display font-bold"
                              style={{ background: `${ins.color}26`, color: ins.color }}>
                              {(ins.nombre || "?").slice(0, 1).toUpperCase()}
                            </span>}
                        <span className="flex-1 min-w-0">
                          <span className="block text-sm font-medium text-neutral-200 truncate">
                            {ins.nombre}
                            {!ins.activa && <span className="text-[10px] text-neutral-600"> · archivada</span>}
                          </span>
                          <span className="block text-[11px] text-neutral-500 truncate">
                            {ins.descripcion || "Sin descripción"}
                          </span>
                        </span>
                        <button onClick={() => setEditandoInsignia({
                            id: ins.id, nombre: ins.nombre,
                            descripcion: ins.descripcion || "",
                            color: ins.color || "#38bdf8",
                            imagenUrl: ins.imagen_url || "", activa: ins.activa })}
                          className="p-1.5 text-neutral-600 hover:text-white transition-colors shrink-0">
                          <Pencil size={13} />
                        </button>
                      </div>

                      <button onClick={() => setInsigniaAbierta(abierta ? null : ins.id)}
                        className="w-full flex items-center gap-2 text-left border-t border-neutral-700 pt-2.5">
                        {/* Las caras de quienes la tienen: dice más de
                            un vistazo que el número solo. */}
                        <span className="flex -space-x-1.5 shrink-0">
                          {ganadores.slice(0, 4).map((d) => (
                            <Avatar key={d.alumno_id}
                              student={{ id: d.alumno_id, name: d.nombre, photo: d.foto }}
                              size={20} />
                          ))}
                        </span>
                        <span className="text-[11px] text-neutral-500 flex-1">
                          {ganadores.length === 0 ? "Nadie la tiene todavía"
                            : ganadores.length === 1 ? "1 Be Trainer"
                            : `${ganadores.length} Be Trainers`}
                        </span>
                        <span className="text-[10px] text-sky-400">
                          {abierta ? "cerrar" : "dar o quitar"}
                        </span>
                        <ChevronDown size={13}
                          className={`text-neutral-600 shrink-0 transition-transform ${
                            abierta ? "" : "-rotate-90"}`} />
                      </button>

                      {abierta && (
                        <div className="space-y-0.5 pt-1 max-h-64 overflow-y-auto">
                          {studentsList.map((st) => {
                            const tiene = ganadores.some((d) => d.alumno_id === st.id);
                            return (
                              <button key={st.id}
                                onClick={() => alternarInsignia(st.id, ins.id, !tiene)}
                                className="w-full flex items-center gap-2 py-1.5 hover:bg-neutral-700/40 rounded-lg px-1 transition-colors text-left">
                                <span className="w-5 h-5 rounded flex items-center justify-center shrink-0"
                                  style={{ border: `2px solid ${tiene ? ins.color : "#525252"}`,
                                           background: tiene ? ins.color : "transparent" }}>
                                  {tiene && <Check size={11} className="text-black" strokeWidth={3} />}
                                </span>
                                <Avatar student={st} size={20} />
                                <span className={`text-xs flex-1 min-w-0 truncate ${
                                  tiene ? "text-neutral-200" : "text-neutral-500"}`}>
                                  {st.name}
                                </span>
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </>
            ) : (

          <div className="space-y-4">
            {/* Cambios de sesiones semanales. Van primero porque
                afectan el puntaje del torneo de acá en adelante. */}
            {solicitudesMeta.filter((x) => x.estado === "pendiente").length > 0 && (
              <div className="space-y-2.5">
                <p className="text-[11px] uppercase tracking-wider text-neutral-500">
                  Cambios de plan semanal
                </p>
                {solicitudesMeta.filter((x) => x.estado === "pendiente").map((x) => {
                  const autor = studentsList.find((a) => a.id === x.alumno_id);
                  const sube = (x.pedida || 0) > (x.actual || 0);
                  return (
                    <div key={x.id} className="bg-neutral-800 border border-neutral-700 rounded-xl p-4">
                      <div className="flex items-center gap-2 mb-2">
                        <Users size={14} className="text-sky-400 shrink-0" />
                        <p className="font-display font-semibold text-sm flex-1 min-w-0 truncate">
                          {autor?.name || "Un Be Trainer"}
                        </p>
                      </div>

                      <div className="flex items-center gap-2 mb-2">
                        <span className="font-display text-2xl font-bold text-neutral-500">
                          {x.actual ?? "—"}
                        </span>
                        <ArrowRight size={14} className="text-neutral-600 shrink-0" />
                        <span className="font-display text-2xl font-bold"
                          style={{ color: sube ? "#22c55e" : "#fb923c" }}>
                          {x.pedida}
                        </span>
                        <span className="text-[11px] text-neutral-500 flex-1">
                          sesiones por semana
                        </span>
                      </div>

                      {x.motivo && (
                        <p className="text-xs text-neutral-400 mb-2">"{x.motivo}"</p>
                      )}

                      <p className="text-[10px] text-neutral-600 mb-3 leading-relaxed">
                        {sube
                          ? "Le va a costar más llegar al 100%. Las semanas anteriores no cambian."
                          : "Le va a resultar más fácil llegar al 100% de acá en adelante. Las semanas anteriores no cambian."}
                      </p>

                      <div className="flex gap-2">
                        <button onClick={() => resolverMeta(x, false)}
                          className="flex-1 py-2 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600 hover:border-neutral-500 transition-colors">
                          No por ahora
                        </button>
                        <button onClick={() => resolverMeta(x, true)}
                          className="flex-1 py-2 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                          Aprobar
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Insignias propuestas por los alumnos. Se aprueban por la
                idea, no por si quien la propuso la cumple. */}
            {propuestas.filter((x) => x.estado === "pendiente").length > 0 && (
              <div className="space-y-2.5">
                <p className="text-[11px] uppercase tracking-wider text-neutral-500">
                  Insignias propuestas
                </p>
                {propuestas.filter((x) => x.estado === "pendiente").map((x) => {
                  const autor = studentsList.find((a) => a.id === x.autor_id);
                  return (
                    <div key={x.id} className="bg-neutral-800 border border-neutral-700 rounded-xl p-4">
                      <div className="flex items-center gap-2 mb-2">
                        <Award size={14} className="text-violet-400 shrink-0" />
                        <p className="font-display font-semibold text-sm flex-1 min-w-0 truncate">{x.nombre}</p>
                      </div>
                      <p className="text-xs text-neutral-400 leading-relaxed mb-1">{x.descripcion}</p>
                      <p className="text-[10px] text-neutral-600 mb-3">
                        Propuesta por {autor?.name || "un Be Trainer"}
                      </p>
                      <div className="flex gap-2">
                        <button onClick={() => resolverPropuestaInsignia(x, false)}
                          className="flex-1 py-2 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600 hover:border-neutral-500 transition-colors">
                          No esta vez
                        </button>
                        <button onClick={() => resolverPropuestaInsignia(x, true)}
                          className="flex-1 py-2 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                          Crear insignia
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            <div className="space-y-2.5">
              <p className="text-[11px] uppercase tracking-wider text-neutral-500">Insignias</p>
              {badgeRequests.length === 0 ? (
                <p className="text-neutral-600 text-xs py-2">No hay solicitudes de insignias pendientes.</p>
              ) : (
                badgeRequests.map((req) => {
                  const badge = BADGES_VIVAS.find((b) => b.id === req.badgeId);
                  const Icon = esIcono(badge?.icon) ? badge.icon : Award;
                  return (
                    <div key={req.id} className="bg-neutral-800 border border-neutral-700 rounded-xl p-4">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0" style={{ backgroundColor: `${badge?.color}1A`, border: `1px solid ${badge?.color}40` }}>
                          <Icon size={18} style={{ color: badge?.color }} />
                        </div>
                        <div className="min-w-0">
                          <p className="font-display font-semibold text-sm truncate">{badge?.name}</p>
                          <p className="text-[11px] text-neutral-500 truncate">{req.studentName} la reclama</p>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <button onClick={() => rejectBadgeRequest(req.id)} className="flex-1 flex items-center justify-center gap-1.5 text-xs font-medium text-red-400 bg-red-400/10 border border-red-400/20 rounded-lg py-2 hover:bg-red-400/20 transition-colors">
                          <ThumbsDown size={13} /> Rechazar
                        </button>
                        <button onClick={(e) => approveBadgeRequest(req.id, e.currentTarget)} className="flex-1 flex items-center justify-center gap-1.5 text-xs font-medium text-emerald-400 bg-emerald-400/10 border border-emerald-400/20 rounded-lg py-2 hover:bg-emerald-400/20 transition-colors">
                          <ThumbsUp size={13} /> Aprobar
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            <div className="space-y-2.5">
              <p className="text-[11px] uppercase tracking-wider text-neutral-500">Récords personales (PR)</p>
              {prRequests.length === 0 ? (
                <p className="text-neutral-600 text-xs py-2">No hay PRs pendientes de aprobación.</p>
              ) : (
                prRequests.map((req) => (
                  <div key={req.id} className="bg-neutral-800 border border-neutral-700 rounded-xl p-4">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-amber-400/10 border border-amber-400/40">
                        <Trophy size={18} className="text-amber-400" />
                      </div>
                      <div className="min-w-0">
                        <p className="font-display font-semibold text-sm truncate">{req.ejercicio} · {req.valor}{req.tipo === "peso" ? "kg" : " reps"}</p>
                        <p className="text-[11px] text-neutral-500 truncate">{req.studentName} lo reclama{req.prevValor ? ` (antes ${req.prevValor}${req.tipo === "peso" ? "kg" : " reps"})` : ""}</p>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <button onClick={() => rejectPRRequest(req.id)} className="flex-1 flex items-center justify-center gap-1.5 text-xs font-medium text-red-400 bg-red-400/10 border border-red-400/20 rounded-lg py-2 hover:bg-red-400/20 transition-colors">
                        <ThumbsDown size={13} /> Rechazar
                      </button>
                      <button onClick={(e) => approvePRRequest(req.id, e.currentTarget)} className="flex-1 flex items-center justify-center gap-1.5 text-xs font-medium text-emerald-400 bg-emerald-400/10 border border-emerald-400/20 rounded-lg py-2 hover:bg-emerald-400/20 transition-colors">
                        <ThumbsUp size={13} /> Aprobar
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        
            )}
          </div>
        )}

        {((view === "session" && activeSession) || enPlantilla) && (() => {
          const activeSession = sesionEnPantalla;
          const activeWeek = semanaEnPantalla;
          return (
          <div className="space-y-3">
            {enPlantilla && (
              <div>
                <span className="text-[10px] uppercase tracking-wider text-sky-400/70">Nombre de la sesión</span>
                <input value={draftTemplate.name} onChange={(e) => setDraftTemplate((prev) => ({ ...prev, name: e.target.value }))}
                  placeholder="Ej: Tren superior - Empuje" autoFocus={!draftTemplate.editando}
                  className="w-full mt-1 bg-neutral-700 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-md px-3 py-2 text-sm text-white placeholder-neutral-600 transition-colors" />
              </div>
            )}
            <div className="flex items-center justify-between mb-1">
              {enPlantilla
                ? <span className="text-[11px] text-neutral-500">{activeSession.exercises.length} ejercicio{activeSession.exercises.length !== 1 ? "s" : ""}</span>
                : <EstadoBadge estado={activeSession.estado} />}
              {/* Tarjetas o lista: solo cambia cómo se ve. */}
              {(isAlumno || isCoach) && (
                <div className="inline-flex rounded-lg border border-neutral-700 bg-neutral-800 p-0.5">
                  {[["tarjetas", LayoutGrid, "Tarjetas"], ["lista", LayoutList, "Lista"]].map(([k, Icono, txt]) => (
                    <button key={k} onClick={() => cambiarVistaSesion(k)}
                      className={`flex items-center gap-1 px-2.5 py-1 rounded-md text-[11px] font-medium transition-colors ${
                        vistaSesion === k ? "bg-sky-400 text-black" : "text-neutral-400"}`}>
                      <Icono size={12} /> {txt}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {activeSession.hasTimer && (
              <IntervalTimer
                config={activeSession.timerConfig}
                editable={isCoach}
                onConfigChange={(cfg) => setSessionRating(activeWeek.id, activeSession.id, "timerConfig", cfg)}
              />
            )}

            {!enPlantilla && <SessionProgressCard weeks={weeks} sessionName={activeSession.name} />}

            {/* El dibujo de cada bloque se define una vez y se usa
                para los ejercicios normales y para los del finalizador:
                el alumno tiene que ver la misma tarjeta en los dos, con
                sus campos para cargar peso y RIR. Antes el finalizador
                era un resumen chico sin nada para completar. */}
            {(() => {
              const dibujarBloque = (bloque, bi) => {
              const esBi = bloque.tipo === "biserie";
              // El descanso del bloque es el del ÚLTIMO ejercicio: en una
              // biserie no se descansa entre medio, sino al terminar.
              const ultimo = bloque.items[bloque.items.length - 1].ex;

              const contenido = bloque.items.map(({ ex, i }) => {
              const kEj = `${activeSession.id}-${i}-ejercicio`;
              const kConQue = `${activeSession.id}-${i}-conQue`;
              const kSeries = `${activeSession.id}-${i}-series`;
              const kReps = `${activeSession.id}-${i}-reps`;
              const kRirC = `${activeSession.id}-${i}-rirConsigna`;
              const set = (field) => (v) => updateExercise(activeWeek.id, activeSession.id, i, field, v);

              // En un tabata no hay repeticiones en reserva: se mide
              // por esfuerzo percibido, aunque el ejercicio no tenga la
              // métrica cambiada.
              const exMetric = (ex.metric === "RPE" || ex.tecnica === "tabata") ? "RPE" : "RIR";
              const exOptions = metricOptions(exMetric);
              const consignaIdx = exOptions.indexOf(ex.rirConsigna);
              const tuyoIdx = exOptions.indexOf(ex.rirTuyo);
              let matchStatus = null;
              if (ex.rirTuyo && consignaIdx !== -1 && tuyoIdx !== -1) matchStatus = tuyoIdx === consignaIdx ? "match" : tuyoIdx < consignaIdx ? "harder" : "easier";
              // El peso, igual que el RIR: verde si movió el sugerido,
              // rojo si se pasó, amarillo si le sobró. Solo cuando los
              // dos son números: "6 ladrillitos" no se compara.
              const pesoStatus = estadoPeso(ex.pesoUsado, ex.pesoSugerido);

              // El número se cuenta por posición, no comparando objetos:
              // el ejercicio que llega acá es una copia del agrupador y
              // nunca era igual al original, así que el número no salía.
              // Se cuentan TODOS, con nombre o sin él. Antes se
              // contaban solo los elegidos: un ejercicio recién
              // agregado quedaba fuera de la cuenta y heredaba el
              // número del siguiente, así que el primero de la sesión
              // decía "7 de 7".
              //
              // Y se numera dentro de su sección: en la activación el
              // primero es el 1, no el 7 porque haya seis en la parte
              // principal.
              const suSeccion = seccionDe(ex);
              const deSuSeccion = activeSession.exercises
                .filter((e) => seccionDe(e) === suSeccion);
              const listaReal = deSuSeccion;
              const numero = activeSession.exercises
                .slice(0, i + 1).filter((e) => seccionDe(e) === suSeccion).length;
              const clavePliegue = esBi
                ? `${activeSession.id}-bi${bloque.grupo}`
                : `${activeSession.id}-${i}`;
              // Durante el arrastre se pliegan todas: con tarjetas de
              // 600 píxeles no se puede mover un ejercicio al final sin
              // hacer scroll, y cada cambio de alto mueve el objetivo
              // bajo el dedo.
              const cerrado = arrastrando !== null || !!plegados[clavePliegue];
              // En piramidal el total son los escalones, no el campo
              // series: ahí cada serie tiene su propio peso.
              const esMovilidad = seccionDe(ex) === "movilidad";
              // Las dos comparten que no llevan RIR, peso ni técnicas.
              const esActivacion = esMovilidad || seccionDe(ex) === "activacion";
              // La movilidad es una sola vuelta: no tiene series, se
              // hace el tiempo y listo. Sin esto pedía 99 series —el
              // valor de respaldo— y la sesión no se podía cerrar
              // nunca porque siempre faltaba una.
              const totalSeries = esMovilidad ? 1
                : ex.tecnica === "tabata" ? 1
                : esPiramidal(ex.tecnica)
                ? (Array.isArray(ex.tecnicaConfig?.escalones)
                    ? ex.tecnicaConfig.escalones.length : 99)
                : (parseNum(ex.series) || 1);
              const seriesListas = (seriesHechas[clavePliegue] || 0) >= totalSeries;

              // Llegaste acá desde una novedad: la tarjeta se remarca
              // para que se vea dónde está. Se va al tocarla.
              const resaltado = !!destacar && destacar.ejercicioId === ex.id;

              return (
                <div key={i} data-ejercicio-idx={i} id={`ej-${ex.id}`}
                  onPointerDown={resaltado ? () => setDestacar(null) : undefined}
                  className={`bg-neutral-800 border rounded-xl space-y-3 transition-all duration-300 ${
                    cerrado ? "px-3 py-2 space-y-0" : "p-4 tarjeta-abierta"} ${
                    resaltado ? "resaltar-novedad" : ""}`}
                  style={{
                    borderColor: resaltado ? "#fbbf24"
                      : arrastrando === i ? "#38bdf8"
                      : sobreIndice === i && arrastrando !== null ? "#38bdf8"
                      : cerrado ? "#40404066" : `${colorTarjeta(ex)}33`,
                    ...(arrastrando === i && { opacity: 0.4 }),
                    // Un reborde verde a la izquierda acompaña al tilde:
                    // se ve de un vistazo cuáles quedan por hacer, sin
                    // leer nada.
                    ...(seriesListas && !resaltado && { borderLeft: "3px solid #22c55e" }),
                  }}>

                  {/* Qué es la novedad, arriba de la tarjeta. */}
                  {resaltado && (
                    <div className="flex items-center gap-2 rounded-lg px-2.5 py-1.5 -mt-1"
                      style={{ background: "#fbbf241A", border: "1px solid #fbbf2455" }}>
                      <Bell size={12} style={{ color: "#fbbf24" }} className="shrink-0" />
                      <span className="text-[11px] flex-1 min-w-0" style={{ color: "#fbbf24" }}>
                        {destacar.tipo === "peso" ? `Movió ${destacar.detalle}`
                          : destacar.tipo === "emom" ? `Llegó a ${destacar.detalle}`
                          : "Te dejó un comentario acá"}
                      </span>
                      <span className="text-[9px] text-neutral-500 shrink-0">tocá para quitar</span>
                    </div>
                  )}

                  {/* Cabecera: el nombre y el número. Tocándola se
                      pliega. Con seis ejercicios en pantalla, los que
                      ya se hicieron solo tapan el que viene. */}
                  <div className="flex items-center gap-1">
                    {/* Agarradera para cambiar el orden.
                        Los eventos se cortan acá: sin stopPropagation
                        el botón de plegar que está al lado recibía el
                        clic al soltar, la tarjeta se cerraba a mitad
                        del arrastre y el movimiento se perdía. */}
                    {isCoach && (
                      <span onPointerDown={(e) => { e.stopPropagation(); inicioArrastre(e, i); }}
                        onPointerMove={(e) => { e.stopPropagation(); moviendoArrastre(e); }}
                        onPointerUp={(e) => { e.stopPropagation(); finArrastre(reordenarSesion); }}
                        onClick={(e) => e.stopPropagation()}
                        style={{ touchAction: "none" }}
                        className="cursor-grab active:cursor-grabbing text-neutral-600 hover:text-sky-400 p-2 -m-1 shrink-0">
                        <GripVertical size={15} />
                      </span>
                    )}
                  <button onClick={() => plegar(clavePliegue, !cerrado)}
                    className="flex-1 min-w-0 flex items-center gap-2 text-left">
                    <span className="flex-1 min-w-0">
                      {/* Plegado va en gris: el color del RIR dice cómo
                          entrenar ese ejercicio, y en una tarjeta cerrada
                          eso no se puede hacer. Seis nombres de colores
                          apilados compiten con el que está abierto. */}
                      {/* El nombre del ejercicio va en gris siempre: el
                          color es del RIR y significa esfuerzo, no
                          identidad. En tabata el título es del bloque,
                          no del primer ejercicio de los dos. */}
                      {/* El nombre entero con su categoría al lado. Sin
                          cortar: "Dorsales remo
                          mancuerna plancha alta" cortado en "Dorsales
                          remo mancu..." no dice cuál ejercicio es, que
                          es justo lo que hay que saber. */}
                      <span className="flex items-start gap-1.5 min-w-0 flex-wrap">
                        <span className="font-display font-semibold text-sm leading-snug"
                          style={{ color: cerrado ? "#94a3b8" : (enClaro() ? "#1e293b" : "#e2e8f0") }}>
                          {ex.tecnica === "tabata"
                            ? (ex.tecnicaConfig?.titulo || `Tabata ${numero}`)
                            : (ex.ejercicio || "Sin ejercicio")}
                        </span>
                        {ex.tecnica !== "tabata" && (
                          <EtiquetaGrupo nombre={ex.ejercicio} grupos={exerciseGroups} />
                        )}
                      </span>

                      <span className="text-[10px] text-neutral-500">
                        Ejercicio {numero} de {listaReal.length}
                        {ex.finalizador && " · finalizador"}
                      </span>
                    </span>
                    <EtiquetaTecnica tecnica={ex.tecnica} />
                    {seriesListas && (
                      <span className="w-5 h-5 rounded-full bg-emerald-500 flex items-center justify-center shrink-0">
                        <Check size={12} className="text-black" strokeWidth={3} />
                      </span>
                    )}
                    <ChevronDown size={15}
                      className={`text-neutral-500 shrink-0 transition-transform ${cerrado ? "-rotate-90" : ""}`} />
                  </button>
                  </div>

                  {/* Quitar el ejercicio de esta sesión. El botón vive
                      fuera de la cabecera plegable: adentro, tocarlo
                      plegaría la tarjeta en vez de borrarlo. */}
                  {isCoach && !cerrado && (
                    <div className="flex justify-end -mt-1">
                      <button onClick={() => setConfirmar({
                          tipo: "quitarEj", indice: i, nombre: ex.ejercicio })}
                        title="Quitar de esta sesión"
                        className="flex items-center gap-1 text-[10px] text-neutral-600 hover:text-red-400 transition-colors px-1 py-0.5">
                        <Trash2 size={11} /> Quitar
                      </button>
                    </div>
                  )}

                  {!cerrado && (<>
                  {/* El nombre ya está en la cabecera de la tarjeta:
                      repetirlo acá era decir lo mismo dos veces con el
                      video en el medio. Al alumno le queda la etiqueta
                      de categoría, que sí agrega algo. Al coach le
                      queda el buscador, porque lo tiene que poder
                      cambiar. */}
                  <BloqueMedios media={mediaDe(ex)} nombre={ex.ejercicio}
                    campoEjercicio={isCoach ? (
                      <BuscadorEjercicio value={ex.ejercicio} grupos={exerciseGroups}
                        onChange={set("ejercicio")} onEscribir />
                    ) : null}
                    modo={isCoach ? "coach" : "alumno"}
                    onCargar={() => abrirEdicionEjercicio(ex.ejercicio)}
                    videoAlumno={ex.videoAlumno}
                    subiendo={subiendoVideo[`${activeSession.id}-${i}`] ?? null}
                    onSubirVideo={(archivo) => subirVideoEjercicio(i, archivo)}
                    onQuitarVideo={() => {
                      updateExercise(activeWeek.id, activeSession.id, i, "videoAlumno", "");
                      showToast("Video quitado");
                    }}
                    onDescargarVideo={(src) => descargarVideo(src,
                      `${(ex.ejercicio || "ejercicio").replace(/\s+/g, "-").toLowerCase()}.mp4`)}
                    onCapturarCuadro={(dataUrl) => setMarcando({
                      imagen: dataUrl, indice: i,
                      destino: isCoach ? "coach" : "alumno",
                      titulo: `Marcá lo que quieras señalar en ${ex.ejercicio || "el ejercicio"}`,
                    })} />

                  {/* Cronómetros del ejercicio. Uno cuenta el trabajo
                      cuando está prescrito por tiempo; el otro el descanso
                      entre series. Pueden estar los dos, uno o ninguno. */}
                  {/* La técnica, con los kilos de cada caída ya
                      calculados: el alumno no tiene que hacer la
                      cuenta al fallo, con el pulso a doscientos. */}
                  {ex.tecnica === "dropset" && (
                    <div className="rounded-lg border p-3 space-y-2"
                      style={{ borderColor: "#f472b666", background: "#f472b60D" }}>
                      <div className="flex items-center gap-2">
                        <TrendingDown size={14} style={{ color: "#f472b6" }} className="shrink-0" />
                        <span className="text-[11px] font-semibold" style={{ color: "#f472b6" }}>
                          Drop set · {ex.tecnicaConfig?.caidas || 3} caídas
                        </span>
                      </div>
                      {parseNum(ex.pesoUsado || ex.pesoSugerido) > 0 ? (
                        <div className="flex flex-wrap items-center gap-1.5">
                          <span className="text-[11px] font-display font-bold bg-neutral-700 rounded px-2 py-1">
                            {parseNum(ex.pesoUsado || ex.pesoSugerido)} kg
                          </span>
                          {caidasDropset(ex.pesoUsado || ex.pesoSugerido, ex.tecnicaConfig?.caidas || 3).map((kg, n) => (
                            <React.Fragment key={n}>
                              <ArrowRight size={11} className="text-neutral-600" />
                              <span className="text-[11px] font-display font-bold rounded px-2 py-1"
                                style={{ background: "#f472b626", color: "#f472b6" }}>
                                {kg} kg
                              </span>
                            </React.Fragment>
                          ))}
                        </div>
                      ) : (
                        <p className="text-[10px] text-neutral-500">
                          Cargá el peso de arranque y te muestro los kilos de cada caída.
                        </p>
                      )}
                      <p className="text-[10px] text-neutral-600 leading-relaxed">
                        Al fallo bajás al peso siguiente y seguís sin descanso.
                      </p>
                    </div>
                  )}

                  {ex.tecnica === "restpause" && (
                    <div className="rounded-lg border p-3 space-y-2"
                      style={{ borderColor: "#22d3ee66", background: "#22d3ee0D" }}>
                      <div className="flex items-center gap-2">
                        <Pause size={13} style={{ color: "#22d3ee" }} className="shrink-0" />
                        <span className="text-[11px] font-semibold" style={{ color: "#22d3ee" }}>
                          Rest-pause · {ex.tecnicaConfig?.tandas || 3} tandas
                        </span>
                      </div>
                      <p className="text-[10px] text-neutral-500 leading-relaxed">
                        Al fallo, {ex.tecnicaConfig?.pausa || 15} segundos de pausa y seguís
                        con el mismo peso. Repetís {(ex.tecnicaConfig?.tandas || 3) - 1} veces más.
                      </p>
                      <IntervalTimer compacto silencioso={isAlumno && ex.modo === "tabata" && modoRitmo === "musica"}
                        config={{ work: 0, rest: ex.tecnicaConfig?.pausa || 15, rounds: 1 }} />
                    </div>
                  )}

                  {esPiramidal(ex.tecnica) && (() => {
                    const escalones = Array.isArray(ex.tecnicaConfig?.escalones)
                      ? ex.tecnicaConfig.escalones : [];
                    if (!escalones.length) return null;
                    const asc = ex.tecnica === "piramidal_asc";
                    const color = asc ? "#fb923c" : "#38bdf8";

                    // Lo que el alumno cargó. Se arma del largo de los
                    // escalones para que las dos listas siempre coincidan,
                    // aunque el coach agregue una serie después.
                    const hechas = escalones.map((_, k) =>
                      (ex.resultadoSeries || [])[k] || { peso: "", reps: "", hecha: false });
                    const previa = Array.isArray(ex.resultadoPrevio)
                      ? ex.resultadoPrevio : [];

                    const cambiarSerie = (k, campo, v) => {
                      const next = hechas.map((h, j) => (j === k ? { ...h, [campo]: v } : h));
                      set("resultadoSeries")(next);
                      const cuantas = next.filter((h) => h.hecha).length;
                      marcarSeries(clavePliegue, cuantas, escalones.length);
                    };

                    // La serie que toca: la primera sin marcar.
                    const actual = hechas.findIndex((h) => !h.hecha);
                    const idx = actual === -1 ? escalones.length - 1 : actual;
                    const terminado = actual === -1;

                    // ─────────────────────────────────────────────
                    // EL ALUMNO: una serie por vez.
                    //
                    // Entre series, con el pulso alto, un número enorme
                    // se lee mejor que una tabla. Las barritas de arriba
                    // dicen cuánto falta sin ocupar lugar.
                    // ─────────────────────────────────────────────
                    if (isAlumno) {
                      const e = escalones[idx] || {};
                      const h = hechas[idx] || {};
                      const sig = escalones[idx + 1];
                      return (
                        <div className="space-y-2">
                          <div className="flex gap-1.5">
                            {escalones.map((_, k) => (
                              <div key={k} className="flex-1 h-1 rounded-full"
                                style={{ background: hechas[k]?.hecha ? ESTADO.bien
                                  : k === idx ? color : "#404040" }} />
                            ))}
                          </div>

                          {terminado ? (
                            <div className="rounded-lg p-3 text-center"
                              style={{ background: `${ESTADO.bien}14`,
                                       border: `1px solid ${ESTADO.bien}55` }}>
                              <Check size={20} className="mx-auto mb-1"
                                style={{ color: ESTADO.bien }} strokeWidth={3} />
                              <p className="text-xs font-medium" style={{ color: ESTADO.bien }}>
                                Piramidal completo
                              </p>
                              <p className="text-[10px] text-neutral-500 mt-0.5">
                                {escalones.length} series
                              </p>
                            </div>
                          ) : (
                            <>
                              <div className="rounded-xl p-3.5 text-center"
                                style={{ background: "#303030", border: `1px solid ${color}55` }}>
                                <p className="text-[9px] uppercase tracking-[0.06em] mb-2 flex items-center justify-center gap-1.5"
                                  style={{ color }}>
                                  Serie {idx + 1} de {escalones.length}
                                  <InfoBoton tema="piramidal" />
                                </p>

                                <div className="flex items-baseline justify-center gap-2.5 mb-3">
                                  <span className="font-display font-bold text-4xl leading-none">
                                    {e.peso}
                                  </span>
                                  <span className="text-xs text-neutral-500">kg</span>
                                  <span className="text-xl text-neutral-600">×</span>
                                  <span className="font-display font-bold text-4xl leading-none">
                                    {e.reps}
                                  </span>
                                </div>

                                {ex.mostrarLibras && aLibras(e.peso) && (
                                  <p className="text-[10px] text-neutral-500 -mt-2 mb-2.5">
                                    {aLibras(e.peso)} lb
                                  </p>
                                )}

                                <button onClick={() => {
                                    // Se guarda lo prescrito como lo que
                                    // hizo. Si movió otro peso, lo corrige
                                    // abajo: es el caso menos frecuente.
                                    const next = hechas.map((x, k) => k === idx
                                      ? { peso: h.peso || e.peso, reps: h.reps || e.reps, hecha: true }
                                      : x);
                                    set("resultadoSeries")(next);
                                    marcarSeries(clavePliegue,
                                      next.filter((x) => x.hecha).length, escalones.length);
                                  }}
                                  className="w-full rounded-lg py-2.5 flex items-center justify-center gap-2 transition-transform active:scale-95"
                                  style={{ background: color, color: "#000" }}>
                                  <Check size={15} strokeWidth={3} />
                                  <span className="text-[13px] font-semibold">Hice esta serie</span>
                                </button>

                                {/* Por si no llegó al peso planificado.
                                    Antes eran dos campos sin título con
                                    el peso planificado como texto de
                                    ayuda: parecían ya completos y no se
                                    notaba que se podían cambiar. */}
                                <p className="text-[10px] text-neutral-500 mt-3 mb-1.5 flex items-center justify-center gap-1">
                                  <Pencil size={10} className="shrink-0" />
                                  ¿Moviste otro peso? Cargá lo que hiciste y tocá el botón
                                </p>
                                {/* min-w-0 en los dos: sin eso un campo
                                    numérico no achica por debajo de su
                                    ancho natural y desborda la tarjeta
                                    en pantallas angostas. */}
                                <div className="flex gap-2 w-full">
                                  <label className="flex-1 min-w-0">
                                    <span className="block text-[9px] text-neutral-600 text-center mb-0.5">kg</span>
                                    <input type="number" inputMode="decimal"
                                      value={h.peso} placeholder={String(e.peso)}
                                      onChange={(ev) => cambiarSerie(idx, "peso", ev.target.value)}
                                      className="w-full min-w-0 bg-neutral-900 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-md px-2 py-1.5 text-sm text-center" />
                                  </label>
                                  <label className="flex-1 min-w-0">
                                    <span className="block text-[9px] text-neutral-600 text-center mb-0.5">repeticiones</span>
                                    <input type="number" inputMode="numeric"
                                      value={h.reps} placeholder={String(e.reps)}
                                      onChange={(ev) => cambiarSerie(idx, "reps", ev.target.value)}
                                      className="w-full min-w-0 bg-neutral-900 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-md px-2 py-1.5 text-sm text-center" />
                                  </label>
                                </div>
                              </div>

                              {sig && (
                                <p className="text-[9px] text-neutral-600 text-center">
                                  después: {sig.peso} kg × {sig.reps}
                                </p>
                              )}
                            </>
                          )}
                        </div>
                      );
                    }

                    // ─────────────────────────────────────────────
                    // EL COACH: tres columnas para comparar.
                    //
                    // Lo que pediste, lo que hizo y lo de la semana
                    // previa, alineados. En ámbar donde movió distinto,
                    // que es lo primero que se busca.
                    // ─────────────────────────────────────────────
                    const clavePir = `${activeSession.id}-pir-${i}`;
                    const abierta = plegados[clavePir] !== true;

                    return (
                      <div className={`rounded-lg border ${abierta ? "" : "px-3 py-2"}`}
                        style={{ borderColor: `${color}44`, background: "#303030" }}>
                        <button onClick={() => plegar(clavePir, abierta)}
                          className={`w-full flex items-center gap-2 text-left ${abierta ? "px-3 pt-2.5 pb-2" : ""}`}>
                          {asc ? <TrendingUp size={13} style={{ color }} className="shrink-0" />
                               : <TrendingDown size={13} style={{ color }} className="shrink-0" />}
                          <span className="text-[11px] font-semibold flex-1" style={{ color }}>
                            Piramidal {asc ? "ascendente" : "descendente"} · {escalones.length} series
                          </span>
                          <ChevronDown size={13}
                            className={`shrink-0 transition-transform ${abierta ? "" : "-rotate-90"}`}
                            style={{ color }} />
                        </button>

                        {abierta && (
                          <div className="rounded-b-lg overflow-hidden">
                            <div className="grid gap-1.5 px-3 py-1.5"
                              style={{ gridTemplateColumns: "20px 1fr 1fr 1fr",
                                       background: "#ffffff08" }}>
                              <span className="text-[8px] text-neutral-600">#</span>
                              <span className="text-[8px] uppercase tracking-wider text-neutral-500">Pediste</span>
                              <span className="text-[8px] uppercase tracking-wider"
                                style={{ color: ESTADO.bien }}>Hizo</span>
                              <span className="text-[8px] uppercase tracking-wider text-neutral-600">Previa</span>
                            </div>

                            {escalones.map((e, k) => {
                              const h = hechas[k];
                              const ant = previa[k];
                              const distinto = h.peso && parseNum(h.peso) !== parseNum(e.peso);
                              return (
                                <div key={k}
                                  className="grid gap-1.5 px-3 py-2 items-center"
                                  style={{ gridTemplateColumns: "20px 1fr 1fr 1fr",
                                           borderTop: "1px solid #ffffff08",
                                           background: distinto ? `${ESTADO.aviso}10` : "transparent" }}>
                                  <span className="text-[10px] text-neutral-600">{k + 1}</span>
                                  <span className="text-xs text-neutral-200">
                                    {e.peso}×{e.reps}
                                  </span>
                                  <span className="text-xs"
                                    style={{ color: !h.peso ? "#737373"
                                      : distinto ? ESTADO.aviso : ESTADO.bien }}>
                                    {h.peso ? `${h.peso}×${h.reps || "?"}` : "—"}
                                  </span>
                                  <span className="text-[11px] text-neutral-600">
                                    {ant?.peso ? `${ant.peso}×${ant.reps || "?"}` : "—"}
                                  </span>
                                </div>
                              );
                            })}

                            {hechas.some((h) => h.peso && parseNum(h.peso) !== parseNum(escalones[hechas.indexOf(h)]?.peso)) && (
                              <p className="text-[9px] text-neutral-600 px-3 py-2"
                                style={{ borderTop: "1px solid #ffffff08" }}>
                                En ámbar, lo que movió distinto a lo pedido
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })()}

                  {ex.tecnica === "tabata" && (() => {
                    const cfg = ex.tecnicaConfig || {};
                    const trabajo = Number(cfg.trabajo) || 20;
                    const pausa = Number(cfg.pausa) || 10;
                    const rondas = Number(cfg.rondas) || 8;
                    const lista = cfg.musica || musicaDefault;
                    const conMusica = isAlumno && modoRitmo === "musica";

                    // Solo lo que hace falta: los dos ejercicios con su
                    // material, los tiempos, el reloj y la lista. El
                    // nombre del bloque y el RPE ya están en la tarjeta.
                    return (
                      <div className="rounded-lg border p-3 space-y-3"
                        style={{ borderColor: "#f8717155", background: "#f871710D" }}>

                        <div className="flex items-stretch gap-2">
                          {[[ex.ejercicio, cfg.conQueA], [cfg.ejercicioB, cfg.conQueB]]
                            .filter(([n]) => n).map(([nom, conQue], k) => (
                            <React.Fragment key={k}>
                              {k === 1 && <span className="text-neutral-600 self-center shrink-0 text-xs">↔</span>}
                              <span className="rounded-lg px-2.5 py-2 flex-1 min-w-0"
                                style={{ background: "#f8717115", border: "1px solid #f8717133" }}>
                                <span className="block truncate text-xs text-neutral-200">{nom}</span>
                                <span className="block truncate text-[10px] text-neutral-500">
                                  {conQue || "sin material"}
                                </span>
                              </span>
                            </React.Fragment>
                          ))}
                        </div>

                        <div className="flex items-center justify-center gap-4 text-center">
                          {[[trabajo, "trabajo"], [pausa, "pausa"], [rondas, "bloques"]].map(([v, l]) => (
                            <span key={l}>
                              <span className="font-display font-bold text-base block leading-none"
                                style={{ color: "#f87171" }}>
                                {v}{l !== "bloques" && <span className="text-[10px] font-normal">s</span>}
                              </span>
                              <span className="text-[9px] uppercase tracking-wider text-neutral-500">{l}</span>
                            </span>
                          ))}
                        </div>

                        {isAlumno && (
                          <IntervalTimer
                            silencioso={conMusica}
                            alterna={[ex.ejercicio, cfg.ejercicioB].filter(Boolean).length === 2
                              ? [ex.ejercicio, cfg.ejercicioB] : null}
                            config={{ work: trabajo, rest: pausa, rounds: rondas }} />
                        )}

                        {lista && (
                          <>
                            <BloqueMusica url={lista} editable={false} onCambiar={() => {}} />
                            {isAlumno && (
                              <div className="flex gap-1.5">
                                {Object.entries(MUSICA_MODOS).map(([k, txt]) => (
                                  <button key={k} onClick={() => cambiarModoRitmo(k)}
                                    className={`flex-1 rounded-lg py-1.5 text-[11px] font-medium border transition-colors ${
                                      modoRitmo === k
                                        ? "bg-sky-400 text-black border-sky-400"
                                        : "text-neutral-400 border-neutral-600 hover:border-sky-400/40"}`}>
                                    {txt}
                                  </button>
                                ))}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    );
                  })()}

{ex.tecnica === "emom" && (() => {
                    const cfg = ex.tecnicaConfig || {};
                    const seg = Number(cfg.segundos) || 60;
                    return (
                      <div className="rounded-lg border p-3 space-y-2"
                        style={{ borderColor: "#a78bfa66", background: "#a78bfa0D" }}>
                        <div className="flex items-center gap-2">
                          <Clock size={13} style={{ color: "#a78bfa" }} className="shrink-0" />
                          <span className="text-[11px] font-semibold" style={{ color: "#a78bfa" }}>
                            EMOM · bloques de {seg} segundos
                          </span>
                        </div>

                        {/* La escalera de repeticiones: se ve dónde
                            arranca y cuánto sube sin tener que contar. */}
                        <div className="flex flex-wrap gap-1">
                          {bloquesEmom(cfg, 6).map((b) => (
                            <span key={b.bloque}
                              className="text-[11px] font-semibold rounded px-2 py-1"
                              style={{ background: "#a78bfa1F", color: "#a78bfa" }}>
                              {b.reps}
                            </span>
                          ))}
                          <span className="text-[11px] text-neutral-500 self-center px-1">
                            → hasta el fallo
                          </span>
                        </div>

                        <p className="text-[11px] text-neutral-400 leading-relaxed">
                          Cada {seg} segundos arrancás un bloque nuevo con
                          {Number(cfg.incremento) > 1
                            ? ` ${cfg.incremento} repeticiones más`
                            : " una repetición más"}. Lo que sobra del bloque es
                          tu descanso. Se corta cuando ya no llegás a completarlo.
                        </p>

                        {isAlumno && (
                          // rounds alto y la marca emom: el cronómetro
                          // se reinicia solo al llegar a cero y va
                          // contando bloques. Antes era rounds: 1, así
                          // que paraba después del primero y había que
                          // volver a arrancarlo perdiendo tiempo.
                          <IntervalTimer compacto
                            silencioso={isAlumno && ex.modo === "tabata" && modoRitmo === "musica"}
                            config={{ work: seg, rest: 0, rounds: 999 }}
                            emom={{
                              repsInicio: Number(cfg.repsInicio) || 1,
                              incremento: Number(cfg.incremento) || 1,
                              onFallo: async (bloques, reps) => {
                                // Como DATO, no como comentario: así se
                                // puede comparar contra las semanas
                                // anteriores y ver la tendencia.
                                set("emomBloques")(bloques);
                                set("emomReps")(reps);
                                if (hayBackend && ex.id) {
                                  await persistir(() => guardarEmom(ex.id, bloques, reps),
                                                  "No se pudo guardar el resultado.");
                                }
                                showToast(`✓ ${bloques} bloques · ${reps} reps`);
                              },
                            }} />
                        )}

                        {/* Dónde llegó, como dato propio. El alumno lo
                            confirma o lo corrige; vos lo ves sin tener
                            que leer un comentario. */}
                        {isAlumno && ex.emomBloques != null && (
                          <div className="rounded-lg p-3 text-center"
                            style={{ background: "#303030", border: "1px solid #a78bfa55" }}>
                            <p className="text-[9px] uppercase tracking-[0.06em] mb-2"
                              style={{ color: "#a78bfa" }}>Llegaste hasta</p>
                            <div className="flex items-baseline justify-center gap-3.5 mb-2.5">
                              <span>
                                <span className="font-display font-bold text-3xl leading-none">
                                  {ex.emomBloques}
                                </span>
                                <span className="block text-[10px] text-neutral-500 mt-0.5">
                                  bloques
                                </span>
                              </span>
                              <span className="text-lg text-neutral-600">·</span>
                              <span>
                                <span className="font-display font-bold text-3xl leading-none">
                                  {ex.emomReps}
                                </span>
                                <span className="block text-[10px] text-neutral-500 mt-0.5">
                                  repeticiones
                                </span>
                              </span>
                            </div>
                            <div className="flex gap-2">
                              <input type="number" inputMode="numeric"
                                value={ex.emomBloques ?? ""} placeholder="bloques"
                                onChange={(e) => {
                                  // Vacío se guarda vacío. Antes cualquier
                                  // valor que no fuera número se volvía 0,
                                  // así que al borrar el campo se
                                  // rellenaba solo y no se podía corregir.
                                  const txt = e.target.value;
                                  if (txt === "") {
                                    set("emomBloques")(null); set("emomReps")(null);
                                    if (hayBackend && ex.id) {
                                      persistir(() => guardarEmom(ex.id, null, null),
                                                "No se pudo borrar el resultado.");
                                    }
                                    return;
                                  }
                                  const b = Math.max(0, Number(txt) || 0);
                                  const ini = Number(ex.tecnicaConfig?.repsInicio) || 1;
                                  const inc = Number(ex.tecnicaConfig?.incremento) || 1;
                                  const reps = Array.from({ length: b },
                                    (_, k) => ini + inc * k).reduce((a, c) => a + c, 0);
                                  set("emomBloques")(b); set("emomReps")(reps);
                                  if (hayBackend && ex.id) {
                                    persistir(() => guardarEmom(ex.id, b, reps),
                                              "No se pudo guardar el resultado.");
                                  }
                                }}
                                className="flex-1 min-w-0 bg-neutral-900 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-md px-2 py-1.5 text-sm text-center" />
                              <span className="text-[10px] text-neutral-600 self-center">
                                corregir si no fue así
                              </span>
                            </div>
                          </div>
                        )}

                        {/* La tendencia: lo de hoy y las veces
                            anteriores. */}
                        {(ex.emomBloques != null || ex.emomPrevio) && (
                          <ProgresionEmom
                            actual={ex.emomBloques}
                            historial={ex.emomPrevio
                              ? [{ bloques: Number(String(ex.emomPrevio).split("|")[0]) || 0,
                                   reps: Number(String(ex.emomPrevio).split("|")[1]) || 0 }]
                              : []} />
                        )}
                      </div>
                    );
                  })()}

                  {/* La lista de música va SOLO en el tabata: ahí la
                      lista marca los tiempos y reemplaza al cronómetro.
                      En el resto de los ejercicios no aporta nada. */}
                  {ex.modo === "tabata" && !enPlantilla && (activeSession.musicaUrl || musicaDefault || isCoach) && (
                    <div className="space-y-2">
                      <BloqueMusica
                        url={activeSession.musicaUrl || musicaDefault}
                        editable={isCoach}
                        onCambiar={async (url) => {
                          setWeeks((prev) => prev.map((w) => w.id !== activeWeek.id ? w : {
                            ...w, sessions: w.sessions.map((se) => se.id !== activeSession.id ? se
                              : { ...se, musicaUrl: url }) }));
                          if (hayBackend) {
                            await persistir(() => guardarMusicaSesion(activeSession.id, url),
                                            "No se pudo guardar la lista.");
                          }
                        }} />

                      {isAlumno && (
                        <>
                          <div className="flex gap-1.5">
                            {Object.entries(MUSICA_MODOS).map(([k, txt]) => (
                              <button key={k} onClick={() => cambiarModoRitmo(k)}
                                className={`flex-1 rounded-lg py-2 text-[11px] font-medium border transition-colors ${
                                  modoRitmo === k
                                    ? "bg-sky-400 text-black border-sky-400"
                                    : "text-neutral-400 border-neutral-600 hover:border-sky-400/40"}`}>
                                {txt}
                              </button>
                            ))}
                          </div>
                          {modoRitmo === "musica" && (
                            <p className="text-[10px] text-neutral-600 leading-relaxed px-1">
                              El cronómetro queda en silencio para que no compita
                              con la lista. Seguís los tiempos por la música.
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  )}

                  {/* En una serie combinada el cronómetro es del bloque
                      y alterna los dos: uno por ejercicio serían dos
                      relojes desincronizados. */}
                  {/* El bloque de tiempo genérico no va cuando la
                      técnica es tabata: ahí los tiempos ya están en su
                      propia tarjeta. */}
                  {["tiempo", "tabata"].includes(ex.modo) && parseNum(ex.reps) > 0
                    && ex.tecnica !== "tabata"
                    && !(ex.biserie && ex.modo === "tabata") && (
                    <div className="space-y-1.5">
                      <p className="text-[10px] uppercase tracking-wider text-neutral-500 text-center">
                        {ex.modo === "tabata" ? "Tabata" : "Trabajo"} · {parseNum(ex.series) || 1} {parseNum(ex.series) === 1 ? "ronda" : "rondas"} de {parseNum(ex.reps)}s
                        {parseNum(ex.descanso) > 0 && ` / ${parseNum(ex.descanso)}s`}
                      </p>
                      <IntervalTimer compacto silencioso={isAlumno && ex.modo === "tabata" && modoRitmo === "musica"}
                        config={{ work: parseNum(ex.reps), rest: parseNum(ex.descanso) || 0,
                                  rounds: parseNum(ex.series) || 1 }} />
                    </div>
                  )}

                  {/* La MISMA grilla para los dos roles. Antes eran
                      dos bloques separados que se fueron desfasando:
                      al planificar mirando lo que ve el alumno, cada
                      campo estaba en otro lugar.

                      El coach edita, el alumno lee. Eso es lo único
                      que cambia; la disposición es idéntica. */}
                  <div className="grid grid-cols-2 gap-2">
                    {/* Con qué · Técnica */}
                    {ex.tecnica !== "tabata" && !(isAlumno && estaOculto(ex, "conQue")) && (
                      isCoach
                        ? <ConOjo ex={ex} campo="conQue" esCoach={isCoach} onCambiar={set("ocultos")}>
                            <FieldSelect label="Con qué" value={ex.conQue} options={CON_QUE_OPTIONS}
                              onChange={set("conQue")} customActive={customFields[kConQue]}
                              onToggleCustom={() => toggleCustom(kConQue)}
                              labelColor={GRIS_ETIQUETA} colorful />
                          </ConOjo>
                        : <LockedField label="Con qué" value={ex.conQue} tono={colorTarjeta(ex)} />
                    )}

                    {/* El alumno la ve como dato. El coach la edita con
                        el selector completo, más abajo: un desplegable
                        cambia la técnica pero no deja configurarla, y en
                        piramidal la configuración ES el ejercicio. */}
                    {/* Dentro de la grilla, al lado de "Con qué": es un
                        campo más y tiene que medir lo mismo. La versión
                        del coach se abre para elegir; la del alumno es
                        solo lectura. */}
                    {!esActivacion && ex.tecnica !== "tabata" && (
                      isCoach
                        ? <ConOjo ex={ex} campo="tecnica" esCoach={isCoach} onCambiar={set("ocultos")}>
                            <SelectorTecnica tecnica={ex.tecnica} config={ex.tecnicaConfig}
                              onChange={(t, cfg) => { set("tecnica")(t); set("tecnicaConfig")(cfg); }}
                              onReps={(v) => { if (v) set("reps")(v); }}
                              pesoBase={ex.pesoSugerido}
                              gruposEjercicios={exerciseGroups} />
                          </ConOjo>
                        : <LockedField label="Técnica"
                            value={TECNICAS[ex.tecnica]?.nombre || "Normal"}
                            tono={colorTarjeta(ex)} />
                    )}



                    {/* Series · Reps */}
                    {esMovilidad ? (
                      isCoach ? null : (
                        <LockedField label="Tiempo"
                          value={ex.reps ? `${parseNum(ex.reps)}s` : ""}
                          tono={colorTarjeta(ex)} />
                      )
                    ) : ex.tecnica !== "dropset" && !esPiramidal(ex.tecnica)
                        && ex.tecnica !== "tabata" && (
                      <>
                        {!(isAlumno && estaOculto(ex, "series")) && (
                          isCoach
                            ? <ConOjo ex={ex} campo="series" esCoach={isCoach} onCambiar={set("ocultos")}>
                                <FieldSelect label="Series" value={ex.series} options={SERIES_OPTIONS}
                                  onChange={set("series")} customActive={customFields[kSeries]}
                                  onToggleCustom={() => toggleCustom(kSeries)}
                                  labelColor={GRIS_ETIQUETA} colorful
                                  previa={ex.seriesPrevia} />
                              </ConOjo>
                            : <LockedField label="Series" value={ex.series} tono={colorTarjeta(ex)} />
                        )}
                        {!(isAlumno && estaOculto(ex, "reps")) && (
                          isCoach
                            ? <ConOjo ex={ex} campo="reps" esCoach={isCoach} onCambiar={set("ocultos")}>
                              <div className="relative">
                                <FieldSelect
                                  label={ex.modo === "tiempo" ? "Segundos" : "Reps"}
                                  value={ex.reps}
                                  options={ex.modo === "tiempo"
                                    ? ["10", "15", "20", "30", "45", "60", "90", "120"]
                                    : REPS_OPTIONS}
                                  onChange={set("reps")} customActive={customFields[kReps]}
                                  onToggleCustom={() => toggleCustom(kReps)}
                                  labelColor={GRIS_ETIQUETA} colorful
                                  previa={ex.repsPrevia} />
                                {/* Reps o tiempo. Una plancha o un
                                    isométrico se prescriben en segundos,
                                    y estaba solo en la activación. */}
                                <button
                                  onClick={() => set("modo")(ex.modo === "tiempo" ? "reps" : "tiempo")}
                                  title="Cambiar entre repeticiones y tiempo"
                                  // A la izquierda del ojo, que vive
                                  // arriba a la derecha: pegados se
                                  // tocaba uno queriendo el otro.
                                  className="absolute right-6 top-1.5 text-[8px] px-1.5 py-0.5 rounded transition-colors"
                                  style={{ color: "#38bdf8", background: "#38bdf814" }}>
                                  {ex.modo === "tiempo" ? "seg" : "rep"}
                                </button>

                                {/* Por lado. En un unilateral "10" es
                                    ambiguo: pueden ser 10 en total o 10
                                    por pierna, que es el doble. */}
                                {ex.modo !== "tiempo" && (
                                  <button
                                    onClick={() => set("repsPorLado")(!ex.repsPorLado)}
                                    title={ex.repsPorLado
                                      ? "Son por cada lado · tocá para volver a total"
                                      : "Son en total · tocá si van por cada lado"}
                                    className="absolute right-12 top-1.5 text-[8px] px-1.5 py-0.5 rounded transition-colors"
                                    style={ex.repsPorLado
                                      ? { color: "#000", background: "#fbbf24" }
                                      : { color: "#8a8a8a", background: "#ffffff0d" }}>
                                    /lado
                                  </button>
                                )}
                              </div>
                              </ConOjo>
                            : <LockedField
                                label={ex.modo === "tiempo" ? "Tiempo"
                                  : ex.repsPorLado ? "Reps por lado" : "Reps"}
                                value={ex.modo === "tiempo" && ex.reps ? `${ex.reps}s`
                                  : ex.repsPorLado && ex.reps ? `${ex.reps} × lado`
                                  : ex.reps}
                                tono={colorTarjeta(ex)} />
                        )}
                      </>
                    )}
                  </div>



                  {/* La configuración de la técnica —escalones, caídas,
                      rondas— debajo de la grilla y a lo ancho. */}
                  {isCoach && !esActivacion && ex.tecnica !== "normal" && (
                    <SelectorTecnica soloPanel nombreA={ex.ejercicio}
                      tecnica={ex.tecnica} config={ex.tecnicaConfig}
                      onChange={(t, cfg) => { set("tecnica")(t); set("tecnicaConfig")(cfg); }}
                      onReps={(v) => { if (v) set("reps")(v); }}
                      pesoBase={ex.pesoSugerido}
                      gruposEjercicios={exerciseGroups} />
                  )}

                  {/* Bi y triseries: una línea suelta debajo de la
                      grilla, no una celda. Un check solo dentro de un
                      recuadro del tamaño de "Series" queda flotando. */}
                  {isCoach && !esActivacion && !esMovilidad
                    && ex.tecnica !== "tabata" && (
                    <div className="px-1">
                      <SelectorBiserie valor={ex.biserie} onChange={set("biserie")}
                        gruposUsados={activeSession.exercises.map((e) => e.biserie).filter(Boolean)}
                        cuantosEnGrupo={ex.biserie
                          ? activeSession.exercises.filter((e) => e.biserie === ex.biserie).length
                          : 0} />
                    </div>
                  )}

                  {/* Peso y RIR. A la izquierda lo prescrito, a la
                      derecha lo que carga el alumno: el ojo baja por
                      una columna y compara con la otra.

                      En piramidal el peso va serie por serie, así que
                      acá solo queda el RIR.

                      El RIR es solo de la principal y el finalizador:
                      la movilidad y la activación son preparación, no
                      se van al fallo. */}
                  {ex.tecnica !== "tabata"
                    && (seccionDe(ex) === "principal" || seccionDe(ex) === "finalizador") && (
                    <div className="space-y-2 pt-1 border-t border-neutral-700">

                      {!esPiramidal(ex.tecnica) && !esActivacion && (
                        <div className="grid grid-cols-2 gap-2">
                          {/* Peso sugerido */}
                          {!(isAlumno && estaOculto(ex, "pesoSugerido")) && (
                            isCoach
                              ? <div>
                                  <ConOjo ex={ex} campo="pesoSugerido" esCoach={isCoach}
                                    onCambiar={set("ocultos")}>
                                    <FieldSelect label="Peso sugerido (kg)" value={ex.pesoSugerido}
                                      options={PESO_OPTIONS} onChange={set("pesoSugerido")}
                                      etiqueta={(kg) => conUnidad(kg, ex.mostrarLibras)}
                                      customActive={customFields[`${activeSession.id}-${i}-pesoSug`]}
                                      onToggleCustom={() => toggleCustom(`${activeSession.id}-${i}-pesoSug`)}
                                      labelColor={GRIS_ETIQUETA} colorful
                                      previa={ex.pesoSugPrevio ? `${ex.pesoSugPrevio} kg` : ""} />
                                  </ConOjo>

                                  {/* Para los que entrenan afuera. Estaba
                                      solo en la librería: al corregir la
                                      sesión de un alumno no había forma
                                      de activarlo. El peso se sigue
                                      guardando en kilos; las libras son
                                      una forma de mostrarlo. */}
                                  <label className="flex items-center gap-2 cursor-pointer select-none mt-1.5 px-1">
                                    <input type="checkbox" checked={!!ex.mostrarLibras}
                                      onChange={(e) => set("mostrarLibras")(e.target.checked)}
                                      className="w-3.5 h-3.5 rounded accent-sky-400 shrink-0" />
                                    <span className="text-[10px] text-neutral-500">
                                      También en libras
                                      {ex.pesoSugerido && ex.mostrarLibras && aLibras(ex.pesoSugerido) && (
                                        <span className="text-neutral-400"> · {aLibras(ex.pesoSugerido)} lb</span>
                                      )}
                                    </span>
                                  </label>
                                </div>
                              : <LockedField label="Peso sugerido (kg)" value={ex.pesoSugerido}
                                  etiqueta={(kg) => conUnidad(kg, ex.mostrarLibras)}
                                  tono={colorTarjeta(ex)} />
                          )}

                          {/* Peso usado */}
                          {isAlumno ? (
                            <FieldSelect label="Peso usado (kg)" value={ex.pesoUsado}
                              options={PESO_OPTIONS} etiqueta={(kg) => conUnidad(kg, ex.mostrarLibras)}
                              onChange={set("pesoUsado")} accent="cyan"
                              matchStatus={pesoStatus}
                              labelColor={FIELD_ACCENTS.peso} colorful
                              atajo={!estaOculto(ex, "pesoSugerido") && ex.pesoSugerido
                                     && ex.pesoSugerido !== "-" && ex.pesoUsado !== ex.pesoSugerido
                                ? { texto: `Usé el sugerido · ${ex.pesoSugerido} kg`,
                                    onTocar: () => set("pesoUsado")(ex.pesoSugerido) }
                                : null}
                              customActive={customFields[`${activeSession.id}-${i}-pesoUsado`]}
                              onToggleCustom={() => toggleCustom(`${activeSession.id}-${i}-pesoUsado`)} />
                          ) : (
                            // El coach ve la referencia; el alumno no.
                            // Es información para planificar, y saber
                            // qué movió antes le condiciona lo de hoy.
                            <div className="rounded-[9px] transition-shadow"
                              style={resaltado && destacar.tipo === "peso"
                                ? { boxShadow: "0 0 0 2px #fbbf24" } : undefined}>
                            <ConOjo ex={ex} campo="pesoUsado" esCoach={isCoach} onCambiar={set("ocultos")}>
                            <LockedField label="Peso usado (kg)" value={ex.pesoUsado}
                              tono={colorTarjeta(ex)}
                              etiqueta={(kg) => conUnidad(kg, ex.mostrarLibras)}
                              previa={ex.pesoPrevia ? `${ex.pesoPrevia} kg`
                                : (cargaPreviaDe(cargasPrevias, ex.ejercicio)?.peso
                                    ? `${cargaPreviaDe(cargasPrevias, ex.ejercicio).peso} kg` : "")}
                              previaDelAlumno />
                            </ConOjo>
                            </div>
                          )}
                        </div>
                      )}

                      <div className="grid grid-cols-2 gap-2">
                        {/* RIR consigna */}
                        {!(isAlumno && estaOculto(ex, "rirConsigna")) && (
                          isCoach
                            ? <ConOjo ex={ex} campo="rirConsigna" esCoach={isCoach}
                                onCambiar={set("ocultos")}>
                                <FieldSelect label={`${exMetric} consigna`} value={ex.rirConsigna}
                                  options={exOptions} onChange={set("rirConsigna")}
                                  customActive={customFields[kRirC]}
                                  onToggleCustom={() => toggleCustom(kRirC)}
                                  dotColor={effortColor(ex.rirConsigna, exMetric)}
                                  labelColor={GRIS_ETIQUETA}
                                  previa={ex.rirConsPrevio} />
                              </ConOjo>
                            : <LockedField label={`${exMetric} consigna`} value={ex.rirConsigna}
                                esfuerzo={effortColor(ex.rirConsigna, exMetric)}
                                tono={colorTarjeta(ex)} />
                        )}

                        {/* RIR tuyo */}
                        {isAlumno ? (
                          <FieldSelect label={`${exMetric} tuyo`} value={ex.rirTuyo}
                            options={exOptions} onChange={set("rirTuyo")} accent="cyan"
                            matchStatus={matchStatus}
                            dotColor={effortColor(ex.rirTuyo, exMetric)}
                            labelColor={FIELD_ACCENTS.rirTuyo}
                            atajo={!estaOculto(ex, "rirConsigna") && ex.rirConsigna
                                   && ex.rirTuyo !== ex.rirConsigna
                              ? { texto: `Fue el de la consigna · ${ex.rirConsigna}`,
                                  onTocar: () => set("rirTuyo")(ex.rirConsigna) }
                              : null} />
                        ) : (
                          <ConOjo ex={ex} campo="rirTuyo" esCoach={isCoach} onCambiar={set("ocultos")}>
                            <LockedField label={`${exMetric} tuyo`} value={ex.rirTuyo}
                              esfuerzo={effortColor(ex.rirTuyo, exMetric)}
                              tono={colorTarjeta(ex)}
                              previa={ex.rirPrevia || cargaPreviaDe(cargasPrevias, ex.ejercicio)?.rir || ""}
                              previaDelAlumno />
                          </ConOjo>
                        )}
                      </div>
                    </div>
                  )}

                  {/* El descanso, a lo ancho: se arranca al terminar la
                      serie, cuando ya se anotó lo que se movió. */}
                  {!ex.biserie && !["tiempo", "tabata"].includes(ex.modo) && parseNum(ex.descanso) > 0 && (
                    <CronoPlegable segundos={parseNum(ex.descanso)}>
                      <IntervalTimer compacto silencioso={isAlumno && ex.modo === "tabata" && modoRitmo === "musica"}
                        config={{ work: 0, rest: parseNum(ex.descanso), rounds: 1 }} />
                    </CronoPlegable>
                  )}

                  {/* Los puntitos, debajo del descanso y a la derecha.
                      En una biserie va uno solo al pie del bloque: las
                      series son las mismas para los dos ejercicios. */}
                  {/* En piramidal las series se marcan en la escalera:
                      dos contadores para lo mismo confunden. */}
                  {/* Un solo círculo: el tabata se hace entero o no se
                      hace. Marcar bloque por bloque sin aire no es algo
                      que nadie vaya a hacer. */}
                  {/* Los DOS ejercicios del tabata, con sus videos.
                      En 20 segundos no hay tiempo de mirar un video: se
                      miran antes de empezar, para saber qué son los dos
                      movimientos. Mostrando solo el que toca, el segundo
                      aparece cuando ya arrancó y no se puede ver. */}
                  {ex.tecnica === "tabata" && (() => {
                    const cfgT = ex.tecnicaConfig || {};
                    const pares = [
                      { letra: "A", color: "#f87171",
                        nombre: ex.ejercicio, conQue: cfgT.conQueA },
                      { letra: "B", color: "#38bdf8",
                        nombre: cfgT.ejercicioB, conQue: cfgT.conQueB },
                    ].filter((x) => x.nombre);
                    if (pares.length < 2) return null;

                    return (
                      <div className="grid grid-cols-2 gap-2">
                        {pares.map((x, k) => (
                          <div key={x.letra}>
                            <div className="relative rounded-lg overflow-hidden"
                              style={{ border: `1px solid ${x.color}44` }}>
                              <BloqueMedios media={mediaDe({ ejercicio: x.nombre })}
                                nombre={x.nombre} modo="alumno" />
                              <span className="absolute left-1.5 top-1.5 w-4 h-4 rounded-full flex items-center justify-center text-[9px] font-bold"
                                style={{ background: x.color, color: "#000" }}>
                                {x.letra}
                              </span>
                            </div>
                            <p className="text-[11px] text-center mt-1.5 leading-snug">
                              {x.nombre}
                            </p>
                            {x.conQue && (
                              <p className="text-[9px] text-neutral-600 text-center">
                                {x.conQue}
                              </p>
                            )}
                          </div>
                        ))}
                      </div>
                    );
                  })()}

                  {isAlumno && ex.tecnica === "tabata" && (
                    <div className="flex items-center justify-end gap-2">
                      <InfoBoton tema="tabata" />
                      <span className="text-[10px] text-neutral-500">
                        {seriesHechas[clavePliegue] ? "Tabata completado" : "Marcá al terminarlo"}
                      </span>
                      <button
                        onClick={() => marcarSeries(clavePliegue,
                          seriesHechas[clavePliegue] ? 0 : 1, 1)}
                        className="w-9 h-9 rounded-full flex items-center justify-center transition-colors"
                        style={{
                          border: `2px solid ${seriesHechas[clavePliegue] ? "#22c55e" : "#525252"}`,
                          background: seriesHechas[clavePliegue] ? "#22c55e" : "transparent",
                        }}>
                        {!!seriesHechas[clavePliegue] && (
                          <Check size={16} className="text-black" strokeWidth={3} />
                        )}
                      </button>
                    </div>
                  )}

                  {/* El mismo contador para todos. En movilidad es un
                      solo círculo: se hace una vez, se toca y la tarjeta
                      se pliega igual que cualquier otro ejercicio. */}
                  {/* !esBi y no !ex.biserie: si la biserie quedó con un
                      solo ejercicio —porque los dos no están seguidos—
                      no se dibuja el recuadro del grupo, y sin esto ese
                      ejercicio se quedaba sin NINGÚN contador. No había
                      forma de marcarlo y la sesión nunca cerraba. */}
                  {isAlumno && !esBi && !esPiramidal(ex.tecnica)
                    && ex.tecnica !== "tabata" && (
                    <ContadorSeries total={esMovilidad ? "1" : ex.series}
                      tono={colorTarjeta(ex)}
                      hechas={seriesHechas[`${activeSession.id}-${i}`] || 0}
                      onCambio={(n) => marcarSeries(`${activeSession.id}-${i}`, n,
                        esMovilidad ? 1 : (parseNum(ex.series) || 1))} />
                  )}

                  {/* Lo que escribió la semana pasada, y tu respuesta.
                      Verlo antes de repetir el ejercicio es lo que hace
                      que el comentario sirva para algo: si dijo que le
                      tiró la lumbar, eso tiene que estar a la vista. */}


                  {/* La conversación del ejercicio: todo lo que se
                      dijeron, semana a semana. Reemplaza al comentario
                      que se copiaba al duplicar, que solo mostraba una
                      semana hacia atrás y a veces arrastraba lo que no
                      correspondía. */}
                  {/* En la librería no hay alumno ni conversación: la
                      nota del ejercicio, la métrica y la sección, que
                      son parte de la plantilla. */}
                  {enPlantilla && (
                    <div className="space-y-2.5 pt-1">
                      <Conversacion notaCoach={ex.notaCoach} onNota={set("notaCoach")} esCoach />
                      {ex.tecnica !== "tabata" && !esActivacion && (
                        <button onClick={() => set("metric")(ex.metric === "RPE" ? "RIR" : "RPE")}
                          className="w-full flex items-center justify-center gap-1.5 text-[11px] font-medium rounded-lg py-1.5 border transition-colors text-neutral-400 bg-neutral-700 border-neutral-600">
                          Usa {ex.metric === "RPE" ? "RPE" : "RIR"} · tocá para cambiar a {ex.metric === "RPE" ? "RIR" : "RPE"}
                        </button>
                      )}
                      <div>
                        <span className="text-[10px] uppercase tracking-wider block mb-1"
                          style={{ color: GRIS_ETIQUETA }}>Sección</span>
                        <div className="flex gap-1.5">
                          {SECCIONES.map((sc) => {
                            const activa = seccionDe(ex) === sc.id
                              || (sc.subs && sc.subs.some((x) => x.id === seccionDe(ex)));
                            return (
                              <button key={sc.id} onClick={() => !activa && set("seccion")(sc.subs ? sc.subs[sc.subs.length - 1].id : sc.id)}
                                className="flex-1 rounded-md py-1.5 text-[10px] font-medium border transition-colors"
                                style={activa
                                  ? { background: sc.color, color: "#000", borderColor: sc.color }
                                  : { color: "#94a3b8", borderColor: "#52525266" }}>
                                {sc.nombre.split(" ")[0]}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                  {ex.ejercicio && !enPlantilla && (
                    <HiloEjercicio
                      hilo={hilos[ex.ejercicio]}
                      alumnoNombre={(viendoComo?.name || selectedStudent?.name
                        || perfilVista?.name || "").split(" ")[0]}
                      esCoach={isCoach}
                      onEnviar={(t) => mandarMensaje(ex, t, null)}
                      onFoto={(dataUrl) => setMarcando({
                        imagen: dataUrl, indice: i,
                        destino: isCoach ? "coach" : "alumno",
                        hilo: ex, titulo: "Marcá lo que quieras señalar" })}
                      onVerTodo={() => verHiloCompleto(ex)}
                      onReaccionar={(m, emoji) => reaccionarMensaje(ex, m, emoji)}
                      puedeTocar={puedeTocarMensaje}
                      onEditar={(m, t) => editarMensajeHilo(ex, m, t)}
                      onBorrar={(m) => borrarMensajeHilo(ex, m)} />
                  )}

                  {/* Plegar desde abajo. Con la tarjeta abierta, el
                      botón de arriba queda fuera de la pantalla: hay
                      que subir hasta el título para cerrarla y volver
                      a bajar al siguiente ejercicio. */}
                  {isCoach && (
                    <button onClick={() => plegar(clavePliegue, true)}
                      className="w-full flex items-center justify-center gap-1.5 text-[10px] text-neutral-600 hover:text-sky-400 py-1.5 transition-colors">
                      <ChevronUp size={12} /> Plegar
                    </button>
                  )}
                  </>)}
                </div>
              );
              });

              // Un ejercicio suelto se dibuja tal cual.
              if (!esBi) return <React.Fragment key={bi}>{contenido}</React.Fragment>;

              // La biserie va en un recuadro propio, para que se lea de
              // un vistazo que se hacen seguidos.
              // Plegada, la biserie deja solo sus ejercicios: el
              // contador y el cronómetro pertenecen al trabajo en curso,
              // y con el bloque cerrado ese trabajo ya está hecho.
              const claveBi = `${activeSession.id}-bi${bloque.grupo}`;
              const biCerrada = !!plegados[claveBi];

              return (
                <div key={bi}
                  className={`rounded-xl border-2 ${biCerrada ? "p-1.5 space-y-1" : "p-2.5 space-y-2.5"}`}
                  style={{ borderColor: biCerrada ? "#40404066" : `${colorSerie(bloque.grupo)}66`,
                           background: biCerrada ? "transparent" : `${colorSerie(bloque.grupo)}0D` }}>
                  <div className="flex items-center gap-2 px-1">
                    <span className="text-[10px] font-bold uppercase tracking-wider rounded-full px-2.5 py-1"
                      style={biCerrada
                        ? { color: "#a3a3a3", background: "#40404040" }
                        : { color: colorSerie(bloque.grupo), background: `${colorSerie(bloque.grupo)}26` }}>
                      {nombreSerie(bloque.items.length)} {bloque.grupo}
                    </span>
                    {!biCerrada && (
                      <span className="text-[10px] text-neutral-400 flex-1">
                        {bloque.items.length} ejercicios seguidos, sin pausa entre medio
                      </span>
                    )}
                  </div>

                  {contenido}

                  {isAlumno && !biCerrada && (
                    <ContadorSeries total={ultimo.series} tono={colorTarjeta(ultimo)}
                      hechas={seriesHechas[claveBi] || 0}
                      onCambio={(n) => marcarSeries(claveBi, n, parseNum(ultimo.series))} />
                  )}

                  {/* Una serie combinada en modo tabata: los ejercicios
                      alternan en cada bloque. 20 de A, pausa, 20 de B,
                      pausa, y vuelta a empezar. */}
                  {!biCerrada && ultimo.modo === "tabata" && parseNum(ultimo.reps) > 0 && (
                    <div className="space-y-1.5 pt-1">
                      <p className="text-[10px] uppercase tracking-wider text-center"
                        style={{ color: colorSerie(bloque.grupo) }}>
                        Tabata · {parseNum(ultimo.series) || 8} bloques de {parseNum(ultimo.reps)}s
                        {parseNum(ultimo.descanso) > 0 && ` / ${parseNum(ultimo.descanso)}s`}
                      </p>
                      <IntervalTimer compacto
                        silencioso={isAlumno && modoRitmo === "musica"}
                        alterna={bloque.items.map(({ ex: e }) => e.ejercicio).filter(Boolean)}
                        config={{ work: parseNum(ultimo.reps),
                                  rest: parseNum(ultimo.descanso) || 0,
                                  rounds: parseNum(ultimo.series) || 8 }} />
                    </div>
                  )}

                  {/* El descanso corresponde al final del bloque. */}
                  {!biCerrada && ultimo.modo !== "tabata" && parseNum(ultimo.descanso) > 0 && (
                    <div className="space-y-1.5 pt-1">
                      <p className="text-[10px] uppercase tracking-wider text-center"
                        style={{ color: colorSerie(bloque.grupo) }}>
                        Descanso al terminar la {nombreSerie(bloque.items.length).toLowerCase()}
                      </p>
                      <CronoPlegable segundos={parseNum(ultimo.descanso)}>
                        <IntervalTimer compacto
                          config={{ work: 0, rest: parseNum(ultimo.descanso), rounds: 1 }} />
                      </CronoPlegable>
                    </div>
                  )}
                </div>
              );
              };

              const conIndice = activeSession.exercises.map((e, idx) => ({ ...e, __i: idx }));

              return (
                <>
                  {/* Qué cambió respecto de la semana pasada. Sin esto
                      el alumno abre la sesión y no sabe si le subiste
                      el peso, si hay un ejercicio nuevo o si le dejaste
                      un comentario: tiene que ir campo por campo. */}
                  {isAlumno && novedades.length > 0 && (
                    <div className="rounded-xl p-3"
                      style={{ background: "#262626", border: "1px solid #38bdf844" }}>
                      <button onClick={() => setNovedadesAbiertas((v) => !v)}
                        className="w-full flex items-center gap-2 text-left">
                        <Sparkles size={14} style={{ color: "#38bdf8" }} className="shrink-0" />
                        <span className="text-[10px] uppercase tracking-[0.06em] font-bold flex-1"
                          style={{ color: "#38bdf8" }}>
                          Novedades de la semana
                        </span>
                        <span className="text-[10px] text-neutral-500">{novedades.length}</span>
                        <ChevronDown size={13}
                          className={`text-neutral-600 shrink-0 transition-transform ${
                            novedadesAbiertas ? "" : "-rotate-90"}`} />
                      </button>

                      {novedadesAbiertas && (
                        <div className="mt-2.5 space-y-2">
                          {novedades.map((n, k) => {
                            const estilo = {
                              peso_sube: [ArrowUpRight, ESTADO.bien,
                                `Te subí el peso · ${n.antes} → ${n.ahora} kg`],
                              peso_baja: [ArrowDownRight, ESTADO.aviso,
                                `Bajamos el peso · ${n.antes} → ${n.ahora} kg`],
                              reps: [Repeat, "#38bdf8",
                                `Cambian las repeticiones · ${n.antes} → ${n.ahora}`],
                              rir: [Gauge, "#fb923c",
                                `Cambia el RIR · ${n.antes} → ${n.ahora}`],
                              nuevo: [Plus, "#a78bfa", "Ejercicio nuevo"],
                            }[n.tipo];
                            if (!estilo) return null;
                            const [Ico, col, texto] = estilo;
                            return (
                              <div key={n.clave || k} className="flex items-stretch rounded-lg"
                                style={{ background: "#ffffff06" }}>
                                <button
                                  onClick={() => setNovedadAbierta({
                                    clave: n.clave, ejercicio: n.ejercicio,
                                    contexto: texto,
                                    dato: n.antes != null && n.ahora != null
                                      ? { etiqueta: "Antes / ahora", valor: `${n.antes} → ${n.ahora}` }
                                      : null,
                                    destino: n.sesion_id
                                      ? { semanaId: n.semana_id, sesionId: n.sesion_id,
                                          ejercicioId: n.ejercicio_id, tipo: n.tipo }
                                      : null,
                                  })}
                                  className="flex-1 min-w-0 flex gap-2 items-start text-left px-2 py-1.5 rounded-l-lg hover:bg-neutral-700/40 transition-colors">
                                  <Ico size={13} style={{ color: col }} className="shrink-0 mt-0.5" />
                                  <span className="text-[11.5px] text-neutral-300 leading-relaxed">
                                    {texto} en <b className="text-neutral-100">{n.ejercicio}</b>
                                  </span>
                                </button>
                                {/* Ya la vio: se va y no vuelve. */}
                                <button onClick={() => {
                                    setNovedades((prev) => prev.filter((x) => x.clave !== n.clave));
                                    if (hayBackend && n.clave) {
                                      descartarNovedad(n.clave).catch(() =>
                                        setNovedades((prev) => [n, ...prev]));
                                    }
                                  }}
                                  title="Marcar como vista"
                                  className="px-2 flex items-center shrink-0 group">
                                  <span className="w-[16px] h-[16px] rounded-[4px] flex items-center justify-center transition-colors group-hover:bg-emerald-400/20"
                                    style={{ border: "1.5px solid #525252" }}>
                                    <Check size={10} strokeWidth={3}
                                      className="text-transparent group-hover:text-emerald-400 transition-colors" />
                                  </span>
                                </button>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}

                  {/* La indicación general de la semana. El coach la
                      escribe, el alumno la ve al abrir la sesión: acá
                      van las cosas que valen para todo el entrenamiento
                      y no para un ejercicio en particular. */}
                  {!enPlantilla && (isCoach || activeSession.notaSemanal) && (
                    <div className="rounded-lg p-2.5"
                      style={{ background: "#303030",
                               border: `1px solid ${activeSession.notaSemanal ? "#38bdf844" : "#ffffff0a"}` }}>
                      <span className="flex items-center gap-1.5 mb-1.5">
                        <MessageSquareReply size={12} style={{ color: "#38bdf8" }} />
                        <span className="text-[9px] uppercase tracking-[0.06em] font-semibold"
                          style={{ color: "#38bdf8" }}>
                          Nota de la semana
                        </span>
                      </span>
                      {isCoach ? (
                        <textarea
                          value={activeSession.notaSemanal || ""}
                          onChange={(e) => {
                            const v = e.target.value;
                            setWeeks((prev) => prev.map((w) => ({
                              ...w,
                              sessions: w.sessions.map((se) =>
                                se.id === activeSession.id ? { ...se, notaSemanal: v } : se),
                            })));
                          }}
                          onBlur={(e) => hayBackend && activeSession.id
                            && persistir(() => guardarNotaSemanal(activeSession.id, e.target.value),
                                         "No se pudo guardar la nota.")}
                          rows={2}
                          placeholder="Algo que valga para toda la sesión…"
                          className="w-full bg-neutral-900 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-md px-2.5 py-2 text-sm resize-none" />
                      ) : (
                        <p className="text-[12px] text-neutral-300 leading-relaxed">
                          {activeSession.notaSemanal}
                        </p>
                      )}
                    </div>
                  )}

                  {/* Cuánto de la sesión lleva hecho. Cuenta SERIES y no
                      ejercicios: uno de cuatro series avanza de a poco
                      en vez de saltar de golpe, que es lo que refleja
                      el esfuerzo real. */}
                  {isAlumno && (() => {
                    // Se cuenta EXACTAMENTE como se dibuja: se arman
                    // los mismos bloques que ve el alumno y se usa la
                    // misma clave. Contarlo por separado fue lo que
                    // hizo que una sesión con biserie nunca llegara
                    // al 100%.
                    const conIdx = activeSession.exercises
                      .map((e, k) => ({ ...e, __i: k }))
                      .filter((e) => e.ejercicio);
                    const unidades = agruparBiseries(conIdx)
                      .map((b) => unidadesDeTarjeta(activeSession.id, b.items));

                    let total = 0, hechas = 0;
                    for (const u of unidades) {
                      total += u.total;
                      hechas += Math.min(u.total, seriesHechas[u.clave] || 0);
                    }
                    if (!total) return null;

                    const pct = Math.round((hechas / total) * 100);
                    // El color acompaña el avance: rojo al arrancar,
                    // verde al terminar. Se ve de reojo sin leer.
                    const color = pct >= 100 ? ESTADO.bien
                      : pct >= 60 ? ESTADO.aviso
                      : pct >= 30 ? ESTADO.atencion
                      : ESTADO.alerta;
                    const listo = pct >= 100;

                    return (
                      <div className="bg-neutral-800 border rounded-xl p-3.5"
                        style={{ borderColor: listo ? `${ESTADO.bien}55` : "#40404066" }}>
                        <div className="flex items-baseline gap-2 mb-2.5">
                          <span className="font-display font-bold text-2xl leading-none"
                            style={{ color }}>{pct}%</span>
                          <span className="text-[11px] text-neutral-400 flex-1">de la sesión</span>
                          <span className="text-[11px] shrink-0"
                            style={{ color: listo ? ESTADO.bien : "#737373" }}>
                            {hechas} de {total} {total === 1 ? "serie" : "series"}
                          </span>
                        </div>

                        <div className="h-1.5 bg-neutral-900 rounded-full overflow-hidden">
                          <div className="h-full rounded-full"
                            style={{ width: `${Math.max(pct, 2)}%`, background: color,
                                     transition: "width 300ms cubic-bezier(0.16, 1, 0.3, 1), background 300ms" }} />
                        </div>

                        {/* Qué falta EN CONCRETO para llegar al 100%.
                            "Tocá los círculos" no alcanzaba: al que le
                            faltaban dos series de un ejercicio no le
                            decía cuál ni cuántas. */}
                        <div className="mt-2 space-y-1">
                          {listo ? (
                            <>
                              <div className="flex items-center gap-1.5">
                                <CheckCircle2 size={12} style={{ color: ESTADO.bien }} />
                                <span className="text-[10px]" style={{ color: ESTADO.bien }}>
                                  Todo listo · ya podés cerrar la sesión
                                </span>
                              </div>
                              {/* El RIR no entra en el porcentaje pero sí
                                  hace falta para cerrar: sin esto llegaba
                                  al 100%, tocaba terminar y le saltaba un
                                  aviso que no esperaba. */}
                              {ejerciciosSinRir().length > 0 && (
                                <p className="text-[10px] pl-[18px] leading-relaxed"
                                  style={{ color: ESTADO.aviso }}>
                                  Te falta el RIR en {ejerciciosSinRir().length}
                                  {ejerciciosSinRir().length === 1 ? " ejercicio" : " ejercicios"}
                                </p>
                              )}
                            </>
                          ) : (
                            <>
                              <div className="flex items-center gap-1.5">
                                <MousePointerClick size={12} className="text-neutral-600 shrink-0" />
                                <span className="text-[10px] text-neutral-500">
                                  Para llegar al 100% te falta:
                                </span>
                              </div>
                              <p className="text-[10px] text-neutral-400 pl-[18px] leading-relaxed">
                                {total - hechas} {total - hechas === 1 ? "serie" : "series"}
                                {(() => {
                                  // Los ejercicios donde queda algo, con
                                  // el mismo criterio que la barra.
                                  const faltan = unidades
                                    .filter((u) => (seriesHechas[u.clave] || 0) < u.total)
                                    .map((u) => u.nombre);
                                  if (!faltan.length) return "";
                                  // Hasta tres nombres: la lista entera
                                  // ocuparía media pantalla.
                                  const muestra = faltan.slice(0, 3).join(", ");
                                  return faltan.length > 3
                                    ? ` · ${muestra} y ${faltan.length - 3} más`
                                    : ` · ${muestra}`;
                                })()}
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })()}

                  {(isAlumno || isCoach) && vistaSesion === "lista" ? (() => {
                    // El coach ve la misma planilla: cambia lo suyo (la
                    // consigna) y lee lo que cargó el alumno, en color.
                    const coach = isCoach;
                    const campo = "bg-neutral-700/70 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-md px-1.5 py-1 text-sm w-full";
                    const leido = (valor, estado) => valor
                      ? <span className="rounded-md px-1.5 py-0.5 font-semibold"
                          style={COLOR_ESTADO[estado] || { color: "#a3a3a3", background: "#ffffff0d" }}>{valor}</span>
                      : <span className="text-neutral-600">—</span>;
                    // ─────────────────────────────────────────────
                    // VISTA DE LISTA DEL ALUMNO
                    // La misma planilla que usa el coach: una fila por
                    // ejercicio, que se desliza hacia el costado. Lo del
                    // coach se lee; lo suyo (peso, RIR, series, video,
                    // conversación) se carga ahí mismo. Guarda en el
                    // mismo lugar que las tarjetas.
                    // ─────────────────────────────────────────────
                    const setEj = (i, campo) => (v) => updateExercise(activeWeek.id, activeSession.id, i, campo, v);
                    const PARTES = [["movilidad", "Movilidad", "#6fc48d"], ["activacion", "Activación", "#6fc48d"],
                                    ["principal", "Parte principal", "#38bdf8"], ["finalizador", "Finalizador", "#e0a068"]];
                    const nada = <span className="text-neutral-600">—</span>;
                    const td = "px-2 py-1.5 border-b border-neutral-700/60 align-middle whitespace-nowrap overflow-hidden text-ellipsis bg-neutral-800";
                    const selector = (valor, opciones, onChange, estado, otro) => (
                      <select value={valor || ""} onChange={(e) => (e.target.value === "__otro__" ? otro() : onChange(e.target.value))}
                        className="bg-neutral-700/70 border rounded-md px-1.5 py-1 text-sm focus:outline-none"
                        style={{ minWidth: 64,
                                 ...(estado ? { borderColor: COLOR_ESTADO[estado].color, color: COLOR_ESTADO[estado].color }
                                            : { borderColor: "#525252" }) }}>
                        {/* Arriba de todo: escribir un peso que no está en la lista. */}
                        {otro && <option value="__otro__">＋ Agregar peso</option>}
                        <option value="">—</option>
                        {valor && !opciones.includes(valor) && <option value={valor}>{valor}</option>}
                        {opciones.map((o) => <option key={o} value={o}>{o}</option>)}
                      </select>
                    );
                    const icono = (activo, encendido, onClick, titulo, Ic, badge, rojo = false) => (
                      <button onClick={onClick} title={titulo}
                        className={`relative inline-flex items-center justify-center w-8 h-8 rounded-lg border ${
                          activo ? "border-sky-400 text-sky-400 bg-sky-400/10"
                          : encendido ? "border-neutral-500 text-sky-400" : "border-neutral-700 text-neutral-500"}`}>
                        <Ic size={14} />
                        {badge > 0 && (
                          <span className={`absolute -top-1.5 -right-1.5 min-w-[15px] h-[15px] px-1 rounded-full ${rojo ? "bg-red-500" : "bg-neutral-600"} text-white text-[9px] font-bold flex items-center justify-center`}>{badge}</span>
                        )}
                      </button>
                    );

                    // Las biseries llevan un solo contador, en el último
                    // ejercicio del grupo: como en las tarjetas.
                    const contador = {};
                    for (const [parte] of PARTES) {
                      const suyos = conIndice.filter((e) => seccionDe(e) === parte);
                      for (const b of agruparBiseries(suyos)) {
                        if (b.tipo === "biserie") {
                          const ult = b.items[b.items.length - 1];
                          b.items.forEach(({ i }) => { contador[i] = null; });
                          contador[ult.i] = { clave: `${activeSession.id}-bi${b.grupo}`, total: ult.ex.series };
                        }
                      }
                    }

                    return (
                      <div className="space-y-1.5">
                        {/* Los títulos de las columnas quedan pegados arriba al
                            bajar, y se deslizan de costado junto con la planilla:
                            siempre se sabe a qué corresponde cada dato. Van en
                            una tabla aparte con los mismos anchos. */}
                        <div>
                          <CabeceraFija id={`lista-cab-${activeSession.id}`} cols={COLS_LISTA}
                            className="rounded-xl border border-neutral-700 mb-2" />
                          <div id={`lista-cuerpo-${activeSession.id}`} className="overflow-x-auto"
                            style={ESTILO_DESLIZA}
                            onScroll={seguirCabecera(`lista-cab-${activeSession.id}`)}>
                          <table className="text-xs border-separate" style={{ tableLayout: "fixed", width: ANCHO_LISTA, borderSpacing: 0 }}>
                            <colgroup>{COLS_LISTA.map(([t, w]) => <col key={t} style={{ width: w }} />)}</colgroup>
                            <tbody>
                              {(() => { let nParte = 0; return PARTES.map(([parte, titulo, color]) => {
                                const items = activeSession.exercises.map((ex, i) => ({ ex, i }))
                                  .filter(({ ex }) => seccionDe(ex) === parte && (ex.ejercicio || ex.tecnica === "tabata"));
                                if (!items.length) return null;
                                // Cada parte se pliega tocando su título. Se recuerda
                                // en el teléfono, como en las tarjetas.
                                const claveParte = `${activeSession.id}-lista-${parte}`;
                                const plegada = !!plegados[claveParte];
                                // Cada parte es su propia tarjeta: un degradé de su color
                                // arriba que se apaga hacia abajo, y un borde apenas teñido.
                                const borde = `1px solid ${color}38`;
                                const lados = { borderLeft: borde, borderRight: borde };
                                const primera = nParte++ === 0;
                                return (
                                  <React.Fragment key={parte}>
                                    {!primera && <tr><td colSpan={13} style={{ height: 10, padding: 0 }} /></tr>}
                                    <tr className="cursor-pointer select-none" onClick={() => plegar(claveParte, !plegada)}>
                                      <td colSpan={13} className="px-2 pt-3 pb-2 bg-neutral-800"
                                        style={{ backgroundImage: `linear-gradient(180deg, ${color}26, ${color}0a)`,
                                                 borderTop: borde, ...lados, borderBottom: `1px solid ${color}26`,
                                                 borderRadius: plegada ? 14 : "14px 14px 0 0" }}>
                                        <span className="sticky left-2 inline-flex items-center gap-1.5 text-[10.5px] font-bold uppercase tracking-wider"
                                          style={{ color }}>
                                          <ChevronDown size={13}
                                            className={`transition-transform ${plegada ? "-rotate-90" : ""}`} />
                                          <span className="w-2 h-2 rounded-full" style={{ background: color }} />
                                          {titulo}
                                          <span className="text-neutral-500 font-medium normal-case tracking-normal">
                                            · {items.length}
                                          </span>
                                        </span>
                                      </td>
                                    </tr>
                                    {!plegada && items.map(({ ex, i }) => {
                                      const esMov = parte === "movilidad";
                                      const esPrep = esMov || parte === "activacion";
                                      const esTabata = ex.tecnica === "tabata";
                                      const pir = esPiramidal(ex.tecnica);
                                      const esc = pir && Array.isArray(ex.tecnicaConfig?.escalones) ? ex.tecnicaConfig.escalones : [];
                                      const metric = (ex.metric === "RPE" || esTabata) ? "RPE" : "RIR";
                                      const opciones = metricOptions(metric);
                                      const ic = opciones.indexOf(ex.rirConsigna), it = opciones.indexOf(ex.rirTuyo);
                                      const estRir = ex.rirTuyo && ic !== -1 && it !== -1
                                        ? (it === ic ? "match" : it < ic ? "harder" : "easier") : null;
                                      const estPeso = estadoPeso(ex.pesoUsado, ex.pesoSugerido);
                                      const media = mediaDe(ex);
                                      const clave = `${activeSession.id}-${i}`;
                                      const abierta = filaLista && filaLista.i === i ? filaLista.que : null;
                                      const hilo = hilos[ex.ejercicio];
                                      // El número es lo que el otro escribió y todavía no
                                      // contestaste (ni le reaccionaste): al contestar se va.
                                      const nMsj = sinContestar(hilo?.mensajes, isCoach ? "coach" : "alumno");
                                      const cont = i in contador ? contador[i]
                                        : { clave, total: esMov ? "1" : ex.series };
                                      const abrir = (que) => setFilaLista(abierta === que ? null : { i, que });
                                      // El reloj de la fila: el trabajo en movilidad, el bloque
                                      // en EMOM (se repite), o el descanso que puso el coach.
                                      const seg = (v) => Math.round(parseNum(v));
                                      const fmt = (n) => (n >= 60 ? `${Math.floor(n / 60)}:${String(n % 60).padStart(2, "0")}` : `${n} s`);
                                      const reloj = esTabata ? null
                                        : esMov && seg(ex.reps) > 0 ? { segundos: seg(ex.reps), tipo: "Trabajo", texto: fmt(seg(ex.reps)) }
                                        : ex.tecnica === "emom" ? { segundos: seg(ex.tecnicaConfig?.segundos) || 60, tipo: "EMOM", repetir: true,
                                                                    texto: `EMOM ${fmt(seg(ex.tecnicaConfig?.segundos) || 60)}` }
                                        : seg(ex.descanso) > 0 ? { segundos: seg(ex.descanso), tipo: "Descanso", texto: fmt(seg(ex.descanso)) }
                                        : null;
                                      // Piramidal: cada serie, "reps × kilos". Gris hasta que la hace.
                                      const chipsPir = esc.map((x, k) => {
                                        const h = (ex.resultadoSeries || [])[k];
                                        const hecha = !!h?.hecha;
                                        return {
                                          etiqueta: hecha ? `${h.reps || x.reps}×${h.peso || x.peso}` : `${x.reps}×${x.peso}`,
                                          estado: hecha ? estadoSerie(h, x) : null,
                                          titulo: `Serie ${k + 1} de ${esc.length} · pedido ${x.reps} × ${x.peso} kg`,
                                          campos: [{ clave: "reps", label: "Reps", valor: h?.reps || x.reps },
                                                   { clave: "peso", label: "Kg", valor: h?.peso || x.peso }],
                                          boton: "Hice esta serie",
                                        };
                                      });
                                      const guardarPir = (k, v) => {
                                        const hechas = esc.map((_, j) =>
                                          (ex.resultadoSeries || [])[j] || { peso: "", reps: "", hecha: false });
                                        const next = hechas.map((h, j) => (j === k
                                          ? { peso: v.peso, reps: v.reps, hecha: true } : h));
                                        setEj(i, "resultadoSeries")(next);
                                        marcarSeries(clave, next.filter((h) => h.hecha).length, esc.length);
                                      };
                                      const chipsEmom = [{
                                        etiqueta: ex.emomBloques ? `${ex.emomBloques} bloques` : "bloques",
                                        titulo: "¿Hasta qué bloque llegaste?",
                                        campos: [{ clave: "b", label: "Bloques", valor: ex.emomBloques ?? "" },
                                                 { clave: "r", label: "Reps del último", valor: ex.emomReps ?? "" }],
                                      }];
                                      const guardarEmom = (_, v) => {
                                        const b = parseNum(v.b), r = parseNum(v.r);
                                        setEj(i, "emomBloques")(b || null);
                                        setEj(i, "emomReps")(r || null);
                                      };
                                      const elegir = (cual) => (k) => setFilaLista(k == null ? null : { i, que: cual, k });
                                      const elegido = (cual) => (abierta === cual ? filaLista.k : null);
                                      // Lo del coach: las series del piramidal (lo que pide, con
                                      // el color de cómo le fue) y las variables de la técnica.
                                      const chipsPirCoach = esc.map((x, k) => {
                                        const h = (ex.resultadoSeries || [])[k];
                                        return {
                                          etiqueta: `${x.reps || "?"}×${x.peso || "?"}`,
                                          estado: h?.hecha ? estadoSerie(h, x) : null,
                                          titulo: `Serie ${k + 1} de ${esc.length}`,
                                          nota: h?.hecha ? `Hizo ${h.reps || x.reps} × ${h.peso || x.peso} kg` : null,
                                          campos: [{ clave: "reps", label: "Reps", valor: x.reps },
                                                   { clave: "peso", label: "Kg", valor: x.peso }],
                                          quitable: esc.length > 1,
                                        };
                                      });
                                      const ponerEsc = (lista) => setEj(i, "tecnicaConfig")({ ...ex.tecnicaConfig, escalones: lista });
                                      const guardarPirCoach = (k, v) => ponerEsc(esc.map((x, j) => (j === k
                                        ? { ...x, reps: String(v.reps ?? x.reps), peso: String(v.peso ?? x.peso) } : x)));
                                      const chipsTec = coach && !esPrep ? chipsDeTecnica(ex.tecnica, ex.tecnicaConfig) : null;
                                      const guardarTec = (_, v) => setEj(i, "tecnicaConfig")(conValor(ex.tecnicaConfig, v));
                                      const editores = {
                                        pir: coach ? [chipsPirCoach, guardarPirCoach] : [chipsPir, guardarPir],
                                        emom: [chipsEmom, guardarEmom],
                                        tec: [chipsTec || [], guardarTec],
                                      };
                                      return (
                                        <React.Fragment key={i}>
                                          <tr>
                                            <td className={`${td} sticky left-0 z-10`} style={{ borderLeft: borde }}>
                                              <div className="flex items-center gap-1.5 whitespace-normal">
                                                {/* El video de la técnica, cargado en la librería. */}
                                                {(media.videoUrl || media.gifUrl) && (
                                                  <button onClick={() => setTecnicaLista({ nombre: ex.ejercicio, media })}
                                                    title="Ver la técnica"
                                                    className="shrink-0 w-6 h-6 rounded-full bg-sky-400/15 text-sky-400 inline-flex items-center justify-center">
                                                    <Play size={11} />
                                                  </button>
                                                )}
                                                <span className="font-semibold text-[12.5px] leading-tight min-w-0">
                                                  {esTabata ? (ex.tecnicaConfig?.titulo || "Tabata") : ex.ejercicio}
                                                  {/* Material y consigna en gris: se leen sin deslizar. */}
                                                  {!esTabata && (
                                                    <span className="block font-normal text-[10.5px] text-neutral-500 truncate">
                                                      {[!estaOculto(ex, "conQue") && ex.conQue,
                                                        esMov ? (ex.reps ? `${parseNum(ex.reps) || ex.reps} s` : "")
                                                          : pir ? `${esc.length} series`
                                                          : [!estaOculto(ex, "series") && ex.series, !estaOculto(ex, "reps") && ex.reps].filter(Boolean).join(" × "),
                                                      ].filter(Boolean).join(" · ")}
                                                    </span>
                                                  )}
                                                </span>
                                              </div>
                                            </td>
                                            <td className={`${td} text-neutral-400`}>
                                              {coach ? <ElegirOpcion value={ex.conQue || ""} opciones={CON_QUE_OPTIONS} onChange={setEj(i, "conQue")} className={campo} />
                                                : estaOculto(ex, "conQue") || !ex.conQue ? nada : ex.conQue}
                                            </td>
                                            <td className={td} style={coach ? { whiteSpace: "normal" } : undefined}>
                                              {esPrep ? nada : coach ? (
                                                <div className="space-y-1">
                                                  <SelectorTecnica compacto tecnica={ex.tecnica} config={ex.tecnicaConfig}
                                                    pesoBase={ex.pesoSugerido}
                                                    onChange={(t, cfg) => { setEj(i, "tecnica")(t); setEj(i, "tecnicaConfig")(cfg); }}
                                                    onReps={(v) => { if (v) setEj(i, "reps")(v); }} />
                                                  {chipsTec && (
                                                    <Chips chips={chipsTec} onGuardar={guardarTec} envolver
                                                      elegido={elegido("tec")} onElegir={elegir("tec")} />
                                                  )}
                                                </div>
                                              ) : ex.tecnica && ex.tecnica !== "normal"
                                                ? <EtiquetaTecnica tecnica={ex.tecnica} />
                                                : <span className="text-neutral-400">Normal</span>}
                                            </td>
                                            <td className={td}>
                                              {esMov ? nada : pir ? esc.length
                                                : coach ? <input value={ex.series || ""} onChange={(e) => setEj(i, "series")(e.target.value)} className={campo} />
                                                : estaOculto(ex, "series") || !ex.series ? nada : ex.series}
                                            </td>
                                            <td className={td}>
                                              {coach && !pir ? (
                                                <div className="flex items-center gap-1">
                                                  <input value={ex.reps || ""} onChange={(e) => setEj(i, "reps")(e.target.value)} className={campo} />
                                                  {esMov && <span className="text-neutral-500">s</span>}
                                                </div>
                                              ) : esMov ? (ex.reps ? `${parseNum(ex.reps) || ex.reps} s` : nada)
                                                : pir || estaOculto(ex, "reps") || !ex.reps ? nada : ex.reps}
                                            </td>
                                            <td className={td} style={coach && pir ? { whiteSpace: "normal" } : undefined}>
                                              {esPrep || esTabata ? nada
                                                : pir ? (coach
                                                  ? <Chips chips={chipsPirCoach} onGuardar={guardarPirCoach} envolver
                                                      elegido={elegido("pir")} onElegir={elegir("pir")}
                                                      onAgregar={() => ponerEsc([...esc, { ...(esc[esc.length - 1] || { reps: "10", peso: "" }) }])} />
                                                  : <span className="text-neutral-400">{esc.map((x) => x.peso || "?").join(" · ")}</span>)
                                                : coach ? (
                                                  <span className="flex items-center gap-1">
                                                    <input value={ex.pesoSugerido || ""} onChange={(e) => setEj(i, "pesoSugerido")(e.target.value)} className={campo} />
                                                    {/* Mostrarle también las libras: el mismo interruptor de la tarjeta. */}
                                                    <button onClick={() => setEj(i, "mostrarLibras")(!ex.mostrarLibras)}
                                                      title={ex.mostrarLibras ? "El alumno ve también las libras · tocá para sacarlas" : "Mostrarle también en libras"}
                                                      className="shrink-0 rounded-md px-1.5 py-1 text-[10px] font-semibold whitespace-nowrap border"
                                                      style={ex.mostrarLibras
                                                        ? { color: "#000", background: "#fbbf24", borderColor: "#fbbf24" }
                                                        : { color: "#8a8a8a", borderColor: "#525252" }}>
                                                      {ex.mostrarLibras && aLibras(ex.pesoSugerido) ? `${aLibras(ex.pesoSugerido)} lb` : "lb"}
                                                    </button>
                                                  </span>
                                                )
                                                : estaOculto(ex, "pesoSugerido") || !ex.pesoSugerido ? nada
                                                : conUnidad(ex.pesoSugerido, ex.mostrarLibras)}
                                            </td>
                                            <td className={td}>
                                              {esPrep ? nada
                                                : coach ? (
                                                  pir ? (
                                                    <span className="flex flex-wrap gap-1">
                                                      {esc.map((x, k) => {
                                                        const h = (ex.resultadoSeries || [])[k];
                                                        return <React.Fragment key={k}>{h?.hecha
                                                          ? leido(`${h.reps || x.reps}×${h.peso || x.peso}`, estadoSerie(h, x))
                                                          : leido("", null)}</React.Fragment>;
                                                      })}
                                                    </span>
                                                  ) : ex.tecnica === "emom"
                                                    ? leido(ex.emomBloques ? `${ex.emomBloques} bloques` : "", null)
                                                    : esTabata ? nada
                                                    : leido(ex.pesoUsado, estPeso)
                                                )
                                                : esTabata ? (
                                                  <button onClick={() => cambiarVistaSesion("tarjetas")}
                                                    className="text-[11px] text-sky-400">Ver en tarjetas</button>
                                                )
                                                : pir ? (
                                                  <Chips chips={chipsPir} onGuardar={guardarPir} envolver
                                                    elegido={elegido("pir")} onElegir={elegir("pir")} />
                                                )
                                                : (
                                                  <div className="flex items-center gap-1.5">
                                                    {pesoEscrito === clave ? (
                                                      <input autoFocus inputMode="decimal" defaultValue={ex.pesoUsado || ""}
                                                        placeholder="kg"
                                                        onBlur={(e) => { const v = e.target.value.trim(); if (v) setEj(i, "pesoUsado")(v); setPesoEscrito(null); }}
                                                        onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); if (e.key === "Escape") setPesoEscrito(null); }}
                                                        className="w-20 bg-neutral-700/70 border border-sky-400 focus:outline-none rounded-md px-1.5 py-1 text-base" />
                                                    ) : selector(ex.pesoUsado, PESO_OPTIONS, setEj(i, "pesoUsado"), estPeso,
                                                        () => setPesoEscrito(clave))}
                                                    {ex.tecnica === "emom" && (
                                                      <Chips chips={chipsEmom} onGuardar={guardarEmom}
                                                        elegido={elegido("emom")} onElegir={elegir("emom")} />
                                                    )}
                                                  </div>
                                                )}
                                            </td>
                                            <td className={td}>
                                              {coach && !esPrep ? (
                                                <select value={ex.rirConsigna || ""} onChange={(e) => setEj(i, "rirConsigna")(e.target.value)} className={campo}>
                                                  <option value="">—</option>
                                                  {ex.rirConsigna && !opciones.includes(ex.rirConsigna) && <option value={ex.rirConsigna}>{ex.rirConsigna}</option>}
                                                  {opciones.map((o) => <option key={o} value={o}>{o}</option>)}
                                                </select>
                                              ) : esPrep || estaOculto(ex, "rirConsigna") || !ex.rirConsigna ? nada
                                                : <span className="font-semibold" style={{ color: effortColor(ex.rirConsigna, metric) }}>{ex.rirConsigna}</span>}
                                            </td>
                                            <td className={td}>
                                              {esPrep ? nada : coach ? leido(ex.rirTuyo, estRir)
                                                : selector(ex.rirTuyo, opciones, setEj(i, "rirTuyo"), estRir)}
                                            </td>
                                            <td className={td}>
                                              {reloj ? (
                                                <button onClick={() => setRelojLista({ ...reloj, nombre: ex.ejercicio, clave: `${clave}-${Date.now()}` })}
                                                  className="inline-flex items-center gap-1 rounded-md px-1.5 py-1 text-[11px] font-semibold"
                                                  style={{ color: "#fb923c", background: "#fb923c14", border: "1px solid #fb923c55" }}>
                                                  <Timer size={12} /> {reloj.texto}
                                                </button>
                                              ) : nada}
                                            </td>
                                            <td className={td} style={{ overflow: "visible" }}>
                                              {coach || pir || esTabata || !cont ? nada : (
                                                <ContadorSeries total={cont.total} tono={colorTarjeta(ex)}
                                                  hechas={seriesHechas[cont.clave] || 0}
                                                  onCambio={(n) => marcarSeries(cont.clave, n, parseNum(cont.total) || 1)} />
                                              )}
                                            </td>
                                            <td className={td}>
                                              {coach
                                                ? (ex.videoAlumno ? icono(abierta === "video", true, () => abrir("video"), "Ver su video", Video, 0) : nada)
                                                : icono(abierta === "video", !!ex.videoAlumno, () => abrir("video"),
                                                    ex.videoAlumno ? "Tu video" : "Subir tu video", ex.videoAlumno ? Video : Upload, 0)}
                                            </td>
                                            <td className={td} style={{ borderRight: borde }}>
                                              {ex.ejercicio && !enPlantilla && icono(abierta === "charla", (hilo?.total || hilo?.mensajes?.length || 0) > 0, () => abrir("charla"),
                                                "Conversación", MessageSquare, nMsj, true)}
                                            </td>
                                          </tr>
                                          {abierta && (
                                            <tr><td colSpan={13} className="px-2 py-2 border-b border-neutral-700/60 bg-neutral-800" style={lados}>
                                              <div style={{ position: "sticky", left: 8, width: "min(30rem, calc(100vw - 64px))" }}>
                                                {editores[abierta] ? (
                                                  editores[abierta][0][filaLista.k] ? (
                                                    <EditorChip key={`${abierta}-${filaLista.k}`} ancho={300}
                                                      chip={editores[abierta][0][filaLista.k]}
                                                      onGuardar={(v) => editores[abierta][1](filaLista.k, v)}
                                                      onQuitar={coach && abierta === "pir"
                                                        ? () => ponerEsc(esc.filter((_, j) => j !== filaLista.k)) : null}
                                                      onCerrar={() => setFilaLista(null)} />
                                                  ) : null
                                                ) : abierta === "video" && coach ? (
                                                  <ReproductorVideo url={ex.videoAlumno} etiqueta="Ver su video" />
                                                ) : abierta === "video" ? (
                                                  <BloqueMedios media={{ videoUrl: "", gifUrl: "" }} nombre={ex.ejercicio}
                                                    modo="alumno" sinAviso videoAlumno={ex.videoAlumno}
                                                    subiendo={subiendoVideo[`${activeSession.id}-${i}`] ?? null}
                                                    onSubirVideo={(archivo) => subirVideoEjercicio(i, archivo)}
                                                    onQuitarVideo={() => {
                                                      updateExercise(activeWeek.id, activeSession.id, i, "videoAlumno", "");
                                                      showToast("Video quitado");
                                                    }}
                                                    onDescargarVideo={(src) => descargarVideo(src,
                                                      `${(ex.ejercicio || "ejercicio").replace(/\s+/g, "-").toLowerCase()}.mp4`)}
                                                    onCapturarCuadro={(dataUrl) => setMarcando({
                                                      imagen: dataUrl, indice: i, destino: "alumno",
                                                      titulo: `Marcá lo que quieras señalar en ${ex.ejercicio || "el ejercicio"}`,
                                                    })} />
                                                ) : (
                                                  <HiloEjercicio abiertoInicial
                                                    hilo={hilos[ex.ejercicio]}
                                                    alumnoNombre={(viendoComo?.name || selectedStudent?.name
                                                      || perfilVista?.name || "").split(" ")[0]}
                                                    esCoach={coach}
                                                    onEnviar={(t) => mandarMensaje(ex, t, null)}
                                                    onFoto={(dataUrl) => setMarcando({
                                                      imagen: dataUrl, indice: i, destino: coach ? "coach" : "alumno",
                                                      hilo: ex, titulo: "Marcá lo que quieras señalar" })}
                                                    onVerTodo={() => verHiloCompleto(ex)}
                                                    onReaccionar={(m, emoji) => reaccionarMensaje(ex, m, emoji)}
                                                    puedeTocar={puedeTocarMensaje}
                                                    onEditar={(m, t) => editarMensajeHilo(ex, m, t)}
                                                    onBorrar={(m) => borrarMensajeHilo(ex, m)} />
                                                )}
                                              </div>
                                            </td></tr>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                                    {/* El cierre de la tarjeta de esta parte. */}
                                    {!plegada && (
                                      <tr><td colSpan={13} className="bg-neutral-800"
                                        style={{ height: 8, padding: 0, ...lados, borderBottom: borde, borderRadius: "0 0 14px 14px" }} /></tr>
                                    )}
                                  </React.Fragment>
                                );
                              }); })()}
                            </tbody>
                          </table>
                          </div>
                        </div>
                        <p className="text-[10px] text-neutral-500 px-1">
                          Deslizá la planilla hacia el costado para cargar lo tuyo.
                        </p>

                        {relojLista && (
                          <RelojLista key={relojLista.clave} reloj={relojLista} onCerrar={() => setRelojLista(null)} />
                        )}
                        {relojLista && <div className="h-20" />}

                        {/* El video de la técnica, en una ventana. */}
                        {tecnicaLista && ReactDOM.createPortal(
                          <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
                            onClick={() => setTecnicaLista(null)}>
                            <div className="w-full max-w-md bg-neutral-800 rounded-xl p-3 space-y-2"
                              onClick={(e) => e.stopPropagation()}>
                              <div className="flex items-center justify-between">
                                <p className="font-display font-semibold text-sm">{tecnicaLista.nombre}</p>
                                <button onClick={() => setTecnicaLista(null)} className="text-neutral-400"><X size={18} /></button>
                              </div>
                              {tecnicaLista.media.gifUrl && (
                                <img src={tecnicaLista.media.gifUrl} alt={tecnicaLista.nombre}
                                  className="w-full max-h-72 object-contain rounded-lg bg-neutral-900" />
                              )}
                              {tecnicaLista.media.videoUrl && <ReproductorVideo url={tecnicaLista.media.videoUrl} />}
                            </div>
                          </div>, document.body)}
                      </div>
                    );
                  })() : SECCIONES.map((sec) => {
                    // Las secciones reales que dibuja este bloque: la
                    // verde son dos, el resto una sola.
                    const reales = sec.subs ? sec.subs.map((x) => x.id) : [sec.id];
                    const mios = conIndice.filter((e) => reales.includes(seccionDe(e)));
                    const claveSec = `${activeSession.id}-sec-${sec.id}`;
                    // Para el coach arrancan plegadas: al planificar
                    // conviene ver la estructura de un vistazo. Para el
                    // alumno arrancan ABIERTAS: él viene a entrenar, no
                    // a mirar el índice. Con todo plegado no encontraba
                    // los ejercicios de movilidad, y como no podía
                    // completarlos, tampoco cerrar la sesión.
                    const abierta = isCoach && !enPlantilla
                      ? plegados[claveSec] === false
                      : plegados[claveSec] !== true;

                    if (!mios.length && sec.id !== "principal" && !isCoach) return null;

                    // Dibuja una subsección: con bloques con nombre o
                    // derecho, según corresponda.
                    const dibujarSub = (idReal, conBloques, etiqueta, ayuda) => {
                      const suyos = conIndice.filter((e) => seccionDe(e) === idReal);
                      // Cada subsección en su propio recuadro y con su
                      // plegado: sin el borde se leían como una lista
                      // continua y no se entendía dónde terminaba una.
                      const claveSub = `${activeSession.id}-sub-${idReal}`;
                      const subAbierta = plegados[claveSub] !== true;

                      return (
                        <div key={idReal}
                          className={etiqueta
                            ? `rounded-lg border transition-all duration-300 ${
                                subAbierta ? "p-2.5 space-y-2.5" : "px-2.5 py-2"}`
                            : "space-y-3"}
                          style={etiqueta
                            ? { borderColor: `${sec.color}44`, background: "#16202e" }
                            : undefined}>
                          {etiqueta && (
                            <button onClick={() => plegar(claveSub, subAbierta)}
                              className="w-full flex items-center gap-2 px-0.5 text-left">
                              <span className="text-[11px] font-bold uppercase tracking-wider"
                                style={{ color: sec.color }}>{etiqueta}</span>
                              <span className="text-[9px] text-neutral-600 flex-1">{ayuda}</span>
                              {suyos.length > 0 && (
                                <span className="text-[10px] text-neutral-600">{suyos.length}</span>
                              )}
                              <ChevronDown size={13}
                                className={`shrink-0 transition-transform ${subAbierta ? "" : "-rotate-90"}`}
                                style={{ color: sec.color }} />
                            </button>
                          )}

                          {(!etiqueta || subAbierta) && (<>

                          {conBloques
                            ? agruparBloques(suyos).map((grupo, gk) => (
                                <div key={gk}
                                  className={grupo.nombre ? "rounded-lg border p-2.5 space-y-2.5" : "space-y-2.5"}
                                  style={grupo.nombre
                                    ? { borderColor: `${sec.color}33`, background: `${sec.color}08` }
                                    : undefined}>
                                  {grupo.nombre && (
                                    <div className="flex items-center gap-2 px-0.5">
                                      <span className="text-[10px] font-bold uppercase tracking-wider flex-1 truncate"
                                        style={{ color: sec.color }}>{grupo.nombre}</span>
                                      {isCoach && (
                                        <>
                                          <button onClick={() => setRenombrandoBloque({
                                              seccion: idReal, viejo: grupo.nombre, nuevo: grupo.nombre })}
                                            className="text-neutral-600 hover:text-white p-0.5">
                                            <Pencil size={11} />
                                          </button>
                                          <button onClick={() => sumarEjercicioASesion(idReal, grupo.nombre)}
                                            className="text-[10px] px-2 py-0.5 rounded-full"
                                            style={{ color: sec.color, background: `${sec.color}1F` }}>
                                            + ejercicio
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  )}
                                  {agruparBiseries(grupo.items)
                                    .map((b, k) => dibujarBloque(b, `${idReal}-${gk}-${k}`))}
                                </div>
                              ))
                            : agruparBiseries(suyos)
                                .map((b, k) => dibujarBloque(b, `${idReal}-${k}`))}

                          {isCoach && (
                            <div className="flex gap-1.5">
                              <button onClick={() => sumarEjercicioASesion(idReal)}
                                className="flex-1 flex items-center justify-center gap-1.5 text-[11px] font-medium border border-dashed rounded-xl py-2 transition-colors"
                                style={{ color: sec.color, borderColor: `${sec.color}44` }}>
                                <Plus size={12} /> {conBloques ? "Ejercicio" : `Ejercicio de ${(etiqueta || sec.nombre || "").toLowerCase()}`}
                              </button>
                              {conBloques && (
                                <button onClick={() => setNuevoBloque({ seccion: idReal, nombre: "" })}
                                  className="flex-1 flex items-center justify-center gap-1.5 text-[11px] font-medium border border-dashed rounded-xl py-2 transition-colors"
                                  style={{ color: sec.color, borderColor: `${sec.color}44` }}>
                                  <Plus size={12} /> Bloque
                                </button>
                              )}
                            </div>
                          )}
                          </>)}
                        </div>
                      );
                    };

                    return (
                      <div key={sec.id}
                        className={`rounded-xl border-2 transition-all duration-300 ${
                          abierta ? "p-3 space-y-4" : "px-3 py-2"}`}
                        style={{ borderColor: `${sec.color}55`, background: `${sec.color}0A` }}>

                        <button onClick={() => plegar(claveSec, abierta)}
                          className="w-full flex items-center gap-2 text-left">
                          <span className="text-[11px] font-bold uppercase tracking-wider flex-1"
                            style={{ color: sec.color }}>
                            {sec.nombre}
                          </span>
                          {mios.length > 0 && (
                            <span className="text-[10px] rounded-full px-2 py-0.5"
                              style={{ color: sec.color, background: `${sec.color}1F` }}>
                              {mios.length}
                            </span>
                          )}
                          <ChevronDown size={14}
                            className={`shrink-0 transition-transform ${abierta ? "" : "-rotate-90"}`}
                            style={{ color: sec.color }} />
                        </button>

                        {abierta && (<div className="contenido-entra space-y-4">
                          {!mios.length && !isCoach && (
                            <p className="text-[11px] text-neutral-600 px-1">{sec.ayuda}</p>
                          )}
                          {sec.subs
                            ? sec.subs
                                .filter((sub) => isCoach
                                  || conIndice.some((e) => seccionDe(e) === sub.id))
                                .map((sub) => dibujarSub(sub.id, sub.bloques, sub.nombre, sub.ayuda))
                            : dibujarSub(sec.id, false, null, null)}
                        </div>)}
                      </div>
                    );
                  })}

                  {/* El asistente lee el registro y propone la
                      devolución. Con veinte alumnos, escribir cada una
                      desde cero es lo que hace que no se escriban. */}
                  {isCoach && hayBackend && activeSession.estado === "Completado" && (
                    <button onClick={borradorDevolucion}
                      className="w-full flex items-center justify-center gap-1.5 text-xs font-medium text-sky-400 bg-sky-400/10 border border-sky-400/25 hover:bg-sky-400/20 rounded-xl py-2.5 transition-colors">
                      <Sparkles size={13} /> Proponerme una devolución
                    </button>
                  )}
                </>
              );
            })()}


            {enPlantilla ? (
              <div className="flex gap-2 pt-2">
                <button onClick={cancelTemplateBuilder} className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">Cancelar</button>
                <button onClick={saveTemplate} className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">{draftTemplate?.editando ? "Guardar cambios" : "Guardar en la librería"}</button>
              </div>
            ) : (
            <div className="bg-neutral-800 border border-neutral-700 rounded-xl p-4 space-y-3">
              <div>
                <label className="text-[10px] uppercase tracking-wider text-neutral-500 block mb-1">Estado de la sesión</label>
                {isAlumno ? (
                  <div className="relative">
                    <select value={activeSession.estado} onChange={(e) => {
                        // Pasar a "Completado" por acá pasa por el
                        // mismo aviso que el botón: es la misma acción
                        // por otro camino y no puede comportarse
                        // distinto.
                        if (e.target.value === "Completado" && isAlumno) {
                          const sinRir = ejerciciosSinRir();
                          if (sinRir.length) { setAvisoRir(sinRir); return; }
                        }
                        setSessionEstado(activeWeek.id, activeSession.id, e.target.value);
                      }}
                      className={`w-full appearance-none rounded-md pl-3 pr-7 py-2 text-sm font-medium focus:outline-none border ${ESTADO_STYLES[activeSession.estado].bg} ${ESTADO_STYLES[activeSession.estado].text} ${ESTADO_STYLES[activeSession.estado].border}`}>
                      <option value="Pendiente" className="bg-neutral-700 text-red-400">Pendiente</option>
                      <option value="En proceso" className="bg-neutral-700 text-yellow-400">En proceso</option>
                      {/* Ya no se bloquea por RIR: el aviso lo da el
                          diálogo, con la lista de lo que falta y la
                          opción de seguir igual. Bloquearlo acá dejaba
                          al alumno trabado sin explicación. */}
                      <option value="Completado" className="bg-neutral-700 text-emerald-400">
                        Completado
                      </option>
                    </select>
                    <ChevronDown size={13} className={`absolute right-2.5 top-3 pointer-events-none ${ESTADO_STYLES[activeSession.estado].text}`} />
                  </div>
                ) : (
                  <EstadoBadge estado={activeSession.estado} />
                )}
              </div>

              {activeSession.estado === "Completado" && (
                <div className="space-y-3 pt-2 border-t border-neutral-700">
                  <div>
                    <label className="text-[10px] uppercase tracking-wider text-neutral-500 block mb-1.5">Escala de Borg · esfuerzo percibido (1-10)</label>
                    <ChipSelect options={BORG_OPTIONS} value={activeSession.borgRPE} onChange={(v) => setSessionRating(activeWeek.id, activeSession.id, "borgRPE", v)} getColor={borgColor} readOnly={isCoach} />
                  </div>
                  <div>
                    <label className="text-[10px] uppercase tracking-wider text-neutral-500 block mb-1.5">¿Qué tan fuerte se sintió?</label>
                    <ChipSelect options={FUERZA_OPTIONS} value={activeSession.fuerzaPercibida} onChange={(v) => setSessionRating(activeWeek.id, activeSession.id, "fuerzaPercibida", v)} getKey={(o) => o.label} getLabel={(o) => o.label} getColor={(o) => o.color} readOnly={isCoach} />
                  </div>
                  <div>
                    <label className="text-[10px] uppercase tracking-wider text-neutral-500 block mb-1.5">Duración de la sesión (minutos)</label>
                    {isAlumno ? (
                      <input type="number" value={activeSession.duracion || ""} onChange={(e) => setSessionRating(activeWeek.id, activeSession.id, "duracion", e.target.value)}
                        placeholder="Ej: 55" className="w-24 bg-neutral-700 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-md px-3 py-1.5 text-sm text-white transition-colors" />
                    ) : (
                      <p className="text-sm text-neutral-300">{activeSession.duracion ? `${activeSession.duracion} min` : "Sin cargar"}</p>
                    )}
                  </div>
                  {/* El botón está siempre: antes desaparecía si faltaba
                      algún dato y el alumno quedaba en una pantalla sin
                      salida, sin saber qué le faltaba. */}
                  {isAlumno && (() => {
                    const falta = [
                      !activeSession.borgRPE && "el esfuerzo",
                      !activeSession.fuerzaPercibida && "cómo te sentiste",
                    ].filter(Boolean);
                    return (
                      <div className="mt-1 space-y-1.5">
                        <button onClick={intentarCerrar} disabled={falta.length > 0}
                          className="w-full bg-sky-400 hover:bg-sky-200 disabled:bg-neutral-700 disabled:text-neutral-500 text-black font-medium text-sm rounded-lg py-2.5 transition-colors">
                          Completar entrenamiento
                        </button>
                        {falta.length > 0 && (
                          <p className="text-[11px] text-yellow-400 text-center">
                            Falta marcar {falta.join(" y ")}.
                          </p>
                        )}
                      </div>
                    );
                  })()}
                </div>
              )}
            </div>
            )}
          </div>
          );
        })()}
      </div>

      {celebrationOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-30 p-4 modal-fondo">
          <div className="relative bg-neutral-800 border border-neutral-600 rounded-2xl w-full max-w-sm p-6 text-center overflow-hidden">
            {!shareStep && <ConfettiBurst />}
            {!shareStep ? (
              <>
                <div className="w-14 h-14 rounded-full bg-sky-400/10 border border-sky-400/30 flex items-center justify-center mx-auto mb-4">
                  <PartyPopper size={26} className="text-sky-400" />
                </div>
                <p className="font-display text-lg font-semibold">¡Felicitaciones!</p>
                <p className="text-sm text-neutral-400 mt-1">Completaste tu entrenamiento de hoy.</p>
                <p className="text-sm text-sky-400 font-medium mt-3">+{sessionRewards.points} puntos al ranking · +{sessionRewards.exp} EXP</p>
                {sessionRewards.detalle?.length > 0 && (
                  <div className="bg-neutral-900/60 border border-neutral-700 rounded-lg p-2.5 mt-2 space-y-1 text-left">
                    {sessionRewards.detalle.map((d, i) => (
                      <div key={i} className="flex items-center justify-between text-[11px]">
                        <span style={{ color: d.aviso ? ESTADO.aviso : "#a3a3a3" }}>{d.txt}</span>
                        <span className="font-medium shrink-0 ml-2"
                          style={{ color: d.aviso ? ESTADO.aviso : "#38bdf8" }}>
                          {d.aviso ? "menos EXP" : `+${d.exp}`}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
                {sessionRewards.leveledUp && (
                  <p className="text-sm text-yellow-400 font-semibold mt-1">🎉 ¡Subiste a Nivel {sessionRewards.newLevel}!</p>
                )}
                {sessionRewards.newPRs && sessionRewards.newPRs.length > 0 && (
                  <div className="bg-amber-400/10 border border-amber-400/30 rounded-lg p-3 mt-3 text-left space-y-1">
                    <p className="text-xs font-semibold text-amber-400 flex items-center gap-1.5"><Trophy size={13} /> ¡Posible PR! Pendiente de aprobación</p>
                    {sessionRewards.newPRs.map((pr) => (
                      <p key={pr.ejercicio} className="text-[11px] text-neutral-300">
                        {pr.ejercicio}: <span className="font-semibold text-amber-400">{pr.valor}{pr.tipo === "peso" ? "kg" : " reps"}</span>
                        {pr.prevValor && <span className="text-neutral-500"> (antes {pr.prevValor}{pr.tipo === "peso" ? "kg" : " reps"})</span>}
                      </p>
                    ))}
                  </div>
                )}
                <div className="flex flex-col gap-2 mt-6">
                  <button onClick={goToShareStep} className="w-full bg-sky-400 hover:bg-sky-200 text-black font-medium text-sm rounded-lg py-2.5 transition-colors">
                    Compartir en el grupo de WhatsApp
                  </button>
                  <button onClick={closeCelebration} className="w-full border border-neutral-600 text-sky-400 font-medium text-sm rounded-lg py-2.5 hover:border-neutral-700 transition-colors">
                    Listo, terminar
                  </button>
                  <p className="text-[11px] text-neutral-500 text-center mt-2 leading-relaxed">
                    Tu entrenamiento ya quedó guardado. Completalo pasando una foto
                    al grupo y sumá 10 puntos más al ranking.
                  </p>
                </div>
              </>
            ) : (
              <>
                <p className="font-display text-base font-semibold mb-1">Compartir en WhatsApp</p>
                <p className="text-xs text-neutral-500 mb-5">
                  Sacate una foto del entrenamiento para compartir con el grupo.
                  Sin ella la sesión no suma al torneo.
                </p>

                {/* La cámara de verdad. `capture` abre la frontal en el
                    celular; en computadora, el explorador de archivos. */}
                {fotoCierre ? (
                  <div className="relative mb-4">
                    <img src={fotoCierre} alt="Tu foto"
                      className="w-full rounded-xl object-cover max-h-64" />
                    <button onClick={() => { setFotoCierre(null); setSelfieTaken(false); }}
                      className="absolute top-2 right-2 w-8 h-8 rounded-full bg-black/70 text-white flex items-center justify-center">
                      <X size={14} />
                    </button>
                  </div>
                ) : (
                  // Dos caminos separados: con `capture` el teléfono
                  // abre la cámara y no ofrece la galería. Decir "o
                  // elegir de tu galería" en un botón que no lo hacía
                  // era peor que no ofrecerlo.
                  <div className="grid grid-cols-2 gap-2 mb-4">
                    <label className="flex flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-neutral-600 hover:border-sky-400/40 py-7 transition-colors cursor-pointer">
                      <input type="file" accept="image/*" capture="user" className="hidden"
                        onChange={(e) => {
                          const f = e.target.files?.[0];
                          e.target.value = "";
                          if (!f) return;
                          const lector = new FileReader();
                          lector.onload = () => { setFotoCierre(lector.result); setSelfieTaken(true); };
                          lector.readAsDataURL(f);
                        }} />
                      <Camera size={22} className="text-neutral-500" />
                      <span className="text-[11px] font-medium text-neutral-400">Sacarte una foto</span>
                    </label>

                    <label className="flex flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-neutral-600 hover:border-sky-400/40 py-7 transition-colors cursor-pointer">
                      <input type="file" accept="image/*" className="hidden"
                        onChange={(e) => {
                          const f = e.target.files?.[0];
                          e.target.value = "";
                          if (!f) return;
                          const lector = new FileReader();
                          lector.onload = () => { setFotoCierre(lector.result); setSelfieTaken(true); };
                          lector.readAsDataURL(f);
                        }} />
                      <ImageIcon size={22} className="text-neutral-500" />
                      <span className="text-[11px] font-medium text-neutral-400">De la galería</span>
                    </label>
                  </div>
                )}

                <div className="text-left mb-4">
                  <p className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1">Mensaje al grupo (editable)</p>
                  <textarea value={shareMessage} onChange={(e) => setShareMessage(e.target.value)} rows={4}
                    className="w-full bg-neutral-700 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-lg p-3 text-xs text-sky-400 resize-none transition-colors" />
                </div>

                {!fotoCierre && (
                  <p className="text-[10px] text-yellow-400 mb-2 leading-relaxed">
                    Sin foto la sesión no suma al torneo. Podés compartir igual,
                    pero acordate de mandar la foto al grupo.
                  </p>
                )}

                <button onClick={sendToWhatsappGroup}
                  className={`w-full flex items-center justify-center gap-1.5 font-medium text-sm rounded-lg py-2.5 transition-colors ${selfieTaken ? "bg-sky-400 hover:bg-sky-200 text-black" : "bg-neutral-700 text-neutral-600 cursor-not-allowed"}`}>
                  <Send size={14} /> Abrir WhatsApp
                </button>
                <p className="text-neutral-600 text-[10px] mt-2">Vos elegís a qué chat o grupo compartirlo</p>
                <button onClick={() => setShareStep(false)} className="text-neutral-500 text-xs mt-3">Volver</button>
              </>
            )}
          </div>
        </div>
      )}

      {achievementPopup && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-40 p-4">
          <div className="relative bg-neutral-800 border border-neutral-600 rounded-2xl w-full max-w-sm p-6 text-center overflow-hidden">
            <ConfettiBurst />
            <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: `${achievementPopup.color}1A`, border: `1px solid ${achievementPopup.color}40` }}>
              <achievementPopup.icon size={26} style={{ color: achievementPopup.color }} />
            </div>
            <p className="font-display text-lg font-semibold">{achievementPopup.title}</p>
            <p className="text-sm text-neutral-400 mt-1">{achievementPopup.subtitle}</p>
            <button onClick={() => setAchievementPopup(null)} className="w-full mt-6 bg-sky-400 hover:bg-sky-200 text-black font-medium text-sm rounded-lg py-2.5 transition-colors">
              Cerrar
            </button>
          </div>
        </div>
      )}

      {prModalOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-30 p-4 modal-fondo">
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5">
            <div className="flex items-center justify-between mb-4">
              <p className="font-display font-semibold text-sm flex items-center gap-2"><Trophy size={15} className="text-amber-400" /> {personalRecords[prDraft.ejercicio] ? "Editar PR" : "Nuevo PR"}</p>
              <button onClick={() => setPrModalOpen(false)} className="text-neutral-500 hover:text-white"><X size={16} /></button>
            </div>
            <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">Ejercicio</label>
            <select value={prDraft.ejercicio} onChange={(e) => setPrDraft((p) => ({ ...p, ejercicio: e.target.value }))} disabled={!!personalRecords[prDraft.ejercicio]}
              className="w-full appearance-none bg-neutral-700 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-sm text-white mb-4 disabled:opacity-60">
              <option value="">Elegir ejercicio...</option>
              {exerciseGroups.map((g) => (
                <optgroup key={g.label} label={g.label}>
                  {g.items.map((o) => <option key={o} value={o}>{o}</option>)}
                </optgroup>
              ))}
            </select>
            <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1.5 block">Tipo de récord</label>
            <div className="flex bg-neutral-700 border border-neutral-600 rounded-lg p-1 mb-4">
              {[["peso", "Peso (kg)"], ["reps", "Repeticiones"]].map(([t, l]) => (
                <button key={t} onClick={() => setPrDraft((p) => ({ ...p, tipo: t }))}
                  className={`flex-1 py-1.5 rounded-md text-xs font-medium transition-colors ${prDraft.tipo === t ? "bg-sky-400 text-black" : "text-neutral-400"}`}>{l}</button>
              ))}
            </div>
            <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">{prDraft.tipo === "peso" ? "Peso (kg)" : "Repeticiones"}</label>
            <input type="number" value={prDraft.valor} onChange={(e) => setPrDraft((p) => ({ ...p, valor: e.target.value }))}
              className="w-full bg-neutral-700 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-sm mb-5" />
            <div className="flex gap-2">
              {personalRecords[prDraft.ejercicio] && (
                <button onClick={deletePR} className="py-2.5 px-3 rounded-lg text-xs font-medium text-red-400 border border-red-400/30 hover:bg-red-400/10 transition-colors">Eliminar</button>
              )}
              <button onClick={() => setPrModalOpen(false)} className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">Cancelar</button>
              <button onClick={savePR} className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">Guardar</button>
            </div>
          </div>
        </div>
      )}

      {newExerciseModalOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-30 p-4 modal-fondo">
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5">
            <div className="flex items-center justify-between mb-4">
              <p className="font-display font-semibold text-sm flex items-center gap-2"><Dumbbell size={15} className="text-sky-400" /> {newExerciseDraft.editando ? "Editar ejercicio" : "Crear ejercicio"}</p>
              <button onClick={() => setNewExerciseModalOpen(false)} className="text-neutral-500 hover:text-white"><X size={16} /></button>
            </div>
            <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">Nombre del ejercicio</label>
            <input value={newExerciseDraft.name} onChange={(e) => setNewExerciseDraft((p) => ({ ...p, name: e.target.value }))} placeholder="Ej: Press Arnold"
              className="w-full bg-neutral-700 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-sm mb-4" />
            <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">Categoría</label>
            {newExerciseDraft.categoriaNueva ? (
              <div className="mb-4 space-y-2">
                <div className="flex gap-2 items-center">
                  {/* El color se elige acá: sin esto las categorías
                      nuevas quedaban todas grises y no se distinguían
                      entre sí en la lista de ejercicios. */}
                  <span className="w-9 h-9 rounded-full shrink-0 border-2 border-neutral-600"
                    style={{ background: newExerciseDraft.color || PALETA_CATEGORIAS[0] }} />
                  <input value={newExerciseDraft.category} autoFocus
                    onChange={(e) => setNewExerciseDraft((p) => ({ ...p, category: e.target.value }))}
                    placeholder="Ej: Zona media, Pliometría..."
                    className="flex-1 min-w-0 bg-neutral-700 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-sm" />
                  <button onClick={() => setNewExerciseDraft((p) => ({ ...p, categoriaNueva: false, category: "" }))}
                    title="Volver a elegir una existente"
                    className="px-3 py-2 rounded-lg border border-neutral-600 text-neutral-400 hover:text-white transition-colors shrink-0">
                    <X size={14} />
                  </button>
                </div>

                <div className="flex flex-wrap gap-2">
                  {PALETA_CATEGORIAS.map((c) => (
                    <button key={c} onClick={() => setNewExerciseDraft((p) => ({ ...p, color: c }))}
                      title="Elegir este color"
                      className="w-7 h-7 rounded-full transition-transform"
                      style={{
                        background: c,
                        outline: (newExerciseDraft.color || PALETA_CATEGORIAS[0]) === c
                          ? "2px solid #fafafa" : "none",
                        outlineOffset: 2,
                      }} />
                  ))}
                </div>

                <p className="text-[10px] text-neutral-600">
                  Se crea al guardar el ejercicio y queda disponible para los próximos.
                </p>
              </div>
            ) : (
              <div className="mb-4 space-y-2">
                <select value={newExerciseDraft.category}
                  onChange={(e) => setNewExerciseDraft((p) => ({ ...p, category: e.target.value }))}
                  className="w-full appearance-none bg-neutral-700 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-base text-white">
                  <option value="">Elegir categoría...</option>
                  {exerciseGroups.map((g) => <option key={g.label} value={g.label}>{g.label}</option>)}
                </select>
                <button onClick={() => setNewExerciseDraft((p) => ({ ...p, categoriaNueva: true, category: "", color: p.color || PALETA_CATEGORIAS[0] }))}
                  className="w-full flex items-center justify-center gap-1.5 text-[11px] font-medium text-sky-400 border border-dashed border-sky-400/40 hover:bg-sky-400/10 rounded-lg py-2 transition-colors">
                  <Plus size={12} /> Crear categoría nueva
                </button>
              </div>
            )}
            <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">Video de técnica (opcional)</label>
            <input value={newExerciseDraft.videoUrl} onChange={(e) => setNewExerciseDraft((p) => ({ ...p, videoUrl: e.target.value }))}
              placeholder="https://youtu.be/..." inputMode="url"
              className={`w-full bg-neutral-700 border focus:outline-none rounded-lg px-3 py-2 text-sm mb-1 ${esUrlValida(newExerciseDraft.videoUrl) ? "border-neutral-600 focus:border-sky-400" : "border-red-400/60"}`} />
            <p className="text-[10px] text-neutral-600 mb-4">Pegá el link de YouTube, Drive o donde lo tengas subido.</p>

            <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">Gif del movimiento (opcional)</label>
            <input value={newExerciseDraft.gifUrl} onChange={(e) => setNewExerciseDraft((p) => ({ ...p, gifUrl: e.target.value }))}
              placeholder="https://.../ejercicio.gif" inputMode="url"
              className={`w-full bg-neutral-700 border focus:outline-none rounded-lg px-3 py-2 text-sm mb-2 ${esUrlValida(newExerciseDraft.gifUrl) ? "border-neutral-600 focus:border-sky-400" : "border-red-400/60"}`} />
            {newExerciseDraft.gifUrl.trim() && esUrlValida(newExerciseDraft.gifUrl) && (
              <img src={newExerciseDraft.gifUrl.trim()} alt="Vista previa"
                className="w-full h-36 rounded-lg object-cover border border-neutral-600 mb-2"
                onError={(e) => { e.currentTarget.style.display = "none"; }} />
            )}
            <details className="mb-3">
              <summary className="text-[10px] text-neutral-500 cursor-pointer hover:text-sky-400">
                ¿De dónde saco el link del gif?
              </summary>
              <div className="text-[10px] text-neutral-500 leading-relaxed mt-2 space-y-1.5 bg-neutral-900 rounded-lg p-2.5">
                <p>El link tiene que terminar en <b className="text-neutral-300">.gif</b> y apuntar
                   a la imagen, no a una página web.</p>
                <p><b className="text-neutral-300">Imgur:</b> subilo en imgur.com, botón derecho sobre
                   el gif → “Copiar dirección de imagen”.</p>
                <p><b className="text-neutral-300">Giphy:</b> abrí el gif, tocá “Media” y copiá el
                   link que dice “GIF”.</p>
                <p className="text-neutral-600">Google Drive no sirve: devuelve una página, no el
                   archivo.</p>
              </div>
            </details>

            {(!esUrlValida(newExerciseDraft.videoUrl) || !esUrlValida(newExerciseDraft.gifUrl)) && (
              <p className="text-[11px] text-red-400 mb-2">Las direcciones tienen que empezar con https://</p>
            )}
            <div className="h-3" />

            <div className="flex gap-2">
              <button onClick={() => setNewExerciseModalOpen(false)} className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">Cancelar</button>
              <button onClick={createExercise} className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">{newExerciseDraft.editando ? "Guardar cambios" : "Crear ejercicio"}</button>
            </div>
          </div>
        </div>
      )}

      {folderModalOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-30 p-4 modal-fondo">
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5">
            <div className="flex items-center justify-between mb-4">
              <p className="font-display font-semibold text-sm flex items-center gap-2"><FolderPlus size={15} className="text-sky-400" /> Nueva carpeta</p>
              <button onClick={() => setFolderModalOpen(false)} className="text-neutral-500 hover:text-white"><X size={16} /></button>
            </div>
            <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">Nombre de la carpeta</label>
            <input value={newFolderName} onChange={(e) => setNewFolderName(e.target.value)} placeholder="Ej: Movilidad"
              className="w-full bg-neutral-700 border border-sky-400/30 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-sm mb-4" />
            <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1.5 block">Métrica de esfuerzo</label>
            <div className="flex bg-neutral-700 border border-neutral-600 rounded-lg p-1 mb-5">
              {[["RIR", "RIR (fuerza)"], ["RPE", "RPE (cardio/interval)"]].map(([m, l]) => (
                <button key={m} onClick={() => setNewFolderMetric(m)} className={`flex-1 py-1.5 rounded-md text-xs font-medium transition-colors ${newFolderMetric === m ? "bg-sky-400 text-black" : "text-neutral-400"}`}>{l}</button>
              ))}
            </div>
            <div className="flex gap-2">
              <button onClick={() => setFolderModalOpen(false)} className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">Cancelar</button>
              <button onClick={createFolder} className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">Crear carpeta</button>
            </div>
          </div>
        </div>
      )}

      {addSessionChoiceOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-30 p-4 modal-fondo">
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5">
            <div className="flex items-center justify-between mb-4">
              <p className="font-display font-semibold text-sm">Agregar sesión</p>
              <button onClick={() => setAddSessionChoiceOpen(false)} className="text-neutral-500 hover:text-white"><X size={16} /></button>
            </div>
            <div className="flex flex-col gap-2.5">
              <button onClick={() => { setAddSessionChoiceOpen(false); openNewSessionForm(); }}
                className="w-full flex items-center gap-3 bg-neutral-700/50 hover:bg-neutral-700 border border-neutral-600 rounded-xl p-4 transition-colors text-left">
                <div className="w-9 h-9 rounded-full bg-sky-400/10 border border-sky-400/30 flex items-center justify-center shrink-0"><Plus size={16} className="text-sky-400" /></div>
                <div>
                  <p className="text-sm font-medium">Crear sesión</p>
                  <p className="text-[11px] text-neutral-500">Armarla ejercicio por ejercicio desde cero</p>
                </div>
              </button>
              <button onClick={() => { setAddSessionChoiceOpen(false); setLibraryPickerOpen(true); }}
                className="w-full flex items-center gap-3 bg-neutral-700/50 hover:bg-neutral-700 border border-neutral-600 rounded-xl p-4 transition-colors text-left">
                <div className="w-9 h-9 rounded-full bg-sky-400/10 border border-sky-400/30 flex items-center justify-center shrink-0"><Library size={16} className="text-sky-400" /></div>
                <div>
                  <p className="text-sm font-medium">Agregar desde la librería</p>
                  <p className="text-[11px] text-neutral-500">Usar una sesión ya armada y asignarla acá</p>
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {libraryPickerOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-30 p-4 modal-fondo">
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 max-h-[80vh] flex flex-col">
            <div className="flex items-center justify-between mb-4">
              <p className="font-display font-semibold text-sm">Agregar desde la librería</p>
              <button onClick={() => setLibraryPickerOpen(false)} className="text-neutral-500 hover:text-white"><X size={16} /></button>
            </div>
            <div className="overflow-y-auto space-y-3 -mx-1 px-1">
              {libraryCategories.filter((cat) => cat.templates.length > 0).map((cat) => {
                const Icon = cat.icon || iconoCategoria(cat.name);
                return (
                  <div key={cat.id}>
                    <p className="text-[11px] uppercase tracking-wider text-neutral-500 flex items-center gap-1.5 mb-1.5"><Icon size={12} className="text-sky-400" /> {cat.name}</p>
                    <div className="space-y-1.5">
                      {cat.templates.map((tpl) => (
                        <button key={tpl.id} onClick={() => addTemplateToCurrentWeek(tpl)}
                          className="w-full flex items-center justify-between bg-neutral-700/40 hover:bg-neutral-700 rounded-lg px-3 py-2.5 transition-colors text-left">
                          <div className="min-w-0">
                            <p className="text-xs text-neutral-200 truncate">{tpl.name}</p>
                            <p className="text-[10px] text-neutral-500">{tpl.exercises.length} ejercicios</p>
                          </div>
                          <Plus size={14} className="text-sky-400 shrink-0" />
                        </button>
                      ))}
                    </div>
                  </div>
                );
              })}
              {libraryCategories.every((cat) => cat.templates.length === 0) && (
                <p className="text-neutral-600 text-xs text-center py-8">Todavía no hay sesiones en la librería.</p>
              )}
            </div>
          </div>
        </div>
      )}

      {assignModal && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-30 p-4 modal-fondo">
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 max-h-[80vh] flex flex-col">
            <div className="flex items-center justify-between mb-1">
              <p className="font-display font-semibold text-sm">Asignar "{assignModal.name}"</p>
              <button onClick={() => { setAssignModal(null); setAQuienes([]); setBuscarAlumno(""); }}
                className="text-neutral-500 hover:text-white"><X size={16} /></button>
            </div>
            <p className="text-xs text-neutral-500 mb-3">
              Elegí a quiénes se la asignás. Podés marcar varios.
            </p>

            {/* Buscador: con veinte alumnos, encontrar a uno bajando
                por la lista es más lento que escribir su nombre. */}
            <div className="relative mb-2">
              <Search size={14} className="absolute left-3 top-2.5 text-neutral-500 pointer-events-none" />
              <input value={buscarAlumno} onChange={(e) => setBuscarAlumno(e.target.value)}
                placeholder="Buscar un Be Trainer..."
                className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg pl-9 pr-8 py-2 text-base text-white placeholder-neutral-500" />
              {buscarAlumno && (
                <button onClick={() => setBuscarAlumno("")}
                  className="absolute right-2.5 top-2.5 text-neutral-500 hover:text-white">
                  <X size={14} />
                </button>
              )}
            </div>

            {(() => {
              const visibles = buscarAlumno.trim()
                ? studentsList.filter((s) => coincide(s.name, buscarAlumno))
                : studentsList;
              const todosMarcados = visibles.length > 0
                && visibles.every((s) => aQuienes.includes(s.id));
              return (
                <>
                  <div className="flex items-center gap-2 mb-2 px-1">
                    <button onClick={() => setAQuienes((prev) => todosMarcados
                      ? prev.filter((id) => !visibles.some((s) => s.id === id))
                      : [...new Set([...prev, ...visibles.map((s) => s.id)])])}
                      className="text-[11px] text-sky-400 hover:underline">
                      {todosMarcados ? "Desmarcar todos" : "Marcar todos"}
                      {buscarAlumno.trim() && ` (${visibles.length})`}
                    </button>
                    <span className="text-[11px] text-neutral-600 flex-1 text-right">
                      {aQuienes.length > 0 && `${aQuienes.length} elegido${aQuienes.length === 1 ? "" : "s"}`}
                    </span>
                  </div>

                  <div className="overflow-y-auto space-y-1.5 -mx-1 px-1 flex-1">
                    {visibles.length === 0 && (
                      <p className="text-xs text-neutral-600 text-center py-4">
                        Ningún Be Trainer con ese nombre.
                      </p>
                    )}
                    {visibles.map((s) => {
                      const marcado = aQuienes.includes(s.id);
                      return (
                        <button key={s.id}
                          onClick={() => setAQuienes((prev) => marcado
                            ? prev.filter((id) => id !== s.id) : [...prev, s.id])}
                          className={`w-full flex items-center gap-2.5 rounded-lg p-2.5 transition-colors text-left border ${
                            marcado ? "bg-sky-400/15 border-sky-400/40"
                                     : "bg-neutral-700/40 border-transparent hover:bg-neutral-700"}`}>
                          <span className={`w-4 h-4 rounded border flex items-center justify-center shrink-0 ${
                            marcado ? "bg-sky-400 border-sky-400" : "border-neutral-500"}`}>
                            {marcado && <Check size={11} className="text-black" strokeWidth={3} />}
                          </span>
                          <Avatar student={s} size={28} />
                          <p className="text-sm text-neutral-200 flex-1 min-w-0 truncate">{s.name}</p>
                        </button>
                      );
                    })}
                  </div>
                </>
              );
            })()}

            <button onClick={() => asignarAVarios(assignModal)}
              disabled={!aQuienes.length || asignando}
              className="w-full mt-3 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 disabled:opacity-40 transition-colors shrink-0">
              {asignando ? "Asignando..."
                : aQuienes.length === 0 ? "Elegí a quién asignársela"
                : aQuienes.length === 1 ? "Asignar a 1 Be Trainer"
                : `Asignar a ${aQuienes.length} Be Trainers`}
            </button>
          </div>
        </div>
      )}

      {newTrainerModalOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-30 p-4 modal-fondo">
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5">
            <div className="flex items-center justify-between mb-1">
              <p className="font-display font-semibold text-sm flex items-center gap-2">
                <Users size={15} className="text-sky-400" /> Invitar un Be Trainer
              </p>
              <button onClick={() => setNewTrainerModalOpen(false)} className="text-neutral-500 hover:text-white">
                <X size={16} />
              </button>
            </div>
            <p className="text-[11px] text-neutral-500 mb-4">
              Le llega un mail para que ponga su contraseña. No necesita el código.
            </p>

            <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">Nombre</label>
            <input value={newTrainerDraft.nombre}
              onChange={(e) => setNewTrainerDraft((p) => ({ ...p, nombre: e.target.value }))}
              placeholder="Ej: Martina" autoComplete="given-name"
              className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-sm mb-3" />

            <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">Apellido</label>
            <input value={newTrainerDraft.apellido}
              onChange={(e) => setNewTrainerDraft((p) => ({ ...p, apellido: e.target.value }))}
              placeholder="Ej: Gómez" autoComplete="family-name"
              className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-sm mb-3" />

            {hayBackend && (
              <>
                <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">Mail</label>
                <input value={newTrainerDraft.email || ""} type="email" inputMode="email"
                  onChange={(e) => setNewTrainerDraft((p) => ({ ...p, email: e.target.value }))}
                  placeholder="martina@gmail.com" autoComplete="off"
                  className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-sm mb-4" />
              </>
            )}

            <div className="flex gap-2">
              <button onClick={() => setNewTrainerModalOpen(false)}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-300 border border-neutral-600 hover:border-neutral-500 transition-colors">
                Cancelar
              </button>
              <button onClick={createTrainer} disabled={sincro.guardando}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 disabled:opacity-50 transition-colors">
                {sincro.guardando ? "Enviando..." : hayBackend ? "Enviar invitación" : "Agregar"}
              </button>
            </div>
          </div>
        </div>
      )}

      {weekActionChoiceOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-30 p-4 modal-fondo">
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5">
            <div className="flex items-center justify-between mb-4">
              <p className="font-display font-semibold text-sm">Nueva semana</p>
              <button onClick={() => setWeekActionChoiceOpen(null)} className="text-neutral-500 hover:text-white"><X size={16} /></button>
            </div>
            <div className="flex flex-col gap-2.5">
              <button onClick={() => { const w = weekActionChoiceOpen; setWeekActionChoiceOpen(null); openDuplicateModal(w); }}
                className="w-full flex items-center gap-3 bg-neutral-700/50 hover:bg-neutral-700 border border-neutral-600 rounded-xl p-4 transition-colors text-left">
                <div className="w-9 h-9 rounded-full bg-sky-400/10 border border-sky-400/30 flex items-center justify-center shrink-0"><Copy size={16} className="text-sky-400" /></div>
                <div>
                  <p className="text-sm font-medium">Duplicar esta semana</p>
                  <p className="text-[11px] text-neutral-500">Clona ejercicio, con qué, series, reps y consigna de "{weekActionChoiceOpen.name}"</p>
                </div>
              </button>
              <button onClick={() => { setWeekActionChoiceOpen(null); setEmptyWeekModalOpen(true); }}
                className="w-full flex items-center gap-3 bg-neutral-700/50 hover:bg-neutral-700 border border-neutral-600 rounded-xl p-4 transition-colors text-left">
                <div className="w-9 h-9 rounded-full bg-sky-400/10 border border-sky-400/30 flex items-center justify-center shrink-0"><Plus size={16} className="text-sky-400" /></div>
                <div>
                  <p className="text-sm font-medium">Crear semana nueva</p>
                  <p className="text-[11px] text-neutral-500">Arranca sin sesiones — las agregás vos después</p>
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {emptyWeekModalOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-30 p-4 modal-fondo">
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5">
            <div className="flex items-center justify-between mb-4">
              <p className="font-display font-semibold text-sm flex items-center gap-2"><Plus size={15} className="text-sky-400" /> Crear semana nueva</p>
              <button onClick={() => setEmptyWeekModalOpen(false)} className="text-neutral-500 hover:text-white"><X size={16} /></button>
            </div>
            <CamposSemana nombre={nuevaSemana.nombre} periodo={nuevaSemana.periodo}
              onNombre={(v) => setNuevaSemana((p) => ({ ...p, nombre: v }))}
              onPeriodo={(v) => setNuevaSemana((p) => ({ ...p, periodo: v }))}
              mesesUsados={mesesUsados} />
            <div className="mt-4">
              <SelectorVisible value={nuevaSemana.visibleDesde}
                onChange={(v) => setNuevaSemana((p) => ({ ...p, visibleDesde: v }))} />
            </div>
            <p className="text-[11px] text-neutral-500 my-4">Arranca sin sesiones. Una vez creada, vas a poder tocar "Agregar sesión" para crearlas desde cero o traerlas de la librería.</p>
            <div className="flex gap-2">
              <button onClick={() => setEmptyWeekModalOpen(false)} className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">Cancelar</button>
              <button onClick={createEmptyWeek} className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">Crear semana</button>
            </div>
          </div>
        </div>
      )}

      {duplicateModal && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-30 p-4 modal-fondo">
          <div className="bg-neutral-800 border border-neutral-600 rounded-2xl w-full max-w-sm p-5">
            <div className="flex items-center justify-between mb-4">
              <p className="font-display font-semibold text-sm flex items-center gap-2"><Copy size={15} className="text-sky-400" /> Crear nueva semana de entrenamiento</p>
              <button onClick={() => setDuplicateModal(null)} className="text-neutral-500 hover:text-white"><X size={16} /></button>
            </div>
            <p className="text-xs text-neutral-500 mb-3">
              Se clonan ejercicio, con qué, series, reps y RIR consigna de las {duplicateModal.sessions.length} sesiones.
              El RIR del alumno queda vacío para completar (el peso lo asignás vos), con el dato de la semana previa como referencia debajo. Estado inicial: Pendiente.
            </p>
            <CamposSemana nombre={nuevaSemana.nombre} periodo={nuevaSemana.periodo}
              onNombre={(v) => setNuevaSemana((p) => ({ ...p, nombre: v }))}
              onPeriodo={(v) => setNuevaSemana((p) => ({ ...p, periodo: v }))}
              mesesUsados={mesesUsados} />
            <div className="mt-4">
              <SelectorVisible value={nuevaSemana.visibleDesde}
                onChange={(v) => setNuevaSemana((p) => ({ ...p, visibleDesde: v }))} />
            </div>
            <div className="mb-4" />
            <div className="flex gap-2">
              <button onClick={() => setDuplicateModal(null)} className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">Cancelar</button>
              <button onClick={confirmDuplicate} className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">Crear semana</button>
            </div>
          </div>
        </div>
      )}

      {viendoComo && (
        <div className="fixed top-0 left-0 right-0 z-50 bg-amber-400 text-black">
          <div className="max-w-2xl mx-auto flex items-center gap-2 px-4 py-2">
            <Eye size={14} className="shrink-0" />
            <span className="text-xs font-medium flex-1 truncate">
              Viendo como {viendoComo.name}
            </span>
            <button onClick={volverACoach}
              className="text-xs font-semibold underline shrink-0">
              Volver a coach
            </button>
          </div>
        </div>
      )}

      {/* Barra de selección: aparece al tildar ejercicios. */}
      {seleccionados.length > 0 && view === "libreria" && (
        <div className="fixed left-0 right-0 z-40 px-4"
          style={{ bottom: "calc(80px + env(safe-area-inset-bottom))" }}>
          <div className="max-w-2xl mx-auto bg-sky-400 text-black rounded-xl shadow-lg flex items-center gap-2 px-3 py-2.5">
            <span className="text-xs font-semibold flex-1">
              {seleccionados.length} {seleccionados.length === 1 ? "ejercicio" : "ejercicios"} seleccionados
            </span>
            <button onClick={() => setSeleccionados([])}
              className="text-xs font-medium px-2.5 py-1.5 rounded-lg border border-black/20 hover:bg-black/10 transition-colors">
              Limpiar
            </button>
            <button onClick={crearSesionDesdeSeleccion}
              className="text-xs font-bold px-3 py-1.5 rounded-lg bg-black text-sky-300 hover:bg-neutral-900 transition-colors">
              Crear sesión
            </button>
          </div>
        </div>
      )}

      <FichaEjercicio
        nombre={fichaEjercicio?.nombre}
        categoria={fichaEjercicio?.categoria}
        media={exerciseMedia[fichaEjercicio?.nombre]}
        onEditar={() => { const n = fichaEjercicio.nombre; setFichaEjercicio(null); abrirEdicionEjercicio(n); }}
        onCerrar={() => setFichaEjercicio(null)} />

      <VistaPreviaPlantilla plantilla={previa} medios={exerciseMedia}
        onCerrar={() => setPrevia(null)} />

      {/* Igual que el otro: fuera de todo contenedor. */}
      {dragTemplate && ReactDOM.createPortal(
        <div className="fixed z-[60] pointer-events-none flex items-center gap-1.5 text-xs font-medium bg-sky-400 text-black rounded-full pl-3 pr-3.5 py-2 shadow-lg"
          style={{ left: dragTemplatePos.x - agarreTpl.current.x, top: dragTemplatePos.y - agarreTpl.current.y }}>
                <GripVertical size={12} /> {libraryCategories.flatMap((c) => c.templates).find((t) => t.id === dragTemplate.id)?.name}
              </div>,
        document.body
      )}

      {/* El fantasma del arrastre va acá, fuera de todo contenedor.
          Adentro quedaba desplazado: el zoom del tamaño de texto y la
          animación de entrada crean sistemas de coordenadas propios, y
          un elemento "fijo" adentro deja de ser fijo respecto de la
          pantalla. Compensar esas transformaciones a mano es frágil;
          sacarlo afuera lo resuelve de raíz. */}
      {dragSessionId && (() => {
        const enCurso = semanaActual?.sessions.find((s) => s.id === dragSessionId);
        return ReactDOM.createPortal(
          <div className="fixed z-[60] pointer-events-none flex items-center gap-1.5 text-xs font-medium bg-sky-400 text-black rounded-full pl-3 pr-3.5 py-2 shadow-lg"
            style={{ left: dragPos.x - agarre.current.x, top: dragPos.y - agarre.current.y }}>
            <Dumbbell size={12} /> {enCurso?.name || "Entrenamiento"}
          </div>,
          document.body
        );
      })()}

      {/* Corregir el nombre o el mes de una semana. */}
      {editandoSemana && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => setEditandoSemana(null)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 space-y-3"
            onClick={(e) => e.stopPropagation()}>
            <p className="font-display font-semibold text-base">Editar la semana</p>

            <div>
              <span className="text-[10px] uppercase tracking-wider text-neutral-500">Nombre</span>
              <input autoFocus value={editandoSemana.name}
                onChange={(e) => setEditandoSemana((p) => ({ ...p, name: e.target.value }))}
                placeholder="Semana 3"
                className="w-full mt-1 bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-base" />
            </div>

            <div>
              <span className="text-[10px] uppercase tracking-wider text-neutral-500">Mes</span>
              <input value={editandoSemana.period}
                onChange={(e) => setEditandoSemana((p) => ({ ...p, period: e.target.value }))}
                placeholder="AGOSTO 2026"
                className="w-full mt-1 bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-base" />
              <p className="text-[10px] text-neutral-600 mt-1">
                El mes agrupa las semanas en la lista. Escribilo igual que en las otras
                para que queden juntas.
              </p>
            </div>

            {/* Los meses que ya existen: tocarlos evita escribirlos mal
                y que la semana termine en un grupo aparte. */}
            {(() => {
              const meses = [...new Set(weeks.map((w) => w.period).filter(Boolean))];
              if (meses.length === 0) return null;
              return (
                <div className="flex flex-wrap gap-1.5">
                  {meses.map((m) => (
                    <button key={m} onClick={() => setEditandoSemana((p) => ({ ...p, period: m }))}
                      className={`text-[10px] rounded-full px-2.5 py-1 border transition-colors ${
                        editandoSemana.period === m
                          ? "bg-sky-400 text-black border-sky-400"
                          : "text-neutral-400 border-neutral-600 hover:border-sky-400/40"}`}>
                      {m}
                    </button>
                  ))}
                </div>
              );
            })()}

            <div className="flex gap-2 pt-1">
              <button onClick={() => setEditandoSemana(null)}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-300 border border-neutral-600 hover:border-neutral-500 transition-colors">
                Cancelar
              </button>
              <button onClick={guardarNombreSemana}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Estado del guardado mientras el coach corrige una sesión.
          Los cambios se guardan solos, pero eso no se ve: sin una
          señal, uno cierra la pantalla sin saber si quedó. */}
      {isCoach && (cambiosPendientes > 0 || sincro.guardando
        || guardadoReciente > 0) && (
        <div className="fixed left-0 right-0 z-30 px-4 pointer-events-none"
          style={{ bottom: "calc(96px + env(safe-area-inset-bottom))" }}>
          <div className="max-w-md mx-auto flex items-center gap-2 bg-neutral-800 border border-neutral-700 rounded-xl shadow-lg shadow-black/40 px-3 py-2 pointer-events-auto">
            {sincro.guardando ? (
              <>
                <RefreshCw size={13} className="text-sky-400 shrink-0 animate-spin" />
                <span className="text-[11px] text-neutral-300 flex-1">Guardando...</span>
              </>
            ) : cambiosPendientes > 0 ? (
              <>
                <Pencil size={13} className="text-yellow-400 shrink-0" />
                <span className="text-[11px] text-neutral-300 flex-1">
                  {cambiosPendientes === 1 ? "1 cambio sin guardar" : `${cambiosPendientes} cambios sin guardar`}
                </span>
                {/* Cancelar descarta lo pendiente y recarga desde la
                    base: sin esto, un cambio hecho por error quedaba
                    guardado igual a los 700ms. */}
                <button onClick={descartarCambios}
                  className="text-[11px] font-medium text-neutral-400 border border-neutral-600 hover:border-neutral-500 rounded-lg px-2.5 py-1.5 transition-colors shrink-0">
                  Cancelar
                </button>
                <button onClick={guardarCambiosYa}
                  className="text-[11px] font-medium bg-sky-400 text-black hover:bg-sky-200 rounded-lg px-3 py-1.5 transition-colors shrink-0">
                  Guardar
                </button>
              </>
            ) : (
              <>
                <Check size={13} className="text-emerald-400 shrink-0" />
                <span className="text-[11px] text-emerald-400 flex-1">Cambios guardados</span>
              </>
            )}
          </div>
        </div>
      )}

      {/* Borrador del asistente. Sale como texto editable: lo que
          escribe no llega a nadie hasta que Matías lo aprueba. */}
      {asistente && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => !asistente.cargando && setAsistente(null)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-lg max-h-[85vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}>

            <div className="flex items-center gap-2 px-4 py-3 border-b border-neutral-700 shrink-0">
              <Sparkles size={14} className="text-sky-400 shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="font-display font-semibold text-sm truncate">{asistente.titulo}</p>
                <p className="text-[10px] text-neutral-500">Borrador · revisalo antes de usarlo</p>
              </div>
              {!asistente.cargando && (
                <button onClick={() => setAsistente(null)}
                  className="p-1 text-neutral-500 hover:text-white transition-colors shrink-0">
                  <X size={15} />
                </button>
              )}
            </div>

            <div className="flex-1 overflow-y-auto p-4">
              {asistente.cargando ? (
                <div className="py-10 text-center space-y-2">
                  <RefreshCw size={20} className="text-sky-400 mx-auto animate-spin" />
                  <p className="text-xs text-neutral-500">Leyendo el registro...</p>
                </div>
              ) : asistente.error ? (
                <div className="py-6 text-center space-y-3">
                  <p className="text-xs text-red-400">{asistente.error}</p>
                  <button onClick={() => setAsistente(null)}
                    className="text-[11px] text-neutral-400 hover:text-white transition-colors">
                    Cerrar
                  </button>
                </div>
              ) : (
                <textarea value={asistente.texto}
                  onChange={(e) => setAsistente((p) => ({ ...p, texto: e.target.value }))}
                  rows={14}
                  className="w-full bg-neutral-900 border border-neutral-700 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-sm leading-relaxed resize-y" />
              )}
            </div>

            {!asistente.cargando && !asistente.error && (
              <div className="px-4 py-3 border-t border-neutral-700 shrink-0 space-y-2">
                <div className="flex gap-2">
                  <button onClick={() => setAsistente(null)}
                    className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-300 border border-neutral-600 hover:border-neutral-500 transition-colors">
                    Descartar
                  </button>

                  {/* La devolución se puede pegar directo en la
                      observación del ejercicio; el resto se copia. */}
                  <button onClick={() => {
                      navigator.clipboard?.writeText(asistente.texto);
                      showToast("✓ Copiado — pegalo donde lo necesites");
                      setAsistente(null);
                    }}
                    className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                    Copiar
                  </button>
                </div>
                <p className="text-[10px] text-neutral-600 leading-relaxed">
                  Lo escribió un modelo leyendo el registro del alumno. Revisá los
                  números y el criterio antes de mandarlo: la devolución es tuya.
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Bienvenida, una sola vez. Además de saludar, dice las dos
          cosas que nadie descubre solo: que hay que completar las
          sesiones semanales, y que sin la foto al grupo no hay punto. */}
      {bienvenida && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo">
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm overflow-hidden">

            <div className="px-5 pt-6 pb-4 text-center"
              style={{ background: "linear-gradient(180deg, #38bdf81A, transparent)" }}>
              <img src={prefs.tema === "claro" ? LOGO_CLARO : LOGO_URI} alt=""
                className="h-10 w-10 object-contain mx-auto mb-3" />
              <p className="font-display font-bold text-lg">
                Bienvenido, {perfilVista?.name?.split(" ")[0] || "Be Trainer"}
              </p>
              <p className="text-xs text-neutral-400 mt-1 leading-relaxed">
                Acá vas a tener tus entrenamientos, tu progreso y el torneo del grupo.
              </p>
            </div>

            <div className="px-5 pb-5 space-y-3">
              <div className="flex gap-3">
                <span className="w-7 h-7 rounded-full bg-sky-400/15 flex items-center justify-center shrink-0 mt-0.5">
                  <span className="font-display text-xs font-bold text-sky-400">1</span>
                </span>
                <div>
                  <p className="text-xs text-neutral-200">Completá tus datos</p>
                  <p className="text-[11px] text-neutral-500 leading-relaxed">
                    Sobre todo cuántas veces por semana podés entrenar: ese número
                    es tu 100% en el torneo.
                  </p>
                </div>
              </div>

              <div className="flex gap-3">
                <span className="w-7 h-7 rounded-full bg-sky-400/15 flex items-center justify-center shrink-0 mt-0.5">
                  <span className="font-display text-xs font-bold text-sky-400">2</span>
                </span>
                <div>
                  <p className="text-xs text-neutral-200">Entrená y cargá lo que hiciste</p>
                  <p className="text-[11px] text-neutral-500 leading-relaxed">
                    El peso y el RIR de cada ejercicio. Mati lo ve y te responde ahí mismo.
                  </p>
                </div>
              </div>

              <div className="flex gap-3">
                <span className="w-7 h-7 rounded-full flex items-center justify-center shrink-0 mt-0.5"
                  style={{ background: "#facc1522" }}>
                  <span className="font-display text-xs font-bold" style={{ color: "#facc15" }}>3</span>
                </span>
                <div>
                  <p className="text-xs text-neutral-200">Compartilo al grupo con una foto</p>
                  <p className="text-[11px] leading-relaxed" style={{ color: "#facc15" }}>
                    Sin la foto la sesión no suma al torneo. Es lo que hace que el
                    ranking sea parejo para todos.
                  </p>
                </div>
              </div>

              <button onClick={() => { setBienvenida(false); setView("perfil"); }}
                className="w-full bg-sky-400 hover:bg-sky-200 text-black font-medium text-sm rounded-lg py-2.5 transition-colors mt-1">
                Completar mis datos
              </button>
              <button onClick={() => setBienvenida(false)}
                className="w-full text-[11px] text-neutral-500 hover:text-neutral-300 transition-colors">
                Después lo hago
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Crear un bloque: se pide el nombre y se crea con su primer
          ejercicio. Un bloque vacío no tiene sentido y habría que
          acordarse de borrarlo. */}
      {/* La insignia en grande. Se toca y se gira: es el momento en
          que alguien la quiere mirar de verdad, no de reojo en una
          grilla de doce. */}
      {/* Falta el RIR en algunos ejercicios. Se avisa, no se bloquea:
          hay días en que alguien entrena y no anota, y dejarlo sin
          poder cerrar la sesión es peor que registrarla incompleta. */}
      {avisoRir && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => setAvisoRir(null)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 space-y-3.5"
            onClick={(e) => e.stopPropagation()}>

            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-full flex items-center justify-center shrink-0"
                style={{ background: `${ESTADO.aviso}1F` }}>
                <AlertTriangle size={17} style={{ color: ESTADO.aviso }} />
              </span>
              <p className="font-display font-semibold text-sm flex-1">
                {avisoRir.length === 1
                  ? "Te falta un RIR"
                  : `Te faltan ${avisoRir.length} RIR`}
              </p>
            </div>

            <div className="space-y-1 max-h-48 overflow-y-auto">
              {avisoRir.map((nombre, k) => (
                <div key={k} className="flex items-center gap-2 text-xs text-neutral-300 bg-neutral-700/40 rounded-lg px-3 py-2">
                  <span className="w-1.5 h-1.5 rounded-full shrink-0"
                    style={{ background: ESTADO.aviso }} />
                  <span>{nombre}</span>
                </div>
              ))}
            </div>

            <p className="text-[11px] text-neutral-400 leading-relaxed">
              Podés terminar igual, pero vas a sumar menos experiencia:
              el RIR es lo que le dice a Mati cómo te fue, y sin eso la
              sesión queda a medias.
            </p>

            <div className="space-y-2">
              <button onClick={() => setAvisoRir(null)}
                className="w-full py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                Volver a completarlos
              </button>
              <button onClick={() => { setAvisoRir(null); openCelebration(true); }}
                className="w-full py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600 hover:border-neutral-500 transition-colors">
                Terminar de todos modos
              </button>
            </div>
          </div>
        </div>
      )}

      {insigniaGrande && (
        <div className="fixed inset-0 bg-black/85 backdrop-blur-sm flex items-center justify-center z-50 p-6 modal-fondo"
          onClick={() => setInsigniaGrande(null)}>
          <div className="modal-caja w-full max-w-xs flex flex-col items-center text-center gap-4"
            onClick={(e) => e.stopPropagation()}>

            <InsigniaGirable src={insigniaGrande.imagen} color={insigniaGrande.color}
              inicial={insigniaGrande.name} tam={200} />

            <div>
              <p className="font-display font-bold text-lg"
                style={{ color: insigniaGrande.color }}>
                {insigniaGrande.name}
              </p>
              {insigniaGrande.desc && (
                <p className="text-xs text-neutral-400 mt-1 leading-relaxed">
                  {insigniaGrande.desc}
                </p>
              )}
            </div>

            <p className="text-[10px] text-neutral-600">Movela con el dedo</p>

            <div className="flex gap-2 w-full">
              <button onClick={() => setInsigniaGrande(null)}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
                Cerrar
              </button>
              {badgeStatus[insigniaGrande.id] === "approved" && (
                <button onClick={() => { compartirInsignia(insigniaGrande); setInsigniaGrande(null); }}
                  className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-emerald-500 text-black hover:bg-emerald-400 transition-colors">
                  Compartir
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* El ciclo: en qué fase está y qué suele implicar.
          El texto es deliberadamente prudente. La evidencia sobre
          periodizar el entrenamiento por fase del ciclo es limitada y
          desparejo entre estudios, así que esto se presenta como
          referencia para leer sus sensaciones —y su RIR—, no como una
          regla de carga. */}
      {verCiclo && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => setVerCiclo(null)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 space-y-3 max-h-[85vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}>
            <div className="flex items-start gap-2">
              <div className="flex-1 min-w-0">
                <p className="font-display font-semibold text-sm">
                  Día {verCiclo.dia} de {verCiclo.largo}
                </p>
                <p className="text-[11px] mt-0.5" style={{ color: "#f472b6" }}>
                  Fase {verCiclo.fase.toLowerCase()}
                </p>
              </div>
              <button onClick={() => setVerCiclo(null)}
                className="p-1 text-neutral-500 hover:text-white shrink-0">
                <X size={16} />
              </button>
            </div>

            {/* Las cuatro fases, con la de hoy marcada. */}
            <div className="flex gap-1">
              {[["Menstrual", 1, 5], ["Folicular", 6, 13],
                ["Ovulación", 14, 16], ["Lútea", 17, verCiclo.largo]].map(([n, d1, d2]) => {
                const esta = verCiclo.fase === n;
                return (
                  <div key={n} className="flex-1 text-center">
                    <div className="h-1.5 rounded-full"
                      style={{ background: esta ? "#f472b6" : "#404040" }} />
                    <p className="text-[8px] mt-1 truncate"
                      style={{ color: esta ? "#f472b6" : "#5f5f5f" }}>{n}</p>
                    <p className="text-[8px]" style={{ color: "#5f5f5f" }}>{d1}-{d2}</p>
                  </div>
                );
              })}
            </div>

            <div className="rounded-lg p-3" style={{ background: "#303030" }}>
              <p className="text-[12px] leading-relaxed" style={{ color: "#d4d4d4" }}>
                {{
                  Menstrual: "Estrógeno y progesterona en sus valores más bajos. Puede haber más fatiga o molestias los primeros días, pero muchas entrenan sin cambios. Si aparece dolor, conviene bajar la exigencia sin suspender.",
                  Folicular: "El estrógeno sube. Suele ser la etapa donde mejor se toleran las cargas altas y la fatiga se recupera más rápido. Buen momento para los trabajos más exigentes de la semana.",
                  Ovulación: "Pico de estrógeno. El rendimiento suele estar alto. Algunos estudios reportan mayor laxitud de los ligamentos en estos días, aunque la evidencia no es concluyente: no es para evitar cargas, sí para cuidar la técnica.",
                  Lútea: "La progesterona sube. Es común sentir el mismo peso más pesado, peor tolerancia al calor y más fatiga acumulada. Si el RIR sale más bajo de lo pedido con el mismo peso, suele ser esto.",
                }[verCiclo.fase]}
              </p>
            </div>

            <div className="rounded-lg p-3" style={{ background: "#26262680",
                   border: "1px solid #ffffff0a" }}>
              <p className="text-[11px] leading-relaxed" style={{ color: "#8a8a8a" }}>
                <b style={{ color: "#a3a3a3" }}>Tomalo como referencia, no como regla.</b>{" "}
                La evidencia sobre ajustar el entrenamiento por fase del ciclo
                todavía es limitada y varía mucho entre personas. Lo que
                mejor ordena la decisión sigue siendo lo que ella reporta:
                su RIR y lo que escribe en los comentarios.
              </p>
            </div>
          </div>
        </div>
      )}

      <VentanaNovedad novedad={novedadAbierta}
        onCerrar={() => setNovedadAbierta(null)}
        onIr={novedadAbierta?.destino ? () => {
          const d = novedadAbierta.destino;
          setNovedadAbierta(null);
          setIrA(d);
        } : null} />

      {/* A quién sumar como coach: sale de los alumnos ya registrados.
          No se puede crear un coach de la nada, porque la cuenta la
          crea la propia persona con su mail y su contraseña. */}
      {eligiendoCoach && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => setEligiendoCoach(false)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 space-y-3 max-h-[80vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}>
            <div>
              <p className="font-display font-semibold text-sm">Sumar un coach</p>
              <p className="text-[11px] text-neutral-500 mt-0.5">
                Va a poder ver y editar el plan de todos.
              </p>
            </div>

            <div className="flex-1 overflow-y-auto space-y-1 -mx-1 px-1">
              {studentsList.length === 0 && (
                <p className="text-[11px] text-neutral-600 text-center py-4">
                  No hay alumnos registrados todavía.
                </p>
              )}
              {studentsList.map((a) => (
                <button key={a.id}
                  onClick={() => setConfirmar({
                    titulo: `¿Sumar a ${a.name?.split(" ")[0]} como coach?`,
                    detalle: "Va a poder ver y editar el plan de todos los alumnos, " +
                             "y deja de aparecer en el ranking.",
                    accion: () => sumarCoach(a),
                  })}
                  className="w-full flex items-center gap-2.5 rounded-lg px-2.5 py-2 border border-neutral-600 hover:border-sky-400/40 transition-colors">
                  <Avatar student={a} size={26} />
                  <span className="flex-1 min-w-0 text-left text-xs truncate">{a.name}</span>
                  <ChevronRight size={13} className="text-neutral-600 shrink-0" />
                </button>
              ))}
            </div>

            <button onClick={() => setEligiendoCoach(false)}
              className="w-full py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* Cambiar el nombre de una sesión ya creada. */}
      {renombrando && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => setRenombrando(null)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 space-y-3"
            onClick={(e) => e.stopPropagation()}>
            <p className="font-display font-semibold text-sm">Nombre de la sesión</p>
            <input autoFocus value={renombrando.nombre}
              onChange={(e) => setRenombrando((p) => ({ ...p, nombre: e.target.value }))}
              onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
              className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-base" />
            <div className="flex gap-2 pt-1">
              <button onClick={() => setRenombrando(null)}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
                Cancelar
              </button>
              <button onClick={async () => {
                  const nombre = renombrando.nombre.trim();
                  if (!nombre) { showToast("Ponele un nombre"); return; }
                  const { semana, sesion } = renombrando;
                  setRenombrando(null);
                  setWeeks((prev) => prev.map((w) => w.id !== semana.id ? w : {
                    ...w,
                    sessions: w.sessions.map((x) =>
                      x.id === sesion.id ? { ...x, name: nombre } : x),
                  }));
                  await persistir(() => renombrarSesion(sesion.id, { nombre }),
                                  "No se pudo cambiar el nombre.");
                }}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Guardar una sesión de un alumno en tu librería: hay que
          elegir en qué carpeta va. */}
      {aGuardar && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => setAGuardar(null)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 space-y-3 max-h-[80vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}>
            <div>
              <p className="font-display font-semibold text-sm">Guardar en tu librería</p>
              <p className="text-[11px] text-neutral-500 mt-0.5 truncate">
                {aGuardar.sesion.name}
              </p>
            </div>

            <p className="text-[10px] uppercase tracking-wider" style={{ color: GRIS_ETIQUETA }}>
              ¿En qué carpeta?
            </p>
            <div className="flex-1 overflow-y-auto space-y-1 -mx-1 px-1">
              {libraryCategories.map((c) => (
                <button key={c.id}
                  onClick={() => setAGuardar((p) => ({ ...p, categoria: c.id }))}
                  className="w-full text-left rounded-lg px-3 py-2.5 border transition-colors"
                  style={aGuardar.categoria === c.id
                    ? { borderColor: "#38bdf8", background: "#38bdf814", color: "#38bdf8" }
                    : { borderColor: "#52525266", color: "#e2e8f0" }}>
                  <span className="text-xs">{c.name || c.nombre}</span>
                </button>
              ))}
            </div>

            <p className="text-[10px] text-neutral-600">
              Se guarda la prescripción, sin el peso ni el RIR que cargó el alumno.
            </p>

            <div className="flex gap-2">
              <button onClick={() => setAGuardar(null)}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
                Cancelar
              </button>
              <button onClick={async () => {
                  if (!aGuardar.categoria) { showToast("Elegí una carpeta"); return; }
                  const { sesion, categoria } = aGuardar;
                  setAGuardar(null);
                  const ok = await persistir(
                    () => crearPlantilla(categoria, {
                      name: sesion.name,
                      hasTimer: !!sesion.hasTimer,
                      timerConfig: sesion.timerConfig,
                      // Sin lo que cargó el alumno: el peso y el RIR
                      // son de él, no de la plantilla.
                      exercises: (sesion.exercises || [])
                        .filter((e) => e.ejercicio)
                        .map((e) => ({ ...e, id: undefined,
                          pesoUsado: "", rirTuyo: "", comentarios: "",
                          resultadoSeries: null, emomBloques: null, emomReps: null })),
                    }),
                    "No se pudo guardar en la librería.");
                  if (ok) { showToast(`✓ "${sesion.name}" guardada`); refrescarLibreria(); }
                }}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* La guía, a pantalla completa dentro de la app. Igual que los
          videos: se abre encima, se cierra, y volvés donde estabas. */}
      {verGuia && (
        <div className="fixed inset-0 z-50 flex flex-col bg-neutral-900">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-neutral-700 shrink-0">
            <img src={LOGO_URI} alt="" className="h-6 object-contain" />
            <span className="font-display font-semibold text-sm flex-1">
              Cómo usar la app
            </span>
            <button onClick={() => setVerGuia(false)}
              className="p-1.5 rounded-full hover:bg-neutral-700 text-neutral-400 hover:text-white transition-colors">
              <X size={18} />
            </button>
          </div>
          {/* La guía es una página aparte: así se actualiza sin tocar
              la app, y no arrastra su peso en cada carga. */}
          <iframe src="/guia.html" title="Guía de BE Training"
            className="flex-1 w-full border-0"
            style={{ background: "#171717" }} />
        </div>
      )}

      {/* La semana que viene, para varios. Dos pasos: a quiénes y
          cómo. Todo junto en una pantalla era un formulario largo
          en el celular. */}
      {semanaMasiva && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => setSemanaMasiva(null)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 space-y-3 max-h-[85vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}>

            {semanaMasiva.paso === "quienes" ? (
              <>
                <div>
                  <p className="font-display font-semibold text-sm">¿A quiénes?</p>
                  <p className="text-[11px] text-neutral-500 mt-0.5">
                    {semanaMasiva.elegidos.length === 0 ? "Ninguno elegido todavía"
                      : `${semanaMasiva.elegidos.length} de ${listaMasiva.length}`}
                  </p>
                </div>

                <button onClick={() => setSemanaMasiva((p) => ({
                    ...p,
                    elegidos: p.elegidos.length === listaMasiva.length
                      ? [] : listaMasiva.map((a) => a.id),
                  }))}
                  className="text-[11px] text-sky-400 text-left">
                  {semanaMasiva.elegidos.length === listaMasiva.length
                    ? "Desmarcar todos" : "Marcar todos"}
                </button>

                <div className="flex-1 overflow-y-auto space-y-0.5 -mx-1 px-1">
                  {listaMasiva.map((a) => {
                    const marcado = semanaMasiva.elegidos.includes(a.id);
                    return (
                      <button key={a.id}
                        onClick={() => setSemanaMasiva((p) => ({
                          ...p,
                          elegidos: marcado
                            ? p.elegidos.filter((x) => x !== a.id)
                            : [...p.elegidos, a.id],
                        }))}
                        className="w-full flex items-center gap-2.5 py-2 px-1 rounded-lg hover:bg-neutral-700/40 transition-colors text-left">
                        <span className="w-5 h-5 rounded flex items-center justify-center shrink-0"
                          style={{ border: `2px solid ${marcado ? "#38bdf8" : "#525252"}`,
                                   background: marcado ? "#38bdf8" : "transparent" }}>
                          {marcado && <Check size={11} className="text-black" strokeWidth={3} />}
                        </span>
                        <Avatar student={a} size={24} />
                        <span className={`text-xs flex-1 min-w-0 truncate ${
                          marcado ? "text-neutral-200" : "text-neutral-400"}`}>
                          {a.name}
                        </span>
                      </button>
                    );
                  })}
                </div>

                <div className="flex gap-2 pt-1">
                  <button onClick={() => setSemanaMasiva(null)}
                    className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
                    Cancelar
                  </button>
                  <button onClick={() => {
                      if (!semanaMasiva.elegidos.length) { showToast("Elegí al menos uno"); return; }
                      setSemanaMasiva((p) => ({ ...p, paso: "como" }));
                    }}
                    className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                    Seguir
                  </button>
                </div>
              </>
            ) : (
              <>
                <div>
                  <p className="font-display font-semibold text-sm">La semana nueva</p>
                  <p className="text-[11px] text-neutral-500 mt-0.5">
                    Para {semanaMasiva.elegidos.length} Be Trainer{semanaMasiva.elegidos.length === 1 ? "" : "s"}
                  </p>
                </div>

                <div className="space-y-2">
                  {[[true, "Clonar la última semana",
                     "Se copian sus sesiones y ejercicios, sin el peso ni el RIR que cargaron"],
                    [false, "Crear una semana vacía",
                     "Las sesiones se las armás vos después"]].map(([val, tit, desc]) => (
                    <button key={String(val)}
                      onClick={() => setSemanaMasiva((p) => ({ ...p, clonar: val }))}
                      className="w-full text-left rounded-lg p-3 border transition-colors"
                      style={semanaMasiva.clonar === val
                        ? { borderColor: "#38bdf8", background: "#38bdf814" }
                        : { borderColor: "#52525266" }}>
                      <p className="text-xs font-medium"
                        style={{ color: semanaMasiva.clonar === val ? "#38bdf8" : "#e2e8f0" }}>
                        {tit}
                      </p>
                      <p className="text-[10px] text-neutral-500 mt-0.5 leading-relaxed">{desc}</p>
                    </button>
                  ))}
                </div>

                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <span className="text-[10px] uppercase tracking-wider block mb-1"
                      style={{ color: GRIS_ETIQUETA }}>Nombre</span>
                    <input value={semanaMasiva.nombre}
                      onChange={(e) => setSemanaMasiva((p) => ({ ...p, nombre: e.target.value }))}
                      placeholder="Semana 5"
                      className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-base" />
                  </div>
                  <div>
                    <span className="text-[10px] uppercase tracking-wider block mb-1"
                      style={{ color: GRIS_ETIQUETA }}>Mes</span>
                    {/* En mayúsculas al escribir, igual que el otro
                        campo de mes. Las semanas se agrupan por este
                        texto: escribirlo distinto crea una carpeta
                        nueva para el mismo mes. */}
                    <input value={semanaMasiva.periodo}
                      onChange={(e) => setSemanaMasiva((p) => ({
                        ...p, periodo: e.target.value.toUpperCase() }))}
                      placeholder={mesActual()}
                      className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-base" />
                  </div>
                </div>

                {/* Los meses que ya usaste: tocar uno es más seguro
                    que escribirlo, y evita la carpeta duplicada. */}
                {(() => {
                  const meses = [...new Set(weeks.map((w) => normalizarMes(w.period))
                    .filter(Boolean))].slice(-3);
                  const hoy = mesActual();
                  const todos = [...new Set([...meses, hoy])];
                  if (!todos.length) return null;
                  return (
                    <div className="flex flex-wrap gap-1.5">
                      {todos.map((m) => (
                        <button key={m}
                          onClick={() => setSemanaMasiva((p) => ({ ...p, periodo: m }))}
                          className="text-[10px] rounded-full px-2.5 py-1 border transition-colors"
                          style={normalizarMes(semanaMasiva.periodo) === m
                            ? { background: "#38bdf8", color: "#000", borderColor: "#38bdf8" }
                            : { color: "#a3a3a3", borderColor: "#52525266" }}>
                          {m}
                        </button>
                      ))}
                    </div>
                  );
                })()}

                <SelectorVisible value={semanaMasiva.visibleDesde}
                  onChange={(v) => setSemanaMasiva((p) => ({ ...p, visibleDesde: v }))} />

                <div className="flex gap-2 pt-1">
                  <button onClick={() => setSemanaMasiva((p) => ({ ...p, paso: "quienes" }))}
                    className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
                    Volver
                  </button>
                  <button onClick={async () => {
                      const nombre = semanaMasiva.nombre.trim();
                      const periodo = semanaMasiva.periodo.trim();
                      if (!nombre) { showToast("Ponele un nombre a la semana"); return; }
                      const { elegidos, clonar } = semanaMasiva;
                      const visible = semanaMasiva.visibleDesde || null;
                      setSemanaMasiva(null);
                      setTarea({ texto: clonar ? "Duplicando semanas" : "Creando semanas",
                                 hechos: 0, total: elegidos.length, detalle: "" });
                      const r = await persistir(
                        () => semanaSiguienteMasiva(elegidos, nombre,
                                periodo || mesActual(), clonar,
                                // Va contando: con veinte alumnos esto
                                // tarda, y sin avance parece colgado.
                                (hechos, quien) => setTarea((t) => t && {
                                  ...t, hechos,
                                  detalle: studentsList.find((a) => a.id === quien)?.name || "",
                                }), visible),
                        "No se pudieron crear las semanas.");
                      setTarea(null);
                      if (!r) return;
                      // Se dice cuántas salieron y cuántas no: un "listo"
                      // cuando fallaron tres es peor que no avisar.
                      if (r.fallados?.length) {
                        // Un aviso que se va solo no alcanza cuando
                        // hay algo que resolver: queda hasta que lo
                        // cierres, y dice a quiénes les falló.
                        setSincro((x) => ({ ...x, error:
                          `${r.hechos.length} creadas · ${r.fallados.length} fallaron: ` +
                          r.fallados.map((f) =>
                            studentsList.find((a) => a.id === f.id)?.name?.split(" ")[0] || "?"
                          ).join(", ") }));
                      } else {
                        showToast(`✓ ${r.hechos.length} semana${r.hechos.length === 1 ? "" : "s"} creada${r.hechos.length === 1 ? "" : "s"}`);
                      }
                      cargarAlumnos().then((l) => setStudentsList(aLista(l))).catch(() => {});
                      setRefrescarPlan((n) => n + 1);
                    }}
                    className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                    Crear
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {editandoInsignia && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => setEditandoInsignia(null)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 space-y-3 max-h-[85vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}>
            <p className="font-display font-semibold text-sm">
              {editandoInsignia.id ? "Editar la insignia" : "Nueva insignia"}
            </p>

            {/* La imagen. Si no hay, se usa el color con la inicial:
                una insignia sin ícono tiene que verse igual, no dejar
                un hueco. */}
            <div className="flex items-center gap-3">
              {editandoInsignia.imagenUrl
                ? <img src={editandoInsignia.imagenUrl} alt=""
                    className="w-16 h-16 rounded-xl object-contain shrink-0"
                    style={{ background: `${editandoInsignia.color}1F` }} />
                : <span className="w-16 h-16 rounded-xl flex items-center justify-center shrink-0 font-display font-bold text-2xl"
                    style={{ background: `${editandoInsignia.color}26`, color: editandoInsignia.color }}>
                    {(editandoInsignia.nombre || "?").slice(0, 1).toUpperCase()}
                  </span>}
              <div className="flex-1 space-y-1.5">
                <label className="block text-[11px] text-sky-400 border border-sky-400/40 rounded-lg py-2 text-center cursor-pointer hover:bg-sky-400/10 transition-colors">
                  <input type="file" accept="image/png,image/*" className="hidden"
                    onChange={async (e) => {
                      const f = e.target.files?.[0];
                      e.target.value = "";
                      if (!f) return;
                      if (!hayBackend) {
                        const lector = new FileReader();
                        lector.onload = () => setEditandoInsignia((p) => ({ ...p, imagenUrl: lector.result }));
                        lector.readAsDataURL(f);
                        return;
                      }
                      const url = await persistir(() => subirImagenInsignia(f),
                                                  "No se pudo subir la imagen.");
                      if (url) setEditandoInsignia((p) => ({ ...p, imagenUrl: url }));
                    }} />
                  {editandoInsignia.imagenUrl ? "Cambiar imagen" : "Subir un PNG"}
                </label>
                {editandoInsignia.imagenUrl && (
                  <button onClick={() => setEditandoInsignia((p) => ({ ...p, imagenUrl: "" }))}
                    className="w-full text-[10px] text-neutral-600 hover:text-red-400 transition-colors">
                    Quitar la imagen
                  </button>
                )}
              </div>
            </div>

            <div>
              <span className="text-[10px] uppercase tracking-wider block mb-1"
                style={{ color: GRIS_ETIQUETA }}>Nombre</span>
              <input value={editandoInsignia.nombre} autoFocus
                onChange={(e) => setEditandoInsignia((p) => ({ ...p, nombre: e.target.value }))}
                placeholder="Constancia de hierro"
                className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-base" />
            </div>

            <div>
              <span className="text-[10px] uppercase tracking-wider block mb-1"
                style={{ color: GRIS_ETIQUETA }}>Cómo se gana</span>
              <input value={editandoInsignia.descripcion}
                onChange={(e) => setEditandoInsignia((p) => ({ ...p, descripcion: e.target.value }))}
                placeholder="4 semanas seguidas al 100%"
                className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-base" />
            </div>

            <div>
              <span className="text-[10px] uppercase tracking-wider block mb-1"
                style={{ color: GRIS_ETIQUETA }}>Color</span>
              <div className="flex gap-1.5 flex-wrap">
                {["#38bdf8", "#6fc48d", "#d4b555", "#e0a068", "#e07a7a",
                  "#a78bfa", "#f472b6", "#2dd4bf"].map((c) => (
                  <button key={c} onClick={() => setEditandoInsignia((p) => ({ ...p, color: c }))}
                    className="w-8 h-8 rounded-lg transition-transform"
                    style={{ background: c,
                             outline: editandoInsignia.color === c ? "2px solid #fff" : "none",
                             outlineOffset: 2 }} />
                ))}
              </div>
            </div>

            {editandoInsignia.id && (
              <button onClick={async () => {
                  const activa = !editandoInsignia.activa;
                  await persistir(() => archivarInsignia(editandoInsignia.id, activa),
                                  "No se pudo archivar.");
                  setEditandoInsignia(null);
                  refrescarCatalogo();
                  showToast(activa ? "✓ Insignia activada" : "Insignia archivada");
                }}
                className="w-full py-2 rounded-lg text-[11px] font-medium text-neutral-400 border border-neutral-600 hover:border-neutral-500 transition-colors">
                {editandoInsignia.activa ? "Archivar" : "Volver a activar"}
              </button>
            )}
            {editandoInsignia.id && (
              <p className="text-[10px] text-neutral-600 leading-relaxed">
                Archivar la saca del catálogo pero la conserva en quienes
                ya la ganaron: es parte de lo que hicieron.
              </p>
            )}

            <div className="flex gap-2 pt-1">
              <button onClick={() => setEditandoInsignia(null)}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
                Cancelar
              </button>
              <button onClick={async () => {
                  if (!editandoInsignia.nombre.trim()) { showToast("Ponele un nombre"); return; }
                  const ok = await persistir(() => guardarInsignia(editandoInsignia),
                                             "No se pudo guardar la insignia.");
                  if (ok) {
                    setEditandoInsignia(null);
                    refrescarCatalogo();
                    showToast("✓ Insignia guardada");
                  }
                }}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {nuevoBloque && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => setNuevoBloque(null)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 space-y-3"
            onClick={(e) => e.stopPropagation()}>
            <p className="font-display font-semibold text-sm">Nombre del bloque</p>
            <input value={nuevoBloque.nombre} autoFocus
              onChange={(e) => setNuevoBloque((p) => ({ ...p, nombre: e.target.value }))}
              placeholder="Zona media"
              className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-base" />
            <p className="text-[10px] text-neutral-600">
              Se crea con su primer ejercicio. Después le agregás los que quieras.
            </p>
            <div className="flex gap-2">
              <button onClick={() => setNuevoBloque(null)}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
                Cancelar
              </button>
              <button onClick={() => {
                  const n = nuevoBloque.nombre.trim();
                  if (!n) { showToast("Ponele un nombre"); return; }
                  const sec = nuevoBloque.seccion;
                  setNuevoBloque(null);
                  sumarEjercicioASesion(sec, n);
                }}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                Crear
              </button>
            </div>
          </div>
        </div>
      )}

      {renombrandoBloque && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => setRenombrandoBloque(null)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 space-y-3"
            onClick={(e) => e.stopPropagation()}>
            <p className="font-display font-semibold text-sm">Renombrar el bloque</p>
            <input value={renombrandoBloque.nuevo} autoFocus
              onChange={(e) => setRenombrandoBloque((p) => ({ ...p, nuevo: e.target.value }))}
              className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2.5 text-base" />
            <p className="text-[10px] text-neutral-600">
              Vaciá el nombre para deshacer el bloque: los ejercicios quedan sueltos.
            </p>
            <div className="flex gap-2">
              <button onClick={() => setRenombrandoBloque(null)}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600">
                Cancelar
              </button>
              <button onClick={async () => {
                  const { seccion, viejo, nuevo } = renombrandoBloque;
                  setRenombrandoBloque(null);
                  if (enPlantilla) {
                    setDraftTemplate((p) => ({ ...p, exercises: p.exercises.map((ex) =>
                      (seccionDe(ex) === seccion && (ex.bloque || "") === viejo)
                        ? { ...ex, bloque: nuevo.trim() } : ex) }));
                    return;
                  }
                  // En pantalla primero, para que se vea al instante.
                  setWeeks((prev) => prev.map((w) => w.id !== activeWeek.id ? w : {
                    ...w, sessions: w.sessions.map((se) => se.id !== activeSession.id ? se : {
                      ...se, exercises: se.exercises.map((ex) =>
                        (seccionDe(ex) === seccion && (ex.bloque || "") === viejo)
                          ? { ...ex, bloque: nuevo.trim() } : ex) }) }));
                  if (hayBackend) {
                    await persistir(
                      () => renombrarBloque(activeSession.id, seccion, viejo, nuevo.trim()),
                      "No se pudo renombrar el bloque.");
                  }
                }}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {duplicandoSesion && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => setDuplicandoSesion(null)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 space-y-3"
            onClick={(e) => e.stopPropagation()}>
            <p className="font-display font-semibold text-sm">
              Duplicar "{duplicandoSesion.sesion.name}"
            </p>
            <div>
              <label className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1 block">
                Nombre de la copia
              </label>
              <input value={duplicandoSesion.nombre}
                onChange={(e) => setDuplicandoSesion((p) => ({ ...p, nombre: e.target.value }))}
                className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-base" />
            </div>

            <p className="text-[11px] text-neutral-500">
              La copia queda en la misma semana. Elegí con qué.
            </p>

            <button onClick={() => duplicarSesion(duplicandoSesion.semana, duplicandoSesion.sesion, "igual", duplicandoSesion.nombre)}
              className="w-full text-left rounded-xl border border-neutral-600 hover:border-sky-400/50 p-3 transition-colors">
              <p className="text-xs font-medium text-neutral-200 mb-0.5">Igual que esta</p>
              <p className="text-[11px] text-neutral-500 leading-relaxed">
                Con los pesos, series, repeticiones y RIR ya puestos. Para
                repetir el mismo entrenamiento en la semana.
              </p>
            </button>

            <button onClick={() => duplicarSesion(duplicandoSesion.semana, duplicandoSesion.sesion, "vacia", duplicandoSesion.nombre)}
              className="w-full text-left rounded-xl border border-neutral-600 hover:border-sky-400/50 p-3 transition-colors">
              <p className="text-xs font-medium text-neutral-200 mb-0.5">Solo la estructura</p>
              <p className="text-[11px] text-neutral-500 leading-relaxed">
                Los mismos ejercicios en el mismo orden, con la prescripción
                en blanco para que la completes.
              </p>
            </button>

            <p className="text-[10px] text-neutral-600 leading-relaxed">
              En las dos, lo que el alumno cargó queda como referencia de la
              semana previa. Su registro no se copia.
            </p>

            <button onClick={() => setDuplicandoSesion(null)}
              className="w-full py-2.5 rounded-lg text-xs font-medium text-neutral-400 border border-neutral-600 hover:border-neutral-500 transition-colors">
              Cancelar
            </button>
          </div>
        </div>
      )}

      {recortando && (
        <RecorteFoto archivo={recortando}
          onListo={guardarFotoRecortada}
          onCancelar={() => setRecortando(null)} />
      )}

      {marcando && (
        <EditorMarcas imagen={marcando.imagen} titulo={marcando.titulo}
          onGuardar={guardarMarcada} onCancelar={() => setMarcando(null)} />
      )}

      {/* Panel de novedades. */}
      {panelNotif && (
        <div className="fixed inset-0 z-40" onClick={() => setPanelNotif(false)}>
          <div className="absolute right-3 md:right-8 top-14 w-[min(22rem,calc(100vw-1.5rem))] max-h-[70vh] bg-neutral-800 border border-neutral-700 rounded-2xl shadow-lg shadow-black/40 flex flex-col overflow-hidden modal-caja"
            onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center gap-2 px-4 py-3 border-b border-neutral-700 shrink-0">
              <Bell size={14} className="text-sky-400 shrink-0" />
              <p className="font-display font-semibold text-sm flex-1 min-w-0 truncate">Novedades</p>
              {sinLeer > 0 && (
                <button onClick={leerTodas}
                  className="text-[10px] text-neutral-500 hover:text-sky-400 transition-colors">
                  Marcar todas
                </button>
              )}
            </div>

            <div className="overflow-y-auto">
              {notificaciones.length === 0 ? (
                <div className="py-10 text-center">
                  <Bell size={22} className="text-neutral-700 mx-auto mb-2" />
                  <p className="text-xs text-neutral-600">Sin novedades por ahora.</p>
                </div>
              ) : notificaciones.map((n) => {
                const Ico = ICONO_NOTIF[n.tipo] || Bell;
                const color = COLOR_NOTIF[n.tipo] || "#38bdf8";
                return (
                  <button key={n.id} onClick={() => abrirNotificacion(n)}
                    className={`w-full flex items-start gap-2.5 px-4 py-3 text-left border-b border-neutral-700/50 transition-colors hover:bg-neutral-700/30 ${
                      n.leida ? "opacity-55" : ""}`}>
                    <span className="w-7 h-7 rounded-full flex items-center justify-center shrink-0 mt-0.5"
                      style={{ background: `${color}1F` }}>
                      <Ico size={13} style={{ color }} />
                    </span>
                    <span className="flex-1 min-w-0">
                      <span className="text-xs text-neutral-200 block leading-snug">{n.titulo}</span>
                      {n.detalle && (
                        <span className="text-[11px] text-neutral-500 block truncate">{n.detalle}</span>
                      )}
                      <span className="text-[10px] text-neutral-600">{haceCuanto(n.creado_en)}</span>
                    </span>
                    {!n.leida && (
                      <span className="w-2 h-2 rounded-full bg-sky-400 shrink-0 mt-1.5" />
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Aviso de insignias recién desbloqueadas. Aparece una vez por
          dispositivo: sin esto el alumno tendría que revisar la pantalla
          de insignias para enterarse de que puede reclamar algo. */}
      {avisoInsignias.length > 0 && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => cerrarAvisoInsignias(false)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5 text-center"
            onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-center gap-2 mb-3">
              {avisoInsignias.slice(0, 3).map((b) => {
                const Ico = b.icon || Award;
                return (
                  <div key={b.id} className="w-12 h-12 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: `${b.color}1A`, border: `1px solid ${b.color}40` }}>
                    <Ico size={20} style={{ color: b.color }} />
                  </div>
                );
              })}
            </div>
            <p className="font-display font-bold text-base mb-1">
              {avisoInsignias.length === 1
                ? "¡Desbloqueaste una insignia!"
                : `¡Desbloqueaste ${avisoInsignias.length} insignias!`}
            </p>
            <p className="text-xs text-neutral-400 leading-relaxed mb-4">
              {avisoInsignias.map((b) => b.name).join(" · ")}
              <br />
              Pedíselas a Mati para que te las apruebe.
            </p>
            <div className="flex gap-2">
              <button onClick={() => cerrarAvisoInsignias(false)}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-300 border border-neutral-600">
                Después
              </button>
              <button onClick={() => cerrarAvisoInsignias(true)}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200 transition-colors">
                Ver insignias
              </button>
            </div>
          </div>
        </div>
      )}

      {confirmar && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center z-50 p-4 modal-fondo"
          onClick={() => setConfirmar(null)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl w-full max-w-sm p-5"
            onClick={(e) => e.stopPropagation()}>
            {/* Caso genérico: el que trae su propio título, su texto y
                su acción. Sin esto había que agregar un tipo nuevo acá
                adentro por cada confirmación de la app. */}
            <div className={`w-11 h-11 rounded-full border flex items-center justify-center mb-3 ${
              confirmar.accion ? "bg-sky-400/10 border-sky-400/30"
                : confirmar.tipo === "archivar"
                ? "bg-amber-400/10 border-amber-400/30" : "bg-red-400/10 border-red-400/30"}`}>
              {confirmar.accion
                ? <Shield size={18} className="text-sky-400" />
                : confirmar.tipo === "archivar"
                ? <Archive size={18} className="text-amber-400" />
                : <Trash2 size={18} className="text-red-400" />}
            </div>
            <p className="font-display font-semibold text-base mb-1.5">
              {confirmar.titulo ? confirmar.titulo
                : confirmar.tipo === "carpeta" ? "¿Eliminar la carpeta?"
                : confirmar.tipo === "archivar" ? "¿Archivar?"
                : confirmar.tipo === "ejercicio"
                  ? ((confirmar.uso?.en_sesiones || 0) + (confirmar.uso?.en_plantillas || 0) > 0
                      ? "Este ejercicio está en uso" : "¿Eliminar del catálogo?")
                : confirmar.tipo === "quitarEj" ? "¿Quitar el ejercicio?"
                : confirmar.tipo === "semana" ? "¿Eliminar la semana?"
                : confirmar.tipo === "sesion" ? "¿Eliminar la sesión?"
                : confirmar.tipo === "eliminar" ? "¿Eliminar definitivamente?"
                : "¿Eliminar la sesión?"}
            </p>
            <p className="text-xs text-neutral-400 leading-relaxed mb-5">
              {confirmar.detalle ? confirmar.detalle
                : confirmar.tipo === "quitarEj" ? (
                <>
                  Se saca <b className="text-neutral-200">{confirmar.nombre || "el ejercicio"}</b> de
                  esta sesión. Si el alumno ya cargó algo en él, ese registro se pierde.
                  El ejercicio sigue en tu catálogo.
                </>
              ) : confirmar.tipo === "semana" ? (() => {
                const hechas = confirmar.semana.sessions.filter((x) => x.estado === "Completado").length;
                const total = confirmar.semana.sessions.length;
                return (
                  <>
                    Se elimina <b className="text-neutral-200">{confirmar.semana.name}</b>
                    {total > 0 ? (
                      <> con sus {total} {total === 1 ? "sesión" : "sesiones"}.
                        {hechas > 0 && (
                          <b className="text-yellow-300">
                            {" "}{hechas} ya {hechas === 1 ? "está completada" : "están completadas"}:
                            se pierde ese registro y la EXP que dio.
                          </b>
                        )}
                      </>
                    ) : " (está vacía)."}
                    <br /><br />
                    Esto no se puede deshacer.
                  </>
                );
              })() : confirmar.tipo === "ejercicio" ? (() => {
                const enUso = (confirmar.uso?.en_sesiones || 0) + (confirmar.uso?.en_plantillas || 0);
                if (!enUso) {
                  return (
                    <>
                      Se saca <b className="text-neutral-200">{confirmar.nombre}</b> del catálogo.
                      No está usado en ninguna sesión ni plantilla, así que no se pierde nada.
                      Podés volver a crearlo cuando quieras.
                    </>
                  );
                }
                const quienes = confirmar.uso?.alumnos || [];
                return (
                  <>
                    <b className="text-neutral-200">{confirmar.nombre}</b> está en{" "}
                    {confirmar.uso.en_sesiones > 0 && `${confirmar.uso.en_sesiones} sesión${confirmar.uso.en_sesiones === 1 ? "" : "es"}`}
                    {confirmar.uso.en_sesiones > 0 && confirmar.uso.en_plantillas > 0 && " y "}
                    {confirmar.uso.en_plantillas > 0 && `${confirmar.uso.en_plantillas} plantilla${confirmar.uso.en_plantillas === 1 ? "" : "s"}`}.
                    {quienes.length > 0 && (
                      <> Lo tienen: <b className="text-neutral-200">{quienes.join(", ")}</b>.</>
                    )}
                    <br /><br />
                    Si lo borro, esas sesiones quedan con un nombre que ya no existe en el
                    catálogo: sin video, sin categoría, y el alumno no va a entender por qué.
                    Sacalo de ahí primero.
                  </>
                );
              })() : confirmar.tipo === "sesion" ? (
                <>
                  Se elimina <b className="text-neutral-200">{confirmar.sesion.name}</b> con
                  sus {confirmar.sesion.exercises.length} ejercicios. Si el alumno ya cargó
                  algo, ese registro también se borra. Esto no se puede deshacer.
                </>
              ) : confirmar.tipo === "archivar" ? (
                <>
                  <b className="text-neutral-200">{confirmar.alumno.name}</b> pierde el acceso a la app
                  y sale del ranking, pero su historial queda guardado. Va a aparecer en
                  “Archivados” al pie de la lista, y podés reactivarlo cuando vuelva.
                </>
              ) : confirmar.tipo === "eliminar" ? (
                <>
                  Se borra <b className="text-neutral-200">{confirmar.alumno.name}</b> por completo:
                  su cuenta, sus semanas, sus entrenamientos, su EXP y sus insignias.
                  <b className="text-red-300"> Esto no se puede deshacer.</b>
                  <br /><br />
                  Si puede volver más adelante, mejor archivarlo.
                </>
              ) : confirmar.tipo === "carpeta" ? (
                <>
                  Se elimina <b className="text-neutral-200">{confirmar.nombre}</b>.
                  {confirmar.cuenta > 0
                    ? ` Sus ${confirmar.cuenta} ${confirmar.cuenta === 1 ? "sesión pasa" : "sesiones pasan"} a "Sin categoría", no se pierden.`
                    : " Está vacía."}
                </>
              ) : (
                <>
                  Se elimina <b className="text-neutral-200">{confirmar.nombre}</b> de la librería.
                  Las sesiones ya asignadas a tus Be Trainers no se tocan. Esto no se puede deshacer.
                </>
              )}
            </p>
            <div className="flex gap-2">
              <button onClick={() => setConfirmar(null)}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-300 border border-neutral-600 hover:border-neutral-500 transition-colors">
                {/* Cuando no hay nada que confirmar, este botón cierra
                    el aviso: "Cancelar" no tendría sentido. */}
                {confirmar.tipo === "ejercicio"
                  && (confirmar.uso?.en_sesiones || 0) + (confirmar.uso?.en_plantillas || 0) > 0
                  ? "Entendido" : "Cancelar"}
              </button>
              {!(confirmar.tipo === "ejercicio"
                && (confirmar.uso?.en_sesiones || 0) + (confirmar.uso?.en_plantillas || 0) > 0) && (
              <button onClick={() => confirmar.accion ? confirmar.accion()
                        : confirmar.tipo === "quitarEj" ? sacarEjercicioDeSesion(confirmar.indice)
                        : confirmar.tipo === "semana" ? eliminarSemana(confirmar.semana)
                        : confirmar.tipo === "ejercicio" ? eliminarEjercicio(confirmar)
                        : confirmar.tipo === "sesion" ? eliminarSesion(confirmar.sesion)
                        : confirmar.tipo === "archivar" ? archivarAlumno(confirmar.alumno)
                        : confirmar.tipo === "eliminar" ? eliminarAlumno(confirmar.alumno)
                        : confirmar.tipo === "carpeta" ? borrarCarpeta(confirmar.id)
                        : borrarPlantilla(confirmar.id, confirmar.categoryId)}
                className={`flex-1 py-2.5 rounded-lg text-xs font-medium transition-colors ${
                  confirmar.accion
                    ? "bg-sky-400 text-black hover:bg-sky-200"
                    : confirmar.tipo === "archivar"
                    ? "bg-amber-400 text-black hover:bg-amber-300"
                    : "bg-red-500 text-white hover:bg-red-400"}`}>
                {confirmar.accion ? (confirmar.textoBoton || "Confirmar")
                  : confirmar.tipo === "archivar" ? "Archivar"
                  : confirmar.tipo === "quitarEj" ? "Quitar" : "Eliminar"}
              </button>
              )}
            </div>
          </div>
        </div>
      )}

      {diagOpen && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-end sm:items-center justify-center p-4 modal-fondo"
          onClick={() => setDiagOpen(false)}>
          <div className="modal-caja bg-neutral-800 border border-neutral-700 rounded-2xl p-5 w-full max-w-md max-h-[85vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}>
            <h3 className="font-display text-base font-semibold flex items-center gap-2 mb-1">
              <Database size={15} className="text-sky-400" /> Qué hay guardado
            </h3>
            <p className="text-[11px] text-neutral-500 mb-4">
              Esto es lo que hay en la base de verdad, no lo que muestra la pantalla.
            </p>

            {!diag && <p className="text-xs text-neutral-500 py-6 text-center">Consultando…</p>}

            {diag?.error && (
              <div className="bg-red-500/10 border border-red-400/30 rounded-lg p-3">
                <p className="text-xs text-red-300">{diag.error}</p>
                <p className="text-[11px] text-neutral-500 mt-2">
                  Si dice algo de conexión, revisá que el archivo .env tenga bien las dos claves.
                </p>
              </div>
            )}

            {diag?.filas && (
              <>
                <div className="space-y-1.5">
                  {diag.filas.map((f) => (
                    <div key={f.tabla} className="flex items-center justify-between bg-neutral-700/40 rounded-lg px-3 py-2">
                      <span className="text-xs text-neutral-300">{NOMBRES_TABLA[f.tabla] || f.tabla}</span>
                      <span className={`text-xs font-display font-semibold ${
                        !f.ok ? "text-red-400" : f.filas > 0 ? "text-emerald-400" : "text-neutral-600"}`}>
                        {!f.ok ? "error" : f.filas === 0 ? "vacío" : `${f.filas}${f.filas === 1000 ? "+" : ""}`}
                      </span>
                    </div>
                  ))}
                </div>

                {diag.ultimaSemana && (
                  <div className="mt-4 bg-sky-400/10 border border-sky-400/25 rounded-lg p-3">
                    <p className="text-[10px] uppercase tracking-wider text-neutral-500 mb-1">Última semana creada</p>
                    <p className="text-xs text-neutral-200">
                      {diag.ultimaSemana.nombre} · {diag.ultimaSemana.periodo}
                    </p>
                  </div>
                )}

                <p className="text-[11px] text-neutral-600 mt-4 leading-relaxed">
                  Si acabás de crear una semana y acá figura, se guardó bien.
                  Si figura “vacío”, no llegó a la base.
                </p>
              </>
            )}

            <div className="flex gap-2 mt-4">
              <button onClick={correrDiagnostico}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium text-neutral-300 border border-neutral-600 hover:border-neutral-500">
                Volver a consultar
              </button>
              <button onClick={() => setDiagOpen(false)}
                className="flex-1 py-2.5 rounded-lg text-xs font-medium bg-sky-400 text-black hover:bg-sky-200">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Lo que se guarda solo: una barra fina arriba de todo.
          Un cartel por cada peso que carga el alumno es mucho ruido
          para algo que dura medio segundo. */}
      {hayBackend && sincro.guardando && !tarea && (
        <div className="fixed top-0 left-0 right-0 h-[3px] z-50 overflow-hidden"
          style={{ background: "#26262666" }}>
          <div className="h-full barra-indefinida"
            style={{ background: "linear-gradient(90deg, #38bdf8, #6fc48d)" }} />
        </div>
      )}

      {/* "Guardado" al terminar, arriba a la derecha. La barra sola
          no alcanzaba: desaparecía y solo te enterabas si FALLABA. */}
      {reciénGuardado && !tarea && !sincro.error && (
        <div className="fixed right-3 top-3 z-50 flex items-center gap-2 px-3 py-2 rounded-full modal-caja shadow-lg"
          style={{ background: "#1f2a22", border: `1px solid ${ESTADO.bien}`,
                   boxShadow: `0 4px 16px ${ESTADO.bien}22` }}>
          <Check size={13} style={{ color: ESTADO.bien }} strokeWidth={3} />
          <span className="text-[11.5px] font-medium" style={{ color: ESTADO.bien }}>
            Guardado
          </span>
        </div>
      )}

      {/* Lo que tarda de verdad: dice qué hace, cuánto lleva y en
          quién va. Sin eso, veinte semanas duplicándose parecen la
          app colgada. */}
      {tarea && (
        <div className="fixed left-1/2 -translate-x-1/2 top-3 z-50 w-[260px] max-w-[92%] rounded-xl px-3.5 py-3 shadow-lg"
          style={{ background: "#262626", border: "1px solid #38bdf855" }}>
          <div className="flex items-center gap-2.5 mb-2">
            <span className="w-3.5 h-3.5 rounded-full shrink-0 giro"
              style={{ border: "2px solid #38bdf8", borderTopColor: "transparent" }} />
            <span className="text-[11.5px] flex-1 min-w-0 truncate">{tarea.texto}</span>
            {tarea.total > 0 && (
              <span className="text-[11px] font-semibold shrink-0" style={{ color: "#38bdf8" }}>
                {tarea.hechos}/{tarea.total}
              </span>
            )}
          </div>
          <div className="h-1 rounded-full overflow-hidden" style={{ background: "#171717" }}>
            <div className="h-full rounded-full"
              style={{
                width: tarea.total > 0
                  ? `${Math.round((tarea.hechos / tarea.total) * 100)}%` : "30%",
                background: "#38bdf8",
                transition: "width 240ms ease-out",
              }} />
          </div>
          {tarea.detalle && (
            <p className="text-[10px] text-neutral-500 mt-2 truncate">{tarea.detalle}</p>
          )}
        </div>
      )}

      {/* Estado de la sincronización. El alumno tiene que poder ver
          si lo que cargó quedó guardado, sobre todo si está entrenando
          en un lugar con mala señal. */}
      {hayBackend && sincro.error && (
        <div className="fixed left-1/2 -translate-x-1/2 top-3 z-50 flex items-center gap-2 text-[11px] px-3 py-2 rounded-full border shadow-lg max-w-[92%] bg-red-500/15 border-red-400/40 text-red-300">
          <>
              <Bell size={12} className="shrink-0" />
              {/* El motivo completo y no cortado: "no se pudo" sin
                  decir por qué obliga a adivinar. La barra crece si
                  hace falta en vez de recortar el texto. */}
              <span className="flex-1 min-w-0">{sincro.error}</span>
              {/* Solo si hay algo en la cola. El botón reintenta los
                  cambios de ejercicio pendientes; para lo que falló
                  fuera de esa cola —una reacción, por ejemplo— no hacía
                  nada y daba a entender que sí. */}
              {Object.keys(pendientes.current || {}).length > 0 && (
                <button onClick={() => { setSincro((x) => ({ ...x, error: null })); guardarPendientes(); }}
                  className="underline font-medium shrink-0">Reintentar</button>
              )}
              <button onClick={() => setSincro((x) => ({ ...x, error: null }))}
                className="shrink-0 text-neutral-500 hover:text-white">
                <X size={12} />
              </button>
          </>
        </div>
      )}

      {/* Los avisos van arriba y anchos. Abajo quedaban a un dedo de
          la barra de navegación, tapados por la mano al tocar, y en
          escritorio en una esquina donde nadie está mirando. */}
      {/* Al centro de la pantalla: arriba competía con la barra del
          navegador y en un celular con el pulgar. Y con color según
          lo que diga —verde si algo salió bien, ámbar si es un aviso—
          en vez de gris para todo. */}
      {toast && (() => {
        const bien = toast.startsWith("✓");
        const color = bien ? ESTADO.bien : ESTADO.aviso;
        return (
          <div key={toast}
            className="fixed inset-x-0 top-1/2 -translate-y-1/2 z-50 flex justify-center px-4 pointer-events-none vista-entra">
            <div className="flex items-center gap-2.5 rounded-2xl px-5 py-4 shadow-2xl shadow-black/60 max-w-sm pointer-events-auto"
              style={{ background: "#16202e", border: `2px solid ${color}` }}>
              {bien
                ? <span className="w-6 h-6 rounded-full flex items-center justify-center shrink-0"
                    style={{ background: color }}>
                    <Check size={14} className="text-black" strokeWidth={3} />
                  </span>
                : <AlertTriangle size={18} className="shrink-0" style={{ color }} />}
              <span className="text-sm text-neutral-100 flex-1 leading-snug">
                {bien ? toast.replace(/^✓\s*/, "") : toast}
              </span>
              <button onClick={() => setToast("")}
                className="text-neutral-500 hover:text-white transition-colors shrink-0">
                <X size={14} />
              </button>
            </div>
          </div>
        );
      })()}

      {/* Columna lateral, solo en pantallas anchas. */}
      <aside className="hidden md:flex fixed left-0 top-0 bottom-0 w-56 flex-col border-r border-neutral-700 bg-neutral-800/40 backdrop-blur z-20">
        <div className="flex items-center gap-2.5 px-5 py-5">
          <img src={prefs.tema === "claro" ? LOGO_CLARO : LOGO_URI} alt="Be Training"
            className="h-8 w-8 object-contain shrink-0" />
          <div className="min-w-0">
            <p className="font-display font-bold text-sm leading-tight truncate">BE Training</p>
            <p className="text-[10px] text-neutral-500 truncate">{profile?.name || userName}</p>
          </div>
        </div>

        <nav className="flex-1 px-3 space-y-1 overflow-y-auto">
          {pestañas.map((t) => {
            const Icon = t.icon || Home;
            const activo = t.active.includes(view);
            // Al alumno le cuenta las que puede reclamar; al coach,
            // las que tiene que resolver.
            const cuenta = t.id === "insignias"
              ? Object.values(badgeStatus).filter((x) => x === "earned").length
              : t.id === "solicitudes" ? (tablero?.pendientes || 0) : 0;
            return (
              <button key={t.id} onClick={() => setView(t.id)}
                className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-left transition-colors ${
                  activo ? "bg-sky-400/15 text-sky-400" : "text-neutral-400 hover:bg-neutral-700/40"}`}>
                <Icon size={16} className="shrink-0" />
                <span className="text-xs font-medium flex-1 truncate">{t.label}</span>
                {!!cuenta && (
                  <span className="min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center shrink-0">
                    {cuenta}
                  </span>
                )}
              </button>
            );
          })}
        </nav>

        <div className="px-3 pb-4 pt-2 border-t border-neutral-700 space-y-1">
          {hayBackend && (
            <button onClick={() => setPanelNotif((v) => !v)}
              className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-neutral-500 hover:bg-neutral-700/40 transition-colors">
              <Bell size={14} className="shrink-0" />
              <span className="text-[11px] flex-1 text-left">Novedades</span>
              {sinLeer > 0 && (
                <span className="min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center shrink-0">
                  {sinLeer > 9 ? "9+" : sinLeer}
                </span>
              )}
            </button>
          )}
          {isCoach && hayBackend && (
            <button onClick={correrDiagnostico}
              className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-neutral-500 hover:bg-neutral-700/40 transition-colors">
              <Database size={14} className="shrink-0" />
              <span className="text-[11px]">Qué hay guardado</span>
            </button>
          )}
          <button onClick={handleLogout}
            className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-neutral-500 hover:text-red-400 hover:bg-neutral-700/40 transition-colors">
            <LogOut size={14} className="shrink-0" />
            <span className="text-[11px]">Cerrar sesión</span>
          </button>
        </div>
      </aside>

      </div>

      {/* Navegación. En el celular es una barra flotante abajo, que es
          donde llega el pulgar. En una computadora esa barra queda
          rarísima: ahí va una columna a la izquierda, como cualquier
          panel de escritorio. Las dos usan la misma lista. */}
      {/* Apoyada en el borde y a todo el ancho: flotando quedaba un
          recuadro suelto con la app de fondo asomando por los costados,
          como si le faltara algo. Así se lee como parte de la pantalla.
          El padding de abajo es el espacio del gesto de inicio del
          iPhone: el fondo llega hasta el filo, los botones no. */}
      <div className="fixed left-0 right-0 bottom-0 z-20 md:hidden bg-neutral-800/95 backdrop-blur-md border-t border-neutral-700"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
        <div className="max-w-md mx-auto flex px-2 pt-2 pb-2.5">
          {/* La MISMA lista que el menú del costado. Antes era una
              copia, y al agregar Insignias solo se actualizó una: en
              la computadora aparecía y en el celular no. */}
          {pestañas.map((t) => {
            const Icon = esIcono(t.icon) ? t.icon : Home;
            const active = t.active.includes(view);
            // El mismo conteo que el menú del costado: al alumno las
            // que puede reclamar, al coach las que tiene que resolver.
            const cuenta = t.id === "insignias"
              ? Object.values(badgeStatus).filter((x) => x === "earned").length
              : t.id === "solicitudes" ? (tablero?.pendientes || 0) : 0;
            return (
              <button key={t.id} onClick={() => setView(t.id)}
                className={`flex-1 flex flex-col items-center gap-1 py-2 rounded-xl relative transition-colors duration-200 ${
                  active ? "bg-sky-400/15" : ""}`}>
                <span className="relative">
                  <Icon size={18}
                    className={`transition-all duration-200 ${active ? "text-sky-400" : "text-neutral-600"}`}
                    style={{ transform: active ? "translateY(-1px) scale(1.08)" : "none" }} />
                  {cuenta > 0 && (
                    <span className="absolute -top-1.5 -right-2 min-w-[15px] h-[15px] px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center">{cuenta}</span>
                  )}
                </span>
                <span className={`text-[10px] font-medium ${active ? "text-sky-400" : "text-neutral-600"}`}>{t.corto || t.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
